(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[573],{

/***/ 5705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[room]",
      function () {
        return __webpack_require__(1157);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ MAIN_ROOM_IDENTIFIER; },
/* harmony export */   "n": function() { return /* binding */ DEFAULT_AMOUNT_OF_ROOMS; }
/* harmony export */ });
// we might want to make this configurable in the future. I'm imagining an option in the dashboard where
// owners can set a default amount of rooms.
var DEFAULT_AMOUNT_OF_ROOMS = 1;
var MAIN_ROOM_IDENTIFIER = "main-room";


/***/ }),

/***/ 8610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useBreakoutSessionState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ../shared/dist/components/Icons/HelpIcon.js
var HelpIcon = __webpack_require__(9370);
// EXTERNAL MODULE: ../shared/dist/contexts/Snackbar/index.js
var Snackbar = __webpack_require__(4017);
// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(9378);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./lib/userData.ts
var lib_userData = __webpack_require__(4218);
;// CONCATENATED MODULE: ./hooks/useUserData.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var userDataState = (0,es/* atom */.cn)({
    key: "user-data-state",
    default: {}
});
var noopFilter = function() {
    return true;
};
/**
 * Returns React-ified userData objects for each passed session_id.
 */ var useUserData = function(ids) {
    var filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noopFilter;
    var userData2 = (0,es/* useRecoilValue */.sJ)(userDataState);
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)([
        "joined-meeting",
        "participant-joined",
        "participant-updated",
        "participant-left", 
    ], (0,es/* useRecoilCallback */._8)(function(param1) {
        var transact_UNSTABLE = param1.transact_UNSTABLE;
        return function(evts) {
            transact_UNSTABLE(function(param) {
                var get = param.get, set = param.set;
                var prev = get(userDataState);
                var newState = _objectSpread({}, prev);
                evts.forEach(function(ev) {
                    switch(ev.action){
                        case "joined-meeting":
                            {
                                var session_id = ev.participants.local.session_id;
                                var userData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily, "local");
                                newState[session_id] = userData;
                                break;
                            }
                        case "participant-joined":
                        case "participant-updated":
                            {
                                var session_id1 = ev.participant.session_id;
                                var userData1 = (0,lib_userData/* getPrebuiltUserData */.n1)(daily, ev.participant.local ? "local" : session_id1);
                                newState[session_id1] = userData1;
                                break;
                            }
                        case "participant-left":
                            {
                                var session_id2 = ev.participant.session_id;
                                delete newState[session_id2];
                                break;
                            }
                    }
                });
                if (fast_deep_equal_default()(prev, newState)) return;
                set(userDataState, newState);
            });
        };
    }, [
        daily
    ]));
    return (0,react.useMemo)(function() {
        return Object.entries(userData2).filter(function(param) {
            var _param = _slicedToArray(param, 1), id = _param[0];
            return ids.includes(id);
        })// Apply custom filter
        .filter(function(param) {
            var _param = _slicedToArray(param, 2), id = _param[0], data = _param[1];
            return filter(id, data);
        })// Convert array back to object
        .reduce(function(res, param) {
            var _param = _slicedToArray(param, 2), id = _param[0], data = _param[1];
            res[id] = data;
            return res;
        }, {});
    }, [
        filter,
        ids,
        userData2
    ]);
};

// EXTERNAL MODULE: ./components/BreakoutRooms/helpers/constants.ts
var constants = __webpack_require__(5436);
;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useMeetingSessionData.ts


// update this atom every time meeting-session-state-updated is called
var sessionDataState = (0,es/* atom */.cn)({
    key: "meeting-session-data-state",
    default: {}
});
var useMeetingSessionData = function() {
    var onMeetingSessionStateUpdated = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).onMeetingSessionStateUpdated;
    (0,daily_react_esm/* useDailyEvent */.VU)("meeting-session-state-updated", (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(event) {
            set(sessionDataState, event.meetingSessionState.data);
            onMeetingSessionStateUpdated === null || onMeetingSessionStateUpdated === void 0 ? void 0 : onMeetingSessionStateUpdated(event);
        };
    }, [
        onMeetingSessionStateUpdated
    ]));
    var sessionData = (0,es/* useRecoilValue */.sJ)(sessionDataState);
    return {
        sessionData: sessionData
    };
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useBreakoutSessionState.tsx
function useBreakoutSessionState_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useBreakoutSessionState_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useBreakoutSessionState_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useBreakoutSessionState_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useBreakoutSessionState_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useBreakoutSessionState_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useBreakoutSessionState_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useBreakoutSessionState_slicedToArray(arr, i) {
    return useBreakoutSessionState_arrayWithHoles(arr) || useBreakoutSessionState_iterableToArrayLimit(arr, i) || useBreakoutSessionState_unsupportedIterableToArray(arr, i) || useBreakoutSessionState_nonIterableRest();
}
function useBreakoutSessionState_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useBreakoutSessionState_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useBreakoutSessionState_arrayLikeToArray(o, minLen);
}










/**
 * Returns all derived state from meeting session and user data.
 */ var useBreakoutSessionState = function() {
    var onMeetingSessionStateUpdated = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).onMeetingSessionStateUpdated;
    var ref17, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var sessionData = useMeetingSessionData({
        onMeetingSessionStateUpdated: onMeetingSessionStateUpdated
    }).sessionData;
    var breakoutStatus = sessionData === null || sessionData === void 0 ? void 0 : (ref17 = sessionData.br) === null || ref17 === void 0 ? void 0 : ref17.status;
    var breakoutHost = sessionData === null || sessionData === void 0 ? void 0 : (ref1 = sessionData.br) === null || ref1 === void 0 ? void 0 : ref1.host;
    var ref16;
    var breakoutMapping = (0,react.useMemo)(function() {
        var ref;
        return (ref16 = sessionData === null || sessionData === void 0 ? void 0 : (ref = sessionData.br) === null || ref === void 0 ? void 0 : ref.mapping) !== null && ref16 !== void 0 ? ref16 : {};
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : (ref2 = sessionData.br) === null || ref2 === void 0 ? void 0 : ref2.mapping
    ]);
    var endDate = (0,react.useMemo)(function() {
        var ref, ref18, ref19, ref20;
        if (!(sessionData === null || sessionData === void 0 ? void 0 : (ref = sessionData.br) === null || ref === void 0 ? void 0 : (ref18 = ref.config) === null || ref18 === void 0 ? void 0 : ref18.endDate)) return null;
        return new Date(sessionData === null || sessionData === void 0 ? void 0 : (ref19 = sessionData.br) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.config) === null || ref20 === void 0 ? void 0 : ref20.endDate);
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : (ref3 = sessionData.br) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : ref4.endDate
    ]);
    var localUserData = useUserData([
        localSessionId
    ]);
    var currentRoomId = (ref5 = localUserData[localSessionId]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.br) === null || ref6 === void 0 ? void 0 : ref6.currentRoomId;
    var joinedState = (ref7 = localUserData[localSessionId]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.br) === null || ref8 === void 0 ? void 0 : ref8.status;
    var hasJoinedBreakout = currentRoomId && (sessionData === null || sessionData === void 0 ? void 0 : (ref9 = sessionData.br) === null || ref9 === void 0 ? void 0 : ref9.status) === "ongoing";
    var currentBreakoutRoom = {
        id: currentRoomId !== null && currentRoomId !== void 0 ? currentRoomId : constants/* MAIN_ROOM_IDENTIFIER */.b,
        name: breakoutMapping === null || breakoutMapping === void 0 ? void 0 : (ref10 = breakoutMapping[currentRoomId]) === null || ref10 === void 0 ? void 0 : ref10.name,
        users: breakoutMapping === null || breakoutMapping === void 0 ? void 0 : (ref11 = breakoutMapping[currentRoomId]) === null || ref11 === void 0 ? void 0 : ref11.users
    };
    var invited = Object.entries(breakoutMapping).find(function(param) {
        var _param = useBreakoutSessionState_slicedToArray(param, 2), room = _param[1];
        return room.users.includes(localSessionId);
    });
    var invitedBreakoutRoom = invited ? {
        id: invited === null || invited === void 0 ? void 0 : invited[0],
        name: invited === null || invited === void 0 ? void 0 : (ref12 = invited[1]) === null || ref12 === void 0 ? void 0 : ref12.name,
        users: invited === null || invited === void 0 ? void 0 : (ref13 = invited[1]) === null || ref13 === void 0 ? void 0 : ref13.users
    } : null;
    var allIds = (0,daily_react_esm/* useParticipantIds */.OV)();
    var breakoutUserDatas = useUserData(allIds, (0,react.useCallback)(function(_id, data) {
        var ref;
        return Boolean(data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.currentRoomId);
    }, []));
    var anyBreakoutParticipantIds = Object.keys(breakoutUserDatas);
    var mainRoomParticipantIds = allIds.filter(function(id) {
        return !anyBreakoutParticipantIds.includes(id);
    });
    var userDatasAsArray = Object.entries(breakoutUserDatas);
    var breakoutParticipantIds = userDatasAsArray.filter(function(param) {
        var _param = useBreakoutSessionState_slicedToArray(param, 2), data = _param[1];
        var ref;
        return currentRoomId && (data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.currentRoomId) === currentRoomId;
    }).map(function(param) {
        var _param = useBreakoutSessionState_slicedToArray(param, 1), id = _param[0];
        return id;
    });
    var invitedUserDatas = useUserData(allIds, (0,react.useCallback)(function(_id, data) {
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.status) === "invited";
    }, []));
    var invitedParticipants = Object.keys(invitedUserDatas);
    var breakoutMappingAsArray = Object.entries(breakoutMapping);
    var breakoutMappingValues = Object.values(breakoutMapping);
    /* Find all users in a room by its name*/ var breakoutParticipantsByRoomName = (0,react.useCallback)(function(roomName) {
        var ref;
        // get room id by its name
        var roomId = (ref = breakoutMappingAsArray.find(function(param) {
            var _param = useBreakoutSessionState_slicedToArray(param, 2), room = _param[1];
            return room.name === roomName;
        })) === null || ref === void 0 ? void 0 : ref[0];
        // get the actual location of participants by room name. for example:
        // user A is in room 1, and has been invited to room 2. their location remains
        // room 1 _until_ they accept the invite.
        return breakoutMappingValues.filter(function(m) {
            return m.name === roomName;
        }).map(function() {
            return userDatasAsArray.filter(function(param) {
                var _param = useBreakoutSessionState_slicedToArray(param, 2), userData = _param[1];
                return userData.br.currentRoomId === roomId;
            }).map(function(param) {
                var _param = useBreakoutSessionState_slicedToArray(param, 1), userId = _param[0];
                return userId;
            });
        });
    }, [
        breakoutMappingAsArray,
        breakoutMappingValues,
        userDatasAsArray
    ]);
    /* Find all users in a room by its id*/ var breakoutParticipantsByRoomId = (0,react.useCallback)(function(roomId) {
        var ref;
        return (ref = breakoutMapping[roomId]) === null || ref === void 0 ? void 0 : ref.users;
    }, [
        breakoutMapping
    ]);
    var participantsAskingForHelp = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            var ref;
            var userData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily, p.local ? "local" : p.session_id);
            return (userData === null || userData === void 0 ? void 0 : (ref = userData.br) === null || ref === void 0 ? void 0 : ref.help) && !p.local;
        }, [
            daily
        ])
    });
    var userData1 = useUserData([
        localSessionId
    ]);
    var isRequestingHelp = Boolean(userData1 === null || userData1 === void 0 ? void 0 : (ref14 = userData1[localSessionId]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.br) === null || ref15 === void 0 ? void 0 : ref15.help);
    var updateAskForHelpStatus = (0,react.useCallback)(function(needHelp) {
        var ref;
        var ref21, ref22;
        (0,lib_userData/* setPrebuiltUserData */.T3)(daily, useBreakoutSessionState_objectSpread({}, (ref21 = userData1 === null || userData1 === void 0 ? void 0 : userData1[localSessionId]) !== null && ref21 !== void 0 ? ref21 : {}, {
            br: useBreakoutSessionState_objectSpread({}, (ref22 = userData1 === null || userData1 === void 0 ? void 0 : (ref = userData1[localSessionId]) === null || ref === void 0 ? void 0 : ref.br) !== null && ref22 !== void 0 ? ref22 : {}, {
                help: needHelp
            })
        }));
        addMessage({
            content: needHelp ? t("breakouts.hostReceivedYourRequest") : t("breakouts.requestWasCanceled"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                size: 16
            }),
            type: "info"
        });
    }, [
        addMessage,
        daily,
        localSessionId,
        t,
        userData1
    ]);
    return {
        breakoutHost: breakoutHost,
        breakoutParticipantsByRoomId: breakoutParticipantsByRoomId,
        breakoutMapping: breakoutMapping,
        breakoutParticipantsByRoomName: breakoutParticipantsByRoomName,
        breakoutParticipantIds: breakoutParticipantIds,
        breakoutStatus: breakoutStatus,
        currentBreakoutRoom: currentBreakoutRoom,
        endDate: endDate,
        hasJoinedBreakout: hasJoinedBreakout,
        invitedBreakoutRoom: invitedBreakoutRoom,
        invitedParticipants: invitedParticipants,
        joinedState: joinedState,
        mainRoomParticipantIds: mainRoomParticipantIds,
        participantsAskingForHelp: participantsAskingForHelp,
        isRequestingHelp: isRequestingHelp,
        updateAskForHelpStatus: updateAskForHelpStatus
    };
};


/***/ }),

/***/ 3827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ useChatUnread; },
/* harmony export */   "RN": function() { return /* binding */ useChatState; },
/* harmony export */   "aM": function() { return /* binding */ ChatProvider; },
/* harmony export */   "mv": function() { return /* binding */ useChatMessages; },
/* harmony export */   "zc": function() { return /* binding */ defaultReactions; }
/* harmony export */ });
/* unused harmony exports ChatContext, chatMessagesState, chatUnreadState */
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _daily_shared_lib_sortByKey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7414);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4283);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9378);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4480);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6804);
/* harmony import */ var _components_BreakoutRooms_helpers_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5436);
/* harmony import */ var _hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6081);
/* harmony import */ var _hooks_useDebugging__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2428);
/* harmony import */ var _hooks_useEmojiSkinTone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4064);
/* harmony import */ var _lib_advancedChat__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8394);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8038);
/* harmony import */ var _lib_state_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8890);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















// The base emoji we allow for reactions to chat messages. Emoji that allow skin tone modifiers
// are also included.
var defaultReactions = [
    "\uD83D\uDC4F",
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\u2764\uFE0F",
    "\uD83D\uDE02",
    "\uD83E\uDD2F",
    "\uD83C\uDF89",
    "\uD83D\uDC4B",
    "\u2795",
    "\uD83D\uDD25", 
];
// The initial reactions that are part of the chat message. We'll fill these arrays with the
// session_ids of the people who reacted with that specific emoji.
var initialReactions = {
    "\u2764\uFE0F": [],
    "\uD83C\uDF89": [],
    "\uD83D\uDC4D": [],
    "\uD83D\uDC4E": [],
    "\uD83D\uDC4F": [],
    "\uD83D\uDC4B": [],
    "\uD83D\uDE02": [],
    "\uD83E\uDD2F": [],
    "\u2795": [],
    "\uD83D\uDD25": []
};
var SYNC_CAP = 1000;
var SYNC_MAX_WAITING_TIME = 60 * 1000;
var SYNC_MAX_WAITING_TIME_OPEN = 5 * 1000;
var ChatContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(null);
var isEqualMessage = function(m1, m2) {
    return m1.fromId === m2.fromId && m1.message === m2.message && Math.abs(m1.date.getTime() - m2.date.getTime()) < 300;
};
var chatMessagesState = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)({
    key: "chat-messages",
    default: []
});
var chatUnreadState = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .selectorFamily */ .CG)({
    key: "chat-unread",
    get: function(room) {
        return function(param) {
            var get = param.get;
            var messages = get(chatMessagesState).filter(function(m) {
                return [
                    _lib_constants__WEBPACK_IMPORTED_MODULE_11__/* .BROADCAST_CHAT_MESSAGE */ .cR,
                    room
                ].includes(m.room);
            });
            return messages.some(function(m) {
                return !m.seen;
            });
        };
    }
});
var ChatProvider = function(param1) {
    var children = param1.children;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useDaily */ .VI)();
    var ref5 = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_7__/* .useCallConfig */ .A)(), enableAdvancedChat = ref5.enableAdvancedChat, enableChat = ref5.enableChat;
    var ref1 = _slicedToArray((0,_lib_state_core__WEBPACK_IMPORTED_MODULE_10__/* .useSidebarView */ .oS)(), 1), sidebarView = ref1[0];
    var prebuiltDebuggerEnabled = (0,_hooks_useDebugging__WEBPACK_IMPORTED_MODULE_8__/* .useDebugging */ .W)().prebuiltDebuggerEnabled;
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useLocalSessionId */ .q5)();
    var ref2 = (0,_hooks_useEmojiSkinTone__WEBPACK_IMPORTED_MODULE_9__/* .useEmojiSkinTone */ .v)(), addModifier = ref2.addModifier, removeModifier = ref2.removeModifier;
    var toggleReaction = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(chatMessage, reaction, modifiedEmoji) {
        var sessionId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : localSessionId;
        var ref;
        var ref4;
        var reactions = (ref4 = chatMessage === null || chatMessage === void 0 ? void 0 : (ref = chatMessage.reactions) === null || ref === void 0 ? void 0 : ref[reaction]) !== null && ref4 !== void 0 ? ref4 : {};
        var reactionsCopy = _objectSpread({}, reactions);
        if ((0,_lib_advancedChat__WEBPACK_IMPORTED_MODULE_12__/* .hasReactedBefore */ .h)(reactionsCopy, sessionId)) {
            // this person has already left the same (type of) emoji so remove it
            Object.keys(reactionsCopy).forEach(function(skinTone) {
                reactionsCopy[skinTone] = reactionsCopy[skinTone].filter(function(id) {
                    return id !== sessionId;
                });
            });
        } else {
            var _modifiedEmoji;
            // this person has not left the same emoji reaction before, so add it
            reactionsCopy[modifiedEmoji] = _toConsumableArray((_modifiedEmoji = reactionsCopy[modifiedEmoji]) !== null && _modifiedEmoji !== void 0 ? _modifiedEmoji : []).concat([
                sessionId, 
            ]);
        }
        return reactionsCopy;
    }, [
        localSessionId
    ]);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true), waitingForSyncToComplete = ref3[0], setWaitingForSyncToComplete = ref3[1];
    var waitingForSync = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(true);
    var requestedPeers = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)({});
    (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useThrottledDailyEvent */ .CH)("participant-updated", (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param2) {
        var set = param2.set;
        return function(evts) {
            set(chatMessagesState, function(n) {
                var newMessages = n.slice();
                evts.forEach(function(param) {
                    var participant = param.participant;
                    newMessages = newMessages.map(function(msg) {
                        if (msg.fromId === participant.session_id) {
                            return _objectSpread({}, msg, {
                                name: participant.user_name
                            });
                        }
                        return msg;
                    });
                });
                if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_4___default()(n, newMessages)) return n;
                return newMessages;
            });
        };
    }, []));
    var addMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(m) {
            set(chatMessagesState, function(old) {
                if (old.some(function(oldM) {
                    return isEqualMessage(oldM, m);
                })) {
                    return old;
                }
                return _toConsumableArray(old).concat([
                    m
                ]).sort((0,_daily_shared_lib_sortByKey__WEBPACK_IMPORTED_MODULE_2__/* .sortByKey */ .Y)("received"));
            });
        };
    }, []);
    var sendAppMessage1 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useAppMessage */ .F3)({
        onAppMessage: (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param) {
            var set = param.set, snapshot = param.snapshot;
            return function() {
                var _ref = _asyncToGenerator(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ev, sendAppMessage) {
                    var ref, ref6, ref7, ref8, messages, ref9, ref10, ref11, ref12, ref13, newMessage, _data, message1, reaction, skinTone, messageWithDates;
                    return _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                if (enableChat) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                _ctx.t0 = ev === null || ev === void 0 ? void 0 : (ref = ev.data) === null || ref === void 0 ? void 0 : ref.event;
                                _ctx.next = _ctx.t0 === "chat-msg" ? 6 : _ctx.t0 === "request-chat-history" ? 9 : _ctx.t0 === "sync-chat-msg" ? 17 : _ctx.t0 === "sync-chat-complete" ? 21 : _ctx.t0 === "message-reaction" ? 24 : 30;
                                break;
                            case 6:
                                ;
                                addMessage({
                                    date: new Date((ref6 = ev.data) === null || ref6 === void 0 ? void 0 : ref6.date),
                                    fromId: ev.fromId,
                                    id: (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(),
                                    local: false,
                                    message: (ref7 = ev.data) === null || ref7 === void 0 ? void 0 : ref7.message,
                                    name: (ref8 = ev.data) === null || ref8 === void 0 ? void 0 : ref8.name,
                                    received: new Date(),
                                    reactions: enableAdvancedChat ? _objectSpread({}, initialReactions) : null,
                                    room: ev.data.room,
                                    seen: sidebarView === "chat"
                                });
                                return _ctx.abrupt("break", 30);
                            case 9:
                                if (!waitingForSyncToComplete) {
                                    _ctx.next = 11;
                                    break;
                                }
                                return _ctx.abrupt("break", 30);
                            case 11:
                                _ctx.next = 13;
                                return snapshot.getPromise(chatMessagesState);
                            case 13:
                                messages = _ctx.sent;
                                _toConsumableArray(messages)// Send SYNC_CAP messages at max. Older messages won't be synced to avoid potential network bottlenecks.
                                .slice(-SYNC_CAP).forEach(function(message) {
                                    sendAppMessage({
                                        event: "sync-chat-msg",
                                        message: message
                                    }, ev.fromId);
                                });
                                sendAppMessage({
                                    event: "sync-chat-complete"
                                }, ev.fromId);
                                return _ctx.abrupt("break", 30);
                            case 17:
                                ;
                                newMessage = _objectSpread({}, (ref9 = ev.data) === null || ref9 === void 0 ? void 0 : ref9.message, {
                                    date: new Date((ref10 = ev.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.message) === null || ref11 === void 0 ? void 0 : ref11.date),
                                    id: (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(),
                                    local: false,
                                    received: new Date((ref12 = ev.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.message) === null || ref13 === void 0 ? void 0 : ref13.received),
                                    seen: sidebarView === "chat"
                                });
                                addMessage(newMessage);
                                return _ctx.abrupt("break", 30);
                            case 21:
                                setWaitingForSyncToComplete(false);
                                // Map not needed anymore at this point
                                requestedPeers.current = {};
                                return _ctx.abrupt("break", 30);
                            case 24:
                                if (enableAdvancedChat) {
                                    _ctx.next = 26;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 26:
                                _data = ev.data, message1 = _data.message, reaction = _data.reaction, skinTone = _data.skinTone;
                                messageWithDates = _objectSpread({}, message1, {
                                    date: new Date(message1.date),
                                    received: new Date(message1.received)
                                });
                                set(chatMessagesState, function(msgs) {
                                    return msgs.map(function(m) {
                                        if (isEqualMessage(messageWithDates, m)) return _objectSpread({}, m, {
                                            reactions: _objectSpread({}, m.reactions, _defineProperty({}, reaction, toggleReaction(m, reaction, skinTone, ev.fromId)))
                                        });
                                        return m;
                                    });
                                });
                                return _ctx.abrupt("break", 30);
                            case 30:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(ev, sendAppMessage) {
                    return _ref.apply(this, arguments);
                };
            }();
        }, [
            addMessage,
            enableAdvancedChat,
            enableChat,
            sidebarView,
            toggleReaction,
            waitingForSyncToComplete, 
        ])
    });
    /**
   * Sends a chat message to all other participants via sendAppMessage.
   */ var sendMessage = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(message, room) {
        if (!enableChat) return;
        var date = new Date();
        var local = daily.participants().local;
        addMessage({
            date: date,
            fromId: local.session_id,
            id: (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(),
            local: true,
            message: message,
            name: local.user_name,
            reactions: enableAdvancedChat ? _objectSpread({}, initialReactions) : null,
            received: date,
            room: room,
            seen: true
        });
        sendAppMessage1({
            event: "chat-msg",
            date: date,
            message: message,
            name: local.user_name,
            room: room
        });
    }, [
        addMessage,
        daily,
        enableAdvancedChat,
        enableChat,
        sendAppMessage1
    ]);
    /**
   * Adds or removes reaction to a message.
   */ var reactToMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(msg, reaction) {
            if (!enableAdvancedChat) return;
            set(chatMessagesState, function(msgs) {
                return msgs.map(function(m) {
                    // get base emoji (the yellow guy)
                    // if the reaction has no modifier, that's fine, it'll just return the original emoji
                    var baseEmoji = removeModifier(reaction);
                    if (isEqualMessage(m, msg)) {
                        // if there's a modifier, add it back. if there's no modifier, that's fine too,
                        // addModifier() will just return the original yellow guy
                        var modifiedEmoji = addModifier(baseEmoji);
                        var newMessage = _objectSpread({}, m, {
                            reactions: _objectSpread({}, m.reactions, _defineProperty({}, baseEmoji, toggleReaction(m, baseEmoji, modifiedEmoji)))
                        });
                        sendAppMessage1({
                            event: "message-reaction",
                            message: m,
                            reaction: baseEmoji,
                            skinTone: modifiedEmoji
                        });
                        return newMessage;
                    }
                    return m;
                });
            });
        };
    }, [
        enableAdvancedChat,
        addModifier,
        removeModifier,
        toggleReaction,
        sendAppMessage1, 
    ]);
    /**
   * Requests chat history (via sendAppMessage) from a random remote peer with an older joined_at date.
   * Does not request if no other remote peers of interest are available.
   */ var requestChatHistory = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var participants = daily.participants();
        if (!(participants === null || participants === void 0 ? void 0 : participants.local)) return;
        var joinedDate = participants.local.joined_at || 0;
        var _id;
        // Previous in the sense of "those who were in the meeting earlier"
        var previousRemotePeerIds = Object.entries(participants).filter(function(param) {
            var _param = _slicedToArray(param, 2), id = _param[0], participant = _param[1];
            return id !== "local" && participant.joined_at < joinedDate && // don't bother requesting history from anyone we already pinged twice
            ((_id = requestedPeers.current[id]) !== null && _id !== void 0 ? _id : 0) < 2;
        }).map(function(param) {
            var _param = _slicedToArray(param, 1), id = _param[0];
            return id;
        });
        // Nothing to sync if there are no older remote peers
        if (previousRemotePeerIds.length === 0) {
            setWaitingForSyncToComplete(false);
            return;
        }
        // Pick a random remote peer id and request history
        var randomIdx = Math.floor(previousRemotePeerIds.length * Math.random());
        var randomId = previousRemotePeerIds[randomIdx];
        sendAppMessage1({
            event: "request-chat-history"
        }, randomId);
        requestedPeers.current[randomId] = randomId in requestedPeers.current ? requestedPeers.current[randomId] + 1 : 1;
    }, [
        daily,
        sendAppMessage1
    ]);
    // DEBUGGING: Add configurable fake chat messages
    var debugAddFakeChatMessages = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (!enableChat) return;
        var _gifRatio = config.gifRatio, gifRatio = _gifRatio === void 0 ? 0.25 : _gifRatio, _interval = config.interval, interval = _interval === void 0 ? 1 : _interval, _localRatio = config.localRatio, localRatio = _localRatio === void 0 ? 0.25 : _localRatio, _messageCount = config.messageCount, messageCount = _messageCount === void 0 ? 20 : _messageCount, _participantCount = config.participantCount, participantCount = _participantCount === void 0 ? 4 : _participantCount, _startDate = config.startDate, startDate = _startDate === void 0 ? new Date(Date.now() - 5 * 60000) : _startDate;
        var gifList = gifRatio ? _lib_constants__WEBPACK_IMPORTED_MODULE_11__/* .DEBUG_GIF_MESSAGES */ .CX : undefined;
        var localParticipant = daily.participants().local;
        var currentDateSelector = 0;
        var dateList;
        var currentParticipant;
        var participantList;
        // helper function for adding messages to chat
        var addFakeMessage = function(message, id) {
            var date = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Date(), local = arguments.length > 3 ? arguments[3] : void 0, room = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : _components_BreakoutRooms_helpers_constants__WEBPACK_IMPORTED_MODULE_14__/* .MAIN_ROOM_IDENTIFIER */ .b;
            addMessage({
                date: date,
                fromId: local ? localParticipant.session_id : currentParticipant,
                id: id,
                local: local,
                message: message,
                name: local ? localParticipant.user_name : currentParticipant,
                reactions: enableAdvancedChat ? _objectSpread({}, initialReactions) : null,
                received: date,
                room: room
            });
        };
        console.warn("Generating chat messages...");
        // generate participants
        if (participantCount) {
            participantList = [];
            // generate participant ids
            for(var i = 0; i < participantCount; i++){
                participantList.push((0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)());
            }
        }
        // generate dates in range from 'startDate' to now at regular intervals
        if (startDate) {
            dateList = [];
            var dateDelta = Math.abs(Date.now() - startDate.getTime());
            var dateStep = dateDelta / messageCount;
            var tempDate = startDate;
            for(var i1 = 0; i1 <= messageCount; i1++){
                dateList.push(tempDate);
                tempDate = new Date(tempDate.getTime() + dateStep);
            }
        }
        // generate chat messages
        if (messageCount) {
            var mCounter = 0;
            // use Interval to regularly add a message in a configurable frequency
            var mInterval = setInterval(function() {
                // clear Interval when all messages are out
                if (mCounter === messageCount) {
                    console.warn("Done generating text chat messages.");
                    clearInterval(mInterval);
                    return;
                }
                // select a random participant
                if (participantCount) {
                    currentParticipant = participantList[Math.floor(Math.random() * participantList.length)];
                }
                var messageId = (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
                var isLocal = !!localRatio && Math.random() <= localRatio;
                if (!!gifRatio && Math.random() <= gifRatio) {
                    // generate gif message
                    addFakeMessage(gifList[Math.floor(Math.random() * gifList.length)], messageId, startDate && dateList[currentDateSelector], isLocal);
                } else {
                    // generate text message
                    addFakeMessage("Test message #".concat(messageId), messageId, startDate && dateList[currentDateSelector], isLocal);
                }
                mCounter++;
                if (startDate) currentDateSelector++;
            }, interval);
        }
    }, [
        addMessage,
        daily,
        enableAdvancedChat,
        enableChat
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        window["dailyDebugAddFakeChatMessages"] = prebuiltDebuggerEnabled ? debugAddFakeChatMessages : undefined;
    }, [
        debugAddFakeChatMessages,
        prebuiltDebuggerEnabled
    ]);
    /**
   * Starts requesting chat history when joined-meeting.
   */ (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!daily || daily.isDestroyed() || !enableChat || !waitingForSyncToComplete) return;
        var interval;
        var timeout;
        // Randomize delay to increase the chance of lowering overall network traffic
        var requestDelay = 1000 + Math.ceil(2000 * Math.random());
        var handleJoinedMeeting = function() {
            timeout = setTimeout(function() {
                // No chat history within ${SYNC_MAX_WAITING_TIME}. Abort!
                waitingForSync.current = false;
                setWaitingForSyncToComplete(false);
            }, SYNC_MAX_WAITING_TIME);
            interval = setInterval(function() {
                if (!waitingForSync.current) {
                    clearInterval(interval);
                    return;
                }
                requestChatHistory();
            }, requestDelay);
        };
        daily.on("joined-meeting", handleJoinedMeeting);
        return function() {
            clearInterval(interval);
            clearTimeout(timeout);
            daily.off("joined-meeting", handleJoinedMeeting);
        };
    }, [
        daily,
        enableChat,
        requestChatHistory,
        waitingForSyncToComplete
    ]);
    /**
   * When opening chat while syncing, wait at most 5 additional seconds.
   */ (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (sidebarView !== "chat") return;
        var timeout = setTimeout(function() {
            if (waitingForSync.current) {
                waitingForSync.current = false;
                setWaitingForSyncToComplete(false);
            }
        }, SYNC_MAX_WAITING_TIME_OPEN);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        sidebarView,
        waitingForSyncToComplete
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChatContext.Provider, {
        value: {
            loading: waitingForSyncToComplete,
            reactToMessage: reactToMessage,
            sendMessage: sendMessage
        },
        children: children
    });
};
var useChatState = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(ChatContext);
};
var useChatMessages = function() {
    var messages = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(chatMessagesState);
    var markMessagesAsRead = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            set(chatMessagesState, function(msgs) {
                return msgs.some(function(m) {
                    return !m.seen;
                }) ? msgs.map(function(m) {
                    return _objectSpread({}, m, {
                        seen: true
                    });
                }) : msgs;
            });
        };
    }, []);
    return {
        messages: messages,
        markMessagesAsRead: markMessagesAsRead
    };
};
var useChatUnread = function(room) {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(chatUnreadState(room));
};


/***/ }),

/***/ 9394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ useParticipants; },
/* harmony export */   "EF": function() { return /* binding */ useCurrentSpeakerId; },
/* harmony export */   "Q": function() { return /* binding */ useParticipantMetaData; },
/* harmony export */   "Ub": function() { return /* binding */ useMuteNewParticipants; },
/* harmony export */   "jU": function() { return /* binding */ useParticipantMarkedForRemoval; },
/* harmony export */   "n5": function() { return /* binding */ ParticipantsProvider; },
/* harmony export */   "o8": function() { return /* binding */ useOrderedParticipantIds; }
/* harmony export */ });
/* unused harmony export ParticipantsContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var _components_BreakoutRooms_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8610);
/* harmony import */ var _hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6081);
/* harmony import */ var _hooks_usePreviousValue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3584);
/* harmony import */ var _lib_participants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1975);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7556);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var ParticipantsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
var participantMetaDataState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "participant-meta-data",
    default: {}
});
var useParticipantMetaData = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(participantMetaDataState);
};
var orderedParticipantIdsState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "ordered-participant-ids",
    default: []
});
var useOrderedParticipantIds = function() {
    var orderedIds = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(orderedParticipantIdsState);
    var ref = (0,_components_BreakoutRooms_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_4__/* .useBreakoutSessionState */ .V)(), breakoutParticipantIds = ref.breakoutParticipantIds, hasJoinedBreakout = ref.hasJoinedBreakout, mainRoomParticipantIds = ref.mainRoomParticipantIds;
    return orderedIds.filter(function(id) {
        return hasJoinedBreakout ? breakoutParticipantIds.includes(id) : mainRoomParticipantIds.includes(id);
    });
};
var participantMarkedForRemovalState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "participant-marked-for-removal",
    default: ""
});
var useParticipantMarkedForRemoval = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(participantMarkedForRemovalState);
};
var muteNewParticipantsState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "mute-new-participants",
    default: false
});
var useMuteNewParticipants = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(muteNewParticipantsState);
};
var ParticipantsEventsHandler = function() {
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var broadcast = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__/* .useCallConfig */ .A)().broadcast;
    var muteNewParticipants = useMuteNewParticipants();
    /**
   * Maintain positions for each participant in Speaker & Grid view.
   */ (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useThrottledDailyEvent */ .CH)([
        "participant-joined",
        "participant-left"
    ], (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param1) {
        var transact_UNSTABLE = param1.transact_UNSTABLE;
        return function(evts) {
            var ref2;
            var ref1;
            var participants = (ref1 = daily === null || daily === void 0 ? void 0 : (ref2 = daily.participants) === null || ref2 === void 0 ? void 0 : ref2.call(daily)) !== null && ref1 !== void 0 ? ref1 : {};
            var muteUpdates = {};
            transact_UNSTABLE(function(param) {
                var set = param.set;
                evts.forEach(function(ev) {
                    switch(ev.action){
                        case "participant-joined":
                            // Ignore non-owners in owner-only-broadcast
                            if (broadcast && !ev.participant.owner) return;
                            // Save new participant's cam & mic state for later
                            var isCamOn = !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(ev.participant, "video");
                            var isMicOn = !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(ev.participant, "audio");
                            set(orderedParticipantIdsState, function(prevIds) {
                                var newIds = prevIds.slice();
                                if (!isCamOn) {
                                    // Append cam-off participants to the end of the list
                                    return _toConsumableArray(newIds).concat([
                                        ev.participant.session_id
                                    ]);
                                }
                                // Find position of first cam-off & mic-off participant
                                var firstInactiveCamOffIndex = newIds.findIndex(function(id) {
                                    var ref;
                                    return (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(participants[id], "video") && (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(participants[id], "audio") && !((ref = participants[id]) === null || ref === void 0 ? void 0 : ref.local);
                                });
                                if (firstInactiveCamOffIndex >= 0) {
                                    // Insert new participant BEFORE first cam-off & mic-off participant
                                    newIds.splice(firstInactiveCamOffIndex, 0, ev.participant.session_id);
                                } else {
                                    // Otherwise just append new participant to the end of the list
                                    newIds.push(ev.participant.session_id);
                                }
                                return newIds.filter(Boolean);
                            });
                            if (isMicOn) {
                                // Actual check for muting happens later.
                                // This just adds to the updates object.
                                muteUpdates[ev.participant.session_id] = {
                                    setAudio: false
                                };
                            }
                            break;
                        case "participant-left":
                            set(orderedParticipantIdsState, function(prevIds) {
                                return prevIds.filter(function(id) {
                                    return id !== ev.participant.session_id;
                                });
                            });
                            set(participantMetaDataState, function(md) {
                                var newMetaData = _objectSpread({}, md);
                                delete newMetaData[ev.participant.session_id];
                                return newMetaData;
                            });
                            break;
                    }
                });
            });
            if (muteNewParticipants && daily && Object.keys(muteUpdates).length > 0) {
                daily.updateParticipants(muteUpdates);
            }
        };
    }, [
        broadcast,
        daily,
        muteNewParticipants
    ]));
    return null;
};
var ParticipantsProvider = function(param2) {
    var children = param2.children;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    /**
     * Unmuted participant ids.
     */ var unmutedParticipantIds = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useParticipantIds */ .OV)({
        filter: (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(p) {
            return !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p, "audio");
        }, [])
    });
    var prevUnmutedParticipantIds = (0,_hooks_usePreviousValue__WEBPACK_IMPORTED_MODULE_6__/* .usePreviousValue */ .z)(unmutedParticipantIds);
    var setMetaData = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useSetRecoilState */ .Zl)(participantMetaDataState);
    /**
     * Update last_active_date whenever a participant unmutes.
     */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var newlyUnmutedIds = unmutedParticipantIds.filter(function(id) {
            return !prevUnmutedParticipantIds.includes(id);
        });
        if (!newlyUnmutedIds.length) return;
        setMetaData(function(m) {
            var newMetaData = _objectSpread({}, m);
            newlyUnmutedIds.forEach(function(id) {
                newMetaData[id] = _objectSpread({}, newMetaData[id], {
                    last_active_date: new Date()
                });
            });
            return newMetaData;
        });
    }, [
        prevUnmutedParticipantIds,
        setMetaData,
        unmutedParticipantIds
    ]);
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useLocalSessionId */ .q5)();
    var isLocalOwner = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useParticipantProperty */ .ou)(localSessionId, "owner");
    /**
     * Swaps the position of 2 participants identified by their session_id.
     */ var swapParticipantPosition = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(id1, id2) {
            /**
           * Ignore in the following cases:
           * - id1 and id2 are equal
           * - one of both ids is not set
           */ if (id1 === id2 || !id1 || !id2) return;
            set(orderedParticipantIdsState, function(prevIds) {
                var newIds = prevIds.slice();
                var idx1 = prevIds.indexOf(id1);
                var idx2 = prevIds.indexOf(id2);
                /**
             * Could not find one of both ids in array.
             * This can be due to a race condition when a participant leaves,
             * while a swap of positions is triggered.
             */ if (idx1 === -1 || idx2 === -1) return prevIds;
                newIds[idx1] = id2;
                newIds[idx2] = id1;
                return newIds;
            });
        };
    }, []);
    var muteAll = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            var muteFutureParticipants = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!isLocalOwner) return;
            set(muteNewParticipantsState, muteFutureParticipants);
            if (!unmutedParticipantIds.length) return;
            daily.updateParticipants(unmutedParticipantIds.reduce(function(o, id) {
                if (id === localSessionId) return o;
                o[id] = {
                    setAudio: false
                };
                return o;
            }, {}));
        };
    }, [
        daily,
        isLocalOwner,
        localSessionId,
        unmutedParticipantIds
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ParticipantsContext.Provider, {
        value: {
            muteAll: muteAll,
            swapParticipantPosition: swapParticipantPosition
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParticipantsEventsHandler, {})
        ]
    });
};
var useParticipants = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(ParticipantsContext);
};
/**
 * Returns the session_id for the participant that should be rendered
 * prominently in speaker or mobile view.
 */ var useCurrentSpeakerId = function() {
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useLocalSessionId */ .q5)();
    var orderedParticipantIds = useOrderedParticipantIds();
    var activeSpeakerId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useActiveSpeakerId */ .fu)({
        filter: (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
            var isRemoteSpeaker = orderedParticipantIds.includes(id);
            if (orderedParticipantIds.length) return isRemoteSpeaker && id !== localSessionId;
            return id === localSessionId;
        }, [
            localSessionId,
            orderedParticipantIds
        ])
    });
    var ref5 = _slicedToArray((0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_8__/* .usePinnedId */ .Sg)(), 1), pinnedId = ref5[0];
    var participantMetaData = useParticipantMetaData();
    var broadcastRole = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__/* .useCallConfig */ .A)().broadcastRole;
    if (!daily) return null;
    /**
   * Ensure activeParticipant is still present in the call.
   * The activeParticipant only updates to a new active participant so
   * if everyone else is muted when AP leaves, the value will be stale.
   */ var isPresent = orderedParticipantIds.includes(activeSpeakerId);
    var isPinnedPresent = orderedParticipantIds.includes(pinnedId) || pinnedId === localSessionId;
    if (isPinnedPresent) return pinnedId;
    var participants = Object.values(daily.participants());
    if (!isPresent && orderedParticipantIds.length > 0 && orderedParticipantIds.every(function(id) {
        var ref;
        var p1 = participants.find(function(p) {
            return p.session_id === id;
        });
        return (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p1, "audio") && !(participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref = participantMetaData[id]) === null || ref === void 0 ? void 0 : ref.last_active_date);
    })) {
        var ref3;
        // Return first cam on participant in case everybody is muted and nobody ever talked
        // or first remote participant, in case everybody's cam is muted, too.
        return (ref3 = orderedParticipantIds.find(function(id) {
            var p2 = participants.find(function(p) {
                return p.session_id === id;
            });
            return !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p2, "video");
        })) !== null && ref3 !== void 0 ? ref3 : orderedParticipantIds === null || orderedParticipantIds === void 0 ? void 0 : orderedParticipantIds[0];
    }
    var sorted = orderedParticipantIds.slice().sort(function(a, b) {
        var ref, ref6;
        var lastActiveA = participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref = participantMetaData[a]) === null || ref === void 0 ? void 0 : ref.last_active_date;
        var lastActiveB = participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref6 = participantMetaData[b]) === null || ref6 === void 0 ? void 0 : ref6.last_active_date;
        if (lastActiveA > lastActiveB) return 1;
        if (lastActiveA < lastActiveB) return -1;
        return 0;
    }).reverse();
    var fallback = broadcastRole === "attendee" ? null : localSessionId;
    var ref4;
    return isPresent ? activeSpeakerId : (ref4 = sorted === null || sorted === void 0 ? void 0 : sorted[0]) !== null && ref4 !== void 0 ? ref4 : fallback;
};


/***/ }),

/***/ 2147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ useRecording; },
/* harmony export */   "RV": function() { return /* binding */ RecordingProvider; },
/* harmony export */   "xA": function() { return /* binding */ isCloudRecordingType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _daily_shared_components_Icons_WarningIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8262);
/* harmony import */ var _daily_shared_contexts_Snackbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4017);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4283);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2031);
/* harmony import */ var _hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6081);
/* harmony import */ var _lib_state_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8890);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7556);
/* harmony import */ var _lib_state_recordings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4183);
/* harmony import */ var _CallProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6797);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var RecordingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)({
    startRecording: null,
    stopRecording: null
});
function isCloudRecordingType(recType) {
    return recType === "cloud" || recType === "cloud-beta";
}
var RecordingProvider = function(param) {
    var children = param.children;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)().t;
    var state = (0,_CallProvider__WEBPACK_IMPORTED_MODULE_9__/* .useCallState */ .oz)().state;
    var enableRecording = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__/* .useCallConfig */ .A)().enableRecording;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useDaily */ .VI)();
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useLocalSessionId */ .q5)();
    var isLocalOwner = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useParticipantProperty */ .ou)(localSessionId, "owner");
    var viewMode = (0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_7__/* .useViewMode */ .mJ)();
    var ref5 = _slicedToArray((0,_lib_state_core__WEBPACK_IMPORTED_MODULE_6__/* .useIsMobile */ .dD)(), 1), isMobile = ref5[0];
    var ref1 = _slicedToArray((0,_lib_state_recordings__WEBPACK_IMPORTED_MODULE_8__/* .useRecordingErrorModal */ .p8)(), 2), setShowRecordingErrorModal = ref1[1];
    var addMessage = (0,_daily_shared_contexts_Snackbar__WEBPACK_IMPORTED_MODULE_2__.useSnackbar)().addMessage;
    var ref2 = _slicedToArray((0,_lib_state_recordings__WEBPACK_IMPORTED_MODULE_8__/* .useRecordingUI */ .oZ)(), 2), recordingUIState = ref2[0], setRecordingUIState = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isInitiator = ref3[0], setIsInitiator = ref3[1];
    /**
   * Updates config for startRecording based on viewMode.
   */ var cloudRecordingConfig = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return {
            layout: {
                preset: viewMode === "speaker" ? "active-participant" : "default"
            }
        };
    }, [
        viewMode
    ]);
    var ref4 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useRecording */ .$n)({
        onRecordingStarted: (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
            setRecordingUIState(null);
        }, [
            setRecordingUIState
        ]),
        onRecordingStopped: (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
            setIsInitiator(false);
        }, [])
    }), isRecording = ref4.isRecording, layout = ref4.layout, local = ref4.local, startedBy = ref4.startedBy, startDailyRecording = ref4.startRecording, stopDailyRecording = ref4.stopRecording;
    /**
   * Displays an error message in the following cases:
   * - the local participant is the one who initiated the cloud recording (not single-participant)
   * - the local participant initiated the local or cloud (old) recording
   * - the local participant is a meeting owner
   *
   * In case a single-participant cloud recording errored out,
   * only the recorded participant sees the error message.
   */ (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useDailyEvent */ .VU)("recording-error", (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setRecordingUIState(null);
        var isRecordedSingleParticipant = isCloudRecordingType(enableRecording) && (layout === null || layout === void 0 ? void 0 : layout.preset) === "single-participant" && (layout === null || layout === void 0 ? void 0 : layout.session_id) === localSessionId;
        var isInitiatorOrOwner = // when the recording fails to start, we don't know who initiated it, so have to use the local state
        // to determine if the local participant is the one who initiated the recording
        isInitiator || isLocalOwner || local || isCloudRecordingType(enableRecording) && (layout === null || layout === void 0 ? void 0 : layout.preset) !== "single-participant" && startedBy === localSessionId;
        var couldNotStartRecording = isCloudRecordingType(enableRecording) && !startedBy && !layout;
        if (isRecordedSingleParticipant || isInitiatorOrOwner) {
            /**
         * In case recording did not even start, error message is only
         * displayed to owners, because all other checks will fail.
         */ if (couldNotStartRecording) {
                addMessage({
                    content: t("recording.status.failedToStart"),
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_daily_shared_components_Icons_WarningIcon__WEBPACK_IMPORTED_MODULE_1__.WarningIcon, {
                        size: 16
                    }),
                    timeout: 30000,
                    type: "error"
                });
            } else if (isMobile) {
                addMessage({
                    content: t("recording.status.stopped"),
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_daily_shared_components_Icons_WarningIcon__WEBPACK_IMPORTED_MODULE_1__.WarningIcon, {
                        size: 16
                    }),
                    type: "error"
                });
            } else {
                setShowRecordingErrorModal(true);
            }
        }
        // cleanup the initiator after showing the error message
        setIsInitiator(false);
    }, [
        addMessage,
        enableRecording,
        isMobile,
        layout,
        local,
        isInitiator,
        isLocalOwner,
        localSessionId,
        setRecordingUIState,
        setShowRecordingErrorModal,
        startedBy,
        t, 
    ]));
    /**
   * Prevent users from accidentally leaving the meeting without stopping
   * their running recording.
   */ var handleOnUnload = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        return t("recording.confirmLeave");
    }, [
        t
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!enableRecording || isCloudRecordingType(enableRecording) || !isRecording || state === "redirecting") return;
        var prev = window.onbeforeunload;
        window.onbeforeunload = handleOnUnload;
        return function() {
            window.onbeforeunload = prev;
        };
    }, [
        enableRecording,
        handleOnUnload,
        isRecording,
        state
    ]);
    /**
   * Actually start the recording via API, after countdown.
   */ var startRecordingForRealz = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        if (isRecording) return;
        if (isCloudRecordingType(enableRecording)) {
            startDailyRecording(cloudRecordingConfig);
        } else {
            startDailyRecording();
        }
    }, [
        cloudRecordingConfig,
        enableRecording,
        isRecording,
        startDailyRecording
    ]);
    /**
   * Progress recording UI state.
   */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var timeout;
        switch(recordingUIState){
            case "starting3":
                timeout = setTimeout(function() {
                    setRecordingUIState("starting2");
                }, 1000);
                break;
            case "starting2":
                timeout = setTimeout(function() {
                    setRecordingUIState("starting1");
                }, 1000);
                break;
            case "starting1":
                if (isInitiator) startRecordingForRealz();
                break;
            case "saved":
                timeout = setTimeout(function() {
                    setRecordingUIState(null);
                }, 5000);
                break;
        }
        return function() {
            clearTimeout(timeout);
        };
    }, [
        isInitiator,
        recordingUIState,
        setRecordingUIState,
        startRecordingForRealz, 
    ]);
    var sendAppMessage = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useAppMessage */ .F3)({
        onAppMessage: (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(ev) {
            var ref;
            switch(ev === null || ev === void 0 ? void 0 : (ref = ev.data) === null || ref === void 0 ? void 0 : ref.event){
                /**
           * Initialize recording countdown for remote participants.
           */ case "recording-starting":
                    setIsInitiator(false);
                    setRecordingUIState("starting3");
                    break;
            }
        }, [
            setRecordingUIState
        ])
    });
    /**
   * Triggered via UI. Initializes the countdown.
   */ var startRecording = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        if (!daily || !enableRecording || isRecording) return;
        setIsInitiator(true);
        setRecordingUIState("starting3");
        sendAppMessage({
            event: "recording-starting"
        });
    }, [
        daily,
        enableRecording,
        isRecording,
        sendAppMessage,
        setRecordingUIState, 
    ]);
    /**
   * Triggered via UI.
   */ var stopRecording = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        if (!enableRecording || !isRecording) return;
        setRecordingUIState("saved");
        stopDailyRecording();
    }, [
        enableRecording,
        isRecording,
        setRecordingUIState,
        stopDailyRecording
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecordingContext.Provider, {
        value: {
            startRecording: startRecording,
            stopRecording: stopRecording
        },
        children: children
    });
};
var useRecording = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(RecordingContext);
};


/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useCallConfig; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4061);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _contexts_RecordingProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2147);
/* harmony import */ var _lib_browserConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7530);
/* harmony import */ var _lib_state_custom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3510);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7556);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var useCallConfig = function() {
    var ref20, ref1;
    var room = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useRoom */ .NW)();
    var ref2 = _slicedToArray((0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_7__/* .usePreferredViewMode */ .Ut)(), 2), setPreferredViewMode = ref2[1];
    var ref3 = _slicedToArray((0,_lib_state_custom__WEBPACK_IMPORTED_MODULE_6__/* .useMaxGridTilesPerPage */ .lW)(), 2), setMaxGridTilesPerPage = ref3[1];
    /**
   * Apply Prebuilt UI constraints, when experimental_optimize_large_calls is set.
   */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var ref;
        var optimizeLargeCalls = room === null || room === void 0 ? void 0 : (ref = room.config) === null || ref === void 0 ? void 0 : ref.experimental_optimize_large_calls;
        if (!optimizeLargeCalls) return;
        setMaxGridTilesPerPage(12);
    // TBC: For now, start the call in Speaker view to match the group call default
    // setPreferredViewMode('grid');
    }, [
        room,
        setMaxGridTilesPerPage,
        setPreferredViewMode
    ]);
    if (!room) return {
        broadcast: null,
        broadcastRole: null,
        poweredByDaily: false
    };
    var config = room.config, domainConfig = room.domainConfig, tokenConfig = room.tokenConfig;
    var ref4;
    var broadcast = (ref4 = config === null || config === void 0 ? void 0 : config.owner_only_broadcast) !== null && ref4 !== void 0 ? ref4 : null;
    var isOwner = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.is_owner;
    var hasFullUIControls = !broadcast || broadcast && isOwner;
    var ref5;
    var recordingType = (ref5 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_recording) !== null && ref5 !== void 0 ? ref5 : config === null || config === void 0 ? void 0 : config.enable_recording;
    var browser =  false ? 0 : bowser__WEBPACK_IMPORTED_MODULE_2___default().parse(window.navigator.userAgent);
    var supportsLocalRecording = (browser === null || browser === void 0 ? void 0 : (ref20 = browser.platform) === null || ref20 === void 0 ? void 0 : ref20.type) === "desktop" && (browser === null || browser === void 0 ? void 0 : (ref1 = browser.engine) === null || ref1 === void 0 ? void 0 : ref1.name) === "Blink";
    var isLocalRecordingReady = recordingType === "local" && supportsLocalRecording;
    var ref6;
    var recordingsBucket = (ref6 = config === null || config === void 0 ? void 0 : config.recordings_bucket) !== null && ref6 !== void 0 ? ref6 : domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.recordings_bucket;
    var isCloudRecordingAllowed = !domainConfig.hipaa || domainConfig.hipaa && recordingsBucket;
    var isCloudRecordingReady = isCloudRecordingAllowed && (0,_contexts_RecordingProvider__WEBPACK_IMPORTED_MODULE_4__/* .isCloudRecordingType */ .xA)(recordingType);
    var enableRecording = hasFullUIControls && (isLocalRecordingReady || isCloudRecordingReady) ? recordingType : null;
    var ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    return {
        broadcast: broadcast,
        broadcastRole: broadcast ? isOwner ? "owner" : "attendee" : null,
        enableBreakoutRooms: (ref7 = config === null || config === void 0 ? void 0 : config.enable_breakout_rooms) !== null && ref7 !== void 0 ? ref7 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_breakout_rooms),
        enableEmojiReactions: (ref8 = config === null || config === void 0 ? void 0 : config.enable_emoji_reactions) !== null && ref8 !== void 0 ? ref8 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_emoji_reactions),
        enableAdvancedChat: (ref9 = config === null || config === void 0 ? void 0 : config.enable_advanced_chat) !== null && ref9 !== void 0 ? ref9 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_advanced_chat),
        enableChat: (ref10 = config === null || config === void 0 ? void 0 : config.enable_chat) !== null && ref10 !== void 0 ? ref10 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_chat),
        enableImplicitPassiveParticipant: !!(config === null || config === void 0 ? void 0 : config["enable_implicit_passive_participants"]),
        enableNetworkUI: (ref11 = config === null || config === void 0 ? void 0 : config.enable_network_ui) !== null && ref11 !== void 0 ? ref11 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_network_ui),
        enableNoiseCancellationUI: !(0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_5__/* .isSafari */ .G6)() && _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsAudioProcessing && ((ref12 = config === null || config === void 0 ? void 0 : config.enable_noise_cancellation_ui) !== null && ref12 !== void 0 ? ref12 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_noise_cancellation_ui)),
        enablePeopleUI: (ref14 = (ref13 = config === null || config === void 0 ? void 0 : config.enable_people_ui) !== null && ref13 !== void 0 ? ref13 : domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_people_ui) !== null && ref14 !== void 0 ? ref14 : true,
        enablePIPUI: (ref15 = config === null || config === void 0 ? void 0 : config.enable_pip_ui) !== null && ref15 !== void 0 ? ref15 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_pip_ui),
        enableHandRaising: (ref16 = config === null || config === void 0 ? void 0 : config.enable_hand_raising) !== null && ref16 !== void 0 ? ref16 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_hand_raising),
        enableRecording: enableRecording,
        enableRecordingUI: (ref17 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_recording_ui) !== null && ref17 !== void 0 ? ref17 : !!enableRecording,
        enableScreenShare: hasFullUIControls && ((ref18 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_screenshare) !== null && ref18 !== void 0 ? ref18 : config === null || config === void 0 ? void 0 : config.enable_screenshare) && _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsScreenShare,
        enableVideoProcessingUI: _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsVideoProcessing && ((ref19 = config === null || config === void 0 ? void 0 : config.enable_video_processing_ui) !== null && ref19 !== void 0 ? ref19 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_video_processing_ui)),
        optimizeLargeCalls: config === null || config === void 0 ? void 0 : config.experimental_optimize_large_calls,
        poweredByDaily: domainConfig && "hide_daily_branding" in domainConfig ? !(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.hide_daily_branding) : false
    };
};


/***/ }),

/***/ 5745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ useCustomIntegrations; }
});

// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./hooks/useMeetingSessionState.ts



var meetingSessionDataState = (0,es/* atom */.cn)({
    key: "meeting-session-data",
    default: undefined
});
var useMeetingSessionState = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var meetingSessionState = (0,es/* useRecoilValue */.sJ)(meetingSessionDataState);
    var initState = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(meetingSessionDataState, daily.meetingSessionState());
        };
    }, [
        daily
    ]);
    /**
   * Initialize state when joined meeting or setting up the hook.
   */ (0,daily_react_esm/* useDailyEvent */.VU)("joined-meeting", initState);
    (0,react.useEffect)(function() {
        if ((daily === null || daily === void 0 ? void 0 : daily.meetingState()) !== "joined-meeting") return;
        initState();
    }, [
        daily,
        initState
    ]);
    /**
   * Update Recoil state whenever meeting session state is updated.
   */ (0,daily_react_esm/* useDailyEvent */.VU)("meeting-session-state-updated", (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(ev) {
            set(meetingSessionDataState, ev.meetingSessionState);
        };
    }, []));
    /**
   * Reset Recoil state when meeting ends.
   */ (0,daily_react_esm/* useDailyEvent */.VU)("left-meeting", (0,es/* useRecoilCallback */._8)(function(param) {
        var reset = param.reset;
        return function() {
            reset(meetingSessionDataState);
        };
    }, []));
    return {
        data: meetingSessionState === null || meetingSessionState === void 0 ? void 0 : meetingSessionState.data,
        topology: meetingSessionState === null || meetingSessionState === void 0 ? void 0 : meetingSessionState.topology
    };
};

;// CONCATENATED MODULE: ./hooks/useCustomIntegrations.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var customIntegrationsState = (0,es/* atom */.cn)({
    key: "custom-integrations",
    default: {}
});
var SESSION_STATE_KEY = "integrations";
var integrationsMeetingState = (0,es/* atom */.cn)({
    key: "integrations-meeting-state",
    default: {}
});
var locallyRunningIntegrationsState = (0,es/* atom */.cn)({
    key: "locally-running-integrations",
    default: []
});
/**
 * Returns custom integrations and a setter to change them.
 */ var useCustomIntegrations = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var runningLocalIntegrations = (0,es/* useRecoilValue */.sJ)(locallyRunningIntegrationsState);
    var runningSharedIntegrations = (0,es/* useRecoilValue */.sJ)(integrationsMeetingState);
    (0,daily_react_esm/* useDailyEvent */.VU)("meeting-session-state-updated", (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(ev) {
            var ref;
            var state = ev.meetingSessionState;
            var ref1;
            set(integrationsMeetingState, (ref1 = (ref = state.data) === null || ref === void 0 ? void 0 : ref.integrations) !== null && ref1 !== void 0 ? ref1 : {});
        };
    }, []));
    var integrations = (0,es/* useRecoilValue */.sJ)(customIntegrationsState);
    var _integrationsAsArray = Object.entries(integrations).map(function(param) {
        var _param = _slicedToArray(param, 2), id = _param[0], integration = _param[1];
        return _objectSpread({}, integration, {
            id: id
        });
    });
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref2 = _slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "owner",
        "user_id",
        "user_name", 
    ]), 3), isOwner = ref2[0], userId = ref2[1], userName = ref2[2];
    var replacePlaceholders = function() {
        var src = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return src.replaceAll("{{session_id}}", localSessionId).replaceAll("{{user_id}}", userId).replaceAll("{{user_name}}", userName);
    };
    var isSharedWithLocalParticipant = function(integration) {
        if (typeof integration.shared === "boolean") return integration.shared;
        if (integration.shared === "owners") return isOwner;
        if (Array.isArray(integration.shared)) return integration.shared.includes(localSessionId);
        return false;
    };
    var meetingSessionState = useMeetingSessionState();
    var mainIntegrations = _integrationsAsArray.filter(function(integration) {
        return integration.location === "main";
    }).map(function(integration) {
        var ref, ref3, ref4;
        return _objectSpread({}, integration, {
            src: replacePlaceholders(integration.src),
            running: integration.id in runningSharedIntegrations && isSharedWithLocalParticipant(integration) || runningLocalIntegrations.includes(integration.id),
            startedBy: meetingSessionState === null || meetingSessionState === void 0 ? void 0 : (ref = meetingSessionState.data) === null || ref === void 0 ? void 0 : (ref3 = ref.integrations) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[integration.id]) === null || ref4 === void 0 ? void 0 : ref4.startedBy
        });
    });
    var sidebarIntegrations = _integrationsAsArray.filter(function(integration) {
        return integration.location === "sidebar";
    }).map(function(integration) {
        return _objectSpread({}, integration, {
            src: replacePlaceholders(integration.src)
        });
    });
    var runningMainIntegrations = mainIntegrations.filter(function(i) {
        return i.running;
    });
    var setCustomIntegrations = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(newVal) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(newVal)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = _slicedToArray(_step.value, 2), key = _value[0], val = _value[1];
                    if (!val.controlledBy) newVal[key].controlledBy = "*";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            set(customIntegrationsState, newVal);
        };
    }, []);
    var startIntegration = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(id) {
            var integration = mainIntegrations.find(function(m) {
                return m.id === id;
            });
            if (!(integration === null || integration === void 0 ? void 0 : integration.shared)) {
                set(locallyRunningIntegrationsState, function(ids) {
                    return _toConsumableArray(new Set(_toConsumableArray(ids).concat([
                        id
                    ])));
                });
                return;
            }
            var state = daily.meetingSessionState();
            var runningIntegrations = _objectSpread({}, state.data[SESSION_STATE_KEY]);
            runningIntegrations[id] = {
                shared: integration.shared,
                startedBy: localSessionId
            };
            daily.setMeetingSessionData(_defineProperty({}, SESSION_STATE_KEY, runningIntegrations), "shallow-merge");
        };
    }, [
        daily,
        localSessionId,
        mainIntegrations
    ]);
    var stopIntegration = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(id) {
            var state = daily.meetingSessionState();
            var runningIntegrations = _objectSpread({}, state.data[SESSION_STATE_KEY]);
            if (!runningIntegrations[id]) {
                set(locallyRunningIntegrationsState, function(ids) {
                    return _toConsumableArray(ids).filter(function(i) {
                        return i !== id;
                    });
                });
                return;
            }
            delete runningIntegrations[id];
            daily.setMeetingSessionData(_defineProperty({}, SESSION_STATE_KEY, runningIntegrations), "shallow-merge");
        };
    }, [
        daily
    ]);
    var canControlIntegration = (0,react.useCallback)(function(param) {
        var controlledBy = param.controlledBy;
        return controlledBy === "*" || controlledBy === "owners" && isOwner || Array.isArray(controlledBy) && controlledBy.includes(localSessionId);
    }, [
        isOwner,
        localSessionId
    ]);
    return {
        canControlIntegration: canControlIntegration,
        mainIntegrations: mainIntegrations,
        runningMainIntegrations: runningMainIntegrations,
        runningSharedIntegrations: runningSharedIntegrations,
        sidebarIntegrations: sidebarIntegrations,
        setCustomIntegrations: setCustomIntegrations,
        startIntegration: startIntegration,
        stopIntegration: stopIntegration
    };
};


/***/ }),

/***/ 2428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useDebugging; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

var prebuiltDebuggerEnabledState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "prebuilt-debugger-enabled",
    default: false
});
var useDebugging = function() {
    var prebuiltDebuggerEnabled = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(prebuiltDebuggerEnabledState);
    var enablePrebuiltDebugger = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            set(prebuiltDebuggerEnabledState, true);
        };
    });
    var disablePrebuiltDebugger = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            set(prebuiltDebuggerEnabledState, false);
        };
    });
    return {
        prebuiltDebuggerEnabled: prebuiltDebuggerEnabled,
        enablePrebuiltDebugger: enablePrebuiltDebugger,
        disablePrebuiltDebugger: disablePrebuiltDebugger
    };
};


/***/ }),

/***/ 4064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ skinToneMap; },
/* harmony export */   "v": function() { return /* binding */ useEmojiSkinTone; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2034);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var skinToneMap = {
    light: "\uD83C\uDFFB",
    mediumLight: "\uD83C\uDFFC",
    medium: "\uD83C\uDFFD",
    mediumDark: "\uD83C\uDFFE",
    dark: "\uD83C\uDFFF"
};
var COOKIE_KEY = "emoji-skin-tone";
var modifiers = Object.values(skinToneMap);
var selectedSkinToneState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: "selected-skin-tone",
    default: null,
    effects: [
        /**
     * Synchronizes atom state with cookie.
     */ function(param) {
            var onSet = param.onSet, setSelf = param.setSelf, trigger = param.trigger;
            if (trigger === "get") {
                var storedSkinTone = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(COOKIE_KEY);
                if (storedSkinTone) {
                    setSelf(storedSkinTone);
                }
            }
            onSet(function(newSkinTone) {
                if (!newSkinTone) {
                    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(COOKIE_KEY, {
                        sameSite: "none",
                        secure: true
                    });
                } else {
                    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set(COOKIE_KEY, newSkinTone, {
                        sameSite: "none",
                        secure: true
                    });
                }
            });
        }, 
    ]
});
var useEmojiSkinTone = function() {
    var ref = _slicedToArray((0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilState */ .FV)(selectedSkinToneState), 2), currentSkinTone = ref[0], selectSkinTone = ref[1];
    var resetSkinTone = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilCallback */ ._8)(function(param) {
        var reset = param.reset;
        return function() {
            reset(selectedSkinToneState);
        };
    }, []);
    /* Returns the current skin tone in the form of the modifier. */ var getModifier = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(tone) {
        var modifier = skinToneMap[tone];
        return modifier;
    }, []);
    /**
   * Returns a modified version of the passed base emoji.
   * Depends on currently selected skin tone.
   */ var addModifier = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(emoji) {
        /**
       * Not all emoji support modifiers - you can't change the skin tone of 😂, for example. Only emoji with the
       * Emoji_Modifier_Base property set to "Yes" can be modified. For more information about this property,
       * see http://unicode.org/reports/tr51/#Diversity_Implementations and https://stackoverflow.com/a/71912170
       */ var supportsModifier = RegExp("\\p{Emoji_Modifier_Base}", "u").test(emoji);
        // can't support modifiers or no skin tone is set? return original emoji
        if (!supportsModifier || !currentSkinTone) return emoji;
        return "".concat(emoji).concat(skinToneMap[currentSkinTone]);
    }, [
        currentSkinTone
    ]);
    /**
   * Removes the modifier, e.g. turns ✋🏻into ✋.
   */ var removeModifier = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(emoji) {
        for(var i = 0; i < modifiers.length; i++){
            emoji = emoji.replace(modifiers[i], "");
        }
        return emoji;
    }, []);
    return {
        currentSkinTone: currentSkinTone,
        addModifier: addModifier,
        selectSkinTone: selectSkinTone,
        resetSkinTone: resetSkinTone,
        getModifier: getModifier,
        removeModifier: removeModifier
    };
};


/***/ }),

/***/ 3584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ usePreviousValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var usePreviousValue = function(value) {
    var prevValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        prevValue.current = value;
        return function() {
            prevValue.current = undefined;
        };
    });
    return prevValue.current;
};


/***/ }),

/***/ 2275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useScreens; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4283);
/* harmony import */ var _contexts_ParticipantsProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9394);


var useScreens = function() {
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useLocalSessionId */ .q5)();
    var orderedParticipantIds = (0,_contexts_ParticipantsProvider__WEBPACK_IMPORTED_MODULE_1__/* .useOrderedParticipantIds */ .o8)();
    var screens = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useScreenShare */ .N2)().screens;
    return screens.filter(function(screen) {
        return orderedParticipantIds.includes(screen.session_id) || screen.session_id === localSessionId;
    });
};


/***/ }),

/***/ 6803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useStyleVariants; }
/* harmony export */ });
/* harmony import */ var _daily_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _lib_state_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8890);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useStyleVariants = function() {
    var ref = _slicedToArray((0,_lib_state_core__WEBPACK_IMPORTED_MODULE_2__/* .useIsMobile */ .dD)(), 1), isMobile = ref[0];
    var iconVariant = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? 24 : 16;
    }, [
        isMobile
    ]);
    var isPortrait = (0,_daily_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_0__.useMediaQuery)("(orientation: portrait)");
    var mobileLandscape = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile && !isPortrait;
    }, [
        isMobile,
        isPortrait
    ]);
    var mobilePortrait = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile && isPortrait;
    }, [
        isMobile,
        isPortrait
    ]);
    var textVariant = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "large" : "base";
    }, [
        isMobile
    ]);
    var textVariantSmall = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "base" : "small";
    }, [
        isMobile
    ]);
    var textVariantStrong = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "largestrong" : "strong";
    }, [
        isMobile
    ]);
    return {
        isPortrait: isPortrait,
        mobileLandscape: mobileLandscape,
        mobilePortrait: mobilePortrait,
        textVariant: textVariant,
        textVariantSmall: textVariantSmall,
        textVariantStrong: textVariantStrong,
        iconVariant: iconVariant
    };
};


/***/ }),

/***/ 8394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ hasReactedBefore; },
/* harmony export */   "o": function() { return /* binding */ hasReactions; }
/* harmony export */ });
/*
 * Only for advanced chat
 * Whether a participant has given the same type of emoji reaction on
 * the message before.
 */ var hasReactedBefore = function(messageReactions, sessionId) {
    return Object.values(messageReactions).some(function(reaction) {
        return reaction.includes(sessionId);
    });
};
/*
 * Only for advanced chat
 * Whether a message has reactions or not
 */ var hasReactions = function(message) {
    var _reactions;
    return Object.values((_reactions = message.reactions) !== null && _reactions !== void 0 ? _reactions : {}).some(function(o) {
        return Object.values(o).some(function(ids) {
            return ids.length > 0;
        });
    });
};


/***/ }),

/***/ 7530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "eS": function() { return /* binding */ isIOSMobile; },
/* harmony export */   "jI": function() { return /* binding */ isAndroidChrome; }
/* harmony export */ });
/* unused harmony export isFirefox */
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_0__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var isAndroidChrome = function(browserName) {
    var ref, ref1, ref2;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    var name = browserName !== null && browserName !== void 0 ? browserName : browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name;
    return name === "Chrome" && (browser === null || browser === void 0 ? void 0 : (ref1 = browser.platform) === null || ref1 === void 0 ? void 0 : ref1.type) === "mobile" && (browser === null || browser === void 0 ? void 0 : (ref2 = browser.os) === null || ref2 === void 0 ? void 0 : ref2.name) === "Android";
};
var isAndroid = function() {
    var ref, ref3;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    return (browser === null || browser === void 0 ? void 0 : (ref = browser.platform) === null || ref === void 0 ? void 0 : ref.type) === "mobile" && (browser === null || browser === void 0 ? void 0 : (ref3 = browser.os) === null || ref3 === void 0 ? void 0 : ref3.name) === "Android";
};
var isFirefox = function() {
    var ref;
    var browser = Bowser.parse(navigator.userAgent);
    return (browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name) === "Firefox";
};
var isIOSMobile = function() {
    var ref;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    return ((ref = browser.platform) === null || ref === void 0 ? void 0 : ref.vendor) === "Apple" && navigator.maxTouchPoints > 0 && typeof TouchEvent !== "undefined";
};
var isSafari = function() {
    var minVersion = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, maxVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var ref, ref4, ref5, ref6;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    var ref7;
    /**
   * Safari stopped reporting its version when running in a WebView on iOS15 an above.
   * In this case we can fallback to the OS version, since Safari on iOS
   * _usually_ matches the OS version anyway (not necessarily the patch version).
   * This avoids trying to destructure from undefined, which would result in a client exception.
   * See https://github.com/lancedikson/bowser/issues/499
   */ var version = (ref7 = browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.version) !== null && ref7 !== void 0 ? ref7 : browser === null || browser === void 0 ? void 0 : (ref4 = browser.os) === null || ref4 === void 0 ? void 0 : ref4.version;
    var ref8 = _slicedToArray(version === null || version === void 0 ? void 0 : version.split(".").map(function(n) {
        return parseInt(n, 10);
    }), 1), major = ref8[0];
    if (!major) return (browser === null || browser === void 0 ? void 0 : (ref5 = browser.browser) === null || ref5 === void 0 ? void 0 : ref5.name) === "Safari";
    return (browser === null || browser === void 0 ? void 0 : (ref6 = browser.browser) === null || ref6 === void 0 ? void 0 : ref6.name) === "Safari" && major >= minVersion && major <= maxVersion;
};


/***/ }),

/***/ 8038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ DEBUG_GIF_MESSAGES; },
/* harmony export */   "ON": function() { return /* binding */ HAND_RAISED_USER_DATA_KEY; },
/* harmony export */   "X3": function() { return /* binding */ EMOJI_REACTION_ANIMATION_DURATION; },
/* harmony export */   "ZR": function() { return /* binding */ SIDEBAR_WIDTH; },
/* harmony export */   "cR": function() { return /* binding */ BROADCAST_CHAT_MESSAGE; },
/* harmony export */   "oi": function() { return /* binding */ MOBILE_SIDEBAR_WIDTH; },
/* harmony export */   "sF": function() { return /* binding */ SPEAKER_PARTICIPANT_BAR_WIDTH; },
/* harmony export */   "vr": function() { return /* binding */ DEFAULT_ASPECT_RATIO; }
/* harmony export */ });
var EMOJI_REACTION_ANIMATION_DURATION = 3000;
var DEFAULT_ASPECT_RATIO = 16 / 9;
var DEBUG_GIF_MESSAGES = [
    "![lol-giphy|1148827|Happy Very Funny GIF by Disney Zootopia](https://media4.giphy.com/media/3NtY188QaxDdC/200.gif?cid=16ac2f0as5twapv6g8w85bppdh96kcig30i49id6jedy6bpf&rid=200.gif&ct=g)",
    "![hello-giphy|680671|Obi Wan Kenobi Reaction GIF by Star Wars](https://media2.giphy.com/media/3ornk57KwDXf81rjWM/200.gif?cid=16ac2f0arzbiw95dj22h9d5uo5ekz6szheiycwm4cvdqk2j7&rid=200.gif&ct=g)",
    "![party-giphy|3445179|Running Man Party Hard GIF](https://media0.giphy.com/media/10hO3rDNqqg2Xe/200.gif?cid=16ac2f0a3esr666qkyqge9w7gxx7q6rl6cl6p5kml2apuy3j&rid=200.gif&ct=g)",
    "![awesome-giphy|368819|Happy Jonah Hill GIF](https://media4.giphy.com/media/5GoVLqeAOo6PK/200.gif?cid=16ac2f0a205awgz7yyji61esys3z4bqoht62u0gasj5tzs3p&rid=200.gif&ct=g)",
    "![lol-giphy|1621109|Despicable Me Reaction GIF](https://media4.giphy.com/media/ZqlvCTNHpqrio/200.gif?cid=16ac2f0as5twapv6g8w85bppdh96kcig30i49id6jedy6bpf&rid=200.gif&ct=g)",
    "![nice-giphy|809837|Sacha Baron Cohen Thumbs Up GIF by Amazon Prime Video](https://media3.giphy.com/media/Od0QRnzwRBYmDU3eEO/200.gif?cid=16ac2f0aj373026hsya9drhj3uwnc8dt7my7acuza4cqt5s0&rid=200.gif&ct=g)",
    "![happy-giphy|306843|Happy Season 9 GIF by The Office](https://media4.giphy.com/media/o75ajIFH0QnQC3nCeD/200.gif?cid=16ac2f0arb5xr7g03f8h5nn2549spkujnml3pw46z77k3t3l&rid=200.gif&ct=g)",
    "![happy-giphy|168428|Happy Pumped Up GIF by Universal Pictures Home Entertainment](https://media2.giphy.com/media/CAxbo8KC2A0y4/200.gif?cid=16ac2f0arb5xr7g03f8h5nn2549spkujnml3pw46z77k3t3l&rid=200.gif&ct=g)",
    "![party-giphy|2973633|Dance Party Reaction GIF](https://media1.giphy.com/media/blSTtZehjAZ8I/200.gif?cid=16ac2f0akfb419zznaan9mro674gtc2a0kx9h9su5c7lx6wp&rid=200.gif&ct=g)",
    "![haha-giphy|2309385|Cracking Up Lol GIF](https://media4.giphy.com/media/l3E6uhDAN3W7vylji/200.gif?cid=16ac2f0afjn3bc3qcmb7xizdk92rtmti3eso9ocjtfa4oa1i&rid=200.gif&ct=g)",
    "![happy-giphy|145298|Happy Winnie The Pooh GIF](https://media1.giphy.com/media/9Y6n9TR7U07ew/200.gif?cid=16ac2f0axe7uu6lwgxmsijmeu2xz5bmn868dree6ftconndd&rid=200.gif&ct=g)",
    "![welcome-giphy|412154|Bruce Willis Party GIF by IFC](https://media4.giphy.com/media/l0MYGb1LuZ3n7dRnO/200.gif?cid=16ac2f0aoopcwqi8qweimqli67g9b4egw1mw3e9ab661lvfg&rid=200.gif&ct=g)",
    "![welcome-giphy|108159|Bom Dia Reaction GIF](https://media4.giphy.com/media/bcKmIWkUMCjVm/200.gif?cid=16ac2f0aoopcwqi8qweimqli67g9b4egw1mw3e9ab661lvfg&rid=200.gif&ct=g)",
    "![clap-giphy|2813597|GIF by Originals](https://media0.giphy.com/media/26FxCOdhlvEQXbeH6/200.gif?cid=16ac2f0amki0m7sb78dlcmwr4x70wn6amrfwfrw6vckmsjia&rid=200.gif&ct=g)",
    "![terrific-giphy|1973921|Elijah Wood Reaction GIF](https://media1.giphy.com/media/jir4LEGA68A9y/200.gif?cid=16ac2f0atyubc6nkskqt11gqjjm2m3ptzw2udhokurvjnc9k&rid=200.gif&ct=g)", 
];
var HAND_RAISED_USER_DATA_KEY = "hr";
var SIDEBAR_WIDTH = "302";
var MOBILE_SIDEBAR_WIDTH = "300";
var SPEAKER_PARTICIPANT_BAR_WIDTH = 192;
var BROADCAST_CHAT_MESSAGE = "broadcast";


/***/ }),

/***/ 1975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ cloneParticipantAndMungeForIframeProvider; },
/* harmony export */   "$T": function() { return /* binding */ isTrackOff; },
/* harmony export */   "FD": function() { return /* binding */ isParticipantTrackOff; },
/* harmony export */   "_k": function() { return /* binding */ cloneParticipantsAndMungeForIframeProvider; }
/* harmony export */ });
/* harmony import */ var _userData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4218);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// This function massages the participant object to remove the MediaStreamTracks
// and manipulate userData to match the client set userData (which internally
// is nested under CUSTOMER_USER_DATA_KEY ('c') so as not to interfere with prebuilt's
// usage) Note: doesn't actually delete the tracks fields, just marks them undefined,
// for code simplicity.
function cloneParticipantAndMungeForIframeProvider(participant) {
    var participantClone = _objectSpread({}, participant, {
        audioTrack: undefined,
        videoTrack: undefined,
        screenVideoTrack: undefined,
        screenAudioTrack: undefined,
        tracks: {
            audio: _objectSpread({}, participant.tracks.audio, {
                track: undefined,
                persistentTrack: undefined
            }),
            video: _objectSpread({}, participant.tracks.video, {
                track: undefined,
                persistentTrack: undefined
            }),
            screenAudio: _objectSpread({}, participant.tracks.screenAudio, {
                track: undefined,
                persistentTrack: undefined
            }),
            screenVideo: _objectSpread({}, participant.tracks.screenVideo, {
                track: undefined,
                persistentTrack: undefined
            })
        }
    });
    if (participant.userData !== undefined) {
        // The spec says that `userData` is not in the participants object if it is undefined
        if (participant.userData[_userData__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_USER_DATA_KEY */ .Ly] === undefined) {
            delete participantClone.userData;
        } else {
            participantClone.userData = participant.userData[_userData__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_USER_DATA_KEY */ .Ly];
        }
    }
    return participantClone;
}
function cloneParticipantsAndMungeForIframeProvider(participants) {
    var newParticipants = {};
    for(var id in participants){
        newParticipants[id] = cloneParticipantAndMungeForIframeProvider(participants[id]);
    }
    return newParticipants;
}
/**
 * Determines whether a track is considered as off.
 * @param p The participant object to check.
 * @param type The track type. Must match a key of a participant's 'tracks' object.
 * @returns true in case the track is in a 'blocked' or 'off' state.
 */ function isParticipantTrackOff(p, type) {
    var trackState = p === null || p === void 0 ? void 0 : p.tracks[type];
    if (!trackState) return true;
    return trackState.state === "blocked" || trackState.state === "off";
}
function isTrackOff(trackState) {
    return trackState === "blocked" || trackState === "off";
}


/***/ }),

/***/ 5184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
var getQueryParam = function(key, query) {
    return Array.isArray(query === null || query === void 0 ? void 0 : query[key]) ? query[key][0] : query[key];
};


/***/ }),

/***/ 7556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ useShowMobilePageMenu; },
/* harmony export */   "DE": function() { return /* binding */ useShowMobileMoreMenu; },
/* harmony export */   "Sg": function() { return /* binding */ usePinnedId; },
/* harmony export */   "UX": function() { return /* binding */ useMobileTray; },
/* harmony export */   "Ut": function() { return /* binding */ usePreferredViewMode; },
/* harmony export */   "mJ": function() { return /* binding */ useViewMode; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _components_BreakoutRooms_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8610);
/* harmony import */ var _hooks_useCustomIntegrations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5745);
/* harmony import */ var _hooks_useScreens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2275);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8890);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





/**
 * This file contains UI state pertaining to layout. E.g.: are we on a mobile device or not,
 * which view mode is preferred.
 */ var mobileTrayState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "mobile-tray",
    default: true
});
/**
 * Returns whether the mobile tray should be shown and a setter to change it.
 */ var useMobileTray = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(mobileTrayState);
};
var showMobileMoreMenuState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-mobile-more-menu-state",
    default: false
});
/**
 * Returns a flag indicating whether to show the More menu in mobile view.
 */ var useShowMobileMoreMenu = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showMobileMoreMenuState);
};
var showMobilePageMenuState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-mobile-page-menu-state",
    default: false
});
/**
 * Returns a flag indicating whether to show the page menu in mobile view.
 */ var useShowMobilePageMenu = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showMobilePageMenuState);
};
var pinnedIdState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "pinned-id",
    default: null
});
/**
 * Returns the currently pinned session or screen id and a setter to change it.
 */ var usePinnedId = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(pinnedIdState);
};
var preferredViewModeState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "preferred-view-mode",
    default: new Promise(function(resolve) {
        if (false) {}
        var search = new URLSearchParams(window.location.search);
        if (search.get("v") === "grid") {
            resolve("grid");
            return;
        }
        resolve("speaker");
        return;
    })
});
/**
 * Returns the currently preferred view mode and a setter to change it.
 */ var usePreferredViewMode = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(preferredViewModeState);
};
var viewModeSelector = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZ)({
    key: "view-mode",
    get: function(param) {
        var get = param.get;
        var isMobile = get(_core__WEBPACK_IMPORTED_MODULE_4__/* .isMobileState */ .lo);
        if (isMobile) return "mobile";
        var pinnedId = get(pinnedIdState);
        if (pinnedId) return "speaker";
        var preferredViewMode = get(preferredViewModeState);
        return preferredViewMode;
    }
});
/**
 * Returns the current view mode: 'grid', 'speaker' or 'mobile'.
 * In case a participant or screen is pinned or a screen is shared, it will default to 'speaker'.
 */ var useViewMode = function() {
    var screens = (0,_hooks_useScreens__WEBPACK_IMPORTED_MODULE_3__/* .useScreens */ .O)();
    var viewMode = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(viewModeSelector);
    var breakoutStatus = (0,_components_BreakoutRooms_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_1__/* .useBreakoutSessionState */ .V)().breakoutStatus;
    var ref = _slicedToArray(usePinnedId(), 1), pinnedId = ref[0];
    var runningMainIntegrations = (0,_hooks_useCustomIntegrations__WEBPACK_IMPORTED_MODULE_2__/* .useCustomIntegrations */ .J)().runningMainIntegrations;
    if (screens.length + runningMainIntegrations.length > 0 && viewMode !== "mobile" || pinnedId) return "speaker";
    if (breakoutStatus === "ongoing") return "grid";
    return viewMode;
};


/***/ }),

/***/ 4183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fy": function() { return /* binding */ useStartRecordingModal; },
/* harmony export */   "VV": function() { return /* binding */ useLeaveWhileRecordingModal; },
/* harmony export */   "oZ": function() { return /* binding */ useRecordingUI; },
/* harmony export */   "p8": function() { return /* binding */ useRecordingErrorModal; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

var recordingUIState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "recording-ui",
    default: null
});
/**
 * Holds additional recording UI states for countdown.
 */ var useRecordingUI = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(recordingUIState);
};
var leaveWhileRecordingModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "leave-while-recording-modal-state",
    default: false
});
/**
 * Used to control visibility of LeaveWhileRecordingModal.
 */ var useLeaveWhileRecordingModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(leaveWhileRecordingModalState);
};
var recordingErrorModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "recording-error-modal-state",
    default: false
});
/**
 * Used to control visibility of RecordingErrorModal.
 */ var useRecordingErrorModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(recordingErrorModalState);
};
var startRecordingModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "start-recording-modal-state",
    default: false
});
/**
 * Used to control visibility of StartRecordingModal.
 */ var useStartRecordingModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(startRecordingModalState);
};


/***/ }),

/***/ 4218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ly": function() { return /* binding */ CUSTOMER_USER_DATA_KEY; },
/* harmony export */   "T3": function() { return /* binding */ setPrebuiltUserData; },
/* harmony export */   "Ui": function() { return /* binding */ PREBUILT_USER_DATA_KEY; },
/* harmony export */   "n1": function() { return /* binding */ getPrebuiltUserData; }
/* harmony export */ });
/* unused harmony export getIframeUserData */
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// This file includes helper functions for working with userData
// and ensuring that prebuilt usage doesn't stomp or get confused
// with iframe usage. Instead of using daily-js setUserData or
// accessing userData directly from the participant blobs, prebuilt
// should use `setPrebuiltUserData` and `getPrebuiltUserData` defined
// below
var CUSTOMER_USER_DATA_KEY = "c";
var PREBUILT_USER_DATA_KEY = "p";
var setPrebuiltUserData = function() {
    var _ref = _asyncToGenerator(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(daily, data) {
        var iframeUserData, newData;
        return _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    iframeUserData = getIframeUserData(daily);
                    if (!(iframeUserData === undefined && data === undefined)) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 4;
                    return daily.setUserData(data);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                    newData = _defineProperty({}, PREBUILT_USER_DATA_KEY, data);
                    if (iframeUserData !== undefined) {
                        newData[CUSTOMER_USER_DATA_KEY] = iframeUserData;
                    }
                    _ctx.next = 9;
                    return daily.setUserData(newData);
                case 9:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function setPrebuiltUserData(daily, data) {
        return _ref.apply(this, arguments);
    };
}();
var getPrebuiltUserData = function(daily) {
    var participantId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "local";
    var ref;
    if (typeof ((ref = daily.participants()[participantId]) === null || ref === void 0 ? void 0 : ref.userData) !== "object") {
        var ref1;
        // in prebuilt, userData should always be either an object of
        // the form { i?: <something>, p?: <something } or undefined
        // if it is anything else, it means that prebuilt has called
        // daily-js.setUserData directly without the setPrebuiltUserData
        // helper above. let's detect this to help prevent that mistake.
        if (((ref1 = daily.participants()[participantId]) === null || ref1 === void 0 ? void 0 : ref1.userData) !== undefined) {
            console.warn("Unsafe use of setUserData detected in prebuilt.");
        }
        return undefined;
    }
    var userData = daily.participants()[participantId].userData;
    return _objectSpread({}, userData[PREBUILT_USER_DATA_KEY]);
};
var getIframeUserData = function(daily) {
    var participantId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "local";
    var ref;
    if (typeof ((ref = daily.participants()[participantId]) === null || ref === void 0 ? void 0 : ref.userData) !== "object") {
        var ref2;
        // unlike in prebuilt code, for customer use of useData, we
        // actually shim the call and can guarantee that the data the
        // sent is either nested in an object or undefined, nonetheless
        // let's warn prebuilt if it's done something to muck with it
        // like we do in getPrebuiltUserData :)
        if (((ref2 = daily.participants()[participantId]) === null || ref2 === void 0 ? void 0 : ref2.userData) !== undefined) {
            console.warn("Unsafe use of setUserData detected in prebuilt.");
        }
        return undefined;
    }
    var userData = daily.participants()[participantId].userData;
    return userData[CUSTOMER_USER_DATA_KEY];
};


/***/ }),

/***/ 1157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CallUI; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ../shared/dist/contexts/Snackbar/index.js
var Snackbar = __webpack_require__(4017);
// EXTERNAL MODULE: ../shared/dist/lib/safeStorage.js
var safeStorage = __webpack_require__(9930);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../shared/dist/components/Button/index.js
var Button = __webpack_require__(9757);
// EXTERNAL MODULE: ../shared/dist/components/Icons/CamIcon.js
var CamIcon = __webpack_require__(9430);
// EXTERNAL MODULE: ../shared/dist/components/Icons/CloseIcon.js
var CloseIcon = __webpack_require__(7880);
// EXTERNAL MODULE: ../shared/dist/components/Icons/MicrophoneIcon.js
var MicrophoneIcon = __webpack_require__(7711);
// EXTERNAL MODULE: ../shared/dist/components/Text/index.js
var Text = __webpack_require__(5645);
// EXTERNAL MODULE: ../shared/dist/contexts/Theme/index.js
var Theme = __webpack_require__(1609);
// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(7160);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
// EXTERNAL MODULE: ./contexts/CallProvider.tsx + 1 modules
var CallProvider = __webpack_require__(6797);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
;// CONCATENATED MODULE: ./hooks/useSound.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var defaultNotMuted = function() {
    return false;
};
var useSound = function(src) {
    var isMuted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultNotMuted;
    var audio = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var tag = document.querySelector('audio[src="'.concat(src, '"]'));
        if (tag) {
            audio.current = tag;
        } else {
            var t = document.createElement("audio");
            t.src = src;
            t.setAttribute("playsinline", "");
            document.body.appendChild(t);
            audio.current = t;
        }
    }, [
        src
    ]);
    var load = (0,react.useCallback)(function() {
        if (!audio.current) return;
        audio.current.load();
    }, [
        audio
    ]);
    var play = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!audio.current || isMuted())) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.prev = 2;
                    audio.current.currentTime = 0;
                    _ctx.next = 6;
                    return audio.current.play();
                case 6:
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](2);
                    console.error(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    })), [
        audio,
        isMuted
    ]);
    return {
        load: load,
        play: play
    };
};

;// CONCATENATED MODULE: ./hooks/useSoundLoader.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var useSoundLoader = function() {
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var ref = _slicedToArray((0,custom/* useEnableJoinSound */.Xn)(), 1), enableJoinSound = ref[0];
    var isJoinSoundMuted = (0,react.useCallback)(function() {
        return !enableJoinSound;
    }, [
        enableJoinSound
    ]);
    var errorSound = useSound("".concat(assetPrefix, "/error.mp3"));
    var knockSound = useSound("".concat(assetPrefix, "/knock.mp3"));
    var joinSound = useSound("".concat(assetPrefix, "/join.mp3"), isJoinSoundMuted);
    var load = (0,react.useCallback)(function() {
        errorSound.load();
        knockSound.load();
        joinSound.load();
    }, [
        errorSound,
        knockSound,
        joinSound
    ]);
    return (0,react.useMemo)(function() {
        return {
            errorSound: errorSound,
            knockSound: knockSound,
            joinSound: joinSound,
            load: load
        };
    }, [
        errorSound,
        knockSound,
        joinSound,
        load
    ]);
};

;// CONCATENATED MODULE: ./contexts/WaitingRoomProvider.tsx




var WaitingRoomContext = /*#__PURE__*/ (0,react.createContext)(null);
var WaitingRoomProvider = function(param) {
    var children = param.children;
    var knockSound = useSoundLoader().knockSound;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var handleWaitingParticipantAdded = (0,react.useCallback)(function(ev) {
        var waiting = Object.entries(daily.waitingParticipants());
        /**
         * Only play knocking sound for first participant in waiting queue.
         */ if (ev.action === "waiting-participant-added" && waiting.length === 1) {
            knockSound.play();
        }
    }, [
        daily,
        knockSound
    ]);
    var waitingParticipants = (0,daily_react_esm/* useWaitingParticipants */.zy)({
        onWaitingParticipantAdded: handleWaitingParticipantAdded
    }).waitingParticipants;
    (0,react.useEffect)(function() {
        if (waitingParticipants.length === 0) {
            setShowModal(false);
        }
    }, [
        waitingParticipants
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomContext.Provider, {
        value: {
            setShowModal: setShowModal,
            showModal: showModal
        },
        children: children
    });
};
var useWaitingRoom = function() {
    return (0,react.useContext)(WaitingRoomContext);
};

// EXTERNAL MODULE: ./node_modules/@daily-co/daily-js/dist/daily-iframe-esm.js
var daily_iframe_esm = __webpack_require__(4061);
// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(9378);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ../../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(2034);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./hooks/useCallConfig.ts
var useCallConfig = __webpack_require__(6081);
;// CONCATENATED MODULE: ./hooks/useAudioProcessor.ts







var audioProcessors = [
    "none",
    "noise-cancellation"
];
var COOKIE_KEY = "audio-processor";
var selectedAudioProcessorState = (0,es/* atom */.cn)({
    key: "selected-audio-processor",
    default: "none",
    effects: [
        /**
     * Synchronizes atom state with cookie.
     */ function(param) {
            var onSet = param.onSet, setSelf = param.setSelf, trigger = param.trigger;
            // not all browsers support audio processing, e.g. Safari. in that case, there's
            // no reason to look at cookies.
            if (!daily_iframe_esm/* default.supportedBrowser */.ZP.supportedBrowser().supportsAudioProcessing) return;
            if (trigger === "get") {
                var storedAudioProcessor = js_cookie_default().get(COOKIE_KEY);
                if (audioProcessors.includes(storedAudioProcessor)) {
                    setSelf(storedAudioProcessor);
                }
            }
            onSet(function(newAudioProcessor) {
                if (newAudioProcessor === "none") {
                    js_cookie_default().remove(COOKIE_KEY, {
                        sameSite: "none",
                        secure: true
                    });
                } else {
                    js_cookie_default().set(COOKIE_KEY, newAudioProcessor, {
                        sameSite: "none",
                        secure: true
                    });
                }
            });
        }, 
    ]
});
var noiseCancellationOnState = (0,es/* selector */.nZ)({
    key: "noise-cancellation-on",
    get: function(param) {
        var get = param.get;
        var selectedAudioProcessor = get(selectedAudioProcessorState);
        return selectedAudioProcessor === "noise-cancellation";
    }
});
var noiseCancellationDisabledState = (0,es/* atom */.cn)({
    key: "noise-cancellation-disabled",
    default: false
});
var useAudioProcessor = function() {
    var enableNoiseCancellationUI = (0,useCallConfig/* useCallConfig */.A)().enableNoiseCancellationUI;
    var waitForUpdate = (0,react.useRef)(false);
    var noiseCancellationOn = (0,es/* useRecoilValue */.sJ)(noiseCancellationOnState);
    var noiseCancellationDisabled = (0,es/* useRecoilValue */.sJ)(noiseCancellationDisabledState);
    var currentAudioProcessor = (0,es/* useRecoilValue */.sJ)(selectedAudioProcessorState);
    /* Update the atom state when the input settings change */ var ref4 = (0,daily_react_esm/* useInputSettings */.Nl)({
        onInputSettingsUpdated: (0,es/* useRecoilCallback */._8)(function(param) {
            var set = param.set;
            return function(event) {
                var ref, ref1, ref2, ref3;
                if (!((ref = event.inputSettings) === null || ref === void 0 ? void 0 : ref.audio)) return;
                var type = (ref1 = event.inputSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.audio) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.processor) === null || ref3 === void 0 ? void 0 : ref3.type;
                switch(type){
                    case "noise-cancellation":
                        set(selectedAudioProcessorState, "noise-cancellation");
                        break;
                    case "none":
                        set(selectedAudioProcessorState, "none");
                        break;
                }
                if (waitForUpdate.current) {
                    waitForUpdate.current = false;
                    set(noiseCancellationDisabledState, false);
                }
            };
        }, [])
    }), inputSettings = ref4.inputSettings, updateInputSettings = ref4.updateInputSettings;
    /* Update the input settings */ var setAudioProcessor = (0,react.useCallback)(function(audioProcessor) {
        if (!enableNoiseCancellationUI) return;
        try {
            var settings = {
                audio: {
                    processor: {
                        type: audioProcessor
                    }
                }
            };
            // old and new settings the same, so return
            if (fast_deep_equal_default()(inputSettings === null || inputSettings === void 0 ? void 0 : inputSettings.audio, settings === null || settings === void 0 ? void 0 : settings.audio)) {
                return;
            }
            //  the current input settings is an empty object, and the new input settings
            //  do not actually change anything, so no-op
            if (fast_deep_equal_default()(inputSettings, {}) && audioProcessor === "none") {
                return;
            }
            updateInputSettings(settings);
        } catch (e) {}
    }, [
        enableNoiseCancellationUI,
        inputSettings,
        updateInputSettings
    ]);
    var handleNoiseCancellationChange = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(isOn) {
            set(noiseCancellationDisabledState, true);
            waitForUpdate.current = true;
            setAudioProcessor(isOn ? "noise-cancellation" : "none");
        };
    }, [
        setAudioProcessor
    ]);
    return {
        noiseCancellationOn: noiseCancellationOn,
        noiseCancellationDisabled: noiseCancellationDisabled,
        handleNoiseCancellationChange: handleNoiseCancellationChange,
        currentAudioProcessor: currentAudioProcessor,
        setAudioProcessor: setAudioProcessor
    };
};

;// CONCATENATED MODULE: ./hooks/useBackgroundEffect.ts
function useBackgroundEffect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useBackgroundEffect_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useBackgroundEffect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useBackgroundEffect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var sortedEffects = [
    "none",
    "soft-blur",
    "strong-blur",
    "vb-coffeeshop",
    "vb-forest",
    "vb-hills",
    "vb-library",
    "vb-lounge",
    "vb-ocean",
    "vb-office",
    "vb-palms",
    "vb-rollercoaster", 
];
var useBackgroundEffect_COOKIE_KEY = "bg-effect";
var selectedBackgroundEffectState = (0,es/* atom */.cn)({
    key: "selected-background-effect",
    default: "none",
    effects: [
        /**
     * Synchronizes atom state with cookie.
     */ function(param) {
            var onSet = param.onSet, setSelf = param.setSelf, trigger = param.trigger;
            if (trigger === "get") {
                var storedBgEffect = js_cookie_default().get(useBackgroundEffect_COOKIE_KEY);
                if (sortedEffects.includes(storedBgEffect)) {
                    setSelf(storedBgEffect);
                }
            }
            onSet(function(newEffect) {
                if (newEffect === "none") {
                    js_cookie_default().remove(useBackgroundEffect_COOKIE_KEY, {
                        sameSite: "none",
                        secure: true
                    });
                } else {
                    js_cookie_default().set(useBackgroundEffect_COOKIE_KEY, newEffect, {
                        sameSite: "none",
                        secure: true
                    });
                }
            });
        }, 
    ]
});
var useBackgroundEffect = function() {
    var enableVideoProcessingUI = (0,useCallConfig/* useCallConfig */.A)().enableVideoProcessingUI;
    var currentEffect = (0,es/* useRecoilValue */.sJ)(selectedBackgroundEffectState);
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref3 = (0,daily_react_esm/* useInputSettings */.Nl)({
        onInputSettingsUpdated: (0,es/* useRecoilCallback */._8)(function(param) {
            var set = param.set;
            return function(ev) {
                var ref, ref1;
                if (!enableVideoProcessingUI) return;
                var newEffect = "none";
                var _inputSettings;
                var video = ((_inputSettings = ev.inputSettings) !== null && _inputSettings !== void 0 ? _inputSettings : {}).video;
                if ((video === null || video === void 0 ? void 0 : (ref = video.processor) === null || ref === void 0 ? void 0 : ref.type) === "background-blur") {
                    var config = video.processor.config;
                    var ref2;
                    var level = (ref2 = config === null || config === void 0 ? void 0 : config.strength) !== null && ref2 !== void 0 ? ref2 : 0;
                    if (level === 0) {
                        newEffect = "none";
                    } else if (level < 0.5) {
                        newEffect = "soft-blur";
                    } else {
                        newEffect = "strong-blur";
                    }
                    set(selectedBackgroundEffectState, newEffect);
                } else if ((video === null || video === void 0 ? void 0 : (ref1 = video.processor) === null || ref1 === void 0 ? void 0 : ref1.type) === "background-image") {
                    var config1 = video.processor.config;
                    if (config1.source) {
                        var url = new URL(config1.source);
                        var match = url.pathname.match(new RegExp(sortedEffects.filter(function(fx) {
                            return fx.startsWith("vb-");
                        }).join("|")));
                        if (match) {
                            newEffect = match[0];
                            set(selectedBackgroundEffectState, newEffect);
                        }
                    }
                } else {
                    set(selectedBackgroundEffectState, "none");
                }
            };
        }, [
            enableVideoProcessingUI
        ])
    }), inputSettings1 = ref3.inputSettings, updateInputSettings = ref3.updateInputSettings;
    var selectEffect = (0,react.useCallback)(function(effect) {
        try {
            var type = "none";
            var blurLevel = 0;
            if (effect.endsWith("-blur")) {
                type = "background-blur";
                switch(effect){
                    case "strong-blur":
                        blurLevel = 1;
                        break;
                    case "soft-blur":
                        blurLevel = 0.2;
                        break;
                }
            } else if (effect.startsWith("vb-")) {
                type = "background-image";
            }
            var settings = null;
            switch(type){
                case "none":
                    settings = {
                        video: {
                            processor: {
                                type: type
                            }
                        }
                    };
                    break;
                case "background-blur":
                    settings = {
                        video: {
                            processor: {
                                type: type,
                                config: {
                                    strength: blurLevel
                                }
                            }
                        }
                    };
                    break;
                case "background-image":
                    var _location = window.location, hostname = _location.hostname, port = _location.port, protocol = _location.protocol;
                    // Check if assetPrefix already contains FQDN
                    var prefix = assetPrefix.match(/^https?\:\/\//) ? assetPrefix : "".concat(protocol, "//").concat(hostname, ":").concat(port).concat(assetPrefix);
                    settings = {
                        video: {
                            processor: {
                                type: type,
                                config: {
                                    source: "".concat(prefix, "/backgrounds/").concat(effect, ".jpg")
                                }
                            }
                        }
                    };
                    break;
            }
            if (fast_deep_equal_default()(inputSettings1, settings) || fast_deep_equal_default()(inputSettings1, {}) && effect === "none") return;
            updateInputSettings(settings);
        } catch (e) {}
    }, [
        assetPrefix,
        inputSettings1,
        updateInputSettings
    ]);
    (0,daily_react_esm/* useDailyEvent */.VU)("started-camera", (0,react.useCallback)(useBackgroundEffect_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, inputSettings;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(!enableVideoProcessingUI || !daily)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return daily.getInputSettings();
                case 5:
                    inputSettings = _ctx.sent;
                    // Apply prebuilt bg-effect cookie if and only if no input settings are
                    // currently applied in daily-js. This is to prevent overriding settings
                    // provided in join(), createFrame(), createCallObject() or by calling
                    // updateInputSettings() directly. Without any such settings applied, the
                    // inputSettings object will be empty {}.
                    if (currentEffect && !(inputSettings === null || inputSettings === void 0 ? void 0 : (ref = inputSettings.video) === null || ref === void 0 ? void 0 : ref.processor)) {
                        selectEffect(currentEffect);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        currentEffect,
        daily,
        enableVideoProcessingUI,
        selectEffect
    ]));
    return {
        currentEffect: currentEffect,
        effects: sortedEffects,
        selectEffect: selectEffect
    };
};

// EXTERNAL MODULE: ./hooks/useDebugging.ts
var useDebugging = __webpack_require__(2428);
// EXTERNAL MODULE: ./lib/browserConfig.ts
var browserConfig = __webpack_require__(7530);
// EXTERNAL MODULE: ./lib/state/core.ts
var core = __webpack_require__(8890);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(9547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../shared/dist/components/Snackbar/index.js
var components_Snackbar = __webpack_require__(4063);
// EXTERNAL MODULE: ../shared/dist/components/Icons/BreakoutIcon.js
var BreakoutIcon = __webpack_require__(9244);
// EXTERNAL MODULE: ../shared/dist/components/Icons/RecordIcon.js
var RecordIcon = __webpack_require__(1135);
// EXTERNAL MODULE: ./components/BreakoutRooms/helpers/constants.ts
var constants = __webpack_require__(5436);
// EXTERNAL MODULE: ./components/BreakoutRooms/hooks/useBreakoutSessionState.tsx + 2 modules
var useBreakoutSessionState = __webpack_require__(8610);
// EXTERNAL MODULE: ./contexts/ParticipantsProvider.tsx
var ParticipantsProvider = __webpack_require__(9394);
// EXTERNAL MODULE: ./lib/constants.ts
var lib_constants = __webpack_require__(8038);
// EXTERNAL MODULE: ./lib/userData.ts
var lib_userData = __webpack_require__(4218);
;// CONCATENATED MODULE: ./hooks/useHandRaising.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var useHasHandRaised = function(id) {
    var ref;
    var userData = (0,daily_react_esm/* useParticipantProperty */.ou)(id, "userData");
    var ref1;
    return (ref1 = userData === null || userData === void 0 ? void 0 : (ref = userData[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref === void 0 ? void 0 : ref[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON]) !== null && ref1 !== void 0 ? ref1 : false;
};
var useHandRaisedQueue = function(id) {
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var idsWithRaisedHands = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            var ref, ref2;
            // if we're in a breakout session, only get the participant IDs that are in the same breakout room
            return (orderedParticipantIds.includes(p.session_id) || p.local) && ((ref = p.userData) === null || ref === void 0 ? void 0 : (ref2 = ref[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref2 === void 0 ? void 0 : ref2[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON]);
        }, [
            orderedParticipantIds
        ]),
        /* Sort hand raisers by date ascending */ sort: (0,react.useCallback)(function(a, b) {
            var ref, ref3, ref4, ref5;
            var aDate = (ref = a.userData) === null || ref === void 0 ? void 0 : (ref3 = ref[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref3 === void 0 ? void 0 : ref3[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
            var bDate = (ref4 = b.userData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref5 === void 0 ? void 0 : ref5[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
            if (aDate < bDate) return -1;
            if (aDate > bDate) return 1;
            return 0;
        }, [])
    });
    if (idsWithRaisedHands.includes(id)) return idsWithRaisedHands.indexOf(id) + 1;
    return undefined;
};
/* A participant can't set another participant's user data. We have to send them a request using
 * sendAppMessage. Sending an app message isn't a global, "app-wide" event - if you send an app message
 * from a hook that's only loaded when a certain component is rendered (which is the case here with ParticipantMenu),
 * participants will never receive a request to update their userdata unless they have that specific menu open.
 * This is why we need to make the forceLowerHand method available on ParticipantsProvider: we need to ensure that
 * app messages are received no matter the intended receiver's app state.
 * */ var useForceLowerHand = function() {
    var sendAppMessage = (0,daily_react_esm/* useAppMessage */.F3)();
    var forceLowerHand = (0,react.useCallback)(function(sessionId) {
        var isAutoLowered = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        sendAppMessage({
            event: "force-lower-hand",
            isAutoLowered: isAutoLowered
        }, sessionId);
    }, [
        sendAppMessage
    ]);
    return {
        forceLowerHand: forceLowerHand
    };
};
var useHandRaising = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var handRaisedParticipants = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            var ref, ref6;
            return (orderedParticipantIds.includes(p.session_id) || p.local) && ((ref = p.userData) === null || ref === void 0 ? void 0 : (ref6 = ref[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref6 === void 0 ? void 0 : ref6[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON]);
        }, [
            orderedParticipantIds
        ])
    });
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var raiseHand = (0,react.useCallback)(function() {
        if (!localSessionId) return;
        var prevUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
        (0,lib_userData/* setPrebuiltUserData */.T3)(daily, _objectSpread({}, prevUserData, _defineProperty({}, lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON, new Date().toISOString())));
    }, [
        daily,
        localSessionId
    ]);
    var lowerHand = (0,react.useCallback)(function() {
        if (!localSessionId) return;
        var prevUserData = _objectSpread({}, (0,lib_userData/* getPrebuiltUserData */.n1)(daily));
        delete prevUserData[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
        (0,lib_userData/* setPrebuiltUserData */.T3)(daily, _objectSpread({}, prevUserData));
    }, [
        daily,
        localSessionId
    ]);
    return {
        raiseHand: raiseHand,
        lowerHand: lowerHand,
        handRaisedParticipants: handRaisedParticipants
    };
};

// EXTERNAL MODULE: ./hooks/usePreviousValue.ts
var usePreviousValue = __webpack_require__(3584);
// EXTERNAL MODULE: ./lib/participants.ts
var lib_participants = __webpack_require__(1975);
;// CONCATENATED MODULE: ./lib/state/breakouts.ts

var breakoutViewState = (0,es/* atom */.cn)({
    key: "breakout-view",
    default: "start"
});
/**
 * Used to control visibility and tabs for breakout views in the sidebar.
 */ var useBreakoutView = function() {
    return (0,es/* useRecoilState */.FV)(breakoutViewState);
};
var joinBreakoutModalState = (0,es/* atom */.cn)({
    key: "join-breakout-modal-state",
    default: false
});
/**
 * Used to control visibility of JoinBreakoutModal.
 */ var useJoinBreakoutModal = function() {
    return (0,es/* useRecoilState */.FV)(joinBreakoutModalState);
};

// EXTERNAL MODULE: ./lib/state/layout.ts
var layout = __webpack_require__(7556);
;// CONCATENATED MODULE: ./contexts/BreakoutsProvider.tsx
function BreakoutsProvider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutsProvider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return BreakoutsProvider_arrayLikeToArray(arr);
}
function BreakoutsProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BreakoutsProvider_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BreakoutsProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BreakoutsProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BreakoutsProvider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function BreakoutsProvider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutsProvider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutsProvider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BreakoutsProvider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BreakoutsProvider_slicedToArray(arr, i) {
    return BreakoutsProvider_arrayWithHoles(arr) || BreakoutsProvider_iterableToArrayLimit(arr, i) || BreakoutsProvider_unsupportedIterableToArray(arr, i) || BreakoutsProvider_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || BreakoutsProvider_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function BreakoutsProvider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutsProvider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutsProvider_arrayLikeToArray(o, minLen);
}





















var MEETING_DATA_BREAKOUTS_KEY = "br";
var noOpWarn = function() {
    console.warn("This call is not configured to use breakout rooms.");
};
var noOpWarnPromise = function() {
    return new Promise(function(resolve) {
        noOpWarn();
        resolve();
    });
};
var BreakoutsContext = /*#__PURE__*/ (0,react.createContext)({
    abortEndingBreakouts: noOpWarn,
    setBreakoutHost: noOpWarn,
    endBreakouts: noOpWarnPromise,
    joinBreakout: noOpWarn,
    declineBreakout: noOpWarn,
    leaveBreakout: noOpWarn,
    moveParticipants: noOpWarn,
    setupBreakouts: noOpWarnPromise
});
var breakoutJoiningState = (0,es/* atom */.cn)({
    key: "breakout-joining",
    default: false,
    effects: [
        function(param) {
            var onSet = param.onSet, resetSelf = param.resetSelf;
            onSet(function(newVal) {
                if (newVal) {
                    setTimeout(resetSelf, 2000);
                }
            });
        }, 
    ]
});
var useRenderBreakoutsInterstitialScreen = function() {
    return (0,es/* useRecoilValue */.sJ)(breakoutJoiningState);
};
var BreakoutsProvider = function(param1) {
    var children = param1.children;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var enableBreakoutRooms = (0,useCallConfig/* useCallConfig */.A)().enableBreakoutRooms;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref6 = BreakoutsProvider_slicedToArray(useJoinBreakoutModal(), 2), setJoinBreakoutModal = ref6[1];
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var state = (0,CallProvider/* useCallState */.oz)().state;
    var hasHandRaised = useHasHandRaised(localSessionId);
    var forceLowerHand = useForceLowerHand().forceLowerHand;
    var ref1 = (0,daily_react_esm/* useScreenShare */.N2)(), isSharingScreen = ref1.isSharingScreen, stopScreenShare = ref1.stopScreenShare;
    var ref2 = BreakoutsProvider_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), setPinnedId = ref2[1];
    /**
   * Cleans up the local participant's state:
   * - Hand is lowered
   * - Mic is muted
   * - Screen share is stopped
   * - Pinned id is reset
   */ var handleRoomSwitch = (0,react.useCallback)(function() {
        var ref;
        // When a user joins a session, the context changes, so reset hand raise.
        hasHandRaised && forceLowerHand(localSessionId, true);
        // When the context for a user changes (e.g. different breakout room, or the session ends), we'll mute them
        var isMicOn = !(0,lib_participants/* isParticipantTrackOff */.FD)((ref = daily === null || daily === void 0 ? void 0 : daily.participants()) === null || ref === void 0 ? void 0 : ref.local, "audio");
        if (isMicOn) {
            daily.setLocalAudio(false);
            addMessage({
                content: t("notification.micMutedAutomatically"),
                type: "info",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                    muted: true,
                    size: 16
                })
            });
        }
        // User is transitioning between rooms, so stop screen sharing.
        isSharingScreen && stopScreenShare();
        // Reset pinned participant
        setPinnedId("");
    }, [
        addMessage,
        daily,
        forceLowerHand,
        hasHandRaised,
        isSharingScreen,
        localSessionId,
        setPinnedId,
        stopScreenShare,
        t, 
    ]);
    var ref3 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)({
        onMeetingSessionStateUpdated: (0,es/* useRecoilCallback */._8)(function(param2) {
            var set = param2.set;
            return function() {
                var _ref = BreakoutsProvider_asyncToGenerator(runtime_default().mark(function _callee(ev) {
                    var ref, userData, meetingData, breakouts, ref7, assigned, ref8, ref9, autojoin, ref10, newUserData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                userData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
                                meetingData = ev.meetingSessionState.data;
                                breakouts = meetingData === null || meetingData === void 0 ? void 0 : meetingData[MEETING_DATA_BREAKOUTS_KEY];
                                ;
                                assigned = Object.entries((ref7 = breakouts === null || breakouts === void 0 ? void 0 : breakouts.mapping) !== null && ref7 !== void 0 ? ref7 : {}).find(function(param) {
                                    var _param = BreakoutsProvider_slicedToArray(param, 2), room = _param[1];
                                    return room.users.includes(localSessionId);
                                });
                                if (!((breakouts === null || breakouts === void 0 ? void 0 : breakouts.status) === "ended")) {
                                    _ctx.next = 10;
                                    break;
                                }
                                {
                                    // Breakout session ended by host or countdown
                                    if (typeof userData === "object" && "br" in userData) {
                                        handleRoomSwitch();
                                        delete userData.br;
                                    }
                                    (0,lib_userData/* setPrebuiltUserData */.T3)(daily, BreakoutsProvider_objectSpread({}, userData));
                                    setJoinBreakoutModal(false);
                                }
                                _ctx.next = 18;
                                break;
                            case 10:
                                if (!((assigned === null || assigned === void 0 ? void 0 : assigned[0]) !== (userData === null || userData === void 0 ? void 0 : (ref = userData.br) === null || ref === void 0 ? void 0 : ref.currentRoomId))) {
                                    _ctx.next = 18;
                                    break;
                                }
                                ;
                                autojoin = Boolean(breakouts === null || breakouts === void 0 ? void 0 : (ref8 = breakouts.config) === null || ref8 === void 0 ? void 0 : ref8.autojoin) || (breakouts === null || breakouts === void 0 ? void 0 : breakouts.host) === localSessionId;
                                ;
                                newUserData = BreakoutsProvider_objectSpread({}, userData, {
                                    br: BreakoutsProvider_objectSpread({}, (ref10 = userData === null || userData === void 0 ? void 0 : userData.br) !== null && ref10 !== void 0 ? ref10 : {}, {
                                        currentRoomId: autojoin ? assigned === null || assigned === void 0 ? void 0 : assigned[0] : userData === null || userData === void 0 ? void 0 : (ref9 = userData.br) === null || ref9 === void 0 ? void 0 : ref9.currentRoomId,
                                        status: autojoin ? "joined" : "invited"
                                    })
                                });
                                _ctx.next = 17;
                                return (0,lib_userData/* setPrebuiltUserData */.T3)(daily, newUserData);
                            case 17:
                                if (!autojoin) {
                                    setJoinBreakoutModal(true);
                                } else {
                                    handleRoomSwitch();
                                    set(breakoutJoiningState, true);
                                }
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(ev) {
                    return _ref.apply(this, arguments);
                };
            }();
        }, [
            daily,
            handleRoomSwitch,
            localSessionId,
            setJoinBreakoutModal
        ])
    }), breakoutHost = ref3.breakoutHost, breakoutParticipantIds = ref3.breakoutParticipantIds, breakoutStatus = ref3.breakoutStatus, invitedBreakoutRoom = ref3.invitedBreakoutRoom;
    var setBreakoutHost = (0,react.useCallback)(function() {
        var idOfHost = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : localSessionId;
        var data = daily.meetingSessionState().data;
        daily.setMeetingSessionData({
            br: BreakoutsProvider_objectSpread({}, data[MEETING_DATA_BREAKOUTS_KEY], {
                host: idOfHost
            })
        }, "shallow-merge");
    }, [
        daily,
        localSessionId
    ]);
    var host = (0,daily_react_esm/* useParticipant */.aV)(breakoutHost);
    var otherOwnerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            return p.owner && p.session_id !== breakoutHost;
        }, [
            breakoutHost
        ]),
        sort: "joined_at"
    });
    /**
   * In case breakout host leaves the call, auto-assign breakout host to first remaining host.
   */ (0,daily_react_esm/* useDailyEvent */.VU)("participant-left", (0,react.useCallback)(function(ev) {
        if (!breakoutHost || ev.participant.session_id !== breakoutHost || (otherOwnerIds === null || otherOwnerIds === void 0 ? void 0 : otherOwnerIds[0]) !== localSessionId) return;
        if (ev.participant.session_id === breakoutHost && (otherOwnerIds === null || otherOwnerIds === void 0 ? void 0 : otherOwnerIds[0]) === localSessionId) {
            setBreakoutHost();
        }
    }, [
        breakoutHost,
        localSessionId,
        otherOwnerIds,
        setBreakoutHost
    ]));
    /**
   * When joining as a host and last breakout host doesn't exist,
   * assign breakout host role.
   */ (0,react.useEffect)(function assignNewBreakoutHost() {
        if (state !== "joined" || breakoutStatus !== "ongoing") return;
        var timeout = setTimeout(function() {
            if (host) return;
            if ((otherOwnerIds === null || otherOwnerIds === void 0 ? void 0 : otherOwnerIds[0]) === localSessionId) {
                setBreakoutHost();
            }
        }, 3000);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        breakoutStatus,
        host,
        localSessionId,
        otherOwnerIds,
        setBreakoutHost,
        state, 
    ]);
    /**
   * When local participant became new breakout host,
   * display a snackbar message.
   */ var prevBreakoutHost = (0,usePreviousValue/* usePreviousValue */.z)(breakoutHost);
    (0,react.useEffect)(function notifyNewBreakoutHost() {
        if (prevBreakoutHost && prevBreakoutHost !== localSessionId && breakoutHost === localSessionId) {
            addMessage({
                content: t("breakouts.newHostMessage"),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutIcon/* BreakoutIcon */.y, {
                    size: 16
                }),
                type: "info"
            });
        }
    }, [
        addMessage,
        breakoutHost,
        localSessionId,
        prevBreakoutHost,
        t
    ]);
    var joinBreakout = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            var ref;
            var prevUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
            if ((prevUserData === null || prevUserData === void 0 ? void 0 : (ref = prevUserData.br) === null || ref === void 0 ? void 0 : ref.status) === "invited") {
                set(breakoutJoiningState, true);
            }
            handleRoomSwitch();
            (0,lib_userData/* setPrebuiltUserData */.T3)(daily, BreakoutsProvider_objectSpread({}, prevUserData, {
                br: {
                    currentRoomId: invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.id,
                    status: "joined"
                }
            }));
        };
    }, [
        daily,
        handleRoomSwitch,
        invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.id
    ]);
    var leaveBreakout = (0,react.useCallback)(function() {
        var prevUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
        handleRoomSwitch();
        (0,lib_userData/* setPrebuiltUserData */.T3)(daily, BreakoutsProvider_objectSpread({}, prevUserData, {
            br: {
                status: "left"
            }
        }));
    }, [
        daily,
        handleRoomSwitch
    ]);
    var ref4 = (0,daily_react_esm/* useRecording */.$n)(), isRecording = ref4.isRecording, stopRecording = ref4.stopRecording;
    var setupBreakouts = (0,react.useCallback)(function() {
        var _ref = BreakoutsProvider_asyncToGenerator(runtime_default().mark(function _callee(roomMapping, sessionConfig) {
            var newSessionData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return daily === null || daily === void 0 ? void 0 : daily.setNetworkTopology({
                            topology: "sfu"
                        });
                    case 2:
                        newSessionData = BreakoutsProvider_defineProperty({}, MEETING_DATA_BREAKOUTS_KEY, {
                            mapping: roomMapping,
                            host: localSessionId,
                            status: "ongoing",
                            config: sessionConfig
                        });
                        if (isRecording) {
                            stopRecording();
                            addMessage({
                                content: t("recording.status.stopped"),
                                type: "info",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordIcon/* RecordIcon */.A, {
                                    size: 16
                                })
                            });
                        }
                        return _ctx.abrupt("return", new Promise(function(resolve) {
                            var handleSessionStateUpdate = function(ev) {
                                var data = ev.meetingSessionState.data;
                                if (fast_deep_equal_default()(data[MEETING_DATA_BREAKOUTS_KEY], newSessionData[MEETING_DATA_BREAKOUTS_KEY])) {
                                    resolve();
                                }
                            };
                            daily.on("meeting-session-state-updated", handleSessionStateUpdate);
                            daily.setMeetingSessionData(newSessionData, "shallow-merge");
                        }));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(roomMapping, sessionConfig) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addMessage,
        daily,
        isRecording,
        localSessionId,
        stopRecording,
        t
    ]);
    var endTimeout = (0,react.useRef)(null);
    var ref5 = BreakoutsProvider_slicedToArray(useBreakoutView(), 2), setBreakoutView = ref5[1];
    var endBreakouts = (0,react.useCallback)(BreakoutsProvider_asyncToGenerator(runtime_default().mark(function _callee() {
        var endNow, ref, sessionData, ref11, ref12, newSessionData, endDate, ref13, newSessionData1, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    endNow = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    ;
                    sessionData = daily.meetingSessionState().data;
                    if (!endNow) {
                        _ctx.next = 8;
                        break;
                    }
                    ;
                    newSessionData = BreakoutsProvider_defineProperty({}, MEETING_DATA_BREAKOUTS_KEY, BreakoutsProvider_objectSpread({}, sessionData[MEETING_DATA_BREAKOUTS_KEY], {
                        status: "ended",
                        host: "",
                        config: {
                            autojoin: (ref11 = sessionData[MEETING_DATA_BREAKOUTS_KEY]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.config) === null || ref12 === void 0 ? void 0 : ref12.autojoin
                        }
                    }));
                    clearTimeout(endTimeout.current);
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        var handleSessionStateUpdate = function(ev) {
                            if (fast_deep_equal_default()(ev.meetingSessionState.data[MEETING_DATA_BREAKOUTS_KEY], newSessionData[MEETING_DATA_BREAKOUTS_KEY])) {
                                daily.off("meeting-session-state-updated", handleSessionStateUpdate);
                                setBreakoutView("start");
                                resolve();
                            }
                        };
                        daily.on("meeting-session-state-updated", handleSessionStateUpdate);
                        daily.setMeetingSessionData(newSessionData, "replace");
                    }));
                case 8:
                    endDate = new Date(Date.now() + 60000);
                    ;
                    newSessionData1 = BreakoutsProvider_defineProperty({}, MEETING_DATA_BREAKOUTS_KEY, BreakoutsProvider_objectSpread({}, sessionData[MEETING_DATA_BREAKOUTS_KEY], {
                        config: BreakoutsProvider_objectSpread({}, (ref13 = (ref = sessionData[MEETING_DATA_BREAKOUTS_KEY]) === null || ref === void 0 ? void 0 : ref.config) !== null && ref13 !== void 0 ? ref13 : {}, {
                            endDate: endDate.toISOString()
                        })
                    }));
                    daily.setMeetingSessionData(newSessionData1, "shallow-merge");
                    clearTimeout(endTimeout.current);
                    endTimeout.current = setTimeout(function() {
                        endBreakouts(true);
                    }, 60000);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        daily,
        setBreakoutView
    ]);
    var abortEndingBreakouts = (0,react.useCallback)(function() {
        var sessionData = daily.meetingSessionState().data;
        var newSessionData = BreakoutsProvider_defineProperty({}, MEETING_DATA_BREAKOUTS_KEY, BreakoutsProvider_objectSpread({}, sessionData[MEETING_DATA_BREAKOUTS_KEY], {
            config: BreakoutsProvider_objectSpread({}, sessionData[MEETING_DATA_BREAKOUTS_KEY].config, {
                endDate: null
            })
        }));
        daily.setMeetingSessionData(newSessionData, "shallow-merge");
        clearTimeout(endTimeout.current);
    }, [
        daily
    ]);
    var moveParticipants = (0,react.useCallback)(function(movements) {
        var sessionData = daily.meetingSessionState().data;
        var mapping = BreakoutsProvider_objectSpread({}, sessionData[MEETING_DATA_BREAKOUTS_KEY].mapping);
        var findUser = function(sessionId) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(mapping)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = BreakoutsProvider_slicedToArray(_step.value, 2), roomId = _value[0], config = _value[1];
                    if (config.users.includes(sessionId)) return roomId;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return null;
        };
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            var _loop = function(_iterator1, _step1) {
                var _value = BreakoutsProvider_slicedToArray(_step1.value, 2), sessionId = _value[0], roomId = _value[1];
                var currentRoom = findUser(sessionId);
                // First, edit the session data: REMOVE the user from whatever current room they are in.
                if (currentRoom) {
                    mapping[currentRoom] = {
                        name: mapping[currentRoom].name,
                        users: _toConsumableArray(mapping[currentRoom].users.filter(function(id) {
                            return id !== sessionId;
                        }))
                    };
                }
                // then add the user to their new room (unless it's the main room)
                if (roomId && roomId !== constants/* MAIN_ROOM_IDENTIFIER */.b) {
                    mapping[roomId] = {
                        name: mapping[roomId].name,
                        users: _toConsumableArray(mapping[roomId].users).concat([
                            sessionId
                        ])
                    };
                }
                // set the new data
                daily.setMeetingSessionData({
                    br: BreakoutsProvider_objectSpread({}, sessionData.br, {
                        mapping: mapping
                    })
                }, "shallow-merge");
            };
            for(var _iterator1 = Object.entries(movements)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop(_iterator1, _step1);
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }, [
        daily
    ]);
    var declineBreakout = (0,react.useCallback)(function() {
        var ref;
        var prevUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
        (0,lib_userData/* setPrebuiltUserData */.T3)(daily, BreakoutsProvider_objectSpread({}, prevUserData, {
            br: {
                status: "declined",
                currentRoomId: (ref = prevUserData.br) === null || ref === void 0 ? void 0 : ref.currentRoomId
            }
        }));
    }, [
        daily
    ]);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-updated", (0,react.useCallback)(function(events) {
        if (breakoutHost !== localSessionId) return;
        var movements = {};
        events.forEach(function(event) {
            var ref, ref14;
            var userData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily, event.participant.local ? "local" : event.participant.session_id);
            if ((userData === null || userData === void 0 ? void 0 : (ref = userData.br) === null || ref === void 0 ? void 0 : ref.status) === "declined" || (userData === null || userData === void 0 ? void 0 : (ref14 = userData.br) === null || ref14 === void 0 ? void 0 : ref14.status) === "left") {
                var ref15;
                var ref16;
                movements[event.participant.session_id] = (ref16 = userData === null || userData === void 0 ? void 0 : (ref15 = userData.br) === null || ref15 === void 0 ? void 0 : ref15.currentRoomId) !== null && ref16 !== void 0 ? ref16 : constants/* MAIN_ROOM_IDENTIFIER */.b;
            }
        });
        if (Object.keys(movements).length === 0) return;
        moveParticipants(movements);
    }, [
        breakoutHost,
        daily,
        localSessionId,
        moveParticipants
    ]));
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-left", (0,react.useCallback)(function(evts) {
        if (breakoutHost !== localSessionId) return;
        var movements = {};
        evts.forEach(function(ev) {
            // moving left participants to the main room, removes them from the list of breakout participants
            movements[ev.participant.session_id] = constants/* MAIN_ROOM_IDENTIFIER */.b;
        });
        if (Object.keys(movements).length === 0) return;
        moveParticipants(movements);
    }, [
        breakoutHost,
        localSessionId,
        moveParticipants
    ]));
    /**
   * Cancel request for help, when breakout host joined this room.
   */ (0,react.useEffect)(function() {
        if (breakoutParticipantIds.includes(breakoutHost)) {
            var ref;
            var prevUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
            // Ignore if help is already falsy to prevent unnecessary writes to userData
            if (!(prevUserData === null || prevUserData === void 0 ? void 0 : (ref = prevUserData.br) === null || ref === void 0 ? void 0 : ref.help)) return;
            var ref17;
            (0,lib_userData/* setPrebuiltUserData */.T3)(daily, BreakoutsProvider_objectSpread({}, prevUserData !== null && prevUserData !== void 0 ? prevUserData : {}, {
                br: BreakoutsProvider_objectSpread({}, (ref17 = prevUserData === null || prevUserData === void 0 ? void 0 : prevUserData.br) !== null && ref17 !== void 0 ? ref17 : {}, {
                    help: false
                })
            }));
        }
    }, [
        breakoutHost,
        breakoutParticipantIds,
        daily
    ]);
    if (!enableBreakoutRooms) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    // TODO: Remove me, when you're done with debugging!
    window["breakouts"] = {
        abortEndingBreakouts: abortEndingBreakouts,
        endBreakouts: endBreakouts,
        joinBreakout: joinBreakout,
        leaveBreakout: leaveBreakout,
        declineBreakout: declineBreakout,
        moveParticipants: moveParticipants,
        setupBreakouts: setupBreakouts
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutsContext.Provider, {
        value: {
            abortEndingBreakouts: abortEndingBreakouts,
            setBreakoutHost: setBreakoutHost,
            endBreakouts: endBreakouts,
            declineBreakout: declineBreakout,
            joinBreakout: joinBreakout,
            leaveBreakout: leaveBreakout,
            moveParticipants: moveParticipants,
            setupBreakouts: setupBreakouts
        },
        children: children
    });
};
var useBreakouts = function() {
    return (0,react.useContext)(BreakoutsContext);
};

;// CONCATENATED MODULE: ./hooks/useJoinSound.ts



/**
 * Convenience hook to play `join.mp3` when first other participants joins.
 */ var useJoinSound = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var joinSound = useSoundLoader().joinSound;
    var ref = (0,react.useState)(false), playJoinSound = ref[0], setPlayJoinSound = ref[1];
    (0,react.useEffect)(function() {
        if (!daily) return;
        /**
     * We don't want to immediately play a joined sound, when the user joins the meeting:
     * Upon joining all other participants, that were already in-call, will emit a
     * participant-joined event.
     * In waiting 2 seconds we make sure, that the sound is only played when the user
     * is **really** the first participant.
     */ setTimeout(function() {
            setPlayJoinSound(true);
        }, 2000);
    }, [
        daily
    ]);
    (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed()) return;
        var handleParticipantJoined = function() {
            // first other participant joined --> play sound
            if (!playJoinSound || Object.keys(daily.participants()).length !== 2) return;
            joinSound.play();
        };
        daily.on("participant-joined", handleParticipantJoined);
        return function() {
            daily.off("participant-joined", handleParticipantJoined);
        };
    }, [
        daily,
        joinSound,
        playJoinSound
    ]);
};

// EXTERNAL MODULE: ../shared/dist/components/Card/index.js
var Card = __webpack_require__(8257);
// EXTERNAL MODULE: ../shared/dist/components/Stack/index.js
var Stack = __webpack_require__(4776);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./hooks/useStyleVariants.ts
var useStyleVariants = __webpack_require__(6803);
;// CONCATENATED MODULE: ./lib/robots.ts
var ROBOTS_PREFIX = "robots-";
var robotsClassName = function(str) {
    return ROBOTS_PREFIX + str;
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/BreakoutHostHelpNotification.tsx
function BreakoutHostHelpNotification_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutHostHelpNotification_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BreakoutHostHelpNotification_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BreakoutHostHelpNotification_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutHostHelpNotification_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutHostHelpNotification_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BreakoutHostHelpNotification_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BreakoutHostHelpNotification_slicedToArray(arr, i) {
    return BreakoutHostHelpNotification_arrayWithHoles(arr) || BreakoutHostHelpNotification_iterableToArrayLimit(arr, i) || BreakoutHostHelpNotification_unsupportedIterableToArray(arr, i) || BreakoutHostHelpNotification_nonIterableRest();
}
function BreakoutHostHelpNotification_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutHostHelpNotification_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutHostHelpNotification_arrayLikeToArray(o, minLen);
}


















var BreakoutHostHelpNotification = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var textVariantStrong = (0,useStyleVariants/* useStyleVariants */._)().textVariantStrong;
    var ref = BreakoutHostHelpNotification_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var ref1 = BreakoutHostHelpNotification_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref1[0], setSidebarView = ref1[1];
    var ref2 = (0,react.useState)(false), /*#__PURE__*/ showNotification = ref2[0], setShowNotification = ref2[1];
    var ref3 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutMapping = ref3.breakoutMapping, participantsAskingForHelp = ref3.participantsAskingForHelp;
    var moveParticipants = useBreakouts().moveParticipants;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var roomsWithRequests = Object.entries(breakoutMapping).filter(function(param) {
        var _param = BreakoutHostHelpNotification_slicedToArray(param, 2), room = _param[1];
        return room.users.some(function(u) {
            return participantsAskingForHelp.includes(u);
        });
    }).map(function(param) {
        var _param = BreakoutHostHelpNotification_slicedToArray(param, 2), roomId = _param[0], room = _param[1];
        return BreakoutHostHelpNotification_objectSpread({}, room, {
            id: roomId
        });
    });
    var firstUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(participantsAskingForHelp === null || participantsAskingForHelp === void 0 ? void 0 : participantsAskingForHelp[0], "user_name") || t("people.guest");
    var handleViewAllClick = (0,react.useCallback)(function() {
        setSidebarView("people");
        setShowNotification(false);
    }, [
        setSidebarView
    ]);
    var handleJoinRoomClick = (0,react.useCallback)(function(id) {
        moveParticipants(BreakoutHostHelpNotification_defineProperty({}, localSessionId, id));
        setShowNotification(false);
    }, [
        localSessionId,
        moveParticipants
    ]);
    var handleDismissClick = (0,react.useCallback)(function() {
        setShowNotification(false);
    }, []);
    var prevParticipantsAskingForHelp = (0,usePreviousValue/* usePreviousValue */.z)(participantsAskingForHelp);
    (0,react.useEffect)(function() {
        if (participantsAskingForHelp.length > (prevParticipantsAskingForHelp === null || prevParticipantsAskingForHelp === void 0 ? void 0 : prevParticipantsAskingForHelp.length)) {
            setShowNotification(true);
        }
    }, [
        participantsAskingForHelp.length,
        prevParticipantsAskingForHelp === null || prevParticipantsAskingForHelp === void 0 ? void 0 : prevParticipantsAskingForHelp.length
    ]);
    if (!showNotification || !roomsWithRequests.length) return null;
    var firstRoom = roomsWithRequests[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "9f278e2b03ac1b1f",
                [
                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                    mediaQueries.coarse
                ]
            ]
        ]) + " " + "breakout-host-help-notification",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Theme.ThemeScope, {
                theme: "light",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "presentation",
                        className: styled_jsx_default().dynamic([
                            [
                                "9f278e2b03ac1b1f",
                                [
                                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                                    mediaQueries.coarse
                                ]
                            ]
                        ]) + " " + "backdrop"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "9f278e2b03ac1b1f",
                                [
                                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                                    mediaQueries.coarse
                                ]
                            ]
                        ]) + " " + (classnames_default()("notification-stack", {
                            "with-sidebar": Boolean(sidebarView)
                        }) || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            noBorder: true,
                            spacing: 8,
                            variant: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            variant: textVariantStrong,
                                            children: roomsWithRequests.length > 1 ? t("breakouts.multipleRoomsAskingForHelp") : participantsAskingForHelp.length > 1 ? t("breakouts.usersAskingForHelp", {
                                                count: participantsAskingForHelp.length
                                            }) : t("breakouts.userAskingForHelp", {
                                                name: firstUserName
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                            align: "center",
                                            gap: isMobile ? 16 : 4,
                                            horizontal: true,
                                            children: [
                                                roomsWithRequests.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "breakouts-help-notification-join-".concat(firstRoom.name),
                                                    className: classnames_default()(robotsClassName("btn-br-join-room-".concat(firstRoom.name))),
                                                    onClick: function() {
                                                        return handleJoinRoomClick(firstRoom.id);
                                                    },
                                                    size: "small",
                                                    variant: "primary",
                                                    children: t("breakouts.joinRoomWithName", {
                                                        name: t("breakouts.roomWithName", {
                                                            name: firstRoom.name
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "breakouts-help-notification-view-all",
                                                    className: robotsClassName("btn-br-help-view-all"),
                                                    onClick: handleViewAllClick,
                                                    size: "small",
                                                    variant: "primary",
                                                    children: t("breakouts.viewAll")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "breakouts-help-notification-dismiss",
                                                    className: robotsClassName("btn-br-dismiss"),
                                                    onClick: handleDismissClick,
                                                    size: "small",
                                                    variant: "secondary",
                                                    children: t("general.dismiss")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "9f278e2b03ac1b1f",
                dynamic: [
                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                    mediaQueries.coarse
                ],
                children: ".breakout-host-help-notification.__jsx-style-dynamic-selector{height:100%;position:absolute;width:100%;z-index:var(--zindex-waitingroom)}.backdrop.__jsx-style-dynamic-selector{background:-webkit-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:-moz-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:-o-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:linear-gradient(180deg,var(--backdrop)0%,var(--backdrop-hidden)100%);height:-webkit-calc(100% - 59px);height:-moz-calc(100% - 59px);height:calc(100% - 59px);left:0;position:absolute;top:var(--header-height);width:100%}.notification-stack.__jsx-style-dynamic-selector{-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px;position:absolute;right:8px;top:-webkit-calc(var(--header-height) + 8px);top:-moz-calc(var(--header-height) + 8px);top:calc(var(--header-height) + 8px)}.notification-stack.with-sidebar.__jsx-style-dynamic-selector{right:".concat(Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8, "px}.notification-stack.__jsx-style-dynamic-selector .card-content{padding-right:24px;position:relative}@media ").concat(mediaQueries.coarse, "{.notification-stack.__jsx-style-dynamic-selector .card-content{padding-right:32px}}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/LoadingSpinner/index.js
var LoadingSpinner = __webpack_require__(3102);
;// CONCATENATED MODULE: ./components/BreakoutRooms/JoiningBreakoutRoomScreen.tsx
function JoiningBreakoutRoomScreen_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function JoiningBreakoutRoomScreen_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return JoiningBreakoutRoomScreen_arrayLikeToArray(arr);
}
function JoiningBreakoutRoomScreen_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function JoiningBreakoutRoomScreen_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function JoiningBreakoutRoomScreen_toConsumableArray(arr) {
    return JoiningBreakoutRoomScreen_arrayWithoutHoles(arr) || JoiningBreakoutRoomScreen_iterableToArray(arr) || JoiningBreakoutRoomScreen_unsupportedIterableToArray(arr) || JoiningBreakoutRoomScreen_nonIterableSpread();
}
function JoiningBreakoutRoomScreen_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return JoiningBreakoutRoomScreen_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return JoiningBreakoutRoomScreen_arrayLikeToArray(o, minLen);
}









var MAX_ALSO_JOINING_COUNT = 10;
var JoiningBreakoutRoomScreen = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var invitedBreakoutRoom = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().invitedBreakoutRoom;
    var participants = daily === null || daily === void 0 ? void 0 : daily.participants();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref1;
    var joiningPeers = ((ref1 = invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.users) !== null && ref1 !== void 0 ? ref1 : []).filter(function(id) {
        return id !== localSessionId;
    });
    var joiningPeersWithName = joiningPeers.filter(function(id) {
        var ref;
        return Boolean(participants === null || participants === void 0 ? void 0 : (ref = participants[id]) === null || ref === void 0 ? void 0 : ref.user_name);
    });
    var displayableNames = joiningPeersWithName.slice(0, MAX_ALSO_JOINING_COUNT);
    var nonDisplayableNamesCount = Math.max(0, joiningPeersWithName.length - MAX_ALSO_JOINING_COUNT);
    var joiningPeersWithoutNameCount = joiningPeers.length - joiningPeersWithName.length;
    var names = JoiningBreakoutRoomScreen_toConsumableArray(displayableNames.length ? displayableNames.map(function(id) {
        return participants[id].user_name;
    }) : []);
    if (joiningPeers.length > 0 && joiningPeersWithoutNameCount > 0) {
        var namesCount = joiningPeersWithoutNameCount + nonDisplayableNamesCount;
        names.push(t("people.othersWithCount", {
            count: namesCount
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
        /*#__PURE__*/ noBorder: true,
        shadow: "none",
        appearance: "grey",
        style: {
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-ae87bccf97afa563" + " " + "joining-breakout-room-screen",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        align: "center",
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "h2",
                                variant: "largestrong",
                                children: t("breakouts.joiningBreakoutScreen.description", {
                                    room: invitedBreakoutRoom ? t("breakouts.roomWithName", {
                                        name: invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name
                                    }) : t("breakouts.mainRoom")
                                })
                            }),
                            invitedBreakoutRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "p",
                                className: "joining-user-names",
                                children: joiningPeers.length > 0 ? t("breakouts.joiningBreakoutScreen.joiningUsers", {
                                    count: names.length,
                                    names: names
                                }) : t("breakouts.joiningBreakoutScreen.standBy")
                            }),
                            !invitedBreakoutRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "p",
                                children: t("breakouts.joiningBreakoutScreen.standBy")
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ae87bccf97afa563",
                children: ".joining-breakout-room-screen.jsx-ae87bccf97afa563{text-align:center;margin-bottom:16px}.joining-breakout-room-screen.jsx-ae87bccf97afa563 .joining-user-names{max-width:80ch}.joining-breakout-room-screen.jsx-ae87bccf97afa563 svg{margin-bottom:16px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/lib/pxToRem.js
var pxToRem = __webpack_require__(7227);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(6804);
// EXTERNAL MODULE: ./hooks/useEmojiSkinTone.ts
var useEmojiSkinTone = __webpack_require__(4064);
;// CONCATENATED MODULE: ./hooks/useEmojiReactions.ts
function useEmojiReactions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useEmojiReactions_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useEmojiReactions_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useEmojiReactions_arrayLikeToArray(arr);
}
function useEmojiReactions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useEmojiReactions_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useEmojiReactions_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useEmojiReactions_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useEmojiReactions_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useEmojiReactions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useEmojiReactions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useEmojiReactions_slicedToArray(arr, i) {
    return useEmojiReactions_arrayWithHoles(arr) || useEmojiReactions_iterableToArrayLimit(arr, i) || useEmojiReactions_unsupportedIterableToArray(arr, i) || useEmojiReactions_nonIterableRest();
}
function useEmojiReactions_toConsumableArray(arr) {
    return useEmojiReactions_arrayWithoutHoles(arr) || useEmojiReactions_iterableToArray(arr) || useEmojiReactions_unsupportedIterableToArray(arr) || useEmojiReactions_nonIterableSpread();
}
function useEmojiReactions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useEmojiReactions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useEmojiReactions_arrayLikeToArray(o, minLen);
}






// The base available audience reaction emoji
var availableReactionEmoji = [
    "\uD83D\uDC4F",
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\uD83D\uDC4B",
    "\u2764\uFE0F",
    "\uD83D\uDE02",
    "\uD83E\uDD2F",
    "\uD83D\uDD25",
    "\uD83C\uDF89", 
];
// The available audience reaction emoji with modifiers
var possibleEmojiCombinations = [];
var generateAllowedEmojiList = function() {
    var emojiWithModifiers = function(emojis) {
        emojis.map(function(emoji) {
            for(var i = 0; i < Object.values(useEmojiSkinTone/* skinToneMap */.m).length; i++){
                possibleEmojiCombinations.push(emoji + Object.values(useEmojiSkinTone/* skinToneMap */.m)[i]);
            }
        });
        return possibleEmojiCombinations;
    };
    emojiWithModifiers([
        "\uD83D\uDC4F",
        "\uD83D\uDC4D",
        "\uD83D\uDC4E",
        "\uD83D\uDC4B"
    ]);
};
generateAllowedEmojiList();
// All allowed audience reaction emoji
var allowedReactionEmoji = useEmojiReactions_toConsumableArray(possibleEmojiCombinations).concat(useEmojiReactions_toConsumableArray(availableReactionEmoji));
// We don't want to allow crafty participants to send any old emoji or message using
// sendAppMessage, so we check if the emoji is allowed.
function emojiIsAllowed(r) {
    return allowedReactionEmoji.includes(r);
}
var currentEmojiReactionState = (0,es/* atom */.cn)({
    key: "current-emoji-reaction",
    default: null
});
var showEmojiReactionsMenuState = (0,es/* atom */.cn)({
    key: "show-emoji-reactions",
    default: false
});
var useShowEmojiReactionsMenu = function() {
    var ref = useEmojiReactions_slicedToArray((0,es/* useRecoilState */.FV)(showEmojiReactionsMenuState), 2), showEmojiReactionsMenu = ref[0], setShowEmojiReactionsMenu = ref[1];
    return {
        setShowEmojiReactionsMenu: setShowEmojiReactionsMenu,
        showEmojiReactionsMenu: showEmojiReactionsMenu
    };
};
var useEmojiReactions = function() {
    var localParticipant = (0,daily_react_esm/* useLocalParticipant */.j1)();
    var currentBreakoutRoom = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().currentBreakoutRoom;
    var currentEmojiReaction = (0,es/* useRecoilValue */.sJ)(currentEmojiReactionState);
    var addCurrentEmojiReaction = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(r, xPosition) {
            set(currentEmojiReactionState, function(old) {
                // Avoid unintentional double reactions
                if (old && old.id === r.id) {
                    return old;
                }
                var newR = useEmojiReactions_objectSpread({}, r);
                // create new date when reaction arrives at client,
                // so differentiating past reactions when changing call views works correctly
                newR.created = new Date();
                newR.xPosition = xPosition;
                // Random position offset between -25 and 25 to make it look more 'bubbly'
                newR.positionOffset = Math.floor(Math.random() * 25 * (Math.round(Math.random()) * 2 - 1));
                return newR;
            });
        };
    }, []);
    var sendAppMessage = (0,daily_react_esm/* useAppMessage */.F3)({
        onAppMessage: (0,react.useCallback)(function(ev) {
            var ref;
            switch(ev === null || ev === void 0 ? void 0 : (ref = ev.data) === null || ref === void 0 ? void 0 : ref.event){
                case "sync-emoji-reaction":
                    var ref1, ref2;
                    if (emojiIsAllowed(ev === null || ev === void 0 ? void 0 : (ref1 = ev.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reaction) === null || ref2 === void 0 ? void 0 : ref2.emoji)) {
                        var ref3;
                        addCurrentEmojiReaction(ev === null || ev === void 0 ? void 0 : (ref3 = ev.data) === null || ref3 === void 0 ? void 0 : ref3.reaction);
                    }
                    break;
            }
        }, [
            addCurrentEmojiReaction
        ])
    });
    var sendReaction = (0,react.useCallback)(function(r, position) {
        if (!(localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.session_id)) return;
        var sessionId = localParticipant.session_id;
        var reaction = {
            emoji: r,
            id: (0,v4/* default */.Z)(),
            sessionId: sessionId,
            room: currentBreakoutRoom.id
        };
        sendAppMessage({
            event: "sync-emoji-reaction",
            reaction: reaction
        });
        // Add own emoji with custom position for the fly-up animation
        addCurrentEmojiReaction(reaction, position);
    }, [
        addCurrentEmojiReaction,
        currentBreakoutRoom.id,
        localParticipant,
        sendAppMessage, 
    ]);
    return {
        currentEmojiReaction: currentEmojiReaction,
        sendReaction: sendReaction
    };
};

;// CONCATENATED MODULE: ./components/EmojiReactions/EmojiReactions.tsx
function EmojiReactions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EmojiReactions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EmojiReactions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var EmojiReactions = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _animation = param.animation, animation = _animation === void 0 ? "flyUp" : _animation, _emojiSize = param.emojiSize, emojiSize = _emojiSize === void 0 ? 42 : _emojiSize, _exclusiveEmoji = param.exclusiveEmoji, exclusiveEmoji = _exclusiveEmoji === void 0 ? "" : _exclusiveEmoji, _sessionIds = param.sessionIds, sessionIds = _sessionIds === void 0 ? [] : _sessionIds;
    var enableEmojiReactions = (0,useCallConfig/* useCallConfig */.A)().enableEmojiReactions;
    var currentEmojiReaction = useEmojiReactions().currentEmojiReaction;
    var zIndex = (0,Theme.useTheme)().zIndex;
    var currentBreakoutRoom = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().currentBreakoutRoom;
    var contentRef = (0,react.useRef)(null);
    var prevReactionIdRef = (0,react.useRef)(null);
    var initTime = (0,react.useMemo)(function() {
        return new Date();
    }, []);
    var shouldRenderReaction = (0,react.useCallback)(function(id) {
        return (currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.room) === currentBreakoutRoom.id && prevReactionIdRef.current !== (currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.id) && (!exclusiveEmoji || exclusiveEmoji === (currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.emoji)) && (!sessionIds.length || sessionIds.some(function(sid) {
            return sid === id;
        }));
    }, [
        currentBreakoutRoom.id,
        currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.emoji,
        currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.id,
        currentEmojiReaction === null || currentEmojiReaction === void 0 ? void 0 : currentEmojiReaction.room,
        exclusiveEmoji,
        sessionIds, 
    ]);
    var getCalculatedStyles = (0,react.useCallback)(function(reaction) {
        // set style rules
        var setStyles = function(config) {
            return "animation-duration: ".concat(config.animationDuration, "ms; animation-name:").concat(config.animationName, "; animation-timing-function: ").concat(config.animationTimingFunction, "; ").concat(config.bottom ? "bottom: ".concat(config.bottom, "px;") : "", " ").concat(config.left ? "left: ".concat(config.left, "px;") : "", " font-size: ").concat((0,pxToRem.pxToRem)(emojiSize), ";");
        };
        var defaultReactionItemStyleConfig = {
            animationDuration: lib_constants/* EMOJI_REACTION_ANIMATION_DURATION */.X3,
            animationName: animation,
            animationTimingFunction: "ease-out"
        };
        var reactionItemStyleText = "";
        // set animation-specific style rules
        switch(animation){
            case "fadeIn":
                reactionItemStyleText = setStyles(defaultReactionItemStyleConfig);
                break;
            case "flyUp":
                reactionItemStyleText = setStyles(EmojiReactions_objectSpread({}, defaultReactionItemStyleConfig, {
                    left: reaction.positionOffset
                }));
                break;
            case "local":
                reactionItemStyleText = setStyles(EmojiReactions_objectSpread({}, defaultReactionItemStyleConfig, {
                    animationDuration: 1000,
                    animationTimingFunction: "cubic-bezier(0.25, 1, 0.5, 1)"
                }));
                break;
        }
        return reactionItemStyleText;
    }, [
        animation,
        emojiSize
    ]);
    /**
     * Inject reactions directly via DOM api.
     * This helps to circumvent side effects when views change while reactions
     * are still kept in state and supposed to animate.
     */ (0,react.useEffect)(function() {
        if (currentEmojiReaction && currentEmojiReaction.created > initTime && shouldRenderReaction(currentEmojiReaction.sessionId)) {
            var ref;
            var reactionItemStyleText = getCalculatedStyles(currentEmojiReaction);
            var emojiElement = document.createElement("div");
            emojiElement.className = "emoji";
            emojiElement.innerHTML = currentEmojiReaction.emoji;
            var reactionElement = document.createElement("div");
            reactionElement.className = "emoji-reaction-item";
            reactionElement.id = currentEmojiReaction.id;
            reactionElement.style.cssText = reactionItemStyleText;
            reactionElement.appendChild(emojiElement);
            // clean up DOM element after animation ended
            reactionElement.onanimationend = function() {
                reactionElement.remove();
            };
            (ref = contentRef.current) === null || ref === void 0 ? void 0 : ref.appendChild(reactionElement);
            // prevReactionIdRef will be checked in shouldRenderReaction().
            // Helps to prevent re-rendering already triggered reactions
            // that are still kept in state while the view is updated.
            prevReactionIdRef.current = currentEmojiReaction.id;
        }
    }, [
        currentEmojiReaction,
        getCalculatedStyles,
        initTime,
        shouldRenderReaction, 
    ]);
    if (!enableEmojiReactions) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: contentRef,
        className: styled_jsx_default().dynamic([
            [
                "20abe6b029dc7de4",
                [
                    zIndex.menu
                ]
            ]
        ]) + " " + "emoji-reactions",
        children: (0,jsx_runtime.jsx)((styled_jsx_default()), {
            id: "20abe6b029dc7de4",
            dynamic: [
                zIndex.menu
            ],
            /*#__PURE__*/ children: "@-webkit-keyframes fadeIn{from{opacity:0}50%{opacity:1}to{opacity:0}}@-moz-keyframes fadeIn{from{opacity:0}50%{opacity:1}to{opacity:0}}@-o-keyframes fadeIn{from{opacity:0}50%{opacity:1}to{opacity:0}}@keyframes fadeIn{from{opacity:0}50%{opacity:1}to{opacity:0}}@-webkit-keyframes flyUp{from{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}50%{opacity:1}to{opacity:0;-webkit-transform:translateY(-230px);transform:translateY(-230px)}}@-moz-keyframes flyUp{from{opacity:0;-moz-transform:translateY(0);transform:translateY(0)}50%{opacity:1}to{opacity:0;-moz-transform:translateY(-230px);transform:translateY(-230px)}}@-o-keyframes flyUp{from{opacity:0;-o-transform:translateY(0);transform:translateY(0)}50%{opacity:1}to{opacity:0;-o-transform:translateY(-230px);transform:translateY(-230px)}}@keyframes flyUp{from{opacity:0;-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0)}50%{opacity:1}to{opacity:0;-webkit-transform:translateY(-230px);-moz-transform:translateY(-230px);-o-transform:translateY(-230px);transform:translateY(-230px)}}@-webkit-keyframes local{from{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(3);transform:scale(3);opacity:0}}@-moz-keyframes local{from{-moz-transform:scale(1);transform:scale(1);opacity:1}to{-moz-transform:scale(3);transform:scale(3);opacity:0}}@-o-keyframes local{from{-o-transform:scale(1);transform:scale(1);opacity:1}to{-o-transform:scale(3);transform:scale(3);opacity:0}}@keyframes local{from{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(3);-moz-transform:scale(3);-o-transform:scale(3);transform:scale(3);opacity:0}}.emoji-reactions.__jsx-style-dynamic-selector{position:relative}.emoji-reactions.__jsx-style-dynamic-selector .emoji-reaction-item{opacity:0;pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:".concat(zIndex.menu, "}.emoji-reactions.__jsx-style-dynamic-selector .emoji-reaction-item .emoji{bottom:0;left:0;position:absolute;-webkit-transform:translate(-50%,50%);-moz-transform:translate(-50%,50%);-ms-transform:translate(-50%,50%);-o-transform:translate(-50%,50%);transform:translate(-50%,50%)}")
        })
    });
});
EmojiReactions.displayName = "EmojiReactions";

;// CONCATENATED MODULE: ./components/EmojiReactions/index.ts


// EXTERNAL MODULE: ../shared/dist/components/VisuallyHidden/index.js
var VisuallyHidden = __webpack_require__(812);
// EXTERNAL MODULE: ./hooks/useCustomIntegrations.ts + 1 modules
var useCustomIntegrations = __webpack_require__(5745);
;// CONCATENATED MODULE: ./hooks/iframe/useIframeMeetingLifecycleHandlers.ts
function useIframeMeetingLifecycleHandlers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIframeMeetingLifecycleHandlers_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useIframeMeetingLifecycleHandlers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIframeMeetingLifecycleHandlers_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIframeMeetingLifecycleHandlers_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIframeMeetingLifecycleHandlers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIframeMeetingLifecycleHandlers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useIframeMeetingLifecycleHandlers_slicedToArray(arr, i) {
    return useIframeMeetingLifecycleHandlers_arrayWithHoles(arr) || useIframeMeetingLifecycleHandlers_iterableToArrayLimit(arr, i) || useIframeMeetingLifecycleHandlers_unsupportedIterableToArray(arr, i) || useIframeMeetingLifecycleHandlers_nonIterableRest();
}
function useIframeMeetingLifecycleHandlers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIframeMeetingLifecycleHandlers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIframeMeetingLifecycleHandlers_arrayLikeToArray(o, minLen);
}







var useIframeMeetingLifecycleHandlers = function(messageChannel) {
    var initializeCallArgs = (0,CallProvider/* useCallState */.oz)().initializeCallArgs;
    var ref11 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 2), setShowFullscreenButton = ref11[1];
    var ref1 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 2), setShowLeaveButton = ref1[1];
    var ref2 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), setShowLocalVideo = ref2[1];
    var ref3 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useMaxGridTilesPerPage */.lW)(), 2), setMaxGridTilesPerPage = ref3[1];
    var ref4 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useMinGridTilesPerPage */.by)(), 2), setMinGridTilesPerPage = ref4[1];
    var ref5 = useIframeMeetingLifecycleHandlers_slicedToArray((0,layout/* usePreferredViewMode */.Ut)(), 2), setPreferredViewMode = ref5[1];
    var ref6 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 2), setCustomTrayButtons = ref6[1];
    var ref7 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 2), setShowUserNameChangeUI = ref7[1];
    var ref8 = useIframeMeetingLifecycleHandlers_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref8[1];
    var setCustomIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().setCustomIntegrations;
    var handleDriverJoinMeetingMsg = (0,react.useCallback)(function(msg) {
        var ref, ref9, ref10;
        if (!msg.properties) return;
        var callArgs = useIframeMeetingLifecycleHandlers_objectSpread({}, msg.properties);
        // It is okay to overwrite the settings in properties with the settings in the
        // preload cache because:
        // 1. If a new settings is provided in the join() call, the settings in preload cache and
        //    properties will be the same. Hence, this will essentially be a no-op.
        // 2. If no new settings are not provided in the join() call, the settings in preload cache
        //    will be the most upto date setting.
        if ((msg === null || msg === void 0 ? void 0 : (ref = msg.preloadCache) === null || ref === void 0 ? void 0 : ref.inputSettings) && // (empty object means uninitialized; would fail validation if used)
        Object.keys(msg.preloadCache.inputSettings).length) {
            callArgs.inputSettings = msg.preloadCache.inputSettings;
        }
        if (msg === null || msg === void 0 ? void 0 : (ref9 = msg.preloadCache) === null || ref9 === void 0 ? void 0 : ref9.audioDeviceId) {
            callArgs.audioSource = msg.preloadCache.audioDeviceId;
        }
        if (msg === null || msg === void 0 ? void 0 : (ref10 = msg.preloadCache) === null || ref10 === void 0 ? void 0 : ref10.videoDeviceId) {
            callArgs.videoSource = msg.preloadCache.videoDeviceId;
        }
        if (callArgs.subscribeToTracksAutomatically !== undefined) {
            console.warn("Prebuilt UI does not support subscribeToTracksAutomatically option; ignoring");
            delete callArgs.subscribeToTracksAutomatically;
        }
        if (callArgs.layoutConfig) {
            if (callArgs.layoutConfig.grid) {
                if (Number.isInteger(callArgs.layoutConfig.grid.maxTilesPerPage)) {
                    setMaxGridTilesPerPage(callArgs.layoutConfig.grid.maxTilesPerPage);
                    delete callArgs.layoutConfig.grid.maxTilesPerPage;
                }
                if (Number.isInteger(callArgs.layoutConfig.grid.minTilesPerPage)) {
                    setMinGridTilesPerPage(callArgs.layoutConfig.grid.minTilesPerPage);
                    delete callArgs.layoutConfig.grid.minTilesPerPage;
                }
            }
        }
        if (callArgs.activeSpeakerMode !== undefined) {
            setPreferredViewMode(callArgs.activeSpeakerMode ? "speaker" : "grid");
            delete callArgs.activeSpeakerMode;
        }
        if (callArgs.customIntegrations !== undefined) {
            setCustomIntegrations(callArgs.customIntegrations);
            delete callArgs.customIntegrations;
        }
        if (callArgs.customTrayButtons !== undefined) {
            setCustomTrayButtons(callArgs.customTrayButtons);
            delete callArgs.customTrayButtons;
        }
        if (callArgs.showParticipantsBar !== undefined) {
            setShowParticipantsBar(callArgs.showParticipantsBar);
            delete callArgs.showParticipantsBar;
        }
        if (callArgs.showLocalVideo !== undefined) {
            setShowLocalVideo(callArgs.showLocalVideo);
            delete callArgs.showLocalVideo;
        }
        if (callArgs.showLeaveButton !== undefined) {
            setShowLeaveButton(callArgs.showLeaveButton);
            delete callArgs.showLeaveButton;
        }
        if (callArgs.showFullscreenButton !== undefined) {
            setShowFullscreenButton(callArgs.showFullscreenButton);
            delete callArgs.showFullscreenButton;
        }
        if (callArgs.userData !== undefined) {
            callArgs.userData = useIframeMeetingLifecycleHandlers_defineProperty({}, lib_userData/* CUSTOMER_USER_DATA_KEY */.Ly, callArgs.userData);
        }
        if (callArgs.showUserNameChangeUI !== undefined) {
            setShowUserNameChangeUI(callArgs.showUserNameChangeUI);
            delete callArgs.showUserNameChangeUI;
        }
        initializeCallArgs(callArgs);
    // Swallow msg (don't forward to call machine): prebuilt UI knows to invoke
    // join() when appropriate. This avoids a multiple-join bug, and accounts
    // for actual join() occurring later in the prebuilt UI flow than when
    // the driver invokes it (i.e. when enable_prejoin_ui = true).
    }, [
        initializeCallArgs,
        setCustomIntegrations,
        setCustomTrayButtons,
        setMaxGridTilesPerPage,
        setMinGridTilesPerPage,
        setPreferredViewMode,
        setShowFullscreenButton,
        setShowLeaveButton,
        setShowLocalVideo,
        setShowParticipantsBar,
        setShowUserNameChangeUI, 
    ]);
    var handleCallMachineJoinedMeetingMsg = (0,react.useCallback)(function(msg) {
        // Remove tracks, which can't be serialized and sent through the
        // message channel.
        var newMsg = useIframeMeetingLifecycleHandlers_objectSpread({}, msg);
        if (msg.participants) {
            newMsg.participants = (0,lib_participants/* cloneParticipantsAndMungeForIframeProvider */._k)(newMsg.participants);
        }
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(newMsg);
    }, [
        messageChannel
    ]);
    return {
        handleDriverJoinMeetingMsg: handleDriverJoinMeetingMsg,
        handleCallMachineJoinedMeetingMsg: handleCallMachineJoinedMeetingMsg
    };
};

;// CONCATENATED MODULE: ./hooks/iframe/useIframeParticipantsHandlers.ts
function useIframeParticipantsHandlers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIframeParticipantsHandlers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIframeParticipantsHandlers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var useIframeParticipantsHandlers = function(messageChannel) {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var handleDriverUpdateParticipantMsg = (0,react.useCallback)(function(msg) {
        if (msg.properties && msg.properties["setSubscribedTracks"] !== undefined) {
            console.warn("Prebuilt UI does not support setSubscribedTracks in updateParticipant(); ignoring");
            delete msg.properties["setSubscribedTracks"];
        }
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleDriverUpdateParticipantsMsg = (0,react.useCallback)(function(msg) {
        if (msg.participants) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.values(msg.participants)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var participantUpdates = _step.value;
                    if (participantUpdates && participantUpdates["setSubscribedTracks"] !== undefined) {
                        console.warn("Prebuilt UI does not support setSubscribedTracks in updateParticipants(); ignoring");
                        delete participantUpdates["setSubscribedTracks"];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleDriverSetUserDataMsg = (0,react.useCallback)(function(msg) {
        var prebuiltUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
        var userData = useIframeParticipantsHandlers_defineProperty({}, lib_userData/* CUSTOMER_USER_DATA_KEY */.Ly, msg.userData);
        // if both our data and iframe data is undefined, then setUserData to
        // undefined to take advantage of a slimmed down presence payload
        if (msg.userData === undefined && prebuiltUserData === undefined) {
            userData = undefined;
        } else if (prebuiltUserData !== undefined) {
            userData[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui] = prebuiltUserData;
        }
        msg.userData = userData;
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleCallMachineParticipantMsg = (0,react.useCallback)(function(msg) {
        // Remove tracks, which can't be serialized and sent through the
        // message channel and clean up userData to only include iframe-set
        // data.
        var newMsg = useIframeParticipantsHandlers_objectSpread({}, msg);
        if (msg.participant) {
            newMsg.participant = (0,lib_participants/* cloneParticipantAndMungeForIframeProvider */.$O)(msg.participant);
        }
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(newMsg);
    }, [
        messageChannel
    ]);
    return {
        handleDriverUpdateParticipantMsg: handleDriverUpdateParticipantMsg,
        handleDriverUpdateParticipantsMsg: handleDriverUpdateParticipantsMsg,
        handleDriverSetUserDataMsg: handleDriverSetUserDataMsg,
        handleCallMachineParticipantMsg: handleCallMachineParticipantMsg
    };
};

// EXTERNAL MODULE: ./lib/theme.ts
var lib_theme = __webpack_require__(6868);
;// CONCATENATED MODULE: ./hooks/iframe/useIframeCustomIntegrations.ts


var useIframeCustomIntegrations = function() {
    var ref1 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), setCustomIntegrations = ref1.setCustomIntegrations, startIntegration = ref1.startIntegration, stopIntegration = ref1.stopIntegration;
    var handleStartCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        msg.ids.forEach(startIntegration);
    }, [
        startIntegration
    ]);
    var handleStopCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        msg.ids.forEach(stopIntegration);
    }, [
        stopIntegration
    ]);
    /**
   * When the client calls `setCustomIntegrations` this function is executed.
   */ var handleSetCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        var ref;
        var newIntegrations = (ref = msg === null || msg === void 0 ? void 0 : msg.integrations) !== null && ref !== void 0 ? ref : {};
        setCustomIntegrations(newIntegrations);
    }, [
        setCustomIntegrations
    ]);
    return {
        handleSetCustomIntegrationsMsg: handleSetCustomIntegrationsMsg,
        handleStartCustomIntegrationsMsg: handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg: handleStopCustomIntegrationsMsg
    };
};

;// CONCATENATED MODULE: ./hooks/iframe/useIframeUIControlHandlers.ts
function useIframeUIControlHandlers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIframeUIControlHandlers_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useIframeUIControlHandlers_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useIframeUIControlHandlers_arrayLikeToArray(arr);
}
function useIframeUIControlHandlers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIframeUIControlHandlers_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useIframeUIControlHandlers_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIframeUIControlHandlers_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIframeUIControlHandlers_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIframeUIControlHandlers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIframeUIControlHandlers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useIframeUIControlHandlers_slicedToArray(arr, i) {
    return useIframeUIControlHandlers_arrayWithHoles(arr) || useIframeUIControlHandlers_iterableToArrayLimit(arr, i) || useIframeUIControlHandlers_unsupportedIterableToArray(arr, i) || useIframeUIControlHandlers_nonIterableRest();
}
function useIframeUIControlHandlers_toConsumableArray(arr) {
    return useIframeUIControlHandlers_arrayWithoutHoles(arr) || useIframeUIControlHandlers_iterableToArray(arr) || useIframeUIControlHandlers_unsupportedIterableToArray(arr) || useIframeUIControlHandlers_nonIterableSpread();
}
function useIframeUIControlHandlers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIframeUIControlHandlers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIframeUIControlHandlers_arrayLikeToArray(o, minLen);
}










var useIframeUIControlHandlers = function(messageChannel) {
    var ref12 = useIframeUIControlHandlers_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 2), setCustomTrayButtons = ref12[1];
    var ref1 = useIframeUIControlHandlers_slicedToArray((0,custom/* useEnableJoinSound */.Xn)(), 2), setEnableJoinSound = ref1[1];
    var ref2 = useIframeUIControlHandlers_slicedToArray((0,custom/* useIsFullscreen */.hb)(), 2), setIsFullscreen = ref2[1];
    var ref3 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), showLocalVideo = ref3[0], setShowLocalVideo = ref3[1];
    var ref4 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowNames */.zD)(), 2), setShowNames = ref4[1];
    var ref5 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref5[1];
    var ref6 = useIframeUIControlHandlers_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView1 = ref6[0], setSidebarView = ref6[1];
    var ref7 = (0,Theme.useTheme)(), setDarkColors = ref7.setDarkColors, setLightColors = ref7.setLightColors;
    var ref8 = useIframeUIControlHandlers_slicedToArray((0,layout/* usePreferredViewMode */.Ut)(), 2), preferredViewMode = ref8[0], setPreferredViewMode = ref8[1];
    var ref9 = (0,react.useState)(false), activeSpeakerMode = ref9[0], setActiveSpeakerMode = ref9[1];
    var ref10 = (0,useCallConfig/* useCallConfig */.A)(), enableBreakoutRooms = ref10.enableBreakoutRooms, enableChat = ref10.enableChat, enableNetworkUI = ref10.enableNetworkUI, enablePeopleUI = ref10.enablePeopleUI;
    var sidebarIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().sidebarIntegrations;
    var handleDriverSetActiveSpeakerModeMsg = (0,react.useCallback)(function(msg) {
        // Map activeSpeakerMode to preferredViewMode
        setPreferredViewMode(msg.enabled ? "speaker" : "grid");
    // Swallow msg (don't forward to call machine)
    }, [
        setPreferredViewMode
    ]);
    var handleDriverShowLocalVideoMsg = (0,react.useCallback)(function(msg) {
        // Map showLocalVideo (property) to showLocalVideo (state)
        setShowLocalVideo(msg === null || msg === void 0 ? void 0 : msg.show);
    // Swallow msg (don't forward to call machine)
    }, [
        setShowLocalVideo
    ]);
    var handleDriverShowParticipantsBarMsg = (0,react.useCallback)(function(msg) {
        // Map showParticipantsBar (property) to showParticipantsBar (state)
        setShowParticipantsBar(msg === null || msg === void 0 ? void 0 : msg.show);
    // Swallow msg (don't forward to call machine)
    }, [
        setShowParticipantsBar
    ]);
    var ref11 = useIframeCustomIntegrations(), handleSetCustomIntegrationsMsg = ref11.handleSetCustomIntegrationsMsg, handleStartCustomIntegrationsMsg = ref11.handleStartCustomIntegrationsMsg, handleStopCustomIntegrationsMsg = ref11.handleStopCustomIntegrationsMsg;
    var handleUpdateCustomTrayButtonsMsg = (0,react.useCallback)(function(msg) {
        setCustomTrayButtons(msg === null || msg === void 0 ? void 0 : msg.btns);
    }, [
        setCustomTrayButtons
    ]);
    var isOwner = (0,daily_react_esm/* useParticipantProperty */.ou)((0,daily_react_esm/* useLocalSessionId */.q5)(), "owner");
    var availableSidebarViews = (0,react.useMemo)(function() {
        var availableViews = [
            null, 
        ].concat(useIframeUIControlHandlers_toConsumableArray(sidebarIntegrations.map(function(i) {
            return i.id;
        })));
        if (enablePeopleUI) availableViews.push("people");
        if (enableChat) availableViews.push("chat");
        if (enableNetworkUI) availableViews.push("network");
        if (enableBreakoutRooms && isOwner) availableViews.push("breakout");
        return availableViews;
    }, [
        enableBreakoutRooms,
        enableChat,
        enableNetworkUI,
        enablePeopleUI,
        isOwner,
        sidebarIntegrations, 
    ]);
    var handleGetSidebarViewMsg = (0,react.useCallback)(function(msg) {
        messageChannel.sendMessageToDriver(useIframeUIControlHandlers_objectSpread({}, msg, {
            action: "get-sidebar-view",
            view: sidebarView1
        }));
    }, [
        messageChannel,
        sidebarView1
    ]);
    var handleSetSidebarViewMsg = (0,react.useCallback)(function(msg) {
        var sidebarView = msg === null || msg === void 0 ? void 0 : msg.view;
        if (availableSidebarViews.includes(sidebarView)) {
            setSidebarView(sidebarView);
        } else {
            console.warn('No sidebar view "'.concat(sidebarView, '" available. Ignoring.'));
        }
    }, [
        availableSidebarViews,
        setSidebarView
    ]);
    var handleSetThemeMsg = (0,react.useCallback)(function(msg) {
        var theme = msg === null || msg === void 0 ? void 0 : msg.theme;
        if (!theme) return;
        var ref = useIframeUIControlHandlers_slicedToArray((0,lib_theme/* convertDailyThemeColors */.Bi)(theme), 2), light = ref[0], dark = ref[1];
        setLightColors(light);
        setDarkColors(dark);
    }, [
        setDarkColors,
        setLightColors
    ]);
    var handleDriverShowNames = (0,react.useCallback)(function(msg) {
        // Map showNamesMode to showNames
        setShowNames((msg === null || msg === void 0 ? void 0 : msg.mode) !== "never");
    // Swallow msg (don't forward to call machine)
    }, [
        setShowNames
    ]);
    var handleDriverEnterFullscreen = (0,react.useCallback)(function(_msg) {
        // Map fullscreen to isFullscreen
        setIsFullscreen(true);
    // Swallow msg (don't forward to call machine)
    }, [
        setIsFullscreen
    ]);
    var handleDriverExitFullscreen = (0,react.useCallback)(function(_msg) {
        // Map exited-fullscreen to isFullscreen
        setIsFullscreen(false);
    // Swallow msg (don't forward to call machine)
    }, [
        setIsFullscreen
    ]);
    var handleDriverSetPlayNewParticipantSound = (0,react.useCallback)(function(msg) {
        setEnableJoinSound(msg.arg);
    }, [
        setEnableJoinSound
    ]);
    /**
   * Map preferredViewMode to activeSpeakerMode (used by API).
   */ (0,react.useEffect)(function() {
        setActiveSpeakerMode(preferredViewMode === "speaker");
    }, [
        preferredViewMode
    ]);
    /**
   * Fire show-local-video-changed event when showLocalVideo changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "show-local-video-changed",
            show: showLocalVideo
        });
    }, [
        messageChannel,
        showLocalVideo
    ]);
    /**
   * Fire set-active-speaker-mode event when activeSpeakerMode changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "active-speaker-mode-change",
            enabled: activeSpeakerMode
        });
    }, [
        activeSpeakerMode,
        messageChannel
    ]);
    /**
   * Fire sidebar-view-changed event when sidebarView changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "sidebar-view-changed",
            view: sidebarView1
        });
    }, [
        sidebarView1,
        messageChannel
    ]);
    return {
        handleDriverEnterFullscreen: handleDriverEnterFullscreen,
        handleDriverExitFullscreen: handleDriverExitFullscreen,
        handleDriverSetActiveSpeakerModeMsg: handleDriverSetActiveSpeakerModeMsg,
        handleDriverSetPlayNewParticipantSound: handleDriverSetPlayNewParticipantSound,
        handleDriverShowLocalVideoMsg: handleDriverShowLocalVideoMsg,
        handleDriverShowNames: handleDriverShowNames,
        handleDriverShowParticipantsBarMsg: handleDriverShowParticipantsBarMsg,
        handleGetSidebarViewMsg: handleGetSidebarViewMsg,
        handleSetCustomIntegrationsMsg: handleSetCustomIntegrationsMsg,
        handleSetSidebarViewMsg: handleSetSidebarViewMsg,
        handleSetThemeMsg: handleSetThemeMsg,
        handleStartCustomIntegrationsMsg: handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg: handleStopCustomIntegrationsMsg,
        handleUpdateCustomTrayButtonsMsg: handleUpdateCustomTrayButtonsMsg
    };
};

;// CONCATENATED MODULE: ./contexts/IframeDriverMessageChannel.ts
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function IframeDriverMessageChannel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IframeDriverMessageChannel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IframeDriverMessageChannel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var IframeDriverMessageChannel = /*#__PURE__*/ function() {
    "use strict";
    function IframeDriverMessageChannel(frameId) {
        _classCallCheck(this, IframeDriverMessageChannel);
        this._wrappedListeners = {};
        this._incrementingListenerId = 0;
        this._frameId = frameId;
    }
    var _proto = IframeDriverMessageChannel.prototype;
    _proto.addListenerForMessagesFromDriver = function addListenerForMessagesFromDriver(listener) {
        var _this = this;
        var wrappedListener = function(evt) {
            var ref, ref1, ref2, ref3;
            var isIframeCallMessage = (evt === null || evt === void 0 ? void 0 : (ref = evt.data) === null || ref === void 0 ? void 0 : ref.what) === "iframe-call-message";
            var hasAction = evt === null || evt === void 0 ? void 0 : (ref1 = evt.data) === null || ref1 === void 0 ? void 0 : ref1.action;
            var isFromModule = !(evt === null || evt === void 0 ? void 0 : (ref2 = evt.data) === null || ref2 === void 0 ? void 0 : ref2.from) || evt.data.from === "module";
            var isTargetFrame = (evt === null || evt === void 0 ? void 0 : (ref3 = evt.data) === null || ref3 === void 0 ? void 0 : ref3.callFrameId) && _this._frameId ? evt.data.callFrameId === _this._frameId : true;
            if (!(isIframeCallMessage && hasAction && isFromModule && isTargetFrame)) {
                return;
            }
            var msg = evt.data;
            listener(msg);
        };
        this._wrappedListeners[this._incrementingListenerId] = wrappedListener;
        window.addEventListener("message", wrappedListener);
        return this._incrementingListenerId++;
    };
    _proto.removeListenerForMessagesFromDriver = function removeListenerForMessagesFromDriver(listenerId) {
        var wrappedListener = this._wrappedListeners[listenerId];
        if (wrappedListener) {
            window.removeEventListener("message", wrappedListener);
            delete this._wrappedListeners[listenerId];
        }
    };
    _proto.sendMessageToDriver = function sendMessageToDriver(message) {
        var ref;
        message.what = "iframe-call-message";
        message.callFrameId = this._frameId;
        message.from = "embedded";
        (ref = window.parent) === null || ref === void 0 ? void 0 : ref.postMessage(message, "*");
    };
    _proto.forwardPackagedMessageToDriver = function forwardPackagedMessageToDriver(msg) {
        var ref;
        var newMsg = IframeDriverMessageChannel_objectSpread({}, msg);
        newMsg.callFrameId = this._frameId;
        (ref = window.parent) === null || ref === void 0 ? void 0 : ref.postMessage(newMsg, "*");
    };
    return IframeDriverMessageChannel;
}();
/**
 * A message channel to and from a driver controlling the call UI via an iframe
 * (e.g. daily-js).
 * Based on WebMessageChannel in pluot-core.
 */ 

;// CONCATENATED MODULE: ./contexts/IframeDriverProvider.tsx
function IframeDriverProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function IframeDriverProvider_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                IframeDriverProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                IframeDriverProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function IframeDriverProvider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IframeDriverProvider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IframeDriverProvider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var IframeDriverContext = /*#__PURE__*/ (0,react.createContext)(null);
var IframeDriverProvider = function(param) {
    var children = param.children, frameId = param.frameId;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref = (0,react.useState)(null), messageChannel = ref[0], setMessageChannel = ref[1];
    var ref1 = useIframeMeetingLifecycleHandlers(messageChannel), handleCallMachineJoinedMeetingMsg = ref1.handleCallMachineJoinedMeetingMsg, handleDriverJoinMeetingMsg = ref1.handleDriverJoinMeetingMsg;
    var ref2 = useIframeParticipantsHandlers(messageChannel), handleCallMachineParticipantMsg = ref2.handleCallMachineParticipantMsg, handleDriverSetUserDataMsg = ref2.handleDriverSetUserDataMsg, handleDriverUpdateParticipantMsg = ref2.handleDriverUpdateParticipantMsg, handleDriverUpdateParticipantsMsg = ref2.handleDriverUpdateParticipantsMsg;
    var ref3 = useIframeUIControlHandlers(messageChannel), handleDriverEnterFullscreen = ref3.handleDriverEnterFullscreen, handleDriverExitFullscreen = ref3.handleDriverExitFullscreen, handleDriverSetActiveSpeakerModeMsg = ref3.handleDriverSetActiveSpeakerModeMsg, handleDriverSetPlayNewParticipantSound = ref3.handleDriverSetPlayNewParticipantSound, handleDriverShowLocalVideoMsg = ref3.handleDriverShowLocalVideoMsg, handleDriverShowNames = ref3.handleDriverShowNames, handleDriverShowParticipantsBarMsg = ref3.handleDriverShowParticipantsBarMsg, handleGetSidebarViewMsg = ref3.handleGetSidebarViewMsg, handleSetCustomIntegrationsMsg = ref3.handleSetCustomIntegrationsMsg, handleSetSidebarViewMsg = ref3.handleSetSidebarViewMsg, handleSetThemeMsg = ref3.handleSetThemeMsg, handleStartCustomIntegrationsMsg = ref3.handleStartCustomIntegrationsMsg, handleStopCustomIntegrationsMsg = ref3.handleStopCustomIntegrationsMsg, handleUpdateCustomTrayButtonsMsg = ref3.handleUpdateCustomTrayButtonsMsg;
    /**
   * Create a message channel to the iframe driver, if we're in an iframe.
   */ (0,react.useEffect)(function() {
        if (!frameId) return;
        setMessageChannel(new IframeDriverMessageChannel(frameId));
        return function() {
            setMessageChannel(null);
        };
    }, [
        frameId
    ]);
    /**
   * Tell the driver that the prebuilt UI has loaded, unblocking it from sending
   * subsequent messages like 'join-meeting'.
   */ (0,react.useEffect)(function() {
        if (!messageChannel) return;
        messageChannel.sendMessageToDriver({
            action: "loaded"
        });
    }, [
        messageChannel
    ]);
    var handleEnumerateDevices = (0,react.useCallback)(function() {
        var _ref = IframeDriverProvider_asyncToGenerator(runtime_default().mark(function _callee(_msg) {
            var jRT, raw, devices;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        jRT = function(struct) {
                            try {
                                return JSON.parse(JSON.stringify(struct));
                            } catch (e) {
                                return null;
                            }
                        };
                        _ctx.next = 3;
                        return navigator.mediaDevices.enumerateDevices();
                    case 3:
                        raw = _ctx.sent;
                        devices = raw.map(jRT);
                        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver(IframeDriverProvider_objectSpread({}, _msg, {
                            devices: devices
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_msg) {
            return _ref.apply(this, arguments);
        };
    }(), [
        messageChannel
    ]);
    /**
   * Set up handling of messages from the iframe driver.
   *
   * Note that we don't require callObject to exist yet in this effect, since
   * 'join-meeting' can happen *before* we initialize our callObject.
   */ (0,react.useEffect)(function() {
        if (!messageChannel) return;
        var driverListenerId = messageChannel.addListenerForMessagesFromDriver(function(msg) {
            switch(msg.action){
                // Add any special-case message handling here. Special messages include:
                // - UI control messages (e.g. 'set-active-speaker-mode')
                // - call machine control messages that require non-default handling
                // Note: try not to modify the message, to not interfere with possible
                // other listeners in the chain.
                case "set-custom-integrations":
                    handleSetCustomIntegrationsMsg(msg);
                    break;
                case "start-custom-integrations":
                    handleStartCustomIntegrationsMsg(msg);
                    break;
                case "stop-custom-integrations":
                    handleStopCustomIntegrationsMsg(msg);
                    break;
                case "update-custom-tray-buttons":
                    handleUpdateCustomTrayButtonsMsg(msg);
                    break;
                case "get-sidebar-view":
                    handleGetSidebarViewMsg(msg);
                    break;
                case "set-sidebar-view":
                    handleSetSidebarViewMsg(msg);
                    break;
                case "set-theme":
                    handleSetThemeMsg(msg);
                    break;
                case "join-meeting":
                    handleDriverJoinMeetingMsg(msg);
                    break;
                case "daily-method-set-play-ding":
                    handleDriverSetPlayNewParticipantSound(msg);
                    break;
                case "daily-method-subscribe-to-tracks-automatically":
                    console.warn("Prebuilt UI does not support setSubscribeToTracksAutomatically()");
                    break;
                case "update-participant":
                    handleDriverUpdateParticipantMsg(msg);
                    break;
                case "update-participants":
                    handleDriverUpdateParticipantsMsg(msg);
                    break;
                case "set-user-data":
                    handleDriverSetUserDataMsg(msg);
                    break;
                case "set-active-speaker-mode":
                    handleDriverSetActiveSpeakerModeMsg(msg);
                    break;
                case "set-show-local-video":
                    handleDriverShowLocalVideoMsg(msg);
                    break;
                case "set-show-names":
                    handleDriverShowNames(msg);
                    break;
                case "set-show-participants-bar":
                    handleDriverShowParticipantsBarMsg(msg);
                    break;
                case "fullscreen":
                    handleDriverEnterFullscreen(msg);
                    break;
                case "exited-fullscreen":
                    handleDriverExitFullscreen(msg);
                    break;
                case "enumerate-devices":
                    handleEnumerateDevices(msg);
                    break;
                default:
                    // By default, simply pass along the message to the call machine.
                    // (Right now we're using a special "private" callObject method, for
                    //  convenience. Note that it doesn't have to be this way: if we
                    //  wanted to limit ourselves only to public callObject methods, we
                    //  could handle each message from the driver as a special case,
                    //  invoking the corresponding callObject method and forwarding the
                    //  response to the iframe driver.)
                    // @ts-ignore
                    daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
                    break;
            }
        });
        return function() {
            messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.removeListenerForMessagesFromDriver(driverListenerId);
        };
    }, [
        daily,
        handleDriverEnterFullscreen,
        handleDriverExitFullscreen,
        handleDriverJoinMeetingMsg,
        handleDriverSetActiveSpeakerModeMsg,
        handleDriverSetPlayNewParticipantSound,
        handleDriverSetUserDataMsg,
        handleDriverShowLocalVideoMsg,
        handleDriverShowNames,
        handleDriverShowParticipantsBarMsg,
        handleDriverUpdateParticipantMsg,
        handleDriverUpdateParticipantsMsg,
        handleEnumerateDevices,
        handleGetSidebarViewMsg,
        handleSetCustomIntegrationsMsg,
        handleSetSidebarViewMsg,
        handleSetThemeMsg,
        handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg,
        handleUpdateCustomTrayButtonsMsg,
        messageChannel, 
    ]);
    /**
   * Set up handling of messages from the call machine.
   */ (0,react.useEffect)(function() {
        if (!daily) return;
        // Listen for any messages from the call machine.
        // (Right now we're using a special "private" callObject method, for
        //  convenience. Note that it doesn't have to be this way: see comment in
        //  driver message listener for a description of the public-method-only
        //  approach.)
        var callMachineListenerId = // @ts-ignore
        daily.addListenerForPackagedMessagesFromCallMachine(function(msg) {
            switch(msg.action){
                // Add any special-case message handling here.
                // Note: try not to modify the message, to not interfere with possible
                // other listeners in the chain.
                case "loaded":
                    break;
                case "joined-meeting":
                    handleCallMachineJoinedMeetingMsg(msg);
                    break;
                case "participant-joined":
                case "participant-updated":
                case "participant-left":
                    handleCallMachineParticipantMsg(msg);
                    break;
                case "track-started":
                case "track-stopped":
                    break;
                default:
                    // By default, simply pass along the message to the iframe driver.
                    messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(msg);
                    break;
            }
        });
        return function() {
            // @ts-ignore
            daily.removeListenerForPackagedMessagesFromCallMachine(callMachineListenerId);
        };
    }, [
        daily,
        messageChannel,
        handleCallMachineJoinedMeetingMsg,
        handleCallMachineParticipantMsg, 
    ]);
    var sendMessageToDriver = (0,react.useCallback)(function(message) {
        if (!messageChannel) return;
        messageChannel.sendMessageToDriver(message);
    }, [
        messageChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeDriverContext.Provider, {
        value: {
            sendMessageToDriver: sendMessageToDriver
        },
        children: children
    });
};
var useIframeDriver = function() {
    return (0,react.useContext)(IframeDriverContext);
};

;// CONCATENATED MODULE: ./components/FullscreenButton/FullscreenIcon.tsx
function FullscreenIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FullscreenIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FullscreenIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var FullscreenIcon = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, props = _objectWithoutProperties(_param, [
        "size"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", FullscreenIcon_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36"
    }, props, {
        className: styled_jsx_default().dynamic([
            [
                "6d5df79603d3b1ae",
                [
                    size,
                    size
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
                fill: colors.background,
                className: styled_jsx_default().dynamic([
                    [
                        "6d5df79603d3b1ae",
                        [
                            size,
                            size
                        ]
                    ]
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.5076 14.2451C23.497 14.7428 23.9032 15.149 24.4009 15.1385L24.4558 15.1374C24.9245 15.1274 25.3021 14.7499 25.3121 14.2812L25.4107 9.66057C25.4228 9.09171 24.9585 8.62738 24.3896 8.63948L19.7689 8.73782C19.3001 8.7478 18.9225 9.12549 18.9127 9.59425L18.9115 9.64943C18.9011 10.1471 19.3073 10.5532 19.805 10.5426L22.1429 10.4928L18.3617 14.274C17.9712 14.6645 17.9712 15.2977 18.3617 15.6882C18.7522 16.0787 19.3854 16.0787 19.7759 15.6882L23.5574 11.9068L23.5076 14.2451Z",
                fill: colors.baseText,
                className: styled_jsx_default().dynamic([
                    [
                        "6d5df79603d3b1ae",
                        [
                            size,
                            size
                        ]
                    ]
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5413 19.8038C10.5519 19.3061 10.1457 18.8998 9.64798 18.9104L9.59302 18.9115C9.12432 18.9214 8.74671 19.299 8.73672 19.7677L8.6382 24.3883C8.62607 24.9572 9.09038 25.4215 9.65925 25.4094L14.28 25.3111C14.7487 25.3011 15.1263 24.9234 15.1362 24.4546L15.1373 24.3995C15.1478 23.9018 14.7415 23.4957 14.2439 23.5063L11.906 23.556L15.6871 19.7749C16.0777 19.3844 16.0777 18.7512 15.6871 18.3607C15.2966 17.9701 14.6635 17.9701 14.2729 18.3607L10.4915 22.1421L10.5413 19.8038Z",
                fill: colors.baseText,
                className: styled_jsx_default().dynamic([
                    [
                        "6d5df79603d3b1ae",
                        [
                            size,
                            size
                        ]
                    ]
                ])
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6d5df79603d3b1ae",
                dynamic: [
                    size,
                    size
                ],
                /*#__PURE__*/ children: "svg.__jsx-style-dynamic-selector{display:block;height:".concat(size, "px;width:").concat(size, "px}")
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/FullscreenButton/FullscreenButton.tsx
function FullscreenButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FullscreenButton_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FullscreenButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FullscreenButton_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FullscreenButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FullscreenButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FullscreenButton_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FullscreenButton_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FullscreenButton_slicedToArray(arr, i) {
    return FullscreenButton_arrayWithHoles(arr) || FullscreenButton_iterableToArrayLimit(arr, i) || FullscreenButton_unsupportedIterableToArray(arr, i) || FullscreenButton_nonIterableRest();
}
function FullscreenButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FullscreenButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FullscreenButton_arrayLikeToArray(o, minLen);
}












var FullscreenButton = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = FullscreenButton_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var ref1 = FullscreenButton_slicedToArray((0,custom/* useIsFullscreen */.hb)(), 1), isFullscreen = ref1[0];
    var sendMessageToDriver = useIframeDriver().sendMessageToDriver;
    var handleClick = (0,react.useCallback)(FullscreenButton_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isFullscreen) {
                        sendMessageToDriver({
                            action: "request-exit-fullscreen"
                        });
                    } else {
                        sendMessageToDriver({
                            action: "request-fullscreen"
                        });
                    }
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isFullscreen,
        sendMessageToDriver
    ]);
    if (!daily_iframe_esm/* default.supportedBrowser */.ZP.supportedBrowser().supportsFullscreen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("fullscreen-button", {
            mobile: isMobile
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
            id: "fullscreen-toggle",
            variant: "ghost",
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                    children: isFullscreen ? t("general.exitFullscreen") : t("general.enterFullscreen")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenIcon, {
                    size: isMobile ? 32 : 24
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/FullscreenButton/index.ts



// EXTERNAL MODULE: ../shared/dist/hooks/useResizeObserver.js
var useResizeObserver = __webpack_require__(9782);
// EXTERNAL MODULE: ./node_modules/use-deep-compare/dist-web/index.js + 1 modules
var dist_web = __webpack_require__(7616);
// EXTERNAL MODULE: ./lib/query.ts
var lib_query = __webpack_require__(5184);
;// CONCATENATED MODULE: ./contexts/TracksProvider.tsx
function TracksProvider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TracksProvider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TracksProvider_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TracksProvider_arrayLikeToArray(arr);
}
function TracksProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TracksProvider_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TracksProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TracksProvider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function TracksProvider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TracksProvider_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TracksProvider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TracksProvider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TracksProvider_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TracksProvider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TracksProvider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TracksProvider_slicedToArray(arr, i) {
    return TracksProvider_arrayWithHoles(arr) || TracksProvider_iterableToArrayLimit(arr, i) || TracksProvider_unsupportedIterableToArray(arr, i) || TracksProvider_nonIterableRest();
}
function TracksProvider_toConsumableArray(arr) {
    return TracksProvider_arrayWithoutHoles(arr) || TracksProvider_iterableToArray(arr) || TracksProvider_unsupportedIterableToArray(arr) || TracksProvider_nonIterableSpread();
}
function TracksProvider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TracksProvider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TracksProvider_arrayLikeToArray(o, minLen);
}















/**
 * Maximum amount of concurrently subscribed or staged most recent speakers.
 */ var MAX_RECENT_SPEAKER_COUNT = 16;
/**
 * Threshold up to which all cams will be subscribed to or staged.
 * If the remote participant count passes this threshold,
 * cam subscriptions are defined by UI view modes.
 */ var SUBSCRIBE_OR_STAGE_ALL_VIDEO_THRESHOLD = 9;
var TracksContext = /*#__PURE__*/ (0,react.createContext)(null);
var maxCamSubscriptionsState = (0,es/* atom */.cn)({
    key: "max-cam-subscriptions",
    default: null
});
var useMaxCamSubscriptions = function() {
    return (0,es/* useRecoilValue */.sJ)(maxCamSubscriptionsState);
};
var TracksEffects = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var query = (0,router.useRouter)().query;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var optimizeLargeCalls = (0,useCallConfig/* useCallConfig */.A)().optimizeLargeCalls;
    var topology1 = (0,daily_react_esm/* useNetwork */.LN)().topology;
    var setMaxCamSubscriptions = (0,es/* useSetRecoilState */.Zl)(maxCamSubscriptionsState);
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var recentSpeakerIds = useRecentSpeakerIds();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var remoteParticipantIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "remote"
    });
    /**
   * Automatically update audio, screenAudio and screenVideo subscriptions.
   */ (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed() || !topology1) return;
        /**
     * A little throttling as we want daily-js to have some room to breathe ☺️
     */ var timeout = setTimeout(function() {
            var participants = daily.participants();
            var updates = remoteParticipantIds.reduce(function(u, id) {
                // Ignore undefined, local or screenshare participant ids
                if (!id || id === localSessionId) return u;
                var isSpeaker = recentSpeakerIds.includes(id) || !(0,lib_participants/* isParticipantTrackOff */.FD)(participants[id], "audio");
                var hasSubscribed = function(type) {
                    var ref, ref1, ref2;
                    return (ref = participants[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.tracks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[type]) === null || ref2 === void 0 ? void 0 : ref2.subscribed;
                };
                var isRelevant = orderedParticipantIds.includes(id);
                var shouldSubscribe = function(type) {
                    // If we're not in SFU, no track subscriptions!
                    if (topology1 !== "sfu") return true;
                    // When optimized for large calls (and in SFU) only subscribe to speakers.
                    if (optimizeLargeCalls && type === "audio" && breakoutStatus !== "ongoing" // during a breakout session we can't reliably determine a speaker
                    ) return isSpeaker;
                    // Otherwise only subscribe to relevant participants.
                    return isRelevant;
                };
                /**
         * Updates the subscription update object for the current participant and given track type.
         * @param type The track type to update the subscription for.
         */ var setSubscribedTrack = function(type) {
                    var _hasSubscribed = hasSubscribed(type);
                    var _shouldSubscribe = shouldSubscribe(type);
                    if (!_hasSubscribed && _shouldSubscribe || _hasSubscribed && !_shouldSubscribe) {
                        if (typeof u[id] !== "object") {
                            u[id] = {
                                setSubscribedTracks: {}
                            };
                        }
                        u[id].setSubscribedTracks[type] = _shouldSubscribe;
                    }
                };
                /**
         * In optimized calls:
         * - subscribe to speakers we're not subscribed to, yet
         * - unsubscribe from non-speakers we're subscribed to
         * In non-optimized calls:
         * - subscribe to all who we're not to subscribed to, yet
         */ setSubscribedTrack("audio");
                /**
         * Update screen subscriptions based on orderedParticipantIds.
         */ setSubscribedTrack("screenAudio");
                setSubscribedTrack("screenVideo");
                return u;
            }, {});
            if (Object.keys(updates).length === 0) return;
            daily.updateParticipants(updates);
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        breakoutStatus,
        daily,
        localSessionId,
        optimizeLargeCalls,
        orderedParticipantIds,
        recentSpeakerIds,
        remoteParticipantIds,
        topology1, 
    ]);
    /**
   * Notify user when pushed out of recent speakers queue.
   */ var showMutedMessage = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        var ref;
        if (!daily || !optimizeLargeCalls) return;
        if (recentSpeakerIds.some(function(id) {
            return id === localSessionId;
        })) {
            showMutedMessage.current = true;
            return;
        }
        if (showMutedMessage.current && !(0,lib_participants/* isParticipantTrackOff */.FD)((ref = daily.participants()) === null || ref === void 0 ? void 0 : ref.local, "audio")) {
            daily.setLocalAudio(false);
            addMessage({
                content: t("notification.micMutedAutomatically")
            });
            showMutedMessage.current = false;
        }
    }, [
        addMessage,
        daily,
        localSessionId,
        optimizeLargeCalls,
        recentSpeakerIds,
        t, 
    ]);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-joined", (0,react.useCallback)(function() {
        var _ref = TracksProvider_asyncToGenerator(runtime_default().mark(function _callee(evts) {
            var ref, ids, topology, updates;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ids = evts.map(function(ev) {
                            return ev.participant.session_id;
                        });
                        _ctx.next = 4;
                        return daily.getNetworkTopology();
                    case 4:
                        _ctx.t1 = ref = _ctx.sent;
                        _ctx.t0 = _ctx.t1 === null;
                        if (_ctx.t0) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.t0 = ref === void 0;
                    case 8:
                        if (!_ctx.t0) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.t2 = void 0;
                        _ctx.next = 13;
                        break;
                    case 12:
                        _ctx.t2 = ref.topology;
                    case 13:
                        topology = _ctx.t2;
                        updates = ids.reduce(function(o, id) {
                            if (topology === "peer") {
                                o[id] = {
                                    setSubscribedTracks: true
                                };
                            }
                            return o;
                        }, {});
                        if (!(Object.keys(updates).length === 0)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 17:
                        daily.updateParticipants(updates);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(evts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        daily
    ]));
    (0,react.useEffect)(function() {
        if (query.max_cam_subs) {
            var maxSubs = parseInt((0,lib_query/* getQueryParam */.P)("max_cam_subs", query), 10);
            if (maxSubs && !Number.isNaN(Math.abs(maxSubs))) {
                setMaxCamSubscriptions(maxSubs);
            }
        }
    }, [
        query,
        setMaxCamSubscriptions
    ]);
    (0,react.useEffect)(function() {
        if (optimizeLargeCalls) {
            setMaxCamSubscriptions(36);
        }
    }, [
        optimizeLargeCalls,
        setMaxCamSubscriptions
    ]);
    return null;
});
var TracksProvider = function(param) {
    var children = param.children;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var topology = (0,daily_react_esm/* useNetwork */.LN)().topology;
    var viewMode = (0,layout/* useViewMode */.mJ)();
    var recentSpeakerIds = useRecentSpeakerIds();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var remoteParticipantIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "remote"
    });
    var subscribeToCam = (0,react.useCallback)(function(id) {
        /**
       * Ignore undefined, local or screenshare.
       */ if (!id || id === localSessionId) return;
        daily.updateParticipant(id, {
            setSubscribedTracks: {
                video: true
            }
        });
    }, [
        daily,
        localSessionId
    ]);
    var lastSubscriptions = (0,react.useRef)({});
    /**
   * Updates cam subscriptions based on passed subscribedIds and stagedIds.
   * For ids not provided, cam tracks will be unsubscribed from.
   *
   * @param subscribedIds Participant ids whose cam tracks should be subscribed to.
   * @param stagedIds Participant ids whose cam tracks should be staged.
   */ var updateCamSubscriptions = (0,react.useCallback)(function(subscribedIds) {
        var stagedIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if (!daily) return;
        // If total number of remote participants is less than a threshold, simply
        // stage all remote cams that aren't already marked for subscription.
        // Otherwise, honor the provided stagedIds, with recent speakers appended
        // who aren't already marked for subscription.
        if (remoteParticipantIds.length <= SUBSCRIBE_OR_STAGE_ALL_VIDEO_THRESHOLD) {
            stagedIds = remoteParticipantIds.filter(function(id) {
                return !subscribedIds.includes(id);
            });
        } else {
            if (viewMode !== "grid") {
                var _stagedIds;
                (_stagedIds = stagedIds).push.apply(_stagedIds, TracksProvider_toConsumableArray(recentSpeakerIds.filter(function(id) {
                    return !subscribedIds.includes(id);
                })));
            }
        }
        // Assemble updates to get to desired cam subscriptions
        var updates = remoteParticipantIds.reduce(function(u, id) {
            var ref, ref3, ref4, ref5;
            var desiredSubscription;
            var currentSubscription = (ref = daily.participants()) === null || ref === void 0 ? void 0 : (ref3 = ref[id]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tracks) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.video) === null || ref5 === void 0 ? void 0 : ref5.subscribed;
            // Ignore undefined, local or screenshare participant ids
            if (!id || id === localSessionId) return u;
            // Decide on desired cam subscription for this participant:
            // subscribed, staged, or unsubscribed
            if (subscribedIds.includes(id) || topology !== "sfu") {
                desiredSubscription = true;
            } else if (stagedIds.includes(id)) {
                desiredSubscription = "staged";
            } else {
                desiredSubscription = false;
            }
            // Skip if we already have the desired subscription to this
            // participant's cam
            if (desiredSubscription === currentSubscription) return u;
            u[id] = {
                setSubscribedTracks: {
                    video: desiredSubscription
                }
            };
            return u;
        }, {});
        if (Object.keys(updates).length === 0) return;
        // Ignore API call if updates were already applied
        if (fast_deep_equal_default()(updates, lastSubscriptions.current)) return;
        lastSubscriptions.current = TracksProvider_objectSpread({}, updates);
        daily.updateParticipants(updates);
    }, [
        daily,
        localSessionId,
        remoteParticipantIds,
        recentSpeakerIds,
        topology,
        viewMode, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TracksContext.Provider, {
        value: {
            subscribeToCam: subscribeToCam,
            updateCamSubscriptions: updateCamSubscriptions
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TracksEffects, {})
        ]
    });
};
var useTracks = function() {
    return (0,react.useContext)(TracksContext);
};
var recentSpeakersState = (0,es/* atom */.cn)({
    key: "recent-speaker-ids",
    default: []
});
/**
 * Returns the ${MAX_RECENT_SPEAKER_COUNT} most recent speakers,
 * ordered by their most recent audio activity.
 */ var useRecentSpeakerIds = function() {
    var ref = TracksProvider_slicedToArray((0,es/* useRecoilState */.FV)(recentSpeakersState), 2), recentSpeakers = ref[0], setRecentSpeakers = ref[1];
    var activeSpeakerId = (0,daily_react_esm/* useActiveSpeakerId */.fu)();
    (0,react.useEffect)(function() {
        setRecentSpeakers(function(prevSpeakers) {
            return [
                activeSpeakerId, 
            ].concat(TracksProvider_toConsumableArray(prevSpeakers.filter(function(id) {
                return id !== activeSpeakerId;
            }))).filter(Boolean).slice(0, MAX_RECENT_SPEAKER_COUNT);
        });
    }, [
        activeSpeakerId,
        setRecentSpeakers
    ]);
    return (0,react.useMemo)(function() {
        return recentSpeakers;
    }, [
        recentSpeakers
    ]);
};

;// CONCATENATED MODULE: ./hooks/useActiveSpeaker.ts
function useActiveSpeaker_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useActiveSpeaker_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useActiveSpeaker_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useActiveSpeaker_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useActiveSpeaker_slicedToArray(arr, i) {
    return useActiveSpeaker_arrayWithHoles(arr) || useActiveSpeaker_iterableToArrayLimit(arr, i) || useActiveSpeaker_unsupportedIterableToArray(arr, i) || useActiveSpeaker_nonIterableRest();
}
function useActiveSpeaker_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useActiveSpeaker_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useActiveSpeaker_arrayLikeToArray(o, minLen);
}







/**
 * Convenience hook to contain all logic on determining the active speaker
 * (= the current one and only actively speaking person)
 */ var useActiveSpeaker = function() {
    var ref = useActiveSpeaker_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 1), showLocalVideo = ref[0];
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var activeSpeakerId = (0,daily_react_esm/* useActiveSpeakerId */.fu)({
        filter: (0,react.useCallback)(function(id) {
            var isRemoteSpeaker = orderedParticipantIds.includes(id);
            if (orderedParticipantIds.length) return isRemoteSpeaker && id !== localSessionId;
            return id === localSessionId;
        }, [
            localSessionId,
            orderedParticipantIds
        ])
    });
    var activeSpeakerAudioState = (0,daily_react_esm/* useParticipantProperty */.ou)(activeSpeakerId, "tracks.audio.state");
    var localAudioTrackState = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "tracks.audio.state");
    var ref1 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutParticipantIds = ref1.breakoutParticipantIds, hasJoinedBreakout = ref1.hasJoinedBreakout;
    var metaData = (0,ParticipantsProvider/* useParticipantMetaData */.Q)();
    var ref2 = useActiveSpeaker_slicedToArray((0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            return !p.local && breakoutParticipantIds.includes(p.session_id) && !(0,lib_participants/* isParticipantTrackOff */.FD)(p, "audio");
        }, [
            breakoutParticipantIds
        ]),
        sort: (0,react.useCallback)(function(a, b) {
            var metaA = metaData[a.session_id];
            var metaB = metaData[b.session_id];
            if ((metaA === null || metaA === void 0 ? void 0 : metaA.last_active_date) > (metaB === null || metaB === void 0 ? void 0 : metaB.last_active_date)) return 1;
            if ((metaA === null || metaA === void 0 ? void 0 : metaA.last_active_date) < (metaB === null || metaB === void 0 ? void 0 : metaB.last_active_date)) return -1;
            return 0;
        }, [
            metaData
        ])
    }), 1), breakoutSpeaker = ref2[0];
    if (hasJoinedBreakout) {
        return breakoutSpeaker !== null && breakoutSpeaker !== void 0 ? breakoutSpeaker : null;
    }
    // we don't show active speaker indicators EVER in a 1:1 call or when the user is alone in-call
    if (broadcastRole !== "attendee" && orderedParticipantIds.length < 2) return null;
    // active speaker as reported by daily-js is currently not in the list of participants of interest
    if (!orderedParticipantIds.includes(activeSpeakerId)) return null;
    if (!(0,lib_participants/* isTrackOff */.$T)(activeSpeakerAudioState)) {
        return activeSpeakerId;
    }
    /**
   * When the local video is displayed and the last known active speaker
   * is muted, we can only fall back to the local participant.
   */ return (0,lib_participants/* isTrackOff */.$T)(localAudioTrackState) || !showLocalVideo ? null : localSessionId;
};

;// CONCATENATED MODULE: ./hooks/useCamSubscriptions.ts


/**
 * Updates cam subscriptions based on passed subscribedIds and stagedIds.
 * @param subscribedIds Participant ids whose cam tracks should be subscribed to.
 * @param stagedIds Participant ids whose cam tracks should be staged.
 * @param throttle Delay in milliseconds. Default: 50
 */ var useCamSubscriptions = function(subscribedIds) {
    var stagedIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], throttle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 50;
    var updateCamSubscriptions = useTracks().updateCamSubscriptions;
    (0,dist_web/* useDeepCompareEffect */.KW)(function() {
        if (!subscribedIds || !stagedIds) return;
        var timeout = setTimeout(function() {
            updateCamSubscriptions(subscribedIds, stagedIds);
        }, throttle);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        subscribedIds,
        stagedIds,
        throttle,
        updateCamSubscriptions
    ]);
};

;// CONCATENATED MODULE: ./hooks/useVideoGrid.ts


var useVideoGrid = function(param) {
    var width = param.width, height = param.height, _gap = param.gap, gap = _gap === void 0 ? 1 : _gap, _tileAspectRatio = param.tileAspectRatio, tileAspectRatio = _tileAspectRatio === void 0 ? lib_constants/* DEFAULT_ASPECT_RATIO */.vr : _tileAspectRatio, _minTileWidth = param.minTileWidth, minTileWidth = _minTileWidth === void 0 ? 1 : _minTileWidth, sessionIds = param.sessionIds, _minCountPerPage = param.minCountPerPage, minCountPerPage = _minCountPerPage === void 0 ? 1 : _minCountPerPage, _maxCountPerPage = param.maxCountPerPage, maxCountPerPage = _maxCountPerPage === void 0 ? 25 : _maxCountPerPage;
    var ref = (0,react.useState)(1), currentPage = ref[0], setCurrentPage = ref[1];
    /**
   * Calculates the maximum amount of columns and rows,
   * based on the given width, height and minimum tile width.
   */ var ref1 = (0,react.useMemo)(function() {
        var columns = Math.max(1, Math.floor(width / minTileWidth));
        var widthPerTile = width / columns;
        var rows = Math.max(1, Math.floor(height / (widthPerTile / tileAspectRatio)));
        return [
            columns,
            rows
        ];
    }, [
        height,
        minTileWidth,
        tileAspectRatio,
        width
    ]), maxColumns = ref1[0], maxRows = ref1[1];
    /**
   * Calculates the amount of elements rendered per page.
   */ var pageSize = (0,react.useMemo)(function() {
        return Math.max(minCountPerPage, Math.min(maxColumns * maxRows, maxCountPerPage));
    }, [
        maxColumns,
        maxRows,
        maxCountPerPage,
        minCountPerPage
    ]);
    /**
   * Total amount of pages for pagination.
   */ var totalPages = (0,react.useMemo)(function() {
        return Math.ceil(sessionIds.length / pageSize);
    }, [
        pageSize,
        sessionIds.length
    ]);
    /**
   * Avoid page from overflowing pages.
   */ (0,react.useEffect)(function() {
        if (currentPage <= totalPages) return;
        setCurrentPage(totalPages);
    }, [
        currentPage,
        totalPages
    ]);
    /**
   * Calculate actual amount of columns and rows.
   * This method runs through different combinations of possible columns and rows,
   * and finds the combination with the highest amount of used space in pixels.
   */ var ref2 = (0,react.useMemo)(function() {
        var tileCount = Math.min(pageSize, sessionIds.length);
        if (tileCount === 0) return [
            width,
            height
        ];
        var getWidthByColumnCount = function(cols) {
            return Math.floor((width - gap * (cols - 1)) / cols);
        };
        var getHeightByRowCount = function(rows) {
            return Math.floor((height - gap * (rows - 1)) / rows);
        };
        var idealTileArea = width * height / tileCount;
        var idealTileWidth = Math.sqrt(idealTileArea * tileAspectRatio);
        var idealTileHeight = Math.sqrt(idealTileArea / tileAspectRatio);
        var roundedColumns = Math.round(width / idealTileWidth);
        var roundedRows = Math.round(height / idealTileHeight);
        var ceiledRows = Math.ceil(tileCount / roundedColumns);
        var ceiledColumns = Math.ceil(tileCount / roundedRows);
        var layoutWithColumnPriority = {
            area: tileCount * getWidthByColumnCount(roundedColumns) * getHeightByRowCount(ceiledRows),
            result: [
                roundedColumns,
                ceiledRows
            ]
        };
        var layoutWithRowPriority = {
            area: tileCount * getWidthByColumnCount(ceiledColumns) * getHeightByRowCount(roundedRows),
            result: [
                ceiledColumns,
                roundedRows
            ]
        };
        if (layoutWithColumnPriority.area > layoutWithRowPriority.area) return layoutWithColumnPriority.result;
        return layoutWithRowPriority.result;
    }, [
        gap,
        height,
        pageSize,
        sessionIds.length,
        tileAspectRatio,
        width
    ]), columns1 = ref2[0], rows1 = ref2[1];
    /**
   * Calculate the session ids rendered on the current, previous and next page.
   */ var currentIds = (0,react.useMemo)(function() {
        return sessionIds.length - currentPage * pageSize > 0 ? sessionIds.slice((currentPage - 1) * pageSize, currentPage * pageSize) : sessionIds.slice(-pageSize);
    }, [
        currentPage,
        pageSize,
        sessionIds
    ]);
    /**
   * Switches to next page, if available.
   */ var nextPage = (0,react.useCallback)(function() {
        return setCurrentPage(function(p) {
            return Math.min(totalPages, p + 1);
        });
    }, [
        totalPages
    ]);
    /**
   * Switches to previous page, if available.
   */ var prevPage = (0,react.useCallback)(function() {
        return setCurrentPage(function(p) {
            return Math.max(1, p - 1);
        });
    }, []);
    /**
   * Calculates the total width and height utilized by the tiles.
   */ var ref3 = (0,react.useMemo)(function() {
        var columnGap = gap * (columns1 - 1);
        var rowGap = gap * (rows1 - 1);
        var tileWidth = (width - columnGap) / columns1;
        var tileHeight = tileWidth / tileAspectRatio;
        if (rows1 * tileHeight + rowGap > height) {
            tileHeight = (height - rowGap) / rows1;
            tileWidth = tileHeight * tileAspectRatio;
        }
        return [
            Math.floor(tileWidth * columns1 + columnGap),
            Math.floor(tileHeight * rows1 + rowGap), 
        ];
    }, [
        columns1,
        gap,
        height,
        rows1,
        tileAspectRatio,
        width
    ]), containerWidth = ref3[0], containerHeight = ref3[1];
    return {
        columns: columns1,
        containerHeight: containerHeight,
        containerWidth: containerWidth,
        rows: rows1,
        currentIds: currentIds,
        nextPage: nextPage,
        prevPage: prevPage,
        currentPage: currentPage,
        totalPages: totalPages,
        pageSize: pageSize
    };
};

;// CONCATENATED MODULE: ./hooks/useVideoQuality.tsx
function useVideoQuality_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useVideoQuality_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useVideoQuality_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useVideoQuality_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useVideoQuality_slicedToArray(arr, i) {
    return useVideoQuality_arrayWithHoles(arr) || useVideoQuality_iterableToArrayLimit(arr, i) || useVideoQuality_unsupportedIterableToArray(arr, i) || useVideoQuality_nonIterableRest();
}
function useVideoQuality_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useVideoQuality_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useVideoQuality_arrayLikeToArray(o, minLen);
}

var videoQualityState = (0,es/* atom */.cn)({
    key: "video-quality",
    default: "auto"
});
var useVideoQuality = function() {
    var ref = useVideoQuality_slicedToArray((0,es/* useRecoilState */.FV)(videoQualityState), 2), videoQuality = ref[0], setVideoQuality = ref[1];
    return {
        videoQuality: videoQuality,
        setVideoQuality: setVideoQuality
    };
};

;// CONCATENATED MODULE: ./hooks/useDisplayName.ts



var useDisplayName = function(sessionId, showNames, network, name) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var userName = (0,daily_react_esm/* useParticipantProperty */.ou)(sessionId, "user_name");
    var hasPoorConnection = network === "very-low" && isLocal;
    var hasWeakConnection = network === "low" && isLocal;
    return (0,react.useMemo)(function() {
        if (!showNames) return "";
        if (name) return name;
        var displayName = userName || (isLocal ? t("people.you") : t("people.guest"));
        if (hasPoorConnection) {
            return t("people.usernamePoorCoonection", {
                displayName: displayName
            });
        }
        if (hasWeakConnection) {
            return t("people.usernameWeakNetwork", {
                displayName: displayName
            });
        }
        if (isLocal) {
            return t("people.youWithName", {
                displayName: userName || t("people.guest")
            });
        }
        return displayName;
    }, [
        hasPoorConnection,
        hasWeakConnection,
        isLocal,
        name,
        showNames,
        t,
        userName, 
    ]);
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/MetricsIcon.js
var MetricsIcon = __webpack_require__(5282);
// EXTERNAL MODULE: ../shared/dist/components/Portal/index.js
var Portal = __webpack_require__(5970);
// EXTERNAL MODULE: ../shared/dist/lib/colors.js
var lib_colors = __webpack_require__(5143);
// EXTERNAL MODULE: ./hooks/useScreens.ts
var useScreens = __webpack_require__(2275);
;// CONCATENATED MODULE: ./components/Tile/DebuggerAudioCanvas.tsx






var DebuggerAudioCanvas = function(param) {
    var isScreen = param.isScreen, sessionId = param.sessionId;
    var colors = (0,Theme.useTheme)().colors;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var audioCanvasRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref3, ref1;
        if (!daily) return;
        var participant = Object.values(daily.participants()).find(function(p) {
            return p.session_id === sessionId;
        });
        var audioTrack = isScreen ? participant === null || participant === void 0 ? void 0 : (ref3 = participant.tracks) === null || ref3 === void 0 ? void 0 : ref3.screenAudio : participant === null || participant === void 0 ? void 0 : (ref1 = participant.tracks) === null || ref1 === void 0 ? void 0 : ref1.audio;
        if (!(audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.persistentTrack)) return;
        var stream = new MediaStream([
            audioTrack.persistentTrack
        ]);
        var ref2;
        var audioCtx = (ref2 = window["dailyAudioContext"]) !== null && ref2 !== void 0 ? ref2 : window["audioContext"];
        var analyser = audioCtx.createAnalyser();
        var source = audioCtx.createMediaStreamSource(stream);
        source.connect(analyser);
        analyser.fftSize = 64;
        var bufferLength = analyser.frequencyBinCount;
        var dataArray = new Uint8Array(bufferLength);
        var frame;
        function draw() {
            if (!audioCanvasRef.current) return;
            var popover = audioCanvasRef.current.closest(".debug-data");
            audioCanvasRef.current.width = popover.clientWidth;
            audioCanvasRef.current.height = popover.clientHeight;
            var ref = audioCanvasRef.current.getBoundingClientRect(), height = ref.height, width = ref.width;
            var canvasCtx = audioCanvasRef.current.getContext("2d");
            canvasCtx.clearRect(0, 0, width, height);
            analyser.getByteFrequencyData(dataArray);
            var barWidth = (width - (bufferLength - 1)) / bufferLength;
            var x = 0;
            for(var i = 0; i < bufferLength; i++){
                var fill = dataArray[i] / 255;
                var barHeight = height * fill;
                canvasCtx.fillStyle = (0,lib_colors.hexToRgba)(colors.accent, fill);
                canvasCtx.fillRect(x, height - barHeight, barWidth, barHeight);
                x += barWidth + 1;
            }
            frame = requestAnimationFrame(draw);
        }
        draw();
        return function() {
            cancelAnimationFrame(frame);
        };
    }, [
        colors.accent,
        daily,
        isScreen,
        sessionId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
        ref: audioCanvasRef,
        className: "jsx-2bcaf0c7a0c380c4",
        children: (0,jsx_runtime.jsx)((styled_jsx_default()), {
            id: "2bcaf0c7a0c380c4",
            children: "canvas.jsx-2bcaf0c7a0c380c4{height:100%;left:0;opacity:.5;position:absolute;top:0;width:100%;z-index:-1}"
        })
    });
};

;// CONCATENATED MODULE: ./components/Tile/Debugger.tsx
function Debugger_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Debugger_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Debugger_arrayLikeToArray(arr);
}
function Debugger_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Debugger_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Debugger_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Debugger_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Debugger_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Debugger_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Debugger_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Debugger_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Debugger_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Debugger_toConsumableArray(arr) {
    return Debugger_arrayWithoutHoles(arr) || Debugger_iterableToArray(arr) || Debugger_unsupportedIterableToArray(arr) || Debugger_nonIterableSpread();
}
function Debugger_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Debugger_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Debugger_arrayLikeToArray(o, minLen);
}

















var Debugger = /*#__PURE__*/ (0,react.memo)(function(param) {
    var isScreen = param.isScreen, sessionId = param.sessionId;
    var ref9 = (0,Theme.useTheme)(), colors = ref9.colors, zIndex1 = ref9.zIndex;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ showModal = ref1[0], setShowModal = ref1[1];
    var debuggerRef = (0,react.useRef)(null);
    var popoverRef = (0,react.useRef)(null);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var userName = (0,daily_react_esm/* useParticipantProperty */.ou)(sessionId, "user_name");
    var handleClick = function() {
        return setShowModal(function(show) {
            return !show;
        });
    };
    var video = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(null), audioData = ref2[0], setAudioData = ref2[1];
    var ref3 = (0,react.useState)(null), videoData = ref3[0], setVideoData = ref3[1];
    var ref4 = (0,react.useState)(null), sessionData = ref4[0], setSessionData = ref4[1];
    var receiveSettings = (0,daily_react_esm/* useReceiveSettings */.NC)({
        id: sessionId
    }).receiveSettings;
    var screens = (0,useScreens/* useScreens */.O)();
    var screen = screens.find(function(s) {
        return s.session_id === sessionId;
    });
    var prebuiltDebuggerEnabled = (0,useDebugging/* useDebugging */.W)().prebuiltDebuggerEnabled;
    (0,react.useEffect)(function() {
        if (!daily || !prebuiltDebuggerEnabled) return;
        var tile = document.getElementById(isScreen ? screen === null || screen === void 0 ? void 0 : screen.screenId : sessionId);
        var lastTime = 0;
        var lastFrames = 0;
        var interval = setInterval(Debugger_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref10, ref5, ref6, ref7, ref8, participant, audioTrack, connected, videoTrack, playbackQuality, time, frames, fps;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        video.current = tile.querySelector("video");
                        participant = Object.values(daily.participants()).find(function(p) {
                            return p.session_id === sessionId;
                        });
                        audioTrack = isScreen ? participant === null || participant === void 0 ? void 0 : (ref10 = participant.tracks) === null || ref10 === void 0 ? void 0 : ref10.screenAudio : participant === null || participant === void 0 ? void 0 : (ref5 = participant.tracks) === null || ref5 === void 0 ? void 0 : ref5.audio;
                        connected = false;
                        connected = !!document.querySelector('.audioTracks audio[data-session-id="'.concat(sessionId, '"][data-audio-type="').concat(isScreen ? "screenAudio" : "audio", '"]'));
                        setAudioData({
                            connected: connected,
                            trackId: audioTrack === null || audioTrack === void 0 ? void 0 : (ref6 = audioTrack.persistentTrack) === null || ref6 === void 0 ? void 0 : ref6.id,
                            trackState: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.state
                        });
                        videoTrack = isScreen ? participant === null || participant === void 0 ? void 0 : (ref7 = participant.tracks) === null || ref7 === void 0 ? void 0 : ref7.screenVideo : participant === null || participant === void 0 ? void 0 : (ref8 = participant.tracks) === null || ref8 === void 0 ? void 0 : ref8.video;
                        if (video.current) {
                            _ctx.next = 11;
                            break;
                        }
                        setVideoData(function(vd) {
                            var ref;
                            return Debugger_objectSpread({}, vd, {
                                fps: 0,
                                renderedHeight: 0,
                                renderedWidth: 0,
                                trackId: videoTrack === null || videoTrack === void 0 ? void 0 : (ref = videoTrack.persistentTrack) === null || ref === void 0 ? void 0 : ref.id,
                                trackState: videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.state,
                                videoHeight: 0,
                                videoWidth: 0
                            });
                        });
                        return _ctx.abrupt("return");
                    case 11:
                        playbackQuality = video.current.getVideoPlaybackQuality();
                        time = video.current.currentTime;
                        frames = playbackQuality.totalVideoFrames;
                        fps = Math.round((frames - lastFrames) / (time - lastTime));
                        setVideoData(function(vd) {
                            var ref, ref11, ref12, ref13, ref14;
                            return Debugger_objectSpread({}, vd, {
                                fps: Number.isNaN(fps) ? 0 : fps,
                                renderedHeight: (ref = video.current) === null || ref === void 0 ? void 0 : ref.clientHeight,
                                renderedWidth: (ref11 = video.current) === null || ref11 === void 0 ? void 0 : ref11.clientWidth,
                                trackId: videoTrack === null || videoTrack === void 0 ? void 0 : (ref12 = videoTrack.persistentTrack) === null || ref12 === void 0 ? void 0 : ref12.id,
                                trackState: videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.state,
                                videoHeight: (ref13 = video.current) === null || ref13 === void 0 ? void 0 : ref13.videoHeight,
                                videoWidth: (ref14 = video.current) === null || ref14 === void 0 ? void 0 : ref14.videoWidth
                            });
                        });
                        lastTime = time;
                        lastFrames = frames;
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 1000);
        /**
       * Gets and stores initial session connection type information.
       */ var setInitialSessionData = function() {
            var _ref = Debugger_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref15, topology;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return daily.getNetworkTopology();
                        case 3:
                            topology = _ctx.sent.topology;
                            setSessionData({
                                connection: topology,
                                sfuWorker: topology === "sfu" ? (ref = rtcpeers) === null || ref === void 0 ? void 0 : (ref15 = ref.sfu) === null || ref15 === void 0 ? void 0 : ref15.workerId : null
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function setInitialSessionData() {
                return _ref.apply(this, arguments);
            };
        }();
        setInitialSessionData();
        return function() {
            clearInterval(interval);
            setShowModal(false);
        };
    }, [
        daily,
        isScreen,
        prebuiltDebuggerEnabled,
        screen === null || screen === void 0 ? void 0 : screen.screenId,
        sessionId
    ]);
    /**
     * Updates connection information based on network-connection events.
     */ (0,daily_react_esm/* useNetwork */.LN)({
        onNetworkConnection: (0,react.useCallback)(function(ev) {
            var ref, ref16;
            setSessionData({
                connection: ev.type,
                sfuWorker: ev.type === "sfu" ? (ref = rtcpeers) === null || ref === void 0 ? void 0 : (ref16 = ref.sfu) === null || ref16 === void 0 ? void 0 : ref16.workerId : null
            });
        }, [])
    });
    var bringToFront = (0,react.useCallback)(function() {
        var _Math;
        var popover = popoverRef.current;
        var highestZIndex = (_Math = Math).max.apply(_Math, Debugger_toConsumableArray(Array.from(document.querySelectorAll(".debug-data")).map(function(el) {
            return parseInt(window.getComputedStyle(el).zIndex, 10);
        })));
        var zIndex = parseInt(window.getComputedStyle(popover).zIndex, 10);
        if (zIndex < highestZIndex) {
            popover.style.zIndex = "".concat(highestZIndex + 1);
        }
    }, []);
    (0,react.useEffect)(function() {
        var _Math;
        var popover = popoverRef.current;
        if (!showModal || !popover) return;
        var currentX = null;
        var currentY = null;
        var debug = debuggerRef.current;
        var ref = debug.getBoundingClientRect(), left = ref.left, top = ref.top;
        var highestZIndex = (_Math = Math).max.apply(_Math, Debugger_toConsumableArray(Array.from(document.querySelectorAll(".debug-data")).map(function(el) {
            return parseInt(window.getComputedStyle(el).zIndex, 10);
        })));
        popover.style.top = "".concat(top + debug.clientHeight, "px");
        popover.style.left = "".concat(left, "px");
        popover.style.zIndex = "".concat(highestZIndex + 1);
        var handleDragStart = function(ev) {
            currentX = ev.clientX;
            currentY = ev.clientY;
            bringToFront();
        };
        var handleDrag = function(ev) {
            if (currentX === null) return;
            popover.style.left = "".concat(popover.offsetLeft + ev.clientX - currentX, "px");
            popover.style.top = "".concat(popover.offsetTop + ev.clientY - currentY, "px");
            currentX = ev.clientX;
            currentY = ev.clientY;
        };
        var handleDragEnd = function() {
            currentX = null;
            currentY = null;
        };
        var header = popover.querySelector("header");
        popover.addEventListener("click", bringToFront);
        header.addEventListener("mousedown", handleDragStart);
        header.addEventListener("touchstart", handleDragStart);
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("mouseup", handleDragEnd);
        return function() {
            popover.removeEventListener("click", bringToFront);
            header.removeEventListener("mousedown", handleDragStart);
            header.removeEventListener("touchstart", handleDragStart);
            document.removeEventListener("mousemove", handleDrag);
            document.removeEventListener("mouseup", handleDragEnd);
        };
    }, [
        bringToFront,
        showModal
    ]);
    if (!prebuiltDebuggerEnabled) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: debuggerRef,
        className: styled_jsx_default().dynamic([
            [
                "2f4279e127cfccf3",
                [
                    colors.background,
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                    colors.custom.mainAreaText,
                    zIndex1.tooltip,
                    colors.custom.mainAreaBg
                ]
            ]
        ]) + " " + (classnames_default()("debugger", {
            visible: showModal
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                id: "debugger-".concat(sessionId),
                onClick: handleClick,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsIcon/* MetricsIcon */.d, {
                        color: colors.baseText,
                        size: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: "Debug participant"
                    })
                ]
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal.Portal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: popoverRef,
                    className: styled_jsx_default().dynamic([
                        [
                            "2f4279e127cfccf3",
                            [
                                colors.background,
                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                colors.custom.mainAreaText,
                                zIndex1.tooltip,
                                colors.custom.mainAreaBg
                            ]
                        ]
                    ]) + " " + "debug-data",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DebuggerAudioCanvas, {
                            isScreen: isScreen,
                            sessionId: sessionId
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "2f4279e127cfccf3",
                                    [
                                        colors.background,
                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                        colors.custom.mainAreaText,
                                        zIndex1.tooltip,
                                        colors.custom.mainAreaBg
                                    ]
                                ]
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "2f4279e127cfccf3",
                                        [
                                            colors.background,
                                            (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                            (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                            colors.custom.mainAreaText,
                                            zIndex1.tooltip,
                                            colors.custom.mainAreaBg
                                        ]
                                    ]
                                ]) + " " + "close",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                    id: "debugger-close-".concat(sessionId),
                                    onClick: handleClick,
                                    variant: "ghost",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                            color: colors.custom.mainAreaText,
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                            children: "Close debugger"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            color: "inherit",
                            children: [
                                "Participant ID:",
                                " ",
                                isLocal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("abbr", {
                                    title: "local",
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: "\uD83C\uDFE0"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("abbr", {
                                    title: "remote",
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: "\uD83D\uDEF0"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: sessionId
                                })
                            ]
                        }),
                        isScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "inherit",
                            children: "Screen share"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            color: "inherit",
                            children: [
                                "Connection: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: sessionData === null || sessionData === void 0 ? void 0 : sessionData.connection
                                })
                            ]
                        }),
                        (sessionData === null || sessionData === void 0 ? void 0 : sessionData.connection) === "sfu" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            color: "inherit",
                            children: [
                                "SFU worker: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: sessionData.sfuWorker
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            color: "inherit",
                            children: [
                                "Name: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "2f4279e127cfccf3",
                                            [
                                                colors.background,
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                colors.custom.mainAreaText,
                                                zIndex1.tooltip,
                                                colors.custom.mainAreaBg
                                            ]
                                        ]
                                    ]),
                                    children: userName || "Guest"
                                })
                            ]
                        }),
                        audioData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (audioData === null || audioData === void 0 ? void 0 : audioData.trackId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Audio Track ID: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: audioData === null || audioData === void 0 ? void 0 : audioData.trackId
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Audio State: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: audioData === null || audioData === void 0 ? void 0 : audioData.trackState
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Audio DOM track playing: ",
                                        audioData.connected ? "\u2705" : "\u274C"
                                    ]
                                })
                            ]
                        }),
                        videoData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (videoData === null || videoData === void 0 ? void 0 : videoData.trackId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Video Track ID: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: videoData === null || videoData === void 0 ? void 0 : videoData.trackId
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Video State: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: videoData === null || videoData === void 0 ? void 0 : videoData.trackState
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Rendered size:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                videoData === null || videoData === void 0 ? void 0 : videoData.renderedWidth,
                                                "x",
                                                videoData === null || videoData === void 0 ? void 0 : videoData.renderedHeight
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Resolution:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                videoData === null || videoData === void 0 ? void 0 : videoData.videoWidth,
                                                "x",
                                                videoData === null || videoData === void 0 ? void 0 : videoData.videoHeight
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Frame rate: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: videoData === null || videoData === void 0 ? void 0 : videoData.fps
                                        })
                                    ]
                                }),
                                !isLocal && receiveSettings && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                    color: "inherit",
                                    children: [
                                        "Receive settings:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "2f4279e127cfccf3",
                                                    [
                                                        colors.background,
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                                                        colors.custom.mainAreaText,
                                                        zIndex1.tooltip,
                                                        colors.custom.mainAreaBg
                                                    ]
                                                ]
                                            ]),
                                            children: JSON.stringify(receiveSettings)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "2f4279e127cfccf3",
                dynamic: [
                    colors.background,
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8),
                    colors.custom.mainAreaText,
                    zIndex1.tooltip,
                    colors.custom.mainAreaBg
                ],
                children: ".debugger.__jsx-style-dynamic-selector{left:8px;opacity:0;pointer-events:none;position:absolute;top:8px;-webkit-transition:opacity.2s ease;-moz-transition:opacity.2s ease;-o-transition:opacity.2s ease;transition:opacity.2s ease}.tile:hover .debugger.__jsx-style-dynamic-selector,.debugger.visible.__jsx-style-dynamic-selector{opacity:1}.debugger.__jsx-style-dynamic-selector button{background:".concat(colors.background, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:4px}.debug-data.__jsx-style-dynamic-selector{background:").concat((0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8), ";border:1px solid ").concat((0,lib_colors.hexToRgba)(colors.custom.mainAreaBg, 0.8), ";-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;-webkit-box-shadow:0px 2px 8px rgba(0,0,0,.2);-moz-box-shadow:0px 2px 8px rgba(0,0,0,.2);box-shadow:0px 2px 8px rgba(0,0,0,.2);color:").concat(colors.custom.mainAreaText, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px;overflow:auto;padding:4px;pointer-events:visible;position:fixed;resize:both;z-index:").concat(zIndex1.tooltip, "}.debug-data.__jsx-style-dynamic-selector header.__jsx-style-dynamic-selector{background:").concat(colors.custom.mainAreaBg, ";cursor:move;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin:-4px;padding:4px;position:-webkit-sticky;position:sticky;top:-4px}.debug-data.__jsx-style-dynamic-selector .close.__jsx-style-dynamic-selector{margin-left:auto}.debug-data.__jsx-style-dynamic-selector abbr.__jsx-style-dynamic-selector{cursor:help}")
            })
        ]
    });
});
Debugger.displayName = "Debugger";

;// CONCATENATED MODULE: ./components/Tile/NoVideo.tsx





var NoVideo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var hasPoorConnection = param.hasPoorConnection, isScreen = param.isScreen, name = param.name, network = param.network;
    var colors = (0,Theme.useTheme)().colors;
    var noVideoText = (0,react.useMemo)(function() {
        var color = "inherit";
        if (network === "low") {
            color = "warning";
        }
        if (hasPoorConnection) {
            color = "error";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            color: color,
            /*#__PURE__*/ truncate: true,
            variant: "strong",
            children: name
        });
    }, [
        hasPoorConnection,
        name,
        network
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "72dda7053cf87b7f",
                [
                    colors.custom.mainAreaBgAccent,
                    colors.custom.mainAreaText
                ]
            ]
        ]) + " " + "noVideo",
        children: [
            isScreen ? null : noVideoText,
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "72dda7053cf87b7f",
                dynamic: [
                    colors.custom.mainAreaBgAccent,
                    colors.custom.mainAreaText
                ],
                children: ".noVideo.__jsx-style-dynamic-selector{background-color:".concat(colors.custom.mainAreaBgAccent, ";color:").concat(colors.custom.mainAreaText, ";left:50%;max-width:100%;padding:0 16px;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}")
            })
        ]
    });
});
NoVideo.displayName = "NoVideo";

// EXTERNAL MODULE: ../shared/dist/components/Icons/EllipsisIcon.js
var EllipsisIcon = __webpack_require__(5707);
// EXTERNAL MODULE: ../shared/dist/components/Menu/index.js
var Menu = __webpack_require__(2104);
// EXTERNAL MODULE: ../shared/dist/components/Icons/HiddenIcon.js
var HiddenIcon = __webpack_require__(3992);
// EXTERNAL MODULE: ../shared/dist/components/Icons/LowerHandIcon.js
var LowerHandIcon = __webpack_require__(2825);
// EXTERNAL MODULE: ../shared/dist/components/Icons/PinIcon.js
var PinIcon = __webpack_require__(756);
// EXTERNAL MODULE: ../shared/dist/components/Icons/StopScreenshareIcon.js
var StopScreenshareIcon = __webpack_require__(5233);
;// CONCATENATED MODULE: ./lib/state/modals.ts

var settingsViewState = (0,es/* atom */.cn)({
    key: "settings-view",
    default: null
});
/**
 * Used to control visibility and tabs for SettingsModal.
 */ var useSettingsView = function() {
    return (0,es/* useRecoilState */.FV)(settingsViewState);
};
var autoplayFailedModalState = (0,es/* atom */.cn)({
    key: "autoplay-failed-modal",
    default: false
});
/**
 * Used to control visibility of AutoPlayFailedModal.
 */ var useAutoplayFailedModal = function() {
    return (0,es/* useRecoilState */.FV)(autoplayFailedModalState);
};
var deviceInUseModalState = (0,es/* atom */.cn)({
    key: "device-in-use-modal",
    default: false
});
/**
 * Used to control visibility of DeviceInUseModal.
 */ var useDeviceInUseModal = function() {
    return (0,es/* useRecoilState */.FV)(deviceInUseModalState);
};
var deviceNotFoundModalState = (0,es/* atom */.cn)({
    key: "device-not-found-modal",
    default: false
});
/**
 * Used to control visibility of DeviceNotFoundModal.
 */ var useDeviceNotFoundModal = function() {
    return (0,es/* useRecoilState */.FV)(deviceNotFoundModalState);
};
var nameModalState = (0,es/* atom */.cn)({
    key: "name-modal-state",
    default: false
});
/**
 * Used to control visibility of NameModal.
 */ var useNameModal = function() {
    return (0,es/* useRecoilState */.FV)(nameModalState);
};
var startScreenshareModalState = (0,es/* atom */.cn)({
    key: "start-screenshare-modal-state",
    default: false
});
/**
 * Used to control visibility of StartScreenshareModal.
 */ var useStartScreenshareModal = function() {
    return (0,es/* useRecoilState */.FV)(startScreenshareModalState);
};
var screenshareErrorModalState = (0,es/* atom */.cn)({
    key: "screenshare-error-modal-state",
    default: null
});
/**
 * Used to control visibility of ScreenshareErrorModal.
 */ var useScreenshareErrorModal = function() {
    return (0,es/* useRecoilState */.FV)(screenshareErrorModalState);
};
var unblockPermissionsModalState = (0,es/* atom */.cn)({
    key: "unblock-modal-state",
    default: false
});
/**
 * Used to control visibility of UnblockPermissionsModal.
 */ var useUnblockPermissionsModal = function() {
    return (0,es/* useRecoilState */.FV)(unblockPermissionsModalState);
};
var muteAllModalState = (0,es/* atom */.cn)({
    key: "mute-all-modal-state",
    default: false
});
/**
 * Used to control visibility of MuteAllModal.
 */ var useMuteAllModal = function() {
    return (0,es/* useRecoilState */.FV)(muteAllModalState);
};
var appsModalState = (0,es/* atom */.cn)({
    key: "apps-modal-state",
    default: false
});
/**
 * Used to control visibility of AppsModal.
 */ var useAppsModal = function() {
    return (0,es/* useRecoilState */.FV)(appsModalState);
};

;// CONCATENATED MODULE: ./components/People/ParticipantMenu.tsx
function ParticipantMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ParticipantMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ParticipantMenu_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ParticipantMenu_arrayLikeToArray(arr);
}
function ParticipantMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParticipantMenu_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ParticipantMenu_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ParticipantMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParticipantMenu_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParticipantMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ParticipantMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ParticipantMenu_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ParticipantMenu_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ParticipantMenu_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ParticipantMenu_slicedToArray(arr, i) {
    return ParticipantMenu_arrayWithHoles(arr) || ParticipantMenu_iterableToArrayLimit(arr, i) || ParticipantMenu_unsupportedIterableToArray(arr, i) || ParticipantMenu_nonIterableRest();
}
function ParticipantMenu_toConsumableArray(arr) {
    return ParticipantMenu_arrayWithoutHoles(arr) || ParticipantMenu_iterableToArray(arr) || ParticipantMenu_unsupportedIterableToArray(arr) || ParticipantMenu_nonIterableSpread();
}
function ParticipantMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ParticipantMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ParticipantMenu_arrayLikeToArray(o, minLen);
}
























var ParticipantMenu = function(_param) {
    var onClose = _param.onClose, sessionId = _param.sessionId, menuProps = ParticipantMenu_objectWithoutProperties(_param, [
        "onClose",
        "sessionId"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref = ParticipantMenu_slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 1), showUserNameChangeUI = ref[0];
    var ref1 = ParticipantMenu_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), showLocalVideo = ref1[0], setShowLocalVideo = ref1[1];
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref2.broadcast, broadcastRole = ref2.broadcastRole, enableVideoProcessingUI = ref2.enableVideoProcessingUI;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref3 = ParticipantMenu_slicedToArray((0,ParticipantsProvider/* useParticipantMarkedForRemoval */.jU)(), 2), setParticipantMarkedForRemoval = ref3[1];
    var forceLowerHand = useForceLowerHand().forceLowerHand;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref4 = ParticipantMenu_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "owner",
        "video"
    ]), 2), isLocalOwner = ref4[0], isLocalVideoEnabled = ref4[1];
    var ref5 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutParticipantIds = ref5.breakoutParticipantIds, breakoutStatus = ref5.breakoutStatus, hasJoinedBreakout = ref5.hasJoinedBreakout, mainRoomParticipantIds = ref5.mainRoomParticipantIds;
    var filteredScreens = (0,useScreens/* useScreens */.O)();
    var filteredScreen = (0,react.useMemo)(function() {
        return filteredScreens.find(function(s) {
            return s.session_id === sessionId;
        });
    }, [
        filteredScreens,
        sessionId
    ]);
    // Grab all screens across breakout rooms so owners are able to stop them
    var screens = (0,daily_react_esm/* useScreenShare */.N2)().screens;
    var screen = (0,react.useMemo)(function() {
        return screens.find(function(s) {
            return s.session_id === sessionId;
        });
    }, [
        screens,
        sessionId
    ]);
    var ref6 = ParticipantMenu_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref6[0];
    var ref7 = ParticipantMenu_slicedToArray(useNameModal(), 2), setShowNameModal = ref7[1];
    var ref8 = ParticipantMenu_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), pinnedId = ref8[0], setPinnedId = ref8[1];
    var ref9 = ParticipantMenu_slicedToArray(useSettingsView(), 2), setSettingsView = ref9[1];
    var ref10 = (0,useStyleVariants/* useStyleVariants */._)(), iconVariant = ref10.iconVariant, textVariant = ref10.textVariant;
    var participantIds = (0,daily_react_esm/* useParticipantIds */.OV)();
    var ref11 = ParticipantMenu_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(sessionId, [
        "audio",
        "video",
        "owner"
    ]), 3), hasAudioEnabled = ref11[0], hasVideoEnabled = ref11[1], isOwner = ref11[2];
    var isLocal = sessionId === localSessionId;
    var userHasHandRaised = useHasHandRaised(sessionId);
    var pinLabel = (0,react.useMemo)(function() {
        var isPinned = pinnedId === sessionId;
        if (isLocal) {
            return isPinned ? t("people.unpinYourself") : t("people.pinYourself");
        }
        return isPinned ? t("people.unpinParticipant") : t("people.pinParticipant");
    }, [
        isLocal,
        sessionId,
        pinnedId,
        t
    ]);
    var handlePinClick = (0,react.useCallback)(function() {
        setPinnedId(sessionId);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose,
        sessionId,
        setPinnedId
    ]);
    var handleUnpinClick = function() {
        setPinnedId(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleRenameClick = function() {
        setShowNameModal(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleBackgroundEffectsClick = function() {
        setSettingsView("effects");
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleToggleSelfViewClick = function() {
        setShowLocalVideo(!showLocalVideo);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleMicMuteClick = function() {
        if (isLocal) {
            daily.setLocalAudio(!hasAudioEnabled);
        } else {
            daily.updateParticipant(sessionId, {
                setAudio: false
            });
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleCamMuteClick = function() {
        if (isLocal) {
            daily.setLocalVideo(!hasVideoEnabled);
        } else {
            daily.updateParticipant(sessionId, {
                setVideo: false
            });
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleStopScreenShareClick = function() {
        daily.sendAppMessage("stop-screen-share", sessionId);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleLowerHandByHost = (0,react.useCallback)(function() {
        forceLowerHand(sessionId);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        forceLowerHand,
        onClose,
        sessionId
    ]);
    var handleRemoveClick = function() {
        setParticipantMarkedForRemoval(sessionId);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var menuItems = [];
    // Rename
    if (isLocal) {
        var _menuItems;
        (_menuItems = menuItems).push.apply(_menuItems, ParticipantMenu_toConsumableArray(showUserNameChangeUI ? [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: textVariant,
                    children: t("people.rename")
                }),
                onClick: handleRenameClick
            }, 
        ] : []).concat(ParticipantMenu_toConsumableArray(enableVideoProcessingUI && !isMobile && broadcastRole !== "attendee" ? [
            {
                disabled: !isLocalVideoEnabled,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: !isLocalVideoEnabled ? "muted" : "default",
                    variant: textVariant,
                    children: t("video.backgroundEffects")
                }),
                onClick: handleBackgroundEffectsClick
            }, 
        ] : []), ParticipantMenu_toConsumableArray(broadcastRole !== "attendee" ? [
            {
                disabled: participantIds.length === 1,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenIcon/* HiddenIcon */._, {
                    size: iconVariant
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: participantIds.length === 1 ? "muted" : "default",
                    variant: textVariant,
                    children: showLocalVideo ? t("people.hideSelfView") : t("people.showSelfView")
                }),
                onClick: handleToggleSelfViewClick
            }, 
        ] : [])));
    }
    var isBroadcastOwner = broadcast && isLocalOwner && isOwner;
    var hasMutePermission = isLocalOwner && !isLocal;
    /**
   * Mute/Unmute microphone and camera
   * In OOB calls, attendees can't turn on their cam/mic so muting
   * doesn't need to be offered here.
   */ if (isBroadcastOwner || !broadcast && hasMutePermission) {
        if (!disableAudio) {
            menuItems.push({
                disabled: !hasAudioEnabled,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: !hasAudioEnabled ? "muted" : "default",
                    variant: textVariant,
                    children: t("audio.muteMicrophone")
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                    color: !hasAudioEnabled ? colors.supportiveText : "currentColor",
                    muted: true,
                    size: iconVariant
                }),
                onClick: handleMicMuteClick
            });
        }
        menuItems.push({
            disabled: !hasVideoEnabled,
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                color: !hasVideoEnabled ? "muted" : "default",
                variant: textVariant,
                children: t("video.muteCamera")
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                id: "mute-cam-".concat(sessionId),
                color: !hasVideoEnabled ? colors.supportiveText : "currentColor",
                muted: true,
                size: iconVariant,
                transition: false
            }),
            onClick: handleCamMuteClick
        });
    }
    // Allow host to lower a participant's hand
    if (isLocalOwner && !isLocal && userHasHandRaised) {
        menuItems.push({
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: textVariant,
                children: t("handRaising.lowerHand")
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LowerHandIcon/* LowerHandIcon */.P, {
                size: iconVariant
            }),
            onClick: handleLowerHandByHost
        });
    }
    // Stop screen share
    if (isLocalOwner && !isLocal && screen) {
        menuItems.push({
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: textVariant,
                children: t("screenShare.stopShare")
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StopScreenshareIcon/* StopScreenshareIcon */.C, {
                size: iconVariant
            }),
            onClick: handleStopScreenShareClick
        });
    }
    var isBroadcastNonAttendee = broadcast && isOwner;
    var isSameBreakoutRoom = breakoutStatus === "ongoing" ? hasJoinedBreakout ? breakoutParticipantIds.includes(sessionId) : mainRoomParticipantIds.includes(sessionId) : true;
    // In OOB calls, pinning is only available for owner tiles
    // Pinning is never available on mobile
    // In Breakout scenarios, pinning is only available for participants in the same room
    if (!isMobile && isSameBreakoutRoom && (!broadcast || isBroadcastNonAttendee)) {
        var disabled = isLocal && !showLocalVideo;
        // Pin / Unpin
        menuItems.push({
            disabled: disabled,
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                color: disabled ? "muted" : "default",
                variant: textVariant,
                children: pinLabel
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon/* PinIcon */.q, {
                size: iconVariant
            }),
            onClick: pinnedId === sessionId || pinnedId === (filteredScreen === null || filteredScreen === void 0 ? void 0 : filteredScreen.screenId) ? handleUnpinClick : handlePinClick
        });
    }
    // Remove from call
    if (isLocalOwner && !isLocal) {
        menuItems.push({
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                color: "error",
                variant: textVariant,
                children: t("people.removeFromCall")
            }),
            onClick: handleRemoveClick
        });
    }
    if (menuItems.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, ParticipantMenu_objectSpread({
        items: menuItems,
        onClose: onClose
    }, menuProps));
};


;// CONCATENATED MODULE: ./components/Tile/TileActions.tsx










var TileActions = function(param) {
    var _alignMenu = param.alignMenu, alignMenu = _alignMenu === void 0 ? "right" : _alignMenu, sessionId = param.sessionId;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,react.useState)(false), /*#__PURE__*/ showMenu = ref[0], setShowMenu = ref[1];
    var btnId = (0,react.useId)();
    var menuId = (0,react.useId)();
    var handleMenuClick = function() {
        return setShowMenu(true);
    };
    var handleMenuClose = function() {
        return setShowMenu(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "97cd5d7c59391f8b",
                [
                    colors.background
                ]
            ]
        ]) + " " + (classnames_default()("tile-actions", {
            showMenu: showMenu
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.MenuButton, {
                "aria-controls": menuId,
                id: btnId,
                onClick: handleMenuClick,
                open: showMenu,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {
                        color: colors.baseText,
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: t("people.showParticipantActions")
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantMenu, {
                align: alignMenu,
                "aria-labelledby": btnId,
                id: menuId,
                onClose: handleMenuClose,
                sessionId: sessionId
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "97cd5d7c59391f8b",
                dynamic: [
                    colors.background
                ],
                children: ".tile-actions.__jsx-style-dynamic-selector{background:".concat(colors.background, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;-webkit-box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);-moz-box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);opacity:0;position:absolute;right:8px;top:8px;-webkit-transition:opacity 150ms ease;-moz-transition:opacity 150ms ease;-o-transition:opacity 150ms ease;transition:opacity 150ms ease}.tile-actions.showMenu.__jsx-style-dynamic-selector{opacity:1}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/RaiseHandIcon.js
var RaiseHandIcon = __webpack_require__(3096);
// EXTERNAL MODULE: ../shared/dist/components/Icons/WarningIcon.js
var WarningIcon = __webpack_require__(8262);
;// CONCATENATED MODULE: ./components/Tile/MicMeter.tsx






var MicMeter = function(param) {
    var sessionId = param.sessionId;
    var colors = (0,Theme.useTheme)().colors;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var audioTrack = (0,daily_react_esm/* useAudioTrack */.Gg)(sessionId);
    var audioVolumeRef = (0,react.useRef)(null);
    var audioTrackForAudioLevel = (0,react.useMemo)(function() {
        if ( false || disableAudio) return null;
        return audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.persistentTrack;
    }, [
        audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.persistentTrack,
        disableAudio
    ]);
    (0,daily_react_esm/* useAudioLevel */.wk)(audioTrackForAudioLevel, (0,react.useCallback)(function(volume) {
        if (!audioVolumeRef.current) return;
        audioVolumeRef.current.style.setProperty("--volume", "".concat(Math.min(24, 2 * 24 * volume), "px"));
    }, []));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: audioVolumeRef,
        className: styled_jsx_default().dynamic([
            [
                "866cf6198a79d5",
                [
                    colors.accent
                ]
            ]
        ]) + " " + "volume",
        children: (0,jsx_runtime.jsx)((styled_jsx_default()), {
            id: "866cf6198a79d5",
            dynamic: [
                colors.accent
            ],
            /*#__PURE__*/ children: ".volume.__jsx-style-dynamic-selector{background:".concat(colors.accent, ";bottom:0;height:var(--volume);left:0;position:absolute;-webkit-transition:height.15s ease;-moz-transition:height.15s ease;-o-transition:height.15s ease;transition:height.15s ease;width:24px;z-index:1}")
        })
    });
};

;// CONCATENATED MODULE: ./components/Tile/TileInfo.tsx
















var TileInfo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _activeIndicator = param.activeIndicator, activeIndicator = _activeIndicator === void 0 ? "static" : _activeIndicator, _isLocal = param.isLocal, isLocal = _isLocal === void 0 ? false : _isLocal, name = param.name, sessionId = param.sessionId;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref = (0,Theme.useTheme)(), colors = ref.colors, isDarkMode = ref.isDarkMode;
    var audioTrackState = (0,daily_react_esm/* useParticipantProperty */.ou)(sessionId, "tracks.audio.state");
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var handRaisedQueueNumber = useHandRaisedQueue(sessionId);
    var isSafari15OrLower = (0,browserConfig/* isSafari */.G6)(1, 15);
    var hasNetworkIssues = isLocal && [
        "low",
        "very-low"
    ].includes(threshold);
    var NameText = (0,react.useMemo)(function() {
        if (!name) return null;
        var color = "white";
        var text = name;
        if (hasNetworkIssues) {
            switch(threshold){
                case "low":
                    color = "warning";
                    text = t("network.weakNetwork");
                    break;
                case "very-low":
                    color = "error";
                    text = t("network.poorConnection");
                    break;
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            className: "name",
            El: "div",
            color: color,
            variant: "strong",
            /*#__PURE__*/ truncate: true,
            children: text
        });
    }, [
        hasNetworkIssues,
        name,
        t,
        threshold
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "269c4c774e3cbd4a",
                [
                    colors.background,
                    colors.border,
                    colors.baseText,
                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                    colors.accent,
                    colors.accent,
                    colors.accentText
                ]
            ]
        ]) + " " + "tile-info",
        children: [
            !!handRaisedQueueNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "269c4c774e3cbd4a",
                        [
                            colors.background,
                            colors.border,
                            colors.baseText,
                            isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                            colors.accent,
                            colors.accent,
                            colors.accentText
                        ]
                    ]
                ]) + " " + (classnames_default()("hand-status", {
                    "hand-status-local": isLocal
                }) || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandIcon/* RaiseHandIcon */.s, {
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: styled_jsx_default().dynamic([
                            [
                                "269c4c774e3cbd4a",
                                [
                                    colors.background,
                                    colors.border,
                                    colors.baseText,
                                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                                    colors.accent,
                                    colors.accent,
                                    colors.accentText
                                ]
                            ]
                        ]) + " " + "queue-number",
                        children: handRaisedQueueNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "269c4c774e3cbd4a",
                        [
                            colors.background,
                            colors.border,
                            colors.baseText,
                            isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                            colors.accent,
                            colors.accent,
                            colors.accentText
                        ]
                    ]
                ]) + " " + "info",
                children: [
                    (hasNetworkIssues || !disableAudio) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "269c4c774e3cbd4a",
                                [
                                    colors.background,
                                    colors.border,
                                    colors.baseText,
                                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                                    colors.accent,
                                    colors.accent,
                                    colors.accentText
                                ]
                            ]
                        ]) + " " + (classnames_default()("mic", {
                            muted: (0,lib_participants/* isTrackOff */.$T)(audioTrackState)
                        }) || ""),
                        children: [
                            hasNetworkIssues && /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                                color: threshold === "low" ? colors.system.orange : colors.system.red,
                                size: 16
                            }),
                            !hasNetworkIssues && !disableAudio && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    activeIndicator === "meter" && !isSafari15OrLower && /*#__PURE__*/ (0,jsx_runtime.jsx)(MicMeter, {
                                        sessionId: sessionId
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                                        color: colors.system.white,
                                        muted: (0,lib_participants/* isTrackOff */.$T)(audioTrackState),
                                        size: 16
                                    })
                                ]
                            })
                        ]
                    }),
                    NameText
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "269c4c774e3cbd4a",
                dynamic: [
                    colors.background,
                    colors.border,
                    colors.baseText,
                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                    colors.accent,
                    colors.accent,
                    colors.accentText
                ],
                children: ".tile-info.__jsx-style-dynamic-selector{position:absolute;top:0;left:0;width:100%;height:100%}.hand-status.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:".concat(colors.background, ";-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;border:1px solid ").concat(colors.border, ";-webkit-box-shadow:0 4px 4px rgba(0,0,0,.25);-moz-box-shadow:0 4px 4px rgba(0,0,0,.25);box-shadow:0 4px 4px rgba(0,0,0,.25);color:").concat(colors.baseText, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:8px;left:0;margin:8px;padding:8px;position:absolute;top:0}.hand-status-local.__jsx-style-dynamic-selector{--blend:").concat(isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)", ";background:-webkit-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:-moz-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:-o-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:linear-gradient(0deg,var(--blend),var(--blend)),").concat(colors.accent, ";border-color:").concat(colors.accent, ";color:").concat(colors.accentText, "}.queue-number.__jsx-style-dynamic-selector{font-size:16px;font-variant-numeric:tabular-nums;font-weight:600;text-align:center}.info.__jsx-style-dynamic-selector{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;background:rgba(0,0,0,.6);bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:stretch;-webkit-justify-content:stretch;-moz-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;left:0;max-width:100%;position:absolute}.info.__jsx-style-dynamic-selector .mic.__jsx-style-dynamic-selector{margin-right:1px;min-width:24px}.info.__jsx-style-dynamic-selector .mic.__jsx-style-dynamic-selector,.info.__jsx-style-dynamic-selector .name{padding:4px}.info.__jsx-style-dynamic-selector .name{height:100%}.mic.__jsx-style-dynamic-selector svg{position:relative;z-index:2}")
            })
        ]
    });
});
TileInfo.displayName = "TileInfo";

;// CONCATENATED MODULE: ./components/Tile/Tile.tsx
function Tile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Tile_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Tile_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Tile_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
















var SM_TILE_MAX_WIDTH = 300;
var Tile = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var _activeIndicator = _param.activeIndicator, activeIndicator = _activeIndicator === void 0 ? "static" : _activeIndicator, alignActionsMenu = _param.alignActionsMenu, _aspectRatio = _param.aspectRatio, aspectRatio1 = _aspectRatio === void 0 ? lib_constants/* DEFAULT_ASPECT_RATIO */.vr : _aspectRatio, className = _param.className, _hideActions = _param.hideActions, hideActions = _hideActions === void 0 ? false : _hideActions, _ignoreAspectRatio = _param.ignoreAspectRatio, ignoreAspectRatio = _ignoreAspectRatio === void 0 ? false : _ignoreAspectRatio, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isScreen = _param.isScreen, isScreen = _isScreen === void 0 ? false : _isScreen, _isSpeaking = _param.isSpeaking, isSpeaking = _isSpeaking === void 0 ? false : _isSpeaking, name = _param.name, network = _param.network, sessionId = _param.sessionId, showNames = _param.showNames, _showReactions = _param.showReactions, showReactions = _showReactions === void 0 ? false : _showReactions, onVideoResize = _param.onVideoResize, _videoFit = _param.videoFit, videoFit = _videoFit === void 0 ? "contain" : _videoFit, props = Tile_objectWithoutProperties(_param, [
        "activeIndicator",
        "alignActionsMenu",
        "aspectRatio",
        "className",
        "hideActions",
        "ignoreAspectRatio",
        "isMobile",
        "isScreen",
        "isSpeaking",
        "name",
        "network",
        "sessionId",
        "showNames",
        "showReactions",
        "onVideoResize",
        "videoFit"
    ]);
    var ref;
    var ref1 = (0,Theme.useTheme)(), colors = ref1.colors, zIndex = ref1.zIndex;
    var prebuiltDebuggerEnabled = (0,useDebugging/* useDebugging */.W)().prebuiltDebuggerEnabled;
    var tileRef = (0,react.useRef)(null);
    var videoEl = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(aspectRatio1), /*#__PURE__*/ tileAspectRatio = ref2[0], setTileAspectRatio = ref2[1];
    var videoState = (0,daily_react_esm/* useMediaTrack */.R2)(sessionId, isScreen ? "screenVideo" : "video");
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var hasPoorConnection = network === "very-low" && isLocal;
    (0,react.useEffect)(function() {
        if (aspectRatio1 === tileAspectRatio) return;
        setTileAspectRatio(aspectRatio1);
    }, [
        aspectRatio1,
        tileAspectRatio
    ]);
    var displayName = useDisplayName(sessionId, showNames, network, name);
    /**
     * Update video aspect ratio if remote screen share window gets resized
     */ var handleVideoResize = (0,react.useCallback)(function(param) {
        var aspectRatio = param.aspectRatio;
        if (isScreen) setTileAspectRatio(aspectRatio);
        onVideoResize === null || onVideoResize === void 0 ? void 0 : onVideoResize(aspectRatio);
    }, [
        isScreen,
        onVideoResize
    ]);
    /**
     * Set up resize observer to update noVideo font styles
     */ var updateNoVideoFontStyles = (0,react.useCallback)(function() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (ref = tileRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
        if (document.hidden || !tileRef.current) return;
        if (!tileRef.current.classList.contains("noVideo")) return;
        var noVideoText = tileRef.current.querySelector(".noVideo strong");
        var shouldRenderSmallText = width < SM_TILE_MAX_WIDTH;
        if (!noVideoText) return;
        noVideoText.style.fontSize = isMobile ? (0,pxToRem.pxToRem)(16) : shouldRenderSmallText ? (0,pxToRem.pxToRem)(12) : (0,pxToRem.pxToRem)(20);
        noVideoText.style.lineHeight = isMobile ? (0,pxToRem.pxToRem)(20) : shouldRenderSmallText ? (0,pxToRem.pxToRem)(16) : (0,pxToRem.pxToRem)(24);
    }, [
        isMobile
    ]);
    (0,useResizeObserver.useResizeObserver)(tileRef, updateNoVideoFontStyles);
    (0,react.useEffect)(function() {
        if (!videoState.isOff) return;
        updateNoVideoFontStyles();
    }, [
        updateNoVideoFontStyles,
        videoState.isOff
    ]);
    var reactionsSessionIds = (0,react.useMemo)(function() {
        return [
            sessionId
        ];
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", Tile_objectSpread({
        ref: tileRef,
        id: "".concat(sessionId).concat(isScreen ? "-screen" : "")
    }, props, {
        className: styled_jsx_default().dynamic([
            [
                "3bbeebbcce289801",
                [
                    colors.custom.mainAreaBgAccent,
                    zIndex.sideNav,
                    colors.system.yellow
                ]
            ],
            [
                "e4c75e21248abc1",
                [
                    100 / tileAspectRatio
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()("tile", className, videoFit, {
            local: isLocal,
            ignoreAR: ignoreAspectRatio,
            isScreenshare: isScreen,
            noVideo: videoState.isOff
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "3bbeebbcce289801",
                        [
                            colors.custom.mainAreaBgAccent,
                            zIndex.sideNav,
                            colors.system.yellow
                        ]
                    ],
                    [
                        "e4c75e21248abc1",
                        [
                            100 / tileAspectRatio
                        ]
                    ]
                ]) + " " + "content",
                children: [
                    showReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "3bbeebbcce289801",
                                [
                                    colors.custom.mainAreaBgAccent,
                                    zIndex.sideNav,
                                    colors.system.yellow
                                ]
                            ],
                            [
                                "e4c75e21248abc1",
                                [
                                    100 / tileAspectRatio
                                ]
                            ]
                        ]) + " " + "tile-reactions",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                            animation: "fadeIn",
                            sessionIds: reactionsSessionIds
                        })
                    }),
                    videoState.isOff ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoVideo, {
                        hasPoorConnection: hasPoorConnection,
                        isScreen: isScreen,
                        name: displayName,
                        network: network
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(daily_react_esm/* DailyVideo */.E5, {
                        ref: videoEl,
                        automirror: true,
                        fit: videoFit,
                        onResize: handleVideoResize,
                        sessionId: sessionId,
                        type: isScreen ? "screenVideo" : "video"
                    }),
                    !isScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TileInfo, {
                        activeIndicator: activeIndicator,
                        isLocal: isLocal,
                        name: !videoState.isOff && showNames ? displayName : null,
                        sessionId: sessionId
                    }),
                    isSpeaking && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "presentation",
                        className: styled_jsx_default().dynamic([
                            [
                                "3bbeebbcce289801",
                                [
                                    colors.custom.mainAreaBgAccent,
                                    zIndex.sideNav,
                                    colors.system.yellow
                                ]
                            ],
                            [
                                "e4c75e21248abc1",
                                [
                                    100 / tileAspectRatio
                                ]
                            ]
                        ]) + " " + "activeBorder"
                    }),
                    !hideActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(TileActions, {
                        alignMenu: alignActionsMenu,
                        sessionId: sessionId
                    }),
                    prebuiltDebuggerEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Debugger, {
                        isScreen: isScreen,
                        sessionId: sessionId
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "e4c75e21248abc1",
                dynamic: [
                    100 / tileAspectRatio
                ],
                children: ".tile.__jsx-style-dynamic-selector:not(.ignoreAR) .content.__jsx-style-dynamic-selector{padding-bottom:".concat(100 / tileAspectRatio, "%}")
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "3bbeebbcce289801",
                dynamic: [
                    colors.custom.mainAreaBgAccent,
                    zIndex.sideNav,
                    colors.system.yellow
                ],
                children: ".tile.__jsx-style-dynamic-selector{background-color:".concat(colors.custom.mainAreaBgAccent, ";min-width:1px;overflow:hidden;position:relative;width:100%}.tile.ignoreAR.__jsx-style-dynamic-selector,.tile.ignoreAR.__jsx-style-dynamic-selector .content.__jsx-style-dynamic-selector{height:100%;width:100%}.tile.__jsx-style-dynamic-selector video{height:-webkit-calc(100% + 4px);height:-moz-calc(100% + 4px);height:calc(100% + 4px);left:-2px;-o-object-position:center;object-position:center;position:absolute;top:-2px;width:-webkit-calc(100% + 4px);width:-moz-calc(100% + 4px);width:calc(100% + 4px)}.tile.__jsx-style-dynamic-selector .content.__jsx-style-dynamic-selector .tile-reactions{left:50%;position:absolute;top:50%;-webkit-transform:translate(50%,-50%);-moz-transform:translate(50%,-50%);-ms-transform:translate(50%,-50%);-o-transform:translate(50%,-50%);transform:translate(50%,-50%);z-index:").concat(zIndex.sideNav, "}.tile.noVideo.__jsx-style-dynamic-selector video{visibility:hidden}.activeBorder.__jsx-style-dynamic-selector{border:2px solid ").concat(colors.system.yellow, ";height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.tile.__jsx-style-dynamic-selector:focus-within .tile-actions,.tile.__jsx-style-dynamic-selector:hover .tile-actions{opacity:1}")
            })
        ]
    }));
});

Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./components/Tile/index.ts


// EXTERNAL MODULE: ../shared/dist/components/Icons/CaretLeftIcon.js
var CaretLeftIcon = __webpack_require__(3513);
// EXTERNAL MODULE: ../shared/dist/components/Icons/CaretRightIcon.js
var CaretRightIcon = __webpack_require__(8029);
;// CONCATENATED MODULE: ./components/GridView/PaginationButton.tsx










var PaginationButton = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick, variant = param.variant;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,Theme.useTheme)(), colors = ref.colors, zIndex = ref.zIndex;
    var Icon = variant === "prev" ? CaretLeftIcon.CaretLeftIcon : CaretRightIcon.CaretRightIcon;
    var label = variant === "prev" ? t("general.prev") : t("general.next");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4f75e2b8ccd0d022",
                [
                    zIndex.menu,
                    colors.background
                ]
            ]
        ]) + " " + (classnames_default()("pagination-btn", variant) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                id: "pagination-".concat(variant),
                className: robotsClassName("btn-pagination-".concat(variant)),
                disabled: disabled,
                onClick: onClick,
                variant: "secondary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        size: 24,
                        variant: "default",
                        className: styled_jsx_default().dynamic([
                            [
                                "4f75e2b8ccd0d022",
                                [
                                    zIndex.menu,
                                    colors.background
                                ]
                            ]
                        ])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        El: "span",
                        /*#__PURE__*/ children: label
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4f75e2b8ccd0d022",
                dynamic: [
                    zIndex.menu,
                    colors.background
                ],
                children: ".pagination-btn.__jsx-style-dynamic-selector{--dur:150ms;--ease:ease-in-out;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;position:absolute;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);z-index:".concat(zIndex.menu, "}.pagination-btn.prev.__jsx-style-dynamic-selector{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;left:0}.pagination-btn.next.__jsx-style-dynamic-selector{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;right:0}.pagination-btn.__jsx-style-dynamic-selector button{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:").concat(colors.background, ";border:none;-webkit-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);-moz-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);padding:0;-webkit-transition:opacity var(--dur)var(--ease),padding var(--dur)var(--ease),width var(--dur)var(--ease);-moz-transition:opacity var(--dur)var(--ease),padding var(--dur)var(--ease),width var(--dur)var(--ease);-o-transition:opacity var(--dur)var(--ease),padding var(--dur)var(--ease),width var(--dur)var(--ease);transition:opacity var(--dur)var(--ease),padding var(--dur)var(--ease),width var(--dur)var(--ease);width:24px}.pagination-btn.prev.__jsx-style-dynamic-selector button{-webkit-border-radius:0 4px 4px 0;-moz-border-radius:0 4px 4px 0;border-radius:0 4px 4px 0;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.pagination-btn.next.__jsx-style-dynamic-selector button{-webkit-border-radius:4px 0 0 4px;-moz-border-radius:4px 0 0 4px;border-radius:4px 0 0 4px;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.pagination-btn.__jsx-style-dynamic-selector button[disabled]{opacity:.2}.pagination-btn.__jsx-style-dynamic-selector svg{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none}.pagination-btn.__jsx-style-dynamic-selector span{-webkit-flex-shrink:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;opacity:0;overflow:hidden;-webkit-transition:opacity var(--dur)var(--ease);-moz-transition:opacity var(--dur)var(--ease);-o-transition:opacity var(--dur)var(--ease);transition:opacity var(--dur)var(--ease)}.pagination-btn.prev.__jsx-style-dynamic-selector button:not([disabled]):focus-visible,.pagination-btn.prev.__jsx-style-dynamic-selector button:not([disabled]):hover{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding:4px 8px 4px 0;width:100%}.pagination-btn.next.__jsx-style-dynamic-selector button:not([disabled]):focus-visible,.pagination-btn.next.__jsx-style-dynamic-selector button:not([disabled]):hover{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding:4px 0 4px 8px;width:100%}.pagination-btn.__jsx-style-dynamic-selector button:not([disabled]):focus-visible span,.pagination-btn.__jsx-style-dynamic-selector button:not([disabled]):hover span{opacity:1}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GridView/GridView.tsx
function GridView_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GridView_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function GridView_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return GridView_arrayLikeToArray(arr);
}
function GridView_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GridView_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function GridView_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GridView_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GridView_slicedToArray(arr, i) {
    return GridView_arrayWithHoles(arr) || GridView_iterableToArrayLimit(arr, i) || GridView_unsupportedIterableToArray(arr, i) || GridView_nonIterableRest();
}
function GridView_toConsumableArray(arr) {
    return GridView_arrayWithoutHoles(arr) || GridView_iterableToArray(arr) || GridView_unsupportedIterableToArray(arr) || GridView_nonIterableSpread();
}
function GridView_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GridView_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GridView_arrayLikeToArray(o, minLen);
}





















var GAP = 1;
var MIN_TILE_WIDTH = 280;
var GridView = function(param) {
    var participantIds = param.participantIds;
    var query = (0,router.useRouter)().query;
    var ref12 = GridView_slicedToArray((0,custom/* useMaxGridTilesPerPage */.lW)(), 1), maxGridTilesPerPage = ref12[0];
    var ref1 = GridView_slicedToArray((0,custom/* useMinGridTilesPerPage */.by)(), 1), minGridTilesPerPage = ref1[0];
    var ref2 = GridView_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref2[0];
    var videoQuality = useVideoQuality().videoQuality;
    var ref3 = GridView_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 1), showLocalVideo = ref3[0];
    var ref4 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref4.broadcastRole, enableEmojiReactions = ref4.enableEmojiReactions, enablePIPUI = ref4.enablePIPUI;
    var swapParticipantPosition = (0,ParticipantsProvider/* useParticipants */.BL)().swapParticipantPosition;
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var participantMetaData = (0,ParticipantsProvider/* useParticipantMetaData */.Q)();
    var maxCamSubscriptions = useMaxCamSubscriptions();
    var activeSpeakerId = useActiveSpeaker();
    var gridRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)({
        width: 1,
        height: 1
    }), /*#__PURE__*/ dimensions = ref5[0], setDimensions = ref5[1];
    var ref6 = (0,react.useState)(maxGridTilesPerPage), maxTilesPerPage = ref6[0], setMaxTilesPerPage = ref6[1];
    var ref7 = (0,daily_react_esm/* useNetwork */.LN)(), threshold = ref7.threshold, topology = ref7.topology;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var shouldRenderLocalVideo = (0,react.useMemo)(function() {
        return showLocalVideo && broadcastRole !== "attendee" || participantIds.length === 0;
    }, [
        broadcastRole,
        participantIds.length,
        showLocalVideo
    ]);
    var sessionIds = (0,react.useMemo)(function() {
        return GridView_toConsumableArray(shouldRenderLocalVideo ? [
            localSessionId
        ] : []).concat(GridView_toConsumableArray(participantIds));
    }, [
        localSessionId,
        participantIds,
        shouldRenderLocalVideo
    ]);
    /**
   * Update max tiles per page from ps query param.
   */ (0,react.useEffect)(function() {
        if (query.ps) {
            var tiles = parseInt((0,lib_query/* getQueryParam */.P)("ps", query), 10);
            if (tiles && !Number.isNaN(Math.abs(tiles))) {
                setMaxTilesPerPage(tiles);
            }
        }
    }, [
        query
    ]);
    (0,useResizeObserver.useResizeObserver)(gridRef, (0,react.useCallback)(function(width, height) {
        setDimensions({
            width: Math.floor(width),
            height: Math.floor(height)
        });
    }, []));
    var ref8 = useVideoGrid({
        width: dimensions.width,
        height: dimensions.height,
        minTileWidth: MIN_TILE_WIDTH,
        gap: GAP,
        sessionIds: sessionIds,
        maxCountPerPage: maxTilesPerPage,
        minCountPerPage: minGridTilesPerPage
    }), columns = ref8.columns, containerHeight = ref8.containerHeight, containerWidth = ref8.containerWidth, currentIds = ref8.currentIds, currentPage = ref8.currentPage, nextPage = ref8.nextPage, pageSize = ref8.pageSize, prevPage = ref8.prevPage, totalPages = ref8.totalPages;
    /**
   * Update track subscriptions based on pagination
   */ var camSubscriptions = (0,react.useMemo)(function() {
        var maxSubs = maxCamSubscriptions ? Math.max(maxCamSubscriptions, pageSize) : 3 * pageSize;
        // Determine participant ids to subscribe to or stage, based on page.
        var renderedOrBufferedIds;
        switch(currentPage){
            // First page
            case 1:
                renderedOrBufferedIds = sessionIds.slice(0, Math.min(maxSubs, 2 * pageSize));
                break;
            // Last page
            case Math.ceil(sessionIds.length / pageSize):
                renderedOrBufferedIds = sessionIds.slice(-Math.min(maxSubs, 2 * pageSize));
                break;
            // Any other page
            default:
                {
                    var buffer = Math.floor((maxSubs - pageSize) / 2);
                    var min = Math.max(0, (currentPage - 1) * pageSize - buffer);
                    var max = Math.min(sessionIds.length, currentPage * pageSize + buffer);
                    renderedOrBufferedIds = sessionIds.slice(min, max);
                }
                break;
        }
        var subscribedIds = [];
        var stagedIds = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Decide whether to subscribe to or stage participants' track based on
            // visibility
            for(var _iterator = renderedOrBufferedIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                if (id !== localSessionId) {
                    if (currentIds.includes(id)) {
                        subscribedIds.push(id);
                    } else {
                        stagedIds.push(id);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        /**
     * For PIP in Safari, when the user is in grid view,
     * but the active speaker is not rendered,
     * we'll want to keep our subscription to the speaker's video.
     */ if (enablePIPUI && (0,browserConfig/* isSafari */.G6)() && !subscribedIds.includes(currentSpeakerId)) {
            subscribedIds.push(currentSpeakerId);
        }
        return {
            subscribedIds: subscribedIds,
            stagedIds: stagedIds
        };
    }, [
        currentIds,
        currentSpeakerId,
        enablePIPUI,
        localSessionId,
        maxCamSubscriptions,
        currentPage,
        pageSize,
        sessionIds, 
    ]);
    useCamSubscriptions(camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.subscribedIds, camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.stagedIds);
    var updateReceiveSettings = (0,daily_react_esm/* useReceiveSettings */.NC)().updateReceiveSettings;
    /**
   * Set bandwidth layer based on amount of visible participants,
   * network conditions or desired video quality.
   */ (0,react.useEffect)(function() {
        if (topology !== "sfu") return;
        var timeout = setTimeout(function() {
            var count = currentIds.length;
            // less than 5 participants? return 2
            // less than 10 participants? return 1
            // more than 10 participants? return 0;
            var layer = count < 5 ? 2 : count < 10 ? 1 : 0;
            var hasPoorNetwork = [
                "low",
                "very-low"
            ].includes(threshold);
            var wantsLowQuality = [
                "bandwidth-saver",
                "low"
            ].includes(videoQuality);
            var receiveSettings = currentIds.reduce(function(settings, id) {
                if (id === localSessionId) return settings;
                if (hasPoorNetwork || wantsLowQuality) {
                    settings[id] = {
                        video: {
                            layer: 0
                        }
                    };
                } else {
                    settings[id] = {
                        video: {
                            layer: layer
                        }
                    };
                }
                return settings;
            }, {});
            if (Object.keys(receiveSettings).length === 0) return;
            updateReceiveSettings(receiveSettings);
        }, 250);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        currentIds,
        threshold,
        localSessionId,
        topology,
        updateReceiveSettings,
        videoQuality, 
    ]);
    /**
   * Handle position updates based on active speaker events
   */ var sortedVisibleRemoteParticipantIds = (0,dist_web/* useDeepCompareMemo */.NY)(function() {
        return currentIds.slice(shouldRenderLocalVideo ? 1 : 0).sort(function(a, b) {
            var ref, ref9;
            var ref10;
            var lastActiveA = (ref10 = (ref = participantMetaData[a]) === null || ref === void 0 ? void 0 : ref.last_active_date) !== null && ref10 !== void 0 ? ref10 : new Date("1970-01-01");
            var ref11;
            var lastActiveB = (ref11 = (ref9 = participantMetaData[b]) === null || ref9 === void 0 ? void 0 : ref9.last_active_date) !== null && ref11 !== void 0 ? ref11 : new Date("1970-01-01");
            if (lastActiveA > lastActiveB) return 1;
            if (lastActiveA < lastActiveB) return -1;
            return 0;
        });
    }, [
        currentIds,
        participantMetaData,
        shouldRenderLocalVideo
    ]);
    (0,react.useEffect)(function() {
        if (!activeSpeakerId) return;
        // active participant is already visible
        if (currentIds.some(function(id) {
            return id === activeSpeakerId;
        })) return;
        // active participant is not part of this grid view
        if (!participantIds.includes(activeSpeakerId)) return;
        // ignore repositioning when viewing page > 1
        if (currentPage > 1) return;
        /**
     * We can now assume that
     * a) the user is looking at page 1
     * b) the most recent active participant is not visible on page 1
     * c) we'll have to promote the most recent participant's position to page 1
     *
     * To achieve that, we'll have to
     * - find the least recent active participant on page 1
     * - swap least & most recent active participant's position via setParticipantPosition
     */ if (!sortedVisibleRemoteParticipantIds.length) return;
        swapParticipantPosition(sortedVisibleRemoteParticipantIds[0], activeSpeakerId);
    }, [
        activeSpeakerId,
        currentIds,
        currentPage,
        participantIds,
        sortedVisibleRemoteParticipantIds,
        swapParticipantPosition, 
    ]);
    var tiles1 = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("tiles", Theme.DARK_THEME_CLASS),
            children: currentIds.map(function(id) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                    isSpeaking: id === activeSpeakerId,
                    network: id === localSessionId ? threshold : null,
                    sessionId: id,
                    showNames: showNames,
                    showReactions: enableEmojiReactions
                }, id);
            })
        });
    }, [
        activeSpeakerId,
        currentIds,
        enableEmojiReactions,
        localSessionId,
        showNames,
        threshold, 
    ]);
    /**
   * Update grid custom properties.
   */ (0,react.useEffect)(function() {
        if (!gridRef.current) return;
        gridRef.current.style.setProperty("--grid-gap", "".concat(GAP, "px"));
        gridRef.current.style.setProperty("--grid-columns", columns.toString());
        gridRef.current.style.setProperty("--grid-width", "".concat(containerWidth, "px"));
        gridRef.current.style.setProperty("--grid-height", "".concat(containerHeight, "px"));
    }, [
        columns,
        containerHeight,
        containerWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: gridRef,
        className: "jsx-2cb80eec292e8c16" + " " + "grid",
        children: [
            totalPages > 1 && currentPage > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                onClick: prevPage,
                variant: "prev"
            }),
            tiles1,
            totalPages > 1 && currentPage < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                onClick: nextPage,
                variant: "next"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "2cb80eec292e8c16",
                children: ".grid.jsx-2cb80eec292e8c16{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:100%}.grid.jsx-2cb80eec292e8c16 .tiles{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row wrap;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;gap:var(--grid-gap,1px);max-height:var(--grid-height,100%);max-width:var(--grid-width,100%);-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;overflow:hidden;-webkit-transition:height 100ms ease,width 100ms ease;-moz-transition:height 100ms ease,width 100ms ease;-o-transition:height 100ms ease,width 100ms ease;transition:height 100ms ease,width 100ms ease;width:100%}.grid.jsx-2cb80eec292e8c16 .tiles .tile{max-width:-webkit-calc(100%/var(--grid-columns,1) - var(--grid-gap));max-width:-moz-calc(100%/var(--grid-columns,1) - var(--grid-gap));max-width:calc(100%/var(--grid-columns,1) - var(--grid-gap))}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GridView/index.ts


// EXTERNAL MODULE: ../shared/dist/components/Anchor/index.js
var Anchor = __webpack_require__(757);
// EXTERNAL MODULE: ../shared/dist/hooks/useResize.js
var useResize = __webpack_require__(4605);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(1190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__(4634);
;// CONCATENATED MODULE: ./components/PoweredByDailyBanner/PoweredByDailyBanner.tsx








var PoweredByDailyBanner = function() {
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,react.useState)(false), /*#__PURE__*/ isVisible = ref[0], setIsVisible = ref[1];
    var bannerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setIsVisible(true);
        return function() {
            document.body.style.removeProperty("--banner-height");
        };
    }, []);
    (0,useResize.useResize)((0,react.useCallback)(function() {
        if (!bannerRef.current || !isVisible) return;
        document.body.style.setProperty("--banner-height", "".concat(bannerRef.current.clientHeight, "px"));
    }, [
        isVisible
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: {
                        opacity: 0,
                        y: "-100%"
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 0.25,
                        ease: "easeOut"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: bannerRef,
                        className: styled_jsx_default().dynamic([
                            [
                                "14537fa28a63ead7",
                                [
                                    colors.system.greyDark
                                ]
                            ]
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            color: "white",
                            children: [
                                "Powered by",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                                    href: "https://daily.co",
                                    underline: true,
                                    children: "Daily"
                                })
                            ]
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "14537fa28a63ead7",
                dynamic: [
                    colors.system.greyDark
                ],
                children: "div.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:".concat(colors.system.greyDark, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:6px 8px 8px;width:100%}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/PoweredByDailyBanner/index.ts


// EXTERNAL MODULE: ../shared/dist/components/FocusTrap/index.js
var FocusTrap = __webpack_require__(3615);
// EXTERNAL MODULE: ../shared/dist/components/Tabs/index.js
var Tabs = __webpack_require__(5431);
// EXTERNAL MODULE: ../shared/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(9802);
// EXTERNAL MODULE: ../../node_modules/tinykeys/dist/tinykeys.module.js
var tinykeys_module = __webpack_require__(2328);
;// CONCATENATED MODULE: ./hooks/useMountTransition.ts

/**
 * This hook helps signaling and synchronizing animations to the lifecycle,
 * depending if components / HTML are mounted.
 * https://letsbuildui.dev/articles/how-to-animate-mounting-content-in-react
 *
 * @param isMounted Indicates if the component / markup is mounted and rendered into the DOM
 * @param unmountDelay Amount of time in milliseconds to wait for the unmount transition to finish
 * @returns
 */ var useMountTransition = function(isMounted, unmountDelay) {
    var ref = (0,react.useState)(false), hasTransitionedIn = ref[0], setHasTransitionedIn = ref[1];
    (0,react.useEffect)(function() {
        var timeoutId;
        if (isMounted && !hasTransitionedIn) {
            // Mounting process
            setHasTransitionedIn(true);
        } else if (!isMounted && hasTransitionedIn) {
            // Unmounting process
            timeoutId = setTimeout(function() {
                return setHasTransitionedIn(false);
            }, unmountDelay);
        }
        return function() {
            clearTimeout(timeoutId);
        };
    }, [
        unmountDelay,
        isMounted,
        hasTransitionedIn
    ]);
    return hasTransitionedIn;
};

// EXTERNAL MODULE: ../shared/dist/components/Checkbox/index.js
var Checkbox = __webpack_require__(8889);
// EXTERNAL MODULE: ../shared/dist/components/Form/index.js
var Form = __webpack_require__(7509);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-virtual/build/lib/index.mjs
var lib = __webpack_require__(6811);
;// CONCATENATED MODULE: ./components/BreakoutRooms/ContentContainer.tsx
function ContentContainer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentContainer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentContainer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ContentContainer_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ContentContainer_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ContentContainer_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var ContentContainer = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, className = _param.className, innerHeight = _param.innerHeight, props = ContentContainer_objectWithoutProperties(_param, [
        "children",
        "className",
        "innerHeight"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", ContentContainer_objectSpread({
        ref: ref
    }, props, {
        className: "jsx-ebaa0dab256d192c" + " " + (props && props.className != null && props.className || classnames_default()("content-container", className) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: innerHeight
                },
                className: "jsx-ebaa0dab256d192c" + " " + "content-inner",
                /*#__PURE__*/ children: children
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ebaa0dab256d192c",
                children: ".content-container.jsx-ebaa0dab256d192c{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow-x:hidden;overflow-y:auto;padding:var(--card-spacing);position:relative}.content-inner.jsx-ebaa0dab256d192c{min-height:100%;position:relative}"
            })
        ]
    }));
});

ContentContainer.displayName = "ContentContainer";

;// CONCATENATED MODULE: ./components/BreakoutRooms/CtaButtonContainer.tsx




var CtaButtonContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-409fd40e516909c5" + " " + "cta",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                /*#__PURE__*/ noBorder: true,
                shadow: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-409fd40e516909c5" + " " + "cta-inner",
                        children: children
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "409fd40e516909c5",
                children: ".cta.jsx-409fd40e516909c5{border-top:1px solid var(--card-border);-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.cta-inner.jsx-409fd40e516909c5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useRoomMapping.tsx
function useRoomMapping_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useRoomMapping_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useRoomMapping_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useRoomMapping_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useRoomMapping_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useRoomMapping_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useRoomMapping_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useRoomMapping_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useRoomMapping_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useRoomMapping_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useRoomMapping_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useRoomMapping_slicedToArray(arr, i) {
    return useRoomMapping_arrayWithHoles(arr) || useRoomMapping_iterableToArrayLimit(arr, i) || useRoomMapping_unsupportedIterableToArray(arr, i) || useRoomMapping_nonIterableRest();
}
function useRoomMapping_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useRoomMapping_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRoomMapping_arrayLikeToArray(o, minLen);
}






/**
 * Contains key-value pairs, where a key is a participant's session_id
 * and the value is the assigned breakouts room id.
 */ var roomMappingState = (0,es/* atom */.cn)({
    key: "room-mapping",
    default: {}
});
var sortNames = function(a, b) {
    if (a.local || b.local) return 1;
    if (a.user_name.toLowerCase() > b.user_name.toLowerCase()) return 1;
    if (a.user_name.toLowerCase() < b.user_name.toLowerCase()) return -1;
    return 0;
};
var useRoomMapping = function() {
    var currentRoomMapping = (0,es/* useRecoilValue */.sJ)(roomMappingState);
    var moveParticipants = useBreakouts().moveParticipants;
    var allParticipantIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        sort: sortNames
    });
    /**
   * Returns a list of participant ids for a breakout room, identified by roomId.
   * Pass MAIN_ROOM_IDENTIFIER to get participants in main room.
   * @param roomId string The identifier for the room.
   * @returns string[]
   */ var getRoomMappingByRoomId = (0,react.useCallback)(function(roomId) {
        var assignedIds = Object.entries(currentRoomMapping).filter(function(param) {
            var _param = useRoomMapping_slicedToArray(param, 2), _$roomId = _param[1];
            return _$roomId !== constants/* MAIN_ROOM_IDENTIFIER */.b;
        }).map(function(param) {
            var _param = useRoomMapping_slicedToArray(param, 1), sessionId = _param[0];
            return sessionId;
        });
        if (roomId === constants/* MAIN_ROOM_IDENTIFIER */.b) {
            return allParticipantIds.filter(function(id) {
                return !assignedIds.includes(id);
            });
        }
        return allParticipantIds.filter(function(id) {
            return (currentRoomMapping === null || currentRoomMapping === void 0 ? void 0 : currentRoomMapping[id]) === roomId;
        });
    }, [
        allParticipantIds,
        currentRoomMapping
    ]);
    /**
   * Map a participant, identified by sessionId, to a breakout room, identified by roomId.
   * @param sessionId string The participant's sessionId.
   * @param roomId string The breakout room's identifier.
   */ var updateRoomMapping = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(sessionId, roomId) {
            set(roomMappingState, function(state) {
                var newState = useRoomMapping_objectSpread({}, state);
                newState[sessionId] = roomId;
                return newState;
            });
        };
    }, []);
    /**
   * Resets all assignments. This will cause participants to be forced back into the main room.
   */ var resetRoomMapping = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(roomMappingState, function() {
                return {};
            });
        };
    }, []);
    var publishRoomMapping = (0,react.useCallback)(function() {
        moveParticipants(currentRoomMapping);
    }, [
        currentRoomMapping,
        moveParticipants
    ]);
    /**
   * Updates local room mapping state to what is currently stored in session state.
   */ var syncRoomMappingFromSessionState = (0,es/* useRecoilCallback */._8)(function(param1) {
        var set = param1.set;
        return useRoomMapping_asyncToGenerator(runtime_default().mark(function _callee() {
            var data, ref, newMapping, ref1, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                        ;
                        newMapping = {};
                        ;
                        Object.entries((ref1 = data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.mapping) !== null && ref1 !== void 0 ? ref1 : {}).forEach(function(param) {
                            var _param = useRoomMapping_slicedToArray(param, 2), roomId = _param[0], users = _param[1].users;
                            users.forEach(function(userId) {
                                newMapping[userId] = roomId;
                            });
                        });
                        set(roomMappingState, newMapping);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    }, []);
    return {
        currentRoomMapping: currentRoomMapping,
        getRoomMappingByRoomId: getRoomMappingByRoomId,
        publishRoomMapping: publishRoomMapping,
        resetRoomMapping: resetRoomMapping,
        syncRoomMappingFromSessionState: syncRoomMappingFromSessionState,
        updateRoomMapping: updateRoomMapping
    };
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useSelectParticipant.tsx
function useSelectParticipant_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSelectParticipant_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useSelectParticipant_arrayLikeToArray(arr);
}
function useSelectParticipant_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useSelectParticipant_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSelectParticipant_toConsumableArray(arr) {
    return useSelectParticipant_arrayWithoutHoles(arr) || useSelectParticipant_iterableToArray(arr) || useSelectParticipant_unsupportedIterableToArray(arr) || useSelectParticipant_nonIterableSpread();
}
function useSelectParticipant_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSelectParticipant_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSelectParticipant_arrayLikeToArray(o, minLen);
}

var selectedParticipantsState = (0,es/* atom */.cn)({
    key: "selected-participants",
    default: []
});
var isSelectedState = (0,es/* selectorFamily */.CG)({
    key: "is-selected-participant",
    get: function(id) {
        return function(param) {
            var get = param.get;
            var selectedIds = get(selectedParticipantsState);
            return selectedIds.includes(id);
        };
    }
});
var useIsSelected = function(id) {
    return (0,es/* useRecoilValue */.sJ)(isSelectedState(id));
};
var useSelectParticipant = function() {
    var selectedParticipants = (0,es/* useRecoilValue */.sJ)(selectedParticipantsState);
    var selectParticipant = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(sessionId) {
            set(selectedParticipantsState, function(state) {
                return useSelectParticipant_toConsumableArray(state).concat([
                    sessionId
                ]);
            });
        };
    }, []);
    var deselectParticipant = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(sessionId) {
            set(selectedParticipantsState, function(state) {
                return state.filter(function(id) {
                    return id !== sessionId;
                });
            });
        };
    }, []);
    var selectAllParticipants = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(participants) {
            set(selectedParticipantsState, participants);
        };
    }, []);
    var deselectAllParticipants = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(selectedParticipantsState, []);
        };
    }, []);
    return {
        selectParticipant: selectParticipant,
        deselectParticipant: deselectParticipant,
        selectAllParticipants: selectAllParticipants,
        deselectAllParticipants: deselectAllParticipants,
        selectedParticipants: selectedParticipants
    };
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useDragAndDrop.tsx


var useDragAndDrop = function() {
    var ref = useSelectParticipant(), deselectParticipant = ref.deselectParticipant, selectedParticipants = ref.selectedParticipants;
    var updateRoomMapping = useRoomMapping().updateRoomMapping;
    var dragParticipant = function(event) {
        event.preventDefault();
    };
    var dropParticipant = function(event) {
        event.stopPropagation();
        var participantId = event.dataTransfer.getData("text/plain");
        var roomIdentifier = event.currentTarget.dataset.roomIdentifier;
        // doing a group drop! And we want to deselect them when they're dropped.
        if (selectedParticipants.length > 0) {
            selectedParticipants.map(function(id) {
                updateRoomMapping(id, roomIdentifier);
                deselectParticipant(id);
            });
            return;
        }
        updateRoomMapping(participantId, roomIdentifier);
    };
    return {
        dragParticipant: dragParticipant,
        dropParticipant: dropParticipant
    };
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/hooks/useRooms.ts
function useRooms_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useRooms_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useRooms_arrayLikeToArray(arr);
}
function useRooms_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useRooms_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useRooms_toConsumableArray(arr) {
    return useRooms_arrayWithoutHoles(arr) || useRooms_iterableToArray(arr) || useRooms_unsupportedIterableToArray(arr) || useRooms_nonIterableSpread();
}
function useRooms_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useRooms_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRooms_arrayLikeToArray(o, minLen);
}



var generateDefaultRooms = function() {
    return useRooms_toConsumableArray(Array(constants/* DEFAULT_AMOUNT_OF_ROOMS */.n)).map(function() {
        return (0,v4/* default */.Z)();
    });
};
var roomsState = (0,es/* atom */.cn)({
    key: "rooms-state",
    default: generateDefaultRooms()
});
var useRooms = function() {
    var rooms = (0,es/* useRecoilValue */.sJ)(roomsState);
    var addRoom = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(newRoomId) {
            set(roomsState, function(state) {
                return useRooms_toConsumableArray(state).concat([
                    newRoomId
                ]);
            });
        };
    }, []);
    var deleteRoom = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(roomIdentifier) {
            set(roomsState, function(state) {
                return state.filter(function(roomId) {
                    return roomId !== roomIdentifier;
                });
            });
        };
    }, []);
    /* We need to generate a new unique ID for room 1 everytime a new breakout session is started.
   * Normally, we'd use "reset" to reset the room state. Doing so however will return the same UUID
   * for room 1 in the new session -- that UUID generated when this hook is first called is its default and
   * won't change. This causes issues with the chat: anyone will be able to read the chat messages
   * in room 1, since its roomId persists over the entirety of the call.
   */ var deleteAllRooms = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(roomsState, generateDefaultRooms);
        };
    }, []);
    return {
        addRoom: addRoom,
        deleteAllRooms: deleteAllRooms,
        deleteRoom: deleteRoom,
        rooms: rooms
    };
};

// EXTERNAL MODULE: ../shared/dist/components/Input/index.js
var Input = __webpack_require__(3765);
;// CONCATENATED MODULE: ./components/BreakoutRooms/NumberOfRoomsField.tsx










var NumberOfRoomsField = function(param) {
    var participantIds = param.participantIds;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = useRooms(), addRoom = ref.addRoom, deleteRoom = ref.deleteRoom, rooms = ref.rooms;
    var ref1 = useRoomMapping(), getRoomMappingByRoomId = ref1.getRoomMappingByRoomId, updateRoomMapping = ref1.updateRoomMapping;
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var amountOfRooms = rooms.length;
    var ref3 = (0,react.useState)(amountOfRooms.toString()), inputValue = ref3[0], setInputValue = ref3[1];
    /**
   * When amount of rooms change (e.g. via room deletion), update Input value.
   */ (0,react.useEffect)(function() {
        setInputValue(amountOfRooms.toString());
    }, [
        amountOfRooms
    ]);
    var handleChange = function(ev) {
        setInputValue(ev.target.value);
        var newAmount = Number(ev.target.valueAsNumber);
        setHasError(false);
        if (isNaN(newAmount)) {
            return;
        }
        // deleting rooms
        if (newAmount < amountOfRooms) {
            for(var i = newAmount; i < amountOfRooms; i++){
                var participants = getRoomMappingByRoomId(rooms[i]);
                participants === null || participants === void 0 ? void 0 : participants.map(function(participant) {
                    updateRoomMapping(participant, constants/* MAIN_ROOM_IDENTIFIER */.b);
                });
                deleteRoom(rooms[i]);
            }
        } else {
            // adding rooms
            for(var i1 = 0; i1 < newAmount - amountOfRooms; i1++){
                addRoom((0,v4/* default */.Z)());
            }
        }
    };
    var handleBlur = function() {
        setHasError(amountOfRooms === 0);
    };
    var minParticipantsPerRoom = Math.floor(participantIds.length / rooms.length);
    var maxParticipantsPerRoom = Math.ceil(participantIds.length / rooms.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        gap: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                El: "label",
                htmlFor: "rooms",
                variant: "strong",
                children: t("breakouts.numberOfRooms")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                type: "number",
                id: "rooms",
                inputMode: "numeric",
                pattern: "[0-9]*",
                value: inputValue,
                min: "1",
                step: "1",
                name: "rooms",
                required: true,
                error: hasError,
                onBlur: handleBlur,
                onChange: handleChange
            }),
            hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                El: "p",
                color: "error",
                variant: "small",
                children: t("breakouts.errorRoomsMin")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                El: "p",
                variant: "small",
                children: minParticipantsPerRoom === maxParticipantsPerRoom ? t("breakouts.peoplePerRoom", {
                    count: minParticipantsPerRoom
                }) : t("breakouts.peoplePerRoomMinMax", {
                    min: minParticipantsPerRoom,
                    max: maxParticipantsPerRoom
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/ArchiveIcon.js
var ArchiveIcon = __webpack_require__(218);
// EXTERNAL MODULE: ../shared/dist/components/Select/index.js
var Select = __webpack_require__(6296);
;// CONCATENATED MODULE: ./components/BreakoutRooms/helpers/lib.ts
var shuffleArray = function(arr) {
    var count = arr.length, random, temp;
    while(count){
        random = Math.random() * count-- | 0;
        temp = arr[count];
        arr[count] = arr[random];
        arr[random] = temp;
    }
    return arr;
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/CheckIcon.js
var CheckIcon = __webpack_require__(7886);
;// CONCATENATED MODULE: ./components/BreakoutRooms/Participant.tsx











var Participant = function(param) {
    var disabled = param.disabled, participant = param.participant;
    var displayName = useDisplayName(participant, true);
    var ref = useSelectParticipant(), deselectParticipant = ref.deselectParticipant, selectedParticipants = ref.selectedParticipants, selectParticipant = ref.selectParticipant;
    var isSelected = useIsSelected(participant);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var fontFamilies = (0,Theme.useTheme)().fontFamilies;
    var imageRef = (0,react.useRef)(null);
    var multipleDragElement = document.getElementById("drag-image");
    (0,react.useEffect)(function() {
        // setDragImage in Safari is pretty buggy. In Chrome and Firefox, we can use
        // a regular div element as a ghost image when multiple participants are selected.
        // In Safari, we need to do some canvas tricks.
        if (!(0,browserConfig/* isSafari */.G6)() && selectedParticipants.length < 2) return;
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = 100;
        canvas.height = 100;
        // make canvas look acceptable
        var canvasContext = canvas.getContext("2d");
        canvasContext.fillRect(0, 0, 0, 0);
        canvasContext.fillStyle = "white";
        canvasContext.font = "42px ".concat(fontFamilies.regular);
        canvasContext.fillText("\uD83D\uDC65", 20, 60);
        // make canvas into an image that is accepted by setDragImage
        var image = new Image();
        image.src = canvas.toDataURL();
        imageRef.current = image;
    }, [
        fontFamilies.regular,
        selectedParticipants.length
    ]);
    var handleDrag = function(event) {
        // when multiple participants are selected, drag them all
        if (selectedParticipants.length > 1) {
            if ((0,browserConfig/* isSafari */.G6)()) {
                event.dataTransfer.setDragImage(imageRef.current, 0, 0);
            } else {
                event.dataTransfer.setDragImage(multipleDragElement, multipleDragElement.getBoundingClientRect().x, multipleDragElement.getBoundingClientRect().y);
            }
            return;
        }
        // only one participant is selected: no need to set a drag image
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", participant);
    };
    var onClick = function() {
        isSelected ? deselectParticipant(participant) : selectParticipant(participant);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: styled_jsx_default().dynamic([
            [
                "76233d16274bffc1",
                [
                    fontFamilies.regular
                ]
            ]
        ]) + " " + "participant",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "breakouts-participant-".concat(participant),
                "data-session-id": participant,
                /*#__PURE__*/ draggable: true,
                iconBefore: isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon.CheckIcon, {
                    size: 14
                }) : undefined,
                onClick: onClick,
                onDragStart: handleDrag,
                type: "button",
                title: disabled ? t("breakouts.participantDisabled", {
                    name: displayName
                }) : displayName,
                disabled: disabled,
                variant: isSelected ? "primary" : "secondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "span",
                    color: "inherit",
                    truncate: true,
                    children: displayName
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "76233d16274bffc1",
                dynamic: [
                    fontFamilies.regular
                ],
                children: ".participant.__jsx-style-dynamic-selector{display:inline-block;max-width:100%}.participant.__jsx-style-dynamic-selector .button{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:1px solid transparent;font-family:".concat(fontFamilies.regular, ";max-width:100%;padding:8px 12px;pointer-events:auto}.participant.__jsx-style-dynamic-selector .button[disabled]{cursor:not-allowed;pointer-events:none}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/Room.tsx
function Room_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Room_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Room_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Room_arrayLikeToArray(arr);
}
function Room_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Room_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Room_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Room_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Room_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Room_slicedToArray(arr, i) {
    return Room_arrayWithHoles(arr) || Room_iterableToArrayLimit(arr, i) || Room_unsupportedIterableToArray(arr, i) || Room_nonIterableRest();
}
function Room_toConsumableArray(arr) {
    return Room_arrayWithoutHoles(arr) || Room_iterableToArray(arr) || Room_unsupportedIterableToArray(arr) || Room_nonIterableSpread();
}
function Room_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Room_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Room_arrayLikeToArray(o, minLen);
}






















var Room = function(param) {
    var onChangeSelect = param.onChangeSelect, onDragOver = param.onDragOver, onDrop = param.onDrop, onResize = param.onResize, roomIdentifier1 = param.roomIdentifier, roomName = param.roomName;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = useRooms(), deleteRoom = ref1.deleteRoom, rooms = ref1.rooms;
    var ref2 = useRoomMapping(), getRoomMappingByRoomId = ref2.getRoomMappingByRoomId, updateRoomMapping = ref2.updateRoomMapping;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var moveParticipants = useBreakouts().moveParticipants;
    var ref3 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref3.breakoutHost, breakoutStatus = ref3.breakoutStatus, invitedParticipants = ref3.invitedParticipants, mainRoomParticipantIds = ref3.mainRoomParticipantIds;
    var ref4 = useSelectParticipant(), deselectParticipant = ref4.deselectParticipant, selectedParticipants = ref4.selectedParticipants;
    var ref5 = Room_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref5[0];
    var participantIds = getRoomMappingByRoomId(roomIdentifier1);
    var isMainRoom = roomIdentifier1 === constants/* MAIN_ROOM_IDENTIFIER */.b;
    var wrapperRef = (0,react.useRef)(null);
    var initialParticipantsToRender = 12;
    var ref6 = (0,react.useState)(initialParticipantsToRender), /*#__PURE__*/ participantsToLoad = ref6[0], setParticipantsToLoad = ref6[1];
    var participantsLeftToLoad = (participantIds === null || participantIds === void 0 ? void 0 : participantIds.length) - participantsToLoad;
    var handleLoadAll = function() {
        setParticipantsToLoad(participantIds === null || participantIds === void 0 ? void 0 : participantIds.length);
    };
    var handleLoadLess = function() {
        setParticipantsToLoad(initialParticipantsToRender);
    };
    var handleDragOver = function(ev) {
        onDragOver === null || onDragOver === void 0 ? void 0 : onDragOver(ev);
        ev.currentTarget.style.borderColor = "var(--focus-border)";
    };
    var handleDragLeave = function(ev) {
        ev.currentTarget.style.borderColor = "";
    };
    var handleDrop = function(ev) {
        onDrop === null || onDrop === void 0 ? void 0 : onDrop(ev);
        ev.currentTarget.style.borderColor = "";
    };
    var handleDeleteRoom = function(room) {
        participantIds === null || participantIds === void 0 ? void 0 : participantIds.map(function(participant) {
            updateRoomMapping(participant, constants/* MAIN_ROOM_IDENTIFIER */.b);
        });
        deleteRoom(room);
    };
    var joinOngoingSession = function() {
        if (breakoutStatus !== "ongoing") return;
        updateRoomMapping(localSessionId, roomIdentifier1);
        moveParticipants(Room_defineProperty({}, localSessionId, isMainRoom ? null : roomIdentifier1));
    };
    var handleSelectRoomsChange = function(roomIdentifier) {
        // if this is triggered, the Ongoing Breakout Sessions panel
        // needs to know about it -- see `hasPendingChanges` there.
        // if the default "Select" option is chosen, don't try to assign the participant(s) to that value.
        if (!roomIdentifier) return;
        onChangeSelect === null || onChangeSelect === void 0 ? void 0 : onChangeSelect();
        selectedParticipantsInRoom.map(function(participant) {
            updateRoomMapping(participant, roomIdentifier);
            deselectParticipant(participant);
        });
    };
    /* Which participants in this current room are also selected? */ var selectedParticipantsInRoom = selectedParticipants.filter(function(participant) {
        return participantIds === null || participantIds === void 0 ? void 0 : participantIds.includes(participant);
    });
    // Which main room participants are also selected? Needed for the random assignment button.
    var selectedParticipantsInMainRoom = selectedParticipants.filter(function(participant) {
        return mainRoomParticipantIds.includes(participant);
    });
    var participantCannotBeMoved = function(p) {
        // Host can always be moved
        var isHost = p === breakoutHost;
        var isInvited = invitedParticipants === null || invitedParticipants === void 0 ? void 0 : invitedParticipants.includes(p);
        return !isHost && isInvited && breakoutStatus === "ongoing";
    };
    var randomlyAssignParticipants = function() {
        var ids = selectedParticipantsInMainRoom.length > 0 ? Room_toConsumableArray(selectedParticipantsInMainRoom) : participantIds === null || participantIds === void 0 ? void 0 : participantIds.filter(function(id) {
            return id !== localSessionId;
        });
        var shuffledParticipants = shuffleArray(ids);
        for(var i = 0; i < shuffledParticipants.length; i++){
            var roomId = rooms[i % rooms.length];
            updateRoomMapping(shuffledParticipants[i], roomId);
            // make sure to deselect any participants upon random room assignment
            deselectParticipant(shuffledParticipants[i]);
        }
    };
    var showRoomSelect = breakoutStatus !== "ongoing" && isMainRoom ? true : selectedParticipantsInRoom.length > 0;
    // Options for the room dropdown menu
    var roomsOptions = (0,react.useMemo)(function() {
        var placeholder = {
            value: "",
            label: t("breakouts.selectRoomPlaceholder")
        };
        var mainRoom = {
            value: constants/* MAIN_ROOM_IDENTIFIER */.b,
            label: t("breakouts.mainRoom")
        };
        var availableRooms = rooms.map(function(roomId) {
            return {
                value: roomId,
                label: t("breakouts.roomWithName", {
                    name: rooms.indexOf(roomId) + 1
                })
            };
        }).filter(function(room) {
            return room.value !== roomIdentifier1;
        });
        return isMainRoom ? [
            placeholder
        ].concat(Room_toConsumableArray(availableRooms)) : [
            placeholder,
            mainRoom
        ].concat(Room_toConsumableArray(availableRooms));
    }, [
        isMainRoom,
        roomIdentifier1,
        rooms,
        t
    ]);
    // Only visible to the host when a breakout session is ongoing
    var showJoinRoomButton = breakoutStatus === "ongoing" && !(participantIds === null || participantIds === void 0 ? void 0 : participantIds.includes(localSessionId));
    // Only visible to the host when a breakout room is not ongoing
    var showDeleteRoomButton = breakoutStatus !== "ongoing" && roomIdentifier1 !== constants/* MAIN_ROOM_IDENTIFIER */.b;
    // Only render the random assignment button for the main room section
    var showRandomAssignmentButton = isMainRoom && breakoutStatus !== "ongoing";
    // Disable random assignment button when only the host is left to assign
    var disableRandomAssignmentButton = !mainRoomParticipantIds.some(function(id) {
        return id !== localSessionId;
    });
    var deselectAllParticipantsInRoom = function() {
        participantIds === null || participantIds === void 0 ? void 0 : participantIds.map(function(p) {
            return deselectParticipant(p);
        });
    };
    var showShowAllButton = (participantIds === null || participantIds === void 0 ? void 0 : participantIds.length) > participantsToLoad;
    var showShowLessButton = (participantIds === null || participantIds === void 0 ? void 0 : participantIds.length) === participantsToLoad;
    (0,useResizeObserver.useResizeObserver)(wrapperRef, (0,react.useCallback)(function() {
        if (!wrapperRef.current) return;
        onResize === null || onResize === void 0 ? void 0 : onResize();
    }, [
        onResize
    ]));
    var assignSelectId = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
        "data-room-identifier": roomIdentifier1,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDrop: handleDrop,
        shadow: "none",
        spacing: 12,
        className: "room",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: wrapperRef,
                "data-testid": "breakout-".concat(roomName !== null && roomName !== void 0 ? roomName : constants/* MAIN_ROOM_IDENTIFIER */.b),
                className: "jsx-1a61c0cbcbf7755a",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-1a61c0cbcbf7755a" + " " + "header-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: "base",
                                    El: "h1",
                                    children: isMainRoom ? t("breakouts.mainRoom") : t("breakouts.roomWithName", {
                                        name: roomName
                                    })
                                }),
                                showJoinRoomButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                    id: "breakouts-join-room-".concat(roomName),
                                    variant: "secondary",
                                    size: "small",
                                    onClick: joinOngoingSession,
                                    children: t("breakouts.joinRoom")
                                }),
                                showDeleteRoomButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                    id: "breakouts-delete-room-".concat(roomName),
                                    variant: "ghost",
                                    disabled: rooms.length < 2,
                                    type: "button",
                                    onClick: function() {
                                        return handleDeleteRoom(roomIdentifier1);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArchiveIcon/* ArchiveIcon */.r, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                            children: t("breakouts.deleteRoom")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            gap: 16,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-1a61c0cbcbf7755a" + " " + "room-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-1a61c0cbcbf7755a" + " " + "buttons-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-1a61c0cbcbf7755a" + " " + "select-buttons",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                        id: "breakouts-deselect-all-".concat(roomName),
                                                        variant: "ghost",
                                                        onClick: deselectAllParticipantsInRoom,
                                                        disabled: selectedParticipantsInRoom.length === 0,
                                                        children: t("breakouts.deselectAll")
                                                    })
                                                }),
                                                showShowAllButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "breakouts-show-all-".concat(roomName),
                                                    variant: "ghost",
                                                    onClick: handleLoadAll,
                                                    children: t("general.showAll")
                                                }),
                                                showShowLessButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "breakouts-show-less-".concat(roomName),
                                                    variant: "ghost",
                                                    onClick: handleLoadLess,
                                                    children: t("general.showLess")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-1a61c0cbcbf7755a" + " " + "participants-container",
                                            children: (participantIds === null || participantIds === void 0 ? void 0 : participantIds.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    (ref = participantIds === null || participantIds === void 0 ? void 0 : participantIds.slice(0, participantsToLoad)) === null || ref === void 0 ? void 0 : ref.map(function(p) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Participant, {
                                                            participant: p,
                                                            disabled: participantCannotBeMoved(p)
                                                        }, p);
                                                    }),
                                                    participantsLeftToLoad > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                        className: "participants-left",
                                                        children: t("breakouts.participantsWithCount", {
                                                            count: participantsLeftToLoad
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                color: "muted",
                                                children: !isMobile && t("breakouts.dragParticipantsHere")
                                            })
                                        })
                                    ]
                                }),
                                showRoomSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-1a61c0cbcbf7755a" + " " + "dropdown",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                        id: assignSelectId,
                                        name: "select-breakout-room",
                                        label: t("breakouts.assignSelectedTo"),
                                        disabled: selectedParticipantsInRoom.length === 0,
                                        options: roomsOptions,
                                        native: true,
                                        value: "" // not assigning a stateful value since we want to reset to "" after a room has been selected
                                        ,
                                        onChange: handleSelectRoomsChange
                                    })
                                }),
                                showRandomAssignmentButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                    id: "breakouts-assign-".concat(roomName),
                                    disabled: disableRandomAssignmentButton,
                                    fullWidth: true,
                                    variant: "secondary",
                                    onClick: randomlyAssignParticipants,
                                    children: selectedParticipantsInMainRoom.length > 0 ? t("breakouts.assignSelectedEvenly") : t("breakouts.assignAllEvenly")
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "1a61c0cbcbf7755a",
                children: "section.drop-hover.jsx-1a61c0cbcbf7755a{outline:1px solid var(--focus-border)}.room-container.jsx-1a61c0cbcbf7755a{background-color:var(--card-grey-bg);-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:4px;padding:8px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.participants-container.jsx-1a61c0cbcbf7755a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:4px;max-width:100%;position:relative}.header-container.jsx-1a61c0cbcbf7755a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-webkit-align-items:baseline;-moz-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.header-container.jsx-1a61c0cbcbf7755a h1{margin-bottom:12px}.buttons-container.jsx-1a61c0cbcbf7755a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:12px}.select-buttons.jsx-1a61c0cbcbf7755a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.room-container.jsx-1a61c0cbcbf7755a .participants-left{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:2px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/ConfigureBreakoutRooms.tsx
function ConfigureBreakoutRooms_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ConfigureBreakoutRooms_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ConfigureBreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ConfigureBreakoutRooms_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ConfigureBreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ConfigureBreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ConfigureBreakoutRooms_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ConfigureBreakoutRooms_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ConfigureBreakoutRooms_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ConfigureBreakoutRooms_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ConfigureBreakoutRooms_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ConfigureBreakoutRooms_slicedToArray(arr, i) {
    return ConfigureBreakoutRooms_arrayWithHoles(arr) || ConfigureBreakoutRooms_iterableToArrayLimit(arr, i) || ConfigureBreakoutRooms_unsupportedIterableToArray(arr, i) || ConfigureBreakoutRooms_nonIterableRest();
}
function ConfigureBreakoutRooms_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ConfigureBreakoutRooms_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ConfigureBreakoutRooms_arrayLikeToArray(o, minLen);
}
























var sessionConfigState = (0,es/* atom */.cn)({
    key: "breakout-session-config",
    default: {
        autojoin: false
    }
});
var ConfigureBreakoutRooms_GAP = 16;
var ConfigureBreakoutRooms = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var participantIds = (0,daily_react_esm/* useParticipantIds */.OV)({});
    var ref = ConfigureBreakoutRooms_slicedToArray(useBreakoutView(), 2), setBreakoutView = ref[1];
    var ref1 = useBreakouts(), setBreakoutHost = ref1.setBreakoutHost, setupBreakouts = ref1.setupBreakouts;
    var rooms = useRooms().rooms;
    var getRoomMappingByRoomId = useRoomMapping().getRoomMappingByRoomId;
    var ref2 = useDragAndDrop(), dragParticipant = ref2.dragParticipant, dropParticipant = ref2.dropParticipant;
    var ref3 = (0,react.useState)("idle"), /*#__PURE__*/ formState = ref3[0], setFormState = ref3[1];
    var sessionConfig = (0,es/* useRecoilValue */.sJ)(sessionConfigState);
    var cancelBreakoutConfiguration = (0,react.useCallback)(function() {
        setBreakoutHost("");
        setBreakoutView("start");
    }, [
        setBreakoutHost,
        setBreakoutView
    ]);
    var handleChangeAutojoin = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(ev) {
            set(sessionConfigState, function(config) {
                return ConfigureBreakoutRooms_objectSpread({}, config, {
                    autojoin: ev.target.checked
                });
            });
        };
    }, []);
    var handleSubmit = function() {
        var _ref = ConfigureBreakoutRooms_asyncToGenerator(runtime_default().mark(function _callee(ev) {
            var roomMapping;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ev.preventDefault();
                        setFormState("submitting");
                        roomMapping = rooms.reduce(function(result, roomId) {
                            return ConfigureBreakoutRooms_objectSpread({}, result, ConfigureBreakoutRooms_defineProperty({}, roomId, {
                                name: rooms.indexOf(roomId) + 1,
                                users: getRoomMappingByRoomId(roomId)
                            }));
                        }, {});
                        _ctx.next = 5;
                        return setupBreakouts(ConfigureBreakoutRooms_objectSpread({}, roomMapping), sessionConfig);
                    case 5:
                        setBreakoutView("ongoing");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(ev) {
            return _ref.apply(this, arguments);
        };
    }();
    var scrollRef = (0,react.useRef)(null);
    var virtualizer = (0,lib/* useVirtualizer */.MG)({
        count: rooms.length + 3,
        estimateSize: function(index) {
            /**
       * These are initial estimates for the very first render cycle.
       * Once each element has rendered at least once, these will be
       * replaced by their actual heights.
       */ switch(index){
                case 0:
                    // Header
                    return 32 + ConfigureBreakoutRooms_GAP;
                case 1:
                    // Configuration Card
                    return 202 + ConfigureBreakoutRooms_GAP;
                case 2:
                    // MainRoom Card
                    return 267 + ConfigureBreakoutRooms_GAP;
                default:
                    // Room Cards
                    return 117 + ConfigureBreakoutRooms_GAP;
            }
        },
        getScrollElement: function() {
            return scrollRef.current;
        },
        overscan: 2
    });
    var virtualItems = virtualizer.getVirtualItems();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                ref: scrollRef,
                innerHeight: virtualizer.getTotalSize(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
                    id: "configure-breakout-rooms",
                    onSubmit: handleSubmit,
                    children: virtualItems.map(function(item) {
                        var style = {
                            transform: "translateY(".concat(item.start, "px)")
                        };
                        switch(item.index){
                            case 0:
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                    ref: virtualizer.measureElement,
                                    "data-index": item.index,
                                    style: style,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "7b876e7abbb7908e",
                                            [
                                                ConfigureBreakoutRooms_GAP
                                            ]
                                        ]
                                    ]) + " " + "heading row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            El: "h1",
                                            variant: "large",
                                            children: t("breakouts.sessionSetup")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                            id: "breakouts-cancel-configuration",
                                            variant: "secondary",
                                            onClick: cancelBreakoutConfiguration,
                                            children: t("general.cancel")
                                        })
                                    ]
                                }, "header");
                            case 1:
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: virtualizer.measureElement,
                                    "data-index": item.index,
                                    style: style,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "7b876e7abbb7908e",
                                            [
                                                ConfigureBreakoutRooms_GAP
                                            ]
                                        ]
                                    ]) + " " + "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                                        shadow: "none",
                                        spacing: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                                gap: 8,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberOfRoomsField, {
                                                        participantIds: participantIds
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox.Checkbox, {
                                                        id: "br-autojoin",
                                                        name: "autojoin",
                                                        label: t("breakouts.autojoinLabel"),
                                                        checked: sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.autojoin,
                                                        onChange: handleChangeAutojoin
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }, "config");
                            case 2:
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "main-room-config",
                                    ref: virtualizer.measureElement,
                                    "data-index": item.index,
                                    style: style,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "7b876e7abbb7908e",
                                            [
                                                ConfigureBreakoutRooms_GAP
                                            ]
                                        ]
                                    ]) + " " + "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Room, {
                                        onDragOver: dragParticipant,
                                        onDrop: dropParticipant,
                                        onResize: function() {
                                            return virtualizer.measureElement(document.getElementById("main-room-config"));
                                        },
                                        roomIdentifier: constants/* MAIN_ROOM_IDENTIFIER */.b
                                    })
                                }, "main-room");
                            default:
                                var index = item.index - 3;
                                var roomId = rooms[index];
                                var domId = "room-config-".concat(roomId);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: domId,
                                    ref: virtualizer.measureElement,
                                    "data-index": item.index,
                                    style: style,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "7b876e7abbb7908e",
                                            [
                                                ConfigureBreakoutRooms_GAP
                                            ]
                                        ]
                                    ]) + " " + "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Room, {
                                        onDragOver: dragParticipant,
                                        onDrop: dropParticipant,
                                        onResize: function() {
                                            return virtualizer.measureElement(document.getElementById(domId));
                                        },
                                        roomIdentifier: roomId,
                                        roomName: index + 1
                                    })
                                }, roomId);
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "breakouts-start-session",
                    loading: formState === "submitting",
                    type: "submit",
                    fullWidth: true,
                    form: "configure-breakout-rooms",
                    children: t("breakouts.startBreakoutSession")
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "7b876e7abbb7908e",
                dynamic: [
                    ConfigureBreakoutRooms_GAP
                ],
                children: ".heading.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.row.__jsx-style-dynamic-selector{left:0;padding-bottom:".concat(ConfigureBreakoutRooms_GAP, "px;position:absolute;top:0;width:100%}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Modal/index.js
var Modal = __webpack_require__(5964);
;// CONCATENATED MODULE: ./components/BreakoutRooms/OngoingBreakoutSession.tsx
function OngoingBreakoutSession_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function OngoingBreakoutSession_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function OngoingBreakoutSession_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function OngoingBreakoutSession_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function OngoingBreakoutSession_slicedToArray(arr, i) {
    return OngoingBreakoutSession_arrayWithHoles(arr) || OngoingBreakoutSession_iterableToArrayLimit(arr, i) || OngoingBreakoutSession_unsupportedIterableToArray(arr, i) || OngoingBreakoutSession_nonIterableRest();
}
function OngoingBreakoutSession_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return OngoingBreakoutSession_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return OngoingBreakoutSession_arrayLikeToArray(o, minLen);
}



















var OngoingBreakoutSession_GAP = 16;
var OngoingBreakoutSession = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var endBreakouts = useBreakouts().endBreakouts;
    var ref7 = (0,react.useState)(false), /*#__PURE__*/ showEndModal = ref7[0], setShowEndModal = ref7[1];
    var ref1 = useRooms(), addRoom = ref1.addRoom, deleteRoom = ref1.deleteRoom, rooms = ref1.rooms;
    var ref2 = useRoomMapping(), currentRoomMapping = ref2.currentRoomMapping, getRoomMappingByRoomId = ref2.getRoomMappingByRoomId, publishRoomMapping = ref2.publishRoomMapping, syncRoomMappingFromSessionState = ref2.syncRoomMappingFromSessionState;
    var ref3 = useDragAndDrop(), dragParticipant = ref3.dragParticipant, dropParticipant = ref3.dropParticipant;
    var ref4 = (0,react.useState)("idle"), formState = ref4[0], setFormState = ref4[1];
    var ref5 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)({
        onMeetingSessionStateUpdated: (0,react.useCallback)(function(ev) {
            if (formState === "submitting") return;
            syncRoomMappingFromSessionState(ev.meetingSessionState.data);
        }, [
            formState,
            syncRoomMappingFromSessionState
        ])
    }), breakoutStatus = ref5.breakoutStatus, endDate = ref5.endDate;
    var handleDropParticipant = function(ev) {
        dropParticipant(ev);
        var participantId = ev.dataTransfer.getData("text/plain");
        var roomIdentifier = ev.currentTarget.dataset.roomIdentifier;
        var mapping = getRoomMappingByRoomId(roomIdentifier);
        if (!mapping.includes(participantId)) {
            setFormState("dirty");
        }
    };
    var handleEndClick = function() {
        setShowEndModal(true);
    };
    var handleEndTimerClick = function() {
        setShowEndModal(false);
        endBreakouts();
    };
    var handleEndNowClick = function() {
        setShowEndModal(false);
        endBreakouts(true);
    };
    var scrollRef = (0,react.useRef)(null);
    var virtualizer = (0,lib/* useVirtualizer */.MG)({
        count: rooms.length + 1,
        estimateSize: function(index) {
            switch(index){
                case 0:
                    return 142 + OngoingBreakoutSession_GAP;
                default:
                    return 122 + OngoingBreakoutSession_GAP;
            }
        },
        getScrollElement: function() {
            return scrollRef.current;
        },
        overscan: 2
    });
    var virtualItems = virtualizer.getVirtualItems();
    var isStateInSync = (0,react.useCallback)(function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : daily === null || daily === void 0 ? void 0 : daily.meetingSessionState().data;
        var ref;
        var idToRoomMapping = {};
        var ref6;
        Object.entries((ref6 = data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.mapping) !== null && ref6 !== void 0 ? ref6 : {}).forEach(function(param) {
            var _param = OngoingBreakoutSession_slicedToArray(param, 2), roomId = _param[0], users = _param[1].users;
            users.forEach(function(id) {
                idToRoomMapping[id] = roomId;
            });
        });
        /**
         * When participants are moved back to main, the currentRoomMapping contains
         * entries to MAIN_ROOM_IDENTIFIER, but these are not reflected in the
         * meeting session state.
         * For correct comparison we'll have to remove main room mapping entries
         * from the current (= local state) mapping object.
         */ var cleanCurrentMapping = {};
        Object.entries(currentRoomMapping).forEach(function(param) {
            var _param = OngoingBreakoutSession_slicedToArray(param, 2), id = _param[0], roomId = _param[1];
            if (roomId !== constants/* MAIN_ROOM_IDENTIFIER */.b) {
                cleanCurrentMapping[id] = roomId;
            }
        });
        return fast_deep_equal_default()(idToRoomMapping, cleanCurrentMapping);
    }, [
        currentRoomMapping,
        daily
    ]);
    var handleClickApplyChanges = function() {
        if (!daily) return;
        if (isStateInSync()) {
            setFormState("idle");
            return;
        }
        /**
       * Wait for new mapping to be published, before re-enabling automatic sync.
       */ var handleStateUpdate = function(ev) {
            var data = ev.meetingSessionState.data;
            if (isStateInSync(data)) {
                setFormState("idle");
                syncRoomMappingFromSessionState(data);
                daily.off("meeting-session-state-updated", handleStateUpdate);
            }
        };
        setFormState("submitting");
        daily.on("meeting-session-state-updated", handleStateUpdate);
        publishRoomMapping();
    };
    var handleClickDiscardChanges = function() {
        setFormState("idle");
        syncRoomMappingFromSessionState(daily.meetingSessionState().data);
    };
    var handleChangeInDropdown = function() {
        setFormState("dirty");
    };
    /**
     * Re-syncs mapping from meeting session state when the breakout panel is opened.
     */ (0,react.useEffect)(function initMappingState() {
        var ref;
        if (!daily) return;
        var data = daily.meetingSessionState().data;
        syncRoomMappingFromSessionState(data);
        var ref8;
        var mapping = (ref8 = data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.mapping) !== null && ref8 !== void 0 ? ref8 : {};
        if (rooms.some(function(id) {
            return !(id in mapping);
        })) {
            rooms.forEach(deleteRoom);
            Object.keys(mapping).forEach(addRoom);
        }
    }, [
        addRoom,
        daily,
        deleteRoom,
        rooms,
        syncRoomMappingFromSessionState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                ref: scrollRef,
                innerHeight: virtualizer.getTotalSize(),
                "data-testid": "ongoing",
                children: virtualItems.map(function(item) {
                    var style = {
                        transform: "translateY(".concat(item.start, "px)")
                    };
                    switch(item.index){
                        case 0:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "main-room-config",
                                ref: virtualizer.measureElement,
                                "data-index": item.index,
                                style: style,
                                className: styled_jsx_default().dynamic([
                                    [
                                        "d854dcd93b2f14a5",
                                        [
                                            OngoingBreakoutSession_GAP
                                        ]
                                    ]
                                ]) + " " + "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Room, {
                                    onDragOver: dragParticipant,
                                    onDrop: handleDropParticipant,
                                    onResize: function() {
                                        return virtualizer.measureElement(document.getElementById("main-room-config"));
                                    },
                                    roomIdentifier: constants/* MAIN_ROOM_IDENTIFIER */.b,
                                    onChangeSelect: handleChangeInDropdown
                                })
                            }, "main-room");
                        default:
                            var index = item.index - 1;
                            var roomId = rooms[index];
                            var domId = "room-config-".concat(roomId);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: domId,
                                ref: virtualizer.measureElement,
                                "data-index": item.index,
                                style: style,
                                className: styled_jsx_default().dynamic([
                                    [
                                        "d854dcd93b2f14a5",
                                        [
                                            OngoingBreakoutSession_GAP
                                        ]
                                    ]
                                ]) + " " + "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Room, {
                                    onDragOver: dragParticipant,
                                    onDrop: handleDropParticipant,
                                    onResize: function() {
                                        return virtualizer.measureElement(document.getElementById(domId));
                                    },
                                    roomIdentifier: roomId,
                                    roomName: index + 1,
                                    onChangeSelect: handleChangeInDropdown
                                })
                            }, roomId);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaButtonContainer, {
                children: [
                    breakoutStatus === "ongoing" && formState !== "idle" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                id: "breakouts-apply-changes",
                                fullWidth: true,
                                loading: formState === "submitting",
                                onClick: handleClickApplyChanges,
                                variant: "primary",
                                children: t("breakouts.applyChanges")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                id: "breakouts-discard-changes",
                                disabled: formState === "submitting",
                                fullWidth: true,
                                onClick: handleClickDiscardChanges,
                                variant: "secondary",
                                children: t("breakouts.discardChanges")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-end-session",
                        fullWidth: true,
                        onClick: handleEndClick,
                        variant: "danger",
                        children: t("breakouts.endBreakoutSessionEllipsis")
                    })
                ]
            }),
            showEndModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                onClose: function() {
                    return setShowEndModal(false);
                },
                actions: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-end-in-60-seconds",
                        disabled: !!endDate,
                        variant: "primary",
                        onClick: handleEndTimerClick,
                        children: t("breakouts.endBreakoutModal.endIn60Seconds")
                    }, "endTimer"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-end-now",
                        variant: "danger",
                        onClick: handleEndNowClick,
                        children: t("breakouts.endBreakoutModal.endImmediately")
                    }, "endNow"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-end-cancel",
                        variant: "secondary",
                        children: t("general.cancel")
                    }, "cancel"), 
                ],
                title: t("breakouts.endBreakoutSession"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "p",
                    variant: "large",
                    children: t("breakouts.endBreakoutModal.desc")
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d854dcd93b2f14a5",
                dynamic: [
                    OngoingBreakoutSession_GAP
                ],
                children: ".row.__jsx-style-dynamic-selector{left:0;padding-bottom:".concat(OngoingBreakoutSession_GAP, "px;position:absolute;top:0;width:100%}")
            })
        ]
    });
});
OngoingBreakoutSession.displayName = "OngoingBreakoutSession";

;// CONCATENATED MODULE: ./components/BreakoutRooms/BreakoutRooms.tsx
function BreakoutRooms_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutRooms_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BreakoutRooms_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BreakoutRooms_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BreakoutRooms_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutRooms_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutRooms_slicedToArray(arr, i) {
    return BreakoutRooms_arrayWithHoles(arr) || BreakoutRooms_iterableToArrayLimit(arr, i) || BreakoutRooms_unsupportedIterableToArray(arr, i) || BreakoutRooms_nonIterableRest();
}
function BreakoutRooms_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutRooms_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutRooms_arrayLikeToArray(o, minLen);
}



















var BreakoutRooms = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = BreakoutRooms_slicedToArray(useBreakoutView(), 2), breakoutView = ref[0], setBreakoutView = ref[1];
    var ref1 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref1.breakoutHost, breakoutMapping = ref1.breakoutMapping, breakoutStatus = ref1.breakoutStatus;
    var setBreakoutHost = useBreakouts().setBreakoutHost;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref2 = useRooms(), addRoom = ref2.addRoom, deleteAllRooms = ref2.deleteAllRooms, deleteRoom = ref2.deleteRoom, rooms = ref2.rooms;
    var deselectAllParticipants = useSelectParticipant().deselectAllParticipants;
    var ref3 = useRoomMapping(), resetRoomMapping = ref3.resetRoomMapping, syncRoomMappingFromSessionState = ref3.syncRoomMappingFromSessionState;
    var canConfigureBreakouts = !breakoutHost || breakoutHost === localSessionId;
    var createSession = (0,react.useCallback)(function() {
        deleteAllRooms();
        deselectAllParticipants();
        resetRoomMapping();
        setBreakoutHost();
        setBreakoutView("configure");
    }, [
        deleteAllRooms,
        deselectAllParticipants,
        resetRoomMapping,
        setBreakoutHost,
        setBreakoutView, 
    ]);
    var recreateSession = (0,react.useCallback)(BreakoutRooms_asyncToGenerator(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    // In case local rooms were deleted previously, restore them from session state
                    if (rooms.some(function(id) {
                        return !(id in breakoutMapping);
                    })) {
                        rooms.forEach(deleteRoom);
                        Object.keys(breakoutMapping).forEach(addRoom);
                    }
                    setBreakoutHost();
                    data = daily.meetingSessionState().data;
                    _ctx.next = 5;
                    return syncRoomMappingFromSessionState(data);
                case 5:
                    setBreakoutView("configure");
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        addRoom,
        breakoutMapping,
        daily,
        deleteRoom,
        rooms,
        setBreakoutHost,
        setBreakoutView,
        syncRoomMappingFromSessionState, 
    ]);
    /**
   * Automatically switch view.
   */ (0,react.useEffect)(function() {
        if (breakoutStatus === "ongoing" && breakoutHost === localSessionId && breakoutView !== "ongoing") {
            setBreakoutView("ongoing");
        }
    }, [
        breakoutHost,
        breakoutStatus,
        breakoutView,
        localSessionId,
        setBreakoutView, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-c0de7105385e5df2" + " " + "breakout-rooms-panel",
        children: [
            breakoutView === "start" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                /*#__PURE__*/ noBorder: true,
                shadow: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 24,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                children: t("breakouts.configurationDesc")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 32,
                                children: [
                                    !canConfigureBreakouts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                                        appearance: "grey",
                                        shadow: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                                            className: "host-info-box-content",
                                            style: {
                                                padding: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutIcon/* BreakoutIcon */.y, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    children: t("breakouts.breakoutSessionInProgress")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        gap: 16,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                id: "breakouts-create-new-session",
                                                disabled: !canConfigureBreakouts,
                                                fullWidth: true,
                                                onClick: createSession,
                                                children: t("breakouts.createNewSession")
                                            }),
                                            canConfigureBreakouts && Object.keys(breakoutMapping).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                id: "breakouts-recreate-session",
                                                disabled: !canConfigureBreakouts,
                                                fullWidth: true,
                                                onClick: recreateSession,
                                                variant: "secondary",
                                                children: t("breakouts.recreateSession")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            breakoutView === "configure" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfigureBreakoutRooms, {}),
            breakoutView === "ongoing" && /*#__PURE__*/ (0,jsx_runtime.jsx)(OngoingBreakoutSession, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                className: "drag-image",
                id: "drag-image",
                tabIndex: -1,
                children: t("breakouts.multipleSelected")
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c0de7105385e5df2",
                children: ".breakout-rooms-panel.jsx-c0de7105385e5df2{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}.breakout-rooms-panel.jsx-c0de7105385e5df2 .drag-image{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;clip:rect(0px,0px,0px,0px);left:0;position:fixed;top:0;z-index:-2}.breakout-rooms-panel.jsx-c0de7105385e5df2 .host-info-box-content{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.breakout-rooms-panel.jsx-c0de7105385e5df2 .host-info-box-content p{margin-left:4px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(3870);
// EXTERNAL MODULE: ../shared/dist/components/Icons/EmojiIcon.js
var EmojiIcon = __webpack_require__(8117);
// EXTERNAL MODULE: ../shared/dist/components/Icons/InfoIcon.js
var InfoIcon = __webpack_require__(3232);
// EXTERNAL MODULE: ../shared/dist/components/Icons/LockIcon.js
var LockIcon = __webpack_require__(2805);
// EXTERNAL MODULE: ../shared/dist/components/Tooltip/index.js
var Tooltip = __webpack_require__(1320);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./contexts/ChatProvider.tsx
var ChatProvider = __webpack_require__(3827);
;// CONCATENATED MODULE: ./components/Chat/ChatCommandMenu.tsx








var ChatCommandMenu = function(param1) {
    var message = param1.message, onPick = param1.onPick, textAreaRef = param1.textAreaRef;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var commands = (0,react.useMemo)(function() {
        return [
            {
                cmd: "/giphy [text]",
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "start",
                    gap: 2,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "strong",
                            children: "/giphy [text]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "muted",
                            variant: "small",
                            children: t("giphy.description")
                        })
                    ]
                }),
                value: "/giphy "
            }, 
        ];
    }, [
        t
    ]);
    var suitableCommands = commands.filter(function(param) {
        var cmd = param.cmd;
        return cmd.startsWith(message);
    });
    /**
   * Autocomplete first command, when user hits Enter.
   */ (0,react.useEffect)(function() {
        var unsubscribe = (0,tinykeys_module/* default */.Z)(textAreaRef.current, {
            Enter: function(ev) {
                if (!suitableCommands.length) return;
                ev.preventDefault();
                ev.stopImmediatePropagation();
                onPick(suitableCommands[0].value);
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        onPick,
        suitableCommands,
        textAreaRef
    ]);
    if (!suitableCommands.length || message.includes(" ") || !message.startsWith("/")) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
        spacing: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardList, {
            children: suitableCommands.map(function(param) {
                var cmd = param.cmd, label = param.label, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "chat-command-".concat(cmd),
                    variant: "ghost",
                    onClick: function() {
                        return onPick(value);
                    },
                    fullWidth: true,
                    children: label
                }, cmd);
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Chat/ChatInput.tsx
function ChatInput_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ChatInput_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ChatInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ChatInput_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ChatInput_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ChatInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChatInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ChatInput_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ChatInput_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ChatInput_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChatInput_slicedToArray(arr, i) {
    return ChatInput_arrayWithHoles(arr) || ChatInput_iterableToArrayLimit(arr, i) || ChatInput_unsupportedIterableToArray(arr, i) || ChatInput_nonIterableRest();
}
function ChatInput_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ChatInput_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ChatInput_arrayLikeToArray(o, minLen);
}












var ChatInput = function(_param) {
    var _showBroadcastControls = _param.showBroadcastControls, showBroadcastControls = _showBroadcastControls === void 0 ? false : _showBroadcastControls, props = ChatInput_objectWithoutProperties(_param, [
        "showBroadcastControls"
    ]);
    var enableAdvancedChat = (0,useCallConfig/* useCallConfig */.A)().enableAdvancedChat;
    var ref6 = (0,Theme.useTheme)(), fontFamilies = ref6.fontFamilies, fontSizes = ref6.fontSizes, lineHeights = ref6.lineHeights, mediaQueries = ref6.mediaQueries;
    var ref1 = ChatInput_slicedToArray((0,es/* useRecoilState */.FV)(localChatMessageState), 2), localMessage = ref1[0], setLocalMessage = ref1[1];
    var textAreaRef = (0,react.useRef)(null);
    var ref2 = ChatInput_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref2[0];
    var ref3 = (0,react.useState)("auto"), /*#__PURE__*/ textAreaHeight = ref3[0], setTextAreaHeight = ref3[1];
    var ref4 = (0,react.useState)("auto"), parentHeight = ref4[0], setParentHeight = ref4[1];
    var ref5 = (0,react.useState)(false), showCommands = ref5[0], setShowCommands = ref5[1];
    /**
   * Initially moves the cursor to end of input.
   */ (0,react.useEffect)(function() {
        if (!textAreaRef.current) return;
        var textArea = textAreaRef.current;
        textArea.setSelectionRange(textArea.value.length, textArea.value.length);
    }, [
        textAreaRef
    ]);
    (0,react.useEffect)(function() {
        if (!textAreaRef.current) return;
        if (!localMessage) {
            setTextAreaHeight("auto");
        } else {
            var height = textAreaRef.current.scrollHeight + (textAreaRef.current.offsetHeight - textAreaRef.current.clientHeight);
            setParentHeight("".concat(height, "px"));
            setTextAreaHeight("".concat(height, "px"));
        }
    }, [
        localMessage,
        textAreaRef
    ]);
    /**
   * Reset parent height when textarea height is set to 'auto'.
   */ (0,react.useEffect)(function() {
        if (!textAreaRef.current || textAreaHeight !== "auto") return;
        setParentHeight("".concat(textAreaRef.current.scrollHeight + (textAreaRef.current.offsetHeight - textAreaRef.current.clientHeight), "px"));
    }, [
        textAreaHeight,
        textAreaRef
    ]);
    var handleChange = function(ev) {
        var ref;
        setLocalMessage(ev.target.value);
        props === null || props === void 0 ? void 0 : (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, ev);
    };
    /**
   * Fill textarea with selected commands value.
   */ var handlePick = function(value) {
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set;
        nativeInputValueSetter.call(textAreaRef.current, value);
        textAreaRef.current.dispatchEvent(new Event("input", {
            bubbles: true
        }));
        setShowCommands(false);
    };
    /**
   * Show/hide command menu based on current input value.
   */ (0,react.useEffect)(function() {
        if (!enableAdvancedChat) return;
        setShowCommands(localMessage.startsWith("/") && !localMessage.includes(" "));
    }, [
        enableAdvancedChat,
        localMessage
    ]);
    /**
   * Register ESC key listener to close command menu.
   */ (0,react.useEffect)(function() {
        if (!showCommands) return;
        var unsubscribe = (0,tinykeys_module/* default */.Z)(textAreaRef.current, {
            Escape: function(ev) {
                ev.preventDefault();
                ev.stopImmediatePropagation();
                setShowCommands(false);
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        showCommands
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            minHeight: parentHeight
        },
        className: styled_jsx_default().dynamic([
            [
                "f4c167d9724e07e4",
                [
                    fontFamilies.regular,
                    fontSizes.base,
                    lineHeights.base,
                    mediaQueries.coarse,
                    fontSizes.large,
                    lineHeights.large
                ]
            ]
        ]) + " " + (classnames_default()("chat-input-wrapper", {
            "can-broadcast": showBroadcastControls
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FocusTrap.FocusTrap, {
                active: showCommands,
                arrowKeys: "updown",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", ChatInput_objectSpread({}, props, {
                        autoFocus: !isMobile,
                        ref: textAreaRef,
                        rows: 1,
                        style: {
                            height: textAreaHeight
                        },
                        onChange: handleChange,
                        value: localMessage,
                        className: styled_jsx_default().dynamic([
                            [
                                "f4c167d9724e07e4",
                                [
                                    fontFamilies.regular,
                                    fontSizes.base,
                                    lineHeights.base,
                                    mediaQueries.coarse,
                                    fontSizes.large,
                                    lineHeights.large
                                ]
                            ]
                        ]) + " " + (props && props.className != null && props.className || "")
                    })),
                    enableAdvancedChat && showCommands && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "f4c167d9724e07e4",
                                [
                                    fontFamilies.regular,
                                    fontSizes.base,
                                    lineHeights.base,
                                    mediaQueries.coarse,
                                    fontSizes.large,
                                    lineHeights.large
                                ]
                            ]
                        ]) + " " + "cmds",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatCommandMenu, {
                            message: localMessage,
                            onPick: handlePick,
                            textAreaRef: textAreaRef
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f4c167d9724e07e4",
                dynamic: [
                    fontFamilies.regular,
                    fontSizes.base,
                    lineHeights.base,
                    mediaQueries.coarse,
                    fontSizes.large,
                    lineHeights.large
                ],
                children: ".chat-input-wrapper.__jsx-style-dynamic-selector{position:relative}.chat-input-wrapper.can-broadcast.__jsx-style-dynamic-selector textarea.__jsx-style-dynamic-selector{padding-bottom:40px}.cmds.__jsx-style-dynamic-selector{bottom:-webkit-calc(100% + 4px);bottom:-moz-calc(100% + 4px);bottom:calc(100% + 4px);position:absolute;width:100%}textarea.__jsx-style-dynamic-selector{background:var(--input-bg);border:1px solid var(--input-border);-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;-webkit-box-shadow:0 0 0 0 var(--focus-shadow);-moz-box-shadow:0 0 0 0 var(--focus-shadow);box-shadow:0 0 0 0 var(--focus-shadow);caret-color:var(--input-color);color:var(--input-color);display:block;font-family:".concat(fontFamilies.regular, ";font-size:").concat(fontSizes.base, ";font-weight:normal;line-height:").concat(lineHeights.base, ";margin:0;overflow:hidden;padding:12px 52px 12px 12px;position:relative;resize:none;-webkit-transition:border 200ms ease,box-shadow 200ms ease;-moz-transition:border 200ms ease,box-shadow 200ms ease;-o-transition:border 200ms ease,box-shadow 200ms ease;transition:border 200ms ease,box-shadow 200ms ease;width:100%;z-index:2}@media ").concat(mediaQueries.coarse, "{textarea.__jsx-style-dynamic-selector{font-size:").concat(fontSizes.large, ";line-height:").concat(lineHeights.large, ";padding-right:72px}}textarea.__jsx-style-dynamic-selector:not([disabled]):focus,textarea.__jsx-style-dynamic-selector:not([disabled]):hover{border:1px solid var(--focus-border);-webkit-box-shadow:0 0 0 2px var(--focus-shadow);-moz-box-shadow:0 0 0 2px var(--focus-shadow);box-shadow:0 0 0 2px var(--focus-shadow)}textarea.__jsx-style-dynamic-selector:not([disabled]):focus{outline:none}textarea.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:var(--input-placeholder-color)}textarea.__jsx-style-dynamic-selector:-moz-placeholder{color:var(--input-placeholder-color)}textarea.__jsx-style-dynamic-selector::-moz-placeholder{color:var(--input-placeholder-color)}textarea.__jsx-style-dynamic-selector:-ms-input-placeholder{color:var(--input-placeholder-color)}textarea.__jsx-style-dynamic-selector::-ms-input-placeholder{color:var(--input-placeholder-color)}textarea.__jsx-style-dynamic-selector::placeholder{color:var(--input-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector{background-color:var(--input-disabled-bg);color:var(--input-disabled-color)}textarea[disabled].__jsx-style-dynamic-selector::-webkit-input-placeholder{color:var(--input-disabled-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector:-moz-placeholder{color:var(--input-disabled-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector::-moz-placeholder{color:var(--input-disabled-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector:-ms-input-placeholder{color:var(--input-disabled-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector::-ms-input-placeholder{color:var(--input-disabled-placeholder-color)}textarea[disabled].__jsx-style-dynamic-selector::placeholder{color:var(--input-disabled-placeholder-color)}")
            })
        ]
    });
};


// EXTERNAL MODULE: ../shared/dist/components/Icons/CaretDownIcon.js
var CaretDownIcon = __webpack_require__(97);
// EXTERNAL MODULE: ./lib/advancedChat.ts
var advancedChat = __webpack_require__(8394);
// EXTERNAL MODULE: ../../node_modules/react-linkify/dist/index.js
var dist = __webpack_require__(3546);
// EXTERNAL MODULE: ../shared/dist/components/Icons/AddEmojiIcon.js
var AddEmojiIcon = __webpack_require__(2013);
// EXTERNAL MODULE: ../shared/dist/hooks/useClosable.js
var useClosable = __webpack_require__(8273);
;// CONCATENATED MODULE: ./components/Chat/AddReaction.tsx
















var AddReaction = function(param) {
    var onClickReaction = param.onClickReaction, _reactions = param.reactions, reactions = _reactions === void 0 ? ChatProvider/* defaultReactions */.zc : _reactions;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var zIndex = (0,Theme.useTheme)().zIndex;
    var ref = (0,react.useState)(false), /*#__PURE__*/ showMenu = ref[0], setShowMenu = ref[1];
    var menuRef = (0,react.useRef)(null);
    var addModifier = (0,useEmojiSkinTone/* useEmojiSkinTone */.v)().addModifier;
    var handleClickReaction = function(reaction) {
        onClickReaction === null || onClickReaction === void 0 ? void 0 : onClickReaction(reaction);
        setShowMenu(false);
    };
    var handleAddReactionClick = function() {
        setShowMenu(function(show) {
            return !show;
        });
    };
    (0,useClosable.useClosable)({
        onClose: (0,react.useCallback)(function() {
            return setShowMenu(false);
        }, []),
        ref: menuRef
    }, [
        showMenu
    ]);
    var id = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "5328c43132a5f2",
                [
                    zIndex.menu
                ]
            ]
        ]) + " " + "add-reaction-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FocusTrap.FocusTrap, {
                active: showMenu,
                children: [
                    showMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: menuRef,
                        className: styled_jsx_default().dynamic([
                            [
                                "5328c43132a5f2",
                                [
                                    zIndex.menu
                                ]
                            ]
                        ]) + " " + "reactions-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            noBorder: true,
                            spacing: 8,
                            shadow: "strong",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                children: reactions.map(function(reaction) {
                                    var chatReaction = addModifier(reaction);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                        id: "chat-add-reaction-".concat(chatReaction),
                                        className: "reaction",
                                        onClick: function() {
                                            return handleClickReaction(chatReaction);
                                        },
                                        variant: "ghost",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            El: "span",
                                            variant: "large",
                                            children: chatReaction
                                        })
                                    }, chatReaction);
                                })
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "chat-add-reaction-".concat(id),
                        className: classnames_default()("add-reaction", {
                            visible: showMenu
                        }),
                        type: "button",
                        onClick: handleAddReactionClick,
                        title: t("chat.addReaction"),
                        variant: "secondary",
                        children: [
                            showMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                size: 16,
                                variant: "thick"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AddEmojiIcon/* AddEmojiIcon */.E, {
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("chat.addReaction")
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5328c43132a5f2",
                dynamic: [
                    zIndex.menu
                ],
                children: ".add-reaction-wrapper.__jsx-style-dynamic-selector{position:absolute;right:-8px;top:min(-webkit-calc(50% - 12px),8px);top:min(-moz-calc(50% - 12px),8px);top:min(calc(50% - 12px),8px)}.add-reaction-wrapper.__jsx-style-dynamic-selector .add-reaction{border:none;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;-webkit-box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);-moz-box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);box-shadow:0px 2px 2px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.04);opacity:0;padding:4px;-webkit-transition:opacity 150ms ease;-moz-transition:opacity 150ms ease;-o-transition:opacity 150ms ease;transition:opacity 150ms ease;z-index:1}.msg:hover .add-reaction-wrapper.__jsx-style-dynamic-selector .add-reaction,.msg .add-reaction-wrapper.__jsx-style-dynamic-selector .add-reaction:focus-visible,.msg .add-reaction-wrapper.__jsx-style-dynamic-selector .add-reaction.visible{opacity:1}.reactions-menu.__jsx-style-dynamic-selector{bottom:16px;position:absolute;right:16px;z-index:".concat(zIndex.menu, "}.reactions-menu.__jsx-style-dynamic-selector .card{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;height:auto;width:auto}.reactions-menu.__jsx-style-dynamic-selector .card-content{display:grid;gap:4px;grid-template-columns:1fr 1fr 1fr 1fr 1fr}.add-reaction-wrapper.__jsx-style-dynamic-selector .reaction{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 8px}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/i18next/dist/esm/i18next.js + 15 modules
var i18next = __webpack_require__(512);
;// CONCATENATED MODULE: ./components/Chat/ChatReactions.tsx
function ChatReactions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ChatReactions_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ChatReactions_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ChatReactions_arrayLikeToArray(arr);
}
function ChatReactions_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ChatReactions_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ChatReactions_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ChatReactions_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ChatReactions_slicedToArray(arr, i) {
    return ChatReactions_arrayWithHoles(arr) || ChatReactions_iterableToArrayLimit(arr, i) || ChatReactions_unsupportedIterableToArray(arr, i) || ChatReactions_nonIterableRest();
}
function ChatReactions_toConsumableArray(arr) {
    return ChatReactions_arrayWithoutHoles(arr) || ChatReactions_iterableToArray(arr) || ChatReactions_unsupportedIterableToArray(arr) || ChatReactions_nonIterableSpread();
}
function ChatReactions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ChatReactions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ChatReactions_arrayLikeToArray(o, minLen);
}













var MAX_TOOLTIP_NAME_COUNT = 6;
var ChatReactions = function(param1) {
    var message = param1.message, onReact = param1.onReact;
    var ref2 = (0,Theme.useTheme)(), colors = ref2.colors, isDarkMode = ref2.isDarkMode;
    var reactionsRef = (0,react.useRef)(null);
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var handleClick = function(reaction) {
        onReact(reaction);
    };
    /**
   * Returns the tooltip title for a reaction button, based on a list of session_ids.
   * The component doesn't automatically re-render, in case participants change
   * their names. Instead, it will lazily update the names, as reactions are
   * added or removed for a message. This has the effect that temporarily names
   * might not be represented correctly until the component runs through the next
   * render cycle.
   * However, setting up listeners to detect name updates is relatively expensive
   * and could lead to many more re-renders than necessary.
   */ var getTooltipTitle = function(reaction, ids, amountOfReactions) {
        var containsLocalUser = ids.includes(localSessionId);
        var idsWithoutLocal = ids.filter(function(id) {
            return id !== localSessionId;
        });
        var participants = daily === null || daily === void 0 ? void 0 : daily.participants();
        var remoteIdsWithName = idsWithoutLocal.filter(function(id) {
            var ref;
            return Boolean(participants === null || participants === void 0 ? void 0 : (ref = participants[id]) === null || ref === void 0 ? void 0 : ref.user_name);
        });
        var max = MAX_TOOLTIP_NAME_COUNT - (containsLocalUser ? 1 : 0);
        var displayableNames = remoteIdsWithName.slice(0, max);
        var nonDisplayableNamesCount = Math.max(0, remoteIdsWithName.length - max);
        var withoutNameCount = idsWithoutLocal.length - remoteIdsWithName.length;
        var names = ChatReactions_toConsumableArray(containsLocalUser ? [
            (0,i18next.t)("people.you")
        ] : []).concat(ChatReactions_toConsumableArray(displayableNames.length ? displayableNames.map(function(id) {
            return participants[id].user_name;
        }) : []));
        if (names.length === 0 && withoutNameCount === 1) {
            names.push((0,i18next.t)("people.someone"));
        } else if (withoutNameCount > 0 && nonDisplayableNamesCount === 0) {
            names.push((0,i18next.t)("people.guestsWithCount", {
                count: withoutNameCount
            }));
        } else if (withoutNameCount > 0 || nonDisplayableNamesCount > 0) {
            names.push((0,i18next.t)("people.othersWithCount", {
                count: nonDisplayableNamesCount + withoutNameCount
            }));
        }
        return (0,i18next.t)("people.reactionsList", {
            names: names,
            reaction: reaction,
            count: amountOfReactions
        });
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: reactionsRef,
        className: styled_jsx_default().dynamic([
            [
                "1405f0ef3b9733be",
                [
                    colors.background,
                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                    colors.accent,
                    colors.accent,
                    colors.accentText,
                    (0,pxToRem.pxToRem)(14)
                ]
            ]
        ]) + " " + "chat-reactions",
        children: [
            ChatProvider/* defaultReactions.filter */.zc.filter(function(r) {
                var ref;
                // filter out emojis that have at least one participantId
                return Object.values((ref1 = (ref = message.reactions) === null || ref === void 0 ? void 0 : ref[r]) !== null && ref1 !== void 0 ? ref1 : {}).some(function(ids) {
                    return ids.length > 0;
                });
            }).map(function(reaction) {
                var ref, ref3, ref4;
                var ref5;
                // id of participants who responded with the reaction in question
                var reactions = Object.values((ref5 = (ref = message.reactions) === null || ref === void 0 ? void 0 : ref[reaction]) !== null && ref5 !== void 0 ? ref5 : {});
                var ref6;
                var skinTonesWithReactions = Object.entries((ref6 = (ref3 = message.reactions) === null || ref3 === void 0 ? void 0 : ref3[reaction]) !== null && ref6 !== void 0 ? ref6 : {}).filter(function(param) {
                    var _param = ChatReactions_slicedToArray(param, 2), ids = _param[1];
                    return ids.length > 0;
                }).map(function(param) {
                    var _param = ChatReactions_slicedToArray(param, 1), skinTone = _param[0];
                    return skinTone;
                });
                var hasReacted = (0,advancedChat/* hasReactedBefore */.h)((ref4 = message.reactions) === null || ref4 === void 0 ? void 0 : ref4[reaction], localSessionId);
                var count = reactions.reduce(function(curr, arr) {
                    return curr + arr.length;
                }, 0);
                var ids1 = reactions.reduce(function(curr, arr) {
                    return ChatReactions_toConsumableArray(curr).concat(ChatReactions_toConsumableArray(arr));
                }, []);
                var modifiedEmoji = skinTonesWithReactions.join("");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                    /*#__PURE__*/ border: true,
                    id: "tt-".concat(message.id, "-").concat(reaction),
                    placement: "bottom",
                    style: {
                        maxWidth: 220
                    },
                    title: getTooltipTitle(modifiedEmoji, ids1, count),
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "chat-reaction-".concat(reaction, "-").concat(message.id),
                        className: classnames_default()({
                            hasReacted: hasReacted,
                            local: message.local
                        }),
                        onClick: function() {
                            return handleClick(reaction);
                        },
                        variant: "secondary",
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "1405f0ef3b9733be",
                                        [
                                            colors.background,
                                            isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                                            colors.accent,
                                            colors.accent,
                                            colors.accentText,
                                            (0,pxToRem.pxToRem)(14)
                                        ]
                                    ]
                                ]) + " " + "emoji",
                                children: modifiedEmoji
                            }),
                            count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                className: "count",
                                color: "inherit",
                                El: "span",
                                children: count >= 100 ? "99+" : count
                            }) : null
                        ]
                    })
                }, reaction);
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "1405f0ef3b9733be",
                dynamic: [
                    colors.background,
                    isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)",
                    colors.accent,
                    colors.accent,
                    colors.accentText,
                    (0,pxToRem.pxToRem)(14)
                ],
                children: ".chat-reactions.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:4px}.chat-reactions.__jsx-style-dynamic-selector button{background:".concat(colors.background, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:6px;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:24px;padding:6px 8px;position:relative;z-index:1}.chat-reactions.__jsx-style-dynamic-selector button.hasReacted{--blend:").concat(isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.7)", ";background:-webkit-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:-moz-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:-o-linear-gradient(bottom,var(--blend),var(--blend)),").concat(colors.accent, ";background:linear-gradient(0deg,var(--blend),var(--blend)),").concat(colors.accent, ";border-color:").concat(colors.accent, ";color:").concat(colors.accentText, "}.chat-reactions.__jsx-style-dynamic-selector .emoji.__jsx-style-dynamic-selector{font-size:").concat((0,pxToRem.pxToRem)(14), "}.chat-reactions.__jsx-style-dynamic-selector .count{font-variant-numeric:tabular-nums}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Chat/GiphyGif.tsx
function GiphyGif_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GiphyGif_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GiphyGif_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function GiphyGif_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = GiphyGif_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function GiphyGif_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var GiphyGif = function(_param) /*#__PURE__*/ {
    var title = _param.title, props = GiphyGif_objectWithoutProperties(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", GiphyGif_objectSpread({}, props, {
                alt: 'Giphy Gif with title "'.concat(title, '"'),
                className: "jsx-3dfdab4ca7a45e5f" + " " + (props && props.className != null && props.className || "")
            })),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "3dfdab4ca7a45e5f",
                children: "img.jsx-3dfdab4ca7a45e5f{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;display:block;width:100%}"
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Chat/GiphyIcon.tsx


var GiphyIcon = function() {
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: "Giphy Logo",
        src: "".concat(assetPrefix, "/giphy-36-light.png"),
        height: "12",
        width: "9"
    });
};

;// CONCATENATED MODULE: ./components/Chat/ChatMessage.tsx





















var MsgLink = function(href, text, key) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
        href: href,
        target: "_blank",
        /*#__PURE__*/ underline: true,
        children: text
    }, key);
};
var chatImageHeightState = (0,es/* atomFamily */.xu)({
    key: "chat-image-height",
    default: undefined
});
var chatImageVisibleState = (0,es/* atomFamily */.xu)({
    key: "chat-image-visible",
    default: true
});
var ChatMessage = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var enableAdvancedChat = param1.enableAdvancedChat, isLocal = param1.isLocal, message = param1.message, onRender = param1.onRender, _showBroadcast = param1.showBroadcast, showBroadcast = _showBroadcast === void 0 ? false : _showBroadcast, _showPrivate = param1.showPrivate, showPrivate = _showPrivate === void 0 ? false : _showPrivate, _showSender = param1.showSender, showSender = _showSender === void 0 ? false : _showSender, _showTimestamp = param1.showTimestamp, showTimestamp = _showTimestamp === void 0 ? false : _showTimestamp;
    var ref = (0,useTranslation/* useTranslation */.$)(), i18n = ref.i18n, t = ref.t;
    var ref1 = (0,Theme.useTheme)(), colors = ref1.colors, fontFamilies = ref1.fontFamilies, fontSizes = ref1.fontSizes, lineHeights = ref1.lineHeights, mediaQueries = ref1.mediaQueries;
    var msgRef = (0,react.useRef)(null);
    var textVariantSmall = (0,useStyleVariants/* useStyleVariants */._)().textVariantSmall;
    var reactToMessage = (0,ChatProvider/* useChatState */.RN)().reactToMessage;
    var giphyMatch = message.message.match(/!\[(.+-giphy)\|(\d+)\|(.+)\]\((.*)\)/i);
    var handleReaction = function(reaction) {
        reactToMessage(message, reaction);
    };
    /**
     * Call onRender to inform parent about potentially changed DOM.
     */ (0,useResizeObserver.useResizeObserver)(msgRef, (0,react.useCallback)(function() {
        onRender === null || onRender === void 0 ? void 0 : onRender(message === null || message === void 0 ? void 0 : message.id, msgRef.current);
    }, [
        message === null || message === void 0 ? void 0 : message.id,
        onRender
    ]));
    var imgHeight = (0,es/* useRecoilValue */.sJ)(chatImageHeightState(message.id));
    var imgVisible = (0,es/* useRecoilValue */.sJ)(chatImageVisibleState(message.id));
    var handleGifLoad = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(ev) {
            set(chatImageHeightState(message === null || message === void 0 ? void 0 : message.id), ev.currentTarget.clientHeight);
            onRender === null || onRender === void 0 ? void 0 : onRender(message === null || message === void 0 ? void 0 : message.id, msgRef.current);
        };
    }, [
        message === null || message === void 0 ? void 0 : message.id,
        onRender
    ]);
    var handleToggleGif = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(chatImageVisibleState(message === null || message === void 0 ? void 0 : message.id), function(prev) {
                return !prev;
            });
        };
    }, [
        message === null || message === void 0 ? void 0 : message.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: msgRef,
        className: styled_jsx_default().dynamic([
            [
                "a7cbdac0c660c39e",
                [
                    colors.backgroundAccent,
                    colors.baseText,
                    mediaQueries.coarse,
                    fontSizes.large,
                    lineHeights.large,
                    colors.accent,
                    colors.accentText,
                    fontFamilies.medium,
                    colors.baseText,
                    colors.accentText
                ]
            ]
        ]) + " " + (classnames_default()("chat-message", {
            local: isLocal,
            subsequent: !showSender && !showTimestamp,
            "with-sender": showSender
        }) || ""),
        children: [
            showTimestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                className: "chat-info time",
                color: "muted",
                textAlign: "center",
                variant: textVariantSmall,
                children: message.received.toLocaleTimeString(i18n.language, {
                    timeStyle: "short"
                })
            }),
            showBroadcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                className: "chat-info broadcast",
                color: "muted",
                textAlign: "center",
                variant: textVariantSmall,
                children: t("chat.broadcast")
            }),
            showPrivate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                className: "chat-info private",
                color: "muted",
                textAlign: "center",
                variant: textVariantSmall,
                children: t("chat.private")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "a7cbdac0c660c39e",
                        [
                            colors.backgroundAccent,
                            colors.baseText,
                            mediaQueries.coarse,
                            fontSizes.large,
                            lineHeights.large,
                            colors.accent,
                            colors.accentText,
                            fontFamilies.medium,
                            colors.baseText,
                            colors.accentText
                        ]
                    ]
                ]) + " " + (classnames_default()("msg", {
                    isLocal: isLocal,
                    gif: enableAdvancedChat && !!giphyMatch
                }) || ""),
                children: [
                    showSender && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                        El: "strong",
                        color: "inherit",
                        className: "sender",
                        variant: textVariantSmall,
                        children: [
                            message.local ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: message.name !== t("people.guest") ? t("people.you") : t("people.youGuest")
                            }) : message.name || t("people.guest"),
                            " "
                        ]
                    }),
                    enableAdvancedChat && giphyMatch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "chat-gif-toggle-".concat(message.id),
                        className: classnames_default()("gif-toggle", {
                            visible: imgVisible
                        }),
                        onClick: handleToggleGif,
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                El: "span",
                                color: "inherit",
                                variant: textVariantSmall,
                                children: [
                                    giphyMatch[1],
                                    " (",
                                    Math.round(parseInt(giphyMatch[2], 10) / 1024),
                                    "kb)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownIcon.CaretDownIcon, {
                                size: 16,
                                variant: "thick"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: imgVisible ? t("chat.hideGif") : t("chat.showGif")
                            })
                        ]
                    }) : null,
                    enableAdvancedChat && giphyMatch ? imgVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiphyGif, {
                                className: "giphy-img",
                                height: imgHeight,
                                onProgress: handleGifLoad,
                                onLoad: handleGifLoad,
                                title: giphyMatch[3],
                                src: giphyMatch[4]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                className: "powered-by-giphy",
                                color: message.local ? "inherit" : "muted",
                                variant: "small",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GiphyIcon, {}),
                                    " Powered by GIPHY"
                                ]
                            })
                        ]
                    }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        componentDecorator: MsgLink,
                        children: message.message.split("\n").map(function(line, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                        className: styled_jsx_default().dynamic([
                                            [
                                                "a7cbdac0c660c39e",
                                                [
                                                    colors.backgroundAccent,
                                                    colors.baseText,
                                                    mediaQueries.coarse,
                                                    fontSizes.large,
                                                    lineHeights.large,
                                                    colors.accent,
                                                    colors.accentText,
                                                    fontFamilies.medium,
                                                    colors.baseText,
                                                    colors.accentText
                                                ]
                                            ]
                                        ])
                                    }),
                                    line
                                ]
                            }, "line-".concat(line));
                        })
                    }),
                    enableAdvancedChat && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddReaction, {
                        onClickReaction: handleReaction
                    })
                ]
            }),
            enableAdvancedChat && (0,advancedChat/* hasReactions */.o)(message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "a7cbdac0c660c39e",
                        [
                            colors.backgroundAccent,
                            colors.baseText,
                            mediaQueries.coarse,
                            fontSizes.large,
                            lineHeights.large,
                            colors.accent,
                            colors.accentText,
                            fontFamilies.medium,
                            colors.baseText,
                            colors.accentText
                        ]
                    ]
                ]) + " " + "reactions",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatReactions, {
                    message: message,
                    onReact: handleReaction
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "a7cbdac0c660c39e",
                dynamic: [
                    colors.backgroundAccent,
                    colors.baseText,
                    mediaQueries.coarse,
                    fontSizes.large,
                    lineHeights.large,
                    colors.accent,
                    colors.accentText,
                    fontFamilies.medium,
                    colors.baseText,
                    colors.accentText
                ],
                children: ".chat-message.__jsx-style-dynamic-selector{--padding-h:12px;background:var(--card-bg);padding:2px 0}.chat-message.with-sender.__jsx-style-dynamic-selector{padding-top:10px}.chat-message.local.__jsx-style-dynamic-selector{padding-left:var(--padding-h)}.chat-message.__jsx-style-dynamic-selector:not(.local){padding-right:var(--padding-h)}.chat-message.__jsx-style-dynamic-selector .chat-info{font-variant-numeric:tabular-nums;padding:var(--padding-h)0}.chat-message.__jsx-style-dynamic-selector:not(.local) .chat-info{margin-right:-webkit-calc(-1*var(--padding-h));margin-right:-moz-calc(-1*var(--padding-h));margin-right:calc(-1*var(--padding-h))}.chat-message.local.__jsx-style-dynamic-selector .chat-info{margin-left:-webkit-calc(-1*var(--padding-h));margin-left:-moz-calc(-1*var(--padding-h));margin-left:calc(-1*var(--padding-h))}.chat-message.__jsx-style-dynamic-selector .chat-info.time+.chat-info{margin-top:-25px}.msg.__jsx-style-dynamic-selector{background:".concat(colors.backgroundAccent, ";-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;color:").concat(colors.baseText, ";padding:-webkit-calc(var(--padding-h) - 5px)var(--padding-h)-webkit-calc(var(--padding-h) - 3px);padding:-moz-calc(var(--padding-h) - 5px)var(--padding-h)-moz-calc(var(--padding-h) - 3px);padding:calc(var(--padding-h) - 5px)var(--padding-h)calc(var(--padding-h) - 3px);position:relative;word-break:break-word}@media ").concat(mediaQueries.coarse, "{.msg.__jsx-style-dynamic-selector{font-size:").concat(fontSizes.large, ";padding:12px;line-height:").concat(lineHeights.large, "}}.msg.isLocal.__jsx-style-dynamic-selector{background:").concat(colors.accent, ";-webkit-border-bottom-right-radius:0;-moz-border-radius-bottomright:0;border-bottom-right-radius:0;color:").concat(colors.accentText, "}.msg.__jsx-style-dynamic-selector:not(.isLocal){-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomleft:0;border-bottom-left-radius:0}.chat-message.subsequent.__jsx-style-dynamic-selector:not(.local) .msg.__jsx-style-dynamic-selector{-webkit-border-top-left-radius:0;-moz-border-radius-topleft:0;border-top-left-radius:0}.chat-message.subsequent.local.__jsx-style-dynamic-selector .msg.__jsx-style-dynamic-selector{-webkit-border-top-right-radius:0;-moz-border-radius-topright:0;border-top-right-radius:0}.msg.__jsx-style-dynamic-selector .sender{display:block;font-family:").concat(fontFamilies.medium, "}.msg.__jsx-style-dynamic-selector .gif-toggle{color:").concat(colors.baseText, "}.msg.isLocal.__jsx-style-dynamic-selector .gif-toggle{color:").concat(colors.accentText, "}.msg.__jsx-style-dynamic-selector .gif-toggle svg{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);-webkit-transition:-webkit-transform 250ms ease;-moz-transition:-moz-transform 250ms ease;-o-transition:-o-transform 250ms ease;transition:-webkit-transform 250ms ease;transition:-moz-transform 250ms ease;transition:-o-transform 250ms ease;transition:transform 250ms ease}.msg.__jsx-style-dynamic-selector .gif-toggle.visible svg{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}.msg.gif.__jsx-style-dynamic-selector .giphy-img{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;height:auto;margin:0 -4px;width:-webkit-calc(100% + 8px);width:-moz-calc(100% + 8px);width:calc(100% + 8px)}.msg.gif.__jsx-style-dynamic-selector .giphy-img{margin-top:4px}.chat-message.__jsx-style-dynamic-selector .powered-by-giphy{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-top:2px;margin-left:-4px}.chat-message.__jsx-style-dynamic-selector .powered-by-giphy picture,.chat-message.__jsx-style-dynamic-selector .powered-by-giphy img{display:block}.reactions.__jsx-style-dynamic-selector{display:block;margin-top:-4px;pointer-events:none;position:relative;-webkit-transition:opacity 200ms ease;-moz-transition:opacity 200ms ease;-o-transition:opacity 200ms ease;transition:opacity 200ms ease}")
            })
        ]
    });
});
ChatMessage.displayName = "ChatMessage";

;// CONCATENATED MODULE: ./components/Chat/ChatScrollView.tsx
function ChatScrollView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ChatScrollView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChatScrollView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var scrollBtnVisibleClass = "visible";
var ChatScrollView = function(param) {
    var loading = param.loading, showBroadcastMessages = param.showBroadcastMessages;
    var ref13, ref1, ref2;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref3 = (0,Theme.useTheme)(), colors = ref3.colors, isDarkMode = ref3.isDarkMode, mediaQueries = ref3.mediaQueries, zIndex = ref3.zIndex;
    var enableAdvancedChat = (0,useCallConfig/* useCallConfig */.A)().enableAdvancedChat;
    var ref4 = (0,ChatProvider/* useChatMessages */.mv)(), markMessagesAsRead = ref4.markMessagesAsRead, messages1 = ref4.messages;
    var chatRef = (0,react.useRef)(null);
    var innerRef = (0,react.useRef)(null);
    var lastScrollTime = (0,react.useRef)(0);
    var isScrolledToBottom = (0,react.useRef)(false);
    var ref5 = (0,react.useState)(false), /*#__PURE__*/ isVisible = ref5[0], setIsVisible = ref5[1];
    var ref6 = (0,react.useState)([]), renderedMessages = ref6[0], setRenderedMessages = ref6[1];
    var chatMessageHeights = (0,react.useRef)({});
    var ref7 = (0,react.useState)(0), updateHeightCount = ref7[0], setUpdateHeightCount = ref7[1];
    var ref8 = (0,react.useState)(false), enableVirtualScrolling = ref8[0], setEnableVirtualScrolling = ref8[1];
    var scrollToBottomRef = (0,react.useRef)(null);
    var isCoarse = (0,useMediaQuery.useMediaQuery)(mediaQueries.coarse);
    /**
   * Minimum height per chat message. Used to calculate minimum height of complete chat.
   */ var MIN_MSG_HEIGHT = (0,react.useMemo)(function() {
        return isCoarse ? 56 : 40;
    }, [
        isCoarse
    ]);
    var ref9 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), currentBreakoutRoom = ref9.currentBreakoutRoom, hasJoinedBreakout = ref9.hasJoinedBreakout;
    var filteredMessages = (0,react.useMemo)(function() {
        return messages1.filter(function(m) {
            return !hasJoinedBreakout && m.room === constants/* MAIN_ROOM_IDENTIFIER */.b || hasJoinedBreakout && m.room === currentBreakoutRoom.id || m.room === lib_constants/* BROADCAST_CHAT_MESSAGE */.cR;
        });
    }, [
        currentBreakoutRoom.id,
        hasJoinedBreakout,
        messages1
    ]);
    // returns an array with all messages that have at least 1 reaction
    var filterMessagesWithReactions = function(messages) {
        return messages.filter(advancedChat/* hasReactions */.o);
    };
    /**
   * Update rendered messages
   */ (0,react.useLayoutEffect)(function() {
        var scrollable = chatRef.current;
        if (!scrollable || loading) return;
        setRenderedMessages(function(rmsgs) {
            // Check if amount of messages or message structure changed.
            if (filteredMessages.length > rmsgs.length || rmsgs.some(function(m, i) {
                return !fast_deep_equal_default()(m, filteredMessages === null || filteredMessages === void 0 ? void 0 : filteredMessages[i]);
            })) {
                isScrolledToBottom.current = // Ignore subpixel rounding differences
                Math.abs(scrollable.scrollTop - (scrollable.scrollHeight - scrollable.clientHeight)) < 2;
                return filteredMessages;
            }
            return rmsgs;
        });
    }, [
        filteredMessages,
        loading
    ]);
    var previousRenderedMessages = (0,usePreviousValue/* usePreviousValue */.z)(renderedMessages);
    /**
   * Enable virtual scrolling when scroll container is actually scrollable.
   *
   * We don't enable virtual scrolling Safari 14:
   * There's a bug in Safari 14 where virtual scrolling breaks,
   * once the first message of the initial viewFrame is being removed.
   * When that happens the scroll container's clientHeight is briefly
   * set to its scrollHeight, which also resets the scrollTop to 0.
   * When that happens the viewFrame briefly updates to the next desired frame,
   * e.g. from [0, 33] to [1, 34], but immediately after to contain all messages,
   * e.g. [0, 55]. Due to the automatic reset of the scrollTop position, the user
   * is thrown back to the start of the chat.
   *
   * cst 2023-02-24:
   * I haven't found a way to work around this issue within our implementation
   * of virtual scrolling. I considered switching to @tanstack/react-virtual,
   * but the migration effort is relatively high and the last time I tried to
   * convert our chat to @tanstack/react-virtual, we ran into a couple of
   * undesirable issues. We might want to retry in the future, e.g. when
   * @tanstack/react-virtual@3.0.0 is out of beta.
   */ (0,useResizeObserver.useResizeObserver)(innerRef, (0,react.useCallback)(function() {
        var scrollable = chatRef.current;
        if (!scrollable || loading || enableVirtualScrolling || (0,browserConfig/* isSafari */.G6)(14, 14)) return;
        setEnableVirtualScrolling(function(enabled) {
            return enabled ? enabled : scrollable.scrollHeight > scrollable.clientHeight;
        });
    }, [
        enableVirtualScrolling,
        loading
    ]));
    /**
   * Allows to update rendered heights for multiple messages.
   */ var updateMessageHeights = (0,react.useCallback)(function(updates) {
        var oldHeights = ChatScrollView_objectSpread({}, chatMessageHeights.current);
        var newHeights = ChatScrollView_objectSpread({}, oldHeights, updates);
        chatMessageHeights.current = newHeights;
        if (!fast_deep_equal_default()(oldHeights, newHeights)) {
            setUpdateHeightCount(function(c) {
                return c + 1;
            });
        }
    }, []);
    /**
   * Index based boundaries for virtual scrolling.
   */ var ref10 = (0,react.useState)([
        Math.max(0, messages1.length - 15),
        Math.max(0, messages1.length - 1), 
    ]), viewFrame = ref10[0], setViewFrame = ref10[1];
    /**
   * Update relevant styles for virtual scrolling.
   */ (0,react.useEffect)(function() {
        if (!enableVirtualScrolling) {
            innerRef.current.style.height = "";
            innerRef.current.querySelectorAll("[data-msg-id]").forEach(function(msgEl) {
                msgEl.style.top = "";
            });
            return;
        }
        var ref15;
        var totalHeight = renderedMessages.reduce(function(sum, msg) {
            var ref14;
            return sum + ((ref15 = (ref14 = chatMessageHeights.current) === null || ref14 === void 0 ? void 0 : ref14[msg.id]) !== null && ref15 !== void 0 ? ref15 : MIN_MSG_HEIGHT);
        }, 0);
        innerRef.current.style.height = "".concat(totalHeight, "px");
        var ref12;
        var heightBefore = renderedMessages.slice(0, viewFrame[0]).reduce(function(sum, msg) {
            var ref;
            return sum + ((ref12 = (ref = chatMessageHeights.current) === null || ref === void 0 ? void 0 : ref[msg.id]) !== null && ref12 !== void 0 ? ref12 : MIN_MSG_HEIGHT);
        }, 0);
        var top = 0;
        innerRef.current.querySelectorAll("[data-msg-id]").forEach(function(msgEl) {
            var ref;
            var id = msgEl.getAttribute("data-msg-id");
            var ref16;
            var height = (ref16 = (ref = chatMessageHeights.current) === null || ref === void 0 ? void 0 : ref[id]) !== null && ref16 !== void 0 ? ref16 : MIN_MSG_HEIGHT;
            msgEl.style.top = "".concat(heightBefore + top, "px");
            top += height;
        });
    }, [
        enableVirtualScrolling,
        MIN_MSG_HEIGHT,
        renderedMessages,
        updateHeightCount,
        viewFrame, 
    ]);
    /**
   * Updates viewFrame for rendered messages, based on target's scroll position.
   */ var updateScrollFrame = (0,react.useCallback)(function(target) {
        var scrollTop = Math.ceil(target.scrollTop);
        var scrollBottom = scrollTop + target.clientHeight;
        var start;
        var end;
        var bottom = target.scrollHeight;
        if (enableVirtualScrolling) {
            /**
         * Chat is actually scrollable, so based on the scroll position
         * we'll have to find the messages of interest.
         * For that we'll loop through the messages and add each message's
         * height (or assumed fallback height) until we reach the actual
         * scroll frame visible to the user.
         * This way we can find the first and last visible messages at the
         * top and bottom of the scroll frame.
         */ for(var i = renderedMessages.length - 1; i >= 0; i--){
                var ref;
                var ref17;
                var msgHeight = (ref17 = (ref = chatMessageHeights.current) === null || ref === void 0 ? void 0 : ref[renderedMessages[i].id]) !== null && ref17 !== void 0 ? ref17 : MIN_MSG_HEIGHT;
                bottom -= msgHeight;
                if (bottom < scrollBottom && typeof end === "undefined") {
                    end = i;
                }
                if (bottom <= scrollTop && typeof start === "undefined") {
                    start = i;
                }
                // Once we found the boundaries we can stop the loop.
                if (typeof end !== "undefined" && typeof start !== "undefined") break;
            }
        } else {
            // No scrolling: render all messages.
            start = 0;
            end = renderedMessages.length - 1;
        }
        if (scrollTop < 10) start = 0;
        if (scrollTop > target.scrollHeight - target.clientHeight - 10) end = renderedMessages.length - 1;
        var buffer = Math.ceil(target.clientHeight / MIN_MSG_HEIGHT / 2);
        requestAnimationFrame(function() {
            setViewFrame([
                Math.max(0, (start !== null && start !== void 0 ? start : 0) - buffer),
                Math.max(0, Math.min(end + buffer, renderedMessages.length - 1)), 
            ]);
            if (scrollTop < target.scrollHeight - target.clientHeight) {
                var ref;
                scrollToBottomRef === null || scrollToBottomRef === void 0 ? void 0 : (ref = scrollToBottomRef.current) === null || ref === void 0 ? void 0 : ref.classList.add(scrollBtnVisibleClass);
            } else {
                var ref18;
                scrollToBottomRef === null || scrollToBottomRef === void 0 ? void 0 : (ref18 = scrollToBottomRef.current) === null || ref18 === void 0 ? void 0 : ref18.classList.remove(scrollBtnVisibleClass);
            }
        });
    }, [
        MIN_MSG_HEIGHT,
        enableVirtualScrolling,
        renderedMessages
    ]);
    /**
   * Update scroll frame, after messages were rendered.
   */ (0,react.useEffect)(function() {
        updateScrollFrame(chatRef.current);
    }, [
        renderedMessages,
        updateScrollFrame
    ]);
    /**
   * Trigger recalculation of viewFrame in case no messages are rendered.
   */ (0,react.useEffect)(function() {
        var renderedCount = viewFrame[1] - viewFrame[0];
        if (renderedMessages.length > 0 && renderedCount >= 0) return;
        var timeout = setTimeout(function() {
            setUpdateHeightCount(function(c) {
                return c + 1;
            });
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        renderedMessages,
        viewFrame
    ]);
    /**
   * Scrolls chat to the bottom.
   * Dependent of whether the chat is visible or not,
   * scrolling is done instantly (invisible) or smoothly (visible).
   */ var scrollToBottom = (0,react.useCallback)(function() {
        if (!chatRef.current || loading) return;
        var timeout = setTimeout(function() {
            var scrollable = chatRef.current;
            if (!scrollable) return;
            lastScrollTime.current = new Date().getTime();
            scrollable.scrollTop = scrollable.scrollHeight;
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        loading
    ]);
    /**
   * Initially show chat
   */ (0,react.useEffect)(function() {
        var scrollable = chatRef.current;
        if (!scrollable || loading || isVisible) return;
        var interval = setInterval(function() {
            // Keep scrolling to bottom until we eventually reach the bottom.
            if (scrollable.scrollTop >= Math.max(0, scrollable.scrollHeight - scrollable.clientHeight - 10)) {
                setIsVisible(true);
                markMessagesAsRead();
                return;
            }
            scrollable.scrollTop = scrollable.scrollHeight;
        }, 250);
        return function() {
            clearInterval(interval);
            markMessagesAsRead();
        };
    }, [
        isVisible,
        loading,
        markMessagesAsRead,
        scrollToBottom,
        updateHeightCount,
        viewFrame, 
    ]);
    /**
   * Automatically scroll to bottom.
   */ (0,react.useLayoutEffect)(function() {
        var lastMessage = renderedMessages === null || renderedMessages === void 0 ? void 0 : renderedMessages[renderedMessages.length - 1];
        // Last new message was sent from local
        if (renderedMessages.length > (previousRenderedMessages === null || previousRenderedMessages === void 0 ? void 0 : previousRenderedMessages.length) && (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.local)) {
            scrollToBottom();
        }
        // First reaction was added to any message while scrolled down
        var prevMessagesWithReactions = filterMessagesWithReactions(previousRenderedMessages !== null && previousRenderedMessages !== void 0 ? previousRenderedMessages : []);
        var messagesWithReactions = filterMessagesWithReactions(renderedMessages);
        if ((previousRenderedMessages === null || previousRenderedMessages === void 0 ? void 0 : previousRenderedMessages.length) === renderedMessages.length && prevMessagesWithReactions.length !== messagesWithReactions.length && isScrolledToBottom.current) {
            scrollToBottom();
        }
        // Chat was scrolled to bottom previously -> continue scrolling to bottom
        if (renderedMessages.length > (previousRenderedMessages === null || previousRenderedMessages === void 0 ? void 0 : previousRenderedMessages.length) && isScrolledToBottom.current) {
            scrollToBottom();
        }
        // Have less than 500ms passed since the last scroll event?
        // If yes, we'll assume we are still scrolling.
        var isScrolling = lastScrollTime.current && new Date().getTime() < lastScrollTime.current + 500;
        if (isScrolling) {
            scrollToBottom();
        }
    }, [
        previousRenderedMessages,
        renderedMessages,
        scrollToBottom
    ]);
    var chatMessageRenderTimeout = (0,react.useRef)(null);
    var updatedMessageHeights = (0,react.useRef)({});
    var handleMessageRender = (0,react.useCallback)(function(id, el) {
        var oldMsg = messages1.find(function(msg) {
            return msg.id === id;
        });
        if (!oldMsg || !el) return;
        cancelAnimationFrame(chatMessageRenderTimeout.current);
        updatedMessageHeights.current[id] = el.clientHeight;
        chatMessageRenderTimeout.current = requestAnimationFrame(function() {
            updateMessageHeights(updatedMessageHeights.current);
            updatedMessageHeights.current = {};
        });
        /**
       * In case the last message reports an updated height (e.g. when a GIF loaded),
       * scroll to the bottom.
       */ if (id === messages1[messages1.length - 1].id && el.clientHeight > chatMessageHeights.current[id] && isScrolledToBottom.current) scrollToBottom();
    }, [
        messages1,
        scrollToBottom,
        updateMessageHeights
    ]);
    var wrappedChatMessages = (0,react.useMemo)(function() {
        var lastRenderedTime = 0;
        return renderedMessages.map(function(msg, i) {
            var fromId = msg.fromId, received = msg.received;
            var prevMsg = renderedMessages === null || renderedMessages === void 0 ? void 0 : renderedMessages[i - 1];
            var isNew5MinChunk = lastRenderedTime < received.getTime() - 5 * 60 * 1000;
            if (isNew5MinChunk) {
                lastRenderedTime = received.getTime();
            }
            var isDifferentSender = (prevMsg === null || prevMsg === void 0 ? void 0 : prevMsg.fromId) !== fromId;
            var showBroadcast = showBroadcastMessages && msg.room === lib_constants/* BROADCAST_CHAT_MESSAGE */.cR && (isNew5MinChunk || (prevMsg === null || prevMsg === void 0 ? void 0 : prevMsg.room) !== lib_constants/* BROADCAST_CHAT_MESSAGE */.cR);
            var showPrivate = showBroadcastMessages && msg.room !== lib_constants/* BROADCAST_CHAT_MESSAGE */.cR && (isNew5MinChunk || (prevMsg === null || prevMsg === void 0 ? void 0 : prevMsg.room) === lib_constants/* BROADCAST_CHAT_MESSAGE */.cR);
            return ChatScrollView_objectSpread({}, msg, {
                showBroadcast: showBroadcast,
                showPrivate: showPrivate,
                showSender: isDifferentSender || isNew5MinChunk,
                showTimestamp: isNew5MinChunk
            });
        }).slice(viewFrame[0], viewFrame[1] + 1).map(function(msg) {
            var id = msg.id, local = msg.local;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("message-wrapper", {
                    local: local
                }),
                "data-msg-id": id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatMessage, {
                    enableAdvancedChat: enableAdvancedChat,
                    message: msg,
                    isLocal: local,
                    onRender: handleMessageRender,
                    showBroadcast: msg.showBroadcast,
                    showPrivate: msg.showPrivate,
                    showSender: msg.showSender,
                    showTimestamp: msg.showTimestamp
                })
            }, id);
        });
    }, [
        enableAdvancedChat,
        handleMessageRender,
        renderedMessages,
        showBroadcastMessages,
        viewFrame, 
    ]);
    var handleScroll = function(ev) {
        updateScrollFrame(ev.currentTarget);
    };
    var handleScrollToBottomClick = function() {
        scrollToBottom();
        scrollToBottomRef.current.classList.remove(scrollBtnVisibleClass);
    };
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onScroll: enableVirtualScrolling ? handleScroll : null,
        ref: chatRef,
        className: styled_jsx_default().dynamic([
            [
                "f27c8399f376f9db",
                [
                    isDarkMode ? "dark" : "light",
                    colors.backgroundAccent,
                    zIndex.tooltip,
                    scrollBtnVisibleClass
                ]
            ]
        ]) + " " + (classnames_default()("messages", {
            virtual: enableVirtualScrolling,
            visible: isVisible
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: innerRef,
                className: styled_jsx_default().dynamic([
                    [
                        "f27c8399f376f9db",
                        [
                            isDarkMode ? "dark" : "light",
                            colors.backgroundAccent,
                            zIndex.tooltip,
                            scrollBtnVisibleClass
                        ]
                    ]
                ]) + " " + "messages-inner",
                children: wrappedChatMessages
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                id: "chat-scroll-to-bottom",
                ref: scrollToBottomRef,
                className: classnames_default()("scroll-to-bottom", {
                    visible: Math.ceil((ref11 = (ref13 = chatRef.current) === null || ref13 === void 0 ? void 0 : ref13.scrollTop) !== null && ref11 !== void 0 ? ref11 : 0) < ((ref1 = chatRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) - ((ref2 = chatRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientHeight)
                }),
                variant: "secondary",
                onClick: handleScrollToBottomClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownIcon.CaretDownIcon, {
                        size: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: t("general.scrollToBottom")
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f27c8399f376f9db",
                dynamic: [
                    isDarkMode ? "dark" : "light",
                    colors.backgroundAccent,
                    zIndex.tooltip,
                    scrollBtnVisibleClass
                ],
                children: ".messages.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;isolation:isolate;opacity:0;overflow-x:hidden;overflow-y:auto;position:relative;scrollbar-color:".concat(isDarkMode ? "dark" : "light", ";scroll-behavior:auto;-webkit-transition:opacity 250ms ease;-moz-transition:opacity 250ms ease;-o-transition:opacity 250ms ease;transition:opacity 250ms ease}.messages.visible.__jsx-style-dynamic-selector{opacity:1;scroll-behavior:smooth}.messages-inner.__jsx-style-dynamic-selector{min-height:100%;padding:0 var(--padding);position:relative}.messages.__jsx-style-dynamic-selector:not(.virtual) .messages-inner.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.virtual.__jsx-style-dynamic-selector .message-wrapper{left:var(--padding);position:absolute;top:var(--padding);width:-webkit-calc(100% - 2*var(--padding));width:-moz-calc(100% - 2*var(--padding));width:calc(100% - 2*var(--padding))}.messages.__jsx-style-dynamic-selector .scroll-to-bottom{background:").concat(colors.backgroundAccent, ";bottom:8px;-webkit-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);-moz-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);float:right;margin-right:4px;margin-top:-34px;opacity:0;padding:8px 12px;pointer-events:none;position:-webkit-sticky;position:sticky;-webkit-transition:opacity 250ms ease 0ms;-moz-transition:opacity 250ms ease 0ms;-o-transition:opacity 250ms ease 0ms;transition:opacity 250ms ease 0ms;z-index:").concat(zIndex.tooltip, "}.messages.__jsx-style-dynamic-selector .scroll-to-bottom.").concat(scrollBtnVisibleClass, "{opacity:1;pointer-events:all;-webkit-transition-delay:500ms;-moz-transition-delay:500ms;-o-transition-delay:500ms;transition-delay:500ms}")
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/emoji-mart/dist-es/index.js + 22 modules
var dist_es = __webpack_require__(5829);
// EXTERNAL MODULE: ./node_modules/emoji-mart/data/all.json
var data_all = __webpack_require__(7232);
;// CONCATENATED MODULE: ./components/Chat/EmojiMenu.tsx
function EmojiMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EmojiMenu_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EmojiMenu_arrayLikeToArray(arr);
}
function EmojiMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EmojiMenu_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EmojiMenu_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EmojiMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EmojiMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EmojiMenu_toConsumableArray(arr) {
    return EmojiMenu_arrayWithoutHoles(arr) || EmojiMenu_iterableToArray(arr) || EmojiMenu_unsupportedIterableToArray(arr) || EmojiMenu_nonIterableSpread();
}
function EmojiMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EmojiMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EmojiMenu_arrayLikeToArray(o, minLen);
}














var categories = Object.fromEntries(data_all.categories.map(function(c) {
    return [
        c.id,
        c
    ];
}));
var sortedCategories = Object.keys(categories);
var categoryValues = Object.values(categories);
var COLUMNS = 6;
var EmojiMenu = function(param1) {
    var filter = param1.filter, onClose = param1.onClose, onSelect = param1.onSelect;
    var colors = (0,Theme.useTheme)().colors;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref5 = (0,react.useState)([]), /*#__PURE__*/ emojiList = ref5[0], setEmojiList = ref5[1];
    var ref1 = (0,react.useState)(0), highlightedIndex = ref1[0], setHighlightedIndex = ref1[1];
    var ref2 = (0,react.useState)(""), searchTerm = ref2[0], setSearchTerm = ref2[1];
    var menuRef = (0,react.useRef)(null);
    var scrollRef = (0,react.useRef)(null);
    var spaceBeforeRef = (0,react.useRef)(null);
    var spaceAfterRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)([
        0,
        36
    ]), renderRange = ref3[0], setRenderRange = ref3[1];
    (0,useClosable.useClosable)({
        onClose: onClose,
        ref: menuRef
    }, []);
    var localizedCategories = {
        Activities: t("emoji.categories.activity"),
        Flags: t("emoji.categories.flags"),
        "Food & Drink": t("emoji.categories.foods"),
        "Animals & Nature": t("emoji.categories.nature"),
        Objects: t("emoji.categories.objects"),
        "Smileys & People": t("emoji.categories.people"),
        "Travel & Places": t("emoji.categories.places"),
        Symbols: t("emoji.categories.symbols")
    };
    (0,react.useEffect)(function() {
        var emojis1 = [];
        var search = filter || searchTerm;
        if (search) {
            emojis1 = dist_es/* emojiIndex.search */.bj.search(search);
        } else {
            emojis1 = Object.values(dist_es/* emojiIndex.emojis */.bj.emojis).map(function(o) {
                return "1" in o ? o["1"] : o;
            });
        }
        var emojisWithCategories = emojis1.map(function(emoji) {
            return EmojiMenu_objectSpread({}, emoji, {
                category: categoryValues.find(function(param) {
                    var emojis = param.emojis;
                    return emojis.includes(emoji.id);
                })
            });
        }).filter(function(emoji) {
            return emoji.category;
        });
        setEmojiList(emojisWithCategories.sort(function(a, b) {
            var ref, ref4;
            var aIdx = sortedCategories.indexOf((ref = a.category) === null || ref === void 0 ? void 0 : ref.id);
            var bIdx = sortedCategories.indexOf((ref4 = b.category) === null || ref4 === void 0 ? void 0 : ref4.id);
            if (aIdx < bIdx) return -1;
            if (aIdx > bIdx) return 1;
            return 0;
        }));
        setHighlightedIndex(0);
        scrollRef.current.scrollTop = 0;
    }, [
        filter,
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        var unsubscribe = (0,tinykeys_module/* default */.Z)(document.body, {
            ArrowDown: function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    var currentEmoji = emojiList[i];
                    var targetIndex = i + COLUMNS;
                    var targetEmoji = emojiList[targetIndex];
                    var col = emojiList.filter(function(emoji) {
                        return emoji.category.id === currentEmoji.category.id;
                    }).findIndex(function(emoji) {
                        return emoji.id === currentEmoji.id;
                    }) % COLUMNS;
                    if (targetEmoji && (targetEmoji === null || targetEmoji === void 0 ? void 0 : targetEmoji.category.id) !== (currentEmoji === null || currentEmoji === void 0 ? void 0 : currentEmoji.category.id)) {
                        var nextFirst = emojiList.find(function(emoji, idx) {
                            return emoji.category.id !== (currentEmoji === null || currentEmoji === void 0 ? void 0 : currentEmoji.category.id) && idx > i;
                        });
                        var nextCategory = emojiList.filter(function(emoji) {
                            return emoji.category.id === nextFirst.category.id;
                        });
                        targetIndex = emojiList.findIndex(function(emoji, idx) {
                            return emoji.category.id !== (currentEmoji === null || currentEmoji === void 0 ? void 0 : currentEmoji.category.id) && idx > i;
                        }) + Math.min(nextCategory.length - 1, col);
                    }
                    return Math.min(emojiList.length - 1, targetIndex);
                });
            },
            ArrowUp: function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    var currentEmoji = emojiList[i];
                    var targetIndex = Math.max(0, i - COLUMNS);
                    var targetEmoji = emojiList[targetIndex];
                    var col = emojiList.filter(function(emoji) {
                        return emoji.category.id === currentEmoji.category.id;
                    }).findIndex(function(emoji) {
                        return emoji.id === currentEmoji.id;
                    }) % COLUMNS;
                    if (targetEmoji && (targetEmoji === null || targetEmoji === void 0 ? void 0 : targetEmoji.category.id) !== (currentEmoji === null || currentEmoji === void 0 ? void 0 : currentEmoji.category.id)) {
                        var prevLastIdx = emojiList.findIndex(function(emoji) {
                            return emoji.category.id === currentEmoji.category.id;
                        }) - 1;
                        var prevLast = emojiList[prevLastIdx];
                        var prevCategory = emojiList.filter(function(emoji) {
                            var ref;
                            return emoji.category.id === (prevLast === null || prevLast === void 0 ? void 0 : (ref = prevLast.category) === null || ref === void 0 ? void 0 : ref.id);
                        });
                        var lastCol = prevCategory.length % COLUMNS;
                        var lastRow = prevCategory.slice(lastCol > 0 ? -lastCol : -COLUMNS);
                        targetIndex = emojiList.findIndex(function(emoji) {
                            return (lastRow === null || lastRow === void 0 ? void 0 : lastRow[col]) ? emoji.id === lastRow[col].id : emoji.id === prevLast.id;
                        });
                    }
                    return Math.max(0, targetIndex);
                });
            },
            ArrowLeft: function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    return Math.max(0, i - 1);
                });
            },
            ArrowRight: function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    return Math.min(emojiList.length - 1, i + 1);
                });
            },
            Enter: function(ev) {
                ev.preventDefault();
                onSelect(emojiList[highlightedIndex].native);
                onClose === null || onClose === void 0 ? void 0 : onClose();
            },
            Tab: function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    return Math.min(emojiList.length - 1, i + 1);
                });
            },
            "Shift+Tab": function(ev) {
                ev.preventDefault();
                setHighlightedIndex(function(i) {
                    return Math.max(0, i - 1);
                });
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        emojiList,
        highlightedIndex,
        onClose,
        onSelect
    ]);
    (0,react.useEffect)(function() {
        if (!menuRef.current) return;
        var emoji = menuRef.current.querySelector(".unoEmoji.highlighted");
        if (!emoji) return;
        var results = menuRef.current.querySelector(".results");
        var ref = results.getBoundingClientRect(), resultsHeight = ref.height, resultsTop = ref.top;
        var ref6 = emoji.getBoundingClientRect(), emojiTop = ref6.top;
        results.scrollTo({
            behavior: "smooth",
            top: results.scrollTop + (emojiTop - resultsTop) - (resultsHeight + 12) / 2
        });
    }, [
        highlightedIndex
    ]);
    (0,react.useEffect)(function() {
        if (!menuRef.current) return;
        var results = menuRef.current.querySelector(".results");
        var chunks = emojiList.reduce(function(res, emoji, i, arr) {
            var ref, ref7;
            if (i === 0 || (arr === null || arr === void 0 ? void 0 : (ref = arr[i - 1]) === null || ref === void 0 ? void 0 : (ref7 = ref.category) === null || ref7 === void 0 ? void 0 : ref7.id) !== emoji.category.id) {
                res.push([]);
            }
            res[res.length - 1].push(emoji);
            return res;
        }, []);
        var getChunkHeight = function(chunk) {
            var lastChunk = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var menu = menuRef.current;
            var category = menu === null || menu === void 0 ? void 0 : menu.querySelector(".category");
            var grid = menu === null || menu === void 0 ? void 0 : menu.querySelector(".grid");
            var emoji = menu === null || menu === void 0 ? void 0 : menu.querySelector(".unoEmoji");
            var ref;
            var headerHeight = (ref = category === null || category === void 0 ? void 0 : category.clientHeight) !== null && ref !== void 0 ? ref : 36;
            var gapHeight = grid && window.getComputedStyle(grid).gap ? parseInt(window.getComputedStyle(grid).gap, 10) : 8;
            var rowHeight = emoji ? emoji.clientHeight : 24;
            var rows = Math.ceil(chunk.length / COLUMNS);
            return headerHeight + rows * rowHeight + (lastChunk ? rows : rows + 1) * gapHeight;
        };
        var handleScroll = function() {
            var _Math;
            var scrollTop = results.scrollTop;
            var scrollBottom = scrollTop + results.clientHeight;
            var beforeSpace = 0;
            var afterSpace = 0;
            var chunksToRender = [];
            var height = 0;
            for(var i1 = 0; i1 < chunks.length; i1++){
                var chunkHeight = getChunkHeight(chunks[i1], i1 === chunks.length - 1);
                var chunkTop = height;
                var chunkBottom = chunkTop + chunkHeight;
                height += chunkHeight;
                if (chunkBottom < scrollTop) {
                    // Chunk is somewhere up
                    beforeSpace += chunkHeight;
                } else if (chunkTop > scrollBottom) {
                    // Chunk is somewhere down
                    afterSpace += chunkHeight;
                } else if (chunkTop <= scrollBottom && chunkBottom >= scrollTop) {
                    // Chunk is (partially) visible
                    chunksToRender.push(i1);
                }
            }
            var chunkLengths = chunks.map(function(c) {
                return c.length;
            });
            var startIdx = chunkLengths.filter(function(_, i) {
                return i < (_Math = Math).min.apply(_Math, EmojiMenu_toConsumableArray(chunksToRender));
            }).reduce(function(sum, count) {
                return sum + count;
            }, 0);
            var endIdx = startIdx + chunksToRender.reduce(function(sum, idx) {
                return sum + chunkLengths[idx];
            }, 0);
            if (spaceBeforeRef.current) spaceBeforeRef.current.style.height = "".concat(beforeSpace, "px");
            if (spaceAfterRef.current) spaceAfterRef.current.style.height = "".concat(afterSpace, "px");
            setRenderRange([
                startIdx,
                endIdx
            ]);
        };
        handleScroll();
        results.addEventListener("scroll", handleScroll);
        return function() {
            results.removeEventListener("scroll", handleScroll);
        };
    }, [
        emojiList
    ]);
    var handleSearchChange = function(ev) {
        setSearchTerm(ev.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: menuRef,
        className: styled_jsx_default().dynamic([
            [
                "5e9e7118bdd80d9",
                [
                    (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                ]
            ]
        ]) + " " + "emojiMenu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
                children: [
                    !filter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardHeader, {
                        className: "search",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            autoFocus: true,
                            value: searchTerm,
                            placeholder: t("emoji.searchPlaceholder"),
                            onChange: handleSearchChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: scrollRef,
                        className: styled_jsx_default().dynamic([
                            [
                                "5e9e7118bdd80d9",
                                [
                                    (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                                ]
                            ]
                        ]) + " " + "results",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: spaceBeforeRef,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "5e9e7118bdd80d9",
                                            [
                                                (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                                            ]
                                        ]
                                    ])
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "5e9e7118bdd80d9",
                                            [
                                                (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                                            ]
                                        ]
                                    ]) + " " + "grid",
                                    children: emojiList.slice(renderRange[0], renderRange[1]).map(function(emoji, i, arr) {
                                        var ref, ref8;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                (i === 0 || (arr === null || arr === void 0 ? void 0 : (ref = arr[i - 1]) === null || ref === void 0 ? void 0 : (ref8 = ref.category) === null || ref8 === void 0 ? void 0 : ref8.id) !== emoji.category.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: styled_jsx_default().dynamic([
                                                        [
                                                            "5e9e7118bdd80d9",
                                                            [
                                                                (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                                                            ]
                                                        ]
                                                    ]) + " " + "category",
                                                    children: localizedCategories[emoji.category.name]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                    id: "chat-emoji-".concat(emoji.id),
                                                    className: classnames_default()("unoEmoji", {
                                                        highlighted: renderRange[0] + i === highlightedIndex
                                                    }),
                                                    variant: "ghost",
                                                    onClick: function() {
                                                        onSelect(emoji.native);
                                                        onClose === null || onClose === void 0 ? void 0 : onClose();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Emoji */.dy, {
                                                        emoji: emoji.id,
                                                        set: "apple",
                                                        size: 24
                                                    })
                                                }, emoji.id)
                                            ]
                                        }, emoji.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: spaceAfterRef,
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "5e9e7118bdd80d9",
                                            [
                                                (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                                            ]
                                        ]
                                    ])
                                })
                            ]
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5e9e7118bdd80d9",
                dynamic: [
                    (0,lib_colors.hexToRgba)(colors.accent, 0.6)
                ],
                children: '.emojiMenu.__jsx-style-dynamic-selector{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end;height:40vh;max-height:200px;max-width:233px;width:100%}.emojiMenu.__jsx-style-dynamic-selector .search{margin-bottom:1px;padding:8px}.emojiMenu.__jsx-style-dynamic-selector .results{overflow:auto}.grid.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin-top:-16px}.category.__jsx-style-dynamic-selector{background:var(--card-bg);border-bottom:1px solid var(--card-border);padding:15px 0 4px;position:-webkit-sticky;position:sticky;top:0px;width:100%;z-index:2}.category.__jsx-style-dynamic-selector::before,.category.__jsx-style-dynamic-selector::after{background:var(--card-bg);content:"";height:100%;position:absolute;top:0;width:8px}.category.__jsx-style-dynamic-selector::before{right:100%}.category.__jsx-style-dynamic-selector::after{left:100%}.emojiMenu.__jsx-style-dynamic-selector .unoEmoji{cursor:pointer;height:24px}.emojiMenu.__jsx-style-dynamic-selector .unoEmoji.highlighted{-webkit-box-shadow:0 0 0 2px '.concat((0,lib_colors.hexToRgba)(colors.accent, 0.6), ";-moz-box-shadow:0 0 0 2px ").concat((0,lib_colors.hexToRgba)(colors.accent, 0.6), ";box-shadow:0 0 0 2px ").concat((0,lib_colors.hexToRgba)(colors.accent, 0.6), "}.emojiMenu.__jsx-style-dynamic-selector .emoji-mart-emoji{display:block;height:24px}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/ReverseIcon.js
var ReverseIcon = __webpack_require__(8244);
;// CONCATENATED MODULE: ./components/Chat/GiphyPreview.tsx











var GiphyPreview = function(param) {
    var onCancel = param.onCancel, onLoad = param.onLoad, onRefresh = param.onRefresh, onSubmit = param.onSubmit, title = param.title, url = param.url;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleLoad = function() {
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-c692d931fe9fc0cd" + " " + "gifPreview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                        style: {
                            padding: 0
                        },
                        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiphyGif, {
                            style: {
                                borderRadius: 0
                            },
                            title: title,
                            src: url,
                            onLoad: handleLoad
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardFooter, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusTrap.FocusTrap, {
                            arrowKeys: "leftright",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                        id: "chat-giphy-submit",
                                        onClick: onSubmit,
                                        variant: "primary",
                                        children: t("chat.submit")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                        id: "chat-giphy-refresh",
                                        className: "btn-refresh",
                                        onClick: onRefresh,
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                                children: t("giphy.refresh")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReverseIcon/* ReverseIcon */.E, {
                                                size: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                        id: "chat-giphy-cancel",
                                        className: "btn-cancel",
                                        onClick: onCancel,
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                                children: t("general.cancel")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                                size: 16,
                                                variant: "thick"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c692d931fe9fc0cd",
                children: ".gifPreview.jsx-c692d931fe9fc0cd img{display:block;width:100%}.gifPreview.jsx-c692d931fe9fc0cd .btn-refresh,.gifPreview.jsx-c692d931fe9fc0cd .btn-cancel{padding-inline:7px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Chat/useGiphySearch.ts
function useGiphySearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGiphySearch_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGiphySearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGiphySearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var MAX_GIFS_PER_SEARCH = 25;
var useGiphySearch = function(q1) {
    var ref = (0,useTranslation/* useTranslation */.$)(), i18n = ref.i18n, t = ref.t;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref1 = (0,react.useState)(null), gif = ref1[0], setGif = ref1[1];
    var ref2 = (0,react.useState)([]), availableGifs = ref2[0], setAvailableGifs = ref2[1];
    var ref3 = (0,react.useState)(0), searchOffset = ref3[0], setSearchOffset = ref3[1];
    var ref4 = (0,react.useState)(false), fetchRandom = ref4[0], setFetchRandom = ref4[1];
    /**
   * Sanitize lang param for GIPHY API
   */ var giphyLang = (0,react.useMemo)(function() {
        // Fix Japanese ISO key
        if (i18n.language === "jp") return "ja";
        // Fallback to en
        if ([
            "ka"
        ].includes(i18n.language)) return "en";
        return i18n.language;
    }, [
        i18n.language
    ]);
    var displayError = (0,react.useCallback)(function() {
        addMessage({
            content: t("giphy.fetchFailed"),
            type: "error"
        });
    }, [
        addMessage,
        t
    ]);
    var fetchRandomGif = (0,react.useCallback)(function() {
        var _ref = useGiphySearch_asyncToGenerator(runtime_default().mark(function _callee(q) {
            var response, parsedResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.giphy.com/v1/gifs/random?api_key=".concat("zuy9F08tii07vqWC4pV8DCdwvJlMl7Kq", "&rating=pg&lang=").concat(giphyLang));
                    case 3:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return response.json();
                    case 7:
                        parsedResponse = _ctx.sent;
                        setGif({
                            q: q,
                            size: parseInt(parsedResponse.data.images.fixed_height.size, 10),
                            title: parsedResponse.data.title,
                            url: parsedResponse.data.images.fixed_height.url
                        });
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        displayError();
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(q) {
            return _ref.apply(this, arguments);
        };
    }(), [
        displayError,
        giphyLang
    ]);
    var searchGifs = (0,react.useCallback)(function() {
        var _ref = useGiphySearch_asyncToGenerator(runtime_default().mark(function _callee(q) {
            var response, parsedResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.giphy.com/v1/gifs/search?api_key=".concat("zuy9F08tii07vqWC4pV8DCdwvJlMl7Kq", "&q=").concat(q, "&limit=").concat(MAX_GIFS_PER_SEARCH, "&offset=0&rating=pg&lang=").concat(giphyLang));
                    case 3:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 7;
                        return response.json();
                    case 7:
                        parsedResponse = _ctx.sent;
                        if (parsedResponse.data.length) {
                            _ctx.next = 11;
                            break;
                        }
                        setFetchRandom(true);
                        return _ctx.abrupt("return");
                    case 11:
                        setAvailableGifs(parsedResponse.data.map(function(result) {
                            return {
                                q: q,
                                size: parseInt(result.images.fixed_height.size, 10),
                                title: result.title,
                                url: result.images.fixed_height.url
                            };
                        }));
                        setSearchOffset(0);
                    case 13:
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        displayError();
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(q) {
            return _ref.apply(this, arguments);
        };
    }(), [
        displayError,
        giphyLang
    ]);
    (0,react.useEffect)(function() {
        if (!q1) {
            setAvailableGifs([]);
            setFetchRandom(false);
            setGif(null);
            setSearchOffset(0);
            return;
        }
        fetchRandom ? fetchRandomGif(q1) : searchGifs(q1);
    }, [
        fetchRandom,
        fetchRandomGif,
        q1,
        searchGifs
    ]);
    var refresh = (0,react.useCallback)(function() {
        if (!q1) return;
        fetchRandom ? fetchRandomGif(q1) : setSearchOffset(function(prevOffset) {
            return (prevOffset + 1) % availableGifs.length;
        });
    }, [
        availableGifs.length,
        fetchRandom,
        fetchRandomGif,
        q1
    ]);
    (0,react.useEffect)(function() {
        if (!availableGifs.length) return;
        setGif(availableGifs[searchOffset]);
    }, [
        availableGifs,
        searchOffset
    ]);
    return {
        gif: gif,
        refresh: refresh
    };
};

;// CONCATENATED MODULE: ./components/Chat/Chat.tsx
function Chat_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Chat_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Chat_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Chat_arrayLikeToArray(arr);
}
function Chat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Chat_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Chat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Chat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Chat_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Chat_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Chat_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Chat_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Chat_slicedToArray(arr, i) {
    return Chat_arrayWithHoles(arr) || Chat_iterableToArrayLimit(arr, i) || Chat_unsupportedIterableToArray(arr, i) || Chat_nonIterableRest();
}
function Chat_toConsumableArray(arr) {
    return Chat_arrayWithoutHoles(arr) || Chat_iterableToArray(arr) || Chat_unsupportedIterableToArray(arr) || Chat_nonIterableSpread();
}
function Chat_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Chat_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Chat_arrayLikeToArray(o, minLen);
}



































/**
 * ChatDownload uses the library "streamsaver" that only works in browser.
 * So we import the component dynamically with the "ssr: false" flag.
 */ var ChatDownload = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 798).then(__webpack_require__.bind(__webpack_require__, 3798)).then(function(mod) {
        return mod.ChatDownload;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3798)
            ];
        }
    },
    ssr: false
});
var CHAR_LIMIT = 256;
var localChatMessageState = (0,es/* atom */.cn)({
    key: "local-chat-message",
    default: ""
});
var Chat = function() {
    var ref = (0,Theme.useTheme)(), colors = ref.colors, mediaQueries = ref.mediaQueries;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref1.broadcastRole, enableAdvancedChat = ref1.enableAdvancedChat, enableBreakoutRooms = ref1.enableBreakoutRooms, optimizeLargeCalls = ref1.optimizeLargeCalls;
    var ref2 = (0,useStyleVariants/* useStyleVariants */._)(), iconVariant = ref2.iconVariant, textVariantSmall = ref2.textVariantSmall;
    var ref3 = (0,ChatProvider/* useChatState */.RN)(), loading = ref3.loading, sendMessage = ref3.sendMessage;
    var messages = (0,ChatProvider/* useChatMessages */.mv)().messages;
    var ref4 = Chat_slicedToArray((0,es/* useRecoilState */.FV)(localChatMessageState), 2), localMessage = ref4[0], setLocalMessage = ref4[1];
    var ref5 = (0,react.useState)(false), /*#__PURE__*/ isEmojiMenuOpen = ref5[0], setIsEmojiMenuOpen = ref5[1];
    var ref6 = (0,react.useState)(""), emojiFilter = ref6[0], setEmojiFilter = ref6[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref7 = Chat_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "owner"
    ]), 1), isLocalOwner = ref7[0];
    var disableChatInput = optimizeLargeCalls && broadcastRole === "attendee";
    var ref8 = (0,react.useState)(false), isBroadcastMessageChecked = ref8[0], setIsBroadcastMessageChecked = ref8[1];
    var currentBreakoutRoom = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().currentBreakoutRoom;
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var targetRoom = isBroadcastMessageChecked ? lib_constants/* BROADCAST_CHAT_MESSAGE */.cR : currentBreakoutRoom.id;
    var breakoutsReadyAndAvailable = enableBreakoutRooms && breakoutStatus === "ongoing";
    /**
   * Show/Hide emoji menu based on localMessage (= the text currently entered in ChatInput).
   */ (0,react.useEffect)(function() {
        if (!enableAdvancedChat) return;
        var match = Array.from(localMessage.matchAll(/:\w+/g), function(m) {
            return m[0];
        });
        if ((match === null || match === void 0 ? void 0 : match.length) && localMessage.endsWith(match[match.length - 1])) {
            var searchStr = match[match.length - 1].substring(1);
            setEmojiFilter(searchStr);
            setIsEmojiMenuOpen(true);
        } else {
            setEmojiFilter("");
            setIsEmojiMenuOpen(false);
        }
    }, [
        enableAdvancedChat,
        localMessage
    ]);
    var ref9 = (0,react.useState)(""), gifQ = ref9[0], setGifQ = ref9[1];
    var ref10 = useGiphySearch(gifQ), gif = ref10.gif, refresh = ref10.refresh;
    var handleSubmit = (0,react.useCallback)(Chat_asyncToGenerator(runtime_default().mark(function _callee() {
        var q;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(localMessage.trim().length === 0)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if (enableAdvancedChat && localMessage.startsWith("/giphy")) {
                        q = localMessage.slice(7);
                        setGifQ(q);
                    } else {
                        sendMessage(localMessage, targetRoom);
                    }
                    setLocalMessage("");
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        targetRoom,
        enableAdvancedChat,
        localMessage,
        sendMessage,
        setLocalMessage, 
    ]);
    var handleBroadcastMessageCheckboxChange = function(ev) {
        setIsBroadcastMessageChecked(ev.target.checked);
    };
    var handleCancelGif = function() {
        setGifQ("");
    };
    var handleLoadGif = function() {
        var scrollable = document.querySelector(".chat .messages");
        scrollable.scrollTop = scrollable.scrollHeight;
    };
    var handleRefreshGif = function() {
        refresh();
    };
    var handleSendGif = (0,react.useCallback)(function() {
        sendMessage("![".concat(gif.q, "-giphy|").concat(gif.size, "|").concat(gif.title, "](").concat(gif.url, ")"), targetRoom);
        setGifQ("");
    }, [
        targetRoom,
        gif,
        sendMessage
    ]);
    /**
   * Setup Escape key listener to cancel sending Gif.
   */ (0,react.useEffect)(function() {
        var unsubscribe = (0,tinykeys_module/* default */.Z)(document.body, {
            Escape: function(ev) {
                if (isEmojiMenuOpen) {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    setIsEmojiMenuOpen(false);
                } else if (gif) {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    setGifQ("");
                }
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        gif,
        isEmojiMenuOpen
    ]);
    var handleInputKeyPress = function(ev) {
        if (ev.key === "Enter" && !(ev.shiftKey || ev.altKey || ev.ctrlKey || ev.metaKey)) {
            ev.preventDefault();
            handleSubmit();
        }
    };
    var toggleEmojiPicker = function() {
        setIsEmojiMenuOpen(function(open) {
            return !open;
        });
    };
    var handleEmojiClose = function() {
        setIsEmojiMenuOpen(false);
        var textarea = document.querySelector(".chat textarea");
        if (!textarea) return;
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    };
    var handleEmojiSelection = function(emoji) {
        var newMsg = "";
        if (!emojiFilter) {
            newMsg = localMessage + emoji;
        } else {
            newMsg = localMessage.substring(0, localMessage.lastIndexOf(":".concat(emojiFilter))) + emoji;
        }
        setLocalMessage(newMsg);
        setIsEmojiMenuOpen(false);
        setEmojiFilter("");
    };
    var localMessageLength = (0,react.useMemo)(function() {
        // Check if Intl.Segmenter is available for correct grapheme splitting
        // Intl.Segmenter type doesn't seem available during next build.
        // @ts-ignore
        if (Intl.Segmenter) {
            // @ts-ignore
            return Chat_toConsumableArray(new Intl.Segmenter().segment(localMessage)).length;
        }
        // Otherwise fallback to (slightly false) string length
        return Chat_toConsumableArray(localMessage).length;
    }, [
        localMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4c04b17c1846dba",
                [
                    mediaQueries.coarse,
                    (0,pxToRem.pxToRem)(24)
                ]
            ]
        ]) + " " + (classnames_default()("chat", {
            advanced: enableAdvancedChat
        }) || ""),
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "4c04b17c1846dba",
                        [
                            mediaQueries.coarse,
                            (0,pxToRem.pxToRem)(24)
                        ]
                    ]
                ]) + " " + "loading",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatScrollView, {
                        loading: loading,
                        showBroadcastMessages: breakoutsReadyAndAvailable
                    }),
                    enableAdvancedChat && gif && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "4c04b17c1846dba",
                                [
                                    mediaQueries.coarse,
                                    (0,pxToRem.pxToRem)(24)
                                ]
                            ]
                        ]) + " " + "gif-preview",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiphyPreview, {
                            onCancel: handleCancelGif,
                            onLoad: handleLoadGif,
                            onRefresh: handleRefreshGif,
                            onSubmit: handleSendGif,
                            title: gif.title,
                            url: gif.url
                        })
                    }),
                    enableAdvancedChat && isEmojiMenuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "4c04b17c1846dba",
                                [
                                    mediaQueries.coarse,
                                    (0,pxToRem.pxToRem)(24)
                                ]
                            ]
                        ]) + " " + "emoji-menu-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiMenu, {
                            filter: emojiFilter,
                            onClose: handleEmojiClose,
                            onSelect: handleEmojiSelection
                        })
                    }) : null,
                    disableChatInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "4c04b17c1846dba",
                                [
                                    mediaQueries.coarse,
                                    (0,pxToRem.pxToRem)(24)
                                ]
                            ]
                        ]) + " " + "disabled-chat",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            shadow: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        horizontal: true,
                                        align: "center",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                                size: 16,
                                                color: colors.system.greyDark
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                color: "muted",
                                                variant: "small",
                                                children: t("chat.disabled")
                                            })
                                        ]
                                    }),
                                    messages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatDownload, {})
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "4c04b17c1846dba",
                                            [
                                                mediaQueries.coarse,
                                                (0,pxToRem.pxToRem)(24)
                                            ]
                                        ]
                                    ]) + " " + (classnames_default()("inputWrapper", {
                                        "can-broadcast": isLocalOwner && breakoutsReadyAndAvailable
                                    }) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatInput, {
                                            maxLength: CHAR_LIMIT,
                                            onKeyPress: handleInputKeyPress,
                                            placeholder: t("chat.inputPlaceholder"),
                                            showBroadcastControls: isLocalOwner && breakoutsReadyAndAvailable
                                        }),
                                        enableAdvancedChat ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                            id: "chat-emoji-picker",
                                            className: "emojiPicker",
                                            variant: "ghost",
                                            onClick: toggleEmojiPicker,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiIcon/* EmojiIcon */.S, {
                                                color: colors.baseText,
                                                size: iconVariant
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                            id: "chat-submit",
                                            className: "submit",
                                            variant: "ghost",
                                            type: "submit",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* ArrowRightIcon */.L, {
                                                    color: colors.baseText,
                                                    size: iconVariant,
                                                    variant: "thick"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                                    children: t("chat.submit")
                                                })
                                            ]
                                        }),
                                        isLocalOwner && breakoutsReadyAndAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                                            className: "broadcast-message-checkbox-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox.Checkbox, {
                                                id: "broadcast-to-all-rooms",
                                                label: t("chat.broadcastMessageLabel"),
                                                name: "broadcast-to-all-rooms",
                                                checked: isBroadcastMessageChecked,
                                                onChange: handleBroadcastMessageCheckboxChange
                                            })
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    align: "center",
                                    justify: "space-between",
                                    horizontal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                            align: "center",
                                            gap: 4,
                                            horizontal: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                    id: "tt-chat-encrypted",
                                                    placement: "top",
                                                    title: t("chat.encrypted"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockIcon.LockIcon, {
                                                        color: "var(--text-muted)",
                                                        size: iconVariant
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    className: "char-limit",
                                                    color: localMessageLength >= CHAR_LIMIT ? "error" : "muted",
                                                    variant: textVariantSmall,
                                                    children: localMessageLength ? t("chat.charLimit", {
                                                        length: localMessageLength,
                                                        max: CHAR_LIMIT
                                                    }) : t("chat.charLimitEmpty", {
                                                        max: CHAR_LIMIT
                                                    })
                                                })
                                            ]
                                        }),
                                        messages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatDownload, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4c04b17c1846dba",
                dynamic: [
                    mediaQueries.coarse,
                    (0,pxToRem.pxToRem)(24)
                ],
                children: ".chat.__jsx-style-dynamic-selector{--padding:16px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}.loading.__jsx-style-dynamic-selector{margin:auto}.gif-preview.__jsx-style-dynamic-selector{padding:0 var(--padding)}.emoji-menu-wrapper.__jsx-style-dynamic-selector{padding:0 var(--padding)}.chat.__jsx-style-dynamic-selector form{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;isolation:isolate;margin-top:auto;padding:var(--padding)}.chat.__jsx-style-dynamic-selector .fakeInputCard{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.chat.__jsx-style-dynamic-selector .fakeInput{padding:12px 28px 12px 12px;outline:none}.chat.advanced.__jsx-style-dynamic-selector .fakeInput{padding:12px 52px 12px 12px}.chat.__jsx-style-dynamic-selector .fakeInput:focus-within{border-color:var(--focus-border)}.chat.__jsx-style-dynamic-selector .fakePlaceholder{left:12px;pointer-events:none;position:absolute;top:12px}.inputWrapper.__jsx-style-dynamic-selector{position:relative}.inputWrapper.can-broadcast.__jsx-style-dynamic-selector .submit,.inputWrapper.can-broadcast.__jsx-style-dynamic-selector .emojiPicker{top:20px}.chat.__jsx-style-dynamic-selector .broadcast-message-checkbox-wrapper{position:absolute;left:13px;bottom:5px;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);z-index:2}.chat.__jsx-style-dynamic-selector .emojiPicker{position:absolute;right:30px;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);z-index:2}.chat.__jsx-style-dynamic-selector .submit{position:absolute;right:12px;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);z-index:2}.chat.__jsx-style-dynamic-selector .char-limit{white-space:nowrap}.disabled-chat.__jsx-style-dynamic-selector{padding-top:8px}.disabled-chat.__jsx-style-dynamic-selector .card{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;padding:var(--padding);height:auto;width:auto;border-left:0;border-right:0}@media ".concat(mediaQueries.coarse, "{.chat.__jsx-style-dynamic-selector .emojiPicker{--size:").concat((0,pxToRem.pxToRem)(24), ";font-size:var(--size);right:44px;height:var(--size);width:var(--size)}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Chat/index.ts


;// CONCATENATED MODULE: ./components/Sidebar/DownloadIcon.tsx



var DownloadIcon = function() {
    var colors = (0,Theme.useTheme)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "jsx-51be46c2ae236522",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.60579 11.1771L11.1772 8.60607C11.5124 8.27095 11.5124 7.72929 11.1772 7.39418C10.8421 7.05907 10.3004 7.05907 9.96521 7.39418L9 8.3526V2.08295C11.8377 2.55902 14 5.02699 14 7.99999C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 7.99999C2 5.02699 4.16229 2.55903 7 2.08295V8.35281L6.03436 7.39418C5.69921 7.05907 5.1575 7.05907 4.82236 7.39418C4.65521 7.56131 4.57121 7.78071 4.57121 8.00012C4.57121 8.21953 4.65521 8.43894 4.82236 8.60607L7.39379 11.1771C7.72893 11.5122 8.27064 11.5122 8.60579 11.1771Z",
                fill: colors.baseText,
                className: "jsx-51be46c2ae236522"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "51be46c2ae236522",
                children: "svg.jsx-51be46c2ae236522{display:block}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Sidebar/UploadIcon.tsx



var UploadIcon = function() {
    var colors = (0,Theme.useTheme)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "jsx-51be46c2ae236522",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.39422 4.82291L4.82279 7.39393C4.48764 7.72905 4.48764 8.27071 4.82279 8.60582C5.15793 8.94093 5.69964 8.94093 6.03479 8.60582L7 7.6474L7 13.9171C4.16229 13.441 2 10.973 2 8.00001C2 4.6863 4.68629 2.00001 8 2.00001C11.3137 2.00001 14 4.6863 14 8.00001C14 10.973 11.8377 13.441 9 13.9171L9 7.64719L9.96564 8.60582C10.3008 8.94093 10.8425 8.94093 11.1776 8.60582C11.3448 8.43869 11.4288 8.21929 11.4288 7.99988C11.4288 7.78047 11.3448 7.56106 11.1776 7.39393L8.60622 4.82291C8.27107 4.4878 7.72936 4.4878 7.39422 4.82291Z",
                fill: colors.baseText,
                className: "jsx-51be46c2ae236522"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "51be46c2ae236522",
                children: "svg.jsx-51be46c2ae236522{display:block}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Sidebar/Network.tsx
function Network_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Network_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Network_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Network_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}















var Network = function() {
    var ref7, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref2 = (0,useStyleVariants/* useStyleVariants */._)(), textVariant = ref2.textVariant, textVariantSmall = ref2.textVariantSmall;
    var ref3 = (0,daily_react_esm/* useNetwork */.LN)(), getStats = ref3.getStats, threshold = ref3.threshold;
    var ref4 = (0,react.useState)(null), /*#__PURE__*/ stats = ref4[0], setStats = ref4[1];
    (0,react.useEffect)(function() {
        var updateStats = function() {
            var _ref = Network_asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.t0 = setStats;
                            _ctx.next = 3;
                            return getStats();
                        case 3:
                            _ctx.t1 = _ctx.sent;
                            (0, _ctx.t0)(_ctx.t1);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function updateStats() {
                return _ref.apply(this, arguments);
            };
        }();
        updateStats();
        var interval = setInterval(updateStats, 2000);
        return function() {
            clearInterval(interval);
        };
    }, [
        getStats
    ]);
    var ref5;
    var downloadKbs = (0,react.useMemo)(function() {
        var ref;
        return Math.round(((ref5 = stats === null || stats === void 0 ? void 0 : (ref = stats.latest) === null || ref === void 0 ? void 0 : ref.videoRecvBitsPerSecond) !== null && ref5 !== void 0 ? ref5 : 0) / 1000);
    }, [
        stats === null || stats === void 0 ? void 0 : (ref7 = stats.latest) === null || ref7 === void 0 ? void 0 : ref7.videoRecvBitsPerSecond
    ]);
    var ref6;
    var uploadKbs = (0,react.useMemo)(function() {
        var ref;
        return Math.round(((ref6 = stats === null || stats === void 0 ? void 0 : (ref = stats.latest) === null || ref === void 0 ? void 0 : ref.videoSendBitsPerSecond) !== null && ref6 !== void 0 ? ref6 : 0) / 1000);
    }, [
        stats === null || stats === void 0 ? void 0 : (ref1 = stats.latest) === null || ref1 === void 0 ? void 0 : ref1.videoSendBitsPerSecond
    ]);
    var statusTitleText = (0,react.useMemo)(function() {
        switch(threshold){
            case "low":
                return t("network.weakNetwork");
            case "very-low":
                return t("network.badPacketLoss");
            default:
            case "good":
                return t("network.packetLoss");
        }
    }, [
        t,
        threshold
    ]);
    var statusSubtitleText = (0,react.useMemo)(function() {
        switch(threshold){
            case "low":
                return t("network.lowBandwidthMode");
            case "very-low":
                return t("network.cameraOff");
            default:
            case "good":
                return t("network.statusGood");
        }
    }, [
        t,
        threshold
    ]);
    var statusIcon = (0,react.useMemo)(function() {
        switch(threshold){
            case "low":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                    color: colors.system.orange
                });
            case "very-low":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                    color: colors.system.red
                });
            default:
            case "good":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: styled_jsx_default().dynamic([
                        [
                            "364e6c31840fa32e",
                            [
                                colors.accent,
                                colors.accentText
                            ]
                        ]
                    ]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "inherit",
                            variant: "strong",
                            children: t("network.good")
                        }),
                        (0,jsx_runtime.jsx)((styled_jsx_default()), {
                            id: "364e6c31840fa32e",
                            dynamic: [
                                colors.accent,
                                colors.accentText
                            ],
                            children: "span.__jsx-style-dynamic-selector{background:".concat(colors.accent, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;color:").concat(colors.accentText, ";display:block;padding:8px;text-transform:uppercase}")
                        })
                    ]
                });
        }
    }, [
        colors.accent,
        colors.accentText,
        colors.system.orange,
        colors.system.red,
        t,
        threshold, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "796eb582a03cf7ce",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + "network",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                gap: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: "muted",
                        variant: textVariantSmall,
                        children: t("network.refreshInfo")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                        className: classnames_default()("status", threshold),
                        noBorder: true,
                        style: {
                            background: colors.backgroundAccent
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                justify: "space-between",
                                horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        gap: 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                variant: "strong",
                                                children: statusTitleText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                variant: textVariant,
                                                children: statusSubtitleText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                                        style: {
                                            flex: "none"
                                        },
                                        children: statusIcon
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                        noBorder: true,
                        style: {
                            background: colors.backgroundAccent
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        align: "center",
                                        gap: 4,
                                        horizontal: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                variant: "strong",
                                                children: t("network.downloadRate")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "span",
                                        variant: "largestrong",
                                        children: t("network.kbs", {
                                            kbs: downloadKbs
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                        noBorder: true,
                        style: {
                            background: colors.backgroundAccent
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        align: "center",
                                        gap: 4,
                                        horizontal: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                variant: "strong",
                                                children: t("network.uploadRate")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "span",
                                        variant: "largestrong",
                                        children: t("network.kbs", {
                                            kbs: uploadKbs
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: "muted",
                        variant: textVariantSmall,
                        children: t("network.bandwidthInfo")
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "796eb582a03cf7ce",
                dynamic: [
                    colors.system.red
                ],
                children: ".network.__jsx-style-dynamic-selector{padding:var(--card-spacing)}.network.__jsx-style-dynamic-selector .card{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.network.__jsx-style-dynamic-selector .status.very-low{border:1px solid ".concat(colors.system.red, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./hooks/useParticipantCounts.ts



var participantCountsState = (0,es/* atom */.cn)({
    key: "participant-counts",
    default: {
        present: 0,
        hidden: 0
    }
});
var useParticipantCounts = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var counts1 = (0,es/* useRecoilValue */.sJ)(participantCountsState);
    var setCounts = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(counts) {
            set(participantCountsState, counts);
        };
    });
    (0,react.useEffect)(function() {
        if (!daily) return;
        setCounts(daily.participantCounts());
    }, [
        daily,
        setCounts
    ]);
    (0,daily_react_esm/* useDailyEvent */.VU)("participant-counts-updated", (0,react.useCallback)(function(ev) {
        setCounts(ev.participantCounts);
    }, [
        setCounts
    ]));
    return counts1;
};

;// CONCATENATED MODULE: ./components/Sidebar/BreakoutRoomHeader.tsx
function BreakoutRoomHeader_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutRoomHeader_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BreakoutRoomHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BreakoutRoomHeader_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutRoomHeader_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutRoomHeader_slicedToArray(arr, i) {
    return BreakoutRoomHeader_arrayWithHoles(arr) || BreakoutRoomHeader_iterableToArrayLimit(arr, i) || BreakoutRoomHeader_unsupportedIterableToArray(arr, i) || BreakoutRoomHeader_nonIterableRest();
}
function BreakoutRoomHeader_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutRoomHeader_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutRoomHeader_arrayLikeToArray(o, minLen);
}












var BreakoutRoomHeader = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var name = param1.name;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var textVariantStrong = (0,useStyleVariants/* useStyleVariants */._)().textVariantStrong;
    var ref2 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref2.breakoutHost, breakoutMapping = ref2.breakoutMapping, breakoutParticipantIds = ref2.breakoutParticipantIds, breakoutParticipantsByRoomName = ref2.breakoutParticipantsByRoomName, currentBreakoutRoom = ref2.currentBreakoutRoom, mainRoomParticipantIds = ref2.mainRoomParticipantIds, participantsAskingForHelp = ref2.participantsAskingForHelp;
    var moveParticipants = useBreakouts().moveParticipants;
    var updateRoomMapping = useRoomMapping().updateRoomMapping;
    var isMainRoom = name === constants/* MAIN_ROOM_IDENTIFIER */.b;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var count = (0,react.useMemo)(function() {
        var ref, ref1;
        if (isMainRoom) return mainRoomParticipantIds.length === 0 ? t("breakouts.noPeopleInRoom") : t("breakouts.peopleInRoom", {
            count: mainRoomParticipantIds.length
        });
        return isOwner ? ((ref = breakoutParticipantsByRoomName(name)[0]) === null || ref === void 0 ? void 0 : ref.length) === 0 ? t("breakouts.noPeopleInRoom") : t("breakouts.peopleInRoom", {
            count: (ref1 = breakoutParticipantsByRoomName(name)[0]) === null || ref1 === void 0 ? void 0 : ref1.length
        }) : !breakoutParticipantIds.length ? t("breakouts.noPeopleInRoom") : t("breakouts.peopleInRoom", {
            count: breakoutParticipantIds.length
        });
    }, [
        breakoutParticipantIds.length,
        breakoutParticipantsByRoomName,
        isMainRoom,
        isOwner,
        mainRoomParticipantIds.length,
        name,
        t, 
    ]);
    var handleClickJoin = function() {
        var id;
        if (isMainRoom) {
            id = constants/* MAIN_ROOM_IDENTIFIER */.b;
        } else {
            id = Object.entries(breakoutMapping).find(function(param) {
                var _param = BreakoutRoomHeader_slicedToArray(param, 2), room = _param[1];
                return room.name === name;
            })[0];
        }
        updateRoomMapping(localSessionId, id);
        moveParticipants(BreakoutRoomHeader_defineProperty({}, localSessionId, isMainRoom ? null : id));
    };
    var hasJoined = !currentBreakoutRoom.name && isMainRoom || currentBreakoutRoom.name === name;
    var hasParticipantsAskingForHelp = isMainRoom ? participantsAskingForHelp.some(function(id) {
        return mainRoomParticipantIds.includes(id);
    }) : Object.values(breakoutMapping).find(function(room) {
        return room.name === name;
    }).users.some(function(id) {
        return participantsAskingForHelp.includes(id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-87ad54c5564a796b" + " " + "room-header",
        children: [
            breakoutHost === localSessionId && !hasJoined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                className: "join",
                onClick: handleClickJoin,
                size: "small",
                variant: hasParticipantsAskingForHelp ? "primary" : "secondary",
                /*#__PURE__*/ children: t("breakouts.joinRoom")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                className: "room-name",
                variant: textVariantStrong,
                children: isMainRoom ? t("breakouts.mainRoom") : t("breakouts.roomWithName", {
                    name: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "small",
                children: count
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "87ad54c5564a796b",
                children: ".room-header.jsx-87ad54c5564a796b{padding-top:-webkit-calc(13px + var(--gap));padding-top:-moz-calc(13px + var(--gap));padding-top:calc(13px + var(--gap))}.room-header.jsx-87ad54c5564a796b .join{float:right}.room-header.jsx-87ad54c5564a796b .room-name{display:block}"
            })
        ]
    });
});
BreakoutRoomHeader.displayName = "BreakoutRoomHeader";

// EXTERNAL MODULE: ../shared/dist/components/Icons/HelpIcon.js
var HelpIcon = __webpack_require__(9370);
// EXTERNAL MODULE: ../shared/dist/components/Icons/ScreenshareIcon.js
var ScreenshareIcon = __webpack_require__(4800);
;// CONCATENATED MODULE: ./components/People/RemoveParticipantModal.tsx
function RemoveParticipantModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RemoveParticipantModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function RemoveParticipantModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RemoveParticipantModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RemoveParticipantModal_slicedToArray(arr, i) {
    return RemoveParticipantModal_arrayWithHoles(arr) || RemoveParticipantModal_iterableToArrayLimit(arr, i) || RemoveParticipantModal_unsupportedIterableToArray(arr, i) || RemoveParticipantModal_nonIterableRest();
}
function RemoveParticipantModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RemoveParticipantModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RemoveParticipantModal_arrayLikeToArray(o, minLen);
}







var RemoveParticipantModal = function(param) {
    var onClose = param.onClose;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref = RemoveParticipantModal_slicedToArray((0,ParticipantsProvider/* useParticipantMarkedForRemoval */.jU)(), 2), participantMarkedForRemoval = ref[0], setParticipantMarkedForRemoval = ref[1];
    var handleRemoveClick = function(close) {
        daily.updateParticipant(participantMarkedForRemoval, {
            eject: true
        });
        setParticipantMarkedForRemoval(null);
        close();
    };
    var userName = (0,daily_react_esm/* useParticipantProperty */.ou)(participantMarkedForRemoval, "user_name");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "remove-participant-modal-cancel",
                variant: "secondary",
                children: t("general.cancel")
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "remove-participant-modal-submit",
                onClick: handleRemoveClick,
                variant: "danger",
                children: t("people.removeParticipant")
            }, "remove"), 
        ],
        onClose: onClose,
        title: t("people.removeParticipant"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: "large",
            children: t("people.confirmRemovalText", {
                name: userName || t("people.guest")
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/People/index.ts



;// CONCATENATED MODULE: ./components/Sidebar/ParticipantActions.tsx
function ParticipantActions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ParticipantActions_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ParticipantActions_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ParticipantActions_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParticipantActions_slicedToArray(arr, i) {
    return ParticipantActions_arrayWithHoles(arr) || ParticipantActions_iterableToArrayLimit(arr, i) || ParticipantActions_unsupportedIterableToArray(arr, i) || ParticipantActions_nonIterableRest();
}
function ParticipantActions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ParticipantActions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ParticipantActions_arrayLikeToArray(o, minLen);
}





















var ParticipantActions = /*#__PURE__*/ (0,react.memo)(function(param) {
    var iconVariant = param.iconVariant, sessionId = param.sessionId, _showActions = param.showActions, showActions = _showActions === void 0 ? true : _showActions, showHandRaising = param.showHandRaising, _showIsAskingForHelp = param.showIsAskingForHelp, showIsAskingForHelp = _showIsAskingForHelp === void 0 ? false : _showIsAskingForHelp, showIsScreenSharing = param.showIsScreenSharing, showMicMutedState = param.showMicMutedState;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = ParticipantActions_slicedToArray(useNameModal(), 2), setShowNameModal = ref[1];
    var ref1 = ParticipantActions_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = ParticipantActions_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref2[0];
    var ref3 = ParticipantActions_slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 1), showUserNameChangeUI = ref3[0];
    var ref4 = (0,react.useState)(false), /*#__PURE__*/ showMenu = ref4[0], setShowMenu = ref4[1];
    var handleChangeNameClick = function() {
        setShowNameModal(true);
        setShowMenu(false);
    };
    var handleMenuClick = function() {
        return setShowMenu(true);
    };
    var handleMenuClose = function() {
        return setShowMenu(false);
    };
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var ref5 = ParticipantActions_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(sessionId, [
        "user_name",
        "audio", 
    ]), 2), userName = ref5[0], hasAudioEnabled = ref5[1];
    var displayName = useDisplayName(sessionId, showNames);
    var isHandRaised = useHasHandRaised(sessionId);
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    if (!sessionId) return null;
    if (isLocal && !userName && showUserNameChangeUI) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
            id: "change-name",
            onClick: handleChangeNameClick,
            variant: "ghost",
            style: {
                display: "inline-flex"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                color: "muted",
                underline: true,
                children: t("people.enterYourName")
            })
        });
    }
    var btnId = "".concat(sessionId, "-actions-btn");
    var menuId = "".concat(sessionId, "-actions");
    // On mobile there are no options for non-owners on remote participants
    // On desktop there's at least always the possibility to pin/unpin a participant
    var shouldRenderMenu = isMobile ? isLocalOwner || isLocal : true;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-ac3e670d02f0a90e",
        children: [
            showIsAskingForHelp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                id: "tt-ask-for-help-".concat(sessionId),
                title: t("breakouts.userAskingForHelp", {
                    name: displayName
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                    size: iconVariant
                })
            }),
            showIsScreenSharing && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                size: iconVariant
            }),
            showHandRaising && isHandRaised && /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandIcon/* RaiseHandIcon */.s, {
                size: iconVariant
            }),
            showMicMutedState && /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                color: !hasAudioEnabled ? "var(--text-error)" : "currentColor",
                muted: !hasAudioEnabled,
                size: iconVariant
            }),
            showActions && shouldRenderMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.MenuButton, {
                "aria-controls": menuId,
                focusable: true,
                id: btnId,
                onClick: handleMenuClick,
                open: showMenu,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {
                        size: iconVariant
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: t("people.showOptions")
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantMenu, {
                align: "right",
                "aria-labelledby": btnId,
                id: menuId,
                onClose: handleMenuClose,
                sessionId: sessionId
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ac3e670d02f0a90e",
                children: "div.jsx-ac3e670d02f0a90e{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:8px}"
            })
        ]
    });
});
ParticipantActions.displayName = "ParticipantActions";

;// CONCATENATED MODULE: ./components/Sidebar/ParticipantRow.tsx










var ParticipantRow = /*#__PURE__*/ (0,react.memo)(function(param) {
    var iconVariant = param.iconVariant, sessionId = param.sessionId, _showActions = param.showActions, showActions = _showActions === void 0 ? false : _showActions, showHandRaising = param.showHandRaising, _showIsAskingForHelp = param.showIsAskingForHelp, showIsAskingForHelp = _showIsAskingForHelp === void 0 ? false : _showIsAskingForHelp, showIsScreenSharing = param.showIsScreenSharing, showMicMutedState = param.showMicMutedState, textVariant = param.textVariant;
    var nameRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), /*#__PURE__*/ isTruncated = ref[0], setIsTruncated = ref[1];
    var displayName = useDisplayName(sessionId, true);
    (0,useResizeObserver.useResizeObserver)(nameRef, (0,react.useCallback)(function() {
        if (!nameRef.current) return;
        var p = nameRef.current.querySelector("p");
        setIsTruncated((p === null || p === void 0 ? void 0 : p.scrollWidth) > (p === null || p === void 0 ? void 0 : p.clientWidth));
    }, []));
    if (!sessionId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-65cd11a05cf0aff2" + " " + "participant-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                disabled: !isTruncated,
                id: "tt-".concat(sessionId),
                title: displayName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: nameRef,
                    className: "jsx-65cd11a05cf0aff2" + " " + (classnames_default()("participant-name-container") || ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        className: classnames_default()(robotsClassName("display-name")),
                        truncate: true,
                        variant: textVariant,
                        children: displayName
                    })
                })
            }),
            (showActions || showMicMutedState) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-65cd11a05cf0aff2" + " " + "actions",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantActions, {
                    iconVariant: iconVariant,
                    sessionId: sessionId,
                    showActions: showActions,
                    showMicMutedState: showMicMutedState,
                    showHandRaising: showHandRaising,
                    showIsAskingForHelp: showIsAskingForHelp,
                    showIsScreenSharing: showIsScreenSharing
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "65cd11a05cf0aff2",
                children: ".participant-name-container.jsx-65cd11a05cf0aff2{display:grid}.participant-row.jsx-65cd11a05cf0aff2{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:8px;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.actions.jsx-65cd11a05cf0aff2{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none}"
            })
        ]
    });
});
ParticipantRow.displayName = "ParticipantRow";

;// CONCATENATED MODULE: ./components/Sidebar/PeopleActions.tsx
function PeopleActions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PeopleActions_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PeopleActions_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function PeopleActions_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PeopleActions_slicedToArray(arr, i) {
    return PeopleActions_arrayWithHoles(arr) || PeopleActions_iterableToArrayLimit(arr, i) || PeopleActions_unsupportedIterableToArray(arr, i) || PeopleActions_nonIterableRest();
}
function PeopleActions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PeopleActions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PeopleActions_arrayLikeToArray(o, minLen);
}















var PeopleActions = function() {
    var colors = (0,Theme.useTheme)().colors;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = PeopleActions_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), showLocalVideo = ref[0], setShowLocalVideo = ref[1];
    var ref1 = PeopleActions_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = (0,react.useState)(false), /*#__PURE__*/ showMoreMenu = ref2[0], setShowMoreMenu = ref2[1];
    var ref3 = PeopleActions_slicedToArray(useMuteAllModal(), 2), setShowMuteAllModal = ref3[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var handleMoreOptionsClick = function() {
        setShowMoreMenu(true);
    };
    var handleMoreOptionsClose = function() {
        setShowMoreMenu(false);
    };
    var handleMuteAllClick = (0,react.useCallback)(function() {
        setShowMoreMenu(false);
        setShowMuteAllModal(true);
    }, [
        setShowMuteAllModal
    ]);
    var handleShowSelfViewClick = (0,react.useCallback)(function() {
        setShowMoreMenu(false);
        setShowLocalVideo(true);
    }, [
        setShowLocalVideo
    ]);
    var menuItems = (0,react.useMemo)(function() {
        var items = [];
        if (!showLocalVideo) {
            items.push({
                label: t("people.showSelfView"),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenIcon/* HiddenIcon */._, {
                    size: 16
                }),
                onClick: handleShowSelfViewClick
            });
        }
        if (isLocalOwner) {
            items.push({
                label: t("people.muteAll"),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                    size: 16
                }),
                onClick: handleMuteAllClick
            });
        }
        return items;
    }, [
        handleMuteAllClick,
        handleShowSelfViewClick,
        isLocalOwner,
        showLocalVideo,
        t, 
    ]);
    if (!isLocalOwner && showLocalVideo) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "251ff458f300f57c",
                [
                    colors.background,
                    (0,lib_colors.hexToRgba)(colors.background, 0)
                ]
            ]
        ]) + " " + "people-actions",
        children: [
            menuItems.length < 2 ? // At most 1 action possible: render it directly.
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !showLocalVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "show-self-view",
                        onClick: handleShowSelfViewClick,
                        size: "small",
                        variant: "secondary",
                        children: t("people.showSelfView")
                    }),
                    isLocalOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "mute-all",
                        onClick: handleMuteAllClick,
                        size: "small",
                        variant: "secondary",
                        children: t("people.muteAll")
                    })
                ]
            }) : // Multiple actions possible. Wrap them in a More… menu.
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.MenuButton, {
                        "aria-controls": "more-options-menu",
                        iconAfter: /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {
                            size: 16
                        }),
                        id: "more-options-btn",
                        open: showMoreMenu,
                        onClick: handleMoreOptionsClick,
                        size: isMobile ? "medium" : "small",
                        variant: "secondary",
                        children: t("general.more")
                    }),
                    showMoreMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                        align: "right",
                        "aria-labelledby": "more-options-btn",
                        id: "more-options-menu",
                        items: menuItems,
                        onClose: handleMoreOptionsClose,
                        placement: "top"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "251ff458f300f57c",
                dynamic: [
                    colors.background,
                    (0,lib_colors.hexToRgba)(colors.background, 0)
                ],
                children: ".people-actions.__jsx-style-dynamic-selector{bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;left:0;margin-top:auto;padding:0;position:-webkit-sticky;position:sticky;width:100%}.people-actions.__jsx-style-dynamic-selector::before{background:-webkit-linear-gradient(bottom,".concat(colors.background, ",").concat((0,lib_colors.hexToRgba)(colors.background, 0), ");background:-moz-linear-gradient(bottom,").concat(colors.background, ",").concat((0,lib_colors.hexToRgba)(colors.background, 0), ");background:-o-linear-gradient(bottom,").concat(colors.background, ",").concat((0,lib_colors.hexToRgba)(colors.background, 0), ");background:linear-gradient(to top,").concat(colors.background, ",").concat((0,lib_colors.hexToRgba)(colors.background, 0), ');bottom:-16px;content:"";left:-16px;pointer-events:none;position:absolute;right:-16px;top:-16px}')
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/WaitingRoom/WaitingParticipantRow.tsx
function WaitingParticipantRow_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function WaitingParticipantRow_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function WaitingParticipantRow_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function WaitingParticipantRow_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WaitingParticipantRow_slicedToArray(arr, i) {
    return WaitingParticipantRow_arrayWithHoles(arr) || WaitingParticipantRow_iterableToArrayLimit(arr, i) || WaitingParticipantRow_unsupportedIterableToArray(arr, i) || WaitingParticipantRow_nonIterableRest();
}
function WaitingParticipantRow_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return WaitingParticipantRow_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return WaitingParticipantRow_arrayLikeToArray(o, minLen);
}










var WaitingParticipantRow = function(param) {
    var participant = param.participant;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,daily_react_esm/* useWaitingParticipants */.zy)(), denyAccess = ref.denyAccess, grantAccess = ref.grantAccess;
    var ref1 = (0,useStyleVariants/* useStyleVariants */._)(), textVariant = ref1.textVariant, textVariantStrong = ref1.textVariantStrong;
    var ref2 = WaitingParticipantRow_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref2[0];
    var handleAllowClick = function() {
        grantAccess(participant.id);
    };
    var handleDenyClick = function() {
        denyAccess(participant.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        align: "center",
        justify: "space-between",
        horizontal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                truncate: true,
                variant: textVariant,
                children: participant.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                style: {
                    flex: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "center",
                    gap: isMobile ? 16 : 4,
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                            id: "waiting-allow-".concat(participant.id),
                            className: classnames_default()(robotsClassName("btn-allow"), robotsClassName(participant.id)),
                            onClick: handleAllowClick,
                            size: "small",
                            variant: "primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "span",
                                variant: textVariantStrong,
                                color: "inherit",
                                children: t("waitingRoom.allow")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                            id: "waiting-deny-".concat(participant.id),
                            className: classnames_default()(robotsClassName("btn-deny"), robotsClassName(participant.id)),
                            onClick: handleDenyClick,
                            size: "small",
                            variant: "secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "span",
                                variant: textVariantStrong,
                                children: t("waitingRoom.deny")
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/WaitingRoom/WaitingRoomModal.tsx
function WaitingRoomModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function WaitingRoomModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function WaitingRoomModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function WaitingRoomModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WaitingRoomModal_slicedToArray(arr, i) {
    return WaitingRoomModal_arrayWithHoles(arr) || WaitingRoomModal_iterableToArrayLimit(arr, i) || WaitingRoomModal_unsupportedIterableToArray(arr, i) || WaitingRoomModal_nonIterableRest();
}
function WaitingRoomModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return WaitingRoomModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return WaitingRoomModal_arrayLikeToArray(o, minLen);
}











var WaitingRoomModal = function(param) {
    var onClose = param.onClose;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,daily_react_esm/* useWaitingParticipants */.zy)(), denyAccess = ref.denyAccess, grantAccess = ref.grantAccess, waitingParticipants = ref.waitingParticipants;
    var ref1 = WaitingRoomModal_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var textVariantStrong = (0,useStyleVariants/* useStyleVariants */._)().textVariantStrong;
    var handleAllowAllClick = function(close) {
        grantAccess("*");
        close();
    };
    var handleDenyAllClick = function(close) {
        denyAccess("*");
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "waiting-modal-allow-all",
                className: robotsClassName("btn-allow"),
                onClick: handleAllowAllClick,
                variant: "primary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "span",
                    color: "inherit",
                    variant: textVariantStrong,
                    children: t("waitingRoom.allowAll")
                })
            }, "allow"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "waiting-modal-deny-all",
                className: robotsClassName("btn-deny"),
                onClick: handleDenyAllClick,
                variant: "secondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "span",
                    variant: textVariantStrong,
                    children: t("waitingRoom.denyAll")
                })
            }, "deny"), 
        ],
        closeText: t("general.close"),
        onClose: onClose,
        title: t("waitingRoom.modal.title"),
        variant: "closable",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
            gap: isMobile ? 16 : 8,
            children: waitingParticipants.map(function(p) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingParticipantRow, {
                    participant: p
                }, p.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/WaitingRoom/WaitingRoomNotification.tsx
function WaitingRoomNotification_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function WaitingRoomNotification_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function WaitingRoomNotification_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WaitingRoomNotification_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function WaitingRoomNotification_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WaitingRoomNotification_slicedToArray(arr, i) {
    return WaitingRoomNotification_arrayWithHoles(arr) || WaitingRoomNotification_iterableToArrayLimit(arr, i) || WaitingRoomNotification_unsupportedIterableToArray(arr, i) || WaitingRoomNotification_nonIterableRest();
}
function WaitingRoomNotification_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return WaitingRoomNotification_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return WaitingRoomNotification_arrayLikeToArray(o, minLen);
}


















var MAX_DISPLAYED_NAME_LENGTH = 20;
var WaitingRoomNotification = function() {
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref2 = (0,Theme.useTheme)(), colors = ref2.colors, mediaQueries = ref2.mediaQueries;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref3 = WaitingRoomNotification_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref3[0];
    var ref4 = WaitingRoomNotification_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref4[0], setSidebarView = ref4[1];
    var showModal = useWaitingRoom().showModal;
    var ref5 = (0,daily_react_esm/* useWaitingParticipants */.zy)(), denyAccess = ref5.denyAccess, grantAccess = ref5.grantAccess, waitingParticipants = ref5.waitingParticipants;
    var ref6 = (0,useStyleVariants/* useStyleVariants */._)(), iconVariant = ref6.iconVariant, textVariantStrong = ref6.textVariantStrong;
    var ref7 = (0,react.useState)(false), /*#__PURE__*/ showNotification = ref7[0], setShowNotification = ref7[1];
    /**
   * Show notification when waiting participants change.
   */ (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed() || showModal || sidebarView === "people") return;
        var handleWaitingParticipantAdded = function() {
            setShowNotification(Object.keys(daily.waitingParticipants()).length > 0);
        };
        daily.on("waiting-participant-added", handleWaitingParticipantAdded);
        return function() {
            daily.off("waiting-participant-added", handleWaitingParticipantAdded);
        };
    }, [
        daily,
        showModal,
        sidebarView
    ]);
    /**
   * Hide notification when people panel is opened.
   */ (0,react.useEffect)(function() {
        if (showModal || sidebarView === "people") setShowNotification(false);
    }, [
        showModal,
        sidebarView
    ]);
    var hasMultiplePeopleWaiting = waitingParticipants.length > 1;
    var handleViewAllClick = function() {
        setSidebarView("people");
        setShowNotification(false);
    };
    var handleAllowClick = function() {
        grantAccess(waitingParticipants[0].id);
    };
    var handleDenyClick = function() {
        denyAccess(hasMultiplePeopleWaiting ? "*" : waitingParticipants[0].id);
    };
    var handleClose = function() {
        return setShowNotification(false);
    };
    var waitingName = (0,react.useMemo)(function() {
        if (hasMultiplePeopleWaiting || waitingParticipants.length === 0) return null;
        if (waitingParticipants[0].name.length < MAX_DISPLAYED_NAME_LENGTH) return waitingParticipants[0].name;
        return "".concat(waitingParticipants[0].name.slice(0, MAX_DISPLAYED_NAME_LENGTH), "\u2026");
    }, [
        hasMultiplePeopleWaiting,
        waitingParticipants
    ]);
    if (!showNotification || waitingParticipants.length === 0) return null;
    return(// Force light theme styles
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "44b362a87e5f8cb7",
                [
                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                    mediaQueries.coarse
                ]
            ]
        ]) + " " + (classnames_default()("waiting-room-notification", Theme.LIGHT_THEME_CLASS) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "presentation",
                className: styled_jsx_default().dynamic([
                    [
                        "44b362a87e5f8cb7",
                        [
                            Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                            mediaQueries.coarse
                        ]
                    ]
                ]) + " " + "backdrop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "44b362a87e5f8cb7",
                        [
                            Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                            mediaQueries.coarse
                        ]
                    ]
                ]) + " " + (classnames_default()("notification", {
                    "with-sidebar": sidebarView
                }) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                    noBorder: true,
                    spacing: 8,
                    variant: "small",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        variant: textVariantStrong,
                                        children: hasMultiplePeopleWaiting ? t("waitingRoom.peopleWouldLikeToJoin", {
                                            count: waitingParticipants.length
                                        }) : t("waitingRoom.personWouldLikeToJoin", {
                                            name: waitingName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        align: "center",
                                        gap: isMobile ? 16 : 4,
                                        horizontal: true,
                                        children: [
                                            hasMultiplePeopleWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                id: "waiting-notification-view-all",
                                                className: robotsClassName("btn-allow"),
                                                onClick: handleViewAllClick,
                                                size: "small",
                                                variant: "primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    El: "span",
                                                    variant: textVariantStrong,
                                                    color: "inherit",
                                                    children: t("waitingRoom.viewAll")
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                id: "waiting-notification-allow-".concat(waitingParticipants[0].id),
                                                className: classnames_default()(robotsClassName("btn-allow"), robotsClassName(waitingParticipants[0].id)),
                                                onClick: handleAllowClick,
                                                size: "small",
                                                variant: "primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    El: "span",
                                                    variant: textVariantStrong,
                                                    color: "inherit",
                                                    children: t("waitingRoom.allow")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                                id: "waiting-notification-deny-".concat(waitingParticipants.length === 1 ? waitingParticipants === null || waitingParticipants === void 0 ? void 0 : (ref = waitingParticipants[0]) === null || ref === void 0 ? void 0 : ref.id : "all"),
                                                className: classnames_default()(robotsClassName("btn-deny"), WaitingRoomNotification_defineProperty({}, robotsClassName(waitingParticipants === null || waitingParticipants === void 0 ? void 0 : (ref1 = waitingParticipants[0]) === null || ref1 === void 0 ? void 0 : ref1.id), waitingParticipants.length === 1)),
                                                onClick: handleDenyClick,
                                                size: "small",
                                                variant: "secondary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    El: "span",
                                                    variant: textVariantStrong,
                                                    children: hasMultiplePeopleWaiting ? t("waitingRoom.denyAll") : t("waitingRoom.deny")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "44b362a87e5f8cb7",
                                        [
                                            Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                                            mediaQueries.coarse
                                        ]
                                    ]
                                ]) + " " + "close",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                    onClick: handleClose,
                                    variant: "ghost",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                            color: colors.baseText,
                                            size: iconVariant
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                            children: t("general.close")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "44b362a87e5f8cb7",
                dynamic: [
                    Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8,
                    mediaQueries.coarse
                ],
                children: ".waiting-room-notification.__jsx-style-dynamic-selector{height:100%;position:absolute;width:100%;z-index:var(--zindex-waitingroom)}.notification.with-sidebar.__jsx-style-dynamic-selector{right:".concat(Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8, "px}.notification.__jsx-style-dynamic-selector .card-content{padding-right:24px}@media ").concat(mediaQueries.coarse, "{.notification.__jsx-style-dynamic-selector .card-content{padding-right:32px}}.backdrop.__jsx-style-dynamic-selector{background:-webkit-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:-moz-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:-o-linear-gradient(top,var(--backdrop)0%,var(--backdrop-hidden)100%);background:linear-gradient(180deg,var(--backdrop)0%,var(--backdrop-hidden)100%);height:-webkit-calc(100% - 59px);height:-moz-calc(100% - 59px);height:calc(100% - 59px);left:0;position:absolute;top:var(--header-height);width:100%}.notification.__jsx-style-dynamic-selector{max-width:-webkit-calc(100% - 16px);max-width:-moz-calc(100% - 16px);max-width:calc(100% - 16px);position:absolute;right:8px;top:-webkit-calc(var(--header-height) + 8px);top:-moz-calc(var(--header-height) + 8px);top:calc(var(--header-height) + 8px)}.close.__jsx-style-dynamic-selector{position:absolute;right:4px;top:4px}")
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/WaitingRoom/index.ts




;// CONCATENATED MODULE: ./components/Sidebar/WaitingList.tsx
function WaitingList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function WaitingList_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function WaitingList_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function WaitingList_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WaitingList_slicedToArray(arr, i) {
    return WaitingList_arrayWithHoles(arr) || WaitingList_iterableToArrayLimit(arr, i) || WaitingList_unsupportedIterableToArray(arr, i) || WaitingList_nonIterableRest();
}
function WaitingList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return WaitingList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return WaitingList_arrayLikeToArray(o, minLen);
}









/**
 * Renders a list of all [waiting participants](https://docs.daily.co/reference/daily-js/instance-methods/waiting-participants) and actions for each.
 * Does not render, when the local participant is not an [owner](https://docs.daily.co/guides/how-daily-works/controlling-who-joins-a-meeting#meeting-owner-privileges).
 */ var WaitingList = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var setShowModal = useWaitingRoom().setShowModal;
    var waitingParticipants = (0,daily_react_esm/* useWaitingParticipants */.zy)().waitingParticipants;
    var ref = WaitingList_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var handleManageAllClick = function() {
        return setShowModal(true);
    };
    if (!isLocalOwner || waitingParticipants.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        gap: isMobile ? 16 : 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: "muted",
                        variant: "small",
                        children: t("waitingRoom.peopleWouldLikeToJoin", {
                            count: waitingParticipants.length
                        })
                    }),
                    waitingParticipants.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "waiting-list-manage-all",
                        onClick: handleManageAllClick,
                        variant: "ghost",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "success",
                            variant: "small",
                            children: t("waitingRoom.manageAll")
                        })
                    })
                ]
            }),
            waitingParticipants.map(function(p) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingParticipantRow, {
                    participant: p
                }, p.id);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Sidebar/People.tsx
function People_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function People_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function People_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return People_arrayLikeToArray(arr);
}
function People_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function People_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function People_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function People_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function People_slicedToArray(arr, i) {
    return People_arrayWithHoles(arr) || People_iterableToArrayLimit(arr, i) || People_unsupportedIterableToArray(arr, i) || People_nonIterableRest();
}
function People_toConsumableArray(arr) {
    return People_arrayWithoutHoles(arr) || People_iterableToArray(arr) || People_unsupportedIterableToArray(arr) || People_nonIterableSpread();
}
function People_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return People_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return People_arrayLikeToArray(o, minLen);
}





















var People = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref7 = People_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref7[0];
    var ref1 = (0,useStyleVariants/* useStyleVariants */._)(), iconVariant = ref1.iconVariant, textVariant = ref1.textVariant, textVariantSmall = ref1.textVariantSmall;
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref2.broadcast, broadcastRole = ref2.broadcastRole;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref3 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref3.breakoutHost, breakoutMapping = ref3.breakoutMapping, breakoutParticipantIds = ref3.breakoutParticipantIds, breakoutParticipantsByRoomName = ref3.breakoutParticipantsByRoomName, breakoutStatus = ref3.breakoutStatus, currentBreakoutRoom = ref3.currentBreakoutRoom, hasJoinedBreakout = ref3.hasJoinedBreakout, mainRoomParticipantIds = ref3.mainRoomParticipantIds, participantsAskingForHelp = ref3.participantsAskingForHelp;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    // Order: local, then screen sharers, then hand raisers, then everyone else.
    var sortParticipantIds = (0,react.useCallback)(function(a, b) {
        var ref, ref4, ref5, ref6;
        // Always put the local user first
        if (a.local || b.local) return 1;
        // Not the local user? Check if they're screen sharing.
        var aScreen = a.screen;
        var bScreen = b.screen;
        // user_name for guests is '' (empty string)
        var aUserName = (a.user_name || t("people.guest")).toLowerCase();
        var bUserName = (b.user_name || t("people.guest")).toLowerCase();
        if (aScreen && bScreen) {
            if (aUserName < bUserName) return -1;
            if (aUserName > bUserName) return 1;
        }
        if (aScreen && !bScreen) {
            return -1;
        }
        if (!aScreen && bScreen) {
            return 1;
        }
        // Not screen sharing? Check if they've raised their hand.
        var aDate = (ref = a.userData) === null || ref === void 0 ? void 0 : (ref4 = ref[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref4 === void 0 ? void 0 : ref4[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
        var bDate = (ref5 = b.userData) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui]) === null || ref6 === void 0 ? void 0 : ref6[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
        // Both hands raised? -> compare queue number
        if (aDate && bDate) {
            if (aDate < bDate) return -1;
            if (aDate > bDate) return 1;
            return 0;
        }
        // A has their hand raised?
        if (aDate && !bDate) {
            return -1;
        }
        // B has their hand raised?
        if (!aDate && bDate) {
            return 1;
        }
        // Sort everyone else alphabetically
        if (aUserName < bUserName) return -1;
        if (aUserName > bUserName) return 1;
        return 0;
    }, [
        t
    ]);
    var peopleRef = (0,react.useRef)(null);
    var stackGap = isMobile ? 16 : 8;
    var itemHeight = (textVariant === "base" ? 16 : 24) + stackGap;
    var present = useParticipantCounts().present;
    /**
   * Holds ids of presenters, which means participants with presence data.
   * In broadcasts, we'll limit presenters to owners.
   */ var presenterIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            return broadcast ? p.owner : true;
        }, [
            broadcast
        ]),
        sort: sortParticipantIds
    });
    var screenSharerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "screen"
    });
    /**
   * Holds ids of viewers (which is only a thing in broadcasts).
   * In regular calls this will always be empty.
   * In regular broadcasts this will be participants with presence data,
   * but without owner rights.
   * In broadcasts with enabled passive participants this will be empty,
   * because passive participants don't appear in daily.participants().
   */ var viewerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            return broadcast ? !p.owner : false;
        }, [
            broadcast
        ]),
        sort: sortParticipantIds
    });
    /**
   * Holds all elements for virtualized scrolling.
   * 'presenters' and 'viewers' are placeholder values
   * for their respective titles.
   */ var rows1 = (0,react.useMemo)(function() {
        var rows = [
            {
                type: "presenters"
            }, 
        ];
        if (breakoutStatus === "ongoing") {
            var baseIds = hasJoinedBreakout ? breakoutParticipantIds : mainRoomParticipantIds;
            var presenters = presenterIds.filter(function(p) {
                return baseIds.includes(p);
            });
            var viewers = viewerIds.filter(function(p) {
                return baseIds.includes(p);
            });
            // Room owner POV
            if (isOwner) {
                // For the room owners, the main room should be on top.
                rows.push({
                    type: "main-room"
                });
                mainRoomParticipantIds.forEach(function(p) {
                    return rows.push({
                        type: "participant",
                        content: p
                    });
                });
                Object.values(breakoutMapping).map(function(room) {
                    rows.push({
                        type: "br-name",
                        content: room.name
                    });
                    var usersPerRoom = breakoutParticipantsByRoomName(room.name);
                    usersPerRoom === null || usersPerRoom === void 0 ? void 0 : usersPerRoom.forEach(function(users) {
                        users.map(function(id) {
                            rows.push({
                                type: "participant",
                                content: id
                            });
                        });
                    });
                });
            }
            // Participant POV
            if (!isOwner) {
                var _rows;
                if (hasJoinedBreakout) {
                    // show the participant their breakout room if they've joined the session
                    rows.push({
                        type: "br-name",
                        content: currentBreakoutRoom.name
                    });
                } else {
                    // not in a breakout session? show the participant the main room. they don't get to see the other
                    // breakout rooms.
                    // The participants in the main room are rendered below, via 'presenters' or 'viewers'
                    rows.push({
                        type: "main-room"
                    });
                }
                if (presenters.length) {
                    var _rows1;
                    if (broadcast) rows.push({
                        type: "br-presenters",
                        content: presenters.length
                    });
                    (_rows1 = rows).push.apply(_rows1, People_toConsumableArray(presenters.map(function(id) {
                        return {
                            type: "participant",
                            content: id
                        };
                    })));
                }
                if (viewers.length) (_rows = rows).push.apply(_rows, [
                    {
                        type: "br-viewers",
                        content: viewers.length
                    }
                ].concat(People_toConsumableArray(viewers.map(function(id) {
                    return {
                        type: "participant",
                        content: id
                    };
                }))));
            }
        } else {
            var // Breakouts not ongoing.
            _rows2;
            (_rows2 = rows).push.apply(_rows2, People_toConsumableArray(presenterIds.map(function(id) {
                return {
                    type: "participant",
                    content: id
                };
            })));
            if (viewerIds.length > 0) {
                var _rows3;
                (_rows3 = rows).push.apply(_rows3, [
                    {
                        type: "viewers"
                    }
                ].concat(People_toConsumableArray(viewerIds.map(function(id) {
                    return {
                        type: "participant",
                        content: id
                    };
                }))));
            }
        }
        return rows;
    }, [
        breakoutMapping,
        breakoutParticipantIds,
        breakoutParticipantsByRoomName,
        breakoutStatus,
        broadcast,
        currentBreakoutRoom.name,
        hasJoinedBreakout,
        isOwner,
        mainRoomParticipantIds,
        presenterIds,
        viewerIds, 
    ]);
    var virtualizer = (0,lib/* useVirtualizer */.MG)({
        count: rows1.length,
        getScrollElement: function() {
            return peopleRef.current;
        },
        estimateSize: (0,react.useCallback)(function(index) {
            switch(rows1[index].type){
                case "presenters":
                    return 16;
                case "viewers":
                    return 24 + stackGap + 16;
                default:
                    return itemHeight;
            }
        }, [
            itemHeight,
            rows1,
            stackGap
        ]),
        overscan: 5
    });
    var renderRow = function(item) {
        var row = rows1[item.index];
        switch(row.type){
            case "presenters":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    variant: textVariantSmall,
                    /*#__PURE__*/ children: broadcast ? t("people.presentersWithCount", {
                        count: presenterIds.length
                    }) : t("people.withCount", {
                        count: present
                    })
                });
            case "viewers":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    variant: textVariantSmall,
                    children: t("people.viewersWithCount", {
                        count: viewerIds.length
                    })
                });
            case "participant":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantRow, {
                    iconVariant: iconVariant,
                    showActions: broadcastRole !== "attendee",
                    sessionId: row.content,
                    showHandRaising: broadcastRole !== "attendee",
                    showMicMutedState: !disableAudio && presenterIds.includes(row.content),
                    showIsScreenSharing: broadcastRole !== "attendee" && screenSharerIds.includes(row.content),
                    textVariant: textVariant
                });
            default:
                return null;
        }
    };
    var renderBreakoutRow = function(item) {
        var row = rows1[item.index];
        switch(row.type){
            case "presenters":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    variant: textVariantSmall,
                    children: t("people.withCount", {
                        count: present
                    })
                });
            case "br-presenters":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    variant: textVariantSmall,
                    children: t("people.presentersWithCount", {
                        count: row.content
                    })
                });
            case "br-viewers":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    variant: textVariantSmall,
                    children: t("people.viewersWithCount", {
                        count: row.content
                    })
                });
            case "br-name":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutRoomHeader, {
                    name: row.content
                });
            case "main-room":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutRoomHeader, {
                    name: constants/* MAIN_ROOM_IDENTIFIER */.b
                });
            case "participant":
                var showActionsOrHandRaising = broadcastRole !== "attendee";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantRow, {
                    iconVariant: iconVariant,
                    showActions: showActionsOrHandRaising,
                    sessionId: row.content,
                    showHandRaising: showActionsOrHandRaising,
                    showMicMutedState: !disableAudio && presenterIds.includes(row.content),
                    showIsAskingForHelp: breakoutHost === localSessionId && participantsAskingForHelp.includes(row.content),
                    showIsScreenSharing: broadcastRole !== "attendee" && screenSharerIds.includes(row.content),
                    textVariant: textVariant
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: peopleRef,
        style: {
            "--gap": "".concat(stackGap, "px")
        },
        className: "jsx-d777fa1387c7922c" + " " + "people",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingList, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "".concat(virtualizer.getTotalSize(), "px")
                },
                className: "jsx-d777fa1387c7922c" + " " + "list",
                children: virtualizer.getVirtualItems().map(function(item) {
                    var row = rows1[item.index];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: virtualizer.measureElement,
                        "data-index": item.index,
                        style: {
                            transform: "translateY(".concat(item.start, "px)")
                        },
                        className: "jsx-d777fa1387c7922c" + " " + (classnames_default()("row", {
                            noPadding: item.index === 0,
                            room: row.type === "br-name" || row.type === "main-room",
                            title: row.type === "presenters" || row.type === "viewers"
                        }) || ""),
                        children: breakoutStatus === "ongoing" ? renderBreakoutRow(item) : renderRow(item)
                    }, item.key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleActions, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d777fa1387c7922c",
                children: ".people.jsx-d777fa1387c7922c{height:100%;overflow-x:hidden;overflow-y:auto;padding:var(--card-spacing);position:relative}.list.jsx-d777fa1387c7922c{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:-webkit-calc(100% - 2*var(--card-spacing));min-height:-moz-calc(100% - 2*var(--card-spacing));min-height:calc(100% - 2*var(--card-spacing));position:relative}.list.jsx-d777fa1387c7922c .row.jsx-d777fa1387c7922c{position:absolute;width:100%}.list.jsx-d777fa1387c7922c .participant-row{padding-top:var(--gap)}.list.jsx-d777fa1387c7922c .title.jsx-d777fa1387c7922c>p{display:block;padding-top:-webkit-calc(24px + var(--gap));padding-top:-moz-calc(24px + var(--gap));padding-top:calc(24px + var(--gap))}.list.jsx-d777fa1387c7922c .row.noPadding.jsx-d777fa1387c7922c>*{padding:0}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Sidebar/Sidebar.tsx
function Sidebar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Sidebar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Sidebar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Sidebar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Sidebar_slicedToArray(arr, i) {
    return Sidebar_arrayWithHoles(arr) || Sidebar_iterableToArrayLimit(arr, i) || Sidebar_unsupportedIterableToArray(arr, i) || Sidebar_nonIterableRest();
}
function Sidebar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Sidebar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sidebar_arrayLikeToArray(o, minLen);
}


























var TABS_HEIGHT = 48;
var TRANSITION_TIME = 250;
var Sidebar = function() {
    var ref8 = (0,Theme.useTheme)(), fontSizes = ref8.fontSizes, mediaQueries = ref8.mediaQueries;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = Sidebar_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = Sidebar_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref2[0], setSidebarView = ref2[1];
    var ref3 = (0,useCallConfig/* useCallConfig */.A)(), enableBreakoutRooms = ref3.enableBreakoutRooms, enableChat = ref3.enableChat, enableNetworkUI = ref3.enableNetworkUI, enablePeopleUI = ref3.enablePeopleUI;
    var sidebarIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().sidebarIntegrations;
    var sidebarRef = (0,react.useRef)(null);
    var isMedium = (0,useMediaQuery.useMediaQuery)(mediaQueries.medium);
    var transitionTime = (0,react.useMemo)(function() {
        return isMobile && !isMedium ? TRANSITION_TIME : 0;
    }, [
        isMedium,
        isMobile
    ]);
    var hasTransitionedIn = useMountTransition(sidebarView, transitionTime);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref4 = Sidebar_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "owner"
    ]), 1), isLocalOwner = ref4[0];
    /**
   * Holds last known sidebarView. Keeps view intact while transitioning out.
   * Note on Safari: Safari does a terrible job at adhering accessibility standards.
   * Clicking a button in Safari apparently doesn't make that element the activeElement.
   * Programmatically calling .focus() makes sure that the clicked tab is actually
   * focussed and the correct tab receives :focus-visible.
   */ var previousSidebarView = (0,usePreviousValue/* usePreviousValue */.z)(sidebarView);
    var handleClickPeople = (0,react.useCallback)(function(ev) {
        setSidebarView("people");
        if ((0,browserConfig/* isSafari */.G6)()) ev.currentTarget.focus();
    }, [
        setSidebarView
    ]);
    var handleClickChat = (0,react.useCallback)(function(ev) {
        setSidebarView("chat");
        if ((0,browserConfig/* isSafari */.G6)()) ev.currentTarget.focus();
    }, [
        setSidebarView
    ]);
    var handleClickNetwork = (0,react.useCallback)(function(ev) {
        setSidebarView("network");
        if ((0,browserConfig/* isSafari */.G6)()) ev.currentTarget.focus();
    }, [
        setSidebarView
    ]);
    var handleClickBreakout = (0,react.useCallback)(function(ev) {
        setSidebarView("breakout");
        if ((0,browserConfig/* isSafari */.G6)()) ev.currentTarget.focus();
    }, [
        setSidebarView
    ]);
    var handleCloseClick = (0,react.useCallback)(function() {
        setSidebarView(null);
    }, [
        setSidebarView
    ]);
    var indexMap = {
        people: 0,
        chat: 1,
        network: 2,
        breakout: 3
    };
    sidebarIntegrations.forEach(function(integration, index) {
        indexMap[integration.id] = index + 4;
    });
    var prevFocus = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref9;
        if (!sidebarView) {
            var // restore focus, when sidebar is closed
            ref5;
            (ref5 = prevFocus.current) === null || ref5 === void 0 ? void 0 : ref5.focus();
            prevFocus.current = null;
            return;
        }
        var unsubscribe = (0,tinykeys_module/* default */.Z)(window, {
            Escape: function() {
                var ref;
                var isMenuOpen = (sidebarRef === null || sidebarRef === void 0 ? void 0 : (ref = sidebarRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('.menuButton[aria-haspopup="true"][aria-expanded="true"]').length) > 0;
                if (isMenuOpen) return;
                setSidebarView(null);
            }
        });
        if (!prevFocus.current) {
            prevFocus.current = document.activeElement;
        }
        // focus first sidebar item
        if (!(sidebarRef === null || sidebarRef === void 0 ? void 0 : (ref9 = sidebarRef.current) === null || ref9 === void 0 ? void 0 : ref9.contains(document.activeElement))) {
            var ref6, ref7;
            (ref7 = sidebarRef === null || sidebarRef === void 0 ? void 0 : (ref6 = sidebarRef.current) === null || ref6 === void 0 ? void 0 : ref6.querySelector("button:not([disabled]),a,input:not([disabled]),textarea:not([disabled])")) === null || ref7 === void 0 ? void 0 : ref7.focus();
        }
        return function() {
            unsubscribe();
        };
    }, [
        setSidebarView,
        sidebarView
    ]);
    if (!enableChat && !enableNetworkUI && !enablePeopleUI && sidebarIntegrations.length === 0) return null;
    var _loading;
    /**
   * To ensure proper transitions when showing / hiding the Sidebar,
   * mounting / unmounting the markup happens in two phases, using the useMountTransition hook:
   *
   * Mounting:
   * 1) sidebarView is set to true
   *    -> Sidebar markup is rendered into the DOM,
   *       the .mounted class is set, but the css transition is not yet triggered.
   * 2) Because sidebarView is changed, the useMountTransition() hook is triggered,
   *    which in turn sets hasTransitionedIn to true.
   *    The .transitioned class is now also set.
   *    Now that both .mounted and .transitioned classes are set, the transition starts.
   *
   * Unmounting:
   * 1) sidebarView is set to false
   *    -> One condition for rendering Sidebar into the DOM is removed, the .mounted class is removed,
   *       but hasTransitionedIn is still true, so it's still available in the DOM!
   *    -> This causes the css transition to revert, because only one of both necessary classes is left.
   * 2) Because sidebarView is changed, the useMountTransition() hook is triggered again
   *    and now sets the hasTransitionedIn flag back to false after a configured delay (to give the reverted transition time to finish).
   *    -> Now finally both conditions for rendering the Sidebar into the DOM are removed,
   *       and with it the markup as well.
   */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: sidebarRef,
        "aria-hidden": !sidebarView && !hasTransitionedIn,
        className: styled_jsx_default().dynamic([
            [
                "578240e7e6ce6e5",
                [
                    TRANSITION_TIME,
                    fontSizes.large,
                    TABS_HEIGHT,
                    mediaQueries.medium,
                    lib_constants/* SIDEBAR_WIDTH */.ZR,
                    mediaQueries.large,
                    lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi
                ]
            ]
        ]) + " " + (classnames_default()("sidebar", {
            /**
         * If a user on a tablet uses an actual mouse pointer,
         * (pointer: coarse) could switch to (pointer: fine), which could break some CSS styles.
         * That's why we keep the dependency to 'isMobile' here.
         */ mobile: isMobile,
            hidden: !sidebarView && !hasTransitionedIn
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusTrap.FocusTrap, {
                active: isMobile && !!sidebarView,
                className: classnames_default()("container", {
                    mounted: sidebarView,
                    transitioned: hasTransitionedIn
                }),
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs */.mQ, {
                    id: "sidebar",
                    initialIndex: indexMap[sidebarView !== null && sidebarView !== void 0 ? sidebarView : previousSidebarView],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
                        noBorder: true,
                        style: {
                            borderRadius: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                                className: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* TabList */.td, {
                                        style: {
                                            "--padding-bottom": "16px"
                                        },
                                        gap: 0,
                                        spaceAround: 8,
                                        children: [
                                            enablePeopleUI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                                className: "tab",
                                                onClick: handleClickPeople,
                                                children: t("general.people")
                                            }),
                                            enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                                className: "tab",
                                                onClick: handleClickChat,
                                                children: t("general.chat")
                                            }),
                                            enableNetworkUI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                                className: "tab",
                                                onClick: handleClickNetwork,
                                                children: t("general.network")
                                            }),
                                            isLocalOwner && enableBreakoutRooms && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                                className: "tab",
                                                onClick: handleClickBreakout,
                                                children: t("general.breakoutRooms")
                                            }),
                                            sidebarIntegrations.map(function(integration) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                                    className: "tab",
                                                    onClick: function() {
                                                        return setSidebarView(integration.id);
                                                    },
                                                    children: integration.label
                                                }, integration.id);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: styled_jsx_default().dynamic([
                                            [
                                                "578240e7e6ce6e5",
                                                [
                                                    TRANSITION_TIME,
                                                    fontSizes.large,
                                                    TABS_HEIGHT,
                                                    mediaQueries.medium,
                                                    lib_constants/* SIDEBAR_WIDTH */.ZR,
                                                    mediaQueries.large,
                                                    lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi
                                                ]
                                            ]
                                        ]) + " " + "close",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                            id: "sidebar-close",
                                            onClick: handleCloseClick,
                                            variant: "ghost",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                                    size: 16,
                                                    variant: "thick"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                                    children: t("general.closeSidebar")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                className: "sidebar-content",
                                noPadding: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* TabPanels */.nP, {
                                    children: [
                                        enablePeopleUI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            className: "sidebar-panel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(People, {})
                                        }),
                                        enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            className: "sidebar-panel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat, {})
                                        }),
                                        enableNetworkUI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            className: "sidebar-panel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Network, {})
                                        }),
                                        isLocalOwner && enableBreakoutRooms && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            className: "sidebar-panel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutRooms, {})
                                        }),
                                        sidebarIntegrations.map(function(integration) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                                className: classnames_default()("sidebar-panel", "integration-panel"),
                                                hideStrategy: "css",
                                                onClick: function() {
                                                    return setSidebarView(integration.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                    allow: integration.allow,
                                                    // @ts-ignore
                                                    csp: integration.csp,
                                                    loading: (_loading = integration.loading) !== null && _loading !== void 0 ? _loading : "lazy",
                                                    name: integration.name,
                                                    referrerPolicy: integration.referrerPolicy,
                                                    sandbox: integration.sandbox,
                                                    src: integration.src,
                                                    srcDoc: integration.srcdoc,
                                                    className: styled_jsx_default().dynamic([
                                                        [
                                                            "578240e7e6ce6e5",
                                                            [
                                                                TRANSITION_TIME,
                                                                fontSizes.large,
                                                                TABS_HEIGHT,
                                                                mediaQueries.medium,
                                                                lib_constants/* SIDEBAR_WIDTH */.ZR,
                                                                mediaQueries.large,
                                                                lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi
                                                            ]
                                                        ]
                                                    ])
                                                })
                                            }, integration.id);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "578240e7e6ce6e5",
                dynamic: [
                    TRANSITION_TIME,
                    fontSizes.large,
                    TABS_HEIGHT,
                    mediaQueries.medium,
                    lib_constants/* SIDEBAR_WIDTH */.ZR,
                    mediaQueries.large,
                    lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi
                ],
                children: ".sidebar.__jsx-style-dynamic-selector{height:-webkit-calc(100vh - var(--header-height) - var(--tray-height));height:-moz-calc(100vh - var(--header-height) - var(--tray-height));height:calc(100vh - var(--header-height) - var(--tray-height));isolation:isolate;left:0;position:fixed;top:var(--header-height);width:100vw;z-index:var(--zindex-sidebar)}.sidebar.mobile.__jsx-style-dynamic-selector{border:none;bottom:0;left:0;position:fixed;top:var(--banner-height,0);width:100%}.sidebar.hidden.__jsx-style-dynamic-selector{opacity:0;pointer-events:none;-webkit-transform:translateX(100%);-moz-transform:translateX(100%);-ms-transform:translateX(100%);-o-transform:translateX(100%);transform:translateX(100%)}.sidebar.__jsx-style-dynamic-selector .container{height:100%;width:100%}.sidebar.mobile.__jsx-style-dynamic-selector .container{-webkit-transform:translateY(100%);-moz-transform:translateY(100%);-ms-transform:translateY(100%);-o-transform:translateY(100%);transform:translateY(100%);-webkit-transition:-webkit-transform ".concat(TRANSITION_TIME, "ms ease;-moz-transition:-moz-transform ").concat(TRANSITION_TIME, "ms ease;-o-transition:-o-transform ").concat(TRANSITION_TIME, "ms ease;transition:-webkit-transform ").concat(TRANSITION_TIME, "ms ease;transition:-moz-transform ").concat(TRANSITION_TIME, "ms ease;transition:-o-transform ").concat(TRANSITION_TIME, "ms ease;transition:transform ").concat(TRANSITION_TIME, "ms ease}.sidebar.mobile.__jsx-style-dynamic-selector .container.transitioned.mounted{-webkit-transform:translateY(0%);-moz-transform:translateY(0%);-ms-transform:translateY(0%);-o-transform:translateY(0%);transform:translateY(0%)}.sidebar.mobile.__jsx-style-dynamic-selector .tablist strong{font-size:").concat(fontSizes.large, "}.sidebar.__jsx-style-dynamic-selector .sidebar-content{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:-webkit-calc(100% - ").concat(TABS_HEIGHT, "px);height:-moz-calc(100% - ").concat(TABS_HEIGHT, "px);height:calc(100% - ").concat(TABS_HEIGHT, "px);margin-top:1px;overflow-x:hidden;overflow-y:auto}.sidebar.__jsx-style-dynamic-selector .sidebar-panel{width:100%}.sidebar.__jsx-style-dynamic-selector .sidebar-panel.visible{padding-top:0}.sidebar.__jsx-style-dynamic-selector .close.__jsx-style-dynamic-selector{border-left:1px solid var(--card-border);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:16px;place-items:center}.sidebar.__jsx-style-dynamic-selector .header{display:grid;grid-template-columns:-webkit-calc(100% - 48px)48px;grid-template-columns:-moz-calc(100% - 48px)48px;grid-template-columns:calc(100% - 48px)48px;overflow:hidden;padding:0}.sidebar.__jsx-style-dynamic-selector .header .tablist{margin-right:1px}.sidebar.__jsx-style-dynamic-selector .integration-panel{overflow:hidden}.sidebar.__jsx-style-dynamic-selector iframe.__jsx-style-dynamic-selector{border:none;height:-webkit-calc(100% - 1px);height:-moz-calc(100% - 1px);height:calc(100% - 1px);margin:0;width:100%}@media ").concat(mediaQueries.medium, "{.sidebar.__jsx-style-dynamic-selector:not(.mobile):not(.hidden){border-left:1px solid var(--card-border);-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;height:100%;position:static;width:").concat(lib_constants/* SIDEBAR_WIDTH */.ZR, "px}.sidebar.hidden.__jsx-style-dynamic-selector{width:0}}@media ").concat(mediaQueries.large, " and (min-height:500px){.sidebar.mobile.__jsx-style-dynamic-selector:not(.hidden){-webkit-flex-basis:300px;-ms-flex-preferred-size:300px;flex-basis:300px;-webkit-box-flex:0;-webkit-flex-grow:0;-moz-box-flex:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:-webkit-calc(100% - var(--banner-height));height:-moz-calc(100% - var(--banner-height));height:calc(100% - var(--banner-height));position:relative;top:0;width:").concat(lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi, "px}.sidebar.mobile.__jsx-style-dynamic-selector .container{-webkit-transform:none;-moz-transform:none;-ms-transform:none;-o-transform:none;transform:none;-webkit-transition:none;-moz-transition:none;-o-transition:none;transition:none}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Sidebar/index.ts


// EXTERNAL MODULE: ../shared/dist/lib/dom.js
var dom = __webpack_require__(6912);
// EXTERNAL MODULE: ../shared/dist/lib/throttle.js
var throttle = __webpack_require__(9399);
// EXTERNAL MODULE: ../../node_modules/@tanstack/virtual-core/build/lib/index.mjs + 1 modules
var build_lib = __webpack_require__(9234);
;// CONCATENATED MODULE: ./hooks/useScrollbarWidth.ts

var useScrollbarWidth = function() {
    var ref = (0,react.useState)(0), scrollbarWidth = ref[0], setScrollbarWidth = ref[1];
    (0,react.useEffect)(function() {
        // Create fake div to determine if scrollbar is rendered inside or outside
        var div = document.createElement("div");
        div.style.width = "100px";
        div.style.height = "1px";
        div.style.position = "absolute";
        div.style.left = "-9999em";
        div.style.top = "-9999em";
        div.style.overflow = "auto";
        div.setAttribute("aria-hidden", "true");
        var child = document.createElement("div");
        child.textContent = "This is a test div.";
        div.appendChild(child);
        document.body.appendChild(div);
        var autoWidth = child.clientWidth;
        div.style.overflow = "hidden";
        var hiddenWidth = child.clientWidth;
        setScrollbarWidth(hiddenWidth - autoWidth);
        div.remove();
    }, []);
    return scrollbarWidth;
};

;// CONCATENATED MODULE: ./components/SpeakerView/useBlockScrolling.ts

/**
 * Takes a ref to the scrolling element in ParticipantBar.
 * Observes DOM changes and returns true, if a TileActions menu is opened.
 * @returns boolean
 */ var useBlockScrolling = function(scrollRef) {
    var ref = (0,react.useState)(false), blockScrolling = ref[0], setBlockScrolling = ref[1];
    (0,react.useEffect)(function() {
        var scrollEl = scrollRef.current;
        if (!scrollEl || typeof MutationObserver === "undefined") return;
        var observer = new MutationObserver(function() {
            if (!scrollEl) return;
            setBlockScrolling(!!scrollEl.querySelector(".tile-actions.showMenu"));
        });
        observer.observe(scrollEl, {
            attributes: true,
            childList: true,
            subtree: true
        });
        return function() {
            observer.disconnect();
        };
    }, [
        scrollRef
    ]);
    return blockScrolling;
};

;// CONCATENATED MODULE: ./components/SpeakerView/ParticipantBar.tsx
function ParticipantBar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ParticipantBar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ParticipantBar_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ParticipantBar_arrayLikeToArray(arr);
}
function ParticipantBar_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ParticipantBar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ParticipantBar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParticipantBar_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParticipantBar_slicedToArray(arr, i) {
    return ParticipantBar_arrayWithHoles(arr) || ParticipantBar_iterableToArrayLimit(arr, i) || ParticipantBar_unsupportedIterableToArray(arr, i) || ParticipantBar_nonIterableRest();
}
function ParticipantBar_toConsumableArray(arr) {
    return ParticipantBar_arrayWithoutHoles(arr) || ParticipantBar_iterableToArray(arr) || ParticipantBar_unsupportedIterableToArray(arr) || ParticipantBar_nonIterableSpread();
}
function ParticipantBar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ParticipantBar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ParticipantBar_arrayLikeToArray(o, minLen);
}























/**
 * Gap between tiles in pixels.
 */ var ParticipantBar_GAP = 1;
var ParticipantBar = function(param) {
    var _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? lib_constants/* DEFAULT_ASPECT_RATIO */.vr : _aspectRatio, fixed = param.fixed, others = param.others, visible = param.visible;
    var ref8;
    var ref1 = (0,Theme.useTheme)(), colors = ref1.colors, mediaQueries = ref1.mediaQueries;
    var enableEmojiReactions = (0,useCallConfig/* useCallConfig */.A)().enableEmojiReactions;
    var swapParticipantPosition = (0,ParticipantsProvider/* useParticipants */.BL)().swapParticipantPosition;
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var maxCamSubscriptions = useMaxCamSubscriptions();
    var ref2 = ParticipantBar_slicedToArray((0,layout/* usePinnedId */.Sg)(), 1), pinnedId = ref2[0];
    var ref3 = ParticipantBar_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sidebarView = ref3[0];
    var ref4 = ParticipantBar_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref4[0];
    var ref5 = ParticipantBar_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 1), showParticipantsBar = ref5[0];
    var scrollTop = (0,react.useRef)(0);
    var scrollRef = (0,react.useRef)(null);
    var othersRef = (0,react.useRef)(null);
    var blockScrolling = useBlockScrolling(scrollRef);
    var scrollbarWidth = useScrollbarWidth();
    var activeSpeakerId = useActiveSpeaker();
    var screens = (0,useScreens/* useScreens */.O)();
    var ref6 = (0,react.useState)(false), /*#__PURE__*/ scrollable1 = ref6[0], setScrollable = ref6[1];
    var itemHeight = (0,react.useMemo)(function() {
        return lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF / aspectRatio + ParticipantBar_GAP;
    }, [
        aspectRatio
    ]);
    var hasPinnedOrScreens = (0,react.useMemo)(function() {
        return screens.length > 0 || pinnedId;
    }, [
        pinnedId,
        screens
    ]);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var virtualizer = (0,lib/* useVirtualizer */.MG)({
        count: others.length,
        getScrollElement: function() {
            return scrollRef.current;
        },
        estimateSize: (0,react.useCallback)(function() {
            return itemHeight;
        }, [
            itemHeight
        ]),
        overscan: 4,
        rangeExtractor: (0,react.useCallback)(function(range) {
            if (!scrollRef.current) return (0,build_lib/* defaultRangeExtractor */.MK)(range);
            var fixedHeight = fixed.length * itemHeight;
            var visHeight = scrollRef.current.clientHeight - fixedHeight;
            var start = Math.max(0, Math.floor(scrollRef.current.scrollTop / itemHeight));
            var end = Math.min(Math.ceil((scrollRef.current.scrollTop + visHeight) / itemHeight), range.count);
            var next = new Set(ParticipantBar_toConsumableArray((0,build_lib/* defaultRangeExtractor */.MK)(range)));
            for(var i = start; i < end; i++){
                next.add(i);
            }
            return ParticipantBar_toConsumableArray(next).sort(function(a, b) {
                return a - b;
            });
        }, [
            fixed.length,
            itemHeight
        ])
    });
    var virtualItems = virtualizer.getVirtualItems();
    var ref7;
    /**
   * Contains the list of session_ids currently rendered,
   * based on the virtualized scroll frame.
   */ var start1 = (ref7 = virtualItems === null || virtualItems === void 0 ? void 0 : (ref8 = virtualItems[0]) === null || ref8 === void 0 ? void 0 : ref8.index) !== null && ref7 !== void 0 ? ref7 : 0;
    var renderedOthers = others.slice(start1, start1 + virtualItems.length);
    /**
   * Determines whether or not to render the active speaker border.
   * Border should be omitted in 1-to-1 scenarios.
   */ var shouldRenderSpeakerBorder = // Non-floating bar with at least 3 rendered participants
    (showParticipantsBar && fixed.length + others.length > 2) || // Floating bar with more than 1 participant on shread screen
    (!showParticipantsBar && fixed.length > 1 && hasPinnedOrScreens);
    /**
   * Determines subscribed and staged participant ids,
   * based on rendered range, scroll position and viewport.
   */ var camSubscriptions = (0,react.useMemo)(function() {
        var fixedRemote = fixed.filter(function(id) {
            return id !== localSessionId;
        });
        var scrollEl = scrollRef.current;
        // No participant bar = Subscribe to speaker & pinned only
        if (!showParticipantsBar || !scrollEl) {
            return {
                subscribedIds: [
                    currentSpeakerId,
                    pinnedId
                ].concat(ParticipantBar_toConsumableArray(fixedRemote)),
                stagedIds: []
            };
        }
        var visibleIds = virtualItems.filter(function(v) {
            return v.end > scrollEl.scrollTop && v.start < scrollEl.scrollTop + scrollEl.clientHeight;
        }).slice(0, maxCamSubscriptions !== null && maxCamSubscriptions !== void 0 ? maxCamSubscriptions : virtualItems.length);
        var bufferedIds = virtualItems.filter(function(v) {
            return v.end <= scrollEl.scrollTop || v.start >= scrollEl.scrollTop + scrollEl.clientHeight;
        });
        return {
            subscribedIds: [
                currentSpeakerId,
                pinnedId, 
            ].concat(ParticipantBar_toConsumableArray(fixedRemote), ParticipantBar_toConsumableArray(visibleIds.map(function(v) {
                return others[v.index];
            }))),
            stagedIds: bufferedIds.map(function(v) {
                return others[v.index];
            })
        };
    }, [
        currentSpeakerId,
        fixed,
        localSessionId,
        maxCamSubscriptions,
        others,
        pinnedId,
        showParticipantsBar,
        virtualItems, 
    ]);
    useCamSubscriptions(camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.subscribedIds, camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.stagedIds);
    /**
   * Keep scroll position when toggling sidebar.
   */ (0,react.useEffect)(function() {
        var scrollable = scrollRef.current;
        if (!scrollable) return;
        var handleScroll = function() {
            scrollTop.current = scrollable.scrollTop;
        };
        scrollable.addEventListener("scroll", handleScroll);
        return function() {
            scrollable.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!scrollRef.current) return;
        scrollRef.current.scrollTop = scrollTop.current;
    }, [
        sidebarView
    ]);
    /**
   * Move out-of-view active speakers to position right after presenters.
   */ (0,react.useEffect)(function() {
        var scrollEl = scrollRef.current;
        // Ignore promoting, when no screens are being shared
        // because the active participant will be shown in the SpeakerTile anyway
        if (!hasPinnedOrScreens || !scrollEl || !activeSpeakerId) return;
        var maybePromoteActiveSpeaker = function() {
            var ref;
            var fixedOtherId = fixed.find(function(id) {
                return id !== localSessionId;
            });
            // Promote speaker when participant bar isn't rendered & screen is shared
            if (!showParticipantsBar && hasPinnedOrScreens && fixedOtherId) {
                swapParticipantPosition(fixedOtherId, activeSpeakerId);
                return;
            }
            // Ignore when speaker is already at first position or component unmounted
            if (!fixedOtherId || fixedOtherId === activeSpeakerId || !scrollEl) return;
            // Active speaker not rendered at all, promote immediately
            if (renderedOthers.every(function(id) {
                return id !== activeSpeakerId;
            }) && activeSpeakerId !== localSessionId) {
                swapParticipantPosition(fixedOtherId, activeSpeakerId);
                return;
            }
            var activeTile = (ref = othersRef.current) === null || ref === void 0 ? void 0 : ref.querySelector('[id="'.concat(activeSpeakerId, '"]'));
            // Ignore when active speaker is not within "others"
            if (!activeTile) return;
            // Ignore when active speaker is already pinned
            if (activeSpeakerId === pinnedId) return;
            // Ignore when speaker is already visible (< 50% cut off)
            if ((0,dom.isElementVisibleInContainer)(activeTile, scrollEl, 0.5)) return;
            swapParticipantPosition(fixedOtherId, activeSpeakerId);
        };
        maybePromoteActiveSpeaker();
        var throttledHandler = (0,throttle/* throttle */.P)(maybePromoteActiveSpeaker, 100);
        scrollEl.addEventListener("scroll", throttledHandler);
        return function() {
            scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.removeEventListener("scroll", throttledHandler);
        };
    }, [
        activeSpeakerId,
        fixed,
        hasPinnedOrScreens,
        localSessionId,
        pinnedId,
        showParticipantsBar,
        swapParticipantPosition,
        renderedOthers, 
    ]);
    (0,useResizeObserver.useResizeObserver)(scrollRef, function() {
        var scrollable = scrollRef.current;
        if (!scrollable) return;
        setScrollable(scrollable.scrollHeight > scrollable.clientHeight);
    });
    var allLength = fixed.length + others.length;
    if (allLength === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: scrollRef,
        className: styled_jsx_default().dynamic([
            [
                "8bb35386a674076d",
                [
                    colors.custom.mainAreaBg,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                    colors.background,
                    colors.background,
                    ParticipantBar_GAP,
                    colors.custom.mainAreaBg,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                    mediaQueries.large,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF
                ]
            ]
        ]) + " " + (classnames_default()("sidebar", {
            blockScrolling: blockScrolling,
            floating: !showParticipantsBar,
            scrollable: scrollable1,
            scrollbarOutside: scrollbarWidth > 0,
            visible: visible
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "8bb35386a674076d",
                        [
                            colors.custom.mainAreaBg,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                            colors.background,
                            colors.background,
                            ParticipantBar_GAP,
                            colors.custom.mainAreaBg,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                            mediaQueries.large,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF
                        ]
                    ]
                ]) + " " + "fixed",
                children: fixed.map(function(id, i) {
                    // reduce setting up & tearing down tiles as much as possible
                    var key = i;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                        alignActionsMenu: showParticipantsBar ? "right" : "left",
                        aspectRatio: aspectRatio,
                        isSpeaking: shouldRenderSpeakerBorder && id === activeSpeakerId,
                        network: id === localSessionId ? threshold : null,
                        sessionId: id,
                        showNames: showNames
                    }, key);
                })
            }),
            showParticipantsBar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: othersRef,
                style: {
                    height: "".concat(virtualizer.getTotalSize(), "px")
                },
                className: styled_jsx_default().dynamic([
                    [
                        "8bb35386a674076d",
                        [
                            colors.custom.mainAreaBg,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                            colors.background,
                            colors.background,
                            ParticipantBar_GAP,
                            colors.custom.mainAreaBg,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                            mediaQueries.large,
                            lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF
                        ]
                    ]
                ]) + " " + "participants",
                children: virtualItems.map(function(row) {
                    var id = others[row.index];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: virtualizer.measureElement,
                        "data-index": row.index,
                        style: {
                            transform: "translateY(".concat(row.start, "px)")
                        },
                        className: styled_jsx_default().dynamic([
                            [
                                "8bb35386a674076d",
                                [
                                    colors.custom.mainAreaBg,
                                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                                    colors.background,
                                    colors.background,
                                    ParticipantBar_GAP,
                                    colors.custom.mainAreaBg,
                                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                                    mediaQueries.large,
                                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF
                                ]
                            ]
                        ]) + " " + "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                            alignActionsMenu: showParticipantsBar ? "right" : "left",
                            aspectRatio: aspectRatio,
                            isSpeaking: shouldRenderSpeakerBorder && id === activeSpeakerId,
                            network: id === localSessionId ? threshold : null,
                            sessionId: id,
                            showNames: showNames,
                            showReactions: enableEmojiReactions
                        })
                    }, row.key);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "8bb35386a674076d",
                dynamic: [
                    colors.custom.mainAreaBg,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                    colors.background,
                    colors.background,
                    ParticipantBar_GAP,
                    colors.custom.mainAreaBg,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF,
                    mediaQueries.large,
                    lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF
                ],
                children: ".sidebar.__jsx-style-dynamic-selector{border-left:1px solid ".concat(colors.custom.mainAreaBg, ";-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;margin-left:1px;min-width:").concat(lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF, "px;overflow-x:hidden;overflow-y:auto}.sidebar.__jsx-style-dynamic-selector:not(.visible){display:none}.sidebar.blockScrolling.__jsx-style-dynamic-selector{overflow-y:hidden}.sidebar.floating.__jsx-style-dynamic-selector{border:none;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;-webkit-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);-moz-box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);box-shadow:0px 4px 4px rgba(0,0,0,.04),0px 0px 4px rgba(0,0,0,.08);left:8px;position:fixed;top:-webkit-calc(var(--header-height) + 8px);top:-moz-calc(var(--header-height) + 8px);top:calc(var(--header-height) + 8px);width:138px;z-index:var(--zindex-sidebar)}.sidebar.floating.__jsx-style-dynamic-selector .tile{border:none}.sidebar.scrollable.blockScrolling.scrollbarOutside.__jsx-style-dynamic-selector{padding-right:12px}.sidebar.scrollable.blockScrolling.scrollbarOutside.__jsx-style-dynamic-selector::after{background:").concat(colors.background, ';content:"";height:100%;position:absolute;right:0;top:0;width:12px}.sidebar.__jsx-style-dynamic-selector:not(.scrollbarOutside) .tile-actions{right:20px}.sidebar.__jsx-style-dynamic-selector .hand-status,.sidebar.__jsx-style-dynamic-selector .hand-status .queue-number{--scale:0.75;-webkit-transform:scale(var(--scale));-moz-transform:scale(var(--scale));-ms-transform:scale(var(--scale));-o-transform:scale(var(--scale));transform:scale(var(--scale));font-size:-webkit-calc(1em/var(--scale));font-size:-moz-calc(1em/var(--scale));font-size:calc(1em/var(--scale));-webkit-transform-origin:0 0;-moz-transform-origin:0 0;-ms-transform-origin:0 0;-o-transform-origin:0 0;transform-origin:0 0}.sidebar.__jsx-style-dynamic-selector .fixed.__jsx-style-dynamic-selector{background:').concat(colors.background, ";position:-webkit-sticky;position:sticky;top:0;z-index:3}.sidebar.__jsx-style-dynamic-selector .participants.__jsx-style-dynamic-selector{position:relative}.sidebar.__jsx-style-dynamic-selector .tile{border-top:").concat(ParticipantBar_GAP, "px solid ").concat(colors.custom.mainAreaBg, ";width:").concat(lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF, "px}.sidebar.__jsx-style-dynamic-selector .fixed.__jsx-style-dynamic-selector .tile:first-child{border:none}.sidebar.__jsx-style-dynamic-selector .participants.__jsx-style-dynamic-selector .row.__jsx-style-dynamic-selector{position:absolute;width:100%}@media ").concat(mediaQueries.large, "{.sidebar.floating.__jsx-style-dynamic-selector{width:").concat(lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF, "px}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/ScreenPinTile.tsx
function ScreenPinTile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ScreenPinTile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ScreenPinTile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScreenPinTile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ScreenPinTile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ScreenPinTile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScreenPinTile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ScreenPinTile_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ScreenPinTile_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ScreenPinTile_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ScreenPinTile_slicedToArray(arr, i) {
    return ScreenPinTile_arrayWithHoles(arr) || ScreenPinTile_iterableToArrayLimit(arr, i) || ScreenPinTile_unsupportedIterableToArray(arr, i) || ScreenPinTile_nonIterableRest();
}
function ScreenPinTile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ScreenPinTile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ScreenPinTile_arrayLikeToArray(o, minLen);
}






var ScreenPinTile = function(_param) {
    var initialRatio = _param.aspectRatio, _fitToRatio = _param.fitToRatio, fitToRatio = _fitToRatio === void 0 ? false : _fitToRatio, _isScreen = _param.isScreen, isScreen = _isScreen === void 0 ? false : _isScreen, onVideoResize = _param.onVideoResize, sessionId = _param.sessionId, _style = _param.style, style = _style === void 0 ? {} : _style, props = ScreenPinTile_objectWithoutProperties(_param, [
        "aspectRatio",
        "fitToRatio",
        "isScreen",
        "onVideoResize",
        "sessionId",
        "style"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,react.useState)(initialRatio), ratio = ref[0], setRatio = ref[1];
    var ref1 = ScreenPinTile_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref1[0];
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var handleVideoResize = function(aspectRatio) {
        if (!fitToRatio) return;
        setRatio(aspectRatio);
        onVideoResize === null || onVideoResize === void 0 ? void 0 : onVideoResize(aspectRatio);
    };
    if (isScreen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, ScreenPinTile_objectSpread({
            ignoreAspectRatio: true,
            isScreen: true,
            sessionId: sessionId,
            onVideoResize: handleVideoResize,
            style: ScreenPinTile_objectSpread({}, style, {
                background: colors.custom.mainAreaBg
            })
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, ScreenPinTile_objectSpread({
        aspectRatio: ratio,
        network: isLocal ? threshold : null,
        onVideoResize: handleVideoResize,
        sessionId: sessionId,
        showNames: showNames
    }, props));
};


;// CONCATENATED MODULE: ./components/SpeakerView/MainIntegration.tsx


var MainIntegration = function(param) {
    var integration = param.integration;
    var _loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                allow: integration.allow,
                // @ts-ignore
                csp: integration.csp,
                loading: (_loading = integration.loading) !== null && _loading !== void 0 ? _loading : "lazy",
                id: "iframe-integration-".concat(integration.id),
                name: integration.name,
                referrerPolicy: integration.referrerPolicy,
                sandbox: integration.sandbox,
                src: integration.src,
                srcDoc: integration.srcdoc,
                className: "jsx-48c663152eaa5429"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "48c663152eaa5429",
                children: "iframe.jsx-48c663152eaa5429{border:none;height:100%;width:100%}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/RefreshIcon.js
var RefreshIcon = __webpack_require__(5434);
;// CONCATENATED MODULE: ./components/Apps/AppIcon.tsx





var AppIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var id = param.id, size = param.size, style = param.style;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().mainIntegrations;
    var app = mainIntegrations.find(function(i) {
        return i.id === id;
    });
    return (app === null || app === void 0 ? void 0 : app.iconURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: t("integrations.iconAltText", {
            label: app.label
        }),
        src: app.iconURL,
        style: style,
        width: size
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
        size: size,
        style: style
    });
});
AppIcon.displayName = "AppIcon";

;// CONCATENATED MODULE: ./components/SpeakerView/MainIntegrationTab.tsx
function MainIntegrationTab_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MainIntegrationTab_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MainIntegrationTab_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MainIntegrationTab_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MainIntegrationTab_slicedToArray(arr, i) {
    return MainIntegrationTab_arrayWithHoles(arr) || MainIntegrationTab_iterableToArrayLimit(arr, i) || MainIntegrationTab_unsupportedIterableToArray(arr, i) || MainIntegrationTab_nonIterableRest();
}
function MainIntegrationTab_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MainIntegrationTab_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MainIntegrationTab_arrayLikeToArray(o, minLen);
}














var MainIntegrationTab = function(param) {
    var index = param.index, integration = param.integration;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var ref1 = MainIntegrationTab_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), pinnedId = ref1[0], setPinnedId = ref1[1];
    var ref2 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), canControlIntegration = ref2.canControlIntegration, stopIntegration = ref2.stopIntegration;
    var btnId = (0,react.useId)();
    var menuId = (0,react.useId)();
    var handleClickPin = function() {
        setPinnedId(function(p) {
            return p === integration.id ? null : integration.id;
        });
        setShowMenu(false);
    };
    var handleClickRefresh = function() {
        var iframe = document.querySelector('iframe[id="iframe-integration-'.concat(integration.id, '"]'));
        iframe.src = iframe.src;
        setShowMenu(false);
    };
    var handleClickClose = function() {
        setShowMenu(false);
        stopIntegration(integration.id);
    };
    (0,react.useEffect)(function() {
        setShowMenu(false);
    }, [
        pinnedId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                index: index,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIcon, {
                    id: integration.id,
                    size: 16,
                    style: {
                        padding: 1
                    }
                }),
                menuButton: {
                    "aria-controls": menuId,
                    id: btnId,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("integrations.showOptions", {
                                    label: integration.label
                                })
                            })
                        ]
                    }),
                    onClick: function() {
                        return setShowMenu(true);
                    },
                    open: showMenu
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "center",
                    gap: 4,
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            El: "span",
                            style: {
                                maxWidth: 200
                            },
                            truncate: true,
                            children: integration.label
                        }),
                        pinnedId === integration.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon/* PinIcon */.q, {
                            size: 16
                        })
                    ]
                })
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                id: menuId,
                align: "left",
                "aria-labelledby": btnId,
                offsetTop: 0,
                placement: "bottom",
                items: [
                    {
                        label: pinnedId === integration.id ? t("integrations.unpin", {
                            label: integration.label
                        }) : t("integrations.pin", {
                            label: integration.label
                        }),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon/* PinIcon */.q, {
                            size: 16
                        }),
                        onClick: handleClickPin
                    },
                    {
                        label: t("integrations.refresh", {
                            label: integration.label
                        }),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIcon/* RefreshIcon */.D, {
                            size: 16
                        }),
                        onClick: handleClickRefresh
                    },
                    canControlIntegration(integration) ? {
                        label: t("integrations.close", {
                            label: integration.label
                        }),
                        onClick: handleClickClose
                    } : null, 
                ].filter(Boolean),
                onClose: function() {
                    return setShowMenu(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/ScreenTab.tsx
function ScreenTab_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ScreenTab_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ScreenTab_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ScreenTab_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ScreenTab_slicedToArray(arr, i) {
    return ScreenTab_arrayWithHoles(arr) || ScreenTab_iterableToArrayLimit(arr, i) || ScreenTab_unsupportedIterableToArray(arr, i) || ScreenTab_nonIterableRest();
}
function ScreenTab_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ScreenTab_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ScreenTab_arrayLikeToArray(o, minLen);
}
















var ScreenTab = function(param) {
    var index = param.index, screen = param.screen;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var ref1 = ScreenTab_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), pinnedId = ref1[0], setPinnedId = ref1[1];
    var stopScreenShare = (0,daily_react_esm/* useScreenShare */.N2)().stopScreenShare;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref2 = ScreenTab_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref2[0];
    var isOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var btnId = (0,react.useId)();
    var menuId = (0,react.useId)();
    var handleClickPin = function() {
        setPinnedId(function(p) {
            return p === screen.screenId ? null : screen.screenId;
        });
        setShowMenu(false);
    };
    var handleClickStop = function() {
        setShowMenu(false);
        stopScreenShare();
    };
    var handleClickRemoteStop = function() {
        setShowMenu(false);
        daily.sendAppMessage("stop-screen-share", screen.session_id);
    };
    (0,react.useEffect)(function() {
        setShowMenu(false);
    }, [
        pinnedId
    ]);
    var name = useDisplayName(screen.session_id, showNames);
    if (screen.session_id === localSessionId) {
        name = t("people.you");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                index: index,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                    size: 16
                }),
                menuButton: {
                    "aria-controls": menuId,
                    id: btnId,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("screenShare.showOptions")
                            })
                        ]
                    }),
                    onClick: function() {
                        return setShowMenu(true);
                    },
                    open: showMenu
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "center",
                    gap: 4,
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                            El: "span",
                            style: {
                                maxWidth: 200
                            },
                            truncate: true,
                            children: [
                                t("general.screenShare"),
                                " (",
                                name,
                                ")"
                            ]
                        }),
                        pinnedId === screen.screenId && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon/* PinIcon */.q, {
                            size: 16
                        })
                    ]
                })
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                id: menuId,
                align: "left",
                "aria-labelledby": btnId,
                offsetTop: 0,
                placement: "bottom",
                items: [
                    {
                        label: pinnedId === screen.screenId ? t("screenShare.unpin") : t("screenShare.pin"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon/* PinIcon */.q, {
                            size: 16
                        }),
                        onClick: handleClickPin
                    },
                    screen.session_id === localSessionId ? {
                        label: t("screenShare.stopSharing"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StopScreenshareIcon/* StopScreenshareIcon */.C, {
                            size: 16
                        }),
                        onClick: handleClickStop
                    } : null,
                    isOwner && screen.session_id !== localSessionId ? {
                        label: t("screenShare.stopShare"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StopScreenshareIcon/* StopScreenshareIcon */.C, {
                            size: 16
                        }),
                        onClick: handleClickRemoteStop
                    } : null, 
                ].filter(Boolean),
                onClose: function() {
                    return setShowMenu(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/SharedTabs.tsx
function SharedTabs_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SharedTabs_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SharedTabs_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SharedTabs_arrayLikeToArray(arr);
}
function SharedTabs_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SharedTabs_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SharedTabs_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SharedTabs_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SharedTabs_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SharedTabs_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SharedTabs_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SharedTabs_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = SharedTabs_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SharedTabs_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SharedTabs_slicedToArray(arr, i) {
    return SharedTabs_arrayWithHoles(arr) || SharedTabs_iterableToArrayLimit(arr, i) || SharedTabs_unsupportedIterableToArray(arr, i) || SharedTabs_nonIterableRest();
}
function SharedTabs_toConsumableArray(arr) {
    return SharedTabs_arrayWithoutHoles(arr) || SharedTabs_iterableToArray(arr) || SharedTabs_unsupportedIterableToArray(arr) || SharedTabs_nonIterableSpread();
}
function SharedTabs_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SharedTabs_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SharedTabs_arrayLikeToArray(o, minLen);
}












var SharedTabs = function(_param) {
    var className = _param.className, _integrations = _param.integrations, integrations = _integrations === void 0 ? [] : _integrations, _screens = _param.screens, screens = _screens === void 0 ? [] : _screens, props = SharedTabs_objectWithoutProperties(_param, [
        "className",
        "integrations",
        "screens"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    var ref = SharedTabs_slicedToArray((0,layout/* usePinnedId */.Sg)(), 1), pinnedId = ref[0];
    var tabsId = (0,react.useId)();
    var tabs = SharedTabs_toConsumableArray(integrations).concat(SharedTabs_toConsumableArray(screens));
    var pinnedIdx = tabs.findIndex(function(t) {
        return "screenId" in t ? t.screenId === pinnedId : t.id === pinnedId;
    });
    var lastActiveTab = (0,react.useRef)(0);
    var handleTabChange = (0,react.useCallback)(function(idx) {
        lastActiveTab.current = idx;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", SharedTabs_objectSpread({}, props, {
        className: styled_jsx_default().dynamic([
            [
                "2c3b6b76f43f60da",
                [
                    colors.custom.mainAreaBgAccent,
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBgAccent, 0),
                    colors.custom.mainAreaBgAccent
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()("shared-tabs", className) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.mQ, {
                id: tabsId,
                initialIndex: pinnedIdx >= 0 ? pinnedIdx : lastActiveTab.current,
                onChangeTab: handleTabChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Theme.ThemeScope, {
                        theme: "dark",
                        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabList */.td, {
                            gap: 16,
                            spaceAround: 8,
                            children: tabs.filter(function(t1) {
                                if (!pinnedId) return true;
                                if (!tabs.some(function(t) {
                                    return "screenId" in t ? t.screenId === pinnedId : t.id === pinnedId;
                                })) return true;
                                if ("screenId" in t1) return t1.screenId === pinnedId;
                                return t1.id === pinnedId;
                            }).map(function(t, idx) {
                                if ("screenId" in t) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenTab, {
                                        index: pinnedIdx >= 0 ? pinnedIdx : idx,
                                        screen: t
                                    }, t.screenId);
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainIntegrationTab, {
                                        index: pinnedIdx >= 0 ? pinnedIdx : idx,
                                        integration: t
                                    }, t.id);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanels */.nP, {
                        children: tabs.map(function(t, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                className: classnames_default()("panel", {
                                    "screen-panel": "screenId" in t
                                }),
                                hideStrategy: "css",
                                index: idx,
                                children: "screenId" in t ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenPinTile, {
                                    fitToRatio: true,
                                    hideActions: true,
                                    isScreen: true,
                                    sessionId: t.session_id
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainIntegration, {
                                    integration: t
                                })
                            }, "screenId" in t ? t.screenId : t.id);
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "2c3b6b76f43f60da",
                dynamic: [
                    colors.custom.mainAreaBgAccent,
                    (0,lib_colors.hexToRgba)(colors.custom.mainAreaBgAccent, 0),
                    colors.custom.mainAreaBgAccent
                ],
                children: ".shared-tabs.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;width:100%}.shared-tabs.__jsx-style-dynamic-selector .tablist{--tab-bg:".concat(colors.custom.mainAreaBgAccent, ";--tabs-scroll-bg-op0:").concat((0,lib_colors.hexToRgba)(colors.custom.mainAreaBgAccent, 0), ";background-color:").concat(colors.custom.mainAreaBgAccent, "}.shared-tabs.__jsx-style-dynamic-selector .tab{--pad:0px}.shared-tabs.__jsx-style-dynamic-selector .tablist .scroll{--pad:4px}.tab-content.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px}.shared-tabs.__jsx-style-dynamic-selector .panel{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;padding-top:0;position:relative}.shared-tabs.__jsx-style-dynamic-selector .screen-panel.visible{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}")
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/SpeakerView/ScreensAndPins.tsx
function ScreensAndPins_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ScreensAndPins_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ScreensAndPins_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ScreensAndPins_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ScreensAndPins_slicedToArray(arr, i) {
    return ScreensAndPins_arrayWithHoles(arr) || ScreensAndPins_iterableToArrayLimit(arr, i) || ScreensAndPins_unsupportedIterableToArray(arr, i) || ScreensAndPins_nonIterableRest();
}
function ScreensAndPins_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ScreensAndPins_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ScreensAndPins_arrayLikeToArray(o, minLen);
}











var ScreensAndPins = function() {
    var colors = (0,Theme.useTheme)().colors;
    var ref = ScreensAndPins_slicedToArray((0,layout/* usePinnedId */.Sg)(), 1), pinnedId = ref[0];
    var viewRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)({
        width: 1,
        height: 1
    }), /*#__PURE__*/ dimensions = ref1[0], setDimensions = ref1[1];
    var screens = (0,useScreens/* useScreens */.O)();
    var runningMainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().runningMainIntegrations;
    var pinnedScreen = (0,react.useMemo)(function() {
        return screens.find(function(s) {
            return s.screenId === pinnedId;
        });
    }, [
        pinnedId,
        screens
    ]);
    var pinnedIntegration = (0,react.useMemo)(function() {
        return runningMainIntegrations.find(function(i) {
            return i.id === pinnedId;
        });
    }, [
        runningMainIntegrations,
        pinnedId
    ]);
    (0,useResizeObserver.useResizeObserver)(viewRef, (0,react.useCallback)(function(width, height) {
        setDimensions({
            width: width,
            height: height
        });
    }, []));
    var isPortraitLayout = dimensions.height > dimensions.width;
    var screensCount = screens.length;
    var isPinnedParticipant = Boolean(pinnedId) && !pinnedIntegration && !pinnedScreen;
    /**
     * Check if there are any running main integrations.
     * Check if there's a pinned participant.
     */ /**
     * When there are only 2 running apps or 2 screen shares, we'll render them in 2 separate Tabs components.
     */ var only2Apps = runningMainIntegrations.length === 2 && screensCount === 0 && !isPinnedParticipant;
    var only2Screens = runningMainIntegrations.length === 0 && screensCount === 2 && !isPinnedParticipant;
    /**
     * Determine the apps rendered in the first (= primary) section:
     * - When there are no running apps, no apps 😄
     * - When there are exactly 2 apps, render the first
     * - Otherwise render all apps here
     */ var primaryTabsApps = (0,react.useMemo)(function() {
        if (!runningMainIntegrations.length) return [];
        if (only2Apps) return runningMainIntegrations.slice(0, 1);
        return runningMainIntegrations;
    }, [
        only2Apps,
        runningMainIntegrations
    ]);
    /**
     * Determine the screen shares rendered in the first section:
     * - When there's a pinned participant
     * - When there are exactly 2 screen shares, render the first
     * - When there are no apps
     * - Otherwise none (because screens will be rendered in secondary section, when there are apps)
     */ var primaryTabsScreens = (0,react.useMemo)(function() {
        if (isPinnedParticipant) return screens;
        if (only2Screens) return screens.slice(0, 1);
        if (!primaryTabsApps.length) return screens;
        return [];
    }, [
        isPinnedParticipant,
        only2Screens,
        primaryTabsApps.length,
        screens
    ]);
    /**
     * There's only 1 case when we render an app in the secondary section:
     * - When there are exactly 2 apps, render the second
     */ var secondaryTabsApps = (0,react.useMemo)(function() {
        if (only2Apps) return runningMainIntegrations.slice(1, 2);
        return [];
    }, [
        only2Apps,
        runningMainIntegrations
    ]);
    /**
     * Screen shares are rendered in secondary section:
     * - When there are exactly 2 screens, render the second here
     * - When there's no pinned participant, but running apps
     * - Otherwise no screens here (because they'll be rendered in the primary section otherwise)
     */ var secondaryTabsScreens = (0,react.useMemo)(function() {
        if (only2Screens) return screens.slice(1, 2);
        if (!isPinnedParticipant && primaryTabsApps.length) return screens;
        return [];
    }, [
        isPinnedParticipant,
        only2Screens,
        primaryTabsApps.length,
        screens
    ]);
    /**
     * Determines the relative width and height for each section, based on main area aspect ratio.
     */ var splitAreaDimensions = (0,react.useMemo)(function() {
        return {
            height: isPortraitLayout ? "50%" : "100%",
            width: isPortraitLayout ? "100%" : "50%"
        };
    }, [
        isPortraitLayout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: viewRef,
        className: styled_jsx_default().dynamic([
            [
                "bf6e0829a96844fa",
                [
                    colors.custom.mainAreaBg
                ]
            ]
        ]) + " " + (classnames_default()("screens-pins", {
            portrait: isPortraitLayout,
            "pinned-integration": !!pinnedIntegration,
            "pinned-participant": isPinnedParticipant,
            "pinned-screen": !!pinnedScreen
        }) || ""),
        children: [
            primaryTabsApps.length + primaryTabsScreens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedTabs, {
                className: classnames_default()({
                    pinned: primaryTabsApps.some(function(app) {
                        return app.id === pinnedId;
                    }) || primaryTabsScreens.some(function(s) {
                        return s.screenId === pinnedId;
                    })
                }),
                integrations: primaryTabsApps,
                screens: primaryTabsScreens
            }),
            secondaryTabsApps.length + secondaryTabsScreens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedTabs, {
                className: classnames_default()({
                    pinned: secondaryTabsApps.some(function(app) {
                        return app.id === pinnedId;
                    }) || secondaryTabsScreens.some(function(s) {
                        return s.screenId === pinnedId;
                    })
                }),
                integrations: secondaryTabsApps,
                screens: secondaryTabsScreens
            }),
            isPinnedParticipant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenPinTile, {
                className: "pinned-participant",
                sessionId: pinnedId,
                style: splitAreaDimensions
            }, pinnedId),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "bf6e0829a96844fa",
                dynamic: [
                    colors.custom.mainAreaBg
                ],
                children: ".screens-pins.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:".concat(colors.custom.mainAreaBg, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:1px;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.screens-pins.portrait.__jsx-style-dynamic-selector{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.screens-pins.portrait.__jsx-style-dynamic-selector>*{height:50%}.screens-pins.__jsx-style-dynamic-selector>*{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}.screens-pins.pinned-screen.__jsx-style-dynamic-selector .shared-tabs:not(.pinned),.screens-pins.pinned-integration.__jsx-style-dynamic-selector .shared-tabs:not(.pinned){-webkit-box-flex:0;-webkit-flex:0;-moz-box-flex:0;-ms-flex:0;flex:0;overflow:hidden;width:0}.screens-pins.pinned-participant.__jsx-style-dynamic-selector:not(.portrait) .shared-tabs .screen-panel{padding-bottom:32px}.screens-pins.__jsx-style-dynamic-selector .pinned{-webkit-box-flex:2;-webkit-flex:2;-moz-box-flex:2;-ms-flex:2;flex:2}.screens-pins.pinned-participant.__jsx-style-dynamic-selector:not(.portrait)>*{max-width:50%}.screens-pins.pinned-participant.portrait.__jsx-style-dynamic-selector>*{max-width:100%}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/SpeakerTile.tsx








var initialSpace = {
    height: 1,
    width: 1
};
var SpeakerTile = function(param) {
    var isScreen = param.isScreen, screenRef = param.screenRef, sessionId = param.sessionId, showNames = param.showNames;
    var colors = (0,Theme.useTheme)().colors;
    var ref2 = (0,react.useState)(null), nativeAspectRatio = ref2[0], setNativeAspectRatio = ref2[1];
    var ref1 = (0,react.useState)(initialSpace), space = ref1[0], setSpace = ref1[1];
    var activeSpeakerId = useActiveSpeaker();
    var participantIds = (0,daily_react_esm/* useParticipantIds */.OV)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    (0,useResizeObserver.useResizeObserver)(screenRef, (0,react.useCallback)(function() {
        if (!screenRef.current) return;
        var ref = screenRef.current.getBoundingClientRect(), height = ref.height, width = ref.width;
        setSpace({
            height: height,
            width: width
        });
    }, [
        screenRef
    ]));
    /**
   * Only use the video's native aspect ratio if it's in portrait mode
   * (e.g. mobile) to update how we crop videos. Otherwise, use landscape
   * defaults.
   */ var handleNativeAspectRatio = function(ratio) {
        setNativeAspectRatio(ratio);
    };
    var camState = (0,daily_react_esm/* useVideoTrack */.HU)(sessionId);
    var style = {
        outline: "1px solid ".concat(colors.custom.mainAreaBg)
    };
    var aspectRatio = camState.isOff ? lib_constants/* DEFAULT_ASPECT_RATIO */.vr : nativeAspectRatio !== null && nativeAspectRatio !== void 0 ? nativeAspectRatio : lib_constants/* DEFAULT_ASPECT_RATIO */.vr;
    if (space.width / space.height < aspectRatio) {
        style.maxHeight = space.width / aspectRatio;
        style.width = "100%";
    } else {
        style.height = "100%";
        style.maxWidth = space.height * aspectRatio;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
        aspectRatio: aspectRatio,
        hideActions: participantIds.length === 1,
        isScreen: isScreen,
        isSpeaking: sessionId === activeSpeakerId,
        network: sessionId === localSessionId ? threshold : null,
        sessionId: sessionId,
        showNames: showNames,
        style: style,
        videoFit: "contain",
        onVideoResize: handleNativeAspectRatio
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/SpeakerView.tsx
function SpeakerView_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SpeakerView_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SpeakerView_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SpeakerView_arrayLikeToArray(arr);
}
function SpeakerView_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SpeakerView_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SpeakerView_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SpeakerView_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SpeakerView_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SpeakerView_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SpeakerView_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SpeakerView_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SpeakerView_slicedToArray(arr, i) {
    return SpeakerView_arrayWithHoles(arr) || SpeakerView_iterableToArrayLimit(arr, i) || SpeakerView_unsupportedIterableToArray(arr, i) || SpeakerView_nonIterableRest();
}
function SpeakerView_toConsumableArray(arr) {
    return SpeakerView_arrayWithoutHoles(arr) || SpeakerView_iterableToArray(arr) || SpeakerView_unsupportedIterableToArray(arr) || SpeakerView_nonIterableSpread();
}
function SpeakerView_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SpeakerView_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SpeakerView_arrayLikeToArray(o, minLen);
}






















var SpeakerView = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref7 = SpeakerView_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref7[0];
    var ref1 = SpeakerView_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 1), showLocalVideo = ref1[0];
    var ref2 = SpeakerView_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 1), showParticipantsBar = ref2[0];
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ref3 = SpeakerView_slicedToArray((0,layout/* usePinnedId */.Sg)(), 1), pinnedId = ref3[0];
    var ref4 = SpeakerView_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sidebarView = ref4[0];
    var updateCamSubscriptions = useTracks().updateCamSubscriptions;
    var activeRef = (0,react.useRef)(null);
    var screens = (0,useScreens/* useScreens */.O)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var runningMainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().runningMainIntegrations;
    var hasMainEmbeds = runningMainIntegrations.length > 0;
    var hasScreens = screens.length > 0;
    var isAttendee = (0,react.useMemo)(function() {
        return broadcastRole === "attendee";
    }, [
        broadcastRole
    ]);
    var ownerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(participant) {
            return participant.owner && !participant.local;
        }, [])
    });
    var hasPinnedOrScreens = (0,react.useMemo)(function() {
        return hasScreens || hasMainEmbeds || Boolean(pinnedId);
    }, [
        hasMainEmbeds,
        hasScreens,
        pinnedId
    ]);
    var showSidebar = (0,react.useMemo)(function() {
        return orderedParticipantIds.length > 0 || hasPinnedOrScreens;
    }, [
        hasPinnedOrScreens,
        orderedParticipantIds
    ]);
    var fixedItems = (0,react.useMemo)(function() {
        var items = [];
        if (!isAttendee && showLocalVideo) {
            items.push(localSessionId);
        }
        if (hasPinnedOrScreens && orderedParticipantIds.length > 0) {
            items.push(orderedParticipantIds[0]);
        }
        return items;
    }, [
        hasPinnedOrScreens,
        isAttendee,
        localSessionId,
        orderedParticipantIds,
        showLocalVideo, 
    ]);
    var otherItems = (0,react.useMemo)(function() {
        if (showParticipantsBar && orderedParticipantIds.length > 1) {
            return orderedParticipantIds.slice(hasPinnedOrScreens ? 1 : 0);
        }
        return [];
    }, [
        hasPinnedOrScreens,
        orderedParticipantIds,
        showParticipantsBar
    ]);
    /**
   * Update cam subscriptions, in case ParticipantBar is not shown.
   */ (0,react.useEffect)(function() {
        // Sidebar takes care of cam subscriptions for all displayed participants.
        if (showSidebar) return;
        updateCamSubscriptions([
            currentSpeakerId,
            pinnedId, 
        ].concat(SpeakerView_toConsumableArray(screens.map(function(s) {
            return s.session_id;
        }))));
    }, [
        currentSpeakerId,
        pinnedId,
        screens,
        showSidebar,
        updateCamSubscriptions, 
    ]);
    var ref5 = (0,daily_react_esm/* useNetwork */.LN)(), threshold = ref5.threshold, topology = ref5.topology;
    var videoQuality = useVideoQuality().videoQuality;
    var updateSpeakerViewReceiveSettings = (0,react.useCallback)(SpeakerView_asyncToGenerator(runtime_default().mark(function _callee() {
        var currentReceiveSettings, newReceiveSettings, hasPoorNetwork, wantsLowQuality;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return daily.getReceiveSettings();
                case 2:
                    currentReceiveSettings = _ctx.sent;
                    newReceiveSettings = {};
                    hasPoorNetwork = [
                        "low",
                        "very-low"
                    ].includes(threshold);
                    wantsLowQuality = [
                        "bandwidth-saver",
                        "low"
                    ].includes(videoQuality);
                    orderedParticipantIds.forEach(function(id) {
                        var ref, ref6;
                        if (id === localSessionId) return;
                        if (hasPoorNetwork || wantsLowQuality) {
                            newReceiveSettings[id] = {
                                video: {
                                    layer: 0
                                }
                            };
                        } else if (// Speaker view settings based on speaker status or pinned user
                        (currentSpeakerId === id && !screens.length && !pinnedId) || pinnedId === id) {
                            newReceiveSettings[id] = {
                                video: {
                                    layer: 2
                                }
                            };
                        } else {
                            newReceiveSettings[id] = {
                                video: {
                                    layer: 0
                                }
                            };
                        }
                        // Ignore call, when desired layer hasn't changed
                        if (newReceiveSettings[id].video.layer === (currentReceiveSettings === null || currentReceiveSettings === void 0 ? void 0 : (ref = currentReceiveSettings[id]) === null || ref === void 0 ? void 0 : (ref6 = ref.video) === null || ref6 === void 0 ? void 0 : ref6.layer)) {
                            delete newReceiveSettings[id];
                        }
                    });
                    if (!(Object.keys(newReceiveSettings).length === 0)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 9:
                    daily.updateReceiveSettings(newReceiveSettings);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        currentSpeakerId,
        daily,
        localSessionId,
        orderedParticipantIds,
        pinnedId,
        screens.length,
        threshold,
        videoQuality, 
    ]);
    (0,react.useEffect)(function() {
        if (!(daily && daily.meetingState() === "joined-meeting")) return;
        if (topology !== "sfu") return;
        updateSpeakerViewReceiveSettings();
    }, [
        daily,
        topology,
        updateSpeakerViewReceiveSettings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "6323f27472325fad",
                [
                    sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0",
                    colors.custom.mainAreaBg
                ]
            ]
        ]) + " " + (classnames_default()("speaker", Theme.DARK_THEME_CLASS) || ""),
        children: [
            isAttendee && ownerIds.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "largestrong",
                color: "white",
                style: {
                    margin: "auto"
                },
                /*#__PURE__*/ children: t("broadcast.hostLeft")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: activeRef,
                className: styled_jsx_default().dynamic([
                    [
                        "6323f27472325fad",
                        [
                            sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0",
                            colors.custom.mainAreaBg
                        ]
                    ]
                ]) + " " + "active",
                children: hasMainEmbeds || hasScreens ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreensAndPins, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerTile, {
                    screenRef: activeRef,
                    sessionId: currentSpeakerId,
                    showNames: showNames
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantBar, {
                fixed: fixedItems,
                others: otherItems,
                visible: showSidebar
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6323f27472325fad",
                dynamic: [
                    sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0",
                    colors.custom.mainAreaBg
                ],
                children: ".speaker.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;position:relative;width:-webkit-calc(100% - ".concat(sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0", "px);width:-moz-calc(100% - ").concat(sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0", "px);width:calc(100% - ").concat(sidebarView !== null ? lib_constants/* SIDEBAR_WIDTH */.ZR : "0", "px)}.active.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;overflow:hidden;position:relative;width:100%}.active.__jsx-style-dynamic-selector .activeBorder{display:none}.active.__jsx-style-dynamic-selector .tile.isScreenshare{background:").concat(colors.custom.mainAreaBg, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SpeakerView/index.ts


// EXTERNAL MODULE: ./lib/state/recordings.ts
var recordings = __webpack_require__(4183);
;// CONCATENATED MODULE: ./components/Call/RecordingState.tsx
function RecordingState_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RecordingState_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function RecordingState_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RecordingState_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RecordingState_slicedToArray(arr, i) {
    return RecordingState_arrayWithHoles(arr) || RecordingState_iterableToArrayLimit(arr, i) || RecordingState_unsupportedIterableToArray(arr, i) || RecordingState_nonIterableRest();
}
function RecordingState_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RecordingState_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RecordingState_arrayLikeToArray(o, minLen);
}












var bannerVariants = {
    hidden: {
        opacity: 0,
        y: "-100%"
    },
    visible: {
        opacity: 1,
        y: 0
    }
};
var redVariants = {
    starting: {
        height: "100%",
        left: 0,
        top: 0,
        width: "100%"
    },
    recording: {
        height: 8,
        left: 8,
        top: 8,
        width: 8
    }
};
var RecordingState = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,daily_react_esm/* useRecording */.$n)(), isLocalParticipantRecorded = ref.isLocalParticipantRecorded, isRecording = ref.isRecording, layout = ref.layout, local = ref.local, recordingStartedDate = ref.recordingStartedDate, startedBy = ref.startedBy, type = ref.type;
    var ref1 = RecordingState_slicedToArray((0,recordings/* useRecordingUI */.oZ)(), 1), recordingUIState = ref1[0];
    var ref2 = (0,react.useState)(null), /*#__PURE__*/ now = ref2[0], setNow = ref2[1];
    var ref3 = RecordingState_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref3[0];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var time = (0,react.useMemo)(function() {
        if (!recordingStartedDate || !now) return null;
        var diff = now.getTime() - recordingStartedDate.getTime();
        if (diff < 0) return null;
        var progress = new Date(diff);
        var hours = progress.getUTCHours();
        var minutes = progress.getUTCMinutes();
        var seconds = progress.getUTCSeconds();
        var withLeadingZero = function(n) {
            return n.toString().padStart(2, "0");
        };
        return [
            hours > 0 ? hours : null,
            hours > 0 ? withLeadingZero(minutes) : minutes,
            withLeadingZero(seconds), 
        ].filter(function(n) {
            return n !== null;
        }).join(":");
    }, [
        now,
        recordingStartedDate
    ]);
    (0,react.useEffect)(function() {
        // Only show recording time for initiator or recorded single participant
        if (!isRecording || type !== "local" && (layout === null || layout === void 0 ? void 0 : layout.preset) === "single-participant" && (layout === null || layout === void 0 ? void 0 : layout.session_id) !== localSessionId || type !== "local" && (layout === null || layout === void 0 ? void 0 : layout.preset) !== "single-participant" && startedBy !== localSessionId || type === "local" && !local) {
            setNow(null);
            return;
        }
        var newNow = function() {
            setNow(new Date());
        };
        newNow();
        var interval = setInterval(newNow, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        isLocalParticipantRecorded,
        isRecording,
        layout,
        local,
        localSessionId,
        startedBy,
        type, 
    ]);
    var isStarting = [
        "starting3",
        "starting2",
        "starting1"
    ].includes(recordingUIState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "f8c34530d72e6fb0",
                [
                    colors.system.white,
                    colors.system.red,
                    colors.system.red
                ]
            ]
        ]) + " " + "recordingState",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: (recordingUIState || isLocalParticipantRecorded) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    className: classnames_default()("banner", {
                        recording: isRecording,
                        starting: isStarting
                    }),
                    variants: bannerVariants,
                    initial: "hidden",
                    animate: "visible",
                    exit: "hidden",
                    transition: {
                        duration: 0.25,
                        ease: "easeInOut"
                    },
                    children: [
                        (isStarting || isRecording) && // Transitions from red background in starting to red dot in recording
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                            className: "red-bg",
                            variants: redVariants,
                            initial: "starting",
                            animate: isStarting ? "starting" : "recording",
                            transition: {
                                duration: 0.2,
                                ease: "easeInOut"
                            }
                        }),
                        isRecording ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "f8c34530d72e6fb0",
                                    [
                                        colors.system.white,
                                        colors.system.red,
                                        colors.system.red
                                    ]
                                ]
                            ]) + " " + "recording-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "presentation",
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "f8c34530d72e6fb0",
                                            [
                                                colors.system.white,
                                                colors.system.red,
                                                colors.system.red
                                            ]
                                        ]
                                    ]) + " " + "indicator"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    align: "center",
                                    gap: 4,
                                    horizontal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            variant: "strong",
                                            color: isMobile ? "white" : "default",
                                            children: t("recording.status.recording")
                                        }),
                                        time && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            className: "time",
                                            color: isMobile ? "white" : "default",
                                            children: time
                                        })
                                    ]
                                })
                            ]
                        }) : recordingUIState === "saved" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            children: t("recording.status.saved")
                        }) : (recordingUIState === null || recordingUIState === void 0 ? void 0 : recordingUIState.startsWith("starting")) ? // 'starting1' | 'starting2' | 'starting3'
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "f8c34530d72e6fb0",
                                    [
                                        colors.system.white,
                                        colors.system.red,
                                        colors.system.red
                                    ]
                                ]
                            ]) + " " + "starting-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "presentation",
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "f8c34530d72e6fb0",
                                            [
                                                colors.system.white,
                                                colors.system.red,
                                                colors.system.red
                                            ]
                                        ]
                                    ]) + " " + "indicator"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                                    align: "center",
                                    gap: 4,
                                    horizontal: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        color: "white",
                                        children: t("recording.status.starting", {
                                            sec: recordingUIState.slice(-1)
                                        })
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f8c34530d72e6fb0",
                dynamic: [
                    colors.system.white,
                    colors.system.red,
                    colors.system.red
                ],
                children: ".recordingState.__jsx-style-dynamic-selector .banner{background:transparent;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:3px 8px 5px}.recordingState.__jsx-style-dynamic-selector .banner.starting .indicator.__jsx-style-dynamic-selector{background:".concat(colors.system.white, "}.recordingState.__jsx-style-dynamic-selector .banner.recording .indicator.__jsx-style-dynamic-selector{opacity:0}.recordingState.__jsx-style-dynamic-selector .recording-text.__jsx-style-dynamic-selector,.recordingState.__jsx-style-dynamic-selector .starting-text.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;position:relative;z-index:1}.recordingState.__jsx-style-dynamic-selector .red-bg{background:").concat(colors.system.red, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;z-index:0}.recordingState.__jsx-style-dynamic-selector .indicator.__jsx-style-dynamic-selector{background:").concat(colors.system.red, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;display:block;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;height:8px;margin-right:4px;width:8px}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Topbar/useCountdown.ts

var useCountdown = function(endDate) {
    var interval = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), seconds = ref[0], setSeconds = ref[1];
    (0,react.useEffect)(function() {
        if (!endDate) return;
        interval.current = setInterval(function() {
            setSeconds(Math.floor((endDate.getTime() - Date.now()) / 1000));
        }, 1000);
        return function() {
            clearInterval(interval.current);
            setSeconds(null);
        };
    }, [
        endDate
    ]);
    if (!seconds || seconds < 0) return "";
    var minutes = Math.floor(seconds / 60);
    return "".concat(minutes.toString(), ":").concat(seconds.toString().padStart(2, "0"));
};

;// CONCATENATED MODULE: ./components/Topbar/BreakoutCountdown.tsx
function BreakoutCountdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutCountdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BreakoutCountdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutCountdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutCountdown_slicedToArray(arr, i) {
    return BreakoutCountdown_arrayWithHoles(arr) || BreakoutCountdown_iterableToArrayLimit(arr, i) || BreakoutCountdown_unsupportedIterableToArray(arr, i) || BreakoutCountdown_nonIterableRest();
}
function BreakoutCountdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutCountdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutCountdown_arrayLikeToArray(o, minLen);
}
















var BreakoutCountdown = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,Theme.useTheme)(), colors = ref.colors, zIndex = ref.zIndex;
    var ref1 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref1.breakoutHost, endDate = ref1.endDate;
    var abortEndingBreakouts = useBreakouts().abortEndingBreakouts;
    var ref2 = BreakoutCountdown_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sidebarView = ref2[0];
    var ref3 = BreakoutCountdown_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref3[0];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isBreakoutHost = localSessionId === breakoutHost;
    var countdown = useCountdown(endDate);
    var hasCountdown = (0,react.useMemo)(function() {
        return Boolean(countdown);
    }, [
        countdown
    ]);
    var ref4 = BreakoutCountdown_slicedToArray((0,layout/* useMobileTray */.UX)(), 2), setShowMobileTray = ref4[1];
    (0,react.useEffect)(function() {
        if (!hasCountdown) return;
        setShowMobileTray(true);
    }, [
        hasCountdown,
        setShowMobileTray
    ]);
    if (!countdown) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "dafadbc2cd8a462",
                [
                    sidebarView ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) / -2 : 0,
                    zIndex.snackbar,
                    colors.system.red,
                    colors.system.white,
                    colors.system.white
                ]
            ]
        ]) + " " + (classnames_default()("breakout-countdown", {
            isMobile: isMobile
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                /*#__PURE__*/ noBorder: true,
                spacing: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "white",
                            variant: "strong",
                            children: t("breakouts.countdown", {
                                countdown: countdown
                            })
                        }),
                        isBreakoutHost && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                            variant: "ghost",
                            onClick: abortEndingBreakouts,
                            className: "abort-button",
                            children: t("general.cancel")
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "dafadbc2cd8a462",
                dynamic: [
                    sidebarView ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) / -2 : 0,
                    zIndex.snackbar,
                    colors.system.red,
                    colors.system.white,
                    colors.system.white
                ],
                children: ".breakout-countdown.__jsx-style-dynamic-selector .card{font-variant-numeric:tabular-nums;height:auto;position:fixed;left:50%;margin-left:".concat(sidebarView ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) / -2 : 0, "px;top:-webkit-calc(var(--header-height) + 8px);top:-moz-calc(var(--header-height) + 8px);top:calc(var(--header-height) + 8px);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%);width:auto;z-index:").concat(zIndex.snackbar, "}.breakout-countdown.__jsx-style-dynamic-selector:not(.isMobile) .card-content{background:").concat(colors.system.red, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:8px}.breakout-countdown.isMobile.__jsx-style-dynamic-selector .card{background:transparent;left:auto;margin-left:0;position:relative;top:auto;-webkit-transform:none;-moz-transform:none;-ms-transform:none;-o-transform:none;transform:none;white-space:nowrap;z-index:auto}.breakout-countdown.isMobile.__jsx-style-dynamic-selector .card-content{background:transparent}.breakout-countdown.__jsx-style-dynamic-selector .abort-button{color:").concat(colors.system.white, ";text-decoration:underline}.breakout-countdown.__jsx-style-dynamic-selector .abort-button:not(.loading):hover,.breakout-countdown.__jsx-style-dynamic-selector .abort-button:not(.loading):focus-visible{-webkit-box-shadow:0 0 0 2px ").concat(colors.system.white, ";-moz-box-shadow:0 0 0 2px ").concat(colors.system.white, ";box-shadow:0 0 0 2px ").concat(colors.system.white, "}")
            })
        ]
    });
});
BreakoutCountdown.displayName = "BreakoutCountdown";

;// CONCATENATED MODULE: ./components/Topbar/BreakoutStatus.tsx








var BreakoutStatus = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), currentBreakoutRoom = ref.currentBreakoutRoom, invitedBreakoutRoom = ref.invitedBreakoutRoom, joinedState = ref.joinedState;
    var isJoiningBreakout = useRenderBreakoutsInterstitialScreen();
    var isInvited = joinedState === "invited" && !isJoiningBreakout;
    var statusText = (0,react.useMemo)(function() {
        var invitedRoomName = t("breakouts.roomWithName", {
            name: invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name
        });
        if (isInvited) return t("breakouts.statusPleaseJoin", {
            room: invitedRoomName
        });
        if (currentBreakoutRoom === null || currentBreakoutRoom === void 0 ? void 0 : currentBreakoutRoom.name) return t("breakouts.roomWithName", {
            name: currentBreakoutRoom === null || currentBreakoutRoom === void 0 ? void 0 : currentBreakoutRoom.name
        });
        return t("breakouts.mainRoom");
    }, [
        currentBreakoutRoom === null || currentBreakoutRoom === void 0 ? void 0 : currentBreakoutRoom.name,
        invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name,
        isInvited,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-4252bd529c98044b" + " " + "breakout-status",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                /*#__PURE__*/ children: t("breakouts.breakoutSession")
            }),
            statusText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "strong",
                children: statusText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutCountdown, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4252bd529c98044b",
                children: ".breakout-status.jsx-4252bd529c98044b{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:12px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Badge/index.js
var Badge = __webpack_require__(485);
;// CONCATENATED MODULE: ./components/Topbar/LiveBadge.tsx









var LiveBadge = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var broadcast = (0,useCallConfig/* useCallConfig */.A)().broadcast;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var ref = (0,daily_react_esm/* useLiveStreaming */.vW)(), isLiveStreaming = ref.isLiveStreaming, layout = ref.layout;
    var shouldRenderLiveBadge = (0,dist_web/* useDeepCompareMemo */.NY)(function() {
        var isOnlyLocalParticipantRecorded = (layout === null || layout === void 0 ? void 0 : layout.preset) === "single-participant" && (layout === null || layout === void 0 ? void 0 : layout.session_id) === localSessionId;
        return isLiveStreaming && (isOnlyLocalParticipantRecorded || (layout === null || layout === void 0 ? void 0 : layout.preset) !== "single-participant") || broadcast;
    }, [
        broadcast,
        isLiveStreaming,
        layout,
        localSessionId
    ]);
    if (!shouldRenderLiveBadge) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-462badf7e62db0" + " " + "live-badge",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                disabled: !isLocalOwner,
                id: "tt-live-badge",
                title: isLiveStreaming ? t("liveStreaming.streaming") : t("broadcast.presenting"),
                placement: "bottom",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                    variant: "error",
                    children: t("broadcast.live")
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "462badf7e62db0",
                children: ".live-badge.jsx-462badf7e62db0{cursor:default;margin-top:1px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Topbar/PeopleInCall.tsx







var PeopleInCall = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref.broadcast, enableImplicitPassiveParticipant = ref.enableImplicitPassiveParticipant;
    var ref1 = useParticipantCounts(), passiveCount = ref1.hidden, present = ref1.present;
    var fullCount = present + passiveCount;
    var ownerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "owner"
    });
    /**
   * The displayed count depends on
   * - whether or not the call is an owner_only_broadcast
   * - the room is configured to have passive participants
   * In broadcast calls we'll show the amount of viewers, which is either
   * - the hidden count, when passive participants are counted
   * - the amount of non owners (fullCount minus amount of owners)
   * In regular calls we'll display the full amount participants.
   */ var count = (0,react.useMemo)(function() {
        // In Broadcast calls, we're only interested in the amount of watchers.
        if (broadcast) {
            return enableImplicitPassiveParticipant ? passiveCount : fullCount - ownerIds.length;
        }
        return fullCount;
    }, [
        broadcast,
        enableImplicitPassiveParticipant,
        fullCount,
        ownerIds.length,
        passiveCount, 
    ]);
    var text = (0,react.useMemo)(function() {
        if (broadcast) return t("people.watchingWithAmount", {
            amount: count
        });
        if (count <= 1) return t("people.waitingForOtherParticipants");
        return t("people.withCount", {
            count: count
        });
    }, [
        broadcast,
        count,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
        children: text
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/PictureInPictureIcon.js
var PictureInPictureIcon = __webpack_require__(2851);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(2642);
// EXTERNAL MODULE: ../../node_modules/worker-timers/build/es2019/module.js + 5 modules
var es2019_module = __webpack_require__(1760);
;// CONCATENATED MODULE: ./components/PictureInPicture/PictureInPicture.tsx
function PictureInPicture_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PictureInPicture_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PictureInPicture_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return PictureInPicture_arrayLikeToArray(arr);
}
function PictureInPicture_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PictureInPicture_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function PictureInPicture_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function PictureInPicture_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PictureInPicture_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PictureInPicture_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PictureInPicture_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PictureInPicture_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PictureInPicture_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PictureInPicture_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PictureInPicture_slicedToArray(arr, i) {
    return PictureInPicture_arrayWithHoles(arr) || PictureInPicture_iterableToArrayLimit(arr, i) || PictureInPicture_unsupportedIterableToArray(arr, i) || PictureInPicture_nonIterableRest();
}
function PictureInPicture_toConsumableArray(arr) {
    return PictureInPicture_arrayWithoutHoles(arr) || PictureInPicture_iterableToArray(arr) || PictureInPicture_unsupportedIterableToArray(arr) || PictureInPicture_nonIterableSpread();
}
function PictureInPicture_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PictureInPicture_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PictureInPicture_arrayLikeToArray(o, minLen);
}
var _this = undefined;













var PIP_FPS = 15;
var PictureInPicture = /*#__PURE__*/ (0,react.forwardRef)(function(_param, pipRef) {
    var _this1 = _this;
    var _enabled = _param.enabled, enabled = _enabled === void 0 ? false : _enabled, onEnterPIP = _param.onEnterPIP, onLeavePIP = _param.onLeavePIP, videoProps = PictureInPicture_objectWithoutProperties(_param, [
        "enabled",
        "onEnterPIP",
        "onLeavePIP"
    ]);
    var t1 = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var canvasRef = (0,react.useRef)(null);
    var canvasStream = (0,react.useRef)(null);
    var viewMode = (0,layout/* useViewMode */.mJ)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var activeSpeakerId = useActiveSpeaker();
    var ref10 = PictureInPicture_slicedToArray((0,layout/* usePinnedId */.Sg)(), 1), pinnedId = ref10[0];
    var isSharingScreen = (0,daily_react_esm/* useScreenShare */.N2)().isSharingScreen;
    var screens = (0,useScreens/* useScreens */.O)();
    var ref1 = (0,react.useState)(enabled), /*#__PURE__*/ shouldDraw = ref1[0], setShouldDraw = ref1[1];
    (0,react.useEffect)(function() {
        setShouldDraw(enabled);
    }, [
        enabled
    ]);
    /**
     * Setup enter/leave event listeners.
     */ (0,react.useEffect)(function() {
        var pipVideo = pipRef.current;
        if (!pipVideo) return;
        var handleEnterPIP = function() {
            onEnterPIP === null || onEnterPIP === void 0 ? void 0 : onEnterPIP();
        };
        var handleLeavePIP = function() {
            onLeavePIP === null || onLeavePIP === void 0 ? void 0 : onLeavePIP();
        };
        pipVideo.addEventListener("enterpictureinpicture", handleEnterPIP);
        pipVideo.addEventListener("leavepictureinpicture", handleLeavePIP);
        return function() {
            pipVideo.removeEventListener("enterpictureinpicture", handleEnterPIP);
            pipVideo.removeEventListener("leavepictureinpicture", handleLeavePIP);
        };
    }, [
        onEnterPIP,
        onLeavePIP,
        pipRef
    ]);
    /**
     * Create Canvas.
     */ (0,react.useEffect)(function() {
        canvasRef.current = document.createElement("canvas");
        canvasRef.current.width = 1280;
        canvasRef.current.height = 720;
        canvasStream.current = canvasRef.current.captureStream(PIP_FPS);
        return function() {
            canvasRef.current.remove();
            canvasRef.current = null;
            canvasStream.current = null;
        };
    }, []);
    var currentSpeakerVideoTrack = (0,daily_react_esm/* useVideoTrack */.HU)(currentSpeakerId);
    var currentSpeakerName = (0,daily_react_esm/* useParticipantProperty */.ou)(currentSpeakerId, "user_name");
    /**
     * Safari workaround: Canvas.captureStream results in red box.
     * We'll apply the current speaker's video track directly instead.
     * In case current speaker is muted, we'll fallback to a black canvas stream.
     */ (0,react.useEffect)(function setupPiPStream() {
        var canvas = canvasRef.current;
        var pipVideo = pipRef.current;
        if (!canvas || !pipVideo) return;
        var canvasContext = canvas.getContext("2d");
        /**
         * Canvas streams on PiP weren't functional (red frame) prior to Safari 16.
         */ if ((0,browserConfig/* isSafari */.G6)(1, 15)) {
            var ref, ref2;
            canvasContext.rect(0, 0, canvas.width, canvas.height);
            canvasContext.fillStyle = "#000";
            canvasContext.fill();
            /**
           * Fallback in case speaker is muted.
           */ canvasContext.font = "bold 40px sans-serif";
            canvasContext.fillStyle = "#fff";
            canvasContext.textAlign = "center";
            canvasContext.fillText(currentSpeakerName !== null && currentSpeakerName !== void 0 ? currentSpeakerName : t1("people.guest"), canvas.width / 2, canvas.height / 2);
            /**
           * In case screens are being shared, show the first screen.
           * Otherwise show the current speaker's video.
           * In all cases only assign a MediaStream, if it's different.
           */ if (screens.length && ((ref = screens[0]) === null || ref === void 0 ? void 0 : (ref2 = ref.screenVideo) === null || ref2 === void 0 ? void 0 : ref2.persistentTrack)) {
                var ref3, ref4, ref5;
                var track = (ref3 = screens[0].screenVideo) === null || ref3 === void 0 ? void 0 : ref3.persistentTrack;
                var ref6;
                var vtracks = (ref6 = (ref4 = pipVideo.srcObject) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.getVideoTracks) === null || ref5 === void 0 ? void 0 : ref5.call(ref4)) !== null && ref6 !== void 0 ? ref6 : [];
                if (vtracks.some(function(t) {
                    return t.id !== (track === null || track === void 0 ? void 0 : track.id);
                })) {
                    pipVideo.srcObject = new MediaStream([
                        track
                    ]);
                }
            } else if (!currentSpeakerVideoTrack.isOff && (currentSpeakerVideoTrack === null || currentSpeakerVideoTrack === void 0 ? void 0 : currentSpeakerVideoTrack.persistentTrack)) {
                var ref7, ref8;
                var track1 = currentSpeakerVideoTrack === null || currentSpeakerVideoTrack === void 0 ? void 0 : currentSpeakerVideoTrack.persistentTrack;
                var ref9;
                var vtracks1 = (ref9 = (ref7 = pipVideo.srcObject) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.getVideoTracks) === null || ref8 === void 0 ? void 0 : ref8.call(ref7)) !== null && ref9 !== void 0 ? ref9 : [];
                if (vtracks1.some(function(t) {
                    return t.id !== (track1 === null || track1 === void 0 ? void 0 : track1.id);
                })) {
                    pipVideo.srcObject = new MediaStream([
                        track1
                    ]);
                }
            } else {
                // Fallback to canvas when speaker is muted
                if (pipVideo.srcObject !== canvasStream.current) {
                    pipVideo.srcObject = canvasStream.current;
                }
            }
        } else {
            /**
           * Assign canvas stream only in case it's not assigned, yet.
           */ if (pipVideo.srcObject !== canvasStream.current) {
                pipVideo.srcObject = canvasStream.current;
            }
        }
    }, [
        currentSpeakerName,
        currentSpeakerVideoTrack,
        pipRef,
        screens,
        t1
    ]);
    /**
     * Initiate the draw loop.
     * NOTE: Getting the Canvas stream doesn't work in Safari.
     * TODO: Move rendering to [OffscreenCanvas](https://developer.mozilla.org/en-US/docs/Web/API/OffscreenCanvas).
     */ (0,react.useEffect)(function() {
        var _this2 = _this1;
        var canvas = canvasRef.current;
        var pipVideo = pipRef.current;
        if (!canvas || !pipVideo || (0,browserConfig/* isSafari */.G6)(1, 15)) return;
        var canvasContext = canvas.getContext("2d");
        if (!shouldDraw) {
            var cWidth = canvas.width;
            var cHeight = canvas.height;
            canvasContext.clearRect(0, 0, cWidth, cHeight);
            return;
        }
        var draw = function() {
            var cWidth = canvas.width;
            var cHeight = canvas.height;
            canvasContext.clearRect(0, 0, cWidth, cHeight);
            /**
         * Returns truncated text, based on passed maxWidth.
         */ var fittingString = function(ctx, text, maxWidth) {
                var width = ctx.measureText(text).width;
                var ellipsis = "\u2026";
                var ellipsisWidth = ctx.measureText(ellipsis).width;
                if (width <= maxWidth || width <= ellipsisWidth) {
                    return text;
                } else {
                    var len = text.length;
                    while(width >= maxWidth - ellipsisWidth && len-- > 0){
                        text = text.substring(0, len);
                        width = ctx.measureText(text).width;
                    }
                    return text + ellipsis;
                }
            };
            var drawMuted = function(name, x, y, w, h) {
                canvasContext.fillStyle = colors.custom.mainAreaBgAccent;
                canvasContext.fillRect(x, y, w, h);
                canvasContext.font = "bold ".concat(w / 16, "px sans-serif");
                canvasContext.textBaseline = "middle";
                canvasContext.textAlign = "center";
                canvasContext.fillStyle = colors.custom.mainAreaText;
                var maxWidth = 0.8 * w;
                canvasContext.fillText(fittingString(canvasContext, name, maxWidth), x + w / 2, y + h / 2, maxWidth);
            };
            var drawVideo = function(video, x, y, w, h, name) {
                var ref, ref11, ref12;
                if (!video) return;
                var stream = video.srcObject;
                if (video.paused || !(stream === null || stream === void 0 ? void 0 : (ref = stream.getVideoTracks) === null || ref === void 0 ? void 0 : (ref11 = ref.call(stream)) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.enabled)) {
                    // Participant is muted
                    drawMuted(name, x, y, w, h);
                    return;
                }
                var videoAR = video.videoWidth / video.videoHeight;
                // Determine centered position, in case video doesn't match 16:9 aspect ratio
                var centeredW = videoAR < 16 / 9 ? h * videoAR : w;
                var centeredX = videoAR < 16 / 9 ? x + (w - centeredW) / 2 : x;
                var centeredH = videoAR > 16 / 9 ? w / videoAR : h;
                var centeredY = videoAR > 16 / 9 ? y + (h - centeredH) / 2 : y;
                // Apply mirroring on Canvas
                var isMirrored = video.classList.contains("isMirrored");
                // Correct X position when potentially flipped
                var rx = isMirrored ? cWidth - (centeredX + centeredW) : centeredX;
                /**
           * We can't easily render a flipped image, but we can flip the canvas,
           * render the image and flip the canvas back again!
           * It's like painting on a transparent sheet of paper 🧑‍🎨
           */ if (isMirrored) {
                    /**
             * Flip the canvas.
             * .scale() happens at x=0,y=0.
             * .translate() shifts the canvas back in view.
             */ canvasContext.translate(cWidth, 0);
                    canvasContext.scale(-1, 1);
                }
                canvasContext.drawImage(video, rx, centeredY, centeredW, centeredH);
                if (isMirrored) {
                    /**
             * Flip the canvas again.
             */ canvasContext.scale(-1, 1);
                    canvasContext.translate(-cWidth, 0);
                }
            };
            var drawParticipant = function(id, x, y, w, h) {
                var tile = document.querySelector('.tile[id="'.concat(id, '"]'));
                var video = tile === null || tile === void 0 ? void 0 : tile.querySelector("video");
                if (video) {
                    drawVideo(video, x, y, w, h, getName(tile));
                } else {
                    drawMuted(getName(tile), x, y, w, h);
                }
            };
            var drawActiveBorder = function(x, y, w, h) {
                canvasContext.beginPath();
                canvasContext.moveTo(x, y);
                canvasContext.lineTo(x + w, y);
                canvasContext.lineTo(x + w, y + h);
                canvasContext.lineTo(x, y + h);
                canvasContext.lineTo(x, y);
                canvasContext.lineWidth = 4;
                canvasContext.strokeStyle = colors.system.yellow;
                canvasContext.stroke();
            };
            var participants = daily.participants();
            var getName = function(tile) {
                var ref, ref14, ref15;
                if (!tile) return "";
                var id = tile.getAttribute("id");
                var name = (participants === null || participants === void 0 ? void 0 : (ref = participants.local) === null || ref === void 0 ? void 0 : ref.session_id) === id ? (participants === null || participants === void 0 ? void 0 : (ref14 = participants.local) === null || ref14 === void 0 ? void 0 : ref14.user_name) ? t1("people.you") : t1("people.youGuest") : ((ref15 = participants[id]) === null || ref15 === void 0 ? void 0 : ref15.user_name) || t1("people.guest");
                return name;
            };
            var shouldDrawGrid = viewMode === "grid" || isSharingScreen;
            if (shouldDrawGrid) {
                var _drawActiveBorder;
                var selector = viewMode === "grid" ? ".grid video[data-subscribed=true], .grid .tile.noVideo:not(.local)" : ".speaker .sidebar .tile:not(.local) video[data-subscribed=true], .speaker .sidebar .tile.noVideo:not(.local)";
                var elements = Array.from(document.querySelectorAll(selector));
                var localVideo = document.querySelector(".local video");
                // Show local screenshare in PiP window if the call is empty.
                if (isSharingScreen && localVideo && !elements.length) {
                    elements.push(localVideo);
                }
                var n = elements.length;
                var cols = Math.ceil(Math.sqrt(n));
                var rows = Math.ceil(n / cols);
                var width1 = cWidth / cols;
                var height = width1 * (9 / 16);
                var dy = (cHeight - rows * height) / 2;
                var active;
                elements.forEach(function(el, i) {
                    var tile = el.closest("[id]");
                    var id = tile.getAttribute("id");
                    var col = i % cols;
                    var row = Math.floor(i / cols);
                    var dx = row === rows - 1 && n % cols > 0 ? (cWidth - n % cols * width1) / 2 : 0;
                    var x = dx + col * width1;
                    var y = dy + row * height;
                    drawParticipant(id, x, y, width1, height);
                    if (id === activeSpeakerId) {
                        active = [
                            x,
                            y,
                            width1,
                            height
                        ];
                    }
                });
                if (active) (_drawActiveBorder = drawActiveBorder).call.apply(_drawActiveBorder, [
                    _this2
                ].concat(PictureInPicture_toConsumableArray(active)));
            } else if (screens.length) {
                var ref13;
                var screenVideo = document.querySelector('[id="'.concat((ref13 = screens[0]) === null || ref13 === void 0 ? void 0 : ref13.screenId, '"] video'));
                var gap = 4;
                var screenSpace = cWidth * 0.7;
                var screenWidth = screenSpace - gap;
                if (screenVideo) {
                    var screenAR = (screenVideo === null || screenVideo === void 0 ? void 0 : screenVideo.videoWidth) / (screenVideo === null || screenVideo === void 0 ? void 0 : screenVideo.videoHeight);
                    var screenHeight = screenWidth / screenAR;
                    if (screenAR > 16 * 0.7 / 9) {
                        // In case screen is more landscape-y than available area,
                        // render screen centered.
                        drawVideo(screenVideo, 0, (cHeight - screenHeight) / 2, screenWidth, screenHeight, "");
                    } else {
                        // Screen is more portrait-y than available area,
                        // video is centered horizontally automatically.
                        drawVideo(screenVideo, 0, 0, cWidth * 0.7, cHeight, "");
                    }
                }
                var participantWidth = cWidth * 0.3;
                var participantHeight = participantWidth * 9 / 16;
                drawParticipant(activeSpeakerId !== null && activeSpeakerId !== void 0 ? activeSpeakerId : orderedParticipantIds[0], cWidth * 0.7, 0, participantWidth, participantHeight);
                if (pinnedId && pinnedId !== activeSpeakerId && !pinnedId.endsWith("-screen")) {
                    drawParticipant(pinnedId, cWidth * 0.7, participantHeight + gap, participantWidth, participantHeight);
                }
            } else {
                drawParticipant(currentSpeakerId, 0, 0, cWidth, cHeight);
            }
        };
        var interval = (0,es2019_module/* setInterval */.Zi)(draw, 1000 / PIP_FPS);
        return function() {
            (0,es2019_module/* clearInterval */.cv)(interval);
        };
    }, [
        activeSpeakerId,
        colors.custom.mainAreaBgAccent,
        colors.custom.mainAreaText,
        colors.system.yellow,
        currentSpeakerId,
        daily,
        isSharingScreen,
        orderedParticipantIds,
        pinnedId,
        pipRef,
        screens,
        shouldDraw,
        t1,
        viewMode, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal.Portal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", PictureInPicture_objectSpread({}, videoProps, {
                    id: "pip-video",
                    autoPlay: true,
                    playsInline: true,
                    ref: pipRef,
                    className: "jsx-c4d5428e2e2d7c6f" + " " + (videoProps && videoProps.className != null && videoProps.className || "")
                }))
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c4d5428e2e2d7c6f",
                children: "#pip-video.jsx-c4d5428e2e2d7c6f{height:24px;right:0;opacity:0;pointer-events:none;position:absolute;top:-webkit-calc(var(--banner-height) + 4px);top:-moz-calc(var(--banner-height) + 4px);top:calc(var(--banner-height) + 4px)}"
            })
        ]
    });
});
/**
 * Renders videos in current viewMode in a hidden video element.
 * Compositing is done on the client using an invisible HTMLCanvasElement.
 */ 
PictureInPicture.displayName = "PictureInPicture";

;// CONCATENATED MODULE: ./components/PictureInPicture/index.ts


;// CONCATENATED MODULE: ./components/Topbar/PictureInPictureButton.tsx
function PictureInPictureButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var PictureInPictureButton = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,react.useState)(true), /*#__PURE__*/ disabled = ref[0], setDisabled = ref[1];
    var ref1 = (0,react.useState)(false), isPIP = ref1[0], setIsPIP = ref1[1];
    var pipRef = (0,react.useRef)(null);
    var handleClick = (0,react.useCallback)(function() {
        if (disabled) return;
        // TODO: Figure out why pictureInPicture types are missing in `next build`
        // @ts-ignore
        if (isPIP && document.pictureInPictureElement) {
            document// @ts-ignore
            .exitPictureInPicture().catch(function(e) {
                console.error(e);
                (0,esm_exports/* captureException */.Tb)(e);
            }).finally(function() {
                setIsPIP(false);
            });
        }
        // @ts-ignore
        if (!isPIP && !document.pictureInPictureElement) {
            pipRef.current// @ts-ignore
            .requestPictureInPicture().then(function() {
                setIsPIP(true);
            }).catch(function(e) {
                console.error(e);
                (0,esm_exports/* captureException */.Tb)(e);
                setIsPIP(false);
            });
        }
    }, [
        disabled,
        isPIP
    ]);
    var handleLeavePIP = function() {
        setIsPIP(false);
    };
    /**
   * Disable button, whenever PIP is toggled.
   */ (0,react.useEffect)(function() {
        setDisabled(true);
    }, [
        isPIP
    ]);
    /**
   * Reenable after 800ms.
   */ (0,react.useEffect)(function() {
        if (!disabled) return;
        var timeout = setTimeout(function() {
            setDisabled(false);
        }, 800);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        disabled
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "b0cae645e57055f1",
                [
                    colors.backgroundAccent,
                    colors.accent
                ]
            ]
        ]) + " " + "pip",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                id: "tt-pip",
                title: isPIP ? t("pip.stop") : t("pip.start"),
                placement: "bottom",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "topbar-pip-toggle",
                    className: classnames_default()("btn", (_obj = {
                        active: isPIP
                    }, PictureInPictureButton_defineProperty(_obj, robotsClassName("btn-speaker-enter-pip"), !isPIP), PictureInPictureButton_defineProperty(_obj, robotsClassName("btn-speaker-leave-pip"), isPIP), _obj)),
                    onClick: handleClick,
                    variant: "ghost",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PictureInPictureIcon/* PictureInPictureIcon */.b, {
                        color: isPIP ? colors.accentText : colors.baseText,
                        variant: isPIP ? "leave" : "enter"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PictureInPicture, {
                ref: pipRef,
                enabled: isPIP,
                onLeavePIP: handleLeavePIP
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "b0cae645e57055f1",
                dynamic: [
                    colors.backgroundAccent,
                    colors.accent
                ],
                children: '.pip.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.pip.__jsx-style-dynamic-selector::before{background:var(--card-border);content:"";height:16px;margin:auto 8px;width:1px}.pip.__jsx-style-dynamic-selector .btn{background-color:'.concat(colors.backgroundAccent, ";-webkit-border-radius:4px!important;-moz-border-radius:4px!important;border-radius:4px!important}.pip.__jsx-style-dynamic-selector .btn.active{background-color:").concat(colors.accent, "}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/GearIcon.js
var GearIcon = __webpack_require__(7877);
;// CONCATENATED MODULE: ./components/MobileView/constants.ts
var DEFAULT_LANDSCAPE_AR = 16 / 9;
var DEFAULT_PORTRAIT_AR = 3 / 4;
var PAGINATION_HEIGHT = 56;
var TILE_GAP = 4;

;// CONCATENATED MODULE: ./components/MobileView/MobileTile.tsx
function MobileTile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileTile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileTile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MobileTile_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MobileTile_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MobileTile_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var MobileTile = function(_param) {
    var _isScreen = _param.isScreen, isScreen = _isScreen === void 0 ? false : _isScreen, network = _param.network, orientation = _param.orientation, sessionId = _param.sessionId, showNames = _param.showNames, showReactions = _param.showReactions, videoFit = _param.videoFit, props = MobileTile_objectWithoutProperties(_param, [
        "isScreen",
        "network",
        "orientation",
        "sessionId",
        "showNames",
        "showReactions",
        "videoFit"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    var isPortrait = (0,react.useMemo)(function() {
        return orientation === "portrait";
    }, [
        orientation
    ]);
    var ref = (0,react.useState)(null), /*#__PURE__*/ cropVideo = ref[0], setCropVideo = ref[1];
    var zIndex = (0,Theme.useTheme)().zIndex;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocal = sessionId === localSessionId;
    var hasPoorConnection = network === "very-low" && isLocal;
    var hasWeakConnection = network === "low" && isLocal;
    var displayName = useDisplayName(sessionId, showNames, network);
    var noVideoText = (0,react.useMemo)(function() {
        var color = "inherit";
        if (hasWeakConnection) {
            color = "warning";
        }
        if (hasPoorConnection) {
            color = "error";
        }
        var style = {
            fontSize: (0,pxToRem.pxToRem)(16),
            lineHeight: (0,pxToRem.pxToRem)(20)
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            color: color,
            style: style,
            truncate: true,
            variant: "strong",
            children: displayName
        });
    }, [
        displayName,
        hasPoorConnection,
        hasWeakConnection
    ]);
    var videoRef = (0,react.useRef)(null);
    var videoState = (0,daily_react_esm/* useMediaTrack */.R2)(sessionId, isScreen ? "screenVideo" : "video");
    /**
   * Handle video resize to determine if video should be cropped based on orientation.
   */ (0,react.useEffect)(function() {
        var video = videoRef.current;
        if (!video) return;
        var handleVideoResize = function() {
            if (orientation === "landscape") {
                setCropVideo(null);
                return;
            }
            if (!video) return;
            var videoHeight = video.videoHeight, videoWidth = video.videoWidth;
            if (videoWidth && videoHeight) {
                var aspectRatio = videoWidth / videoHeight;
                if (aspectRatio >= 4 / 3) {
                    setCropVideo("landscape");
                } else if (aspectRatio <= 3 / 4) {
                    setCropVideo("portrait");
                } else {
                    setCropVideo(null);
                }
            }
        };
        handleVideoResize();
        video.addEventListener("resize", handleVideoResize);
        return function() {
            video === null || video === void 0 ? void 0 : video.removeEventListener("resize", handleVideoResize);
        };
    }, [
        isPortrait,
        orientation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", MobileTile_objectSpread({
        id: sessionId
    }, props, {
        className: styled_jsx_default().dynamic([
            [
                "52720469968a6bc2",
                [
                    colors.custom.mainAreaBgAccent,
                    zIndex.sideNav,
                    DEFAULT_PORTRAIT_AR,
                    DEFAULT_PORTRAIT_AR,
                    colors.custom.mainAreaBgAccent,
                    colors.custom.mainAreaText
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()("mobile-tile", {
            cropLandscape: cropVideo === "landscape",
            cropPortrait: cropVideo === "portrait",
            portrait: isPortrait,
            landscape: !isPortrait
        }) || ""),
        children: [
            showReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "52720469968a6bc2",
                        [
                            colors.custom.mainAreaBgAccent,
                            zIndex.sideNav,
                            DEFAULT_PORTRAIT_AR,
                            DEFAULT_PORTRAIT_AR,
                            colors.custom.mainAreaBgAccent,
                            colors.custom.mainAreaText
                        ]
                    ]
                ]) + " " + "mobile-tile-reactions",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                    animation: "fadeIn",
                    sessionIds: [
                        sessionId
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(daily_react_esm/* DailyVideo */.E5, {
                ref: videoRef,
                automirror: true,
                fit: videoFit,
                sessionId: sessionId,
                type: isScreen ? "screenVideo" : "video"
            }),
            videoState.isOff && !isScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "52720469968a6bc2",
                        [
                            colors.custom.mainAreaBgAccent,
                            zIndex.sideNav,
                            DEFAULT_PORTRAIT_AR,
                            DEFAULT_PORTRAIT_AR,
                            colors.custom.mainAreaBgAccent,
                            colors.custom.mainAreaText
                        ]
                    ]
                ]) + " " + "noVideo",
                children: noVideoText
            }),
            !isScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TileInfo, {
                activeIndicator: "static",
                name: !videoState.isOff && showNames ? displayName : null,
                sessionId: sessionId
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "52720469968a6bc2",
                dynamic: [
                    colors.custom.mainAreaBgAccent,
                    zIndex.sideNav,
                    DEFAULT_PORTRAIT_AR,
                    DEFAULT_PORTRAIT_AR,
                    colors.custom.mainAreaBgAccent,
                    colors.custom.mainAreaText
                ],
                children: ".mobile-tile.__jsx-style-dynamic-selector{background:".concat(colors.custom.mainAreaBgAccent, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;height:100%;overflow:hidden;position:relative;width:100%}.mobile-tile.__jsx-style-dynamic-selector video{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;height:-webkit-calc(100% + 4px);height:-moz-calc(100% + 4px);height:calc(100% + 4px);left:-2px;-o-object-position:center;object-position:center;position:absolute;top:-2px;width:-webkit-calc(100% + 4px);width:-moz-calc(100% + 4px);width:calc(100% + 4px)}.mobile-tile.__jsx-style-dynamic-selector .mobile-tile-reactions.__jsx-style-dynamic-selector{left:50%;position:absolute;top:50%;-webkit-transform:translate(50%,-50%);-moz-transform:translate(50%,-50%);-ms-transform:translate(50%,-50%);-o-transform:translate(50%,-50%);transform:translate(50%,-50%);z-index:").concat(zIndex.sideNav, "}.mobile-tile.portrait.cropLandscape.__jsx-style-dynamic-selector video{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;height:56.25%;margin-top:-webkit-calc(\n            -webkit-calc(\n                -webkit-calc(100% / ").concat(DEFAULT_PORTRAIT_AR, ") - 100% *\n                  ").concat(DEFAULT_PORTRAIT_AR, "\n              ) / 2\n          );margin-top:-moz-calc(\n            -moz-calc(\n                -moz-calc(100% / ").concat(DEFAULT_PORTRAIT_AR, ") - 100% *\n                  ").concat(DEFAULT_PORTRAIT_AR, "\n              ) / 2\n          );margin-top:calc(\n            calc(\n                calc(100% / ").concat(DEFAULT_PORTRAIT_AR, ") - 100% *\n                  ").concat(DEFAULT_PORTRAIT_AR, "\n              ) / 2\n          );-o-object-fit:cover;object-fit:cover;width:100%}.mobile-tile.portrait.cropPortrait.__jsx-style-dynamic-selector video{-o-object-fit:cover;object-fit:cover}.noVideo.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:").concat(colors.custom.mainAreaBgAccent, ";color:").concat(colors.custom.mainAreaText, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;padding:8px;height:100%;position:absolute;top:0;width:100%}.mobile-tile.__jsx-style-dynamic-selector .hand-status{-webkit-transform:scale(.75);-moz-transform:scale(.75);-ms-transform:scale(.75);-o-transform:scale(.75);transform:scale(.75);-webkit-transform-origin:0 0;-moz-transform-origin:0 0;-ms-transform-origin:0 0;-o-transform-origin:0 0;transform-origin:0 0;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}")
            })
        ]
    }));
};


// EXTERNAL MODULE: ../shared/dist/components/CheckboxToggle/index.js
var CheckboxToggle = __webpack_require__(8175);
// EXTERNAL MODULE: ../shared/dist/components/Icons/AudioIcon.js
var AudioIcon = __webpack_require__(3375);
;// CONCATENATED MODULE: ./components/SettingsModal/MicVolume.tsx






var MicVolume = function() {
    var colors = (0,Theme.useTheme)().colors;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var audioTrack = (0,daily_react_esm/* useAudioTrack */.Gg)(localSessionId);
    (0,daily_react_esm/* useAudioLevel */.wk)(audioTrack.persistentTrack, (0,throttle/* throttle */.P)(function(volume) {
        // If this component unmounts while a throttling cycle is in place,
        // the next time the throttled function runs the dots are not available anymore.
        // So let's make sure they exist before assigning `height`s.
        if (!dot1.current || !dot2.current || !dot3.current) return;
        var getHeight = function(base) {
            return "".concat(Math.round(100 * (3 + base * 2 * (volume >= 0.1 ? volume : 0))) / 100, "px");
        };
        dot1.current.style.height = getHeight(5);
        dot2.current.style.height = getHeight(11);
        dot3.current.style.height = getHeight(7);
    }, 150));
    var dot1 = (0,react.useRef)(null);
    var dot2 = (0,react.useRef)(null);
    var dot3 = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4510983c9ca8e3fe",
                [
                    colors.accent
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: dot1,
                className: styled_jsx_default().dynamic([
                    [
                        "4510983c9ca8e3fe",
                        [
                            colors.accent
                        ]
                    ]
                ]) + " " + "dot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: dot2,
                className: styled_jsx_default().dynamic([
                    [
                        "4510983c9ca8e3fe",
                        [
                            colors.accent
                        ]
                    ]
                ]) + " " + "dot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: dot3,
                className: styled_jsx_default().dynamic([
                    [
                        "4510983c9ca8e3fe",
                        [
                            colors.accent
                        ]
                    ]
                ]) + " " + "dot"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4510983c9ca8e3fe",
                dynamic: [
                    colors.accent
                ],
                /*#__PURE__*/ children: "div.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:16px;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:16px}div.__jsx-style-dynamic-selector .dot{background:".concat(colors.accent, ";-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;height:3px;margin:0 1px;-webkit-transition:height.15s ease;-moz-transition:height.15s ease;-o-transition:height.15s ease;transition:height.15s ease;width:3px}")
            })
        ]
    });
};
MicVolume.displayName = "MicVolume";

;// CONCATENATED MODULE: ./components/SettingsModal/TestRecording.tsx
function TestRecording_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TestRecording_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TestRecording_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TestRecording_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
















var MAX_RECORD_TIME = 5000;
var TestRecording = function() {
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var audioRef = (0,react.useRef)(null);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var audioTrack = (0,daily_react_esm/* useAudioTrack */.Gg)(localSessionId);
    var ref2 = (0,react.useState)("idle"), /*#__PURE__*/ recordState = ref2[0], setRecordState = ref2[1];
    var ref3 = (0,react.useState)(0), duration = ref3[0], setDuration = ref3[1];
    var ref4 = (0,react.useState)(false), supportsMediaRecorder = ref4[0], setSupportsMediaRecorder = ref4[1];
    var ref5 = (0,react.useState)(false), showTooltipWhenPlayFailed = ref5[0], setShowTooltipWhenPlayFailed = ref5[1];
    (0,react.useEffect)(function() {
        setSupportsMediaRecorder(MediaRecorder && (MediaRecorder.isTypeSupported("audio/mp4") || MediaRecorder.isTypeSupported("audio/webm")));
    }, []);
    var mediaRecorder = (0,react.useRef)(null);
    var handleClickTest = function() {
        var _ref = TestRecording_asyncToGenerator(runtime_default().mark(function _callee() {
            var audioChunks, start, timeout;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        mediaRecorder.current = new MediaRecorder(new MediaStream([
                            audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.persistentTrack
                        ]));
                        mediaRecorder.current.start();
                        audioChunks = [];
                        start = Date.now();
                        mediaRecorder.current.addEventListener("dataavailable", function(ev) {
                            audioChunks.push(ev.data);
                        });
                        timeout = setTimeout(function() {
                            if (mediaRecorder.current.state === "recording") mediaRecorder.current.stop();
                        }, MAX_RECORD_TIME);
                        mediaRecorder.current.addEventListener("stop", function() {
                            clearTimeout(timeout);
                            var blob = // Safari only returns one blob when recording stopped
                            audioChunks.length === 1 && _instanceof(audioChunks[0], Blob) ? audioChunks[0] : new Blob(audioChunks);
                            var audioUrl = URL.createObjectURL(blob);
                            var end = Date.now();
                            setDuration((end - start) / 1000);
                            audioRef.current.src = audioUrl;
                            audioRef.current.play().catch(function() {
                                /**
         * On iOS the attempt to automatically play() the audio will likely fail.
         * For that case we'll transition to the "ended" state and show a tooltip
         * to indicate to the user, that the play button should be clicked
         * to play the recording.
         */ setRecordState("ended");
                                setShowTooltipWhenPlayFailed(true);
                            });
                        });
                        setRecordState("recording");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClickTest() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickStop = function() {
        mediaRecorder.current.stop();
    };
    var handleAudioEnded = function() {
        setRecordState("ended");
    };
    var handlePlay = function() {
        setRecordState("playing");
    };
    var handleClickPlay = function() {
        setShowTooltipWhenPlayFailed(false);
        audioRef.current.currentTime = 0;
        audioRef.current.play();
    };
    var handleClickReset = function() {
        setRecordState("idle");
        audioRef.current.pause();
        audioRef.current.src = null;
    };
    var ref6 = (0,daily_react_esm/* useDevices */.Ls)(), hasMicError = ref6.hasMicError, microphones = ref6.microphones;
    var audioTrackState = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "tracks.audio.state");
    var muted = (0,react.useMemo)(function() {
        return (0,lib_participants/* isTrackOff */.$T)(audioTrackState) || hasMicError;
    }, [
        hasMicError,
        audioTrackState
    ]);
    var deviceId = (ref = microphones.find(function(m) {
        return m.selected;
    })) === null || ref === void 0 ? void 0 : (ref1 = ref.device) === null || ref1 === void 0 ? void 0 : ref1.deviceId;
    (0,react.useEffect)(function() {
        setRecordState("idle");
        if (!audioRef.current) return;
        audioRef.current.pause();
        audioRef.current.src = null;
    }, [
        deviceId
    ]);
    var tooltipId = (0,react.useId)();
    if (!supportsMediaRecorder) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "9d640d64297e559e",
                [
                    MAX_RECORD_TIME,
                    colors.accent,
                    colors.accent,
                    colors.background,
                    colors.background,
                    colors.border,
                    colors.system.red,
                    colors.background,
                    colors.border,
                    colors.border,
                    colors.border,
                    colors.backgroundAccent,
                    colors.backgroundAccent,
                    colors.background,
                    colors.background,
                    duration
                ]
            ]
        ]) + " " + "test-recording",
        children: [
            recordState === "idle" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                disabled: !muted,
                title: t("settings.modal.unmuteToTestMic"),
                id: tooltipId,
                placement: "top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "test-mic",
                    disabled: muted,
                    fullWidth: true,
                    onClick: handleClickTest,
                    variant: "ghost",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: "muted",
                        underline: true,
                        style: {
                            opacity: muted ? 0.6 : undefined
                        },
                        children: t("settings.modal.testYourMic")
                    })
                })
            }) : recordState === "recording" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                gap: 8,
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: styled_jsx_default().dynamic([
                            [
                                "9d640d64297e559e",
                                [
                                    MAX_RECORD_TIME,
                                    colors.accent,
                                    colors.accent,
                                    colors.background,
                                    colors.background,
                                    colors.border,
                                    colors.system.red,
                                    colors.background,
                                    colors.border,
                                    colors.border,
                                    colors.border,
                                    colors.backgroundAccent,
                                    colors.backgroundAccent,
                                    colors.background,
                                    colors.background,
                                    duration
                                ]
                            ]
                        ]) + " " + "recording-dot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("recording.status.recording")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "test-mic-stop",
                        className: "stop-btn",
                        fullWidth: true,
                        onClick: handleClickStop,
                        variant: "ghost",
                        children: t("recording.stop")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "9d640d64297e559e",
                        [
                            MAX_RECORD_TIME,
                            colors.accent,
                            colors.accent,
                            colors.background,
                            colors.background,
                            colors.border,
                            colors.system.red,
                            colors.background,
                            colors.border,
                            colors.border,
                            colors.border,
                            colors.backgroundAccent,
                            colors.backgroundAccent,
                            colors.background,
                            colors.background,
                            duration
                        ]
                    ]
                ]) + " " + "player",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        disabled: !showTooltipWhenPlayFailed,
                        id: tooltipId,
                        open: showTooltipWhenPlayFailed,
                        tabIndex: -1,
                        title: t("settings.modal.playRecording"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                            id: "test-mic-play",
                            disabled: recordState === "playing",
                            onClick: handleClickPlay,
                            variant: "ghost",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioIcon/* AudioIcon */.f, {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                    children: t("settings.modal.playRecording")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "9d640d64297e559e",
                                [
                                    MAX_RECORD_TIME,
                                    colors.accent,
                                    colors.accent,
                                    colors.background,
                                    colors.background,
                                    colors.border,
                                    colors.system.red,
                                    colors.background,
                                    colors.border,
                                    colors.border,
                                    colors.border,
                                    colors.backgroundAccent,
                                    colors.backgroundAccent,
                                    colors.background,
                                    colors.background,
                                    duration
                                ]
                            ]
                        ]) + " " + "bar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "9d640d64297e559e",
                                    [
                                        MAX_RECORD_TIME,
                                        colors.accent,
                                        colors.accent,
                                        colors.background,
                                        colors.background,
                                        colors.border,
                                        colors.system.red,
                                        colors.background,
                                        colors.border,
                                        colors.border,
                                        colors.border,
                                        colors.backgroundAccent,
                                        colors.backgroundAccent,
                                        colors.background,
                                        colors.background,
                                        duration
                                    ]
                                ]
                            ]) + " " + (classnames_default()("progress", {
                                playing: recordState === "playing"
                            }) || "")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "test-mic-reset",
                        onClick: handleClickReset,
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                size: 16,
                                variant: "thick"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("general.cancel")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                ref: audioRef,
                autoPlay: true,
                onEnded: handleAudioEnded,
                onPlay: handlePlay,
                className: styled_jsx_default().dynamic([
                    [
                        "9d640d64297e559e",
                        [
                            MAX_RECORD_TIME,
                            colors.accent,
                            colors.accent,
                            colors.background,
                            colors.background,
                            colors.border,
                            colors.system.red,
                            colors.background,
                            colors.border,
                            colors.border,
                            colors.border,
                            colors.backgroundAccent,
                            colors.backgroundAccent,
                            colors.background,
                            colors.background,
                            duration
                        ]
                    ]
                ])
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "9d640d64297e559e",
                dynamic: [
                    MAX_RECORD_TIME,
                    colors.accent,
                    colors.accent,
                    colors.background,
                    colors.background,
                    colors.border,
                    colors.system.red,
                    colors.background,
                    colors.border,
                    colors.border,
                    colors.border,
                    colors.backgroundAccent,
                    colors.backgroundAccent,
                    colors.background,
                    colors.background,
                    duration
                ],
                children: ".test-recording.__jsx-style-dynamic-selector .stop-btn{-webkit-animation-duration:".concat(MAX_RECORD_TIME, "ms;-moz-animation-duration:").concat(MAX_RECORD_TIME, "ms;-o-animation-duration:").concat(MAX_RECORD_TIME, "ms;animation-duration:").concat(MAX_RECORD_TIME, "ms;-webkit-animation-name:fill-left-to-right;-moz-animation-name:fill-left-to-right;-o-animation-name:fill-left-to-right;animation-name:fill-left-to-right;-webkit-animation-timing-function:linear;-moz-animation-timing-function:linear;-o-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;-o-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:1;-moz-animation-iteration-count:1;-o-animation-iteration-count:1;animation-iteration-count:1;-webkit-animation-direction:normal;-moz-animation-direction:normal;-o-animation-direction:normal;animation-direction:normal;-webkit-animation-play-state:running;-moz-animation-play-state:running;-o-animation-play-state:running;animation-play-state:running;background:-webkit-linear-gradient(left,").concat(colors.accent, " 0%,").concat(colors.accent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:-moz-linear-gradient(left,").concat(colors.accent, " 0%,").concat(colors.accent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:-o-linear-gradient(left,").concat(colors.accent, " 0%,").concat(colors.accent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:linear-gradient(90deg,").concat(colors.accent, " 0%,").concat(colors.accent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);-webkit-background-size:200%100%;-moz-background-size:200%100%;-o-background-size:200%100%;background-size:200%100%;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;outline:1px solid ").concat(colors.border, ";padding:0px 4px}.recording-dot.__jsx-style-dynamic-selector{background:").concat(colors.system.red, ";-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;display:block;height:7px;width:7px}.player.__jsx-style-dynamic-selector{background:").concat(colors.background, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;outline:1px solid ").concat(colors.border, "}.player.__jsx-style-dynamic-selector button{padding:0 4px}.player.__jsx-style-dynamic-selector button:first-of-type{-webkit-border-radius:4px 0 0 4px!important;-moz-border-radius:4px 0 0 4px!important;border-radius:4px 0 0 4px!important}.player.__jsx-style-dynamic-selector button:last-of-type{-webkit-border-radius:0 4px 4px 0!important;-moz-border-radius:0 4px 4px 0!important;border-radius:0 4px 4px 0!important}.bar.__jsx-style-dynamic-selector{border-left:1px solid ").concat(colors.border, ";border-right:1px solid ").concat(colors.border, ";position:relative;width:64px}.progress.__jsx-style-dynamic-selector{background:-webkit-linear-gradient(left,").concat(colors.backgroundAccent, " 0%,").concat(colors.backgroundAccent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:-moz-linear-gradient(left,").concat(colors.backgroundAccent, " 0%,").concat(colors.backgroundAccent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:-o-linear-gradient(left,").concat(colors.backgroundAccent, " 0%,").concat(colors.backgroundAccent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);background:linear-gradient(90deg,").concat(colors.backgroundAccent, " 0%,").concat(colors.backgroundAccent, " 50%,").concat(colors.background, " 50%,").concat(colors.background, " 100%);-webkit-background-size:200%100%;-moz-background-size:200%100%;-o-background-size:200%100%;background-size:200%100%;display:block;height:100%;width:100%}.progress.playing.__jsx-style-dynamic-selector{-webkit-animation-duration:").concat(duration, "s;-moz-animation-duration:").concat(duration, "s;-o-animation-duration:").concat(duration, "s;animation-duration:").concat(duration, "s;-webkit-animation-name:fill-left-to-right;-moz-animation-name:fill-left-to-right;-o-animation-name:fill-left-to-right;animation-name:fill-left-to-right;-webkit-animation-timing-function:linear;-moz-animation-timing-function:linear;-o-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;-o-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:1;-moz-animation-iteration-count:1;-o-animation-iteration-count:1;animation-iteration-count:1;-webkit-animation-direction:normal;-moz-animation-direction:normal;-o-animation-direction:normal;animation-direction:normal;-webkit-animation-play-state:running;-moz-animation-play-state:running;-o-animation-play-state:running;animation-play-state:running}@-webkit-keyframes fill-left-to-right{from{background-position:100%0%}to{background-position:0%0%}}@-moz-keyframes fill-left-to-right{from{background-position:100%0%}to{background-position:0%0%}}@-o-keyframes fill-left-to-right{from{background-position:100%0%}to{background-position:0%0%}}@keyframes fill-left-to-right{from{background-position:100%0%}to{background-position:0%0%}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/TestSound.tsx









var TestSound = function(param) {
    var _animationPlacement = param.animationPlacement, animationPlacement = _animationPlacement === void 0 ? "left" : _animationPlacement;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var audioRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isPlaying = ref[0], setIsPlaying = ref[1];
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var handleTestSoundClick = function() {
        audioRef.current.play();
    };
    (0,react.useEffect)(function() {
        var audio = audioRef.current;
        if (!audio) return;
        var handlePlaying = function() {
            setIsPlaying(true);
        };
        var handleEnded = function() {
            setIsPlaying(false);
        };
        audio.addEventListener("playing", handlePlaying);
        audio.addEventListener("ended", handleEnded);
        return function() {
            audio.removeEventListener("playing", handlePlaying);
            audio.removeEventListener("ended", handleEnded);
        };
    }, [
        audioRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                gap: 4,
                horizontal: true,
                style: {
                    flexDirection: animationPlacement === "right" ? "row-reverse" : "row",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: animationPlacement === "right" && "100%",
                            right: animationPlacement === "left" && "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: isPlaying && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {
                                    color: "var(--text-muted)",
                                    size: 16
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "test-sound",
                        disabled: isPlaying,
                        onClick: handleTestSoundClick,
                        variant: "ghost",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "muted",
                            style: {
                                margin: "-1px 0 1px"
                            },
                            underline: true,
                            children: t("settings.modal.playTestSound")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                ref: audioRef,
                src: "".concat(assetPrefix, "/test-sound.mp3")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/AudioVideoSettings.tsx




















var AudioVideoSettings = function(param) {
    var shouldShowMicVolume = param.shouldShowMicVolume, _shouldShowNoiseCancellation = param.shouldShowNoiseCancellation, shouldShowNoiseCancellation = _shouldShowNoiseCancellation === void 0 ? false : _shouldShowNoiseCancellation;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref.broadcastRole, enableNoiseCancellationUI = ref.enableNoiseCancellationUI;
    var ref1 = (0,daily_react_esm/* useDevices */.Ls)(), cameras = ref1.cameras, camState = ref1.camState, microphones = ref1.microphones, micState = ref1.micState, setCamera = ref1.setCamera, setMicrophone = ref1.setMicrophone, setSpeaker = ref1.setSpeaker, speakers = ref1.speakers;
    var isAttendee = (0,react.useMemo)(function() {
        return broadcastRole === "attendee";
    }, [
        broadcastRole
    ]);
    var handleCamChange = function(id) {
        setCamera(id);
    };
    var handleMicChange = function(id) {
        setMicrophone(id);
    };
    var handleSpeakerChange = function(id) {
        setSpeaker(id);
    };
    var ref2 = useAudioProcessor(), handleNoiseCancellationChange = ref2.handleNoiseCancellationChange, noiseCancellationDisabled = ref2.noiseCancellationDisabled, noiseCancellationOn = ref2.noiseCancellationOn;
    var camOptions = (0,react.useMemo)(function() {
        switch(camState){
            case "blocked":
                return [
                    {
                        label: t("video.cameraBlocked"),
                        value: null
                    }, 
                ];
            case "not-found":
                return [
                    {
                        label: t("video.noCamera"),
                        value: null
                    }, 
                ];
            default:
                if (!cameras.length) {
                    return [
                        {
                            label: t("video.unmuteToAllowAccess"),
                            value: null
                        }, 
                    ];
                }
                return cameras.map(function(cam, index) {
                    return {
                        label: cam.state === "in-use" ? "\u26A0\uFE0F ".concat(cam.device.label || "".concat(t("video.cameraWithNumber", {
                            number: index + 1
                        }))) : cam.device.label || "".concat(t("video.cameraWithNumber", {
                            number: index + 1
                        })),
                        selected: cam.selected,
                        value: cam.device.deviceId
                    };
                });
        }
    }, [
        camState,
        cameras,
        t
    ]);
    var micOptions = (0,react.useMemo)(function() {
        switch(micState){
            case "blocked":
                return [
                    {
                        label: t("audio.microphoneBlocked"),
                        value: null
                    }, 
                ];
            case "not-found":
                return [
                    {
                        label: t("audio.noMicrophone"),
                        value: null
                    }, 
                ];
            default:
                if (!microphones.length) {
                    return [
                        {
                            label: t("audio.unmuteToAllowAccess"),
                            value: null
                        }, 
                    ];
                }
                return microphones.map(function(mic, index) {
                    return {
                        label: mic.state === "in-use" ? "\u26A0\uFE0F ".concat(mic.device.label || "".concat(t("audio.microphoneWithNumber", {
                            number: index + 1
                        }))) : mic.device.label || "".concat(t("audio.microphoneWithNumber", {
                            number: index + 1
                        })),
                        selected: mic.selected,
                        value: mic.device.deviceId
                    };
                });
        }
    }, [
        micState,
        microphones,
        t
    ]);
    var isSafari15OrLower = (0,browserConfig/* isSafari */.G6)(1, 15);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-c611169c7e9db3e4" + " " + "audio-video-settings",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                gap: 16,
                children: [
                    !isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                gap: 4,
                                /*#__PURE__*/ horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                                        id: "cam-settings-label",
                                        size: 16,
                                        transition: false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "label",
                                        className: "label",
                                        htmlFor: "settings-camera",
                                        variant: "strong",
                                        children: t("video.camera")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                className: robotsClassName("select-video-devices"),
                                disabled: !cameras.length,
                                id: "settings-camera",
                                name: "settings-camera",
                                native: true,
                                onChange: handleCamChange,
                                options: camOptions
                            })
                        ]
                    }),
                    !disableAudio && !isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                gap: 4,
                                horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "label",
                                        className: "label",
                                        htmlFor: "settings-microphone",
                                        variant: "strong",
                                        children: t("audio.microphone")
                                    }),
                                    micState === "granted" && microphones.length > 0 && shouldShowMicVolume && !isSafari15OrLower && /*#__PURE__*/ (0,jsx_runtime.jsx)(MicVolume, {}),
                                    microphones.length > 0 && !isSafari15OrLower && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                                        style: {
                                            marginLeft: "auto"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestRecording, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                className: robotsClassName("select-audio-devices"),
                                disabled: !microphones.length,
                                id: "settings-microphone",
                                name: "settings-microphone",
                                native: true,
                                onChange: handleMicChange,
                                options: micOptions
                            })
                        ]
                    }),
                    !disableAudio && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 4,
                                horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioIcon/* AudioIcon */.f, {
                                        id: "speaker-settings-label",
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "label",
                                        className: "label",
                                        htmlFor: "settings-speakers",
                                        variant: "strong",
                                        children: t("audio.speakers")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                                        style: {
                                            marginLeft: "auto"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestSound, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                id: "settings-speakers",
                                name: "settings-speakers",
                                native: true,
                                onChange: handleSpeakerChange,
                                options: speakers.length > 0 ? speakers.map(function(speaker, index) {
                                    return {
                                        label: speaker.device.label || "".concat(t("audio.speakers_{number}", {
                                            number: index + 1
                                        })),
                                        selected: speaker.selected,
                                        value: speaker.device.deviceId
                                    };
                                }) : [
                                    {
                                        label: t("audio.systemDefault"),
                                        selected: true,
                                        value: "default"
                                    }, 
                                ]
                            })
                        ]
                    }),
                    enableNoiseCancellationUI && shouldShowNoiseCancellation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        className: "noise-cancellation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                className: "label",
                                variant: "strong",
                                children: t("audio.noiseCancellationTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxToggle/* CheckboxToggle */.p, {
                                reverseOrder: true,
                                checked: noiseCancellationOn,
                                checkedLabel: t("audio.noiseCancellationDesc"),
                                disabled: noiseCancellationDisabled,
                                id: "noise-cancellation-settings",
                                name: "noise-cancellation-settings",
                                onChange: function(event) {
                                    return handleNoiseCancellationChange(event.target.checked);
                                },
                                uncheckedLabel: t("audio.noiseCancellationDesc"),
                                value: "1"
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c611169c7e9db3e4",
                children: ".audio-video-settings.jsx-c611169c7e9db3e4 .label{display:block;margin-bottom:1px;margin-top:-1px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/LandscapeIcon.js
var LandscapeIcon = __webpack_require__(6498);
// EXTERNAL MODULE: ../shared/dist/components/Icons/UserIcon.js
var UserIcon = __webpack_require__(3353);
;// CONCATENATED MODULE: ./components/SettingsModal/BackgroundEffects.tsx
















var BackgroundEffects = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var videoTrack = (0,daily_react_esm/* useVideoTrack */.HU)(localSessionId);
    var isUserFacingVideo = (0,react.useMemo)(function() {
        if (!(videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.track)) return true;
        var videoTrackSettings = videoTrack.track.getSettings();
        return "facingMode" in videoTrackSettings ? videoTrackSettings.facingMode === "user" : true;
    }, [
        videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.track
    ]);
    var ref = useBackgroundEffect(), currentEffect = ref.currentEffect, effects = ref.effects, selectEffect = ref.selectEffect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "a11470ec7d50391d",
                [
                    colors.accent
                ]
            ]
        ]) + " " + (classnames_default()("effects", {
            isUserFacingVideo: isUserFacingVideo
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                /*#__PURE__*/ horizontal: true,
                wrap: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "strong",
                        children: t("settings.modal.selectEffect")
                    }),
                    currentEffect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("settings.modal.appliedEffect", {
                            effect: currentEffect
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "a11470ec7d50391d",
                        [
                            colors.accent
                        ]
                    ]
                ]) + " " + "selection",
                children: effects.map(function(effect) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        id: "tt-eff-".concat(effect),
                        placement: "top",
                        // i18next-extract-mark-context-next-line ["none", "strong-blur", "soft-blur", "vb-coffeeshop", "vb-forest", "vb-hills", "vb-library", "vb-lounge", "vb-ocean", "vb-office", "vb-palms", "vb-rollercoaster"]
                        title: t("settings.modal.effects", {
                            context: effect
                        }),
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                            id: "background-effect-".concat(effect),
                            className: classnames_default()("btn-effect", effect, {
                                vb: effect.startsWith("vb-"),
                                selected: currentEffect === effect
                            }),
                            "data-testid": "btn-".concat(effect),
                            onClick: function() {
                                return selectEffect(effect);
                            },
                            variant: "secondary",
                            children: effect === "none" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                                        className: "icon-".concat(effect),
                                        color: currentEffect === effect ? colors.accent : undefined,
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                        children: t("settings.modal.effects_none")
                                    })
                                ]
                            }) : effect.endsWith("-blur") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandscapeIcon/* LandscapeIcon */.B, {
                                        className: "icon-".concat(effect),
                                        color: currentEffect === effect ? colors.accent : undefined,
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                        children: // i18next-extract-mark-context-next-line ["strong-blur", "soft-blur"]
                                        t("settings.modal.effects", {
                                            context: effect
                                        })
                                    })
                                ]
                            }) : effect.startsWith("vb-") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                // i18next-extract-mark-context-next-line ["vb-coffeeshop", "vb-forest", "vb-hills", "vb-library", "vb-lounge", "vb-ocean", "vb-office", "vb-palms", "vb-rollercoaster"]
                                alt: t("settings.modal.effects", {
                                    context: effect
                                }),
                                src: "".concat(assetPrefix, "/backgrounds/").concat(effect, "-thumb.jpg"),
                                height: 56,
                                width: 56,
                                className: styled_jsx_default().dynamic([
                                    [
                                        "a11470ec7d50391d",
                                        [
                                            colors.accent
                                        ]
                                    ]
                                ])
                            }) : null
                        })
                    }, effect);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "a11470ec7d50391d",
                dynamic: [
                    colors.accent
                ],
                children: ".effects.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px}.selection.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.selection.__jsx-style-dynamic-selector .btn-effect{height:56px;padding:15px;width:56px}.selection.__jsx-style-dynamic-selector .btn-effect.vb{padding:0;overflow:hidden}.isUserFacingVideo.__jsx-style-dynamic-selector .selection.__jsx-style-dynamic-selector .btn-effect.vb{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);-o-transform:scaleX(-1);transform:scaleX(-1)}.selection.__jsx-style-dynamic-selector .btn-effect.selected{border-color:".concat(colors.accent, "}.selection.__jsx-style-dynamic-selector .icon-soft-blur{-webkit-filter:blur(1px);filter:blur(1px)}.selection.__jsx-style-dynamic-selector .icon-strong-blur{-webkit-filter:blur(3px);filter:blur(3px)}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/UserPreferences/EmojiSkinTone.tsx










var EmojiSkinTone = function() {
    var ref = (0,useEmojiSkinTone/* useEmojiSkinTone */.v)(), currentSkinTone = ref.currentSkinTone, getModifier = ref.getModifier, resetSkinTone = ref.resetSkinTone, selectSkinTone = ref.selectSkinTone;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var onEmojiClick = function(tone) {
        if (!tone) resetSkinTone();
        selectSkinTone(tone);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        gap: 8,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "strong",
                /*#__PURE__*/ children: t("settings.modal.emojiSkinToneTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-572c1d78dbbc6db0" + " " + "buttons-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        id: "skin-tone-none",
                        placement: "top",
                        title: t("settings.modal.noSkinTone"),
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                            className: robotsClassName("skin-tone-none"),
                            onClick: function() {
                                return onEmojiClick(null);
                            },
                            variant: !currentSkinTone ? "primary" : "secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "span",
                                variant: "large",
                                children: "\u270B"
                            })
                        }, null)
                    }, "skin-tone-none"),
                    Object.keys(useEmojiSkinTone/* skinToneMap */.m).map(function(tone) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            id: "skin-tone-".concat(tone),
                            placement: "top",
                            // i18next-extract-mark-context-next-line ["dark", "light", "medium", "mediumDark", "mediumLight"]
                            title: t("settings.modal.useSkinTone", {
                                context: tone
                            }),
                            tabIndex: -1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                className: robotsClassName("skin-tone-".concat(tone)),
                                onClick: function() {
                                    return onEmojiClick(tone);
                                },
                                variant: currentSkinTone && tone === currentSkinTone ? "primary" : "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    El: "span",
                                    variant: "large",
                                    children: "\u270B".concat(getModifier(tone))
                                })
                            }, tone)
                        }, "skin-tone-".concat(tone));
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "572c1d78dbbc6db0",
                children: ".buttons-container.jsx-572c1d78dbbc6db0{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/lib/sortByKey.js
var sortByKey = __webpack_require__(7414);
;// CONCATENATED MODULE: ./components/SettingsModal/UserPreferences/Language.tsx








var langLabels = {
    de: "Deutsch",
    en: "English",
    es: "Espa\xf1ol",
    fi: "Suomi",
    fr: "Fran\xe7ais",
    it: "Italiano",
    jp: "\u65E5\u672C\u8A9E",
    ka: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
    nl: "Nederlands",
    no: "Norsk",
    pl: "Polski",
    pt: "Portugu\xeas",
    ru: "P\u0443\u0441\u0441\u043A\u0438\u0439",
    sv: "Svenska",
    tr: "T\xfcrk\xe7e"
};
var Language = function() {
    var ref = (0,useTranslation/* useTranslation */.$)(), i18n = ref.i18n, t = ref.t;
    var handleLanguageChange = function(value) {
        i18n.changeLanguage(value);
    };
    var languageOptions = (0,react.useMemo)(function() {
        return (i18n.options.supportedLngs || []).filter(function(e) {
            return e !== "cimode";
        }).map(function(lang) {
            return {
                label: langLabels[lang],
                selected: i18n.language === lang,
                value: lang
            };
        }).sort((0,sortByKey/* sortByKey */.Y)("label"));
    }, [
        i18n
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        gap: 8,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "strong",
                children: t("settings.modal.languageDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                className: robotsClassName("select-language"),
                id: "lang",
                name: "lang",
                native: true,
                onChange: handleLanguageChange,
                options: languageOptions
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/UserPreferences.tsx








var UserPreferences = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,useCallConfig/* useCallConfig */.A)(), enableAdvancedChat = ref.enableAdvancedChat, enableEmojiReactions = ref.enableEmojiReactions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "large",
                children: t("settings.modal.userPreferences")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                gap: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Language, {}),
                    (enableAdvancedChat || enableEmojiReactions) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiSkinTone, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/DataList/index.js
var DataList = __webpack_require__(8318);
;// CONCATENATED MODULE: ./components/SettingsModal/VersionInfo.tsx
function VersionInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function VersionInfo_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                VersionInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                VersionInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function VersionInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VersionInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VersionInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var appState = (0,es/* atomFamily */.xu)({
    key: "backend-app-info",
    default: null
});
var VersionInfo = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var topology = (0,daily_react_esm/* useNetwork */.LN)().topology;
    var _NEXT_PUBLIC_SENTRY_ENVIRONMENT;
    var prebuiltInfo = {
        app_name: "prebuilt",
        git_hash: "9aced16db61620cccc074b4f5da2951348db85ac",
        git_ref: "refs/heads/main",
        environment_name: (_NEXT_PUBLIC_SENTRY_ENVIRONMENT = "production") !== null && _NEXT_PUBLIC_SENTRY_ENVIRONMENT !== void 0 ? _NEXT_PUBLIC_SENTRY_ENVIRONMENT : location.hostname.includes("localhost") || location.hostname.includes("khk-local.wss.daily.co") ? "local-development" : "production"
    };
    var webapp = (0,es/* useRecoilValue */.sJ)(appState("webapp"));
    var sfu = (0,es/* useRecoilValue */.sJ)(appState("sfu"));
    var storeAppInfo = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(app, info) {
            set(appState(app), info);
        };
    });
    /**
   * Fetch webapp info.
   */ (0,react.useEffect)(function() {
        if (!daily || webapp) return;
        if (!daily.properties["url"]) return;
        var url = new URL(daily.properties["url"]);
        fetch("".concat(url.origin, "/ctrl/version-info")).then(function() {
            var _ref = VersionInfo_asyncToGenerator(runtime_default().mark(function _callee(response) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (response.ok) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.t0 = storeAppInfo;
                            _ctx.next = 5;
                            return response.json();
                        case 5:
                            _ctx.t1 = _ctx.sent;
                            (0, _ctx.t0)("webapp", _ctx.t1);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(e) {
            console.warn("Could not fetch webapp version info", e);
        });
    }, [
        daily,
        storeAppInfo,
        webapp
    ]);
    /**
   * Fetch sfu info.
   */ (0,react.useEffect)(function() {
        var ref, ref1;
        if (sfu) return;
        if (topology !== "sfu") {
            storeAppInfo("sfu", null);
            return;
        }
        // TODO: How can we get the workerId via official daily-js API?
        var sfuWorker = window === null || window === void 0 ? void 0 : (ref = window["rtcpeers"]) === null || ref === void 0 ? void 0 : (ref1 = ref["soup"]) === null || ref1 === void 0 ? void 0 : ref1["workerId"];
        if (!sfuWorker) return;
        fetch("https://".concat(sfuWorker, ".wss.daily.co/ctrl/version-info")).then(function() {
            var _ref = VersionInfo_asyncToGenerator(runtime_default().mark(function _callee(response) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (response.ok) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.t0 = storeAppInfo;
                            _ctx.next = 5;
                            return response.json();
                        case 5:
                            _ctx.t1 = _ctx.sent;
                            (0, _ctx.t0)("sfu", _ctx.t1);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(e) {
            console.warn("Could not fetch sfu version info", e);
        });
    }, [
        sfu,
        storeAppInfo,
        topology
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "version-info",
        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            gap: 16,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInfo, VersionInfo_objectSpread({}, prebuiltInfo)),
                webapp && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInfo, VersionInfo_objectSpread({}, webapp)),
                sfu && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInfo, VersionInfo_objectSpread({}, sfu))
            ]
        })
    });
};
var AppInfo = function(app) {
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var _git_ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "eacabb59fff033c0",
                [
                    mediaQueries.large
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataList/* DataList */.F, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DT, {
                        children: "App"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DD, {
                        children: app.app_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DT, {
                        children: "Commit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DD, {
                        children: app.git_hash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                            href: "https://github.com/daily-co/pluot-core/commit/".concat(app.git_hash),
                            target: "_blank",
                            underline: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "mono",
                                truncate: true,
                                children: app.git_hash
                            })
                        }) : "unspecified"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DT, {
                        children: "Branch"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DD, {
                        children: (_git_ref = app.git_ref) !== null && _git_ref !== void 0 ? _git_ref : "unspecified"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DT, {
                        children: "Environment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataList.DD, {
                        children: app.environment_name
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "eacabb59fff033c0",
                dynamic: [
                    mediaQueries.large
                ],
                children: 'div.__jsx-style-dynamic-selector dl{grid-template-columns:1fr;grid-template-areas:"."}@media '.concat(mediaQueries.large, '{div.__jsx-style-dynamic-selector dl{grid-template-columns:1fr 3fr;grid-template-areas:". ."}}')
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Radio/index.js
var Radio = __webpack_require__(9153);
;// CONCATENATED MODULE: ./components/SettingsModal/VideoQualitySettings.tsx








var VideoQualitySettings = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = useVideoQuality(), setVideoQuality = ref.setVideoQuality, videoQuality = ref.videoQuality;
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var handleChange = function(ev) {
        setVideoQuality(ev.target.value);
    };
    var autoQuality = (0,react.useMemo)(function() {
        if (videoQuality !== "auto") return null;
        switch(threshold){
            case "good":
                return t("settings.modal.highQuality");
            case "low":
                return t("settings.modal.lowQuality");
            case "very-low":
                return t("settings.modal.bandwidthSaver");
            default:
                return null;
        }
    }, [
        t,
        threshold,
        videoQuality
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        gap: 16,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "large",
                children: t("settings.modal.videoQualityDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 4,
                                horizontal: true,
                                style: {
                                    display: "inline-flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        El: "label",
                                        htmlFor: "video-quality-auto",
                                        variant: "strong",
                                        children: t("settings.modal.auto")
                                    }),
                                    autoQuality && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                                        El: "label",
                                        htmlFor: "video-quality-auto",
                                        children: [
                                            "(",
                                            autoQuality,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                color: "muted",
                                children: t("settings.modal.autoDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            flex: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                            checked: videoQuality === "auto",
                            id: "video-quality-auto",
                            label: null,
                            name: "video-quality",
                            onChange: handleChange,
                            value: "auto"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "label",
                                htmlFor: "video-quality-high",
                                variant: "strong",
                                children: t("settings.modal.highQuality")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                color: "muted",
                                children: t("settings.modal.highQualityDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            flex: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                            checked: videoQuality === "high",
                            id: "video-quality-high",
                            label: null,
                            name: "video-quality",
                            onChange: handleChange,
                            value: "high"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "label",
                                htmlFor: "video-quality-low",
                                variant: "strong",
                                children: t("settings.modal.lowQuality")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                color: "muted",
                                children: t("settings.modal.lowQualityDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            flex: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                            checked: videoQuality === "low",
                            id: "video-quality-low",
                            label: null,
                            name: "video-quality",
                            onChange: handleChange,
                            value: "low"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "label",
                                htmlFor: "video-quality-bandwidth-saver",
                                variant: "strong",
                                children: t("settings.modal.bandwidthSaver")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                color: "muted",
                                children: t("settings.modal.bandwidthSaverDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            flex: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                            checked: videoQuality === "bandwidth-saver",
                            id: "video-quality-bandwidth-saver",
                            label: null,
                            name: "video-quality",
                            onChange: handleChange,
                            value: "bandwidth-saver"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/SettingsModal.tsx
function SettingsModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SettingsModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SettingsModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SettingsModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SettingsModal_slicedToArray(arr, i) {
    return SettingsModal_arrayWithHoles(arr) || SettingsModal_iterableToArrayLimit(arr, i) || SettingsModal_unsupportedIterableToArray(arr, i) || SettingsModal_nonIterableRest();
}
function SettingsModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SettingsModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SettingsModal_arrayLikeToArray(o, minLen);
}
























var versionState = (0,es/* atom */.cn)({
    key: "show-version-info",
    default: false
});
var SettingsModal = function(param1) {
    var onClose = param1.onClose;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = SettingsModal_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var ref1 = SettingsModal_slicedToArray(useSettingsView(), 2), settingsView = ref1[0], setSettingsView = ref1[1];
    var colors = (0,Theme.useTheme)().colors;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref2.broadcastRole, enableVideoProcessingUI = ref2.enableVideoProcessingUI;
    var ref3 = (0,daily_react_esm/* useDevices */.Ls)(), cameras = ref3.cameras, camState = ref3.camState;
    var isNarrowViewport = (0,useMediaQuery.useMediaQuery)("(max-width: 500px)");
    var prebuiltDebuggerEnabled = (0,useDebugging/* useDebugging */.W)().prebuiltDebuggerEnabled;
    var showVersionInfo = (0,es/* useRecoilValue */.sJ)(versionState);
    var enableVersionInfo = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(versionState, true);
        };
    });
    var disableVersionInfo = (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function() {
            set(versionState, false);
        };
    });
    (0,react.useEffect)(function() {
        window["dailyEnableVersionInfo"] = enableVersionInfo;
        prebuiltDebuggerEnabled ? enableVersionInfo() : disableVersionInfo();
    }, [
        disableVersionInfo,
        enableVersionInfo,
        prebuiltDebuggerEnabled
    ]);
    var disableBackgroundEffects = camState === "pending" || cameras.length === 0;
    var index = {
        devices: 0,
        quality: 1,
        "user-preferences": 2,
        effects: 3,
        version: 4
    };
    var shouldRenderVideo = (0,react.useMemo)(function() {
        return (settingsView === "devices" || settingsView === "effects") && broadcastRole !== "attendee";
    }, [
        broadcastRole,
        settingsView
    ]);
    var supportsBackgroundEffects = (0,react.useMemo)(function() {
        return daily_iframe_esm/* default.supportedBrowser */.ZP.supportedBrowser().supportsVideoProcessing && !isMobile && broadcastRole !== "attendee" && enableVideoProcessingUI;
    }, [
        broadcastRole,
        enableVideoProcessingUI,
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        closeText: t("general.close"),
        onClose: onClose,
        position: "top",
        title: t("settings.modal.title"),
        variant: "closable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "d32d9694c1a95ea9",
                        [
                            colors.backgroundAccent
                        ]
                    ]
                ]) + " " + (classnames_default()("settings-modal", {
                    narrow: isNarrowViewport
                }) || ""),
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.mQ, {
                    id: "settings-modal",
                    initialIndex: index[settingsView],
                    vertical: !isNarrowViewport,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "d32d9694c1a95ea9",
                                    [
                                        colors.backgroundAccent
                                    ]
                                ]
                            ]) + " " + "tablist",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* TabList */.td, {
                                gap: isNarrowViewport ? undefined : 0,
                                spaceAround: isNarrowViewport ? 4 : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                        className: classnames_default()("tab", robotsClassName("tab-audio-video")),
                                        onClick: function() {
                                            return setSettingsView("devices");
                                        },
                                        children: t("settings.modal.audioVideo")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                        className: classnames_default()("tab", robotsClassName("tab-video-quality")),
                                        onClick: function() {
                                            return setSettingsView("quality");
                                        },
                                        children: t("settings.modal.videoQuality")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                        className: classnames_default()("tab", robotsClassName("tab-user-preferences")),
                                        onClick: function() {
                                            return setSettingsView("user-preferences");
                                        },
                                        children: t("settings.modal.userPreferences")
                                    }),
                                    supportsBackgroundEffects && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                        className: classnames_default()("tab", {
                                            disabled: disableBackgroundEffects
                                        }, robotsClassName("tab-effects")),
                                        disabled: disableBackgroundEffects,
                                        onClick: function() {
                                            return setSettingsView("effects");
                                        },
                                        children: t("settings.modal.backgroundEffects")
                                    }),
                                    showVersionInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.OK, {
                                        className: "tab",
                                        onClick: function() {
                                            return setSettingsView("version");
                                        },
                                        children: "Version Info"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "d32d9694c1a95ea9",
                                    [
                                        colors.backgroundAccent
                                    ]
                                ]
                            ]) + " " + "panels",
                            children: [
                                shouldRenderVideo ? isMobile && isNarrowViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
                                    orientation: "landscape",
                                    sessionId: localSessionId,
                                    showNames: true,
                                    videoFit: "cover"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                                    activeIndicator: "meter",
                                    hideActions: true,
                                    sessionId: localSessionId,
                                    showNames: true
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* TabPanels */.nP, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioVideoSettings, {
                                                shouldShowMicVolume: true,
                                                shouldShowNoiseCancellation: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoQualitySettings, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPreferences, {})
                                        }),
                                        supportsBackgroundEffects && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundEffects, {})
                                        }),
                                        showVersionInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* TabPanel */.x4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VersionInfo, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d32d9694c1a95ea9",
                dynamic: [
                    colors.backgroundAccent
                ],
                children: ".settings-modal.__jsx-style-dynamic-selector .mobile-tile{aspect-ratio:1/1}.settings-modal.__jsx-style-dynamic-selector .tile{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;height:auto;margin-bottom:var(--card-spacing)}.settings-modal.__jsx-style-dynamic-selector:not(.narrow){display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin:-webkit-calc(-1*var(--card-spacing));margin:-moz-calc(-1*var(--card-spacing));margin:calc(-1*var(--card-spacing));min-height:164px}.settings-modal.__jsx-style-dynamic-selector:not(.narrow) .tablist.__jsx-style-dynamic-selector{background:".concat(colors.backgroundAccent, ";border-right:1px solid var(--card-border);border-top:1px solid var(--card-border);-webkit-box-flex:0;-webkit-flex:0 0 160px;-moz-box-flex:0;-ms-flex:0 0 160px;flex:0 0 160px}.settings-modal.__jsx-style-dynamic-selector:not(.narrow) .tile{margin:-webkit-calc(-1*var(--card-spacing))-webkit-calc(-1*var(--card-spacing))var(--card-spacing);margin:-moz-calc(-1*var(--card-spacing))-moz-calc(-1*var(--card-spacing))var(--card-spacing);margin:calc(-1*var(--card-spacing))calc(-1*var(--card-spacing))var(--card-spacing);width:auto}.settings-modal.__jsx-style-dynamic-selector:not(.narrow) .panels.__jsx-style-dynamic-selector{border-top:1px solid var(--card-border);-webkit-box-flex:1;-webkit-flex:1 1 100%;-moz-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;padding:var(--card-spacing)}.settings-modal.__jsx-style-dynamic-selector .tab.disabled{opacity:.4}.settings-modal.__jsx-style-dynamic-selector .hand-status{display:none}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SettingsModal/index.ts


;// CONCATENATED MODULE: ./components/Topbar/SettingsButton.tsx
function SettingsButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SettingsButton_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SettingsButton_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SettingsButton_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SettingsButton_slicedToArray(arr, i) {
    return SettingsButton_arrayWithHoles(arr) || SettingsButton_iterableToArrayLimit(arr, i) || SettingsButton_unsupportedIterableToArray(arr, i) || SettingsButton_nonIterableRest();
}
function SettingsButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SettingsButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SettingsButton_arrayLikeToArray(o, minLen);
}








var SettingsButton = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = SettingsButton_slicedToArray(useSettingsView(), 2), settingsView = ref[0], setSettingsView = ref[1];
    var handleClick = function() {
        setSettingsView("devices");
    };
    var handleModalClose = function() {
        setSettingsView(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-ccd094d6b4aed3bd" + " " + "settings",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                id: "topbar-settings",
                className: "settings-btn",
                onClick: handleClick,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GearIcon/* GearIcon */.U, {
                        fill: "currentColor",
                        stroke: "transparent",
                        size: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        /*#__PURE__*/ children: t("settings.open")
                    })
                ]
            }),
            settingsView && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsModal, {
                onClose: handleModalClose
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ccd094d6b4aed3bd",
                children: ".settings.jsx-ccd094d6b4aed3bd .settings-btn{margin:-4px;padding:4px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/AppsIcon.js
var AppsIcon = __webpack_require__(4182);
;// CONCATENATED MODULE: ./components/Topbar/AppsStatus.tsx












var btnStyle = {
    background: "var(--badge-default-bg)",
    borderRadius: 4
};
var AppsStatus = function() {
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var screens = (0,useScreens/* useScreens */.O)();
    var ref1 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), runningMainIntegrations = ref1.runningMainIntegrations, stopIntegration = ref1.stopIntegration;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var screenIds = screens.map(function(s) {
        return s.session_id;
    });
    var firstAppUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(runningMainIntegrations === null || runningMainIntegrations === void 0 ? void 0 : (ref = runningMainIntegrations[0]) === null || ref === void 0 ? void 0 : ref.startedBy, "user_name");
    var handleClickStop = function(app) {
        stopIntegration(app.id);
    };
    var isSharingApp = runningMainIntegrations.some(function(i) {
        return i.startedBy === localSessionId;
    });
    var isSingleApp = screenIds.length === 0 && runningMainIntegrations.length === 1;
    var message;
    var actionOrIcon;
    if (isSharingApp) {
        var app2 = runningMainIntegrations.find(function(i) {
            return i.startedBy === localSessionId;
        });
        message = t("integrations.stopSharing", {
            label: app2.label
        });
        actionOrIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
            variant: "danger",
            onClick: function() {
                return handleClickStop(app2);
            },
            style: {
                borderRadius: btnStyle.borderRadius,
                padding: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                variant: "default",
                size: 16
            })
        });
    } else if (isSingleApp) {
        var app1 = runningMainIntegrations === null || runningMainIntegrations === void 0 ? void 0 : runningMainIntegrations[0];
        if (app1.shared) {
            message = t("integrations.isSharing", {
                name: firstAppUserName !== null && firstAppUserName !== void 0 ? firstAppUserName : t("people.guest"),
                label: app1.label
            });
        } else {
            message = t("integrations.onlyYouCanSee", {
                label: app1.label
            });
        }
        actionOrIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIcon, {
            id: app1.id,
            size: 24,
            style: btnStyle
        });
    } else if (screenIds.length) {
        var count = runningMainIntegrations.length + screenIds.length;
        message = t("integrations.itemsAreShared", {
            count: count
        });
        actionOrIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
            size: 24,
            style: btnStyle
        });
    } else {
        var count1 = runningMainIntegrations.length;
        message = t("integrations.appsAreShared", {
            count: count1
        });
        actionOrIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsIcon/* AppsIcon */.j, {
            size: 24,
            style: btnStyle
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        align: "center",
        gap: 8,
        horizontal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                children: message
            }),
            actionOrIcon
        ]
    });
};

;// CONCATENATED MODULE: ./components/Topbar/ScreenshareButton.tsx














var ScreenshareButton = function(param) {
    var onClick = param.onClick;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var isSharingScreen = (0,daily_react_esm/* useScreenShare */.N2)().isSharingScreen;
    var screens = (0,useScreens/* useScreens */.O)();
    var firstScreenUserName = (0,daily_react_esm/* useParticipantProperty */.ou)((ref = screens[0]) === null || ref === void 0 ? void 0 : ref.session_id, "user_name");
    var infoText = (0,react.useMemo)(function() {
        return isSharingScreen ? t("screenShare.stopSharing") : screens.length > 1 ? t("screenShare.peopleWithCount", {
            count: screens.length
        }) : t("screenShare.personWithName", {
            name: firstScreenUserName || t("people.someone")
        });
    }, [
        firstScreenUserName,
        isSharingScreen,
        screens,
        t
    ]);
    if (!screens.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "f46821e21c790b60",
                [
                    colors.backgroundAccent
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                /*#__PURE__*/ horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: infoText
                    }),
                    isSharingScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "topbar-screen-share-stop",
                        className: robotsClassName("btn-screenshare-stop"),
                        onClick: onClick,
                        variant: "danger",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                size: 16,
                                color: colors.system.white,
                                variant: "thick"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("screenShare.stopSharing")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "presentation",
                        className: styled_jsx_default().dynamic([
                            [
                                "f46821e21c790b60",
                                [
                                    colors.backgroundAccent
                                ]
                            ]
                        ]) + " " + "screenShareIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                            size: 16,
                            color: colors.baseText
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f46821e21c790b60",
                dynamic: [
                    colors.backgroundAccent
                ],
                children: "div.__jsx-style-dynamic-selector button{-webkit-border-radius:4px!important;-moz-border-radius:4px!important;border-radius:4px!important;padding:3px!important}.screenShareIcon.__jsx-style-dynamic-selector{background-color:".concat(colors.backgroundAccent, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:4px}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Topbar/Unpin.tsx
function Unpin_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Unpin_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Unpin_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Unpin_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Unpin_slicedToArray(arr, i) {
    return Unpin_arrayWithHoles(arr) || Unpin_iterableToArrayLimit(arr, i) || Unpin_unsupportedIterableToArray(arr, i) || Unpin_nonIterableRest();
}
function Unpin_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Unpin_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Unpin_arrayLikeToArray(o, minLen);
}















var Unpin = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = Unpin_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), pinnedId = ref[0], setPinnedId = ref[1];
    var screens = (0,useScreens/* useScreens */.O)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var runningMainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().runningMainIntegrations;
    var isPinnedScreen = (0,react.useMemo)(function() {
        return screens.some(function(s) {
            return s.screenId === pinnedId;
        });
    }, [
        pinnedId,
        screens
    ]);
    var pinnedIntegration = (0,react.useMemo)(function() {
        return runningMainIntegrations.find(function(i) {
            return i.id === pinnedId;
        });
    }, [
        runningMainIntegrations,
        pinnedId
    ]);
    var handleClick = function() {
        setPinnedId(null);
    };
    var label = (0,react.useMemo)(function() {
        if (pinnedIntegration) return "Unpin ".concat(pinnedIntegration.label);
        if (isPinnedScreen) return t("screenShare.unpin");
        if (pinnedId === localSessionId) return t("people.unpinYourself");
        return t("people.unpinParticipant");
    }, [
        localSessionId,
        isPinnedScreen,
        pinnedId,
        pinnedIntegration,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "8d6ee8fbd87da8ae",
                [
                    colors.accent
                ]
            ]
        ]) + " " + "unpin",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                /*#__PURE__*/ horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "topbar-unpin-".concat(pinnedId),
                        className: robotsClassName("btn-unpin"),
                        onClick: handleClick,
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                                className: "close",
                                color: colors.accentText,
                                size: 24
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: label
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "8d6ee8fbd87da8ae",
                dynamic: [
                    colors.accent
                ],
                children: ".unpin.__jsx-style-dynamic-selector button{-webkit-border-radius:4px!important;-moz-border-radius:4px!important;border-radius:4px!important}.unpin.__jsx-style-dynamic-selector .close{background:".concat(colors.accent, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}")
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/GridViewIcon.js
var GridViewIcon = __webpack_require__(255);
// EXTERNAL MODULE: ../shared/dist/components/Icons/SpeakerViewIcon.js
var SpeakerViewIcon = __webpack_require__(6312);
;// CONCATENATED MODULE: ./components/Topbar/ViewSwitch.tsx
function ViewSwitch_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ViewSwitch_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ViewSwitch_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ViewSwitch_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ViewSwitch_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ViewSwitch_slicedToArray(arr, i) {
    return ViewSwitch_arrayWithHoles(arr) || ViewSwitch_iterableToArrayLimit(arr, i) || ViewSwitch_unsupportedIterableToArray(arr, i) || ViewSwitch_nonIterableRest();
}
function ViewSwitch_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ViewSwitch_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ViewSwitch_arrayLikeToArray(o, minLen);
}
















var BLOCK_SWITCH_TIMEOUT = 500;
var ViewSwitch = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var viewMode = (0,layout/* useViewMode */.mJ)();
    var ref = ViewSwitch_slicedToArray((0,layout/* usePreferredViewMode */.Ut)(), 2), setPreferredViewMode = ref[1];
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ blockSwitch = ref1[0], setBlockSwitch = ref1[1];
    /**
   * Prevent users from switching between views too quickly.
   */ var switchView = (0,react.useCallback)(function(mode) {
        if (blockSwitch || mode === viewMode) {
            return;
        }
        setPreferredViewMode(mode);
        setBlockSwitch(true);
        setTimeout(function() {
            setBlockSwitch(false);
        }, BLOCK_SWITCH_TIMEOUT);
    }, [
        blockSwitch,
        setPreferredViewMode,
        viewMode
    ]);
    var speakerViewDisabled = viewMode !== "speaker" && blockSwitch || breakoutStatus === "ongoing";
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "dd5c89d9476c882a",
                [
                    colors.backgroundAccent,
                    colors.accent,
                    colors.backgroundAccent
                ]
            ]
        ]) + " " + "view-switch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: viewMode === "grid" ? t("view.grid") : t("view.speaker")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        align: "center",
                        horizontal: true,
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                id: "tt-speaker-view-disabled",
                                disabled: !speakerViewDisabled,
                                title: t("view.speakerViewDisabled"),
                                placement: "bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                    id: "view-switch-speaker",
                                    className: classnames_default()("btn", (_obj = {
                                        active: viewMode === "speaker"
                                    }, ViewSwitch_defineProperty(_obj, robotsClassName("btn-speaker-view-switch"), viewMode !== "speaker"), ViewSwitch_defineProperty(_obj, robotsClassName("btn-speaker-view-noop"), viewMode === "speaker"), _obj)),
                                    disabled: speakerViewDisabled,
                                    onClick: function() {
                                        return switchView("speaker");
                                    },
                                    variant: "ghost",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerViewIcon/* SpeakerViewIcon */.d, {
                                            color: viewMode === "speaker" ? colors.accentText : speakerViewDisabled ? colors.supportiveText : colors.baseText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                            children: t("view.switchToSpeaker")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                                id: "view-switch-grid",
                                className: classnames_default()("btn", (_obj1 = {
                                    active: viewMode === "grid"
                                }, ViewSwitch_defineProperty(_obj1, robotsClassName("btn-grid-view-switch"), viewMode !== "grid"), ViewSwitch_defineProperty(_obj1, robotsClassName("btn-grid-view-noop"), viewMode === "grid"), _obj1)),
                                disabled: viewMode !== "grid" && blockSwitch,
                                onClick: function() {
                                    return switchView("grid");
                                },
                                variant: "ghost",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GridViewIcon/* GridViewIcon */.q, {
                                        color: viewMode === "grid" ? colors.accentText : colors.baseText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                        children: t("view.switchToGrid")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "dd5c89d9476c882a",
                dynamic: [
                    colors.backgroundAccent,
                    colors.accent,
                    colors.backgroundAccent
                ],
                children: ".view-switch.__jsx-style-dynamic-selector .btn{background-color:".concat(colors.backgroundAccent, ";-webkit-border-radius:4px!important;-moz-border-radius:4px!important;border-radius:4px!important}.view-switch.__jsx-style-dynamic-selector .btn.active{background-color:").concat(colors.accent, "}.view-switch.__jsx-style-dynamic-selector .btn[disabled]{background-color:").concat(colors.backgroundAccent, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Topbar/TopbarAction.tsx
function TopbarAction_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TopbarAction_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TopbarAction_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TopbarAction_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TopbarAction_slicedToArray(arr, i) {
    return TopbarAction_arrayWithHoles(arr) || TopbarAction_iterableToArrayLimit(arr, i) || TopbarAction_unsupportedIterableToArray(arr, i) || TopbarAction_nonIterableRest();
}
function TopbarAction_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TopbarAction_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TopbarAction_arrayLikeToArray(o, minLen);
}










var TopbarAction = function() {
    var participantIds = (0,daily_react_esm/* useParticipantIds */.OV)();
    var screens = (0,useScreens/* useScreens */.O)();
    var ref = TopbarAction_slicedToArray((0,layout/* usePinnedId */.Sg)(), 2), pinnedId = ref[0], setPinnedId = ref[1];
    var runningMainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().runningMainIntegrations;
    var ref1 = (0,daily_react_esm/* useScreenShare */.N2)(), isSharingScreen = ref1.isSharingScreen, stopScreenShare = ref1.stopScreenShare;
    var integrationIds = (0,react.useMemo)(function() {
        return runningMainIntegrations.map(function(i) {
            return i.id;
        });
    }, [
        runningMainIntegrations
    ]);
    (0,react.useEffect)(function() {
        if (!pinnedId) return;
        var pinned = participantIds.some(function(id) {
            return id === pinnedId;
        }) || screens.some(function(s) {
            return s.screenId === pinnedId;
        }) || integrationIds.some(function(id) {
            return id === pinnedId;
        });
        if (!pinned) {
            // pinned tile is not present anymore
            setPinnedId(null);
        }
    }, [
        integrationIds,
        participantIds,
        pinnedId,
        screens,
        setPinnedId
    ]);
    if (pinnedId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Unpin, {});
    }
    if (runningMainIntegrations.length && !isSharingScreen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsStatus, {});
    }
    if (screens.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareButton, {
            onClick: stopScreenShare
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewSwitch, {});
};

;// CONCATENATED MODULE: ./components/Topbar/Topbar.tsx
















var Topbar = /*#__PURE__*/ (0,react.memo)(function() {
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), enablePIPUI = ref2.enablePIPUI, poweredByDaily = ref2.poweredByDaily;
    var isSafari14OrLower = (0,browserConfig/* isSafari */.G6)(1, 14);
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var topbarRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ supportsPIP = ref1[0], setSupportsPIP = ref1[1];
    /**
   * Recalculates and sets the --header-height CSS variable.
   */ var updateCSSHeaderHeight = (0,react.useCallback)(function() {
        if (!topbarRef.current) return;
        var ref = topbarRef.current.getBoundingClientRect(), height = ref.height, top = ref.top;
        document.body.style.setProperty("--header-height", "".concat(height + top, "px"));
    }, []);
    /**
   * Set up ResizeObserver to determine when Topbar shifts position.
   */ (0,useResizeObserver.useResizeObserver)(topbarRef, updateCSSHeaderHeight);
    (0,useResize.useResize)(updateCSSHeaderHeight);
    (0,react.useEffect)(function() {
        updateCSSHeaderHeight;
    }, [
        poweredByDaily,
        updateCSSHeaderHeight
    ]);
    (0,react.useEffect)(function() {
        // TODO: Figure out why pictureInPicture types are missing in `next build`
        // @ts-ignore
        setSupportsPIP(document.pictureInPictureEnabled);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: topbarRef,
        className: "jsx-89ec28b0d67cac58" + " " + "topbar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        align: "center",
                        horizontal: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsButton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                gap: 4,
                                horizontal: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveBadge, {}),
                                    breakoutStatus === "ongoing" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutStatus, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleInCall, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordingState, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-89ec28b0d67cac58" + " " + "action",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarAction, {}),
                            enablePIPUI && supportsPIP && !isSafari14OrLower && /*#__PURE__*/ (0,jsx_runtime.jsx)(PictureInPictureButton, {})
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "89ec28b0d67cac58",
                children: ".topbar.jsx-89ec28b0d67cac58{background:var(--card-bg);border-bottom:1px solid var(--card-border);-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;padding:4px 8px;width:100vw;z-index:var(--zindex-tray)}.action.jsx-89ec28b0d67cac58{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}"
            })
        ]
    });
});
Topbar.displayName = "Topbar";

;// CONCATENATED MODULE: ./components/Topbar/index.ts


;// CONCATENATED MODULE: ./lib/dom.ts
/**
 * Checks if the given media element is currently in a playing state.
 * @param element The media element to check.
 * @returns boolean
 */ var isMediaElementPlaying = function(element) {
    return element.currentTime > 0 && !element.paused && !element.ended && element.readyState > element.HAVE_CURRENT_DATA;
};

;// CONCATENATED MODULE: ./lib/sentry-capture-helpers.ts
function sentry_capture_helpers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sentry_capture_helpers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sentry_capture_helpers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/**
 * Use this method to capture exceptions due to play() failing for an <audio> element.
 * @param e The thrown exception, as caught in the catch statement.
 * @param audio The HTMLAudioElement which was attempted to play().
 * @param localSessionId The sessionId as returned from useLocalSessionId().
 * @param extra Optional additional extra data to be captured in Sentry. Should contain context information, e.g. which component caught this exception.
 */ var captureAudioPlayException = function(e, audio, localSessionId) {
    var extra = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref, ref1;
    var audioTrack = (ref1 = (ref = audio.srcObject) === null || ref === void 0 ? void 0 : ref.getAudioTracks()) === null || ref1 === void 0 ? void 0 : ref1[0];
    (0,esm_exports/* captureException */.Tb)(e, {
        extra: sentry_capture_helpers_objectSpread({
            audioElement: audio.outerHTML,
            dataset: sentry_capture_helpers_objectSpread({}, audio.dataset),
            localSessionId: localSessionId,
            mediaStreamTrack: {
                // contentHint not available in Next.js types?
                // @ts-ignore
                contentHint: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.contentHint,
                enabled: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.enabled,
                id: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.id,
                kind: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.kind,
                label: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.label,
                muted: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.muted,
                readyState: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.readyState
            }
        }, extra)
    });
};

;// CONCATENATED MODULE: ./components/Call/AudioTracks.tsx
function AudioTracks_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AudioTracks_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AudioTracks_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function AudioTracks_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AudioTracks_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AudioTracks_slicedToArray(arr, i) {
    return AudioTracks_arrayWithHoles(arr) || AudioTracks_iterableToArrayLimit(arr, i) || AudioTracks_unsupportedIterableToArray(arr, i) || AudioTracks_nonIterableRest();
}
function AudioTracks_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AudioTracks_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AudioTracks_arrayLikeToArray(o, minLen);
}










var AudioTracks = function() {
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref = AudioTracks_slicedToArray(useAutoplayFailedModal(), 2), setShowAutoplayFailedModal = ref[1];
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ isClient = ref1[0], setIsClient = ref1[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    (0,react.useEffect)(function() {
        setIsClient(true);
    }, []);
    (0,react.useEffect)(function() {
        var playTracks = function() {
            document.querySelectorAll(".audioTracks audio").forEach(function(audio) {
                var playAudio = function() {
                    var promise = audio.play();
                    if (promise !== undefined) {
                        promise.then(function() {
                        // All good, audio is playing
                        }).catch(function(error) {
                            // Audio play still failing
                            console.warn("Failed to play audio", error);
                            if (AudioTracks_instanceof(error, DOMException) && error.name === "NotAllowedError") {
                                setShowAutoplayFailedModal(true);
                            }
                            captureAudioPlayException(error, audio, localSessionId, {
                                audioTracks: 1
                            });
                        });
                    }
                };
                if (!isMediaElementPlaying(audio)) {
                    playAudio();
                }
            });
        };
        navigator.mediaDevices.addEventListener("devicechange", playTracks);
        return function() {
            navigator.mediaDevices.removeEventListener("devicechange", playTracks);
        };
    }, [
        localSessionId,
        setShowAutoplayFailedModal
    ]);
    var handlePlayFailed = (0,react.useCallback)(function() {
        setShowAutoplayFailedModal(true);
    }, [
        setShowAutoplayFailedModal
    ]);
    // Only render audio tracks in browser
    if (!isClient || disableAudio) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal.Portal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-a249ad1e5ddf0faa" + " " + "audioTracks",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(daily_react_esm/* DailyAudio */.Th, {
                    maxSpeakers: MAX_RECENT_SPEAKER_COUNT,
                    onPlayFailed: handlePlayFailed
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "a249ad1e5ddf0faa",
                    children: ".audioTracks.jsx-a249ad1e5ddf0faa{position:absolute;visibility:hidden}"
                })
            ]
        })
    }, "AudioTracks");
};

;// CONCATENATED MODULE: ./components/Apps/AppsList.tsx










var AppsList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var children = param.children, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, _iconVariant = param.iconVariant, iconVariant = _iconVariant === void 0 ? "thick" : _iconVariant, onClickApp = param.onClickApp, _textVariant = param.textVariant, textVariant = _textVariant === void 0 ? "base" : _textVariant;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), canControlIntegration = ref.canControlIntegration, mainIntegrations = ref.mainIntegrations, runningMainIntegrations = ref.runningMainIntegrations, runningSharedIntegrations = ref.runningSharedIntegrations, startIntegration = ref.startIntegration, stopIntegration = ref.stopIntegration;
    var apps = mainIntegrations.filter(canControlIntegration);
    var handleClickApp = function(integration) {
        if (integration.running || integration.id in runningSharedIntegrations) {
            stopIntegration(integration.id);
        } else {
            startIntegration(integration.id);
        }
        onClickApp === null || onClickApp === void 0 ? void 0 : onClickApp(integration);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-4dc67d98406d81e8" + " " + "apps-list",
        children: [
            children,
            apps.map(function(app) {
                var isRunning = runningMainIntegrations.some(function(a) {
                    return a.id === app.id;
                }) || app.id in runningSharedIntegrations;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                    className: classnames_default()({
                        running: isRunning
                    }),
                    onClick: function() {
                        return handleClickApp(app);
                    },
                    title: t(isRunning ? "integrations.close" : "integrations.launch", {
                        label: app.label
                    }),
                    variant: "secondary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIcon, {
                            id: app.id,
                            size: iconSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: textVariant,
                            /*#__PURE__*/ children: app.label
                        }),
                        isRunning && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                            className: "close",
                            size: iconSize,
                            variant: iconVariant
                        })
                    ]
                }, app.id);
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4dc67d98406d81e8",
                children: ".apps-list.jsx-4dc67d98406d81e8{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}.apps-list.jsx-4dc67d98406d81e8 button{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px;min-width:100px;padding:8px 32px 8px 8px;position:relative;width:100%}.apps-list.jsx-4dc67d98406d81e8 button:not(.running){background:inherit}.apps-list.jsx-4dc67d98406d81e8 button .close{position:absolute;right:8px;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%)}"
            })
        ]
    });
});
AppsList.displayName = "AppsList";

;// CONCATENATED MODULE: ./components/Apps/AppsModal.tsx
function AppsModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AppsModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AppsModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var AppsModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, AppsModal_objectSpread({
        variant: "closable",
        title: t("general.apps")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsList, {
            iconSize: 24,
            iconVariant: "default",
            textVariant: "large"
        })
    }));
};

;// CONCATENATED MODULE: ./components/BreakoutRooms/JoinBreakoutModal.tsx
function JoinBreakoutModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function JoinBreakoutModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            JoinBreakoutModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var JoinBreakoutModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var ref = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), currentBreakoutRoom = ref.currentBreakoutRoom, invitedBreakoutRoom = ref.invitedBreakoutRoom;
    var ref1 = useBreakouts(), declineBreakout = ref1.declineBreakout, joinBreakout = ref1.joinBreakout;
    var isMobileVP = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var handleClickCancel = function() {
        declineBreakout(true);
        props.onClose();
    };
    var handleClickJoin = function() {
        joinBreakout();
        props.onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, JoinBreakoutModal_objectSpread({
        hideOnBackdropClick: false,
        hideOnEsc: false,
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "breakouts-join-session",
                fullWidth: isMobileVP,
                onClick: handleClickJoin,
                children: t("breakouts.joinModal.join", {
                    room: t("breakouts.roomWithName", {
                        name: invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name
                    })
                })
            }, "submit"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "breakouts-cancel-invite",
                fullWidth: isMobileVP,
                variant: "secondary",
                onClick: handleClickCancel,
                children: t("breakouts.joinModal.cancel", {
                    room: (currentBreakoutRoom === null || currentBreakoutRoom === void 0 ? void 0 : currentBreakoutRoom.name) ? t("breakouts.roomWithName", {
                        name: currentBreakoutRoom === null || currentBreakoutRoom === void 0 ? void 0 : currentBreakoutRoom.name
                    }) : t("breakouts.mainRoom")
                })
            }, "cancel"), 
        ],
        title: t("breakouts.joinModal.title")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            El: "label",
            variant: "large",
            children: t("breakouts.joinModal.description", {
                room: (invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name) ? t("breakouts.roomWithName", {
                    name: invitedBreakoutRoom === null || invitedBreakoutRoom === void 0 ? void 0 : invitedBreakoutRoom.name
                }) : t("breakouts.mainRoom")
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/BroadcastJoiningModal/BroadcastJoiningModal.tsx
function BroadcastJoiningModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BroadcastJoiningModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BroadcastJoiningModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BroadcastJoiningModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BroadcastJoiningModal_slicedToArray(arr, i) {
    return BroadcastJoiningModal_arrayWithHoles(arr) || BroadcastJoiningModal_iterableToArrayLimit(arr, i) || BroadcastJoiningModal_unsupportedIterableToArray(arr, i) || BroadcastJoiningModal_nonIterableRest();
}
function BroadcastJoiningModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BroadcastJoiningModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BroadcastJoiningModal_arrayLikeToArray(o, minLen);
}







var BroadcastJoiningModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = useSoundLoader(), loadSounds = ref.load;
    var ref1 = BroadcastJoiningModal_slicedToArray(useAutoplayFailedModal(), 2), setShowAutoplayFailedModal = ref1[1];
    var handleModalClose = function() {
        loadSounds();
        // brute-force audio tracks to play and avoid rendering the AutoPlayFailedModal
        setShowAutoplayFailedModal(false);
        document.querySelectorAll(".audioTracks audio").forEach(function(audio) {
            if (audio.paused) audio.play();
        });
        props.onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "broadcast-joining",
                variant: "primary",
                children: t("broadcast.joiningButton")
            }, "joining"), 
        ],
        onClose: handleModalClose,
        title: t("broadcast.welcome"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            El: "p",
            variant: "large",
            children: t("broadcast.joiningViewer")
        })
    });
};

;// CONCATENATED MODULE: ./components/BroadcastJoiningModal/index.ts


;// CONCATENATED MODULE: ./components/Haircheck/DeviceInUseModal.tsx
function DeviceInUseModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DeviceInUseModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DeviceInUseModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var DeviceInUseModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var camState = (0,daily_react_esm/* useDevices */.Ls)().camState;
    var camInUse = camState === "in-use";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, DeviceInUseModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "device-in-use-modal-close",
                variant: "primary",
                children: props.closeText
            }, "close"), 
        ],
        title: camInUse ? t("haircheck.deviceInUse.title_camera") : t("haircheck.deviceInUse.title_other")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            El: "p",
            variant: "large",
            children: camInUse ? t("haircheck.deviceInUse.desc_camera") : t("haircheck.deviceInUse.desc_other")
        })
    }));
};

;// CONCATENATED MODULE: ./components/Haircheck/DeviceNotFoundModal.tsx
function DeviceNotFoundModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DeviceNotFoundModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DeviceNotFoundModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var DeviceNotFoundModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,daily_react_esm/* useDevices */.Ls)(), camState = ref.camState, micState = ref.micState;
    var camNotFound = camState === "not-found";
    var micNotFound = micState === "not-found";
    /**
   * When there are no devices found, we ask the user to connect devices and then reload.
   * The CTA in this Modal therefore triggers a reload.
   */ var handleReload = function() {
        window.location.reload();
    };
    var modalTitle = (0,react.useMemo)(function() {
        var context = camNotFound && micNotFound ? "both" : camNotFound ? "camera" : "mic";
        // i18next-extract-mark-context-next-line ["camera", "mic", "both"]
        return t("haircheck.noDevices.title", {
            context: context
        });
    }, [
        camNotFound,
        micNotFound,
        t
    ]);
    var modalContent = (0,react.useMemo)(function() {
        var context = camNotFound && micNotFound ? "both" : camNotFound ? "camera" : "mic";
        // i18next-extract-mark-context-next-line ["camera", "mic", "both"]
        return t("haircheck.noDevices.modalContent", {
            context: context
        });
    }, [
        camNotFound,
        micNotFound,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, DeviceNotFoundModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "device-not-found-modal-reload",
                onClick: handleReload,
                variant: "primary",
                children: t("general.reloadCall")
            }, "reload"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "device-not-found-modal-close",
                variant: "secondary",
                children: props.closeText
            }, "close"), 
        ],
        title: modalTitle
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            El: "p",
            variant: "large",
            children: modalContent
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 4 modules
var Trans = __webpack_require__(327);
;// CONCATENATED MODULE: ./components/Haircheck/CTAButton.tsx
function CTAButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CTAButton_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CTAButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CTAButton_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CTAButton_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CTAButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CTAButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CTAButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CTAButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CTAButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CTAButton_slicedToArray(arr, i) {
    return CTAButton_arrayWithHoles(arr) || CTAButton_iterableToArrayLimit(arr, i) || CTAButton_unsupportedIterableToArray(arr, i) || CTAButton_nonIterableRest();
}
function CTAButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CTAButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CTAButton_arrayLikeToArray(o, minLen);
}






var CTAButton = function(_param) {
    var children = _param.children, props = CTAButton_objectWithoutProperties(_param, [
        "children"
    ]);
    var ref = CTAButton_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var textVariantStrong = (0,useStyleVariants/* useStyleVariants */._)().textVariantStrong;
    var mobileButtonStyles = (0,react.useMemo)(function() {
        return isMobile ? {
            padding: "10px 20px 12px"
        } : {};
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, CTAButton_objectSpread({}, props, {
        style: mobileButtonStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: textVariantStrong,
            El: "span",
            color: "inherit",
            children: children
        })
    }));
};


;// CONCATENATED MODULE: ./components/Haircheck/getBrowserIcon.ts
function getBrowserIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var CHROME = "Chrome";
var EDGE = "Microsoft Edge";
var FIREFOX = "Firefox";
var OPERA = "Opera";
/**
 * Helper method to calculate the right image path for permissions icon in browsers.
 */ var getBrowserIcon = function(browser, isDarkMode) {
    var _obj;
    var browserIcons = (_obj = {}, getBrowserIcon_defineProperty(_obj, CHROME, "chrome"), getBrowserIcon_defineProperty(_obj, EDGE, "edge"), getBrowserIcon_defineProperty(_obj, FIREFOX, "firefox"), getBrowserIcon_defineProperty(_obj, OPERA, "opera"), _obj);
    if (!browser) return null;
    var browserName = browser.browser.name;
    var parts = [];
    if ((0,browserConfig/* isAndroidChrome */.jI)()) {
        parts.push("mobile");
    }
    parts.push([
        CHROME,
        EDGE,
        FIREFOX,
        OPERA
    ].includes(browserName) ? browserIcons[browserName] : "chrome");
    // New icons in Firefox 89
    if (browserName === FIREFOX && parseFloat(browser.browser.version) >= 89) {
        parts.push("new");
    }
    parts.push(isDarkMode ? "dark" : "light");
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    return "".concat(assetPrefix, "/unblock/").concat(parts.join("-"), ".png");
};

;// CONCATENATED MODULE: ./components/Haircheck/useSafariUnblockPermissions.ts
function useSafariUnblockPermissions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useSafariUnblockPermissions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useSafariUnblockPermissions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useSafariUnblockPermissions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





/**
 * Utility hook to consolidate logic around unblocking permissions in Safari.
 */ var useSafariUnblockPermissions = function() {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref2 = (0,CallProvider/* useCallState */.oz)(), disableAudio = ref2.disableAudio, mode = ref2.mode;
    var ref1 = (0,react.useState)(0), safariRetryCount = ref1[0], setSafariRetryCount = ref1[1];
    /**
   * Executes logic to grant cam & mic permissions in Safari.
   * Reloads the page in direct-link calls.
   * In embedded calls we'll call getUserMedia manually with a "fake" deviceId,
   * in order to generate new gUM constraints every time we call grantAccess.
   * Safari allows up to 3 attempts, after that all calls to gUM will be ignored
   * until the user refreshes the page.
   */ var grantAccess = (0,react.useCallback)(useSafariUnblockPermissions_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, onFail, onSuccess, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, onFail = ref.onFail, onSuccess = ref.onSuccess;
                    if (!(mode === "direct-link")) {
                        _ctx.next = 5;
                        break;
                    }
                    {
                        window.location.reload();
                    }
                    _ctx.next = 18;
                    break;
                case 5:
                    _ctx.prev = 5;
                    if (!(0,browserConfig/* isSafari */.G6)(14)) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 9;
                    return navigator.mediaDevices.getUserMedia({
                        video: {
                            deviceId: {
                                ideal: safariRetryCount.toString()
                            }
                        }
                    });
                case 9:
                    daily.setLocalVideo(true);
                    if (!disableAudio) daily.setLocalAudio(true);
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](5);
                    onFail === null || onFail === void 0 ? void 0 : onFail(_ctx.t0);
                    setSafariRetryCount(function(i) {
                        return i + 1;
                    });
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                5,
                14
            ]
        ]);
    })), [
        daily,
        disableAudio,
        mode,
        safariRetryCount
    ]);
    return {
        grantAccess: grantAccess
    };
};

;// CONCATENATED MODULE: ./components/Haircheck/UnblockPermissionsInstructions.tsx













var UnblockPermissionsInstructions_EDGE = "Microsoft Edge";
var FALLBACK_BROWSER = "Chrome";
var SUPPORTED_BROWSERS = [
    UnblockPermissionsInstructions_EDGE,
    "Chrome",
    "Firefox",
    "Opera",
    "Safari"
];
var UnblockPermissionsInstructions = function(param) {
    var _hideUnblockButton = param.hideUnblockButton, hideUnblockButton = _hideUnblockButton === void 0 ? false : _hideUnblockButton;
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isDarkMode = (0,Theme.useTheme)().isDarkMode;
    var mode = (0,CallProvider/* useCallState */.oz)().mode;
    var ref2 = (0,react.useState)(null), /*#__PURE__*/ browser = ref2[0], setBrowser = ref2[1];
    (0,react.useEffect)(function() {
        setBrowser(es5_default().parse(navigator.userAgent));
    }, []);
    var browserIcon = (0,react.useMemo)(function() {
        return getBrowserIcon(browser, isDarkMode);
    }, [
        browser,
        isDarkMode
    ]);
    var browserName = SUPPORTED_BROWSERS.includes(browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name) ? browser === null || browser === void 0 ? void 0 : (ref1 = browser.browser) === null || ref1 === void 0 ? void 0 : ref1.name : FALLBACK_BROWSER;
    var grantAccess = useSafariUnblockPermissions().grantAccess;
    var handleGrantAccessClick = (0,react.useCallback)(function() {
        grantAccess();
    }, [
        grantAccess
    ]);
    var i18nOptions = (0,react.useMemo)(function() {
        if ((0,browserConfig/* isSafari */.G6)(13) && (0,browserConfig/* isIOSMobile */.eS)()) {
            return "Safari13+iOS";
        }
        if ((0,browserConfig/* isSafari */.G6)(15)) {
            return "Safari15";
        }
        return browserName;
    }, [
        browserName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) && mode === "direct-link" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                gap: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "large",
                        El: "p",
                        textAlign: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                            i18nKey: "haircheck.blocked.safariText"
                        })
                    }),
                    !hideUnblockButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        id: "haircheck-unblock-grant-access-safari-direct",
                        onClick: handleGrantAccessClick,
                        fullWidth: true,
                        children: t("haircheck.blocked.grantAccess")
                    })
                ]
            }) : (0,browserConfig/* isAndroidChrome */.jI)(browserName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "large",
                El: "p",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                    i18nKey: "haircheck.blocked.androidChromeText",
                    children: [
                        "1. Tap the lock icon",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            src: browserIcon,
                            height: "24",
                            style: {
                                display: "inline",
                                verticalAlign: "middle "
                            },
                            className: "jsx-4f5f5157e2d652e6"
                        }),
                        " ",
                        "in your browser's address bar",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "jsx-4f5f5157e2d652e6"
                        }),
                        "2. Tap Permissions",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "jsx-4f5f5157e2d652e6"
                        }),
                        "3. Tap Camera and Microphone and Allow both",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "jsx-4f5f5157e2d652e6"
                        }),
                        "4. Tap Try again below to refresh"
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "jsx-4f5f5157e2d652e6" + " " + (((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)() ? "withButton" : "") || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Firefox", "Chrome", "Microsoft Edge", "Opera", "Safari", "Safari15", "Safari13+iOS"]
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                                    i18nKey: "haircheck.blocked.unblockModalStep1",
                                    tOptions: {
                                        context: i18nOptions
                                    },
                                    values: {
                                        url: window.location.hostname
                                    },
                                    children: [
                                        "Click the camera icon",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: browserIcon,
                                            height: "24",
                                            className: "jsx-4f5f5157e2d652e6" + " " + "blocked-icon"
                                        }),
                                        " ",
                                        "in your browser's address bar"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Firefox", "Chrome", "Microsoft Edge", "Opera", "Safari", "Safari15", "Safari13+iOS"]
                                t("haircheck.blocked.unblockModalStep2", {
                                    context: i18nOptions
                                })
                            }),
                            ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Safari", "Safari15", "Safari13+iOS"]
                                t("haircheck.blocked.unblockModalStep3", {
                                    context: i18nOptions
                                })
                            })
                        ]
                    }),
                    !hideUnblockButton && ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                        justify: "stretch",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                            id: "haircheck-unblock-grant-access-safari2",
                            onClick: handleGrantAccessClick,
                            fullWidth: true,
                            children: t("haircheck.blocked.grantAccess")
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4f5f5157e2d652e6",
                children: ".blocked-icon.jsx-4f5f5157e2d652e6{vertical-align:bottom}ol.jsx-4f5f5157e2d652e6{padding:0 0 0 20px;text-align:left}ol.withButton.jsx-4f5f5157e2d652e6{padding:0;margin-bottom:16px}ol.withButton.jsx-4f5f5157e2d652e6 li{margin-left:20px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/UnblockPermissionsModal.tsx
function UnblockPermissionsModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UnblockPermissionsModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UnblockPermissionsModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UnblockPermissionsModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var UnblockPermissionsModal = function(param) {
    var closeText = param.closeText, onClose = param.onClose;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var grantAccess = useSafariUnblockPermissions().grantAccess;
    var handleGrantAccessClick = (0,react.useCallback)(function() {
        var _ref = UnblockPermissionsModal_asyncToGenerator(runtime_default().mark(function _callee(close) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        grantAccess({
                            onSuccess: close
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(close) {
            return _ref.apply(this, arguments);
        };
    }(), [
        grantAccess
    ]);
    var actions = (0,react.useMemo)(function() {
        if ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) {
            return [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "unblock-permissions-modal-grant",
                    variant: "primary",
                    onClick: handleGrantAccessClick,
                    children: t("haircheck.blocked.grantAccess")
                }, "grant"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                    id: "unblock-permissions-modal-close",
                    variant: "secondary",
                    children: closeText
                }, "close"), 
            ];
        }
        return [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "unblock-permissions-modal-dismiss",
                variant: "primary",
                children: t("general.dismiss")
            }, "dismiss"), 
        ];
    }, [
        closeText,
        handleGrantAccessClick,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        actions: actions,
        onClose: onClose,
        title: t("haircheck.blocked.unblockModalTitle"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    El: "p",
                    children: t("haircheck.blocked.unblockModalContentText")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnblockPermissionsInstructions, {
                    hideUnblockButton: true
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/NameModal/NameModal.tsx
function NameModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NameModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NameModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var NameModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var localUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "user_name");
    var ref = (0,react.useState)(localUserName !== null && localUserName !== void 0 ? localUserName : ""), name = ref[0], setName = ref[1];
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var handleChange = function(ev) {
        setName(ev.target.value);
    };
    var handleSubmit = function() {
        daily.setUserName(name);
        var accessState = daily.accessState();
        if (accessState.awaitingAccess) {
            daily.requestAccess({
                name: name,
                access: {
                    level: "full"
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, NameModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "name-modal-submit",
                form: "name-form",
                type: "submit",
                children: t("nameModal.changeName")
            }, "submit"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "name-modal-cancel",
                variant: "secondary",
                children: t("general.cancel")
            }, "cancel"), 
        ],
        title: t("nameModal.title")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            id: "name-form",
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                gap: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        El: "label",
                        variant: "large",
                        children: t("nameModal.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                        className: robotsClassName("input-name"),
                        maxLength: 80,
                        name: "username",
                        onChange: handleChange,
                        placeholder: t("nameModal.inputPlaceholder"),
                        value: name
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/NameModal/index.ts


;// CONCATENATED MODULE: ./components/Recording/LeaveWhileRecordingModal.tsx
function LeaveWhileRecordingModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LeaveWhileRecordingModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LeaveWhileRecordingModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var LeaveWhileRecordingModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var leaveCall = (0,CallProvider/* useCallState */.oz)().leaveCall;
    var handleLeave = function() {
        leaveCall();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, LeaveWhileRecordingModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "leave-while-recording-stay",
                children: t("recording.leaveModal.stayInMeeting")
            }, "stay"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "leave-while-recording-leave",
                onClick: handleLeave,
                variant: "secondary",
                children: t("recording.leaveModal.leaveWithoutSaving")
            }, "leave"), 
        ],
        title: t("recording.leaveModal.title")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: "large",
            children: t("recording.leaveModal.content")
        })
    }));
};

;// CONCATENATED MODULE: ./components/Recording/RecordingErrorModal.tsx
function RecordingErrorModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecordingErrorModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecordingErrorModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var RecordingErrorModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, RecordingErrorModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "recording-error-close",
                children: props.closeText
            }, "close"), 
        ],
        title: t("recording.errorModal.title")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: "large",
            children: t("recording.errorModal.content")
        })
    }));
};

// EXTERNAL MODULE: ./contexts/RecordingProvider.tsx
var RecordingProvider = __webpack_require__(2147);
;// CONCATENATED MODULE: ./components/Recording/StartRecordingModal.tsx
function StartRecordingModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function StartRecordingModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            StartRecordingModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var StartRecordingModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var enableRecording = (0,useCallConfig/* useCallConfig */.A)().enableRecording;
    var startRecording = (0,RecordingProvider/* useRecording */.$n)().startRecording;
    var handleStartClick = function(close) {
        startRecording();
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, StartRecordingModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "start-recording-modal-start",
                onClick: handleStartClick,
                variant: "danger",
                children: t("recording.startRecording")
            }, "start"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "start-recording-modal-close",
                variant: "secondary",
                children: props.closeText
            }, "close"), 
        ],
        title: t("recording.startModal.title")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: "large",
            children: // i18next-extract-mark-context-next-line ["cloud-beta"]
            t("recording.startModal.content", {
                context: enableRecording
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Recording/index.ts




;// CONCATENATED MODULE: ./components/ScreenShareErrorModal/ScreenShareErrorModal.tsx
function ScreenShareErrorModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScreenShareErrorModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScreenShareErrorModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ScreenShareErrorModal_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ScreenShareErrorModal_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ScreenShareErrorModal_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













var ScreenShareErrorModal = function(_param) {
    var error = _param.error, props = ScreenShareErrorModal_objectWithoutProperties(_param, [
        "error"
    ]);
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isDarkMode = (0,Theme.useTheme)().isDarkMode;
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var FALLBACK_BROWSER = "Chrome";
    var SUPPORTED_BROWSERS = [
        "Chrome",
        "Firefox",
        "Microsoft Edge",
        "Opera",
        "Safari", 
    ];
    var ref2 = (0,react.useState)(null), /*#__PURE__*/ browser = ref2[0], setBrowser = ref2[1];
    var browserName = SUPPORTED_BROWSERS.includes(browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name) ? browser === null || browser === void 0 ? void 0 : (ref1 = browser.browser) === null || ref1 === void 0 ? void 0 : ref1.name : FALLBACK_BROWSER;
    (0,react.useEffect)(function() {
        setBrowser(es5_default().parse(navigator.userAgent));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, ScreenShareErrorModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "screen-share-error-modal-dismiss",
                variant: "secondary",
                children: t("general.dismiss")
            }, "dismiss"), 
        ],
        title: t("screenShare.errorTitle")
    }, props, {
        children: [
            error === "blocked-by-os" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "large",
                        El: "p",
                        children: t("screenShare.errorBlockedByOsSub", {
                            browserName: browserName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "jsx-7d3c7297fcb0da6d",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                                    i18nKey: "screenShare.errorBlockedByOsStep1",
                                    children: [
                                        "On your Mac, choose Apple menu",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: "".concat(assetPrefix, "/unblock/apple-logo-").concat(isDarkMode ? "dark" : "light", ".png"),
                                            height: "24",
                                            className: "jsx-7d3c7297fcb0da6d" + " " + "blocked-icon"
                                        }),
                                        " ",
                                        "> System Preferences, then click Sharing",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: "".concat(assetPrefix, "/unblock/apple-security-").concat(isDarkMode ? "dark" : "light", ".png"),
                                            height: "24",
                                            className: "jsx-7d3c7297fcb0da6d" + " " + "blocked-icon"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: t("screenShare.errorBlockedByOsStep2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: t("screenShare.errorBlockedByOsStep3", {
                                    browserName: browserName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: t("screenShare.errorBlockedByOsStep4", {
                                    browserName: browserName
                                })
                            })
                        ]
                    })
                ]
            }),
            error === "blocked-by-browser" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (0,browserConfig/* isSafari */.G6)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                        style: {
                            marginBottom: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "large",
                            El: "p",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                i18nKey: "screenShare.errorBlockedByBrowserSafari"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "jsx-7d3c7297fcb0da6d" + " " + (classnames_default()({
                            safari: (0,browserConfig/* isSafari */.G6)()
                        }) || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Firefox", "Safari"]
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                                    i18nKey: "screenShare.errorBlockedByBrowserStep1",
                                    tOptions: {
                                        context: (0,browserConfig/* isSafari */.G6)(15) ? "Safari15" : browserName
                                    },
                                    values: {
                                        url: window.location.hostname
                                    },
                                    children: [
                                        "Click the screen share icon",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: "".concat(assetPrefix, "/unblock/firefox-screenshare-").concat(isDarkMode ? "dark" : "light", ".png"),
                                            height: "24",
                                            className: "jsx-7d3c7297fcb0da6d" + " " + "blocked-icon"
                                        }),
                                        " ",
                                        "in your browser's address bar"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Firefox", "Safari"]
                                t("screenShare.errorBlockedByBrowserStep2", {
                                    context: browserName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                variant: "large",
                                El: "li",
                                children: // i18next-extract-mark-context-next-line ["Firefox", "Safari"]
                                t("screenShare.errorBlockedByBrowserStep3", {
                                    context: browserName
                                })
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "7d3c7297fcb0da6d",
                children: ".blocked-icon.jsx-7d3c7297fcb0da6d{vertical-align:bottom}ol.jsx-7d3c7297fcb0da6d{padding:0 0 0 24px;text-align:left}ol.safari.jsx-7d3c7297fcb0da6d{margin-left:16px}"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/ScreenShareErrorModal/index.ts


;// CONCATENATED MODULE: ./components/Sidebar/MuteAllModal.tsx
function MuteAllModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MuteAllModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MuteAllModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var MuteAllModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var muteAll = (0,ParticipantsProvider/* useParticipants */.BL)().muteAll;
    var muteNewParticipants = (0,ParticipantsProvider/* useMuteNewParticipants */.Ub)();
    var ref = (0,react.useState)(muteNewParticipants), isChecked = ref[0], setIsChecked = ref[1];
    var handleCheckboxChange = function(ev) {
        setIsChecked(ev.target.checked);
    };
    var handleMuteAll = (0,react.useCallback)(function(close) {
        muteAll(isChecked);
        close();
    }, [
        isChecked,
        muteAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, MuteAllModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "mute-all-modal-cancel",
                variant: "secondary",
                children: t("general.cancel")
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "mute-all-modal-mute",
                onClick: handleMuteAll,
                variant: "primary",
                children: t("people.muteAllParticipants")
            }, "mute"), 
        ],
        title: t("people.muteAllModalTitle")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    children: t("people.muteAllModalDesc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox.Checkbox, {
                    id: "mute-new-participants",
                    label: t("people.muteNewParticipantsCheckboxLabel"),
                    name: "mute-new-participants",
                    checked: isChecked,
                    onChange: handleCheckboxChange
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/StartScreenShareModal/StartScreenShareModal.tsx
function StartScreenShareModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function StartScreenShareModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            StartScreenShareModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var StartScreenShareModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var startScreenShare = (0,daily_react_esm/* useScreenShare */.N2)().startScreenShare;
    var handleStartClick = function(close) {
        startScreenShare();
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, StartScreenShareModal_objectSpread({
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "screen-share-modal-start",
                onClick: handleStartClick,
                variant: "primary",
                children: t("screenShare.startSharing")
            }, "start"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "screen-share-modal-cancel",
                variant: "secondary",
                children: t("general.cancel")
            }, "cancel"), 
        ],
        title: t("screenShare.startScreenSharing")
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            variant: "large",
            children: t("screenShare.startModalDesc")
        })
    }));
};

;// CONCATENATED MODULE: ./components/StartScreenShareModal/index.ts


;// CONCATENATED MODULE: ./components/Call/AutoplayFailedModal.tsx









var AutoplayFailedModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var handleModalClose = (0,react.useCallback)(function() {
        document.querySelectorAll(".audioTracks audio").forEach(function(audio) {
            var playAudio = function() {
                var promise = audio.play();
                if (promise !== undefined) {
                    promise.then(function() {
                    // All good, audio is playing
                    }).catch(function(error) {
                        // Audio play still failing
                        console.warn("Failed to play audio", error);
                        captureAudioPlayException(error, audio, localSessionId, {
                            autoplayFailedModal: 1
                        });
                    });
                }
            };
            if (!isMediaElementPlaying(audio)) playAudio();
        });
        props.onClose();
    }, [
        localSessionId,
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        actions: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                id: "autoplay-failed-join",
                variant: "primary",
                children: t("general.joinMeeting")
            }, "join"), 
        ],
        onClose: handleModalClose,
        title: t("lobby.audioPrompt.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
            El: "p",
            variant: "large",
            children: t("lobby.audioPrompt.desc")
        })
    });
};

;// CONCATENATED MODULE: ./components/Call/Modals.tsx
function Modals_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Modals_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Modals_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Modals_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Modals_slicedToArray(arr, i) {
    return Modals_arrayWithHoles(arr) || Modals_iterableToArrayLimit(arr, i) || Modals_unsupportedIterableToArray(arr, i) || Modals_nonIterableRest();
}
function Modals_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Modals_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Modals_arrayLikeToArray(o, minLen);
}

























var Modals = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var closeText = t("general.close");
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref17 = Modals_slicedToArray(useAutoplayFailedModal(), 2), showAutoplayFailedModal = ref17[0], setShowAutoplayFailedModal = ref17[1];
    var ref1 = Modals_slicedToArray(useDeviceInUseModal(), 2), showDeviceInUseModal = ref1[0], setShowDeviceInUseModal = ref1[1];
    var ref2 = Modals_slicedToArray(useDeviceNotFoundModal(), 2), showDeviceNotFoundModal = ref2[0], setShowDeviceNotFoundModal = ref2[1];
    var ref3 = Modals_slicedToArray(useJoinBreakoutModal(), 2), showJoinBreakoutModal = ref3[0], setShowJoinBreakoutModal = ref3[1];
    var ref4 = Modals_slicedToArray(useNameModal(), 2), showNameModal = ref4[0], setShowNameModal = ref4[1];
    var ref5 = Modals_slicedToArray((0,recordings/* useRecordingErrorModal */.p8)(), 2), showRecordingErrorModal = ref5[0], setShowRecordingErrorModal = ref5[1];
    var ref6 = Modals_slicedToArray((0,recordings/* useStartRecordingModal */.Fy)(), 2), showStartRecordingModal = ref6[0], setShowStartRecordingModal = ref6[1];
    var ref7 = Modals_slicedToArray(useStartScreenshareModal(), 2), showStartScreenshareModal = ref7[0], setShowStartScreenshareModal = ref7[1];
    var ref8 = Modals_slicedToArray(useScreenshareErrorModal(), 2), screenShareError = ref8[0], setScreenShareError = ref8[1];
    var ref9 = Modals_slicedToArray(useUnblockPermissionsModal(), 2), showUnblockPermissionsModal = ref9[0], setShowUnblockPermissionsModal = ref9[1];
    var ref10 = Modals_slicedToArray((0,recordings/* useLeaveWhileRecordingModal */.VV)(), 2), showLeaveWhileRecordingModal = ref10[0], setShowLeaveWhileRecordingModal = ref10[1];
    var ref11 = Modals_slicedToArray(useMuteAllModal(), 2), showMuteAllModal = ref11[0], setShowMuteAllModal = ref11[1];
    var ref12 = Modals_slicedToArray(useAppsModal(), 2), showAppsModal = ref12[0], setShowAppsModal = ref12[1];
    var ref13 = Modals_slicedToArray((0,core/* useAttendeeInteractedWithUI */.Ew)(), 2), attendeeInteractedWithUI = ref13[0], setAttendeeInteractedWithUI = ref13[1];
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var ref14 = Modals_slicedToArray((0,ParticipantsProvider/* useParticipantMarkedForRemoval */.jU)(), 2), participantMarkedForRemoval = ref14[0], setParticipantMarkedForRemoval = ref14[1];
    var handleRemoveParticipantModalClose = function() {
        return setParticipantMarkedForRemoval(null);
    };
    var handleJoinBreakoutModalClose = function() {
        return setShowJoinBreakoutModal(false);
    };
    var handleNameModalClose = function() {
        return setShowNameModal(false);
    };
    var handleAutoplayFailedModalClose = function() {
        return setShowAutoplayFailedModal(false);
    };
    var handleBroadcastJoiningModalClose = function() {
        return setAttendeeInteractedWithUI(true);
    };
    var handleDeviceInUseModalClose = function() {
        return setShowDeviceInUseModal(false);
    };
    var handleDeviceNotFoundModalClose = function() {
        return setShowDeviceNotFoundModal(false);
    };
    var handleRecordingErrorModalClose = function() {
        return setShowRecordingErrorModal(false);
    };
    var handleStartRecordingModalClose = function() {
        return setShowStartRecordingModal(false);
    };
    var handleStartScreenShareModalClose = function() {
        return setShowStartScreenshareModal(false);
    };
    var handleScreenShareErrorModal = function() {
        return setScreenShareError(null);
    };
    var handleUnblockPermissionsModalClose = function() {
        return setShowUnblockPermissionsModal(false);
    };
    var handleLeaveWhileRecordingModalClose = function() {
        return setShowLeaveWhileRecordingModal(false);
    };
    var handleMuteAllModalClose = function() {
        return setShowMuteAllModal(false);
    };
    var handleAppsModalClose = function() {
        return setShowAppsModal(false);
    };
    /** In public+no prejoin UI rooms, attendees won't see the haircheck
   * and won't have a UI interaction before joining the call. We show
   * a modal to prompt a user interaction.
   */ var isAttendee = (0,react.useMemo)(function() {
        return broadcastRole === "attendee";
    }, [
        broadcastRole
    ]);
    (0,daily_react_esm/* useDailyEvent */.VU)("nonfatal-error", (0,react.useCallback)(function(ev) {
        if (ev.type === "screen-share-error") {
            var ref, ref15, ref16;
            if (ev.errorMsg.includes("getDisplayMedia requires transient activation from a user gesture")) {
                setShowStartScreenshareModal(true);
            }
            if (((ref = ev.details) === null || ref === void 0 ? void 0 : ref.blockedBy) === "os") {
                setScreenShareError("blocked-by-os");
            } else if (((ref15 = ev.details) === null || ref15 === void 0 ? void 0 : ref15.blockedBy) === "browser") {
                setScreenShareError("blocked-by-browser");
            } else if (((ref16 = ev.details) === null || ref16 === void 0 ? void 0 : ref16.category) === "unknown") {
                addMessage({
                    content: t("screenShare.unknownError"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                        size: 16
                    }),
                    type: "error"
                });
            }
        }
    }, [
        addMessage,
        setScreenShareError,
        setShowStartScreenshareModal,
        t
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            participantMarkedForRemoval && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveParticipantModal, {
                onClose: handleRemoveParticipantModalClose
            }),
            showAutoplayFailedModal && !isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoplayFailedModal, {
                onClose: handleAutoplayFailedModalClose
            }),
            (!attendeeInteractedWithUI || showAutoplayFailedModal) && isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsx)(BroadcastJoiningModal, {
                onClose: handleBroadcastJoiningModalClose
            }),
            showDeviceInUseModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceInUseModal, {
                onClose: handleDeviceInUseModalClose,
                closeText: closeText
            }),
            showDeviceNotFoundModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceNotFoundModal, {
                onClose: handleDeviceNotFoundModalClose,
                closeText: closeText
            }),
            showJoinBreakoutModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinBreakoutModal, {
                onClose: handleJoinBreakoutModalClose
            }),
            showLeaveWhileRecordingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaveWhileRecordingModal, {
                onClose: handleLeaveWhileRecordingModalClose,
                closeText: closeText
            }),
            showMuteAllModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(MuteAllModal, {
                onClose: handleMuteAllModalClose,
                closeText: closeText
            }),
            showNameModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(NameModal, {
                onClose: handleNameModalClose
            }),
            showRecordingErrorModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordingErrorModal, {
                onClose: handleRecordingErrorModalClose,
                closeText: closeText
            }),
            showStartRecordingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(StartRecordingModal, {
                onClose: handleStartRecordingModalClose,
                closeText: closeText
            }),
            showStartScreenshareModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(StartScreenShareModal, {
                onClose: handleStartScreenShareModalClose
            }),
            screenShareError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenShareErrorModal, {
                error: screenShareError,
                closeText: t("general.dismiss"),
                onClose: handleScreenShareErrorModal
            }),
            showUnblockPermissionsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnblockPermissionsModal, {
                onClose: handleUnblockPermissionsModalClose,
                closeText: closeText
            }),
            showAppsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsModal, {
                onClose: handleAppsModalClose
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Call/Call.tsx
function Call_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Call_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Call_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Call_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Call_slicedToArray(arr, i) {
    return Call_arrayWithHoles(arr) || Call_iterableToArrayLimit(arr, i) || Call_unsupportedIterableToArray(arr, i) || Call_nonIterableRest();
}
function Call_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Call_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Call_arrayLikeToArray(o, minLen);
}




























var Call = function() {
    var ref = (0,Theme.useTheme)(), colors = ref.colors, zIndex = ref.zIndex;
    var viewMode = (0,layout/* useViewMode */.mJ)();
    var ref1 = Call_slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 1), showFullscreenButton = ref1[0];
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), enableEmojiReactions = ref2.enableEmojiReactions, poweredByDaily = ref2.poweredByDaily;
    var ref3 = useWaitingRoom(), setShowModal = ref3.setShowModal, showModal = ref3.showModal;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var isJoiningBreakout = useRenderBreakoutsInterstitialScreen();
    var breakoutHost = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutHost;
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ref4 = Call_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sideBarView = ref4[0];
    var sideBarIsOpen = sideBarView !== null;
    var addExtraSpaceForSnackbars = sideBarIsOpen && !isJoiningBreakout;
    var handleModalClose = (0,react.useCallback)(function() {
        return setShowModal(false);
    }, [
        setShowModal
    ]);
    useJoinSound();
    return (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: styled_jsx_default().dynamic([
                [
                    "d3d1cbc29d1aca00",
                    [
                        colors.custom.mainAreaBg,
                        zIndex.header,
                        (sideBarIsOpen ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) : 0) + (viewMode === "speaker" ? lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF : 0) + 100
                    ]
                ]
            ]) + " " + "call",
            children: [
                poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: styled_jsx_default().dynamic([
                        [
                            "d3d1cbc29d1aca00",
                            [
                                colors.custom.mainAreaBg,
                                zIndex.header,
                                (sideBarIsOpen ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) : 0) + (viewMode === "speaker" ? lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF : 0) + 100
                            ]
                        ]
                    ]) + " " + "main",
                    children: [
                        showFullscreenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenButton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioTracks, {}),
                        isJoiningBreakout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JoiningBreakoutRoomScreen, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            /*#__PURE__*/ children: viewMode === "grid" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridView, {
                                participantIds: orderedParticipantIds
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerView, {})
                        }),
                        enableEmojiReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "d3d1cbc29d1aca00",
                                    [
                                        colors.custom.mainAreaBg,
                                        zIndex.header,
                                        (sideBarIsOpen ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) : 0) + (viewMode === "speaker" ? lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF : 0) + 100
                                    ]
                                ]
                            ]) + " " + "reactions",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                                animation: "flyUp"
                            })
                        }),
                        (isJoiningBreakout && localSessionId === breakoutHost || !isJoiningBreakout) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {})
                    ]
                }),
                isLocalOwner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomNotification, {}),
                        showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomModal, {
                            onClose: handleModalClose
                        })
                    ]
                }),
                breakoutHost === localSessionId && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutHostHelpNotification, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Snackbar/* SnackbarPresenter */.O9, {
                    style: {
                        right: "".concat(addExtraSpaceForSnackbars ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) + 8 : 8, "px")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals, {}),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "d3d1cbc29d1aca00",
                    dynamic: [
                        colors.custom.mainAreaBg,
                        zIndex.header,
                        (sideBarIsOpen ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) : 0) + (viewMode === "speaker" ? lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF : 0) + 100
                    ],
                    children: ".call.__jsx-style-dynamic-selector{background:".concat(colors.custom.mainAreaBg, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100vh;padding-bottom:59px;position:relative;width:100vw}.main.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:auto;-moz-box-flex:1;-ms-flex:auto;flex:auto;height:100%;min-height:0;overflow:hidden;position:relative}.main.__jsx-style-dynamic-selector .fullscreen-button{left:8px;position:fixed;top:-webkit-calc(var(--header-height) + 8px);top:-moz-calc(var(--header-height) + 8px);top:calc(var(--header-height) + 8px);z-index:").concat(zIndex.header, "}.reactions.__jsx-style-dynamic-selector{bottom:0;position:absolute;right:").concat((sideBarIsOpen ? Number(lib_constants/* SIDEBAR_WIDTH */.ZR) : 0) + (viewMode === "speaker" ? lib_constants/* SPEAKER_PARTICIPANT_BAR_WIDTH */.sF : 0) + 100, "px}")
                })
            ]
        });
    }, [
        addExtraSpaceForSnackbars,
        breakoutHost,
        colors.custom.mainAreaBg,
        enableEmojiReactions,
        handleModalClose,
        isJoiningBreakout,
        isLocalOwner,
        localSessionId,
        orderedParticipantIds,
        poweredByDaily,
        showFullscreenButton,
        showModal,
        sideBarIsOpen,
        viewMode,
        zIndex.header, 
    ]);
};

;// CONCATENATED MODULE: ./components/Call/index.ts


;// CONCATENATED MODULE: ./components/Haircheck/LockedMessage.tsx






var LockedMessage = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
        align: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            align: "center",
            gap: 4,
            horizontal: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockIcon.LockIcon, {
                    color: colors.supportiveText,
                    size: 16
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    textAlign: "center",
                    children: t("haircheck.setup.lockedByOwner")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/NameForm.tsx
function NameForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function NameForm_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function NameForm_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function NameForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function NameForm_slicedToArray(arr, i) {
    return NameForm_arrayWithHoles(arr) || NameForm_iterableToArrayLimit(arr, i) || NameForm_unsupportedIterableToArray(arr, i) || NameForm_nonIterableRest();
}
function NameForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return NameForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return NameForm_arrayLikeToArray(o, minLen);
}



















var NameForm = function(param) {
    var onComplete = param.onComplete;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var preJoinNonAuthorized = (0,CallProvider/* useCallState */.oz)().preJoinNonAuthorized;
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var ref = NameForm_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var colors = (0,Theme.useTheme)().colors;
    var ref1 = (0,react.useState)(""), username = ref1[0], setUsername = ref1[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var localUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "user_name");
    var ref2 = useSoundLoader(), loadSounds = ref2.load;
    (0,react.useEffect)(function() {
        setUsername(localUserName || "");
    }, [
        localUserName
    ]);
    var handleChange = function(ev) {
        setUsername(ev.target.value);
    };
    var handleSubmit = function() {
        loadSounds();
        onComplete(username);
    };
    var textVariantStrong = (0,react.useMemo)(function() {
        return isMobile ? "largestrong" : "strong";
    }, [
        isMobile
    ]);
    var disabled = (0,react.useMemo)(function() {
        return username.length === 0;
    }, [
        username
    ]);
    var subtitle = (0,react.useMemo)(function() {
        /**
     * Owner only broadcast calls have different copy for owners
     * and attendees. Non-OOB calls have different copy based
     * on room privacy settings.
     */ switch(broadcastRole){
            case "attendee":
                return preJoinNonAuthorized ? t("haircheck.nameForm.broadcastViewerPrivate") : t("haircheck.nameForm.broadcastViewerPublic");
            case "owner":
                return t("haircheck.nameForm.broadcastOwner");
            default:
                return preJoinNonAuthorized ? t("haircheck.nameForm.subtitlePrivate") : t("haircheck.nameForm.subtitle");
        }
    }, [
        broadcastRole,
        preJoinNonAuthorized,
        t
    ]);
    var buttonText = (0,react.useMemo)(function() {
        if (broadcastRole === "attendee") {
            return preJoinNonAuthorized ? t("haircheck.setup.requestToJoin") : t("general.joinMeeting");
        }
        return t("general.continue");
    }, [
        broadcastRole,
        preJoinNonAuthorized,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
        gap: 24,
        className: "card-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                style: {
                    padding: "24px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
                    onSubmit: handleSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                gap: 8,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        variant: "largestrong",
                                        El: "label",
                                        htmlFor: "username",
                                        children: preJoinNonAuthorized ? t("haircheck.nameForm.titlePrivate") : t("haircheck.nameForm.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        variant: textVariant,
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                                gap: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    autoFocus: true,
                                    className: robotsClassName("input-name"),
                                    id: "username",
                                    name: "username",
                                    maxLength: 80,
                                    onChange: handleChange,
                                    size: 52,
                                    value: username,
                                    style: isMobile ? {
                                        fontSize: (0,pxToRem.pxToRem)(16),
                                        height: 48
                                    } : {}
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                                id: "name-form-continue",
                                className: robotsClassName("btn-continue"),
                                disabled: disabled,
                                type: "submit",
                                fullWidth: true,
                                style: isMobile ? {
                                    padding: "10px 16px 12px"
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: textVariantStrong,
                                    El: "span",
                                    style: {
                                        color: disabled ? colors.supportiveText : colors.accentText
                                    },
                                    children: buttonText
                                })
                            }),
                            preJoinNonAuthorized && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {})
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/OwnerOnlyBroadcastWaiting.tsx









var OwnerOnlyBroadcastWaiting = function(param) {
    var onCancelJoinRequest = param.onCancelJoinRequest;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
        className: "card-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "center",
                    gap: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "largestrong",
                            children: t("haircheck.setup.titleWaiting")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "muted",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                                onClick: onCancelJoinRequest,
                                underline: true,
                                className: robotsClassName("btn-cancel-request"),
                                children: t("haircheck.setup.cancelRequest")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {})
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/ChatIcon.js
var ChatIcon = __webpack_require__(1814);
;// CONCATENATED MODULE: ./hooks/useHandRaisingBadgeStatus.ts
function useHandRaisingBadgeStatus_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useHandRaisingBadgeStatus_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useHandRaisingBadgeStatus_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useHandRaisingBadgeStatus_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useHandRaisingBadgeStatus_slicedToArray(arr, i) {
    return useHandRaisingBadgeStatus_arrayWithHoles(arr) || useHandRaisingBadgeStatus_iterableToArrayLimit(arr, i) || useHandRaisingBadgeStatus_unsupportedIterableToArray(arr, i) || useHandRaisingBadgeStatus_nonIterableRest();
}
function useHandRaisingBadgeStatus_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useHandRaisingBadgeStatus_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useHandRaisingBadgeStatus_arrayLikeToArray(o, minLen);
}





var useHandRaisingBadgeStatus = function() {
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref = useHandRaisingBadgeStatus_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sidebarView = ref[0];
    var handRaisedParticipants = useHandRaising().handRaisedParticipants;
    var previousHandRaisedParticipants = (0,usePreviousValue/* usePreviousValue */.z)(handRaisedParticipants);
    var lastHandRaiserId = handRaisedParticipants[(handRaisedParticipants === null || handRaisedParticipants === void 0 ? void 0 : handRaisedParticipants.length) - 1];
    var ref1 = (0,react.useState)(false), handRaiseBadgeStatus = ref1[0], setHandRaiseBadgeStatus = ref1[1];
    (0,react.useEffect)(function() {
        // Show the badge when the queue's length has increased,
        // and when the hand raiser is not the local participant
        if ((handRaisedParticipants === null || handRaisedParticipants === void 0 ? void 0 : handRaisedParticipants.length) > (previousHandRaisedParticipants === null || previousHandRaisedParticipants === void 0 ? void 0 : previousHandRaisedParticipants.length) && lastHandRaiserId !== localSessionId) {
            setHandRaiseBadgeStatus(true);
        }
        // don't show the badge when the People panel is opened
        if (sidebarView === "people") {
            setHandRaiseBadgeStatus(false);
        }
        // Immediately hide the badge when there are no hand raisers
        if (handRaisedParticipants.length === 0) {
            setHandRaiseBadgeStatus(false);
        }
    }, [
        handRaisedParticipants === null || handRaisedParticipants === void 0 ? void 0 : handRaisedParticipants.length,
        previousHandRaisedParticipants === null || previousHandRaisedParticipants === void 0 ? void 0 : previousHandRaisedParticipants.length,
        lastHandRaiserId,
        localSessionId,
        sidebarView, 
    ]);
    return handRaiseBadgeStatus;
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/NoiseCancellationIcon.js
var NoiseCancellationIcon = __webpack_require__(3906);
;// CONCATENATED MODULE: ./contexts/MediaDeviceProvider.tsx
function MediaDeviceProvider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MediaDeviceProvider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MediaDeviceProvider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MediaDeviceProvider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MediaDeviceProvider_slicedToArray(arr, i) {
    return MediaDeviceProvider_arrayWithHoles(arr) || MediaDeviceProvider_iterableToArrayLimit(arr, i) || MediaDeviceProvider_unsupportedIterableToArray(arr, i) || MediaDeviceProvider_nonIterableRest();
}
function MediaDeviceProvider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MediaDeviceProvider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MediaDeviceProvider_arrayLikeToArray(o, minLen);
}







var noop = function() {};
var REREQUEST_INTERVAL = 2000;
var MediaDeviceContext = /*#__PURE__*/ (0,react.createContext)({
    promptForAccess: noop
});
var MediaDeviceProvider = function(param) {
    var children = param.children;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref5 = (0,CallProvider/* useCallState */.oz)(), disableAudio = ref5.disableAudio, mode = ref5.mode, state = ref5.state;
    var room = (0,daily_react_esm/* useRoom */.NW)();
    var ref1 = MediaDeviceProvider_slicedToArray(useDeviceInUseModal(), 2), setShowDeviceInUseModal = ref1[1];
    var ref2 = MediaDeviceProvider_slicedToArray(useDeviceNotFoundModal(), 2), setShowDeviceNotFoundModal = ref2[1];
    var ref3 = MediaDeviceProvider_slicedToArray(useUnblockPermissionsModal(), 2), showUnblockPermissionsModal = ref3[0], setShowUnblockPermissionsModal = ref3[1];
    var ref4 = (0,daily_react_esm/* useDevices */.Ls)(), camState = ref4.camState, micState = ref4.micState;
    /**
     * Clean up modals, when errors are resolved.
     */ (0,react.useEffect)(function() {
        if (camState !== "blocked" && micState !== "blocked") {
            setShowUnblockPermissionsModal(false);
        }
        if (camState !== "in-use" && micState !== "in-use") {
            setShowDeviceInUseModal(false);
        }
        if (camState !== "not-found" && micState !== "not-found") {
            setShowDeviceNotFoundModal(false);
        }
    }, [
        camState,
        micState,
        setShowDeviceInUseModal,
        setShowDeviceNotFoundModal,
        setShowUnblockPermissionsModal, 
    ]);
    /**
     * Automatically show modal when selected device is in use.
     */ (0,react.useEffect)(function() {
        if (state !== "joined" || camState !== "in-use") return;
        setShowDeviceInUseModal(true);
    }, [
        camState,
        setShowDeviceInUseModal,
        state
    ]);
    var promptForAccess = (0,react.useCallback)(function() {
        if ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) {
            if (mode === "direct-link") {
                if (showUnblockPermissionsModal) {
                    window.location.reload();
                } else {
                    setShowUnblockPermissionsModal(true);
                }
            } else {
                if (!(0,browserConfig/* isIOSMobile */.eS)() || (0,browserConfig/* isSafari */.G6)(14)) {
                    var openModal = true;
                    var openTimeout = setTimeout(function() {
                        openModal = false;
                    }, 1500);
                    daily.once("camera-error", function() {
                        if (openModal) {
                            setShowUnblockPermissionsModal(true);
                            clearTimeout(openTimeout);
                        }
                    });
                }
                daily.setLocalVideo(true);
                if (!disableAudio) daily.setLocalAudio(true);
            }
        } else {
            setShowUnblockPermissionsModal(true);
        }
    }, [
        daily,
        disableAudio,
        mode,
        setShowUnblockPermissionsModal,
        showUnblockPermissionsModal, 
    ]);
    var browser = (0,react.useMemo)(function() {
        return es5_default().parse(navigator.userAgent);
    }, []);
    /**
     * Automatically re-request cam access.
     */ (0,react.useEffect)(function() {
        if (!daily || !room) return;
        var interval;
        switch(camState){
            case "in-use":
                var ref6;
                if ((browser === null || browser === void 0 ? void 0 : (ref6 = browser.browser) === null || ref6 === void 0 ? void 0 : ref6.name) === "Firefox") return;
            case "blocked":
                if ((0,browserConfig/* isSafari */.G6)() || (0,browserConfig/* isIOSMobile */.eS)()) return;
                interval = setInterval(function() {
                    try {
                        daily.setLocalVideo(true);
                        if (!disableAudio) {
                            var ref;
                            daily.setLocalAudio(true);
                            if (room === null || room === void 0 ? void 0 : (ref = room.config) === null || ref === void 0 ? void 0 : ref.start_audio_off) {
                                daily.setLocalAudio(false);
                            }
                        }
                    } catch (e) {}
                }, REREQUEST_INTERVAL);
                break;
            default:
                break;
        }
        return function() {
            clearInterval(interval);
        };
    }, [
        browser,
        camState,
        daily,
        disableAudio,
        room
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaDeviceContext.Provider, {
        value: {
            promptForAccess: promptForAccess
        },
        children: children
    });
};
var useMediaDevices = function() {
    return (0,react.useContext)(MediaDeviceContext);
};

;// CONCATENATED MODULE: ./components/Tray/constant.ts
var TOOLTIP_DELAY = 800;
var ACTION_CUSTOM_BUTTON_CLICK = "custom-button-click";

;// CONCATENATED MODULE: ./components/Tray/ToggleText.tsx





var ToggleText = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, offText = param.offText, _on = param.on, on = _on === void 0 ? false : _on, onText = param.onText;
    var onRef = (0,react.useRef)(null);
    var offRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (!onRef.current || !offRef.current) return;
        (ref = offRef.current) === null || ref === void 0 ? void 0 : ref.classList.remove("short");
        (ref1 = onRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("short");
        var ref4 = (ref2 = onRef.current) === null || ref2 === void 0 ? void 0 : ref2.firstElementChild.getBoundingClientRect(), onWidth = ref4.width;
        var ref5 = (ref3 = offRef.current) === null || ref3 === void 0 ? void 0 : ref3.firstElementChild.getBoundingClientRect(), offWidth = ref5.width;
        if (onWidth < offWidth) {
            var ref6;
            (ref6 = onRef.current) === null || ref6 === void 0 ? void 0 : ref6.classList.add("short");
        } else {
            var ref7;
            (ref7 = offRef.current) === null || ref7 === void 0 ? void 0 : ref7.classList.add("short");
        }
    }, [
        onRef,
        offRef,
        onText,
        offText,
        on
    ]);
    var color = disabled ? "muted" : "default";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-574ee7463e7212" + " " + (classnames_default()({
            on: on
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: onRef,
                className: "jsx-574ee7463e7212" + " " + "onText",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "span",
                    color: color,
                    children: onText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: offRef,
                className: "jsx-574ee7463e7212" + " " + "offText",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    El: "span",
                    color: color,
                    children: offText
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "574ee7463e7212",
                children: "div.jsx-574ee7463e7212{position:relative;white-space:nowrap}div.jsx-574ee7463e7212 .onText.jsx-574ee7463e7212{visibility:hidden}div.on.jsx-574ee7463e7212 .offText.jsx-574ee7463e7212{visibility:hidden}div.on.jsx-574ee7463e7212 .onText.jsx-574ee7463e7212{visibility:visible}div.jsx-574ee7463e7212 .short.jsx-574ee7463e7212{left:50%;position:absolute;top:0;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%)}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Tray/TrayBadge.tsx




var TrayBadge = function(param) {
    var color = param.color, _top = param.top, top = _top === void 0 ? 4 : _top, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _visible = param.visible, visible = _visible === void 0 ? false : _visible;
    var colors = (0,Theme.useTheme)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "5c12c5cccf41388e",
                [
                    colors.system.white,
                    top
                ]
            ]
        ]) + " " + "tray-badge",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    background: color
                },
                className: styled_jsx_default().dynamic([
                    [
                        "5c12c5cccf41388e",
                        [
                            colors.system.white,
                            top
                        ]
                    ]
                ]) + " " + (classnames_default()("badge", variant, {
                    visible: visible
                }) || "")
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5c12c5cccf41388e",
                dynamic: [
                    colors.system.white,
                    top
                ],
                /*#__PURE__*/ children: ".tray-badge.__jsx-style-dynamic-selector{display:block}.tray-badge.__jsx-style-dynamic-selector .badge{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:12px;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:4px;-webkit-transform:scale(0);-moz-transform:scale(0);-ms-transform:scale(0);-o-transform:scale(0);transform:scale(0);-webkit-transform-origin:center;-moz-transform-origin:center;-ms-transform-origin:center;-o-transform-origin:center;transform-origin:center;-webkit-transition:-webkit-transform 250ms ease;-moz-transition:-moz-transform 250ms ease;-o-transition:-o-transform 250ms ease;transition:-webkit-transform 250ms ease;transition:-moz-transform 250ms ease;transition:-o-transform 250ms ease;transition:transform 250ms ease;width:12px}.tray-badge.__jsx-style-dynamic-selector .badge::after{background:".concat(colors.system.white, ';-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;content:"";height:4px;width:4px}.tray-badge.__jsx-style-dynamic-selector .badge.default{left:50%;position:absolute;top:').concat(top, "px}.tray-badge.__jsx-style-dynamic-selector .badge.inline{margin:2px;position:relative}.tray-badge.__jsx-style-dynamic-selector .badge.visible{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Tray/TrayButton.tsx
function TrayButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TrayButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TrayButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TrayButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = TrayButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function TrayButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var TrayButton = function(_param) {
    var _badge = _param.badge, badge = _badge === void 0 ? null : _badge, children = _param.children, className = _param.className, _visible = _param.visible, visible = _visible === void 0 ? true : _visible, props = TrayButton_objectWithoutProperties(_param, [
        "badge",
        "children",
        "className",
        "visible"
    ]);
    var ref = (0,Theme.useTheme)(), colors = ref.colors, mediaQueries = ref.mediaQueries;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", TrayButton_objectSpread({
        type: "button"
    }, props, {
        onTouchStart: function(e) {
            return e.stopPropagation();
        },
        className: styled_jsx_default().dynamic([
            [
                "572d5de4dfc1ba27",
                [
                    mediaQueries.nonCoarse,
                    colors.backgroundAccent
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()(className, {
            visible: visible
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                align: "center",
                gap: 2,
                /*#__PURE__*/ children: children
            }),
            badge && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, TrayButton_objectSpread({}, badge)),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "572d5de4dfc1ba27",
                dynamic: [
                    mediaQueries.nonCoarse,
                    colors.backgroundAccent
                ],
                children: "button.__jsx-style-dynamic-selector{background:transparent;border:none;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;color:inherit;margin:-4px 0;padding:4px 8px;position:relative;-webkit-transition:background 250ms ease;-moz-transition:background 250ms ease;-o-transition:background 250ms ease;transition:background 250ms ease}button.__jsx-style-dynamic-selector:focus{outline:none}@media ".concat(mediaQueries.nonCoarse, "{button.__jsx-style-dynamic-selector:focus-visible:not([disabled]),button.__jsx-style-dynamic-selector:hover:not([disabled]){background:").concat(colors.backgroundAccent, "}}button.__jsx-style-dynamic-selector:focus-visible:not([disabled]){-webkit-box-shadow:0 0 0 2px var(--focus-shadow);-moz-box-shadow:0 0 0 2px var(--focus-shadow);box-shadow:0 0 0 2px var(--focus-shadow)}button.__jsx-style-dynamic-selector:not([disabled]){cursor:pointer}button.__jsx-style-dynamic-selector:not(.visible){margin:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;visibility:hidden}")
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/Tray/AudioControls.tsx
function AudioControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AudioControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AudioControls_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AudioControls_arrayLikeToArray(arr);
}
function AudioControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AudioControls_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AudioControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AudioControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AudioControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AudioControls_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AudioControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AudioControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AudioControls_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AudioControls_slicedToArray(arr, i) {
    return AudioControls_arrayWithHoles(arr) || AudioControls_iterableToArrayLimit(arr, i) || AudioControls_unsupportedIterableToArray(arr, i) || AudioControls_nonIterableRest();
}
function AudioControls_toConsumableArray(arr) {
    return AudioControls_arrayWithoutHoles(arr) || AudioControls_iterableToArray(arr) || AudioControls_unsupportedIterableToArray(arr) || AudioControls_nonIterableSpread();
}
function AudioControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AudioControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AudioControls_arrayLikeToArray(o, minLen);
}




































var AudioControls = /*#__PURE__*/ (0,react.memo)(function(param) {
    var id = param.id, _shouldEnableAudioMenu = param.shouldEnableAudioMenu, shouldEnableAudioMenu = _shouldEnableAudioMenu === void 0 ? true : _shouldEnableAudioMenu;
    var ref9 = (0,Theme.useTheme)(), colors = ref9.colors, mediaQueries = ref9.mediaQueries;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = AudioControls_slicedToArray(useDeviceInUseModal(), 2), setShowDeviceInUseModal = ref1[1];
    var ref2 = AudioControls_slicedToArray(useDeviceNotFoundModal(), 2), setShowDeviceNotFoundModal = ref2[1];
    var ref3 = AudioControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref3[0];
    var ref4 = AudioControls_slicedToArray((0,layout/* useMobileTray */.UX)(), 1), showMobileTray = ref4[0];
    var ref5 = AudioControls_slicedToArray(useSettingsView(), 2), setSettingsView = ref5[1];
    var promptForAccess = useMediaDevices().promptForAccess;
    var ref6 = (0,daily_react_esm/* useDevices */.Ls)(), hasMicError = ref6.hasMicError, microphones = ref6.microphones, micState = ref6.micState, setMicrophone = ref6.setMicrophone, setSpeaker = ref6.setSpeaker, speakers = ref6.speakers;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var audioTrackState = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "tracks.audio.state");
    var muted = (0,react.useMemo)(function() {
        return (0,lib_participants/* isTrackOff */.$T)(audioTrackState) || hasMicError;
    }, [
        hasMicError,
        audioTrackState
    ]);
    var hasHandUp = useHasHandRaised(localSessionId);
    var lowerHand = useHandRaising().lowerHand;
    var isDesktop = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var ref7 = (0,react.useState)(false), /*#__PURE__*/ showAudioMenu = ref7[0], setShowAudioMenu = ref7[1];
    var enableNoiseCancellationUI = (0,useCallConfig/* useCallConfig */.A)().enableNoiseCancellationUI;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref8 = useAudioProcessor(), handleNoiseCancellationChange = ref8.handleNoiseCancellationChange, noiseCancellationDisabled = ref8.noiseCancellationDisabled, noiseCancellationOn = ref8.noiseCancellationOn;
    var handleNoiseToggleChange = (0,react.useCallback)(function(event) {
        handleNoiseCancellationChange(event.target.checked);
        addMessage({
            content: event.target.checked ? t("audio.noiseCancellationOn") : t("audio.noiseCancellationOff")
        });
    }, [
        addMessage,
        handleNoiseCancellationChange,
        t
    ]);
    /**
     * Setup media session event handler and map muted state.
     */ (0,react.useEffect)(function() {
        var ref;
        if (!daily || // @ts-ignore
        typeof ((ref = navigator.mediaSession) === null || ref === void 0 ? void 0 : ref.setMicrophoneActive) !== "function") return;
        // @ts-ignore
        navigator.mediaSession.setMicrophoneActive(!muted);
        var handleToggleMic = function() {
            if (hasMicError) return;
            daily.setLocalAudio(muted);
        };
        try {
            navigator.mediaSession.setActionHandler("togglemicrophone", handleToggleMic);
        } catch (e) {}
    }, [
        daily,
        hasMicError,
        muted
    ]);
    var toggleMic = (0,react.useCallback)(function() {
        switch(micState){
            case "blocked":
                promptForAccess();
                break;
            case "in-use":
                setShowDeviceInUseModal(true);
                break;
            case "not-found":
                setShowDeviceNotFoundModal(true);
                break;
            default:
                daily.setLocalAudio(muted);
                // If the participant has their hand up and unmutes themselves,
                // we want to lower their hand automatically.
                if (hasHandUp && muted) {
                    lowerHand();
                }
                break;
        }
    }, [
        micState,
        promptForAccess,
        setShowDeviceInUseModal,
        setShowDeviceNotFoundModal,
        daily,
        muted,
        hasHandUp,
        lowerHand, 
    ]);
    var ctrlKey =  true && navigator.platform.startsWith("Mac") ? "Cmd" : "Ctrl";
    (0,react.useEffect)(function() {
        var unsubscribe = (0,tinykeys_module/* default */.Z)(window, {
            "$mod+KeyD": function(ev) {
                toggleMic();
                ev.preventDefault();
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        toggleMic
    ]);
    var handleMicClick = (0,react.useCallback)(function() {
        var _ref = AudioControls_asyncToGenerator(runtime_default().mark(function _callee(mic) {
            var lastMic;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowAudioMenu(false);
                        if (!mic.selected) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        lastMic = microphones.find(function(m) {
                            return m.selected;
                        });
                        try {
                            // optimistic UI update
                            setMicrophone === null || setMicrophone === void 0 ? void 0 : setMicrophone(mic.device.deviceId);
                        } catch (e) {
                            setMicrophone === null || setMicrophone === void 0 ? void 0 : setMicrophone(lastMic.device.deviceId);
                        // reset to last known device in case switching failed
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(mic) {
            return _ref.apply(this, arguments);
        };
    }(), [
        microphones,
        setMicrophone
    ]);
    var handleSpeakerClick = (0,react.useCallback)(function() {
        var _ref = AudioControls_asyncToGenerator(runtime_default().mark(function _callee(speaker) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowAudioMenu(false);
                        if (!speaker.selected) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setSpeaker === null || setSpeaker === void 0 ? void 0 : setSpeaker(speaker.device.deviceId);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(speaker) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setSpeaker
    ]);
    var handleMenuOpen = function() {
        setShowAudioMenu(true);
    };
    var handleMenuClose = function() {
        setShowAudioMenu(false);
    };
    var handleSettingsClick = (0,react.useCallback)(function() {
        setSettingsView("devices");
        setShowAudioMenu(false);
    }, [
        setSettingsView
    ]);
    var isSupported = micState !== "not-supported";
    var mobileDisabled = isMobile && !showMobileTray;
    var enableAudioMenu = shouldEnableAudioMenu && !isMobile && isSupported && micState !== "pending";
    var btnText = (0,react.useMemo)(function() {
        switch(micState){
            case "pending":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("audio.microphone")
                });
            case "blocked":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("general.allow")
                });
            case "in-use":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("audio.inUse")
                });
            case "not-found":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("audio.noMic")
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                    on: !muted,
                    onText: t("audio.mute"),
                    offText: t("audio.unmute")
                });
        }
    }, [
        micState,
        muted,
        t
    ]);
    var menuItems = (0,react.useMemo)(function() {
        var items = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    align: "center",
                    gap: 4,
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                            size: 16
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "strong",
                            style: {
                                display: "block",
                                margin: "-1px 0 1px"
                            },
                            children: t("audio.microphone")
                        })
                    ]
                }),
                static: true
            }, 
        ];
        if (micState === "not-found") {
            items.push({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                    color: colors.system.red,
                    size: 16
                }),
                label: t("audio.noMicrophone"),
                onClick: function() {
                    toggleMic();
                    setShowAudioMenu(false);
                }
            });
        } else {
            var _items;
            microphones.length ? (_items = items).push.apply(_items, AudioControls_toConsumableArray(microphones.map(function(mic, index) {
                return {
                    className: robotsClassName("mic-device"),
                    disabled: mic.state === "in-use",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                        id: mic.device.deviceId,
                        name: mic.device.deviceId,
                        checked: mic.selected,
                        readOnly: true,
                        tabIndex: -1
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        horizontal: true,
                        children: [
                            mic.state === "in-use" && /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                                color: colors.system.red,
                                size: 16
                            }),
                            mic.device.label || "".concat(t("audio.microphoneWithNumber", {
                                number: index + 1
                            }))
                        ]
                    }),
                    onClick: function() {
                        return handleMicClick(mic);
                    }
                };
            }))) : items.push({
                label: t("audio.unmuteToAllowAccess"),
                static: true
            });
        }
        items.push({
            divider: true
        }, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                gap: 4,
                horizontal: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioIcon/* AudioIcon */.f, {
                        size: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "strong",
                        style: {
                            display: "block",
                            margin: "-1px 0 1px"
                        },
                        children: t("audio.speakers")
                    })
                ]
            }),
            static: true
        });
        if (speakers.length > 0) {
            var _items1;
            (_items1 = items).push.apply(_items1, AudioControls_toConsumableArray(speakers.map(function(speaker, index) {
                return {
                    className: robotsClassName("speaker-device"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                        id: speaker.device.deviceId,
                        name: speaker.device.deviceId,
                        checked: speaker.selected,
                        readOnly: true,
                        tabIndex: -1
                    }),
                    label: speaker.device.label || "".concat(t("audio.speakers_{number}", {
                        number: index + 1
                    })),
                    onClick: function() {
                        return handleSpeakerClick(speaker);
                    }
                };
            })));
        } else {
            items.push({
                className: robotsClassName("speaker-device"),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                    id: "system-default",
                    name: "system-default",
                    checked: true,
                    readOnly: true,
                    tabIndex: -1
                }),
                label: t("audio.systemDefault"),
                onClick: function() {
                    return setShowAudioMenu(false);
                }
            });
        }
        items.push({
            divider: true
        });
        if (enableNoiseCancellationUI && !(0,browserConfig/* isSafari */.G6)()) {
            var checkboxId = "cancel-noise";
            items.push({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxToggle/* CheckboxToggle */.p, {
                        checked: noiseCancellationOn,
                        id: checkboxId,
                        onChange: function(event) {
                            return handleNoiseToggleChange(event);
                        },
                        name: checkboxId,
                        checkedLabel: "",
                        uncheckedLabel: "",
                        value: "1",
                        disabled: noiseCancellationDisabled
                    })
                }),
                HrefComponent: "label",
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "noise-cancellation-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NoiseCancellationIcon/* NoiseCancellationIcon */.n, {}),
                        " ",
                        t("audio.enableNoiseCancellation")
                    ]
                }),
                // @ts-ignore
                htmlFor: checkboxId
            });
        }
        items.push({
            label: t("audio.settings"),
            onClick: handleSettingsClick
        });
        return items;
    }, [
        colors.system.red,
        enableNoiseCancellationUI,
        handleMicClick,
        handleNoiseToggleChange,
        handleSettingsClick,
        handleSpeakerClick,
        micState,
        microphones,
        noiseCancellationDisabled,
        noiseCancellationOn,
        speakers,
        t,
        toggleMic, 
    ]);
    var isTooltipDisabled = // Dedicated mobile view
    isMobile || // Responsive view on mobile-ish viewport size
    !isDesktop || // Unsupported browser
    !isSupported || // Pending device access
    micState === "pending" || // Error state
    hasMicError;
    var isButtonDisabled = // Unsupported browser
    !isSupported || // Disabled on mobile (hidden tray)
    mobileDisabled || // Pending device access
    micState === "pending";
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "7c1482f641722f2",
                [
                    mediaQueries.nonCoarse,
                    colors.system.red,
                    colors.backgroundAccent
                ]
            ]
        ]) + " " + (classnames_default()("audio-controls", {
            muted: muted,
            audioMenu: shouldEnableAudioMenu
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                delay: TOOLTIP_DELAY,
                disabled: isTooltipDisabled,
                id: "tt-audio-controls",
                title: "".concat(ctrlKey, " + D"),
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                    className: classnames_default()("btn", (_obj = {}, AudioControls_defineProperty(_obj, robotsClassName("btn-mic-mute"), !muted), AudioControls_defineProperty(_obj, robotsClassName("btn-mic-unmute"), muted), _obj)),
                    id: id,
                    disabled: isButtonDisabled,
                    onClick: toggleMic,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                            className: classnames_default()("icon", {
                                disabled: isButtonDisabled
                            }),
                            color: muted ? colors.system.white : "currentColor",
                            id: "AudioControls",
                            muted: muted,
                            transition: true
                        }),
                        btnText
                    ]
                })
            }),
            enableAudioMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.MenuButton, {
                "aria-controls": "audio-menu",
                className: robotsClassName("btn-audio-devices"),
                id: "audio-menu-btn",
                onClick: handleMenuOpen,
                open: showAudioMenu,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownIcon.CaretDownIcon, {
                        size: 16,
                        variant: "default"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: t("audio.selectAudioDevices")
                    })
                ]
            }),
            showAudioMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "left",
                "aria-labelledby": "audio-menu-btn",
                className: robotsClassName("audio-devices-menu"),
                edgeSpacing: 16,
                id: "audio-menu",
                items: menuItems,
                offsetTop: 4,
                onClose: handleMenuClose,
                placement: "top",
                cardListProps: {
                    style: {
                        marginRight: 16,
                        overflow: "auto"
                    }
                }
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "7c1482f641722f2",
                dynamic: [
                    mediaQueries.nonCoarse,
                    colors.system.red,
                    colors.backgroundAccent
                ],
                children: ".audio-controls.__jsx-style-dynamic-selector{position:relative;white-space:nowrap}.audio-controls.__jsx-style-dynamic-selector .btn[disabled]{opacity:.4}.audio-controls.__jsx-style-dynamic-selector .icon.disabled{opacity:-webkit-calc(.3/.4);opacity:-moz-calc(.3/.4);opacity:calc(.3/.4)}@media ".concat(mediaQueries.nonCoarse, "{.audio-controls.audioMenu.__jsx-style-dynamic-selector .btn{min-width:64px;padding:4px 10px}}.audio-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.audio-controls.muted.__jsx-style-dynamic-selector .icon{background:").concat(colors.system.red, "}.audio-controls.__jsx-style-dynamic-selector #audio-menu-btn:focus-visible,.audio-controls.__jsx-style-dynamic-selector #audio-menu-btn:hover{background:").concat(colors.backgroundAccent, '}.audio-controls.__jsx-style-dynamic-selector #audio-menu-btn{-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;padding:2px;position:absolute;right:0;top:-4px;-webkit-transition:background 250ms ease;-moz-transition:background 250ms ease;-o-transition:background 250ms ease;transition:background 250ms ease}.menu-list label[for="cancel-noise"]{padding-left:40px;margin-right:-4px}.noise-cancellation-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}')
            })
        ]
    });
});
AudioControls.displayName = "AudioControls";

;// CONCATENATED MODULE: ./components/Tray/CustomIcon.tsx
function CustomIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomIcon_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CustomIcon_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CustomIcon_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var CustomIcon = function(_param) /*#__PURE__*/ {
    var alt = _param.alt, _padding = _param.padding, padding = _padding === void 0 ? 2 : _padding, src = _param.src, _size = _param.size, size = _size === void 0 ? 24 : _size, _style = _param.style, style = _style === void 0 ? {} : _style, props = CustomIcon_objectWithoutProperties(_param, [
        "alt",
        "padding",
        "src",
        "size",
        "style"
    ]);
    return (0,jsx_runtime.jsx)("img", CustomIcon_objectSpread({
        alt: alt,
        src: src,
        height: size,
        width: size
    }, props, {
        style: CustomIcon_objectSpread({}, style, {
            padding: padding
        })
    }));
};


// EXTERNAL MODULE: ../shared/dist/components/Icons/EmojiReactionsIcon.js
var EmojiReactionsIcon = __webpack_require__(2681);
// EXTERNAL MODULE: ../shared/dist/components/Popover/index.js
var Popover = __webpack_require__(2060);
;// CONCATENATED MODULE: ./components/Tray/EmojiReactionsMenu.tsx
function EmojiReactionsMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EmojiReactionsMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EmojiReactionsMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EmojiReactionsMenu_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = EmojiReactionsMenu_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function EmojiReactionsMenu_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var EmojiReactionsMenu = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var _align = _param.align, align = _align === void 0 ? "left" : _align, onClickReaction = _param.onClickReaction, _onClose = _param.onClose, onClose = _onClose === void 0 ? null : _onClose, props = EmojiReactionsMenu_objectWithoutProperties(_param, [
        "align",
        "onClickReaction",
        "onClose"
    ]);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref = (0,react.useState)(props["aria-labelledby"]), /*#__PURE__*/ ariaLabelledBy = ref[0], setAriaLabelledBy = ref[1];
    (0,useResize.useResize)((0,react.useCallback)(function() {
        var trayButton = document.getElementById(props["aria-labelledby"]);
        setAriaLabelledBy((0,dom.isElementVisibleInViewport)(trayButton) ? props["aria-labelledby"] : "tray-more-btn");
    }, [
        props
    ]));
    var addModifier = (0,useEmojiSkinTone/* useEmojiSkinTone */.v)().addModifier;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover.Popover, EmojiReactionsMenu_objectSpread({
        id: props.id
    }, props, {
        align: align,
        placement: "top",
        onClose: onClose,
        "aria-labelledby": ariaLabelledBy,
        cardProps: {
            noBorder: true,
            spacing: 8,
            shadow: "strong"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", EmojiReactionsMenu_objectSpread({}, props, {
                className: styled_jsx_default().dynamic([
                    [
                        "a978f718b5955e64",
                        [
                            (0,pxToRem.pxToRem)(25)
                        ]
                    ]
                ]) + " " + (props && props.className != null && props.className || "reactions-menu-content"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                    children: availableReactionEmoji.map(function(reaction) {
                        var audienceReaction = addModifier(reaction);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                            className: "reaction",
                            onClick: function() {
                                return onClickReaction(audienceReaction);
                            },
                            variant: "ghost",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "a978f718b5955e64",
                                            [
                                                (0,pxToRem.pxToRem)(25)
                                            ]
                                        ]
                                    ]) + " " + "reactions-menu-button-reactions",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                                        animation: "local",
                                        emojiSize: 25,
                                        exclusiveEmoji: audienceReaction,
                                        sessionIds: [
                                            localSessionId
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    El: "span",
                                    variant: "large",
                                    children: audienceReaction
                                })
                            ]
                        }, audienceReaction);
                    })
                })
            })),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "a978f718b5955e64",
                dynamic: [
                    (0,pxToRem.pxToRem)(25)
                ],
                children: ".reactions-menu-content.__jsx-style-dynamic-selector .card-content{background:var(--menu-bg);-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:4px;height:auto;width:auto}.reactions-menu-content.__jsx-style-dynamic-selector .reaction{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.reactions-menu-content.__jsx-style-dynamic-selector{overflow:hidden}.reactions-menu-content.__jsx-style-dynamic-selector .reaction span{font-size:".concat((0,pxToRem.pxToRem)(25), "}.reactions-menu-content.__jsx-style-dynamic-selector .reactions-menu-button-reactions.__jsx-style-dynamic-selector{left:50%;pointer-events:none;position:absolute;top:50%;-webkit-transform:translate(50%,50%);-moz-transform:translate(50%,50%);-ms-transform:translate(50%,50%);-o-transform:translate(50%,50%);transform:translate(50%,50%)}")
            })
        ]
    }));
});

EmojiReactionsMenu.displayName = "EmojiReactionsMenu";

;// CONCATENATED MODULE: ./components/Tray/EmojiReactionControls.tsx
function EmojiReactionControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EmojiReactionControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function EmojiReactionControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EmojiReactionControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function EmojiReactionControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EmojiReactionControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EmojiReactionControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EmojiReactionControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = EmojiReactionControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function EmojiReactionControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function EmojiReactionControls_slicedToArray(arr, i) {
    return EmojiReactionControls_arrayWithHoles(arr) || EmojiReactionControls_iterableToArrayLimit(arr, i) || EmojiReactionControls_unsupportedIterableToArray(arr, i) || EmojiReactionControls_nonIterableRest();
}
function EmojiReactionControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EmojiReactionControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EmojiReactionControls_arrayLikeToArray(o, minLen);
}

















var EmojiReactionControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = EmojiReactionControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var enableEmojiReactions = (0,useCallConfig/* useCallConfig */.A)().enableEmojiReactions;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var sendReaction = useEmojiReactions().sendReaction;
    var ref5 = useShowEmojiReactionsMenu(), setShowEmojiReactionsMenu = ref5.setShowEmojiReactionsMenu, showEmojiReactionsMenu = ref5.showEmojiReactionsMenu;
    var ref1 = EmojiReactionControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var isMobileVP = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var ref2 = EmojiReactionControls_slicedToArray((0,layout/* useMobileTray */.UX)(), 1), showMobileTray = ref2[0];
    var handleButtonClick = function(ev) {
        setShowEmojiReactionsMenu(true);
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    var handleClickReaction = (0,react.useCallback)(function(reaction) {
        // Set custom position for the own emoji during the fly-up animation
        var xPosition;
        var ref;
        var controlsButtonElement = document.getElementById((ref = props === null || props === void 0 ? void 0 : props.id) !== null && ref !== void 0 ? ref : "emoji-reaction-controls");
        xPosition = (0,dom.isElementVisibleInViewport)(controlsButtonElement) ? controlsButtonElement.getBoundingClientRect().x : document.getElementById("tray-more-btn").getBoundingClientRect().x;
        sendReaction(reaction, xPosition);
    }, [
        props === null || props === void 0 ? void 0 : props.id,
        sendReaction
    ]);
    var handleMenuClose = (0,react.useCallback)(function() {
        setShowEmojiReactionsMenu(false);
    }, [
        setShowEmojiReactionsMenu
    ]);
    (0,react.useEffect)(function() {
        if (!showMobileTray) {
            handleMenuClose();
        }
    }, [
        handleMenuClose,
        showMobileTray
    ]);
    if (!enableEmojiReactions) return null;
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "emoji-reaction-controls",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                title: t("emojiReactions.sendReaction"),
                delay: TOOLTIP_DELAY,
                id: "tt-emoji-reaction-controls",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, EmojiReactionControls_objectSpread({
                    className: classnames_default()(className),
                    onClick: handleButtonClick
                }, props, {
                    id: (ref3 = props === null || props === void 0 ? void 0 : props.id) !== null && ref3 !== void 0 ? ref3 : "emoji-reaction-controls",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactionsIcon/* EmojiReactionsIcon */.H, {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            children: t("emojiReactions.react")
                        })
                    ]
                }))
            }),
            showEmojiReactionsMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactionsMenu, {
                align: !isMobile && isMobileVP ? "right" : "center",
                "aria-labelledby": (ref4 = props === null || props === void 0 ? void 0 : props.id) !== null && ref4 !== void 0 ? ref4 : "emoji-reaction-controls",
                id: "emoji-reaction-menu",
                onClickReaction: handleClickReaction,
                onClose: handleMenuClose
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/RaiseHandControls.tsx
function RaiseHandControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RaiseHandControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function RaiseHandControls_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return RaiseHandControls_arrayLikeToArray(arr);
}
function RaiseHandControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function RaiseHandControls_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function RaiseHandControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RaiseHandControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RaiseHandControls_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RaiseHandControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RaiseHandControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RaiseHandControls_slicedToArray(arr, i) {
    return RaiseHandControls_arrayWithHoles(arr) || RaiseHandControls_iterableToArrayLimit(arr, i) || RaiseHandControls_unsupportedIterableToArray(arr, i) || RaiseHandControls_nonIterableRest();
}
function RaiseHandControls_toConsumableArray(arr) {
    return RaiseHandControls_arrayWithoutHoles(arr) || RaiseHandControls_iterableToArray(arr) || RaiseHandControls_unsupportedIterableToArray(arr) || RaiseHandControls_nonIterableSpread();
}
function RaiseHandControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RaiseHandControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RaiseHandControls_arrayLikeToArray(o, minLen);
}





















var RaiseHandControls = function(_param) {
    var props = _extends({}, _param);
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var colors = (0,Theme.useTheme)().colors;
    var ref2 = RaiseHandControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref2[0];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var enableHandRaising = (0,useCallConfig/* useCallConfig */.A)().enableHandRaising;
    var ref1 = useHandRaising(), handRaisedParticipants = ref1.handRaisedParticipants, lowerHand = ref1.lowerHand, raiseHand = ref1.raiseHand;
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var isHandRaised = useHasHandRaised(localSessionId);
    var raisedHandQueue = (0,react.useRef)([]);
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var prevRaisedHands = (0,usePreviousValue/* usePreviousValue */.z)(handRaisedParticipants);
    (0,react.useEffect)(function() {
        var _current;
        var participants = Object.values(daily.participants());
        var newHands = handRaisedParticipants.filter(function(id) {
            return !(prevRaisedHands === null || prevRaisedHands === void 0 ? void 0 : prevRaisedHands.includes(id)) && id !== localSessionId;
        }).map(function(id) {
            return {
                session_id: id,
                /*#__PURE__*/ username: participants === null || participants === void 0 ? void 0 : participants.find(function(p) {
                    return p.session_id === id;
                }).user_name
            };
        });
        (_current = raisedHandQueue.current).push.apply(_current, RaiseHandControls_toConsumableArray(newHands));
        var removedHands = (prevRaisedHands !== null && prevRaisedHands !== void 0 ? prevRaisedHands : []).filter(function(id) {
            return !handRaisedParticipants.includes(id);
        });
        raisedHandQueue.current = raisedHandQueue.current.filter(function(param) {
            var session_id = param.session_id;
            return !removedHands.includes(session_id);
        });
    }, [
        daily,
        handRaisedParticipants,
        localSessionId,
        prevRaisedHands
    ]);
    (0,react.useLayoutEffect)(function setupSnackbarInterval() {
        var interval = setInterval(function() {
            if (!raisedHandQueue.current.length) return;
            var message;
            if (raisedHandQueue.current.length === 1) {
                var ref;
                var userName = (ref = raisedHandQueue.current.pop()) === null || ref === void 0 ? void 0 : ref.username;
                message = t("handRaising.notificationWithUsername", {
                    displayName: userName || t("people.guest")
                });
            } else {
                var count = raisedHandQueue.current.length;
                message = t("handRaising.notificationWithCount", {
                    count: count
                });
                raisedHandQueue.current = [];
            }
            addMessage({
                content: message,
                type: "info",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandIcon/* RaiseHandIcon */.s, {
                    size: 18
                }),
                timeout: 2000
            });
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        addMessage,
        orderedParticipantIds,
        t
    ]);
    (0,daily_react_esm/* useAppMessage */.F3)({
        onAppMessage: (0,react.useCallback)(function(ev) {
            var ref;
            switch(ev === null || ev === void 0 ? void 0 : (ref = ev.data) === null || ref === void 0 ? void 0 : ref.event){
                case "force-lower-hand":
                    var prevUserData = RaiseHandControls_objectSpread({}, (0,lib_userData/* getPrebuiltUserData */.n1)(daily));
                    delete prevUserData[lib_constants/* HAND_RAISED_USER_DATA_KEY */.ON];
                    (0,lib_userData/* setPrebuiltUserData */.T3)(daily, RaiseHandControls_objectSpread({}, prevUserData));
                    // Send a message to the local participant notifying them their hand's been lowered.
                    // When a breakout is ongoing, the host doesn't lower the participant's hand -- the BreakoutProvider does.
                    addMessage({
                        type: "info",
                        content: breakoutStatus === "ongoing" && ev.data.isAutoLowered ? t("notification.handLoweredAutomatically") : t("notification.handLoweredByHost")
                    });
                    break;
            }
        }, [
            addMessage,
            breakoutStatus,
            daily,
            t
        ])
    });
    var buttonClick = function() {
        if (isHandRaised) {
            lowerHand();
        } else {
            raiseHand();
        }
    };
    if (!enableHandRaising) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "79e4f06e2c29c5b7",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + "raisehand-controls",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                disabled: isMobile,
                id: "tt-raisehand-button",
                title: isHandRaised ? t("handRaising.lowerHand") : t("handRaising.raiseHand"),
                placement: "top",
                tabIndex: -1,
                delay: TOOLTIP_DELAY,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, RaiseHandControls_objectSpread({
                    onClick: buttonClick,
                    className: "btn"
                }, props, {
                    children: [
                        isHandRaised ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LowerHandIcon/* LowerHandIcon */.P, {
                            className: "icon",
                            color: colors.system.white
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandIcon/* RaiseHandIcon */.s, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                            on: isHandRaised,
                            onText: t("handRaising.lower"),
                            offText: t("handRaising.raise"),
                            disabled: !enableHandRaising
                        })
                    ]
                }))
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "79e4f06e2c29c5b7",
                dynamic: [
                    colors.system.red
                ],
                children: ".raisehand-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background:".concat(colors.system.red, "}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/RecordControls.tsx
function RecordControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RecordControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function RecordControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecordControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RecordControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RecordControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecordControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RecordControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = RecordControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RecordControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RecordControls_slicedToArray(arr, i) {
    return RecordControls_arrayWithHoles(arr) || RecordControls_iterableToArrayLimit(arr, i) || RecordControls_unsupportedIterableToArray(arr, i) || RecordControls_nonIterableRest();
}
function RecordControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RecordControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RecordControls_arrayLikeToArray(o, minLen);
}





















var RecordControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = RecordControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,useCallConfig/* useCallConfig */.A)(), enableRecording = ref.enableRecording, enableRecordingUI = ref.enableRecordingUI;
    var ref1 = (0,RecordingProvider/* useRecording */.$n)(), startRecording = ref1.startRecording, stopRecording = ref1.stopRecording;
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    var ref2 = RecordControls_slicedToArray((0,recordings/* useRecordingUI */.oZ)(), 1), recordingUIState = ref2[0];
    var ref3 = (0,daily_react_esm/* useRecording */.$n)(), isLocalParticipantRecorded = ref3.isLocalParticipantRecorded, isRecording = ref3.isRecording, local = ref3.local;
    var ref4 = RecordControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref4[0];
    var ref5 = (0,react.useState)(false), /*#__PURE__*/ showRecordingMenu = ref5[0], setShowRecordingMenu = ref5[1];
    var disabled = (0,react.useMemo)(function() {
        return enableRecording === "local" && isRecording && !local || recordingUIState === "saved" || isRecording && !isLocalParticipantRecorded || breakoutStatus === "ongoing";
    }, [
        breakoutStatus,
        enableRecording,
        isLocalParticipantRecorded,
        isRecording,
        local,
        recordingUIState, 
    ]);
    var showAsRecording = isRecording && !disabled;
    var handleButtonClick = function(ev) {
        setShowRecordingMenu(true);
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    var handleMenuItemClick = function() {
        setShowRecordingMenu(false);
        if (showAsRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    };
    var handleMenuClose = function() {
        setShowRecordingMenu(false);
    };
    var tooltipTitle = (0,react.useMemo)(function() {
        if (isMobile) return null;
        if (breakoutStatus === "ongoing") return t("recording.disabledDuringBreakout");
        if (disabled) return t("recording.notAvailable");
        if (isRecording) return t("recording.stopRecording");
        return t("recording.startRecording");
    }, [
        breakoutStatus,
        disabled,
        isMobile,
        isRecording,
        t
    ]);
    if (!enableRecording || !enableRecordingUI) return null;
    var ref6, ref7;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "6144370060377484",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + (classnames_default()("record-controls", {
            active: showAsRecording
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                title: tooltipTitle,
                delay: TOOLTIP_DELAY,
                disabled: !tooltipTitle,
                id: "tt-recording-btn",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, RecordControls_objectSpread({
                    className: classnames_default()(className, (_obj = {}, RecordControls_defineProperty(_obj, robotsClassName("btn-record-disabled"), disabled), RecordControls_defineProperty(_obj, robotsClassName("btn-record-start"), !disabled && !showAsRecording), RecordControls_defineProperty(_obj, robotsClassName("btn-record-stop"), showAsRecording), _obj)),
                    disabled: disabled,
                    onClick: handleButtonClick
                }, props, {
                    id: (ref6 = props === null || props === void 0 ? void 0 : props.id) !== null && ref6 !== void 0 ? ref6 : "recording-btn",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordIcon/* RecordIcon */.A, {
                            className: "icon",
                            color: showAsRecording ? colors.system.white : disabled ? "var(--text-muted)" : "currentColor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                            on: showAsRecording,
                            onText: t("recording.stop"),
                            offText: t("recording.start"),
                            disabled: disabled
                        })
                    ]
                }))
            }),
            showRecordingMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "left",
                "aria-labelledby": (ref7 = props === null || props === void 0 ? void 0 : props.id) !== null && ref7 !== void 0 ? ref7 : "recording-btn",
                id: "recording-menu",
                items: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            align: "center",
                            gap: 4,
                            horizontal: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordIcon/* RecordIcon */.A, {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: "strong",
                                    children: t("general.recording")
                                })
                            ]
                        }),
                        static: true
                    },
                    {
                        label: showAsRecording ? t("recording.stopRecording") : t("recording.startRecording"),
                        onClick: handleMenuItemClick
                    }, 
                ],
                onClose: handleMenuClose,
                placement: "top"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6144370060377484",
                dynamic: [
                    colors.system.red
                ],
                children: ".record-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.record-controls.active.__jsx-style-dynamic-selector .icon{background:".concat(colors.system.red, "}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/VideoControls.tsx
function VideoControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function VideoControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function VideoControls_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return VideoControls_arrayLikeToArray(arr);
}
function VideoControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function VideoControls_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                VideoControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                VideoControls_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function VideoControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoControls_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function VideoControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function VideoControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function VideoControls_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function VideoControls_slicedToArray(arr, i) {
    return VideoControls_arrayWithHoles(arr) || VideoControls_iterableToArrayLimit(arr, i) || VideoControls_unsupportedIterableToArray(arr, i) || VideoControls_nonIterableRest();
}
function VideoControls_toConsumableArray(arr) {
    return VideoControls_arrayWithoutHoles(arr) || VideoControls_iterableToArray(arr) || VideoControls_unsupportedIterableToArray(arr) || VideoControls_nonIterableSpread();
}
function VideoControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return VideoControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return VideoControls_arrayLikeToArray(o, minLen);
}






























var VideoControls = /*#__PURE__*/ (0,react.memo)(function(param) {
    var id = param.id, _shouldEnableVideoMenu = param.shouldEnableVideoMenu, shouldEnableVideoMenu = _shouldEnableVideoMenu === void 0 ? true : _shouldEnableVideoMenu;
    var ref10 = (0,Theme.useTheme)(), colors = ref10.colors, mediaQueries = ref10.mediaQueries;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var state = (0,CallProvider/* useCallState */.oz)().state;
    var enableVideoProcessingUI = (0,useCallConfig/* useCallConfig */.A)().enableVideoProcessingUI;
    var promptForAccess = useMediaDevices().promptForAccess;
    var ref1 = (0,daily_react_esm/* useDevices */.Ls)(), cameras = ref1.cameras, camState = ref1.camState, hasCamError = ref1.hasCamError, setCamera = ref1.setCamera;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isVideoEnabled = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "video");
    var remoteParticipants = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "remote"
    });
    var isDesktop = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var ref2 = VideoControls_slicedToArray(useDeviceInUseModal(), 2), setShowDeviceInUseModal = ref2[1];
    var ref3 = VideoControls_slicedToArray(useDeviceNotFoundModal(), 2), setShowDeviceNotFoundModal = ref3[1];
    var ref4 = VideoControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref4[0];
    var ref5 = VideoControls_slicedToArray((0,layout/* useMobileTray */.UX)(), 1), showMobileTray = ref5[0];
    var ref6 = VideoControls_slicedToArray(useSettingsView(), 2), setSettingsView = ref6[1];
    var ref7 = VideoControls_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), showLocalVideo = ref7[0], setShowLocalVideo = ref7[1];
    var ref8 = (0,react.useState)(false), /*#__PURE__*/ showCamsMenu = ref8[0], setShowCamsMenu = ref8[1];
    /**
     * Local muted state for optimistic updates when toggling the camera.
     * Enabling camera can take ~1 second until the participant state is updated.
     * Adding an optimistic local state update adds the expected UI feedback.
     */ var ref9 = (0,react.useState)(!isVideoEnabled), muted = ref9[0], setMuted = ref9[1];
    (0,react.useEffect)(function() {
        /**
       * Add a small delay before actually updating the local state.
       * When toggling the camera fast, participant-update events might be emitted subsequently.
       */ var timeout = setTimeout(function() {
            setMuted(!isVideoEnabled);
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        isVideoEnabled
    ]);
    /**
     * Setup media session event handler and map muted state.
     */ (0,react.useEffect)(function() {
        var ref;
        // @ts-ignore
        if (!daily || typeof ((ref = navigator.mediaSession) === null || ref === void 0 ? void 0 : ref.setCameraActive) !== "function") return;
        // @ts-ignore
        navigator.mediaSession.setCameraActive(!muted);
        var handleToggleCam = function() {
            if (hasCamError) return;
            daily.setLocalVideo(muted);
        };
        try {
            navigator.mediaSession.setActionHandler("togglecamera", handleToggleCam);
        } catch (e) {}
    }, [
        daily,
        hasCamError,
        muted
    ]);
    var toggleCamera = (0,react.useCallback)(function() {
        switch(camState){
            case "blocked":
                promptForAccess();
                break;
            case "in-use":
                setShowDeviceInUseModal(true);
                break;
            case "not-found":
                setShowDeviceNotFoundModal(true);
                break;
            default:
                daily.setLocalVideo(muted);
                setMuted(!muted);
                break;
        }
    }, [
        camState,
        daily,
        muted,
        promptForAccess,
        setShowDeviceInUseModal,
        setShowDeviceNotFoundModal, 
    ]);
    var ctrlKey =  true && navigator.platform.startsWith("Mac") ? "Cmd" : "Ctrl";
    (0,react.useEffect)(function() {
        var unsubscribe = (0,tinykeys_module/* default */.Z)(window, {
            "$mod+KeyE": function(ev) {
                toggleCamera();
                ev.preventDefault();
            }
        });
        return function() {
            unsubscribe();
        };
    }, [
        toggleCamera
    ]);
    var handleCamClick = function() {
        var _ref = VideoControls_asyncToGenerator(runtime_default().mark(function _callee(cam) {
            var lastSelected;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowCamsMenu(false);
                        if (!cam.selected) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        lastSelected = cameras.find(function(c) {
                            return c.selected;
                        });
                        try {
                            // optimistic UI update
                            setCamera(cam.device.deviceId);
                        } catch (e) {
                            // reset to last known device in case switching failed
                            setCamera(lastSelected.device.deviceId);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCamClick(cam) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMenuOpen = function() {
        setShowCamsMenu(true);
    };
    var handleMenuClose = function() {
        setShowCamsMenu(false);
    };
    var handleBackgroundEffectsClick = function() {
        setSettingsView("effects");
        setShowCamsMenu(false);
    };
    var handleSettingsClick = function() {
        setSettingsView("devices");
        setShowCamsMenu(false);
    };
    var handleToggleSelfView = function() {
        setShowLocalVideo(function(show) {
            return !show;
        });
        setShowCamsMenu(false);
    };
    var isSupported = camState !== "not-supported";
    var mobileDisabled = isMobile && !showMobileTray;
    var isOnlyCamInUse = cameras.length === 1 && cameras[0].state === "in-use";
    var enableVideoMenu = shouldEnableVideoMenu && !isMobile && isSupported && camState !== "pending";
    var renderAsMuted = muted || hasCamError;
    var btnText = (0,react.useMemo)(function() {
        switch(camState){
            case "pending":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("video.camera")
                });
            case "blocked":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("general.allow")
                });
            case "in-use":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("video.inUse")
                });
            case "not-found":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("video.noCamera")
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                    on: !renderAsMuted,
                    onText: t("video.mute"),
                    offText: t("video.unmute")
                });
        }
    }, [
        camState,
        renderAsMuted,
        t
    ]);
    var isTooltipDisabled = // Dedicated mobile view
    isMobile || // Responsive view on mobile-ish viewport size
    !isDesktop || // Unsupported browser
    !isSupported || // Pending device access
    camState === "pending" || // Error state
    hasCamError;
    var isButtonDisabled = // Unsupported browser
    !isSupported || // Disabled on mobile (hidden tray)
    mobileDisabled || // User's only cam is in use (toggling cam doesn't do anything)
    isOnlyCamInUse || // Pending device access
    camState === "pending";
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4c8be4331c8f9fc7",
                [
                    mediaQueries.nonCoarse,
                    colors.system.red,
                    colors.backgroundAccent
                ]
            ]
        ]) + " " + (classnames_default()("video-controls", {
            muted: renderAsMuted,
            videoMenu: enableVideoMenu
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                delay: TOOLTIP_DELAY,
                disabled: isTooltipDisabled,
                id: "tt-video-controls",
                title: "".concat(ctrlKey, " + E"),
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                    className: classnames_default()("btn", (_obj = {}, VideoControls_defineProperty(_obj, robotsClassName("btn-cam-mute"), !muted), VideoControls_defineProperty(_obj, robotsClassName("btn-cam-unmute"), muted), _obj)),
                    disabled: isButtonDisabled,
                    id: id,
                    onClick: toggleCamera,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                            className: classnames_default()("icon", {
                                disabled: isButtonDisabled
                            }),
                            color: renderAsMuted ? colors.system.white : "currentColor",
                            id: "VideoControls",
                            muted: renderAsMuted
                        }),
                        btnText
                    ]
                })
            }),
            enableVideoMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.MenuButton, {
                "aria-controls": "camera-menu",
                className: robotsClassName("btn-cam-devices"),
                focusable: false,
                id: "camera-menu-btn",
                onClick: handleMenuOpen,
                open: showCamsMenu,
                variant: "ghost",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownIcon.CaretDownIcon, {
                        size: 16,
                        variant: "default"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                        children: t("video.selectVideoDevices")
                    })
                ]
            }),
            showCamsMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "left",
                "aria-labelledby": "camera-menu-btn",
                className: robotsClassName("cam-devices-menu"),
                edgeSpacing: 16,
                id: "camera-menu",
                items: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            align: "center",
                            gap: 4,
                            horizontal: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                                    id: "video-menu-label",
                                    size: 16,
                                    transition: false
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: "strong",
                                    style: {
                                        display: "block",
                                        margin: "-1px 0 1px"
                                    },
                                    children: t("video.camera")
                                })
                            ]
                        }),
                        static: true
                    }, 
                ].concat(VideoControls_toConsumableArray(!cameras.length ? [
                    {
                        label: t("video.unmuteToAllowAccess"),
                        static: true
                    }, 
                ] : []), VideoControls_toConsumableArray(cameras.map(function(cam, index) {
                    return {
                        className: robotsClassName("cam-device"),
                        disabled: cam.state === "in-use",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio.Radio, {
                            id: cam.device.deviceId,
                            name: cam.device.deviceId,
                            checked: cam.selected,
                            readOnly: true,
                            tabIndex: -1
                        }),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            horizontal: true,
                            children: [
                                cam.state === "in-use" && /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                                    color: colors.system.red,
                                    size: 16
                                }),
                                cam.device.label || "".concat(t("video.cameraWithNumber", {
                                    number: index + 1
                                }))
                            ]
                        }),
                        onClick: function() {
                            return handleCamClick(cam);
                        }
                    };
                })), [
                    {
                        divider: true
                    }, 
                ], VideoControls_toConsumableArray(enableVideoProcessingUI && !isMobile ? [
                    {
                        disabled: !isVideoEnabled,
                        label: t("video.backgroundEffects"),
                        onClick: handleBackgroundEffectsClick
                    }, 
                ] : []), [
                    {
                        label: t("video.settings"),
                        onClick: handleSettingsClick
                    }, 
                ], VideoControls_toConsumableArray(state === "joined" ? [
                    {
                        disabled: remoteParticipants.length === 0,
                        label: showLocalVideo ? t("people.hideSelfView") : t("people.showSelfView"),
                        onClick: handleToggleSelfView
                    }, 
                ] : [])),
                offsetTop: 4,
                onClose: handleMenuClose,
                placement: "top",
                cardListProps: {
                    style: {
                        marginRight: 16,
                        overflow: "auto"
                    }
                }
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4c8be4331c8f9fc7",
                dynamic: [
                    mediaQueries.nonCoarse,
                    colors.system.red,
                    colors.backgroundAccent
                ],
                children: ".video-controls.__jsx-style-dynamic-selector{position:relative;white-space:nowrap}.video-controls.__jsx-style-dynamic-selector .btn[disabled]{opacity:.4}.video-controls.__jsx-style-dynamic-selector .icon.disabled{opacity:-webkit-calc(.3/.4);opacity:-moz-calc(.3/.4);opacity:calc(.3/.4)}@media ".concat(mediaQueries.nonCoarse, "{.video-controls.__jsx-style-dynamic-selector .btn{min-width:64px;padding:4px 10px}}.video-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.video-controls.muted.__jsx-style-dynamic-selector .icon{background:").concat(colors.system.red, "}.video-controls.__jsx-style-dynamic-selector #camera-menu-btn:focus-visible,.video-controls.__jsx-style-dynamic-selector #camera-menu-btn:hover{background:").concat(colors.backgroundAccent, "}.video-controls.__jsx-style-dynamic-selector #camera-menu-btn{-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;padding:2px;position:absolute;right:0;top:-4px;-webkit-transition:background 250ms ease;-moz-transition:background 250ms ease;-o-transition:background 250ms ease;transition:background 250ms ease}")
            })
        ]
    });
});
VideoControls.displayName = "VideoControls";

;// CONCATENATED MODULE: ./components/MobileTray/MobileMoreMenu.tsx
function MobileMoreMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileMoreMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileMoreMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var MobileMoreMenu = /*#__PURE__*/ (0,react.memo)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, MobileMoreMenu_objectSpread({
        align: "left",
        cardProps: {
            style: {
                borderRadius: 8
            }
        },
        cardListProps: {
            style: {
                justifyContent: "space-between",
                overflow: "auto"
            }
        },
        className: classnames_default()(robotsClassName("mobile-more-menu")),
        edgeSpacing: 8,
        offsetTop: 7,
        placement: "top",
        position: "absolute"
    }, props));
});
MobileMoreMenu.displayName = "MobileMoreMenu";

;// CONCATENATED MODULE: ./components/MobileTray/MobileTray.tsx
function MobileTray_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileTray_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobileTray_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return MobileTray_arrayLikeToArray(arr);
}
function MobileTray_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function MobileTray_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobileTray_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileTray_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileTray_slicedToArray(arr, i) {
    return MobileTray_arrayWithHoles(arr) || MobileTray_iterableToArrayLimit(arr, i) || MobileTray_unsupportedIterableToArray(arr, i) || MobileTray_nonIterableRest();
}
function MobileTray_toConsumableArray(arr) {
    return MobileTray_arrayWithoutHoles(arr) || MobileTray_iterableToArray(arr) || MobileTray_unsupportedIterableToArray(arr) || MobileTray_nonIterableSpread();
}
function MobileTray_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileTray_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileTray_arrayLikeToArray(o, minLen);
}













































var TRAY_MAX_WIDTH = 343;
var CONTENT_HEIGHT = 44;
var MobileTray = /*#__PURE__*/ (0,react.memo)(function() {
    var ref16;
    var trayRef = (0,react.useRef)(null);
    var ref1 = (0,Theme.useTheme)(), colors = ref1.colors, isDarkMode = ref1.isDarkMode;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref2 = MobileTray_slicedToArray((0,layout/* useMobileTray */.UX)(), 1), showMobileTray = ref2[0];
    var ref3 = MobileTray_slicedToArray(useSettingsView(), 2), settingsView = ref3[0], setSettingsView = ref3[1];
    var ref4 = MobileTray_slicedToArray((0,core/* useSidebarView */.oS)(), 2), setSidebarView = ref4[1];
    var ref5 = MobileTray_slicedToArray((0,recordings/* useStartRecordingModal */.Fy)(), 2), setShowStartRecordingModal = ref5[1];
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ref6 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref6.broadcastRole, enableBreakoutRooms = ref6.enableBreakoutRooms, enableChat = ref6.enableChat, enableEmojiReactions = ref6.enableEmojiReactions, enableHandRaising = ref6.enableHandRaising, enablePeopleUI = ref6.enablePeopleUI, enableRecording = ref6.enableRecording, enableRecordingUI = ref6.enableRecordingUI;
    var ref7 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref7.breakoutHost, breakoutStatus = ref7.breakoutStatus, currentBreakoutRoom = ref7.currentBreakoutRoom, isRequestingHelp = ref7.isRequestingHelp, updateAskForHelpStatus = ref7.updateAskForHelpStatus;
    var chatUnread = (0,ChatProvider/* useChatUnread */.HB)(currentBreakoutRoom.id);
    var stopRecording = (0,RecordingProvider/* useRecording */.$n)().stopRecording;
    var ref8 = (0,daily_react_esm/* useRecording */.$n)(), isLocalParticipantRecorded = ref8.isLocalParticipantRecorded, isRecording = ref8.isRecording;
    var ref9 = MobileTray_slicedToArray((0,recordings/* useRecordingUI */.oZ)(), 1), recordingUIState = ref9[0];
    var ref10 = MobileTray_slicedToArray((0,layout/* useShowMobileMoreMenu */.DE)(), 2), showMenu = ref10[0], setShowMenu = ref10[1];
    var ref11 = (0,react.useState)(false), /*#__PURE__*/ snackbarShown = ref11[0], setSnackbarShown = ref11[1];
    var ref12 = (0,react.useState)(0), menuLeft = ref12[0], setMenuLeft = ref12[1];
    var waitingParticipants = (0,daily_react_esm/* useWaitingParticipants */.zy)().waitingParticipants;
    var ref13 = MobileTray_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 1), customTrayButtons = ref13[0];
    var sendMessageToDriver = useIframeDriver().sendMessageToDriver;
    var fitsRecordingButton = (0,useMediaQuery.useMediaQuery)("screen and (min-width: 350px)") && !(enableEmojiReactions && enableHandRaising);
    var handRaiseBadgeStatus = useHandRaisingBadgeStatus();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var ref14 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), canControlIntegration = ref14.canControlIntegration, mainIntegrations = ref14.mainIntegrations;
    var apps = mainIntegrations.filter(canControlIntegration);
    var ref15 = MobileTray_slicedToArray(useAppsModal(), 2), setShowAppsModal = ref15[1];
    var isAttendee = (0,react.useMemo)(function() {
        return broadcastRole === "attendee";
    }, [
        broadcastRole
    ]);
    var handleMenuShow = (0,react.useCallback)(function() {
        setShowMenu(true);
    }, [
        setShowMenu
    ]);
    var handleMenuHide = function() {
        setShowMenu(false);
    };
    var handleAskForHelpClick = (0,react.useCallback)(function() {
        updateAskForHelpStatus(!isRequestingHelp);
        setShowMenu(false);
    }, [
        isRequestingHelp,
        setShowMenu,
        updateAskForHelpStatus
    ]);
    var handlePeopleClick = (0,react.useCallback)(function() {
        setSidebarView("people");
        setShowMenu(false);
    }, [
        setShowMenu,
        setSidebarView
    ]);
    var handleChatClick = (0,react.useCallback)(function() {
        setSidebarView("chat");
        setShowMenu(false);
    }, [
        setShowMenu,
        setSidebarView
    ]);
    var handleRecordClick = (0,react.useCallback)(function() {
        if (isRecording) {
            stopRecording();
        } else {
            setShowStartRecordingModal(true);
        }
        setShowMenu(false);
    }, [
        isRecording,
        setShowMenu,
        setShowStartRecordingModal,
        stopRecording
    ]);
    var handleSettingsClick = (0,react.useCallback)(function() {
        isAttendee ? setSettingsView("quality") : setSettingsView("devices");
        setShowMenu(false);
    }, [
        isAttendee,
        setSettingsView,
        setShowMenu
    ]);
    var handleSettingsModalClose = function() {
        setSettingsView(null);
    };
    var handleBreakoutsClick = (0,react.useCallback)(function() {
        setSidebarView("breakout");
        setShowMenu(false);
    }, [
        setShowMenu,
        setSidebarView
    ]);
    var handleAppsClick = (0,react.useCallback)(function() {
        setShowAppsModal(true);
        setShowMenu(false);
    }, [
        setShowAppsModal,
        setShowMenu
    ]);
    var handleCustomButtonClick = (0,react.useCallback)(function(id) {
        sendMessageToDriver({
            action: ACTION_CUSTOM_BUTTON_CLICK,
            button_id: id
        });
        setShowMenu(false);
    }, [
        sendMessageToDriver,
        setShowMenu
    ]);
    (0,react.useEffect)(function() {
        if (chatUnread && !snackbarShown) {
            addMessage({
                content: t("chat.started"),
                type: "info",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* ChatIcon */.k, {
                    id: "mobileChatSnackbarIcon",
                    size: 16
                })
            });
            setSnackbarShown(true);
        }
    }, [
        addMessage,
        chatUnread,
        snackbarShown,
        t
    ]);
    (0,useResize.useResize)((0,react.useCallback)(function() {
        var ref;
        if (!(trayRef === null || trayRef === void 0 ? void 0 : trayRef.current) || !showMenu) return;
        var tray = trayRef === null || trayRef === void 0 ? void 0 : (ref = trayRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        setMenuLeft(tray.left);
    }, [
        showMenu
    ]));
    var menuItems = (0,react.useMemo)(function() {
        var _items;
        var items = [];
        if (enablePeopleUI) {
            items.push({
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    El: "p",
                    children: t("general.people")
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                            color: colors.system.red,
                            visible: (waitingParticipants === null || waitingParticipants === void 0 ? void 0 : waitingParticipants.length) > 0 || handRaiseBadgeStatus,
                            top: 0
                        })
                    ]
                }),
                id: "mobile-more-menu-people",
                onClick: handlePeopleClick
            });
        }
        // Show chat for any call chat is enabled in
        if (enableChat) {
            items.push({
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    El: "p",
                    children: t("general.chat")
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* ChatIcon */.k, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                            color: colors.system.red,
                            visible: chatUnread,
                            top: 0
                        })
                    ]
                }),
                id: "mobile-more-menu-chat",
                onClick: handleChatClick
            });
        }
        if (enableRecording && !fitsRecordingButton && enableRecordingUI) {
            var disabled = recordingUIState === "saved" || isRecording && !isLocalParticipantRecorded || breakoutStatus === "ongoing";
            items.push({
                disabled: disabled,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: disabled ? "muted" : "default",
                    variant: "large",
                    El: "p",
                    children: isRecording ? t("recording.stopRecording") : t("recording.start")
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordIcon/* RecordIcon */.A, {
                    color: isRecording ? colors.system.white : undefined,
                    style: isRecording ? {
                        background: colors.system.red,
                        borderRadius: 4
                    } : {}
                }),
                id: "mobile-more-menu-".concat(isRecording ? "stop" : "start", "-recording"),
                onClick: handleRecordClick
            });
        }
        if (enableBreakoutRooms) {
            if (isLocalOwner) {
                items.push({
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "large",
                        El: "p",
                        children: t("general.breakoutRooms")
                    }),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutIcon/* BreakoutIcon */.y, {}),
                    id: "mobile-more-menu-breakouts",
                    onClick: handleBreakoutsClick
                });
            }
            if (breakoutStatus === "ongoing") {
                items.push({
                    disabled: orderedParticipantIds.includes(breakoutHost),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: orderedParticipantIds.includes(breakoutHost) ? "muted" : "inherit",
                        variant: "large",
                        El: "p",
                        children: isRequestingHelp ? t("breakouts.cancelRequestForHelp") : t("breakouts.askHostForHelp")
                    }),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            borderRadius: 4,
                            background: isRequestingHelp ? colors.system.red : undefined
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                            color: isRequestingHelp ? colors.system.white : undefined
                        })
                    }),
                    id: "mobile-more-menu-ask-for-help",
                    onClick: handleAskForHelpClick
                });
            }
        }
        if (apps.length) {
            items.push({
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    El: "p",
                    children: t("general.appsEllipsis")
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsIcon/* AppsIcon */.j, {}),
                onClick: handleAppsClick
            });
        }
        (_items = items).push.apply(_items, MobileTray_toConsumableArray(Object.entries(customTrayButtons).map(function(param) {
            var _param = MobileTray_slicedToArray(param, 2), id = _param[0], btn = _param[1];
            return {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "large",
                    El: "p",
                    children: btn.tooltip
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcon, {
                    alt: btn.label,
                    src: isDarkMode && btn.iconPathDarkMode ? btn.iconPathDarkMode : btn.iconPath,
                    padding: 4,
                    size: 24,
                    style: {
                        display: "block"
                    }
                }),
                id: "mobile-more-menu-custom-".concat(id),
                onClick: function() {
                    return handleCustomButtonClick(id);
                }
            };
        })));
        // Always show settings
        items.push({
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "large",
                El: "p",
                children: t("general.settings")
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GearIcon/* GearIcon */.U, {
                fill: "currentColor",
                stroke: "transparent"
            }),
            id: "mobile-more-menu-settings",
            onClick: handleSettingsClick
        });
        return items;
    }, [
        apps.length,
        breakoutHost,
        breakoutStatus,
        chatUnread,
        colors.system.red,
        colors.system.white,
        customTrayButtons,
        enableBreakoutRooms,
        enableChat,
        enablePeopleUI,
        enableRecording,
        enableRecordingUI,
        fitsRecordingButton,
        handRaiseBadgeStatus,
        handleAppsClick,
        handleAskForHelpClick,
        handleBreakoutsClick,
        handleChatClick,
        handleCustomButtonClick,
        handlePeopleClick,
        handleRecordClick,
        handleSettingsClick,
        isDarkMode,
        isLocalOwner,
        isLocalParticipantRecorded,
        isRecording,
        isRequestingHelp,
        orderedParticipantIds,
        recordingUIState,
        t,
        waitingParticipants === null || waitingParticipants === void 0 ? void 0 : waitingParticipants.length, 
    ]);
    var menuId = "mobileTrayMoreMenu";
    var btnId = "mobileTrayMoreButton";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: trayRef,
        className: styled_jsx_default().dynamic([
            [
                "6c609929004ceb77",
                [
                    colors.backgroundAccent,
                    TRAY_MAX_WIDTH,
                    CONTENT_HEIGHT
                ]
            ]
        ]) + " " + (classnames_default()("mobile-tray", {
            hidden: !showMobileTray
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "6c609929004ceb77",
                        [
                            colors.backgroundAccent,
                            TRAY_MAX_WIDTH,
                            CONTENT_HEIGHT
                        ]
                    ]
                ]) + " " + "left",
                children: [
                    !isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls, {
                        id: "mobile-video-controls"
                    }),
                    !isAttendee && !disableAudio && /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioControls, {
                        id: "mobile-audio-controls"
                    }),
                    enableEmojiReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactionControls, {
                        id: "mobile-emoji-reaction-controls"
                    }),
                    !isAttendee && enableHandRaising && /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandControls, {
                        id: "mobile-raisehand-controls"
                    }),
                    enableRecording && fitsRecordingButton && enableRecordingUI && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordControls, {
                        id: "mobile-record-controls"
                    })
                ]
            }),
            isAttendee && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "6c609929004ceb77",
                        [
                            colors.backgroundAccent,
                            TRAY_MAX_WIDTH,
                            CONTENT_HEIGHT
                        ]
                    ]
                ]) + " " + "attendee-msg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "strong",
                    children: t("broadcast.viewingCall")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                "aria-controls": menuId,
                id: btnId,
                className: classnames_default()("btn", "mobile", robotsClassName("mobile-more-btn")),
                disabled: !showMobileTray,
                onClick: handleMenuShow,
                style: {
                    padding: "4px 12px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("general.more")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                        color: colors.system.red,
                        visible: chatUnread || waitingParticipants.length > 0 || handRaiseBadgeStatus
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMoreMenu, {
                "aria-labelledby": btnId,
                id: menuId,
                items: menuItems,
                onClose: handleMenuHide,
                style: {
                    left: menuLeft,
                    width: (ref16 = trayRef.current) === null || ref16 === void 0 ? void 0 : ref16.clientWidth
                }
            }),
            settingsView && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsModal, {
                onClose: handleSettingsModalClose
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6c609929004ceb77",
                dynamic: [
                    colors.backgroundAccent,
                    TRAY_MAX_WIDTH,
                    CONTENT_HEIGHT
                ],
                children: ".mobile-tray.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:".concat(colors.backgroundAccent, ";-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;bottom:56px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:50%;max-width:min(-webkit-calc(100% - 8px),").concat(TRAY_MAX_WIDTH, "px);max-width:min(-moz-calc(100% - 8px),").concat(TRAY_MAX_WIDTH, "px);max-width:min(calc(100% - 8px),").concat(TRAY_MAX_WIDTH, "px);opacity:1;padding:7px 4px;position:absolute;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:opacity.2s ease,-webkit-transform.2s ease;-moz-transition:opacity.2s ease,-moz-transform.2s ease;-o-transition:opacity.2s ease,-o-transform.2s ease;transition:opacity.2s ease,-webkit-transform.2s ease;transition:opacity.2s ease,-moz-transform.2s ease;transition:opacity.2s ease,-o-transform.2s ease;transition:opacity.2s ease,transform.2s ease;width:100%;z-index:10}.mobile-tray.hidden.__jsx-style-dynamic-selector{opacity:0;-webkit-transform:translate(-50%,200%);-moz-transform:translate(-50%,200%);-ms-transform:translate(-50%,200%);-o-transform:translate(-50%,200%);transform:translate(-50%,200%)}.mobile-tray.__jsx-style-dynamic-selector .left.__jsx-style-dynamic-selector{align:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-right:auto}.mobile-tray.hidden.__jsx-style-dynamic-selector button.__jsx-style-dynamic-selector{pointer-events:none}.mobile-tray.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector{position:relative}.ellipsis.__jsx-style-dynamic-selector{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}.attendee-msg.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:").concat(CONTENT_HEIGHT, "px;margin:0 auto;padding:0 8px}")
            })
        ]
    });
});
MobileTray.displayName = "MobileTray";

;// CONCATENATED MODULE: ./components/MobileTray/index.ts


;// CONCATENATED MODULE: ./components/MobileView/Screen.tsx


var Screen = function(param) {
    var screen = param.screen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
        isScreen: true,
        orientation: "landscape",
        sessionId: screen.session_id,
        showNames: false
    });
};

;// CONCATENATED MODULE: ./components/MobileView/Home.tsx
function Home_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Home_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Home_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Home_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Home_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Home_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Home_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Home_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Home_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Home_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Home_slicedToArray(arr, i) {
    return Home_arrayWithHoles(arr) || Home_iterableToArrayLimit(arr, i) || Home_unsupportedIterableToArray(arr, i) || Home_nonIterableRest();
}
function Home_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Home_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Home_arrayLikeToArray(o, minLen);
}




















var FIXED_PORTRAIT = {
    height: 114,
    width: 85
};
var FIXED_PORTRAIT_TABLET = {
    height: 128,
    width: 96
};
var FIXED_LANDSCAPE = {
    height: 90,
    width: 160
};
var Home = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var className = _param.className, props = Home_objectWithoutProperties(_param, [
        "className"
    ]);
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = Home_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 1), showLocalVideo = ref[0];
    var ref1 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref1.broadcastRole, enableEmojiReactions = ref1.enableEmojiReactions;
    var ref2 = Home_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref2[0];
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var ref3 = (0,useStyleVariants/* useStyleVariants */._)(), isPortrait = ref3.mobilePortrait;
    var tilesRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)({
        height: 1,
        width: 1
    }), /*#__PURE__*/ tilesDimensions = ref4[0], setTilesDimensions = ref4[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var participantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ownerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "owner"
    });
    var screens = (0,useScreens/* useScreens */.O)();
    var runningMainIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().runningMainIntegrations;
    var isTablet = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var showFixedBar = (0,react.useMemo)(function() {
        switch(broadcastRole){
            case "attendee":
                return screens.length > 0;
            case "owner":
                return screens.length > 0 || ownerIds.length > 1;
            default:
                return screens.length > 0 || participantIds.length > 0;
        }
    }, [
        broadcastRole,
        ownerIds.length,
        participantIds.length,
        screens.length
    ]);
    (0,useResizeObserver.useResizeObserver)(tilesRef, (0,react.useCallback)(function(width, height) {
        var zoom = document.documentElement.clientWidth / window.innerWidth;
        // Avoid UI updates, when user pinch-zoomed into page
        if (zoom !== 1) return;
        setTilesDimensions({
            height: height,
            width: width
        });
    }, []));
    var speakerStyle = (0,react.useMemo)(function() {
        var maxHeight = tilesDimensions.height, maxWidth = tilesDimensions.width;
        if (isPortrait) {
            return {
                height: Math.min(maxHeight, maxWidth / DEFAULT_PORTRAIT_AR),
                width: Math.min(maxWidth, maxHeight * DEFAULT_PORTRAIT_AR)
            };
        }
        return {
            height: Math.min(maxHeight, maxWidth / DEFAULT_LANDSCAPE_AR),
            width: Math.min(maxWidth, maxHeight * DEFAULT_LANDSCAPE_AR)
        };
    }, [
        isPortrait,
        tilesDimensions
    ]);
    var mainArea = (0,react.useMemo)(function() {
        if (screens.length > 0 || runningMainIntegrations.length > 0) {
            var _loading;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "screens",
                children: [
                    screens.map(function(screen) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Screen, {
                            screen: screen
                        }, screen.screenId);
                    }),
                    runningMainIntegrations.map(function(integration) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            allow: integration.allow,
                            // @ts-ignore
                            csp: integration.csp,
                            loading: (_loading = integration.loading) !== null && _loading !== void 0 ? _loading : "lazy",
                            name: integration.name,
                            referrerPolicy: integration.referrerPolicy,
                            sandbox: integration.sandbox,
                            src: integration.src,
                            srcDoc: integration.srcdoc
                        }, integration.id);
                    })
                ]
            });
        }
        if (currentSpeakerId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
                orientation: isPortrait ? "portrait" : "landscape",
                sessionId: currentSpeakerId,
                showNames: showNames,
                style: speakerStyle
            });
        }
        if (broadcastRole === "attendee") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "largestrong",
                color: "white",
                style: {
                    margin: "auto"
                },
                children: t("broadcast.hostLeft")
            });
        }
        return null;
    }, [
        broadcastRole,
        currentSpeakerId,
        isPortrait,
        runningMainIntegrations,
        screens,
        showNames,
        speakerStyle,
        t, 
    ]);
    var fixedStyle = (0,react.useMemo)(function() {
        if (isPortrait) return isTablet ? FIXED_PORTRAIT_TABLET : FIXED_PORTRAIT;
        return FIXED_LANDSCAPE;
    }, [
        isPortrait,
        isTablet
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", Home_objectSpread({}, props, {
        style: Home_objectSpread({}, props.style, // CSSProperties type doesn't know about custom properties
        Home_defineProperty({}, "--screens", screens.length + runningMainIntegrations.length)),
        className: styled_jsx_default().dynamic([
            [
                "376c597161aa0cdb",
                [
                    TILE_GAP,
                    FIXED_LANDSCAPE.width,
                    TILE_GAP,
                    TILE_GAP,
                    TILE_GAP,
                    FIXED_PORTRAIT.height,
                    mediaQueries.large,
                    FIXED_PORTRAIT_TABLET.height,
                    TILE_GAP,
                    2 * TILE_GAP,
                    DEFAULT_PORTRAIT_AR,
                    TILE_GAP,
                    PAGINATION_HEIGHT,
                    DEFAULT_LANDSCAPE_AR,
                    TILE_GAP
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()("home", className, {
            isPortrait: isPortrait,
            hasFixed: showFixedBar
        }) || ""),
        children: [
            showFixedBar && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "376c597161aa0cdb",
                        [
                            TILE_GAP,
                            FIXED_LANDSCAPE.width,
                            TILE_GAP,
                            TILE_GAP,
                            TILE_GAP,
                            FIXED_PORTRAIT.height,
                            mediaQueries.large,
                            FIXED_PORTRAIT_TABLET.height,
                            TILE_GAP,
                            2 * TILE_GAP,
                            DEFAULT_PORTRAIT_AR,
                            TILE_GAP,
                            PAGINATION_HEIGHT,
                            DEFAULT_LANDSCAPE_AR,
                            TILE_GAP
                        ]
                    ]
                ]) + " " + "fixed",
                children: [
                    showLocalVideo && broadcastRole !== "attendee" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
                        orientation: isPortrait ? "portrait" : "landscape",
                        sessionId: localSessionId,
                        showNames: showNames,
                        style: fixedStyle
                    }),
                    screens.length + runningMainIntegrations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
                        orientation: isPortrait ? "portrait" : "landscape",
                        sessionId: currentSpeakerId,
                        showNames: showNames,
                        style: fixedStyle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: tilesRef,
                className: styled_jsx_default().dynamic([
                    [
                        "376c597161aa0cdb",
                        [
                            TILE_GAP,
                            FIXED_LANDSCAPE.width,
                            TILE_GAP,
                            TILE_GAP,
                            TILE_GAP,
                            FIXED_PORTRAIT.height,
                            mediaQueries.large,
                            FIXED_PORTRAIT_TABLET.height,
                            TILE_GAP,
                            2 * TILE_GAP,
                            DEFAULT_PORTRAIT_AR,
                            TILE_GAP,
                            PAGINATION_HEIGHT,
                            DEFAULT_LANDSCAPE_AR,
                            TILE_GAP
                        ]
                    ]
                ]) + " " + "tiles",
                children: [
                    mainArea,
                    enableEmojiReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "376c597161aa0cdb",
                                [
                                    TILE_GAP,
                                    FIXED_LANDSCAPE.width,
                                    TILE_GAP,
                                    TILE_GAP,
                                    TILE_GAP,
                                    FIXED_PORTRAIT.height,
                                    mediaQueries.large,
                                    FIXED_PORTRAIT_TABLET.height,
                                    TILE_GAP,
                                    2 * TILE_GAP,
                                    DEFAULT_PORTRAIT_AR,
                                    TILE_GAP,
                                    PAGINATION_HEIGHT,
                                    DEFAULT_LANDSCAPE_AR,
                                    TILE_GAP
                                ]
                            ]
                        ]) + " " + "home-reactions",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                            animation: "flyUp"
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "376c597161aa0cdb",
                dynamic: [
                    TILE_GAP,
                    FIXED_LANDSCAPE.width,
                    TILE_GAP,
                    TILE_GAP,
                    TILE_GAP,
                    FIXED_PORTRAIT.height,
                    mediaQueries.large,
                    FIXED_PORTRAIT_TABLET.height,
                    TILE_GAP,
                    2 * TILE_GAP,
                    DEFAULT_PORTRAIT_AR,
                    TILE_GAP,
                    PAGINATION_HEIGHT,
                    DEFAULT_LANDSCAPE_AR,
                    TILE_GAP
                ],
                children: ".home.__jsx-style-dynamic-selector{display:grid;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;gap:0px ".concat(TILE_GAP, 'px;grid-template-areas:"fixed tiles";grid-template-columns:').concat(FIXED_LANDSCAPE.width, "px minmax(0,1fr);margin:0 auto;overflow:hidden;padding:").concat(TILE_GAP, "px ").concat(TILE_GAP, "px 0}.home.isPortrait.__jsx-style-dynamic-selector{gap:").concat(TILE_GAP, "px 0px;grid-auto-flow:row;grid-auto-rows:minmax(-webkit-min-content,-webkit-max-content);grid-auto-rows:minmax(min-content,max-content);grid-template-columns:1fr;grid-template-rows:").concat(FIXED_PORTRAIT.height, 'px minmax(0,1fr);grid-template-areas:"fixed""tiles";height:auto!important;max-height:100%;margin:auto 0;-webkit-box-pack:stretch;-webkit-justify-content:stretch;-moz-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}.home.__jsx-style-dynamic-selector:not(.isPortrait){max-width:100%;width:auto!important}@media ').concat(mediaQueries.large, "{.home.isPortrait.__jsx-style-dynamic-selector{grid-template-rows:").concat(FIXED_PORTRAIT_TABLET.height, "px minmax(0,1fr)}}.fixed.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:").concat(TILE_GAP, "px;grid-area:fixed;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.home.isPortrait.__jsx-style-dynamic-selector .fixed.__jsx-style-dynamic-selector{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.tiles.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;grid-area:tiles;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:relative}.home.isPortrait.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector{height:-webkit-calc(\n              -webkit-calc(100vw - ").concat(2 * TILE_GAP, "px) / ").concat(DEFAULT_PORTRAIT_AR, "\n            );height:-moz-calc(\n              -moz-calc(100vw - ").concat(2 * TILE_GAP, "px) / ").concat(DEFAULT_PORTRAIT_AR, "\n            );height:calc(\n              calc(100vw - ").concat(2 * TILE_GAP, "px) / ").concat(DEFAULT_PORTRAIT_AR, "\n            );max-height:100%}.home.__jsx-style-dynamic-selector:not(.isPortrait) .tiles.__jsx-style-dynamic-selector{height:100%;max-width:100%;width:-webkit-calc(\n              -webkit-calc(100vh - ").concat(TILE_GAP, "px - ").concat(PAGINATION_HEIGHT, "px) *\n                ").concat(DEFAULT_LANDSCAPE_AR, "\n            );width:-moz-calc(\n              -moz-calc(100vh - ").concat(TILE_GAP, "px - ").concat(PAGINATION_HEIGHT, "px) *\n                ").concat(DEFAULT_LANDSCAPE_AR, "\n            );width:calc(\n              calc(100vh - ").concat(TILE_GAP, "px - ").concat(PAGINATION_HEIGHT, "px) *\n                ").concat(DEFAULT_LANDSCAPE_AR, "\n            )}.home.__jsx-style-dynamic-selector:not(.hasFixed) .tiles.__jsx-style-dynamic-selector{grid-area:fixed/fixed/tiles/tiles}.home.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector>.screens{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:").concat(TILE_GAP, "px;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.home.isPortrait.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector>.screens{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.home.__jsx-style-dynamic-selector:not(.isPortrait) .tiles.__jsx-style-dynamic-selector>.screens{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.home.isPortrait.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector>.screens .tile,.home.isPortrait.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector>.screens iframe{height:-webkit-calc(100%/var(--screens));height:-moz-calc(100%/var(--screens));height:calc(100%/var(--screens));width:100%}.home.__jsx-style-dynamic-selector:not(.isPortrait) .tiles.__jsx-style-dynamic-selector>.screens .tile,.home.__jsx-style-dynamic-selector:not(.isPortrait) .tiles.__jsx-style-dynamic-selector>.screens iframe{height:100%;width:-webkit-calc(100%/var(--screens));width:-moz-calc(100%/var(--screens));width:calc(100%/var(--screens))}.home.__jsx-style-dynamic-selector .home-reactions.__jsx-style-dynamic-selector{bottom:0;position:absolute;right:85px}.home.__jsx-style-dynamic-selector .tiles.__jsx-style-dynamic-selector iframe{border:none}")
            })
        ]
    }));
});


// EXTERNAL MODULE: ../shared/dist/components/Icons/CaretUpIcon.js
var CaretUpIcon = __webpack_require__(7728);
// EXTERNAL MODULE: ../shared/dist/components/Icons/HomeIcon.js
var HomeIcon = __webpack_require__(5721);
;// CONCATENATED MODULE: ./components/MobileView/MobilePaginationBar.tsx
function MobilePaginationBar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobilePaginationBar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobilePaginationBar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobilePaginationBar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobilePaginationBar_slicedToArray(arr, i) {
    return MobilePaginationBar_arrayWithHoles(arr) || MobilePaginationBar_iterableToArrayLimit(arr, i) || MobilePaginationBar_unsupportedIterableToArray(arr, i) || MobilePaginationBar_nonIterableRest();
}
function MobilePaginationBar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobilePaginationBar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobilePaginationBar_arrayLikeToArray(o, minLen);
}






















var MobilePaginationBar = function(param) {
    var _loop = function(i) {
        menuItems.push({
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "start",
                gap: 0,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        El: "span",
                        variant: "large",
                        /*#__PURE__*/ children: t("general.page", {
                            page: i
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            maxWidth: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "muted",
                            truncate: true,
                            children: getParticipantsOnPage(i).map(function(id, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        idx > 0 && ", ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantName, {
                                            sessionId: id
                                        }, id)
                                    ]
                                }, id);
                            })
                        })
                    })
                ]
            }),
            onClick: function() {
                return handleClickPage(i);
            }
        });
    };
    var getParticipantsOnPage = param.getParticipantsOnPage, onChangePage = param.onChangePage, page = param.page, pages = param.pages;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref1.broadcast, broadcastRole = ref1.broadcastRole, enableChat = ref1.enableChat;
    var orderedIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ownerIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "owner"
    });
    var screens = (0,useScreens/* useScreens */.O)();
    var ref2 = MobilePaginationBar_slicedToArray((0,layout/* useShowMobilePageMenu */.C$)(), 2), showMenu = ref2[0], setShowMenu = ref2[1];
    var breakoutStatus = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutStatus;
    /**
   * In OOB calls, owners should always see the full count, not just visible
   * participants. Attendees can see the full count if chat is enabled. Otherwise
   * we don't share participant info.
   *
   * In non-OOB calls, show the usual participant count.
   */ var count = broadcastRole === "owner" || broadcastRole === "attendee" && enableChat || !broadcast ? orderedIds.length + 1 : ownerIds.length;
    var firstScreenParticipantUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(screens === null || screens === void 0 ? void 0 : (ref = screens[0]) === null || ref === void 0 ? void 0 : ref.session_id, "user_name");
    var peopleInCall = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-d59455bb5fc30acc" + " " + "people",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                    color: "muted",
                    truncate: true,
                    children: [
                        breakoutStatus === "ongoing" ? t("breakouts.peopleInRoom", {
                            count: count
                        }) : count <= 1 && !broadcast ? null : t("people.withCount", {
                            count: count
                        }),
                        screens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                " ",
                                "(",
                                screens.length > 1 ? t("screenShare.peopleWithCount", {
                                    count: screens.length
                                }) : t("screenShare.personWithName", {
                                    name: firstScreenParticipantUserName || t("people.someone")
                                }),
                                ")"
                            ]
                        })
                    ]
                }),
                broadcastRole === "owner" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                    style: {
                        alignSelf: "flex-start",
                        marginLeft: "auto"
                    },
                    variant: "success",
                    children: t("broadcast.live")
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "d59455bb5fc30acc",
                    children: ".people.jsx-d59455bb5fc30acc{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;gap:8px;overflow:hidden;max-width:100%}"
                })
            ]
        });
    }, [
        breakoutStatus,
        broadcast,
        broadcastRole,
        count,
        firstScreenParticipantUserName,
        screens.length,
        t, 
    ]);
    var handleClickMenuButton = function() {
        setShowMenu(true);
    };
    var handleClickPage = function(p) {
        onChangePage(p);
        setShowMenu(false);
    };
    var menuItems = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "start",
                gap: 0,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        El: "span",
                        variant: "large",
                        children: screens.length ? t("general.screenShare") : t("general.homePage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                        style: {
                            maxWidth: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "muted",
                            truncate: true,
                            children: getParticipantsOnPage(1).map(function(id, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        idx > 0 && ", ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantName, {
                                            sessionId: id
                                        }, id)
                                    ]
                                }, id);
                            })
                        })
                    })
                ]
            }),
            icon: screens.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                size: 24
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeIcon/* HomeIcon */.t, {
                size: 24
            }),
            onClick: function() {
                return handleClickPage(1);
            }
        }, 
    ];
    for(var i = 2; i <= pages; i++)_loop(i);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Theme.ThemeScope, {
        theme: "dark",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "be9bef0e17ce133a",
                        [
                            PAGINATION_HEIGHT
                        ]
                    ]
                ]) + " " + "bar",
                children: [
                    count < 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "be9bef0e17ce133a",
                                [
                                    PAGINATION_HEIGHT
                                ]
                            ]
                        ]) + " " + "waiting",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            children: t("people.waitingForOthers")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.MenuButton, {
                        "aria-controls": "mobile-page-menu",
                        className: "page-menu-btn",
                        id: "mobile-page-menu-btn",
                        onClick: handleClickMenuButton,
                        open: showMenu,
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "be9bef0e17ce133a",
                                        [
                                            PAGINATION_HEIGHT
                                        ]
                                    ]
                                ]) + " " + "page",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        children: page === 1 ? screens.length ? t("general.screenShare") : t("general.homePage") : t("general.page", {
                                            page: page
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretUpIcon/* CaretUpIcon */.y, {
                                        size: 16
                                    })
                                ]
                            }),
                            peopleInCall
                        ]
                    }),
                    showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                        "aria-labelledby": "mobile-page-menu-btn",
                        id: "mobile-page-menu",
                        items: menuItems,
                        onClose: function() {
                            return setShowMenu(false);
                        },
                        placement: "top",
                        offsetLeft: -8,
                        cardProps: {
                            style: {
                                maxHeight: "50vh",
                                maxWidth: 360,
                                overflowX: "hidden",
                                overflowY: "auto",
                                width: "calc(100vw - 16px)"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutCountdown, {})
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "be9bef0e17ce133a",
                dynamic: [
                    PAGINATION_HEIGHT
                ],
                children: ".bar.__jsx-style-dynamic-selector{--status-gap:2px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:-webkit-calc(-webkit-calc(".concat(PAGINATION_HEIGHT, "px - 32px) / 2)16px;padding:-moz-calc(-moz-calc(").concat(PAGINATION_HEIGHT, "px - 32px) / 2)16px;padding:calc(calc(").concat(PAGINATION_HEIGHT, "px - 32px) / 2)16px;width:100%}.waiting.__jsx-style-dynamic-selector{margin:0 auto}.bar.__jsx-style-dynamic-selector .page-menu-btn{-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:100%}.bar.__jsx-style-dynamic-selector .page-menu-btn .page.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px}")
            })
        ]
    });
};
// @ts-ignore
var ParticipantName = function(param) {
    var sessionId = param.sessionId;
    var ref = MobilePaginationBar_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref[0];
    var name = useDisplayName(sessionId, showNames);
    return name;
};

;// CONCATENATED MODULE: ./components/Tray/BreakoutLeaveMenuContent.tsx
function BreakoutLeaveMenuContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BreakoutLeaveMenuContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BreakoutLeaveMenuContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BreakoutLeaveMenuContent_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = BreakoutLeaveMenuContent_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function BreakoutLeaveMenuContent_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var BreakoutLeaveMenuContent = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var onClickLeaveCall = _param.onClickLeaveCall, onClickLeaveRoom = _param.onClickLeaveRoom, props = BreakoutLeaveMenuContent_objectWithoutProperties(_param, [
        "onClickLeaveCall",
        "onClickLeaveRoom"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", BreakoutLeaveMenuContent_objectSpread({}, props, {
        className: "jsx-53089f6563f236c9" + " " + (props && props.className != null && props.className || "breakout-leave-menu-content"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-leave-room",
                        className: "breakout-leave-room-btn",
                        /*#__PURE__*/ fullWidth: true,
                        onClick: onClickLeaveRoom,
                        variant: "primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            color: "inherit",
                            variant: "strong",
                            children: (0,i18next.t)("breakouts.leaveToMain")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "breakouts-leave-call",
                        className: "breakout-leave-call-btn",
                        fullWidth: true,
                        onClick: onClickLeaveCall,
                        variant: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "strong",
                            children: (0,i18next.t)("breakouts.leaveEntirely")
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "53089f6563f236c9",
                children: ".breakout-leave-menu-content.jsx-53089f6563f236c9 .card-content{display:grid;gap:10px;height:auto;min-width:225px;padding:15px}"
            })
        ]
    }));
});

BreakoutLeaveMenuContent.displayName = "BreakoutLeaveMenuContent";

;// CONCATENATED MODULE: ./components/MobileView/MobileTopBar.tsx
function MobileTopBar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileTopBar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobileTopBar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function MobileTopBar_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                MobileTopBar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                MobileTopBar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function MobileTopBar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobileTopBar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileTopBar_slicedToArray(arr, i) {
    return MobileTopBar_arrayWithHoles(arr) || MobileTopBar_iterableToArrayLimit(arr, i) || MobileTopBar_unsupportedIterableToArray(arr, i) || MobileTopBar_nonIterableRest();
}
function MobileTopBar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileTopBar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileTopBar_arrayLikeToArray(o, minLen);
}






















var MobileTopBar = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref7 = (0,CallProvider/* useCallState */.oz)(), enableCallButtons = ref7.enableCallButtons, leaveCall = ref7.leaveCall;
    var ref1 = MobileTopBar_slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 1), showFullscreenButton = ref1[0];
    var ref2 = MobileTopBar_slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 1), showLeaveButton = ref2[0];
    var ref3 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref3.broadcastRole, poweredByDaily = ref3.poweredByDaily;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref4 = MobileTopBar_slicedToArray((0,layout/* useMobileTray */.UX)(), 1), showMobileTray = ref4[0];
    var topbarRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), /*#__PURE__*/ showBreakoutLeaveMenu = ref5[0], setShowBreakoutLeaveMenu = ref5[1];
    var ref6 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), currentBreakoutRoom = ref6.currentBreakoutRoom, hasJoinedBreakout = ref6.hasJoinedBreakout;
    var leaveBreakout = useBreakouts().leaveBreakout;
    var reverseCamera = function() {
        var _ref = MobileTopBar_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return daily.cycleCamera();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reverseCamera() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateHeaderHeight = (0,react.useCallback)(function() {
        if (!topbarRef.current) return;
        var ref = topbarRef.current.getBoundingClientRect(), height = ref.height, top = ref.top;
        document.body.style.setProperty("--header-height", "".concat(height + top, "px"));
    }, []);
    (0,useResize.useResize)(updateHeaderHeight);
    (0,react.useEffect)(function() {
        updateHeaderHeight();
    }, [
        poweredByDaily,
        updateHeaderHeight
    ]);
    var handleLeaveButtonClick = (0,react.useCallback)(function() {
        if (hasJoinedBreakout) {
            setShowBreakoutLeaveMenu(function(show) {
                return !show;
            });
            return;
        }
        leaveCall();
    }, [
        hasJoinedBreakout,
        leaveCall,
        setShowBreakoutLeaveMenu
    ]);
    var handleClickLeaveRoom = function() {
        leaveBreakout(true);
        setShowBreakoutLeaveMenu(false);
    };
    var handleCloseLeaveMenu = function() {
        setShowBreakoutLeaveMenu(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: topbarRef,
        className: "jsx-8a0ff70bca53e57d" + " " + (classnames_default()("mobile-topbar", {
            hidden: !showMobileTray
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8a0ff70bca53e57d" + " " + "button-container",
                children: [
                    broadcastRole !== "attendee" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button.Button, {
                        id: "mobile-cam-switch",
                        className: "cam-switch",
                        onClick: reverseCamera,
                        disabled: !showMobileTray,
                        onTouchStart: function(e) {
                            return e.stopPropagation();
                        },
                        variant: "ghost",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReverseIcon/* ReverseIcon */.E, {
                                size: 24,
                                className: "icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden.VisuallyHidden, {
                                children: t("video.changeCamera")
                            })
                        ]
                    }),
                    showFullscreenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8a0ff70bca53e57d" + " " + "message",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordingState, {}),
                    hasJoinedBreakout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        color: "white",
                        variant: "strong",
                        children: t("breakouts.roomWithName", {
                            name: currentBreakoutRoom.name
                        })
                    }) : null
                ]
            }),
            showLeaveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                className: "leave",
                disabled: !enableCallButtons || !showMobileTray,
                id: "btn-leave-mobile",
                onClick: handleLeaveButtonClick,
                variant: hasJoinedBreakout ? "primary" : "danger",
                onTouchStart: function(e) {
                    return e.stopPropagation();
                },
                children: hasJoinedBreakout ? t("general.exitWithOptions") : t("general.leave")
            }),
            showBreakoutLeaveMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "right",
                "aria-labelledby": "btn-leave-mobile",
                id: "breakout-leave-menu-mobile",
                placement: "bottom",
                onClose: handleCloseLeaveMenu,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutLeaveMenuContent, {
                    onClickLeaveCall: leaveCall,
                    onClickLeaveRoom: handleClickLeaveRoom
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "739acbabc64af175",
                children: ":root{--header-height:0}"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c54c5679f050dd0b",
                children: ".mobile-topbar.jsx-8a0ff70bca53e57d{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:-webkit-linear-gradient(top,var(--backdrop),var(--backdrop-hidden));background:-moz-linear-gradient(top,var(--backdrop),var(--backdrop-hidden));background:-o-linear-gradient(top,var(--backdrop),var(--backdrop-hidden));background:linear-gradient(to bottom,var(--backdrop),var(--backdrop-hidden));display:grid;gap:8px;grid-template-columns:1fr auto 1fr;justify-items:center;opacity:1;padding:4px 12px 32px;position:absolute;top:0;-webkit-transition:opacity.2s ease,-webkit-transform.2s ease;-moz-transition:opacity.2s ease,-moz-transform.2s ease;-o-transition:opacity.2s ease,-o-transform.2s ease;transition:opacity.2s ease,-webkit-transform.2s ease;transition:opacity.2s ease,-moz-transform.2s ease;transition:opacity.2s ease,-o-transform.2s ease;transition:opacity.2s ease,transform.2s ease;width:100%;z-index:10}.mobile-topbar.hidden.jsx-8a0ff70bca53e57d{opacity:0;-webkit-transform:translateY(-100%);-moz-transform:translateY(-100%);-ms-transform:translateY(-100%);-o-transform:translateY(-100%);transform:translateY(-100%)}.mobile-topbar.jsx-8a0ff70bca53e57d .button-container.jsx-8a0ff70bca53e57d{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-right:auto}.mobile-topbar.jsx-8a0ff70bca53e57d .cam-switch{margin-left:0;padding:12px}.mobile-topbar.jsx-8a0ff70bca53e57d .leave{grid-column-start:3;margin-left:auto}.message.jsx-8a0ff70bca53e57d{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:0;grid-column-start:2;margin:0 auto}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/MobileView/Page.tsx
function Page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Page_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Page_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Page_arrayLikeToArray(arr);
}
function Page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Page_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Page_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Page_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Page_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Page_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Page_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Page_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Page_slicedToArray(arr, i) {
    return Page_arrayWithHoles(arr) || Page_iterableToArrayLimit(arr, i) || Page_unsupportedIterableToArray(arr, i) || Page_nonIterableRest();
}
function Page_toConsumableArray(arr) {
    return Page_arrayWithoutHoles(arr) || Page_iterableToArray(arr) || Page_unsupportedIterableToArray(arr) || Page_nonIterableSpread();
}
function Page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Page_arrayLikeToArray(o, minLen);
}














var Page = function(_param) {
    var active = _param.active, className = _param.className, index = _param.index, _isBufferPage = _param.isBufferPage, isBufferPage = _isBufferPage === void 0 ? false : _isBufferPage, sessionIds = _param.sessionIds, props = Page_objectWithoutProperties(_param, [
        "active",
        "className",
        "index",
        "isBufferPage",
        "sessionIds"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    var enableEmojiReactions = (0,useCallConfig/* useCallConfig */.A)().enableEmojiReactions;
    var ref6 = Page_slicedToArray((0,custom/* useShowNames */.zD)(), 1), showNames = ref6[0];
    var ref1 = (0,useStyleVariants/* useStyleVariants */._)(), isPortrait = ref1.mobilePortrait;
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var pageRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)({
        height: 1,
        width: 1
    }), /*#__PURE__*/ pageDimensions = ref2[0], setPageDimensions = ref2[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var offScreenSessionIds = (0,react.useMemo)(function() {
        return orderedParticipantIds.filter(function(id) {
            return !sessionIds.includes(id);
        });
    }, [
        orderedParticipantIds,
        sessionIds
    ]);
    var updatePageDimensions = (0,react.useCallback)(function() {
        var ref, ref3;
        var ref4, ref5;
        setPageDimensions({
            height: (ref4 = (ref = pageRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) !== null && ref4 !== void 0 ? ref4 : 1,
            width: (ref5 = ((ref3 = pageRef.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth) - 8) !== null && ref5 !== void 0 ? ref5 : 1
        });
    }, []);
    (0,useResize.useResize)(updatePageDimensions);
    (0,react.useLayoutEffect)(updatePageDimensions, [
        active,
        updatePageDimensions
    ]);
    var tileStyle = (0,react.useMemo)(function() {
        if (!pageRef.current) return {};
        var maxHeight = pageDimensions.height, maxWidth = pageDimensions.width;
        if (isPortrait) {
            var maxHeightPerTile = maxHeight / sessionIds.length - 4;
            var ar = maxWidth / maxHeightPerTile;
            if (ar < DEFAULT_LANDSCAPE_AR) {
                return {
                    height: maxWidth / DEFAULT_LANDSCAPE_AR,
                    width: maxWidth
                };
            }
            return {
                height: maxHeightPerTile,
                width: maxHeightPerTile * DEFAULT_LANDSCAPE_AR
            };
        }
        var maxWidthPerTile = maxWidth / sessionIds.length - 4;
        var ar1 = maxWidthPerTile / maxHeight;
        if (ar1 < DEFAULT_PORTRAIT_AR) {
            return {
                height: maxWidthPerTile / DEFAULT_PORTRAIT_AR,
                width: maxWidthPerTile
            };
        }
        return {
            height: maxHeight,
            width: maxHeight * DEFAULT_PORTRAIT_AR
        };
    }, [
        isPortrait,
        pageDimensions,
        sessionIds.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", Page_objectSpread({
        ref: pageRef
    }, props, {
        className: styled_jsx_default().dynamic([
            [
                "7f073737576161a1",
                [
                    colors.custom.mainAreaBg
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || classnames_default()("page", className, {
            active: active,
            isBufferPage: isBufferPage,
            isPortrait: isPortrait
        }) || ""),
        children: [
            enableEmojiReactions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "7f073737576161a1",
                        [
                            colors.custom.mainAreaBg
                        ]
                    ]
                ]) + " " + "page-reactions",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactions, {
                    animation: "flyUp",
                    sessionIds: [
                        localSessionId
                    ].concat(Page_toConsumableArray(offScreenSessionIds))
                })
            }),
            sessionIds.map(function(sessionId, i) {
                var key = "page".concat(index, "slot").concat(i);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: tileStyle,
                    className: styled_jsx_default().dynamic([
                        [
                            "7f073737576161a1",
                            [
                                colors.custom.mainAreaBg
                            ]
                        ]
                    ]) + " " + "tile",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTile, {
                        network: sessionId === localSessionId ? threshold : null,
                        orientation: isPortrait ? "landscape" : "portrait",
                        sessionId: sessionId,
                        showNames: showNames,
                        showReactions: enableEmojiReactions
                    })
                }, key);
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "7f073737576161a1",
                dynamic: [
                    colors.custom.mainAreaBg
                ],
                children: ".page.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:4px 4px 0}.page.__jsx-style-dynamic-selector:not(.isPortrait) .tile.__jsx-style-dynamic-selector:not(:first-child){margin-left:4px}.page.isPortrait.__jsx-style-dynamic-selector{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.page.isPortrait.__jsx-style-dynamic-selector .tile.__jsx-style-dynamic-selector:not(:first-child){margin-top:4px}.page.active.__jsx-style-dynamic-selector{background:".concat(colors.custom.mainAreaBg, ";z-index:5}.page.isBufferPage.__jsx-style-dynamic-selector{opacity:0;-webkit-transition-duration:0ms!important;-moz-transition-duration:0ms!important;-o-transition-duration:0ms!important;transition-duration:0ms!important;visiblity:hidden}.page.__jsx-style-dynamic-selector .page-reactions.__jsx-style-dynamic-selector{bottom:0;position:absolute;right:85px}")
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/MobileView/SwipeContainer.tsx



var SwipeContainer = function(param) {
    var children = param.children, onChangePage = param.onChangePage, onSwipe = param.onSwipe, page = param.page, pages1 = param.pages;
    var swipeRef = (0,react.useRef)(null);
    var dragStartTime = (0,react.useRef)(null);
    var dragStart = (0,react.useRef)(0);
    var dragDelta = (0,react.useRef)(0);
    /**
   * Automatically switch to last page, e.g. when only participant on last page leaves.
   */ (0,react.useEffect)(function() {
        if (page > pages1) {
            onChangePage(pages1);
        }
    }, [
        onChangePage,
        page,
        pages1
    ]);
    var preparePagesX = function() {
        var ref;
        var pages = Array.from((ref = swipeRef.current) === null || ref === void 0 ? void 0 : ref.childNodes).filter(function(el) {
            return !el.classList.contains("hidden");
        });
        pages.forEach(function(el) {
            el.style.transitionDuration = "0ms";
        });
    };
    var updatePagesX = (0,react.useCallback)(function(delta) {
        var ref;
        var pages = Array.from((ref = swipeRef.current) === null || ref === void 0 ? void 0 : ref.childNodes).filter(function(el) {
            return !el.classList.contains("hidden");
        });
        pages.forEach(function(el) {
            var elPage = parseInt(el.dataset["page"], 10);
            switch(elPage - page){
                case 0:
                    // same page
                    el.style.transform = "translate3d(".concat(delta, "px, 0, 0)");
                    break;
                case 1:
                    // next page
                    el.style.transform = "translate3d(calc(100vw + ".concat(delta, "px), 0, 0)");
                    break;
                case -1:
                    // prev page
                    el.style.transform = "translate3d(calc(-100vw + ".concat(delta, "px), 0, 0)");
                    break;
            }
        });
    }, [
        page
    ]);
    var resetPagesX = (0,react.useCallback)(function(delta) {
        var ref;
        var pages = Array.from((ref = swipeRef.current) === null || ref === void 0 ? void 0 : ref.childNodes).filter(function(el) {
            return !el.classList.contains("hidden");
        });
        pages.forEach(function(el) {
            el.style.transitionDuration = "";
        });
        updatePagesX(delta);
    }, [
        updatePagesX
    ]);
    var handleTouchStart = (0,react.useCallback)(function(ev) {
        if (ev.touches.length > 1) return;
        dragStartTime.current = new Date();
        dragStart.current = ev.touches[0].clientX;
        dragDelta.current = 0;
        preparePagesX();
    }, []);
    /**
   * Setup touchmove handler
   */ var moveFrame = (0,react.useRef)(null);
    var handleTouchMove = (0,react.useCallback)(function(ev) {
        if (pages1 === 1 || ev.touches.length > 1) return;
        if (moveFrame.current) cancelAnimationFrame(moveFrame.current);
        var pageWidth = swipeRef.current.clientWidth;
        var newDelta = ev.touches[0].clientX - dragStart.current;
        var newDragDelta;
        if (newDelta < 0) {
            var maxDrag = page === pages1 ? pageWidth / 6 : pageWidth;
            newDragDelta = Math.max(-maxDrag, newDelta);
        } else {
            var maxDrag1 = page === 1 ? pageWidth / 6 : pageWidth;
            newDragDelta = Math.min(maxDrag1, newDelta);
        }
        if (Math.abs(newDragDelta) > 3) {
            ev.stopPropagation();
        }
        dragDelta.current = newDragDelta;
        moveFrame.current = requestAnimationFrame(function() {
            onSwipe === null || onSwipe === void 0 ? void 0 : onSwipe(newDragDelta / pageWidth);
            updatePagesX(newDragDelta);
        });
    }, [
        dragDelta,
        dragStart,
        moveFrame,
        onSwipe,
        page,
        pages1,
        swipeRef,
        updatePagesX, 
    ]);
    (0,react.useEffect)(function() {
        var swipe = swipeRef.current;
        if (!swipe) return;
        swipe.addEventListener("touchmove", handleTouchMove, {
            passive: true
        });
        return function() {
            if (moveFrame.current) cancelAnimationFrame(moveFrame.current);
            swipe.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        handleTouchMove
    ]);
    (0,react.useEffect)(function() {
        var swipe = swipeRef.current;
        if (!swipe) return;
        var handleTouchEnd = function(ev) {
            var ref;
            if (!dragStartTime.current) return;
            if (moveFrame.current) cancelAnimationFrame(moveFrame.current);
            var pageWidth = swipeRef.current.clientWidth;
            var time = new Date().getTime() - ((ref = dragStartTime.current) === null || ref === void 0 ? void 0 : ref.getTime());
            var speed = dragDelta.current / time;
            dragStartTime.current = null;
            dragStart.current = 0;
            var next = (dragDelta.current < -pageWidth / 2 || speed < -0.25) && page < pages1;
            var prev = (dragDelta.current > pageWidth / 2 || speed > 0.25) && page > 1;
            if (next) {
                resetPagesX(-pageWidth);
                onChangePage(Math.min(pages1, page + 1));
            } else if (prev) {
                resetPagesX(pageWidth);
                onChangePage(Math.max(1, page - 1));
            } else {
                resetPagesX(0);
                onSwipe === null || onSwipe === void 0 ? void 0 : onSwipe(0);
            }
            if (Math.abs(dragDelta.current) > 3) {
                ev.stopPropagation();
            }
        };
        swipe.addEventListener("touchstart", handleTouchStart, {
            passive: true
        });
        swipe.addEventListener("touchend", handleTouchEnd, {
            passive: true
        });
        return function() {
            swipe.removeEventListener("touchstart", handleTouchStart);
            swipe.removeEventListener("touchend", handleTouchEnd);
        };
    }, [
        handleTouchStart,
        onChangePage,
        onSwipe,
        page,
        pages1,
        resetPagesX,
        swipeRef,
        updatePagesX, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: swipeRef,
        className: "jsx-c56d0c10555affe1" + " " + "swipe",
        children: [
            children,
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c56d0c10555affe1",
                children: ".swipe.jsx-c56d0c10555affe1{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:relative}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/MobileView/MobileCall.tsx
function MobileCall_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileCall_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobileCall_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return MobileCall_arrayLikeToArray(arr);
}
function MobileCall_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileCall_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function MobileCall_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobileCall_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileCall_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileCall_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileCall_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MobileCall_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MobileCall_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MobileCall_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function MobileCall_slicedToArray(arr, i) {
    return MobileCall_arrayWithHoles(arr) || MobileCall_iterableToArrayLimit(arr, i) || MobileCall_unsupportedIterableToArray(arr, i) || MobileCall_nonIterableRest();
}
function MobileCall_toConsumableArray(arr) {
    return MobileCall_arrayWithoutHoles(arr) || MobileCall_iterableToArray(arr) || MobileCall_unsupportedIterableToArray(arr) || MobileCall_nonIterableSpread();
}
function MobileCall_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileCall_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileCall_arrayLikeToArray(o, minLen);
}






















var MAX_RENDERED_PAGES = 6;
var MAX_CAROUSEL_PAGES = MAX_RENDERED_PAGES - 2;
var CURRENT_PAGE_SUBSCRIPTION_DELAY = 400;
var ADJACENT_PAGES_SUBSCRIPTION_DELAY = 2000;
var MobileCall = function(param) {
    var _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 3 : _pageSize;
    var colors = (0,Theme.useTheme)().colors;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var topology = (0,daily_react_esm/* useNetwork */.LN)().topology;
    var currentSpeakerId = (0,ParticipantsProvider/* useCurrentSpeakerId */.EF)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var subscribeToCam = useTracks().subscribeToCam;
    var ref6 = MobileCall_slicedToArray((0,layout/* useShowMobileMoreMenu */.DE)(), 2), setShowMoreMenu = ref6[1];
    var ref1 = MobileCall_slicedToArray((0,layout/* useShowMobilePageMenu */.C$)(), 2), setShowPageMenu = ref1[1];
    var ref2 = MobileCall_slicedToArray((0,layout/* useMobileTray */.UX)(), 2), setShowMobileTray = ref2[1];
    var isJoiningBreakout = useRenderBreakoutsInterstitialScreen();
    var ref3 = (0,react.useState)(1), /*#__PURE__*/ page = ref3[0], setPage = ref3[1];
    var callRef = (0,react.useRef)(null);
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var screens = (0,useScreens/* useScreens */.O)();
    useJoinSound();
    var pages = (0,react.useMemo)(function() {
        if (orderedParticipantIds.length <= 1) return 1;
        return 1 + Math.ceil(orderedParticipantIds.length / pageSize);
    }, [
        pageSize,
        orderedParticipantIds.length
    ]);
    var previousPage = (0,usePreviousValue/* usePreviousValue */.z)(page);
    var previousRenderedPages = (0,react.useRef)(null);
    /**
   * Determine rendered pages.
   */ var renderedPages = (0,react.useMemo)(function() {
        if (pages <= MAX_RENDERED_PAGES) {
            // All pages fit within one chunk
            return new Array(pages).fill(0).map(function(_, i) {
                return i + 1;
            });
        }
        if (page <= MAX_CAROUSEL_PAGES) {
            // User is viewing first chunk of pages
            return MobileCall_toConsumableArray(new Array(MAX_RENDERED_PAGES - 1).fill(0).map(function(_, i) {
                return i + 1;
            })).concat([
                pages, 
            ]);
        }
        if ([
            page - 1,
            page,
            Math.min(page + 1, pages)
        ].every(function(p) {
            return previousRenderedPages.current.includes(p);
        })) {
            // All important pages are already present from a previous memoization cycle.
            // No need to recalculate ☺️
            return previousRenderedPages.current;
        }
        if (Math.abs(page - previousPage) > 1) {
            // User navigated using pagination dots
            return [
                1, 
            ].concat(MobileCall_toConsumableArray(new Array(MAX_CAROUSEL_PAGES).fill(0).map(function(_, i) {
                return page + (i - 1);
            })), [
                pages, 
            ]);
        }
        if (page === previousPage) {
            var _Math, _Math1;
            // Page hasn't changed, but pages and one of the adjacent pages is missing.
            var missingPage = [
                page - 1,
                page,
                Math.min(page + 1, pages)
            ].find(function(p) {
                return !previousRenderedPages.current.includes(p);
            });
            var swapPage = missingPage > page ? (_Math = Math).min.apply(_Math, MobileCall_toConsumableArray(previousRenderedPages.current.filter(function(p) {
                return p > 1;
            }))) : (_Math1 = Math).max.apply(_Math1, MobileCall_toConsumableArray(previousRenderedPages.current.filter(function(p) {
                return p < pages;
            })));
            var idx = previousRenderedPages.current.findIndex(function(p) {
                return p === swapPage;
            });
            var newPages = MobileCall_toConsumableArray(previousRenderedPages.current);
            if (missingPage && idx >= 0) {
                newPages[idx] = missingPage;
                return newPages;
            }
        }
        // Determine buffer page and promote it to be a new adjacent page
        var swapIndex = previousRenderedPages.current.findIndex(function(p) {
            return p !== 1 && p !== pages && (previousPage < page ? p < previousPage - 1 : p > previousPage + 1);
        });
        var newPages1 = MobileCall_toConsumableArray(previousRenderedPages.current);
        if (swapIndex >= 0) {
            if (previousPage < page) {
                // Example: [1,2,3,4,(5),10] => [1,6,3,4,(5),10]
                newPages1[swapIndex] = page + 1;
            } else {
                // Example: [1,(6),7,8,9,10] => [1,(6),7,8,5,10]
                newPages1[swapIndex] = page - 1;
            }
        }
        return newPages1;
    }, [
        page,
        pages,
        previousPage
    ]);
    (0,react.useEffect)(function() {
        previousRenderedPages.current = MobileCall_toConsumableArray(renderedPages);
    }, [
        renderedPages
    ]);
    var getParticipantsOnPage = (0,react.useCallback)(function(p) {
        if (p === 1) {
            var ids = [];
            if (broadcastRole !== "attendee") {
                ids.push(localSessionId);
            }
            ids.push(currentSpeakerId);
            return MobileCall_toConsumableArray(new Set(ids));
        }
        return orderedParticipantIds.slice(Math.max(0, pageSize * (p - 2)), Math.min(orderedParticipantIds.length, pageSize * (p - 1)));
    }, [
        broadcastRole,
        currentSpeakerId,
        localSessionId,
        orderedParticipantIds,
        pageSize, 
    ]);
    /**
   * Automatically switch to page 1, when a screen share starts.
   */ var prevScreens = (0,usePreviousValue/* usePreviousValue */.z)(screens.length);
    (0,react.useEffect)(function() {
        if (screens.length <= prevScreens) return;
        setPage(1);
    }, [
        screens.length,
        prevScreens
    ]);
    var updateReceiveSettings = (0,daily_react_esm/* useReceiveSettings */.NC)().updateReceiveSettings;
    /**
   * Set bandwidth layer based on visible participants
   */ (0,react.useEffect)(function() {
        if (topology !== "sfu") return;
        var receiveSettings = orderedParticipantIds.reduce(function(settings, id) {
            settings[id] = {
                video: {
                    layer: page === 1 && id === currentSpeakerId ? 1 : 0
                }
            };
            return settings;
        }, {});
        if (Object.keys(receiveSettings).length === 0) return;
        updateReceiveSettings(receiveSettings);
    }, [
        currentSpeakerId,
        orderedParticipantIds,
        page,
        topology,
        updateReceiveSettings, 
    ]);
    /**
   * Subscribe to videos on current page, delaying subscribing to
   * not-already-staged ones as a resource usage optimization.
   */ (0,react.useEffect)(function() {
        if (!daily) return;
        var users = daily.participants();
        /**
     * First we try to subscribe to videos that are already staged.
     */ var isStaged = function(id) {
            var ref, ref4, ref5;
            return ((ref = users[id]) === null || ref === void 0 ? void 0 : (ref4 = ref.tracks) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.video) === null || ref5 === void 0 ? void 0 : ref5.subscribed) === "staged";
        };
        if (page === 1) {
            if (isStaged(currentSpeakerId)) subscribeToCam(currentSpeakerId);
            return;
        }
        getParticipantsOnPage(page).forEach(function(id) {
            if (isStaged(id)) subscribeToCam(id);
        });
        /**
     * If the user stays on page, subscribe to not-already-staged videos.
     */ var timeout = setTimeout(function() {
            getParticipantsOnPage(page).forEach(function(id) {
                subscribeToCam(id);
            });
        }, CURRENT_PAGE_SUBSCRIPTION_DELAY);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        currentSpeakerId,
        daily,
        getParticipantsOnPage,
        page,
        pageSize,
        subscribeToCam, 
    ]);
    /**
   * Memoize subscribed & staged ids.
   */ var camSubscriptions = (0,react.useMemo)(function() {
        var renderedOrBufferedIds = [
            currentSpeakerId
        ];
        // Buffer adjacent pages (meaning allow staging subscriptions for them)
        for(var p = Math.max(1, page - 1); p <= Math.min(pages, page + 1); p++){
            var _renderedOrBufferedIds;
            (_renderedOrBufferedIds = renderedOrBufferedIds).push.apply(_renderedOrBufferedIds, MobileCall_toConsumableArray(getParticipantsOnPage(p)));
        }
        var renderedIds = page === 1 ? [
            currentSpeakerId
        ] : getParticipantsOnPage(page);
        var stagedIds = renderedOrBufferedIds.filter(function(id) {
            return !renderedIds.includes(id);
        });
        return {
            stagedIds: stagedIds,
            subscribedIds: renderedIds
        };
    }, [
        currentSpeakerId,
        getParticipantsOnPage,
        page,
        pages
    ]);
    useCamSubscriptions(camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.subscribedIds, camSubscriptions === null || camSubscriptions === void 0 ? void 0 : camSubscriptions.stagedIds, ADJACENT_PAGES_SUBSCRIPTION_DELAY);
    var content = (0,react.useMemo)(function() {
        return renderedPages.map(function(p, i) {
            var isBufferPage = ![
                1,
                pages,
                page - 1,
                page,
                page + 1
            ].includes(p);
            var props = {
                key: "page".concat(i),
                active: page === p,
                className: "swipe-page",
                "data-page": p,
                style: {
                    transform: "translate3d(".concat(Math.max(-200, Math.min(200, 100 * (p - page))), "vw, 0, 0)")
                }
            };
            var ids = orderedParticipantIds.slice((p - 2) * pageSize, (p - 1) * pageSize);
            var _active = props.active, homeProps = MobileCall_objectWithoutProperties(props, [
                "active"
            ]);
            return p === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, MobileCall_objectSpread({}, homeProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, MobileCall_objectSpread({
                index: i,
                isBufferPage: isBufferPage,
                sessionIds: ids
            }, props));
        });
    }, [
        orderedParticipantIds,
        page,
        pages,
        pageSize,
        renderedPages
    ]);
    var handleChangePage = function(p) {
        setPage(p);
    };
    var handleTouchEnd = (0,react.useCallback)(function(e) {
        var ref;
        var target = e.target;
        // don't hide the tray if the user is pressing a button
        if ((target === null || target === void 0 ? void 0 : target.closest("button")) || (target === null || target === void 0 ? void 0 : (ref = target.tagName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "button" || e.touches.length > 1) return;
        // close the menu whenever the tray closes
        setShowMoreMenu(false);
        setShowPageMenu(false);
        setShowMobileTray(function(showMobileTray) {
            return !showMobileTray;
        });
    }, [
        setShowMobileTray,
        setShowMoreMenu,
        setShowPageMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isJoiningBreakout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JoiningBreakoutRoomScreen, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: styled_jsx_default().dynamic([
                [
                    "9ac15362f5b2227a",
                    [
                        colors.custom.mainAreaBg,
                        PAGINATION_HEIGHT
                    ]
                ]
            ]) + " " + "mobile-call",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTopBar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: callRef,
                    onTouchEnd: handleTouchEnd,
                    className: styled_jsx_default().dynamic([
                        [
                            "9ac15362f5b2227a",
                            [
                                colors.custom.mainAreaBg,
                                PAGINATION_HEIGHT
                            ]
                        ]
                    ]) + " " + "call",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeContainer, {
                        onChangePage: handleChangePage,
                        page: page,
                        pages: pages,
                        children: content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styled_jsx_default().dynamic([
                        [
                            "9ac15362f5b2227a",
                            [
                                colors.custom.mainAreaBg,
                                PAGINATION_HEIGHT
                            ]
                        ]
                    ]) + " " + "pagination",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePaginationBar, {
                        getParticipantsOnPage: getParticipantsOnPage,
                        onChangePage: setPage,
                        page: page,
                        pages: pages
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTray, {}),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "9ac15362f5b2227a",
                    dynamic: [
                        colors.custom.mainAreaBg,
                        PAGINATION_HEIGHT
                    ],
                    children: ".mobile-call.__jsx-style-dynamic-selector{background-color:".concat(colors.custom.mainAreaBg, ";display:grid;grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(0,1fr)").concat(PAGINATION_HEIGHT, 'px;grid-template-areas:"call""pagination";height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:relative;width:100%}.call.__jsx-style-dynamic-selector{grid-area:call}.call.__jsx-style-dynamic-selector .swipe-page{content-visibility:auto;height:100%;position:absolute;-webkit-transition:-webkit-transform.25s ease;-moz-transition:-moz-transform.25s ease;-o-transition:-o-transform.25s ease;transition:-webkit-transform.25s ease;transition:-moz-transform.25s ease;transition:-o-transform.25s ease;transition:transform.25s ease;width:100%}.call.__jsx-style-dynamic-selector .swipe-page.swiping{-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}.pagination.__jsx-style-dynamic-selector{grid-area:pagination}')
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./components/MobileView/MobileView.tsx
function MobileView_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileView_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobileView_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobileView_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileView_slicedToArray(arr, i) {
    return MobileView_arrayWithHoles(arr) || MobileView_iterableToArrayLimit(arr, i) || MobileView_unsupportedIterableToArray(arr, i) || MobileView_nonIterableRest();
}
function MobileView_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileView_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileView_arrayLikeToArray(o, minLen);
}




















var MobileView = function() {
    var mobileRef = (0,react.useRef)(null);
    var poweredByDaily = (0,useCallConfig/* useCallConfig */.A)().poweredByDaily;
    var ref = useWaitingRoom(), setShowModal = ref.setShowModal, showModal = ref.showModal;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var isJoiningBreakout = useRenderBreakoutsInterstitialScreen();
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var breakoutHost = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().breakoutHost;
    var handleModalClose = function() {
        return setShowModal(false);
    };
    var ref1 = MobileView_slicedToArray((0,core/* useSidebarView */.oS)(), 1), sideBarView = ref1[0];
    var sideBarIsOpen = sideBarView !== null;
    var isLargeScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    /* The mobile sidebar is rendered on big enough screens on the side, so we need to take that into account here. */ var addExtraSpaceForSnackbars = isLargeScreen && sideBarIsOpen && !isJoiningBreakout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: mobileRef,
        className: "jsx-49b455f5fc5ec3b8" + " " + "mobile",
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "jsx-49b455f5fc5ec3b8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCall, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioTracks, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Snackbar/* SnackbarPresenter */.O9, {
                style: {
                    right: "".concat(addExtraSpaceForSnackbars ? Number(lib_constants/* MOBILE_SIDEBAR_WIDTH */.oi) + 8 : 8, "px")
                }
            }),
            isLocalOwner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomNotification, {}),
                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomModal, {
                        onClose: handleModalClose
                    })
                ]
            }),
            breakoutHost === localSessionId && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutHostHelpNotification, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "49b455f5fc5ec3b8",
                children: ".mobile.jsx-49b455f5fc5ec3b8{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;overflow:hidden;position:relative;width:100%}main.jsx-49b455f5fc5ec3b8{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;position:relative;width:100%}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/MobileView/index.ts



;// CONCATENATED MODULE: ./components/Haircheck/CTAContent.tsx















var CTAContent = function(param) {
    var accessState = param.accessState, camState = param.camState, hasCamError = param.hasCamError, hasMicError = param.hasMicError, micState = param.micState, onCancelClick = param.onCancelClick, onComplete = param.onComplete, requestState = param.requestState, shouldUseLandscapeLayout = param.shouldUseLandscapeLayout;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var broadcastRole = (0,useCallConfig/* useCallConfig */.A)().broadcastRole;
    var isLargeScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var isSmallScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var hasNoErrors = !hasCamError && !hasMicError;
    var joinWithoutText = (0,react.useMemo)(function() {
        if (accessState === "lobby") {
            var requestJoinWithoutX = t("haircheck.setup.requestJoinWithoutDevices");
            if (hasCamError && !hasMicError) {
                requestJoinWithoutX = t("haircheck.setup.requestJoinWithoutCam");
            }
            if (hasMicError && !hasCamError) {
                requestJoinWithoutX = t("haircheck.setup.requestJoinWithoutMic");
            }
            return requestJoinWithoutX;
        }
        var joinWithoutX = t("haircheck.setup.joinWithoutDevices");
        if (hasCamError && !hasMicError) {
            joinWithoutX = t("haircheck.setup.joinWithoutCam");
        }
        if (hasMicError && !hasCamError) {
            joinWithoutX = t("haircheck.setup.joinWithoutMic");
        }
        return joinWithoutX;
    }, [
        accessState,
        hasCamError,
        hasMicError,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        /*#__PURE__*/ children: requestState === "waiting" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    horizontal: !shouldUseLandscapeLayout && !isSmallScreen,
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: "largestrong",
                            children: t("haircheck.setup.titleWaiting")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                    onClick: onCancelClick,
                    underline: true,
                    className: robotsClassName("btn-cancel-request"),
                    children: t("haircheck.setup.cancelRequest")
                })
            ]
        }) : hasNoErrors ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-92d17888a23f1f5a" + " " + (classnames_default()("no-errors-content", {
                horizontal: !shouldUseLandscapeLayout && !isSmallScreen,
                landscape: shouldUseLandscapeLayout
            }) || ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "largestrong",
                    textAlign: shouldUseLandscapeLayout || isSmallScreen ? "center" : "left",
                    children: t("haircheck.setup.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                    style: {
                        width: isSmallScreen && "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        id: "haircheck-join",
                        className: robotsClassName("btn-join"),
                        disabled: camState === "pending" || micState === "pending",
                        onClick: onComplete,
                        fullWidth: isSmallScreen,
                        children: broadcastRole === "owner" ? t("haircheck.setup.joinBroadcast") : accessState === "lobby" ? t("haircheck.setup.requestToJoin") : t("general.joinMeeting")
                    })
                }),
                (shouldUseLandscapeLayout || isSmallScreen) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: !isLargeScreen ? {
                        flex: "1 1 100%"
                    } : {},
                    className: "jsx-92d17888a23f1f5a",
                    children: [
                        accessState === "lobby" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {}),
                        broadcastRole === "owner" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                textAlign: "center",
                                color: "muted",
                                children: t("haircheck.setup.joinAsPresenter")
                            })
                        })
                    ]
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "92d17888a23f1f5a",
                    children: ".no-errors-content.jsx-92d17888a23f1f5a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:8px;width:100%;padding:0 16px}.no-errors-content.horizontal.jsx-92d17888a23f1f5a{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:0 24px}.no-errors-content.landscape.jsx-92d17888a23f1f5a{padding:0}"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
            align: "center",
            justify: "center",
            gap: shouldUseLandscapeLayout ? 24 : 16,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    style: {},
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                        onClick: onComplete,
                        underline: true,
                        className: robotsClassName("btn-join"),
                        children: joinWithoutText
                    })
                }),
                accessState === "lobby" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {}),
                broadcastRole === "owner" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        textAlign: "center",
                        color: "muted",
                        children: t("haircheck.setup.joinAsPresenter")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/EffectsIcon.js
var EffectsIcon = __webpack_require__(1353);
// EXTERNAL MODULE: ../shared/dist/components/Icons/NoiseCancellationIconOn.js
var NoiseCancellationIconOn = __webpack_require__(6115);
;// CONCATENATED MODULE: ./components/Haircheck/NoiseCancellationControls.tsx















var NoiseCancellationControls = /*#__PURE__*/ (0,react.memo)(function(param) {
    var micState = param.micState;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var enableNoiseCancellationUI = (0,useCallConfig/* useCallConfig */.A)().enableNoiseCancellationUI;
    var ref = useAudioProcessor(), handleNoiseCancellationChange = ref.handleNoiseCancellationChange, noiseCancellationDisabled = ref.noiseCancellationDisabled, noiseCancellationOn = ref.noiseCancellationOn;
    if (!enableNoiseCancellationUI) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "noise-cancellation-btn-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            delay: TOOLTIP_DELAY,
            // disabled={noiseCancellationDisabled}
            id: "tt-noise-cancellation-controls",
            title: t("audio.enableNoiseCancellation"),
            tabIndex: -1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                id: "btn-noise-cancellation",
                className: classnames_default()("btn", robotsClassName("noise-btn")),
                disabled: micState === "pending" || noiseCancellationDisabled,
                onClick: function() {
                    return handleNoiseCancellationChange(!noiseCancellationOn);
                },
                children: [
                    noiseCancellationDisabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}) : noiseCancellationOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoiseCancellationIconOn/* NoiseCancellationIconOn */.W, {
                        backgroundColor: colors.accent
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoiseCancellationIcon/* NoiseCancellationIcon */.n, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                        on: noiseCancellationOn && !noiseCancellationDisabled,
                        onText: t("audio.noiseCancellationOnShort"),
                        offText: t("audio.noiseCancellationOffShort")
                    })
                ]
            })
        })
    });
});
NoiseCancellationControls.displayName = "NoiseCancellationControls";

;// CONCATENATED MODULE: ./components/Haircheck/SetupTray.tsx
function SetupTray_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SetupTray_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SetupTray_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SetupTray_arrayLikeToArray(arr);
}
function SetupTray_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SetupTray_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SetupTray_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SetupTray_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SetupTray_slicedToArray(arr, i) {
    return SetupTray_arrayWithHoles(arr) || SetupTray_iterableToArrayLimit(arr, i) || SetupTray_unsupportedIterableToArray(arr, i) || SetupTray_nonIterableRest();
}
function SetupTray_toConsumableArray(arr) {
    return SetupTray_arrayWithoutHoles(arr) || SetupTray_iterableToArray(arr) || SetupTray_unsupportedIterableToArray(arr) || SetupTray_nonIterableSpread();
}
function SetupTray_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SetupTray_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SetupTray_arrayLikeToArray(o, minLen);
}

























var SetupTray = function(param) {
    var cameras = param.cameras, camState = param.camState, hasMicError = param.hasMicError, micState = param.micState;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref = SetupTray_slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 1), showUserNameChangeUI = ref[0];
    var enableVideoProcessingUI = (0,useCallConfig/* useCallConfig */.A)().enableVideoProcessingUI;
    var ref1 = SetupTray_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = (0,react.useState)(false), /*#__PURE__*/ showMenu = ref2[0], setShowMenu = ref2[1];
    var ref3 = SetupTray_slicedToArray(useSettingsView(), 2), settingsView = ref3[0], setSettingsView = ref3[1];
    var ref4 = SetupTray_slicedToArray(useNameModal(), 2), showNameModal = ref4[0], setShowNameModal = ref4[1];
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var menuId = "trayMoreMenu";
    var btnId = "trayMoreButton";
    var handleSettingsModalClose = function() {
        setSettingsView(null);
    };
    var handleSettingsButtonClick = function() {
        setSettingsView("devices");
        setShowMenu(false);
    };
    var handleMenuClick = function() {
        setShowMenu(true);
    };
    var handleMenuClose = function() {
        setShowMenu(false);
    };
    var handleChangeNameClick = function() {
        setShowNameModal(true);
        setShowMenu(false);
    };
    var handleEffectsClick = function() {
        setSettingsView("effects");
    };
    var handleNameModalClose = function() {
        setShowNameModal(false);
    };
    var supportsBackgroundEffects = (0,react.useMemo)(function() {
        return daily_iframe_esm/* default.supportedBrowser */.ZP.supportedBrowser().supportsVideoProcessing && !isMobile && enableVideoProcessingUI;
    }, [
        enableVideoProcessingUI,
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                justify: "space-between",
                horizontal: true,
                padding: 8,
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        align: "center",
                        gap: 0,
                        horizontal: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls, {
                                id: "haircheck-video-controls",
                                shouldEnableVideoMenu: false
                            }),
                            !disableAudio && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                /**
               * In case a cam is available, but no mic, we want to render
               * the video tile anyway, because we'll request cam & mic access.
               * In that case the tooltip helps to direct the user's attention
               * to their mic not working.
               */ id: "tt-no-mic",
                                // i18next-extract-mark-context-next-line ["camera", "mic", "both"]
                                title: t("haircheck.noDevices.title", {
                                    context: "mic"
                                }),
                                disabled: micState !== "not-found",
                                placement: "top",
                                open: !!hasMicError,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioControls, {
                                    id: "haircheck-audio-controls",
                                    shouldEnableAudioMenu: false
                                })
                            }),
                            supportsBackgroundEffects && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-5d6c7e9e015699e5" + " " + "effects-btn-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                                    id: "btn-effects",
                                    className: classnames_default()("btn", robotsClassName("effects-btn")),
                                    disabled: camState === "pending" || cameras.length === 0,
                                    onClick: handleEffectsClick,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EffectsIcon/* EffectsIcon */.d, {
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            children: t("general.effects")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoiseCancellationControls, {
                                micState: micState
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                        "aria-controls": menuId,
                        id: btnId,
                        className: classnames_default()("btn", robotsClassName("more-btn")),
                        onClick: handleMenuClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                children: t("general.more")
                            })
                        ]
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "right",
                placement: "top",
                offsetTop: 5,
                "aria-labelledby": btnId,
                id: menuId,
                className: classnames_default()(robotsClassName("more-menu")),
                cardProps: isMobile ? {
                    style: {
                        borderRadius: 8
                    }
                } : null,
                items: SetupTray_toConsumableArray(showUserNameChangeUI ? [
                    {
                        className: robotsClassName("btn-change-name"),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: textVariant,
                            children: t("people.rename")
                        }),
                        onClick: handleChangeNameClick
                    }, 
                ] : []).concat([
                    {
                        className: robotsClassName("btn-settings"),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                            variant: textVariant,
                            children: t("general.settingsEllipsis")
                        }),
                        onClick: handleSettingsButtonClick
                    }, 
                ]),
                onClose: handleMenuClose
            }),
            showNameModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(NameModal, {
                onClose: handleNameModalClose
            }),
            settingsView && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsModal, {
                onClose: handleSettingsModalClose
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5d6c7e9e015699e5",
                children: ".noise-cancellation-btn-container.jsx-5d6c7e9e015699e5 #btn-noise-cancellation[disabled],.effects-btn-container.jsx-5d6c7e9e015699e5 #btn-effects[disabled]{opacity:.4}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/VideoContainer.tsx
function VideoContainer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoContainer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VideoContainer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VideoContainer_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = VideoContainer_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function VideoContainer_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var VideoContainer = function(_param) {
    var children = _param.children, _hasVideo = _param.hasVideo, hasVideo = _hasVideo === void 0 ? true : _hasVideo, props = VideoContainer_objectWithoutProperties(_param, [
        "children",
        "hasVideo"
    ]);
    var ref = (0,Theme.useTheme)(), colors = ref.colors, mediaQueries = ref.mediaQueries;
    var mobileLandscape = (0,useStyleVariants/* useStyleVariants */._)().mobileLandscape;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "6bdb6a6edecf216f",
                [
                    colors.custom.mainAreaBgAccent,
                    mediaQueries.small,
                    mediaQueries.medium,
                    mediaQueries.large
                ]
            ]
        ]) + " " + (classnames_default()("videoContainer", {
            hasVideo: hasVideo
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", VideoContainer_objectSpread({}, props, {
                className: styled_jsx_default().dynamic([
                    [
                        "6bdb6a6edecf216f",
                        [
                            colors.custom.mainAreaBgAccent,
                            mediaQueries.small,
                            mediaQueries.medium,
                            mediaQueries.large
                        ]
                    ]
                ]) + " " + (props && props.className != null && props.className || classnames_default()("videoArea", {
                    androidLandscape: (0,browserConfig/* isAndroid */.Dt)() && mobileLandscape
                }) || ""),
                /*#__PURE__*/ children: hasVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: children
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styled_jsx_default().dynamic([
                        [
                            "6bdb6a6edecf216f",
                            [
                                colors.custom.mainAreaBgAccent,
                                mediaQueries.small,
                                mediaQueries.medium,
                                mediaQueries.large
                            ]
                        ]
                    ]) + " " + "message-container",
                    children: children
                })
            })),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6bdb6a6edecf216f",
                dynamic: [
                    colors.custom.mainAreaBgAccent,
                    mediaQueries.small,
                    mediaQueries.medium,
                    mediaQueries.large
                ],
                children: ".videoContainer.__jsx-style-dynamic-selector{background-color:var(--bg-color);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-shadow:1px 0 0 var(--card-border),0 1px 0 var(--card-border);-moz-box-shadow:1px 0 0 var(--card-border),0 1px 0 var(--card-border);box-shadow:1px 0 0 var(--card-border),0 1px 0 var(--card-border)}.videoContainer.hasVideo.__jsx-style-dynamic-selector{background-color:".concat(colors.custom.mainAreaBgAccent, ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.videoArea.__jsx-style-dynamic-selector{padding-bottom:56.25%;position:relative;max-width:60vw;width:464px}.videoArea.androidLandscape.__jsx-style-dynamic-selector{width:328px}.videoContainer.hasVideo.__jsx-style-dynamic-selector .videoArea.__jsx-style-dynamic-selector{padding-bottom:0}.message-container.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;padding:16px;top:0;width:100%;position:absolute}@media ").concat(mediaQueries.small, "{.videoArea.__jsx-style-dynamic-selector{max-width:90vw}.message-container.__jsx-style-dynamic-selector{padding:16px}}@media ").concat(mediaQueries.medium, "{.videoArea.__jsx-style-dynamic-selector{max-width:84vw}.message-container.__jsx-style-dynamic-selector{padding:32px}}@media ").concat(mediaQueries.large, "{.videoArea.__jsx-style-dynamic-selector{width:494px}}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Haircheck/DeviceInUse.tsx















var DeviceInUseError = function(param) {
    var accessState = param.accessState, cameras = param.cameras, camState = param.camState, hasCamError = param.hasCamError, hasMicError = param.hasMicError, micState = param.micState, onCancelClick = param.onCancelClick, onComplete = param.onComplete, requestState = param.requestState, shouldUseLandscapeLayout = param.shouldUseLandscapeLayout;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var isSmallScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var showExtraContent = !isSmallScreen && !shouldUseLandscapeLayout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
        spacing: 8,
        columns: shouldUseLandscapeLayout && [
            1,
            2,
            2,
            2
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                /*#__PURE__*/ noPadding: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoContainer, {
                        hasVideo: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "c52fd5128b340020",
                                    [
                                        mediaQueries.medium,
                                        mediaQueries.large
                                    ]
                                ]
                            ]) + " " + (classnames_default()("device-in-use-content", {
                                landscape: shouldUseLandscapeLayout
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "c52fd5128b340020",
                                            [
                                                mediaQueries.medium,
                                                mediaQueries.large
                                            ]
                                        ]
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                                            muted: true,
                                            id: "camicon",
                                            style: {
                                                display: "inline",
                                                verticalAlign: "bottom"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            variant: "largestrong",
                                            style: {
                                                display: "inline",
                                                paddingLeft: "4px"
                                            },
                                            children: camState === "in-use" ? t("haircheck.deviceInUse.title_camera") : t("haircheck.deviceInUse.title_other")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    El: "div",
                                    textAlign: "center",
                                    variant: textVariant,
                                    children: camState === "in-use" ? t("haircheck.deviceInUse.desc_camera") : t("haircheck.deviceInUse.desc_other")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SetupTray, {
                        micState: micState,
                        camState: camState,
                        hasMicError: hasMicError,
                        cameras: cameras
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                style: shouldUseLandscapeLayout ? {
                    flex: "1 0 40%",
                    minWidth: "30%",
                    padding: "46px 8px 16px"
                } : {
                    padding: "0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                    padding: showExtraContent ? 24 : 16,
                    gap: 24,
                    align: "stretch",
                    children: [
                        showExtraContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioVideoSettings, {
                            shouldShowMicVolume: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAContent, {
                            accessState: accessState,
                            requestState: requestState,
                            onCancelClick: onCancelClick,
                            onComplete: onComplete,
                            hasCamError: hasCamError,
                            hasMicError: hasMicError,
                            camState: camState,
                            micState: micState,
                            shouldUseLandscapeLayout: shouldUseLandscapeLayout
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c52fd5128b340020",
                dynamic: [
                    mediaQueries.medium,
                    mediaQueries.large
                ],
                children: ".device-in-use-content.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}@media ".concat(mediaQueries.medium, "{.device-in-use-content.__jsx-style-dynamic-selector:not(.landscape){padding:16px}}@media ").concat(mediaQueries.large, "{.device-in-use-content.__jsx-style-dynamic-selector:not(.landscape){padding:32px}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/DeviceErrorHandling.tsx
















var DeviceErrorHandling = function(param) {
    var accessState = param.accessState, cameras = param.cameras, camState = param.camState, hasCamError = param.hasCamError, hasMicError = param.hasMicError, micState = param.micState, onCancelClick = param.onCancelClick, onComplete = param.onComplete, requestState = param.requestState, shouldUseLandscapeLayout = param.shouldUseLandscapeLayout;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var isDeviceInUseError = camState === "in-use" || micState === "in-use";
    var isBlockedError = camState === "blocked" || micState === "blocked";
    var camNotFound = camState === "not-found";
    var micNotFound = micState === "not-found";
    var getHeading = function(title) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-ca677bce37130cba" + " " + "heading",
            children: [
                micNotFound ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                    /*#__PURE__*/ muted: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                    muted: true,
                    id: "camicon"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    variant: "largestrong",
                    children: title
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "ca677bce37130cba",
                    children: ".heading.jsx-ca677bce37130cba{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px;text-align:left}.heading.jsx-ca677bce37130cba svg{margin-left:-2px}"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4c45e4f14e0ac0af",
                [
                    mediaQueries.small,
                    mediaQueries.medium,
                    mediaQueries.medium
                ]
            ]
        ]) + " " + (classnames_default()("device-error", {
            unblockSafari: (0,browserConfig/* isSafari */.G6)() && isBlockedError
        }) || ""),
        children: [
            isDeviceInUseError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceInUseError, {
                camState: camState,
                micState: micState,
                hasMicError: hasMicError,
                hasCamError: hasCamError,
                shouldUseLandscapeLayout: shouldUseLandscapeLayout,
                cameras: cameras,
                accessState: accessState,
                requestState: requestState,
                onComplete: onComplete,
                onCancelClick: onCancelClick
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                    children: isBlockedError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 16,
                        children: [
                            getHeading(t("haircheck.blocked.title")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnblockPermissionsInstructions, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAContent, {
                                accessState: accessState,
                                requestState: requestState,
                                onCancelClick: onCancelClick,
                                onComplete: onComplete,
                                hasCamError: hasCamError,
                                hasMicError: hasMicError,
                                camState: camState,
                                micState: micState,
                                shouldUseLandscapeLayout: shouldUseLandscapeLayout
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                        gap: 16,
                        children: [
                            getHeading(// i18next-extract-mark-context-next-line ["both", "camera", "mic"]
                            t("haircheck.noDevices.title", {
                                context: camNotFound && micNotFound ? "both" : camNotFound ? "camera" : "mic"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                El: "div",
                                variant: textVariant,
                                children: // i18next-extract-mark-context-next-line ["both", "camera", "mic"]
                                t("haircheck.noDevices.modalContent", {
                                    context: camNotFound && micNotFound ? "both" : camNotFound ? "camera" : "mic"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                                align: "stretch",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                                    id: "haircheck-reload",
                                    onClick: function() {
                                        return window.location.reload();
                                    },
                                    fullWidth: true,
                                    children: t("general.tryAgain")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAContent, {
                                accessState: accessState,
                                requestState: requestState,
                                onCancelClick: onCancelClick,
                                onComplete: onComplete,
                                hasCamError: hasCamError,
                                hasMicError: hasMicError,
                                camState: camState,
                                micState: micState,
                                shouldUseLandscapeLayout: shouldUseLandscapeLayout
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4c45e4f14e0ac0af",
                dynamic: [
                    mediaQueries.small,
                    mediaQueries.medium,
                    mediaQueries.medium
                ],
                children: ".device-error.__jsx-style-dynamic-selector .card-content{padding:32px;width:92vw}@media ".concat(mediaQueries.small, "{.device-error.__jsx-style-dynamic-selector .card-content{padding:24px;width:92vw}}@media ").concat(mediaQueries.medium, "{.device-error.__jsx-style-dynamic-selector .card-content{max-width:500px;width:82vw}}@media ").concat(mediaQueries.medium, "{.device-error.unblockSafari.__jsx-style-dynamic-selector .card-content{max-width:388px}}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/NotSupportedMessage.tsx









var NotSupportedMessage = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
        align: "center",
        gap: 16,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon.WarningIcon, {
                        color: colors.system.red
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        textAlign: "center",
                        variant: "largestrong",
                        children: t("haircheck.setup.notSupportedTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        textAlign: "center",
                        style: {
                            maxWidth: 464
                        },
                        variant: textVariant,
                        children: t("haircheck.setup.notSupportedSubtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                id: "haircheck-join-not-supported",
                className: robotsClassName("btn-join"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    color: "muted",
                    underline: true,
                    variant: textVariant,
                    children: t("haircheck.setup.joinAnyway")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/Setup.tsx
function Setup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Setup_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Setup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Setup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Setup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Setup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Setup_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Setup_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Setup_slicedToArray(arr, i) {
    return Setup_arrayWithHoles(arr) || Setup_iterableToArrayLimit(arr, i) || Setup_unsupportedIterableToArray(arr, i) || Setup_nonIterableRest();
}
function Setup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Setup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Setup_arrayLikeToArray(o, minLen);
}





























var Setup = function(param) {
    var accessState = param.accessState, onCancelJoinRequest = param.onCancelJoinRequest;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mediaQueries = (0,Theme.useTheme)().mediaQueries;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref = (0,react.useState)("idle"), requestState = ref[0], setRequestState = ref[1];
    var ref1 = Setup_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = (0,daily_react_esm/* useDevices */.Ls)(), cameras = ref2.cameras, camState = ref2.camState, hasCamError = ref2.hasCamError, hasMicError = ref2.hasMicError, micState = ref2.micState;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var setRedirectOnLeaveCall = (0,CallProvider/* useCallState */.oz)().setRedirectOnLeaveCall;
    var ref3 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref3.broadcastRole, optimizeLargeCalls = ref3.optimizeLargeCalls, poweredByDaily = ref3.poweredByDaily;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var localUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "user_name");
    var ref4 = (0,useStyleVariants/* useStyleVariants */._)(), isPortrait = ref4.isPortrait, mobileLandscape = ref4.mobileLandscape, mobilePortrait = ref4.mobilePortrait;
    var ref5 = useSoundLoader(), joinSound = ref5.joinSound, loadSounds = ref5.load;
    var isSmallScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var isLargeScreen = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var shouldUseLandscapeLayout = !isPortrait && !isLargeScreen || mobileLandscape;
    var showExtraContent = camState !== "pending" && !isSmallScreen && !shouldUseLandscapeLayout && !isMobile;
    (0,react.useEffect)(function() {
        if (!daily) return;
        daily.startCamera();
    }, [
        daily
    ]);
    var handleComplete = (0,react.useCallback)(Setup_asyncToGenerator(runtime_default().mark(function _callee() {
        var granted;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (daily) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    loadSounds();
                    // In case participant unmuted during prejoin, force-mute again.
                    if (optimizeLargeCalls && !(0,lib_participants/* isParticipantTrackOff */.FD)(daily.participants().local, "audio")) {
                        daily.setLocalAudio(false);
                        addMessage({
                            content: t("notification.micMutedAutomatically")
                        });
                    }
                    _ctx.next = 6;
                    return daily.join();
                case 6:
                    if (!(accessState === "lobby")) {
                        _ctx.next = 12;
                        break;
                    }
                    setRequestState("waiting");
                    _ctx.next = 10;
                    return daily === null || daily === void 0 ? void 0 : daily.requestAccess({
                        name: localUserName,
                        access: {
                            level: "full"
                        }
                    });
                case 10:
                    granted = _ctx.sent.granted;
                    if (granted) {
                        joinSound.play();
                    } else {
                        setRedirectOnLeaveCall(false);
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        accessState,
        addMessage,
        daily,
        joinSound,
        loadSounds,
        localUserName,
        optimizeLargeCalls,
        setRedirectOnLeaveCall,
        t, 
    ]);
    var tileAspectRatio = (0,react.useMemo)(function() {
        return isMobile ? isPortrait ? DEFAULT_PORTRAIT_AR : DEFAULT_LANDSCAPE_AR : lib_constants/* DEFAULT_ASPECT_RATIO */.vr;
    }, [
        isPortrait,
        isMobile
    ]);
    var getAvailableHeight = (0,react.useMemo)(function() {
        /**
     * To avoid having to scroll in mobile portrait mode or anything
     * getting cut off, we need to set the tile height to whatever
     * is available after accommodating all the other elements on
     * the screen
     */ if (!mobilePortrait) return;
        var bannerIsShowing = poweredByDaily ? 30 : 0;
        var titleCard = 96;
        var ctaButton = isSmallScreen && 40;
        var lockedByHost = accessState === "lobby" && isSmallScreen ? 24 : 0;
        var totalPadding = 80;
        var trayHeight = 59;
        var testSoundCard = !showExtraContent && 48;
        var ownerMsg = broadcastRole === "owner" ? 32 : 0;
        var audioVideoSettings = !showExtraContent ? 0 : accessState === "lobby" ? 273 : 233;
        var maxTileHeight = window.innerHeight - (titleCard + ctaButton + totalPadding + lockedByHost + testSoundCard + trayHeight + bannerIsShowing + ownerMsg + audioVideoSettings);
        return maxTileHeight;
    }, [
        accessState,
        broadcastRole,
        isSmallScreen,
        mobilePortrait,
        poweredByDaily,
        showExtraContent, 
    ]);
    var noDeviceErrors = !hasCamError && !hasMicError;
    if (camState === "not-supported" || micState === "not-supported") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotSupportedMessage, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: noDeviceErrors ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Card, {
                spacing: 8,
                style: {
                    backgroundColor: "var(--body-bg)",
                    flexDirection: shouldUseLandscapeLayout ? "row-reverse" : "column"
                },
                columns: shouldUseLandscapeLayout && [
                    1,
                    2,
                    2,
                    2
                ],
                children: [
                    camState !== "pending" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                        style: shouldUseLandscapeLayout ? {
                            flex: "1 0 40%",
                            minWidth: "30%",
                            padding: "46px 8px 16px"
                        } : {
                            padding: "24px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            align: "center",
                            justify: "center",
                            style: {
                                paddingTop: "48px",
                                height: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAContent, {
                                        shouldUseLandscapeLayout: shouldUseLandscapeLayout,
                                        accessState: accessState,
                                        requestState: requestState,
                                        onCancelClick: onCancelJoinRequest,
                                        onComplete: handleComplete,
                                        camState: camState,
                                        micState: micState,
                                        hasCamError: hasCamError,
                                        hasMicError: hasMicError
                                    })
                                }),
                                shouldUseLandscapeLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.StackItem, {
                                    style: {
                                        marginTop: "auto"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                        justify: "center",
                                        horizontal: true,
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioIcon/* AudioIcon */.f, {
                                                id: "speaker-settings-label",
                                                size: 16
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestSound, {
                                                animationPlacement: "right"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.CardContent, {
                        noPadding: true,
                        style: shouldUseLandscapeLayout ? {
                            flex: "1 0 60%",
                            boxShadow: "1px 0 0 var(--card-border), 0 1px 0 var(--card-border)"
                        } : {},
                        children: [
                            camState === "pending" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoContainer, {
                                hasVideo: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    style: {
                                        textAlign: isSmallScreen ? "left" : "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            variant: "largestrong",
                                            children: t("haircheck.setup.allowAccessTitle")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                            children: t("haircheck.setup.allowAccessSubtitle")
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                                    aspectRatio: tileAspectRatio,
                                    activeIndicator: "meter",
                                    hideActions: true,
                                    name: localUserName,
                                    sessionId: localSessionId,
                                    showNames: true,
                                    style: mobilePortrait ? {
                                        border: "none",
                                        maxHeight: getAvailableHeight
                                    } : {
                                        border: "none"
                                    },
                                    videoFit: "cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetupTray, {
                                micState: micState,
                                camState: camState,
                                hasMicError: hasMicError,
                                cameras: cameras
                            })
                        ]
                    }),
                    camState !== "pending" && !showExtraContent && !shouldUseLandscapeLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            horizontal: true,
                            justify: "center",
                            padding: 8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioIcon/* AudioIcon */.f, {
                                    id: "speaker-settings-label",
                                    size: 16,
                                    color: "var(--text-muted)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TestSound, {
                                    animationPlacement: "right"
                                })
                            ]
                        })
                    }),
                    showExtraContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                        noPadding: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            padding: 24,
                            gap: 24,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioVideoSettings, {
                                    shouldShowMicVolume: true
                                }),
                                accessState === "lobby" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {}),
                                broadcastRole === "owner" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        textAlign: "center",
                                        color: "muted",
                                        children: t("haircheck.setup.joinAsPresenter")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceErrorHandling, {
                accessState: accessState,
                requestState: requestState,
                camState: camState,
                micState: micState,
                hasMicError: hasMicError,
                cameras: cameras,
                hasCamError: hasCamError,
                onComplete: handleComplete,
                onCancelClick: onCancelJoinRequest,
                shouldUseLandscapeLayout: shouldUseLandscapeLayout
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/Haircheck.tsx
function Haircheck_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Haircheck_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Haircheck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Haircheck_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Haircheck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Haircheck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Haircheck_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Haircheck_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Haircheck_slicedToArray(arr, i) {
    return Haircheck_arrayWithHoles(arr) || Haircheck_iterableToArrayLimit(arr, i) || Haircheck_unsupportedIterableToArray(arr, i) || Haircheck_nonIterableRest();
}
function Haircheck_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Haircheck_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Haircheck_arrayLikeToArray(o, minLen);
}
















var Haircheck = function() {
    var ref = (0,CallProvider/* useCallState */.oz)(), leaveCall = ref.leaveCall, mode = ref.mode, setRedirectOnLeaveCall = ref.setRedirectOnLeaveCall;
    var ref1 = Haircheck_slicedToArray((0,core/* useAttendeeInteractedWithUI */.Ew)(), 2), setAttendeeInteractedWithUI = ref1[1];
    var ref2 = (0,Theme.useTheme)(), mediaQueries = ref2.mediaQueries, zIndex = ref2.zIndex;
    var ref3 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref3.broadcast, broadcastRole = ref3.broadcastRole, poweredByDaily = ref3.poweredByDaily;
    var ref4 = useSoundLoader(), joinSound = ref4.joinSound, loadSounds = ref4.load;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var localUserName = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "user_name");
    var ref5 = (0,react.useState)("name"), /*#__PURE__*/ step = ref5[0], setStep = ref5[1];
    var ref6 = Haircheck_slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 1), showUserNameChangeUI = ref6[0];
    var accessState = (0,react.useMemo)(function() {
        if (!daily) return null;
        var access = daily.accessState().access;
        if (access === "unknown" || access.level === "none") return "none";
        return access.level;
    }, [
        daily
    ]);
    var handleCancelJoinRequest = (0,react.useCallback)(function() {
        if (!daily) return;
        setRedirectOnLeaveCall(false);
        if (mode === "direct-link") {
            leaveCall();
            window.location.reload();
        } else {
            leaveCall();
        }
    }, [
        daily,
        leaveCall,
        mode,
        setRedirectOnLeaveCall
    ]);
    /**
   * For owner only broadcast meetings, attendees join directly
   * from the name form since there's no device set up to consider.
   */ var handleOOBAttendeeJoin = (0,react.useCallback)(function() {
        var _ref = Haircheck_asyncToGenerator(runtime_default().mark(function _callee(name) {
            var granted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (daily) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        loadSounds();
                        _ctx.next = 5;
                        return daily.join();
                    case 5:
                        if (!(accessState === "lobby")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return daily.requestAccess({
                            name: name,
                            access: {
                                level: "full"
                            }
                        });
                    case 8:
                        granted = _ctx.sent.granted;
                        if (granted) {
                            joinSound.play();
                        } else {
                            setRedirectOnLeaveCall(false);
                            leaveCall();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessState,
        daily,
        joinSound,
        leaveCall,
        loadSounds,
        setRedirectOnLeaveCall, 
    ]);
    (0,react.useEffect)(function() {
        if (broadcast === null) return;
        /**
     * All participants from non-owner-only-broadcast calls can skip to
     * the set up if their name is already set. In owner-only-broadcast
     * calls, only owners see the set up. Attendees join from the name form.
     */ if ((localUserName || !showUserNameChangeUI) && (!broadcast || broadcastRole === "owner")) {
            setStep("setup");
        }
    }, [
        broadcast,
        broadcastRole,
        showUserNameChangeUI,
        localUserName
    ]);
    // This used to be invoked even when user name was specified by token. It's
    // important to *not* re-set the user name, otherwise a session-specific
    // token-specified user name will be stored and used in future sessions.
    var handleNameComplete = (0,react.useCallback)(function(username) {
        daily.setUserName(username);
        if (broadcastRole === "attendee") {
            setStep("owner-only-waiting");
            handleOOBAttendeeJoin(username);
            // Track the only UI interaction an attendee can have before joining
            setAttendeeInteractedWithUI(true);
        }
    }, [
        broadcastRole,
        daily,
        handleOOBAttendeeJoin,
        setAttendeeInteractedWithUI
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "b3d1b20c6bf02161",
                [
                    mediaQueries.coarse,
                    mediaQueries.small,
                    mediaQueries.nonCoarse,
                    zIndex.header
                ]
            ]
        ]) + " " + (classnames_default()("haircheck", {
            banner: poweredByDaily
        }) || ""),
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "b3d1b20c6bf02161",
                        [
                            mediaQueries.coarse,
                            mediaQueries.small,
                            mediaQueries.nonCoarse,
                            zIndex.header
                        ]
                    ]
                ]) + " " + "banner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner, {})
            }),
            step === "name" && (!localUserName || broadcastRole === "attendee") && /*#__PURE__*/ (0,jsx_runtime.jsx)(NameForm, {
                onComplete: handleNameComplete
            }),
            step === "setup" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Setup, {
                accessState: accessState,
                onCancelJoinRequest: handleCancelJoinRequest
            }),
            step === "owner-only-waiting" && /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnerOnlyBroadcastWaiting, {
                onCancelJoinRequest: handleCancelJoinRequest
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "b3d1b20c6bf02161",
                dynamic: [
                    mediaQueries.coarse,
                    mediaQueries.small,
                    mediaQueries.nonCoarse,
                    zIndex.header
                ],
                children: ".haircheck.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;overflow:auto;padding:16px;width:100%}.haircheck.banner.__jsx-style-dynamic-selector{padding-top:46px}@media ".concat(mediaQueries.coarse, "{.haircheck.__jsx-style-dynamic-selector{padding:32px;margin:0;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden}.haircheck.banner.__jsx-style-dynamic-selector{padding-top:62px}}@media ").concat(mediaQueries.small, "{.haircheck.__jsx-style-dynamic-selector{padding:8px}.haircheck.banner.__jsx-style-dynamic-selector{padding-top:38px}}@media ").concat(mediaQueries.nonCoarse, "{.haircheck.__jsx-style-dynamic-selector>*:not(.banner){margin:auto}}.banner.__jsx-style-dynamic-selector{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;left:0;position:fixed;top:0;width:100vw;z-index:").concat(zIndex.header, "}.haircheck.__jsx-style-dynamic-selector .card-container{width:460px}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Haircheck/index.ts


;// CONCATENATED MODULE: ./components/Tray/AppsControls.tsx
function AppsControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AppsControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AppsControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AppsControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = AppsControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function AppsControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var AppsControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = AppsControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), canControlIntegration = ref.canControlIntegration, mainIntegrations = ref.mainIntegrations, runningSharedIntegrations = ref.runningSharedIntegrations;
    var apps = mainIntegrations.filter(canControlIntegration);
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ showPopover = ref1[0], setShowPopover = ref1[1];
    var handleClickApps = (0,react.useCallback)(function(ev) {
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
        setShowPopover(true);
    }, [
        onClick
    ]);
    var handleClosePopover = (0,react.useCallback)(function() {
        setShowPopover(false);
    }, []);
    if (!apps.length) return null;
    var controllableRunningApps = mainIntegrations.filter(canControlIntegration).filter(function(i) {
        return i.id in runningSharedIntegrations || i.running;
    });
    var isControllableAppRunning = controllableRunningApps.length > 0;
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "def5dd13724133a4",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + (classnames_default()("apps-controls", className, {
            active: isControllableAppRunning
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, AppsControls_objectSpread({
                onClick: handleClickApps
            }, props, {
                id: (ref2 = props === null || props === void 0 ? void 0 : props.id) !== null && ref2 !== void 0 ? ref2 : "apps-btn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsIcon/* AppsIcon */.j, {
                        className: "icon",
                        color: isControllableAppRunning ? colors.system.white : "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("general.apps")
                    })
                ]
            })),
            showPopover && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover.Popover, {
                align: "right",
                "aria-labelledby": (ref3 = props === null || props === void 0 ? void 0 : props.id) !== null && ref3 !== void 0 ? ref3 : "apps-btn",
                id: "apps-popover",
                onClose: handleClosePopover,
                placement: "top",
                cardProps: {
                    appearance: "grey",
                    spacing: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsList, {
                        onClickApp: handleClosePopover,
                        iconSize: 16,
                        iconVariant: "thick",
                        textVariant: "base",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            align: "center",
                            gap: 4,
                            horizontal: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsIcon/* AppsIcon */.j, {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: "strong",
                                    children: t("general.apps")
                                })
                            ]
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "def5dd13724133a4",
                dynamic: [
                    colors.system.red
                ],
                children: ".apps-controls.__jsx-style-dynamic-selector img.__jsx-style-dynamic-selector{display:block;margin:2px}.apps-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.apps-controls.active.__jsx-style-dynamic-selector .icon{background:".concat(colors.system.red, "}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/BreakoutControls.tsx
function BreakoutControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BreakoutControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BreakoutControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BreakoutControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BreakoutControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BreakoutControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BreakoutControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BreakoutControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = BreakoutControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function BreakoutControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BreakoutControls_slicedToArray(arr, i) {
    return BreakoutControls_arrayWithHoles(arr) || BreakoutControls_iterableToArrayLimit(arr, i) || BreakoutControls_unsupportedIterableToArray(arr, i) || BreakoutControls_nonIterableRest();
}
function BreakoutControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BreakoutControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BreakoutControls_arrayLikeToArray(o, minLen);
}







var BreakoutControls = function(_param) {
    var onClick = _param.onClick, props = BreakoutControls_objectWithoutProperties(_param, [
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = BreakoutControls_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref[0], setSidebarView = ref[1];
    var handleBreakoutClick = function(ev) {
        setSidebarView(sidebarView === "breakout" ? null : "breakout");
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "breakout-controls",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, BreakoutControls_objectSpread({
            id: "breakout-controls",
            onClick: handleBreakoutClick
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutIcon/* BreakoutIcon */.y, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("general.breakoutRooms")
                })
            ]
        }))
    });
};


;// CONCATENATED MODULE: ./components/Tray/ChatControls.tsx
function ChatControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ChatControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ChatControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ChatControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ChatControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ChatControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChatControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ChatControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ChatControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ChatControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChatControls_slicedToArray(arr, i) {
    return ChatControls_arrayWithHoles(arr) || ChatControls_iterableToArrayLimit(arr, i) || ChatControls_unsupportedIterableToArray(arr, i) || ChatControls_nonIterableRest();
}
function ChatControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ChatControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ChatControls_arrayLikeToArray(o, minLen);
}















var ChatControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = ChatControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,Theme.useTheme)(), colors = ref.colors, mediaQueries = ref.mediaQueries;
    var ref1 = ChatControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref1[0];
    var ref2 = ChatControls_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref2[0], setSidebarView = ref2[1];
    var enableChat = (0,useCallConfig/* useCallConfig */.A)().enableChat;
    var currentBreakoutRoom = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().currentBreakoutRoom;
    var chatUnread = (0,ChatProvider/* useChatUnread */.HB)(currentBreakoutRoom.id);
    var ref3 = (0,react.useState)(false), hasOpenedChatOnce = ref3[0], setHasOpenedChatOnce = ref3[1];
    var isMobileVP = (0,useMediaQuery.useMediaQuery)(mediaQueries.small);
    var handleChatClick = function(ev) {
        setSidebarView(sidebarView === "chat" ? null : "chat");
        setHasOpenedChatOnce(true);
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    (0,react.useEffect)(function() {
        if (sidebarView !== "chat") return;
        setHasOpenedChatOnce(true);
    }, [
        sidebarView
    ]);
    if (!enableChat) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "chat-controls",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            disabled: !chatUnread || hasOpenedChatOnce || isMobile || isMobileVP,
            disableListeners: true,
            id: "tt-chat-notification",
            open: chatUnread && !hasOpenedChatOnce,
            placement: "top",
            tabIndex: -1,
            title: t("chat.started"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, ChatControls_objectSpread({
                badge: {
                    color: colors.system.red,
                    visible: sidebarView !== "chat" && chatUnread
                },
                className: classnames_default()(className, (_obj = {}, ChatControls_defineProperty(_obj, robotsClassName("btn-chat-show"), sidebarView !== "chat"), ChatControls_defineProperty(_obj, robotsClassName("btn-chat-hide"), sidebarView === "chat"), _obj)),
                onClick: handleChatClick
            }, props, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* ChatIcon */.k, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("general.chat")
                    })
                ]
            }))
        })
    });
};


;// CONCATENATED MODULE: ./components/Tray/ContactHostControls.tsx
function ContactHostControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContactHostControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContactHostControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ContactHostControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ContactHostControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ContactHostControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}















var ContactHostControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = ContactHostControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ref = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref.breakoutHost, breakoutStatus = ref.breakoutStatus, isRequestingHelp = ref.isRequestingHelp, updateAskForHelpStatus = ref.updateAskForHelpStatus;
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ showHelpMenu = ref1[0], setShowHelpMenu = ref1[1];
    var handleButtonClick = function(ev) {
        setShowHelpMenu(true);
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    var handleMenuItemClick = function() {
        updateAskForHelpStatus(!isRequestingHelp);
        setShowHelpMenu(false);
    };
    var handleMenuClose = function() {
        setShowHelpMenu(false);
    };
    if (breakoutStatus !== "ongoing") return null;
    var isHostInRoom = orderedParticipantIds.includes(breakoutHost);
    var ref2, ref3;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "db399826a286d915",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + (classnames_default()("contact-host-controls", {
            active: isRequestingHelp
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, ContactHostControls_objectSpread({
                className: classnames_default()(className, (_obj = {}, ContactHostControls_defineProperty(_obj, robotsClassName("btn-contact-host"), !isRequestingHelp), ContactHostControls_defineProperty(_obj, robotsClassName("btn-cancel-contact-host"), isRequestingHelp), _obj)),
                disabled: isHostInRoom,
                onClick: handleButtonClick
            }, props, {
                id: (ref2 = props === null || props === void 0 ? void 0 : props.id) !== null && ref2 !== void 0 ? ref2 : "contact-host-btn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                        className: "icon",
                        color: isRequestingHelp ? colors.system.white : isHostInRoom ? colors.supportiveText : "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                        disabled: isHostInRoom,
                        on: isRequestingHelp,
                        onText: t("general.cancelWithEllipsis"),
                        offText: t("breakouts.contactHostEllipsis")
                    })
                ]
            })),
            showHelpMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "left",
                "aria-labelledby": (ref3 = props === null || props === void 0 ? void 0 : props.id) !== null && ref3 !== void 0 ? ref3 : "contact-host-btn",
                id: "contact-host-menu",
                items: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                            align: "center",
                            gap: 4,
                            horizontal: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                    variant: "strong",
                                    children: isRequestingHelp ? t("general.cancel") : t("breakouts.contactHost")
                                })
                            ]
                        }),
                        static: true
                    },
                    {
                        label: isRequestingHelp ? t("breakouts.cancelRequestForHelp") : t("breakouts.askHostForHelp"),
                        onClick: handleMenuItemClick
                    }, 
                ],
                onClose: handleMenuClose,
                placement: "top"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "db399826a286d915",
                dynamic: [
                    colors.system.red
                ],
                children: ".contact-host-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.contact-host-controls.active.__jsx-style-dynamic-selector .icon{background:".concat(colors.system.red, "}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/CustomButton.tsx
function CustomButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CustomButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CustomButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ICON_SIZE = 24;
var CustomButton = function(_param) {
    var btn = _param.btn, id = _param.id, props = CustomButton_objectWithoutProperties(_param, [
        "btn",
        "id"
    ]);
    var isDarkMode = (0,Theme.useTheme)().isDarkMode;
    var sendMessageToDriver = useIframeDriver().sendMessageToDriver;
    var handleClick = (0,react.useCallback)(function() {
        sendMessageToDriver({
            action: ACTION_CUSTOM_BUTTON_CLICK,
            button_id: id
        });
    }, [
        id,
        sendMessageToDriver
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        delay: TOOLTIP_DELAY,
        disabled: !btn.tooltip,
        id: "tt-custom-button_".concat(id),
        tabIndex: -1,
        title: btn.tooltip,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, CustomButton_objectSpread({
            className: robotsClassName("btn-custom"),
            onClick: handleClick
        }, props, {
            id: "".concat(id, "-controls"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcon, {
                    alt: btn.label,
                    src: isDarkMode && btn.iconPathDarkMode ? btn.iconPathDarkMode : btn.iconPath,
                    padding: 4,
                    size: ICON_SIZE,
                    style: {
                        display: "block"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: btn.label
                })
            ]
        }))
    });
};


// EXTERNAL MODULE: ../shared/dist/components/Icons/ExitIcon.js
var ExitIcon = __webpack_require__(3467);
// EXTERNAL MODULE: ../shared/dist/components/Icons/ReturnIcon.js
var ReturnIcon = __webpack_require__(6958);
;// CONCATENATED MODULE: ./components/Tray/LeaveButton.tsx
function LeaveButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LeaveButton_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LeaveButton_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LeaveButton_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LeaveButton_slicedToArray(arr, i) {
    return LeaveButton_arrayWithHoles(arr) || LeaveButton_iterableToArrayLimit(arr, i) || LeaveButton_unsupportedIterableToArray(arr, i) || LeaveButton_nonIterableRest();
}
function LeaveButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LeaveButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LeaveButton_arrayLikeToArray(o, minLen);
}
















var LeaveButton = function(param) {
    var id = param.id;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref4 = (0,CallProvider/* useCallState */.oz)(), enableCallButtons = ref4.enableCallButtons, leaveCall = ref4.leaveCall;
    var ref1 = LeaveButton_slicedToArray((0,recordings/* useLeaveWhileRecordingModal */.VV)(), 2), setShowLeaveWhileRecordingModal = ref1[1];
    var ref2 = (0,daily_react_esm/* useRecording */.$n)(), isRecording = ref2.isRecording, local = ref2.local;
    var ref3 = (0,react.useState)(false), showBreakoutLeaveMenu = ref3[0], setShowBreakoutLeaveMenu = ref3[1];
    var hasJoinedBreakout = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)().hasJoinedBreakout;
    var leaveBreakout = useBreakouts().leaveBreakout;
    var leaveCallCompletely = (0,react.useCallback)(function() {
        if (isRecording && local) {
            setShowLeaveWhileRecordingModal(true);
            return;
        }
        // In case Picture in Picture is active, end it
        try {
            // @ts-ignore
            if (document.pictureInPictureElement) {
                // @ts-ignore
                document.exitPictureInPicture();
            }
        } catch (e) {}
        leaveCall();
    }, [
        isRecording,
        leaveCall,
        local,
        setShowLeaveWhileRecordingModal
    ]);
    var handleClick = (0,react.useCallback)(function() {
        if (hasJoinedBreakout) {
            setShowBreakoutLeaveMenu(!showBreakoutLeaveMenu);
            return;
        }
        leaveCallCompletely();
    }, [
        hasJoinedBreakout,
        leaveCallCompletely,
        setShowBreakoutLeaveMenu,
        showBreakoutLeaveMenu, 
    ]);
    var handleClickLeaveRoom = function() {
        leaveBreakout(true);
        setShowBreakoutLeaveMenu(false);
    };
    var handleCloseLeaveMenu = function() {
        setShowBreakoutLeaveMenu(false);
    };
    (0,react.useEffect)(function() {
        var ref;
        if (typeof ((ref = navigator.mediaSession) === null || ref === void 0 ? void 0 : ref.setActionHandler) !== "function") return;
        try {
            navigator.mediaSession.setActionHandler("hangup", handleClick);
        } catch (e) {}
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "leave",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                "aria-controls": hasJoinedBreakout ? "breakout-leave-menu" : undefined,
                className: robotsClassName(id),
                disabled: !enableCallButtons,
                id: id,
                onClick: handleClick,
                children: [
                    hasJoinedBreakout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnIcon/* ReturnIcon */.B, {
                        color: colors.system.red
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitIcon/* ExitIcon */.i, {
                        color: colors.system.red
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: hasJoinedBreakout ? t("general.exitWithOptions") : t("general.leave")
                    })
                ]
            }),
            showBreakoutLeaveMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover.Popover, {
                align: "right",
                "aria-labelledby": id,
                id: "breakout-leave-menu",
                placement: "top",
                onClose: handleCloseLeaveMenu,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutLeaveMenuContent, {
                    onClickLeaveCall: leaveCallCompletely,
                    onClickLeaveRoom: handleClickLeaveRoom
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared/dist/components/Icons/GaugeIcon.js
var GaugeIcon = __webpack_require__(9858);
;// CONCATENATED MODULE: ./components/Tray/MoreControls.tsx
function MoreControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MoreControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MoreControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MoreControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MoreControls_slicedToArray(arr, i) {
    return MoreControls_arrayWithHoles(arr) || MoreControls_iterableToArrayLimit(arr, i) || MoreControls_unsupportedIterableToArray(arr, i) || MoreControls_nonIterableRest();
}
function MoreControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MoreControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MoreControls_arrayLikeToArray(o, minLen);
}




































var MoreControls = function(param) {
    var controls = param.controls, id = param.id;
    var colors = (0,Theme.useTheme)().colors;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var sendMessageToDriver = useIframeDriver().sendMessageToDriver;
    var ref = (0,useCallConfig/* useCallConfig */.A)(), enableBreakoutRooms = ref.enableBreakoutRooms, enableChat = ref.enableChat, enableHandRaising = ref.enableHandRaising, enableNetworkUI = ref.enableNetworkUI, enableRecording = ref.enableRecording, enableScreenShare = ref.enableScreenShare;
    var ref1 = (0,daily_react_esm/* useScreenShare */.N2)(), isSharingScreen = ref1.isSharingScreen, startScreenShare = ref1.startScreenShare, stopScreenShare = ref1.stopScreenShare;
    var screens = (0,useScreens/* useScreens */.O)();
    var orderedParticipantIds = (0,ParticipantsProvider/* useOrderedParticipantIds */.o8)();
    var ref2 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref2.breakoutHost, breakoutStatus = ref2.breakoutStatus, currentBreakoutRoom = ref2.currentBreakoutRoom, isRequestingHelp = ref2.isRequestingHelp, updateAskForHelpStatus = ref2.updateAskForHelpStatus;
    var chatUnread = (0,ChatProvider/* useChatUnread */.HB)(currentBreakoutRoom.id);
    var ref3 = MoreControls_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 1), customTrayButtons = ref3[0];
    var ref4 = MoreControls_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref4[0], setSidebarView = ref4[1];
    var ref5 = MoreControls_slicedToArray((0,recordings/* useStartRecordingModal */.Fy)(), 2), setShowStartRecordingModal = ref5[1];
    var ref6 = MoreControls_slicedToArray(useAppsModal(), 2), setShowAppsModal = ref6[1];
    var stopRecording = (0,RecordingProvider/* useRecording */.$n)().stopRecording;
    var ref7 = MoreControls_slicedToArray((0,recordings/* useRecordingUI */.oZ)(), 1), recordingUIState = ref7[0];
    var ref8 = (0,daily_react_esm/* useRecording */.$n)(), isLocalParticipantRecorded = ref8.isLocalParticipantRecorded, isRecording = ref8.isRecording;
    var waitingParticipants = (0,daily_react_esm/* useWaitingParticipants */.zy)().waitingParticipants;
    var ref9 = (0,react.useState)(false), showMenu = ref9[0], setShowMenu = ref9[1];
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref10 = useHandRaising(), lowerHand = ref10.lowerHand, raiseHand = ref10.raiseHand;
    var isHandRaised = useHasHandRaised(localSessionId);
    var setShowEmojiReactionsMenu = useShowEmojiReactionsMenu().setShowEmojiReactionsMenu;
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var handleAskForHelpClick = (0,react.useCallback)(function() {
        updateAskForHelpStatus(!isRequestingHelp);
        setShowMenu(false);
    }, [
        isRequestingHelp,
        updateAskForHelpStatus
    ]);
    var handleEmojiReactionClick = (0,react.useCallback)(function() {
        setShowEmojiReactionsMenu(true);
        setShowMenu(false);
    }, [
        setShowEmojiReactionsMenu
    ]);
    var handlePeopleClick = (0,react.useCallback)(function() {
        setSidebarView(sidebarView !== "people" ? "people" : null);
        setShowMenu(false);
    }, [
        sidebarView,
        setSidebarView
    ]);
    var handleChatClick = (0,react.useCallback)(function() {
        setSidebarView(sidebarView !== "chat" ? "chat" : null);
        setShowMenu(false);
    }, [
        sidebarView,
        setSidebarView
    ]);
    var handleNetworkClick = (0,react.useCallback)(function() {
        setSidebarView(sidebarView !== "network" ? "network" : null);
        setShowMenu(false);
    }, [
        sidebarView,
        setSidebarView
    ]);
    var handleBreakoutsClick = (0,react.useCallback)(function() {
        setSidebarView(sidebarView !== "breakout" ? "breakout" : null);
        setShowMenu(false);
    }, [
        sidebarView,
        setSidebarView
    ]);
    var handleRecordClick = (0,react.useCallback)(function() {
        if (isRecording) {
            stopRecording();
        } else {
            setShowStartRecordingModal(true);
        }
        setShowMenu(false);
    }, [
        isRecording,
        setShowStartRecordingModal,
        stopRecording
    ]);
    var handleScreenshareClick = (0,react.useCallback)(function() {
        isSharingScreen ? stopScreenShare() : startScreenShare();
        setShowMenu(false);
    }, [
        isSharingScreen,
        startScreenShare,
        stopScreenShare
    ]);
    var handleRaiseHandClick = (0,react.useCallback)(function() {
        if (isHandRaised) {
            lowerHand();
        } else {
            raiseHand();
        }
    }, [
        isHandRaised,
        lowerHand,
        raiseHand
    ]);
    var handleAppsClick = (0,react.useCallback)(function() {
        setShowMenu(false);
        setShowAppsModal(true);
    }, [
        setShowAppsModal
    ]);
    var peopleIcon = (0,react.useMemo)(function() {
        if (waitingParticipants.length > 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
            color: colors.system.red,
            visible: true,
            variant: "inline"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
            size: 16
        });
    }, [
        colors.system.red,
        waitingParticipants
    ]);
    var networkIcon = (0,react.useMemo)(function() {
        switch(threshold){
            case "low":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                    color: colors.system.orange,
                    visible: true,
                    variant: "inline"
                });
            case "very-low":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                    color: colors.system.red,
                    visible: true,
                    variant: "inline"
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GaugeIcon/* GaugeIcon */.h, {
                    size: 16
                });
        }
    }, [
        colors.system.orange,
        colors.system.red,
        threshold
    ]);
    var items = (0,react.useMemo)(function() {
        return controls.map(function(c) {
            switch(c){
                case "apps":
                    return {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsIcon/* AppsIcon */.j, {
                            size: 16
                        }),
                        label: t("general.appsEllipsis"),
                        onClick: handleAppsClick
                    };
                case "contact-host":
                    return {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                borderRadius: 4,
                                background: isRequestingHelp ? colors.system.red : undefined
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIcon/* HelpIcon */.b, {
                                color: isRequestingHelp ? colors.system.white : undefined,
                                size: 16
                            })
                        }),
                        disabled: orderedParticipantIds.includes(breakoutHost),
                        label: isRequestingHelp ? t("breakouts.cancelRequestForHelp") : t("breakouts.askHostForHelp"),
                        onClick: handleAskForHelpClick
                    };
                case "emoji-reaction":
                    return {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactionsIcon/* EmojiReactionsIcon */.H, {
                            size: 16
                        }),
                        id: "more-menu-emoji-reactions",
                        label: t("emojiReactions.sendReaction"),
                        onClick: handleEmojiReactionClick
                    };
                case "breakouts":
                    if (!enableBreakoutRooms) return null;
                    return {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutIcon/* BreakoutIcon */.y, {
                            size: 16
                        }),
                        id: "more-menu-breakouts",
                        label: t("general.breakoutRooms"),
                        onClick: handleBreakoutsClick
                    };
                case "chat":
                    if (!enableChat) return null;
                    return {
                        icon: chatUnread ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TrayBadge, {
                            color: colors.system.red,
                            variant: "inline",
                            visible: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* ChatIcon */.k, {
                            size: 16
                        }),
                        id: "more-menu-chat",
                        label: t("general.chat"),
                        onClick: handleChatClick
                    };
                case "network":
                    if (!enableNetworkUI) return null;
                    return {
                        icon: networkIcon,
                        id: "more-menu-network",
                        label: t("general.network"),
                        onClick: handleNetworkClick
                    };
                case "people":
                    return {
                        icon: peopleIcon,
                        id: "more-menu-people",
                        label: t("general.people"),
                        onClick: handlePeopleClick
                    };
                case "raisehand":
                    if (!enableHandRaising) return null;
                    return {
                        icon: isHandRaised ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LowerHandIcon/* LowerHandIcon */.P, {
                            size: 16
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandIcon/* RaiseHandIcon */.s, {
                            size: 16
                        }),
                        id: "more-menu-".concat(isHandRaised ? "lower" : "raise", "-hand"),
                        label: isHandRaised ? t("handRaising.lowerHand") : t("handRaising.raiseHand"),
                        onClick: handleRaiseHandClick
                    };
                case "record":
                    if (!enableRecording) return null;
                    var disabled = recordingUIState === "saved" || isRecording && !isLocalParticipantRecorded || breakoutStatus === "ongoing";
                    return {
                        disabled: disabled,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordIcon/* RecordIcon */.A, {
                            color: isRecording ? colors.system.red : "currentColor",
                            size: 16
                        }),
                        id: "more-menu-".concat(isRecording ? "stop" : "start", "-recording"),
                        label: isRecording ? t("recording.stop") : t("general.record"),
                        onClick: handleRecordClick
                    };
                case "screenshare":
                    if (!enableScreenShare) return null;
                    return {
                        disabled: screens.length >= 2 && !isSharingScreen,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                            color: isSharingScreen ? colors.system.white : "currentColor",
                            size: 16,
                            style: {
                                background: isSharingScreen ? colors.system.red : undefined,
                                borderRadius: 2
                            }
                        }),
                        id: "more-menu-".concat(isSharingScreen ? "stop" : "start", "-screenshare"),
                        label: isSharingScreen ? t("screenShare.stop") : t("screenShare.start"),
                        onClick: handleScreenshareClick
                    };
                default:
                    if (!(c in customTrayButtons)) return null;
                    var btn = customTrayButtons[c];
                    return {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcon, {
                            alt: btn.label,
                            src: btn.iconPath,
                            size: 16,
                            padding: 2
                        }),
                        id: "more-menu-custom-".concat(c),
                        label: btn.tooltip,
                        onClick: function() {
                            sendMessageToDriver({
                                action: ACTION_CUSTOM_BUTTON_CLICK,
                                button_id: c
                            });
                            setShowMenu(false);
                        }
                    };
            }
        }).filter(Boolean);
    }, [
        breakoutHost,
        breakoutStatus,
        chatUnread,
        colors.system.red,
        colors.system.white,
        controls,
        customTrayButtons,
        enableBreakoutRooms,
        enableChat,
        enableHandRaising,
        enableNetworkUI,
        enableRecording,
        enableScreenShare,
        handleAppsClick,
        handleAskForHelpClick,
        handleBreakoutsClick,
        handleChatClick,
        handleEmojiReactionClick,
        handleNetworkClick,
        handlePeopleClick,
        handleRaiseHandClick,
        handleRecordClick,
        handleScreenshareClick,
        isHandRaised,
        isLocalParticipantRecorded,
        isRecording,
        isRequestingHelp,
        isSharingScreen,
        networkIcon,
        orderedParticipantIds,
        peopleIcon,
        recordingUIState,
        screens.length,
        sendMessageToDriver,
        t, 
    ]);
    var badgeConfig = (0,react.useMemo)(function() {
        if (controls.includes("people") && waitingParticipants.length > 0) return {
            color: colors.system.red,
            visible: true
        };
        if (controls.includes("chat") && chatUnread) return {
            color: colors.system.red,
            visible: true
        };
        if (controls.includes("network")) {
            switch(threshold){
                case "low":
                    return {
                        color: colors.system.orange,
                        visible: true
                    };
                case "very-low":
                    return {
                        color: colors.system.red,
                        visible: true
                    };
            }
        }
    }, [
        chatUnread,
        colors.system.orange,
        colors.system.red,
        controls,
        threshold,
        waitingParticipants, 
    ]);
    if (controls.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, {
                "aria-controls": "tray-more-menu",
                badge: badgeConfig,
                id: id,
                onClick: function() {
                    return setShowMenu(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisIcon/* EllipsisIcon */.w, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        children: t("general.more")
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Menu, {
                align: "right",
                "aria-labelledby": id,
                id: "tray-more-menu",
                items: items,
                offsetTop: 4,
                onClose: function() {
                    return setShowMenu(false);
                },
                placement: "top"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Tray/NetworkControls.tsx
function NetworkControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function NetworkControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function NetworkControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NetworkControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function NetworkControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function NetworkControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NetworkControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NetworkControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = NetworkControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NetworkControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function NetworkControls_slicedToArray(arr, i) {
    return NetworkControls_arrayWithHoles(arr) || NetworkControls_iterableToArrayLimit(arr, i) || NetworkControls_unsupportedIterableToArray(arr, i) || NetworkControls_nonIterableRest();
}
function NetworkControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return NetworkControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return NetworkControls_arrayLikeToArray(o, minLen);
}












var NetworkControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = NetworkControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref = NetworkControls_slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var ref1 = NetworkControls_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref1[0], setSidebarView = ref1[1];
    var enableNetworkUI = (0,useCallConfig/* useCallConfig */.A)().enableNetworkUI;
    var threshold = (0,daily_react_esm/* useNetwork */.LN)().threshold;
    var ref2 = (0,react.useState)("good"), latestNetwork = ref2[0], setLatestNetwork = ref2[1];
    var ref3 = (0,react.useState)(false), hasNetworkChanged = ref3[0], setHasNetworkChanged = ref3[1];
    (0,react.useEffect)(function() {
        if (threshold === latestNetwork || sidebarView === "network") return;
        setLatestNetwork(threshold);
        setHasNetworkChanged(threshold !== "good");
    }, [
        latestNetwork,
        sidebarView,
        threshold
    ]);
    var handleNetworkClick = function(ev) {
        if (isMobile) return; // todo: handle mobile
        setSidebarView(function(sbv) {
            return sbv === "network" ? null : "network";
        });
        setHasNetworkChanged(false);
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    var badgeColorMap = {
        good: "transparent",
        low: colors.system.orange,
        "very-low": colors.system.red
    };
    if (!enableNetworkUI) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "network-controls",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, NetworkControls_objectSpread({
            badge: {
                color: badgeColorMap[latestNetwork],
                visible: hasNetworkChanged
            },
            className: classnames_default()(className, (_obj = {}, NetworkControls_defineProperty(_obj, robotsClassName("btn-network-show"), sidebarView !== "network"), NetworkControls_defineProperty(_obj, robotsClassName("btn-network-hide"), sidebarView === "network"), _obj)),
            onClick: handleNetworkClick
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GaugeIcon/* GaugeIcon */.h, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("general.network")
                })
            ]
        }))
    });
};


;// CONCATENATED MODULE: ./components/Tray/PeopleControls.tsx
function PeopleControls_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PeopleControls_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PeopleControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PeopleControls_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function PeopleControls_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PeopleControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PeopleControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PeopleControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PeopleControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PeopleControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PeopleControls_slicedToArray(arr, i) {
    return PeopleControls_arrayWithHoles(arr) || PeopleControls_iterableToArrayLimit(arr, i) || PeopleControls_unsupportedIterableToArray(arr, i) || PeopleControls_nonIterableRest();
}
function PeopleControls_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PeopleControls_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PeopleControls_arrayLikeToArray(o, minLen);
}












var PeopleControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = PeopleControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var colors = (0,Theme.useTheme)().colors;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = PeopleControls_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView = ref[0], setSidebarView = ref[1];
    var waitingParticipants = (0,daily_react_esm/* useWaitingParticipants */.zy)().waitingParticipants;
    var handRaiseBadgeStatus = useHandRaisingBadgeStatus();
    var handlePeopleClick = function(ev) {
        setSidebarView(sidebarView === "people" ? null : "people");
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "people-controls",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, PeopleControls_objectSpread({
            badge: {
                color: colors.system.red,
                visible: handRaiseBadgeStatus || waitingParticipants.length > 0
            },
            className: classnames_default()(className, (_obj = {}, PeopleControls_defineProperty(_obj, robotsClassName("btn-people-show"), sidebarView !== "people"), PeopleControls_defineProperty(_obj, robotsClassName("btn-people-hide"), sidebarView === "people"), _obj)),
            onClick: handlePeopleClick
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                    children: t("general.people")
                })
            ]
        }))
    });
};


;// CONCATENATED MODULE: ./components/Tray/ScreenShareControls.tsx
function ScreenShareControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScreenShareControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScreenShareControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ScreenShareControls_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ScreenShareControls_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ScreenShareControls_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


















var MAX_SCREEN_SHARES = 2;
var ScreenShareControls = function(_param) {
    var className = _param.className, onClick = _param.onClick, props = ScreenShareControls_objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,Theme.useTheme)(), colors = ref.colors, mediaQueries = ref.mediaQueries;
    var enableScreenShare = (0,useCallConfig/* useCallConfig */.A)().enableScreenShare;
    var ref1 = (0,daily_react_esm/* useScreenShare */.N2)(), isSharingScreen = ref1.isSharingScreen, startScreenShare = ref1.startScreenShare, stopScreenShare = ref1.stopScreenShare;
    var screens = (0,useScreens/* useScreens */.O)();
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var isDesktop = (0,useMediaQuery.useMediaQuery)(mediaQueries.large);
    var toggleSharingScreen = (0,react.useCallback)(function(ev) {
        isSharingScreen ? stopScreenShare() : startScreenShare();
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    }, [
        isSharingScreen,
        onClick,
        startScreenShare,
        stopScreenShare
    ]);
    var disabled = screens.length >= MAX_SCREEN_SHARES && !isSharingScreen;
    var tooltipTitle = (0,react.useMemo)(function() {
        // No tooltips on mobile or when not screen sharing
        if (!isDesktop) return null;
        if (isSharingScreen) return t("screenShare.stopSharing");
        if (screens.length >= MAX_SCREEN_SHARES) return t("screenShare.limited");
        return null;
    }, [
        isDesktop,
        isSharingScreen,
        screens.length,
        t
    ]);
    (0,daily_react_esm/* useAppMessage */.F3)({
        onAppMessage: (0,react.useCallback)(function(ev) {
            if (ev.data !== "stop-screen-share") return;
            stopScreenShare();
            addMessage({
                content: t("notification.screenShareStoppedByHost")
            });
        }, [
            addMessage,
            stopScreenShare,
            t
        ])
    });
    if (!enableScreenShare) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "4d03de5b3e259ccc",
                [
                    colors.system.red
                ]
            ]
        ]) + " " + (classnames_default()("screen-share-controls", {
            isSharing: isSharingScreen
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                title: tooltipTitle,
                delay: TOOLTIP_DELAY,
                disabled: !isDesktop || !isSharingScreen && screens.length < MAX_SCREEN_SHARES,
                id: "tt-screenshare-btn",
                tabIndex: -1,
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrayButton, ScreenShareControls_objectSpread({
                    className: classnames_default()(className, (_obj = {}, ScreenShareControls_defineProperty(_obj, robotsClassName("btn-screenshare-start"), !isSharingScreen), ScreenShareControls_defineProperty(_obj, robotsClassName("btn-screenshare-stop"), isSharingScreen), _obj)),
                    onClick: toggleSharingScreen,
                    disabled: disabled
                }, props, {
                    children: [
                        isSharingScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StopScreenshareIcon/* StopScreenshareIcon */.C, {
                            className: "icon",
                            color: colors.system.white
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenshareIcon/* ScreenshareIcon */.Q, {
                            className: "icon",
                            color: disabled ? "var(--text-muted)" : "currentColor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleText, {
                            on: isSharingScreen,
                            onText: t("screenShare.stop"),
                            offText: t("screenShare.start"),
                            disabled: disabled
                        })
                    ]
                }))
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4d03de5b3e259ccc",
                dynamic: [
                    colors.system.red
                ],
                children: ".screen-share-controls.__jsx-style-dynamic-selector .icon{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.screen-share-controls.isSharing.__jsx-style-dynamic-selector .icon{background:".concat(colors.system.red, "}")
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/Tray/Tray.tsx
function Tray_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Tray_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Tray_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Tray_arrayLikeToArray(arr);
}
function Tray_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Tray_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Tray_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Tray_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Tray_slicedToArray(arr, i) {
    return Tray_arrayWithHoles(arr) || Tray_iterableToArrayLimit(arr, i) || Tray_unsupportedIterableToArray(arr, i) || Tray_nonIterableRest();
}
function Tray_toConsumableArray(arr) {
    return Tray_arrayWithoutHoles(arr) || Tray_iterableToArray(arr) || Tray_unsupportedIterableToArray(arr) || Tray_nonIterableSpread();
}
function Tray_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Tray_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tray_arrayLikeToArray(o, minLen);
}





























var MORE_ID = "tray-more-btn";
var LEAVE_ID = "btn-leave";
var Tray = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var ref10 = Tray_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 1), customTrayButtons = ref10[0];
    var disableAudio = (0,CallProvider/* useCallState */.oz)().disableAudio;
    var ref1 = Tray_slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 1), showLeaveButton = ref1[0];
    var ref2 = (0,useCallConfig/* useCallConfig */.A)(), broadcastRole = ref2.broadcastRole, enableBreakoutRooms = ref2.enableBreakoutRooms, enableChat = ref2.enableChat, enableEmojiReactions = ref2.enableEmojiReactions, enableHandRaising = ref2.enableHandRaising, enableNetworkUI = ref2.enableNetworkUI, enablePeopleUI = ref2.enablePeopleUI, enableRecording = ref2.enableRecording, enableRecordingUI = ref2.enableRecordingUI, enableScreenShare = ref2.enableScreenShare;
    var ref3 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), canControlIntegration = ref3.canControlIntegration, mainIntegrations = ref3.mainIntegrations;
    var ref4 = (0,useBreakoutSessionState/* useBreakoutSessionState */.V)(), breakoutHost = ref4.breakoutHost, breakoutStatus = ref4.breakoutStatus;
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var isLocalOwner = (0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, "owner");
    var isAttendee = (0,react.useMemo)(function() {
        return broadcastRole === "attendee";
    }, [
        broadcastRole
    ]);
    var apps = mainIntegrations.filter(canControlIntegration);
    var controlsRef = (0,react.useRef)(null);
    var secondaryRef = (0,react.useRef)(null);
    var defaultControls = (0,react.useMemo)(function() {
        var _controls;
        var controls = [];
        if (enablePeopleUI) controls.push("people");
        if (enableChat) controls.push("chat");
        if (enableEmojiReactions) controls.push("emoji-reaction");
        /* In broadcast only calls, we want to enable raise hand controls for participants only*/ if (!isAttendee && enableHandRaising) controls.push("raisehand");
        if (enableScreenShare) controls.push("screenshare");
        if (enableRecording && enableRecordingUI) controls.push("record");
        if (enableNetworkUI) controls.push("network");
        if (isLocalOwner && enableBreakoutRooms) controls.push("breakouts");
        if (apps.length) controls.push("apps");
        if (breakoutStatus === "ongoing" && breakoutHost !== localSessionId) controls.push("contact-host");
        if (customTrayButtons) (_controls = controls).push.apply(_controls, Tray_toConsumableArray(Object.keys(customTrayButtons)));
        return controls;
    }, [
        apps.length,
        breakoutHost,
        breakoutStatus,
        customTrayButtons,
        enableBreakoutRooms,
        enableChat,
        enableEmojiReactions,
        enableHandRaising,
        enableNetworkUI,
        enablePeopleUI,
        enableRecording,
        enableRecordingUI,
        enableScreenShare,
        isAttendee,
        isLocalOwner,
        localSessionId, 
    ]);
    var ref5 = (0,react.useState)(defaultControls), /*#__PURE__*/ visibleControls = ref5[0], setVisibleControls = ref5[1];
    var ref6 = (0,react.useState)([]), menuControls = ref6[0], setMenuControls = ref6[1];
    (0,useResize.useResize)((0,react.useCallback)(function() {
        var ref11, ref7;
        if (!controlsRef.current) return;
        document.body.style.setProperty("--tray-height", "".concat(controlsRef.current.closest(".tray").clientHeight, "px"));
        var clientWidth = controlsRef.current.clientWidth;
        var controlWidths = defaultControls.reduce(function(widths, control) {
            var ref;
            widths[control] = (ref = document.getElementById("".concat(control, "-controls"))) === null || ref === void 0 ? void 0 : ref.clientWidth;
            return widths;
        }, {});
        var secondaryWidth = secondaryRef.current.clientWidth;
        var ref8;
        var moreWidth = (ref8 = (ref11 = document.getElementById(MORE_ID)) === null || ref11 === void 0 ? void 0 : ref11.clientWidth) !== null && ref8 !== void 0 ? ref8 : 0;
        var ref9;
        var leaveWidth = (ref9 = (ref7 = document.getElementById(LEAVE_ID)) === null || ref7 === void 0 ? void 0 : ref7.clientWidth) !== null && ref9 !== void 0 ? ref9 : 0;
        var availableSecondaryWidth = secondaryWidth - moreWidth - leaveWidth;
        var availableWidth = clientWidth + availableSecondaryWidth;
        var visControls = [];
        var menControls = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(controlWidths)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = Tray_slicedToArray(_step.value, 2), control1 = _value[0], width = _value[1];
                if (!defaultControls.includes(control1)) continue;
                if (availableWidth >= width) {
                    availableWidth -= width;
                    visControls.push(control1);
                } else {
                    availableWidth = 0;
                    menControls.push(control1);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Don't update visibleControls, if nothing has changed.
        // Avoids infinite state update loop.
        if (fast_deep_equal_default()(visibleControls, visControls)) return;
        setMenuControls(menControls);
        setVisibleControls(visControls);
    }, [
        defaultControls,
        visibleControls
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "749e0175ced7ff7b",
                [
                    colors.backgroundAccent
                ]
            ]
        ]) + " " + "tray",
        children: [
            !isAttendee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "749e0175ced7ff7b",
                        [
                            colors.backgroundAccent
                        ]
                    ]
                ]) + " " + "av-controls",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls, {
                        id: "video-controls"
                    }),
                    !disableAudio && /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioControls, {
                        id: "audio-controls"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                variant: "strong",
                style: {
                    paddingLeft: 8,
                    flex: 1
                },
                children: t("broadcast.viewingCall")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: controlsRef,
                className: styled_jsx_default().dynamic([
                    [
                        "749e0175ced7ff7b",
                        [
                            colors.backgroundAccent
                        ]
                    ]
                ]) + " " + "controls",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleControls, {
                        id: "people-controls",
                        visible: visibleControls.includes("people")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatControls, {
                        id: "chat-controls",
                        visible: visibleControls.includes("chat")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiReactionControls, {
                        id: "emoji-reaction-controls",
                        visible: visibleControls.includes("emoji-reaction")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RaiseHandControls, {
                        id: "raisehand-controls",
                        visible: visibleControls.includes("raisehand")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenShareControls, {
                        id: "screenshare-controls",
                        visible: visibleControls.includes("screenshare")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordControls, {
                        id: "record-controls",
                        visible: visibleControls.includes("record")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NetworkControls, {
                        id: "network-controls",
                        visible: visibleControls.includes("network")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakoutControls, {
                        id: "breakouts-controls",
                        visible: visibleControls.includes("breakouts")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsControls, {
                        id: "apps-controls",
                        visible: visibleControls.includes("apps")
                    }),
                    Object.entries(customTrayButtons !== null && customTrayButtons !== void 0 ? customTrayButtons : {}).map(function(param) {
                        var _param = Tray_slicedToArray(param, 2), id = _param[0], btn = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                            btn: btn,
                            id: id,
                            visible: visibleControls.includes(id)
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: secondaryRef,
                className: styled_jsx_default().dynamic([
                    [
                        "749e0175ced7ff7b",
                        [
                            colors.backgroundAccent
                        ]
                    ]
                ]) + " " + "secondary-controls",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactHostControls, {
                        id: "contact-host-controls",
                        visible: visibleControls.includes("contact-host")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreControls, {
                        controls: menuControls,
                        id: MORE_ID
                    }),
                    showLeaveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaveButton, {
                        id: LEAVE_ID
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "749e0175ced7ff7b",
                dynamic: [
                    colors.backgroundAccent
                ],
                children: ".tray.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:var(--card-bg);border-top:1px solid var(--card-border);bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;padding:8px 4px;position:fixed;width:100vw;z-index:var(--zindex-tray)}.av-controls.__jsx-style-dynamic-selector,.secondary-controls.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}.secondary-controls.__jsx-style-dynamic-selector{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.tray.__jsx-style-dynamic-selector .controls.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:0}.tray.__jsx-style-dynamic-selector .integration.active{background:".concat(colors.backgroundAccent, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Tray/index.ts


;// CONCATENATED MODULE: ./components/WaitingForHost/WaitingForHost.tsx












var WaitingForHost = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var ref = (0,Theme.useTheme)(), mediaQueries = ref.mediaQueries, zIndex = ref.zIndex;
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ showText = ref1[0], setShowText = ref1[1];
    var poweredByDaily = (0,useCallConfig/* useCallConfig */.A)().poweredByDaily;
    /**
     * This waiting message only shows if there is no owner/host present.
     * Add a delay to avoid the message flashing before the participant
     * count has updated correctly.
     */ (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setShowText(true);
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "5862eee67471fd40",
                [
                    mediaQueries.nonCoarse,
                    zIndex.header
                ]
            ]
        ]) + " " + "container",
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "5862eee67471fd40",
                        [
                            mediaQueries.nonCoarse,
                            zIndex.header
                        ]
                    ]
                ]) + " " + "banner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner, {})
            }),
            showText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "5862eee67471fd40",
                        [
                            mediaQueries.nonCoarse,
                            zIndex.header
                        ]
                    ]
                ]) + " " + "waitingForHost",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        variant: "largestrong",
                                        children: t("broadcast.waitingForHostTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        textAlign: "center",
                                        variant: textVariant,
                                        children: t("broadcast.waitingForHostSubtitle")
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5862eee67471fd40",
                dynamic: [
                    mediaQueries.nonCoarse,
                    zIndex.header
                ],
                children: ".container.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;overflow:auto;padding:46px 16px 16px;width:100%}.waitingForHost.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;width:100%;padding:8px}.waitingForHost.__jsx-style-dynamic-selector .card-content{padding:32px}@media ".concat(mediaQueries.nonCoarse, "{.haircheck.__jsx-style-dynamic-selector>*:not(.banner){margin:auto}}.banner.__jsx-style-dynamic-selector{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;left:0;position:fixed;top:0;width:100vw;z-index:").concat(zIndex.header, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/WaitingForHost/index.ts


// EXTERNAL MODULE: ./components/App/Layout.tsx + 1 modules
var Layout = __webpack_require__(9142);
;// CONCATENATED MODULE: ./components/App/LoadingScreen.tsx




var LoadingScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-4d499f1db3cc8313",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {})
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4d499f1db3cc8313",
                children: "div.jsx-4d499f1db3cc8313{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100vh;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/App/FinalMessage.tsx







var FinalMessage = function(param) {
    var _cta = param.cta, cta = _cta === void 0 ? null : _cta, desc = param.desc, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _poweredByDaily = param.poweredByDaily, poweredByDaily = _poweredByDaily === void 0 ? false : _poweredByDaily, _showLoadingScreen = param.showLoadingScreen, showLoadingScreen = _showLoadingScreen === void 0 ? false : _showLoadingScreen, title = param.title, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    if (showLoadingScreen) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {});
    var titleColor = {
        default: "default",
        error: "error",
        success: "success"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-a2a29622f42dbbc8" + " " + "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    align: "center",
                                    gap: 16,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                            align: "center",
                                            children: [
                                                icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    color: titleColor[variant],
                                                    textAlign: "center",
                                                    variant: "largestrong",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    textAlign: "center",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        cta
                                    ]
                                })
                            })
                        })
                    }),
                    (0,jsx_runtime.jsx)((styled_jsx_default()), {
                        id: "a2a29622f42dbbc8",
                        children: ".container.jsx-a2a29622f42dbbc8{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;overflow:auto;width:100%;padding:8px}.container.jsx-a2a29622f42dbbc8 .card-content{padding:32px}"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/App/useBandwidthControls.ts



var STANDARD_HIGH_BITRATE_CAP = 980;
var STANDARD_LOW_BITRATE_CAP = 300;
/**
 * Automatically updates bandwidth controls based on topology, network threshold and videoQuality.
 */ var useBandwidthControls = function() {
    var videoQuality = useVideoQuality().videoQuality;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref = (0,daily_react_esm/* useNetwork */.LN)(), threshold = ref.threshold, topology = ref.topology;
    var isSharingScreen = (0,daily_react_esm/* useScreenShare */.N2)().isSharingScreen;
    var lastQualitySet = (0,react.useRef)(null);
    var lastSetKBS = (0,react.useRef)(null);
    /**
   * Query param based flag to turn off auto-cam-mute on very-low network.
   */ var disableCameraNetworkQualityMute = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        var query = new URLSearchParams(window.location.search);
        disableCameraNetworkQualityMute.current = query.has("disableCameraNetworkQualityMute");
    }, []);
    var setQuality = (0,react.useCallback)(function(q) {
        if (!daily) return;
        if ([
            "new",
            "loading"
        ].includes(daily.meetingState()) || !topology) return;
        var peers = Object.keys(daily.participants()).length - 1;
        var isSFU = topology === "sfu";
        var lowKbs = isSFU ? STANDARD_LOW_BITRATE_CAP : Math.floor(STANDARD_LOW_BITRATE_CAP / Math.max(1, peers));
        var highKbs = isSFU ? STANDARD_HIGH_BITRATE_CAP : Math.floor(STANDARD_HIGH_BITRATE_CAP / Math.max(1, peers));
        switch(q){
            case "auto":
            case "high":
                if (lastSetKBS.current !== highKbs) {
                    daily.setBandwidth({
                        kbs: highKbs
                    });
                    lastSetKBS.current = highKbs;
                }
                break;
            case "low":
                if (lastSetKBS.current !== lowKbs) {
                    daily.setBandwidth({
                        kbs: lowKbs
                    });
                    lastSetKBS.current = lowKbs;
                }
                break;
            case "bandwidth-saver":
                daily.setLocalVideo(false);
                if (lastSetKBS.current !== lowKbs) {
                    daily.setBandwidth({
                        kbs: lowKbs
                    });
                    lastSetKBS.current = lowKbs;
                }
                break;
        }
        lastQualitySet.current = q;
    }, [
        daily,
        topology
    ]);
    /**
   * Re-calculate bandwidth limits when network threshold or videoQuality changes.
   */ (0,react.useEffect)(function() {
        if (isSharingScreen) {
            setQuality("low");
            return;
        }
        switch(threshold){
            case "very-low":
                if (!disableCameraNetworkQualityMute.current) {
                    setQuality("bandwidth-saver");
                }
                break;
            case "low":
                setQuality(videoQuality === "bandwidth-saver" ? videoQuality : "low");
                break;
            case "good":
                setQuality([
                    "bandwidth-saver",
                    "low"
                ].includes(videoQuality) ? videoQuality : "high");
                break;
        }
    }, [
        isSharingScreen,
        setQuality,
        threshold,
        topology,
        videoQuality
    ]);
    /**
   * Re-calculates bandwidth limits, when participants join or leave,
   * opt topology changes.
   */ var timeout = (0,react.useRef)(null);
    var handleParticipantCountChange = (0,react.useCallback)(function() {
        if (!lastQualitySet.current) return;
        if (timeout.current) clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            setQuality(lastQualitySet.current);
        }, 500);
    }, [
        setQuality
    ]);
    /**
   * Re-call handleParticipantCountChange in case joined or left participant
   * triggered a topology switch (p2p->sfu or sfu->p2p).
   */ (0,react.useEffect)(handleParticipantCountChange, [
        handleParticipantCountChange,
        topology, 
    ]);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-joined", handleParticipantCountChange);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-left", handleParticipantCountChange);
};

;// CONCATENATED MODULE: ./components/App/useIntercomIntegration.ts
function useIntercomIntegration_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIntercomIntegration_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useIntercomIntegration_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIntercomIntegration_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIntercomIntegration_slicedToArray(arr, i) {
    return useIntercomIntegration_arrayWithHoles(arr) || useIntercomIntegration_iterableToArrayLimit(arr, i) || useIntercomIntegration_unsupportedIterableToArray(arr, i) || useIntercomIntegration_nonIterableRest();
}
function useIntercomIntegration_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIntercomIntegration_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIntercomIntegration_arrayLikeToArray(o, minLen);
}




/**
 * Helper hook to identify whether this call is running in an Intercom integration.
 * Automatically hides participant bar, names and leave button.
 */ var useIntercomIntegration = function() {
    var query = (0,router.useRouter)().query;
    var state = (0,CallProvider/* useCallState */.oz)().state;
    var ref = useIntercomIntegration_slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 2), setShowFullscreenButton = ref[1];
    var ref1 = useIntercomIntegration_slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 2), setShowLeaveButton = ref1[1];
    var ref2 = useIntercomIntegration_slicedToArray((0,custom/* useShowNames */.zD)(), 2), setShowNames = ref2[1];
    var ref3 = useIntercomIntegration_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref3[1];
    var configureForIntercom = (0,react.useCallback)(function() {
        setShowParticipantsBar(false);
        setShowNames(false);
        setShowLeaveButton(false);
        setShowFullscreenButton(true);
    }, [
        setShowFullscreenButton,
        setShowLeaveButton,
        setShowNames,
        setShowParticipantsBar, 
    ]);
    (0,react.useEffect)(function() {
        if (query["autojoin"] === "t" && query["intercomAppLink"] === "t" && state === "joining") {
            configureForIntercom();
        }
    }, [
        configureForIntercom,
        query,
        state
    ]);
};

;// CONCATENATED MODULE: ./components/App/App.tsx
function App_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function App_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function App_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function App_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                App_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                App_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function App_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function App_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function App_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function App_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            App_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function App_slicedToArray(arr, i) {
    return App_arrayWithHoles(arr) || App_iterableToArrayLimit(arr, i) || App_unsupportedIterableToArray(arr, i) || App_nonIterableRest();
}
function App_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return App_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return App_arrayLikeToArray(o, minLen);
}

































var App = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref8 = (0,CallProvider/* useCallState */.oz)(), mode = ref8.mode, reloadCall = ref8.reloadCall, state = ref8.state;
    var ref1 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref1.broadcast, broadcastRole = ref1.broadcastRole;
    var ref2 = (0,daily_react_esm/* useDevices */.Ls)(), camState = ref2.camState, micState = ref2.micState;
    var ref3 = App_slicedToArray((0,core/* useIsMobile */.dD)(), 2), isMobile = ref3[0], setIsMobile = ref3[1];
    var ref4 = (0,react.useState)(false), disableWaitingForHostMsg = ref4[0], setDisableWaitingForHostMsg = ref4[1];
    var ownerParticipantIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "owner"
    });
    var poweredByDaily = (0,useCallConfig/* useCallConfig */.A)().poweredByDaily;
    var errorSound = useSoundLoader().errorSound;
    var ref5 = (0,useDebugging/* useDebugging */.W)(), disablePrebuiltDebugger = ref5.disablePrebuiltDebugger, enablePrebuiltDebugger = ref5.enablePrebuiltDebugger;
    var query = (0,router.useRouter)().query;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    useBandwidthControls();
    useIntercomIntegration();
    /**
   * Applies stored background effect when the camera is started.
   */ useBackgroundEffect();
    /**
   * Applies stored audio processor when the camera is started
   */ var ref6 = useAudioProcessor(), currentAudioProcessor = ref6.currentAudioProcessor, setAudioProcessor = ref6.setAudioProcessor;
    (0,daily_react_esm/* useDailyEvent */.VU)("started-camera", (0,react.useCallback)(App_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, inputSettings;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (daily) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return daily.getInputSettings();
                case 5:
                    inputSettings = _ctx.sent;
                    if (currentAudioProcessor && !(inputSettings === null || inputSettings === void 0 ? void 0 : (ref = inputSettings.audio) === null || ref === void 0 ? void 0 : ref.processor)) {
                        setAudioProcessor(currentAudioProcessor);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        currentAudioProcessor,
        daily,
        setAudioProcessor
    ]));
    /**
   * Provide debugging functionality
   */ (0,react.useEffect)(function() {
        window["dailyDisablePrebuiltDebugger"] = disablePrebuiltDebugger;
        window["dailyEnablePrebuiltDebugger"] = enablePrebuiltDebugger;
        if ("debug" in query) {
            enablePrebuiltDebugger();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    /**
   * Listen for live-streaming errors and show a snackbar in case.
   */ (0,daily_react_esm/* useLiveStreaming */.vW)({
        onLiveStreamingError: (0,react.useCallback)(function() {
            addMessage({
                content: t("notification.liveStreamingError"),
                type: "error"
            });
        }, [
            addMessage,
            t
        ])
    });
    /**
   * Determine whether the client runs on mobile.
   * This activates the mobile UI.
   */ (0,react.useEffect)(function() {
        if (isMobile) return;
        var platform = es5_default().parse(window.navigator.userAgent).platform;
        var browserType = platform === null || platform === void 0 ? void 0 : platform.type;
        if ([
            "mobile",
            "tablet"
        ].includes(browserType) || (0,browserConfig/* isIOSMobile */.eS)()) {
            setIsMobile(true);
        }
    }, [
        isMobile,
        setIsMobile
    ]);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-joined", (0,react.useCallback)(function(evts) {
        // the "waiting for host" message only shows before a host has joined
        if (evts.some(function(ev) {
            return ev.participant.owner;
        })) setDisableWaitingForHostMsg(true);
    }, []));
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref7 = App_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "tracks.audio.off.byRemoteRequest",
        "tracks.video.off.byRemoteRequest", 
    ]), 2), audioMutedByRemoteRequest = ref7[0], videoMutedByRemoteRequest = ref7[1];
    /**
   * Display a muted by host message, in case the participant's mic got muted.
   */ (0,react.useEffect)(function() {
        if (!audioMutedByRemoteRequest) return;
        addMessage({
            content: t("notification.micMutedByHost"),
            type: "info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                muted: true,
                size: 16
            })
        });
    }, [
        addMessage,
        audioMutedByRemoteRequest,
        t
    ]);
    /**
   * Display a muted by host message, in case the participant's cam got muted.
   */ (0,react.useEffect)(function() {
        if (!videoMutedByRemoteRequest) return;
        addMessage({
            content: t("notification.camMutedByHost"),
            type: "info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                id: "snackbarIcon".concat(Date.now()),
                muted: true,
                size: 16
            })
        });
    }, [
        addMessage,
        videoMutedByRemoteRequest,
        t
    ]);
    /**
   * Play error sound on 'knocking-denied' CallState.
   * TODO: Refactor to 'useEvent' once it's available.
   */ (0,react.useEffect)(function() {
        if (state !== "knocking-denied") return;
        errorSound.play();
    }, [
        errorSound,
        state
    ]);
    var messageProps = (0,react.useMemo)(function() {
        switch(state){
            case "ended":
                return {
                    desc: t("lobby.ended.desc"),
                    title: t("lobby.ended.title"),
                    variant: "error"
                };
            case "error":
                return {
                    desc: t("lobby.error.desc"),
                    title: t("lobby.error.title"),
                    variant: "error"
                };
            case "expired":
                return {
                    desc: t("lobby.expired.desc"),
                    title: t("lobby.expired.title"),
                    variant: "error"
                };
            case "full":
                return {
                    desc: t("lobby.full.desc"),
                    title: t("lobby.full.title"),
                    variant: "error"
                };
            case "joining":
                if ((camState === "pending" || micState === "pending") && broadcast !== null && broadcastRole !== "attendee") {
                    return {
                        desc: t("lobby.devicePermissions.desc"),
                        title: t("lobby.devicePermissions.title")
                    };
                }
                break;
            case "knocking-cancelled":
                return mode === "direct-link" ? {
                    showLoadingScreen: true
                } : {
                    desc: t("lobby.canceled.desc"),
                    title: t("lobby.canceled.title")
                };
            case "knocking-denied":
                return {
                    desc: t("lobby.denied.desc"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                        color: colors.system.red
                    }),
                    title: t("lobby.denied.title")
                };
            case "left":
                return {
                    cta: poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        href: "https://www.daily.co",
                        variant: "secondary",
                        children: t("lobby.left.learnMore")
                    }),
                    desc: poweredByDaily ? t("lobby.left.descBranded") : t("lobby.left.descUnbranded"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "largestrong",
                        children: "\uD83D\uDC4B"
                    }),
                    poweredByDaily: poweredByDaily,
                    title: t("lobby.left.title")
                };
            case "nbf":
                return {
                    cta: mode === "direct-link" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "nbf-reload",
                        onClick: reloadCall,
                        variant: "primary",
                        children: t("general.tryAgain")
                    }) : null,
                    desc: t("lobby.notAvailable.desc"),
                    title: t("lobby.notAvailable.title"),
                    variant: "error"
                };
            case "not-allowed":
                return {
                    desc: t("lobby.noAccess.desc"),
                    title: t("lobby.noAccess.title"),
                    variant: "error"
                };
            case "not-found":
                return {
                    desc: t("lobby.notFound.desc"),
                    title: t("lobby.notFound.title"),
                    variant: "error"
                };
            case "not-secure":
                return {
                    desc: t("lobby.notSecure.desc"),
                    title: t("lobby.notSecure.title"),
                    variant: "error"
                };
            case "removed-from-call":
                return {
                    desc: t("lobby.removed.desc"),
                    title: t("lobby.removed.title"),
                    variant: "error"
                };
        }
        return null;
    }, [
        broadcast,
        broadcastRole,
        camState,
        colors.system.red,
        micState,
        mode,
        poweredByDaily,
        reloadCall,
        state,
        t, 
    ]);
    return (0,react.useMemo)(function() {
        if (mode === "embedded" && state === "redirecting") {
            // Don't redirect in embedded mode, just clear out UI
            return null;
        }
        if (messageProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalMessage, App_objectSpread({}, messageProps))
            });
        }
        if ([
            "awaiting-args",
            "ready",
            "joining"
        ].includes(state) || // Wait for localParticipant to be present
        !localSessionId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {});
        }
        if (state === "lobby") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Haircheck, {})
            });
        }
        /**
     * A host must be present for OOB attendees to see the in-call UI.
     * Once attendees have entered the call, this message won't be shown
     * again.
     */ if (broadcastRole === "attendee" && ownerParticipantIds.length === 0 && !disableWaitingForHostMsg) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingForHost, {}),
                    ";"
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomProvider, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Call, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tray, {})
                    ]
                })
            })
        });
    }, [
        broadcastRole,
        disableWaitingForHostMsg,
        isMobile,
        localSessionId,
        messageProps,
        ownerParticipantIds.length,
        state,
        mode, 
    ]);
};

;// CONCATENATED MODULE: ./components/App/index.ts


;// CONCATENATED MODULE: ./contexts/ConditionalProvider.tsx


var ConditionalProvider = function(param) {
    var check = param.check, children = param.children, Provider = param.Provider;
    var config = (0,useCallConfig/* useCallConfig */.A)();
    if (check(config)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

;// CONCATENATED MODULE: ./pages/[room].tsx
/* provided dependency */ var process = __webpack_require__(4406);
function _room_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _room_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _room_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





















function CallUI(param) {
    var _micAudioMode = param.micAudioMode, micAudioMode = _micAudioMode === void 0 ? "speech" : _micAudioMode;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,router.useRouter)(), query = ref.query, replace = ref.replace;
    var ref1 = (0,react.useState)(null), domain = ref1[0], setDomain = ref1[1];
    var ref2 = (0,react.useState)(true), isDomainSet = ref2[0], setIsDomainSet = ref2[1];
    var ref3 = (0,react.useState)(null), customHost = ref3[0], setCustomHost = ref3[1];
    var ref4 = (0,react.useState)(false), bypassRegionDetection = ref4[0], setBypassRegionDetection = ref4[1];
    var ref5 = (0,react.useState)(false), v2CamAndMic = ref5[0], setV2CamAndMic = ref5[1];
    var ref6 = (0,react.useState)(null), roomsCheckOrigin = ref6[0], setRoomsCheckOrigin = ref6[1];
    var ref7 = (0,react.useState)(null), apiHost = ref7[0], setApiHost = ref7[1];
    var ref8 = (0,react.useState)(null), room = ref8[0], setRoom = ref8[1];
    var ref9 = (0,react.useState)(""), token = ref9[0], setToken = ref9[1];
    var ref10 = (0,react.useState)(""), frameId = ref10[0], setFrameId = ref10[1];
    /**
   * Read all required query params, once query is ready,
   * making sure they'll never be removed from state,
   * when they're removed from the URL (like token).
   */ (0,react.useEffect)(function() {
        if (Object.keys(query).length === 0) return;
        if (query.debug) {
            var _NEXT_PUBLIC_SENTRY_ENVIRONMENT;
            console.log({
                app_name: "prebuilt",
                git_hash: "9aced16db61620cccc074b4f5da2951348db85ac",
                git_ref: "refs/heads/main",
                environment_name: (_NEXT_PUBLIC_SENTRY_ENVIRONMENT = "production") !== null && _NEXT_PUBLIC_SENTRY_ENVIRONMENT !== void 0 ? _NEXT_PUBLIC_SENTRY_ENVIRONMENT : location.hostname.includes("localhost") || location.hostname.includes("khk-local.wss.daily.co") ? "local-development" : "production"
            });
        }
        if (query.name) {
            // HACK: Set PLUOT_PARTICIPANT_NAME in localStorage directly,
            // so daily-js will pick that up immediately.
            // This has the advantage of not having to wait until daily-js is loaded.
            var safeLocalStorage = (0,safeStorage/* safeStorage */.w)(function() {
                return localStorage;
            });
            safeLocalStorage.setItem("PLUOT_PARTICIPANT_NAME", (0,lib_query/* getQueryParam */.P)("name", query));
        }
        if (query.customHost) {
            setCustomHost((0,lib_query/* getQueryParam */.P)("customHost", query));
        } else if (process.env.DAILY_CUSTOM_HOST) {
            setCustomHost(process.env.DAILY_CUSTOM_HOST);
        }
        if (query.room) setRoom((0,lib_query/* getQueryParam */.P)("room", query));
        if (query.bypassRegionDetection) setBypassRegionDetection((0,lib_query/* getQueryParam */.P)("bypassRegionDetection", query) === "true");
        if (query.v2CamAndMic) {
            setV2CamAndMic((0,lib_query/* getQueryParam */.P)("v2CamAndMic", query) === "true");
        }
        if (query.roomsCheckOrigin) {
            setRoomsCheckOrigin((0,lib_query/* getQueryParam */.P)("roomsCheckOrigin", query));
        } else if (process.env.DAILY_ROOMS_CHECK_ORIGIN) {
            setRoomsCheckOrigin(process.env.DAILY_ROOMS_CHECK_ORIGIN);
        }
        if (query.apiHost) {
            setApiHost((0,lib_query/* getQueryParam */.P)("apiHost", query));
        } else if (process.env.DAILY_API_HOST) {
            setApiHost(process.env.DAILY_API_HOST);
        }
        if (query.t) {
            setToken((0,lib_query/* getQueryParam */.P)("t", query));
        }
        if (query.emb) {
            setFrameId((0,lib_query/* getQueryParam */.P)("emb", query));
        }
        if (query.domain) {
            setDomain((0,lib_query/* getQueryParam */.P)("domain", query));
            setIsDomainSet(true);
            return;
        }
        // Find domain via location.hostname
        var dnsTrailer = ".daily.co";
        if (process.env.DAILY_DNS_TRAILER) {
            dnsTrailer = process.env.DAILY_DNS_TRAILER;
        }
        if (location.hostname.endsWith(dnsTrailer)) {
            setDomain(location.hostname.replace(dnsTrailer, ""));
            setIsDomainSet(true);
            return;
        }
        setIsDomainSet(false);
    }, [
        query
    ]);
    /**
   * Once we got the token, remove it from the URL.
   */ (0,react.useEffect)(function() {
        if (!token || !query.t) return;
        var _t = query.t, newQuery = _room_objectWithoutProperties(query, [
            "t"
        ]);
        replace({
            query: newQuery
        }, undefined, {
            shallow: true
        });
    }, [
        query,
        replace,
        token
    ]);
    var isEmbedded = (0,react.useMemo)(function() {
        return !!frameId;
    }, [
        frameId
    ]);
    if (!isDomainSet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalMessage, {
                    title: t("lobby.notFound.title"),
                    desc: t("lobby.notFound.desc"),
                    variant: "error"
                })
            })
        });
    }
    if (!domain) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar.SnackbarProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallProvider/* CallProvider */.DG, {
                domain: domain,
                room: room,
                customHost: customHost,
                token: token,
                isEmbedded: isEmbedded,
                bypassRegionDetection: bypassRegionDetection,
                v2CamAndMic: v2CamAndMic,
                roomsCheckOrigin: roomsCheckOrigin,
                apiHost: apiHost,
                micAudioMode: micAudioMode,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantsProvider/* ParticipantsProvider */.n5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TracksProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeDriverProvider, {
                            frameId: frameId,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaDeviceProvider, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                    check: function(config) {
                                        return Boolean(config.enableRecording);
                                    },
                                    Provider: RecordingProvider/* RecordingProvider */.RV,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                        check: function(config) {
                                            return Boolean(config.enableChat);
                                        },
                                        Provider: ChatProvider/* ChatProvider */.aM,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                            check: function(config) {
                                                return Boolean(config.enableBreakoutRooms);
                                            },
                                            Provider: BreakoutsProvider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {})
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 3368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Anchor = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _dom = __webpack_require__(6912);

var _excluded = ["children", "className", "href", "onClick", "underline"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Anchor = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      underline = _ref.underline,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isExternalHref = href && href.match(/^(https?:)?\/\//);
  var isHashHref = href === null || href === void 0 ? void 0 : href.match(/^#/);
  var targetProps = isExternalHref ? {
    rel: 'noopener',
    target: '_blank'
  } : {};

  var handleClick = function handleClick(ev) {
    if (isHashHref) {
      ev.preventDefault();
      var targetEl = document.getElementById(href.slice(1));

      if (targetEl) {
        (0, _dom.scrollToElement)(targetEl);
      }
    }

    onClick === null || onClick === void 0 ? void 0 : onClick(ev);
  };

  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
    ref: ref,
    href: href,
    onClick: handleClick
  }, targetProps, props, {
    className: "jsx-4048977518" + " " + (props && props.className != null && props.className || targetProps && targetProps.className != null && targetProps.className || (0, _classnames["default"])(className, {
      underline: underline
    }) || "")
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "4048977518"
  }, ["a.jsx-4048977518{color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;position:relative;-webkit-text-decoration:none;text-decoration:none;}", "a.underline.jsx-4048977518{-webkit-text-decoration:underline;text-decoration:underline;}", "a.jsx-4048977518:focus-visible{border-radius:2px;outline:2px solid var(--focus-shadow);}"]));
});
exports.Anchor = Anchor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBbmNob3IiLCJmb3J3YXJkUmVmIiwicmVmIiwiY2hpbGRyZW4iLCJjbGFzc05hbWUiLCJocmVmIiwib25DbGljayIsInVuZGVybGluZSIsInByb3BzIiwiaXNFeHRlcm5hbEhyZWYiLCJtYXRjaCIsImlzSGFzaEhyZWYiLCJ0YXJnZXRQcm9wcyIsInJlbCIsInRhcmdldCIsImhhbmRsZUNsaWNrIiwiZXYiLCJwcmV2ZW50RGVmYXVsdCIsInRhcmdldEVsIiwiZG9jdW1lbnQiLCJnZXRFbGVtZW50QnlJZCIsInNsaWNlIiwic2Nyb2xsVG9FbGVtZW50IiwiY2xhc3NuYW1lcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FuY2hvci9BbmNob3IudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IHNjcm9sbFRvRWxlbWVudCB9IGZyb20gJy4uLy4uL2xpYi9kb20nO1xuXG5pbnRlcmZhY2UgUHJvcHMgZXh0ZW5kcyBSZWFjdC5BbmNob3JIVE1MQXR0cmlidXRlczxIVE1MQW5jaG9yRWxlbWVudD4ge1xuICB1bmRlcmxpbmU/OiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgQW5jaG9yID0gZm9yd2FyZFJlZjxIVE1MQW5jaG9yRWxlbWVudCwgUHJvcHM+KFxuICAoeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBocmVmLCBvbkNsaWNrLCB1bmRlcmxpbmUsIC4uLnByb3BzIH0sIHJlZikgPT4ge1xuICAgIGNvbnN0IGlzRXh0ZXJuYWxIcmVmID0gaHJlZiAmJiBocmVmLm1hdGNoKC9eKGh0dHBzPzopP1xcL1xcLy8pO1xuICAgIGNvbnN0IGlzSGFzaEhyZWYgPSBocmVmPy5tYXRjaCgvXiMvKTtcblxuICAgIGNvbnN0IHRhcmdldFByb3BzID0gaXNFeHRlcm5hbEhyZWZcbiAgICAgID8ge1xuICAgICAgICAgIHJlbDogJ25vb3BlbmVyJyxcbiAgICAgICAgICB0YXJnZXQ6ICdfYmxhbmsnLFxuICAgICAgICB9XG4gICAgICA6IHt9O1xuXG4gICAgY29uc3QgaGFuZGxlQ2xpY2sgPSAoZXY6IFJlYWN0Lk1vdXNlRXZlbnQ8SFRNTEFuY2hvckVsZW1lbnQ+KSA9PiB7XG4gICAgICBpZiAoaXNIYXNoSHJlZikge1xuICAgICAgICBldi5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgICBjb25zdCB0YXJnZXRFbCA9IGRvY3VtZW50LmdldEVsZW1lbnRCeUlkKGhyZWYuc2xpY2UoMSkpO1xuICAgICAgICBpZiAodGFyZ2V0RWwpIHtcbiAgICAgICAgICBzY3JvbGxUb0VsZW1lbnQodGFyZ2V0RWwpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICBvbkNsaWNrPy4oZXYpO1xuICAgIH07XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGFcbiAgICAgICAgcmVmPXtyZWZ9XG4gICAgICAgIGNsYXNzTmFtZT17Y2xhc3NuYW1lcyhjbGFzc05hbWUsIHsgdW5kZXJsaW5lIH0pfVxuICAgICAgICBocmVmPXtocmVmfVxuICAgICAgICBvbkNsaWNrPXtoYW5kbGVDbGlja31cbiAgICAgICAgey4uLnRhcmdldFByb3BzfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICA+XG4gICAgICAgIHtjaGlsZHJlbn1cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIGEge1xuICAgICAgICAgICAgY29sb3I6IGluaGVyaXQ7XG4gICAgICAgICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAgICAgICBmb250LWZhbWlseTogaW5oZXJpdDtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogaW5oZXJpdDtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiBpbmhlcml0O1xuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IGluaGVyaXQ7XG4gICAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgICAgICAgfVxuICAgICAgICAgIGEudW5kZXJsaW5lIHtcbiAgICAgICAgICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICAgICAgICAgIH1cbiAgICAgICAgICBhOmZvY3VzLXZpc2libGUge1xuICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogMnB4O1xuICAgICAgICAgICAgb3V0bGluZTogMnB4IHNvbGlkIHZhcigtLWZvY3VzLXNoYWRvdyk7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2E+XG4gICAgKTtcbiAgfVxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFQTs7Ozs7Ozs7QUFNTyxJQUFNQSxNQUFNLGdCQUFHLElBQUFDLGlCQUFBLEVBQ3BCLGdCQUE4REMsR0FBOUQsRUFBc0U7RUFBQSxJQUFuRUMsUUFBbUUsUUFBbkVBLFFBQW1FO0VBQUEsSUFBekRDLFNBQXlELFFBQXpEQSxTQUF5RDtFQUFBLElBQTlDQyxJQUE4QyxRQUE5Q0EsSUFBOEM7RUFBQSxJQUF4Q0MsT0FBd0MsUUFBeENBLE9BQXdDO0VBQUEsSUFBL0JDLFNBQStCLFFBQS9CQSxTQUErQjtFQUFBLElBQWpCQyxLQUFpQjtFQUNwRSxJQUFNQyxjQUFjLEdBQUdKLElBQUksSUFBSUEsSUFBSSxDQUFDSyxLQUFMLENBQVcsaUJBQVgsQ0FBL0I7RUFDQSxJQUFNQyxVQUFVLEdBQUdOLElBQUgsYUFBR0EsSUFBSCx1QkFBR0EsSUFBSSxDQUFFSyxLQUFOLENBQVksSUFBWixDQUFuQjtFQUVBLElBQU1FLFdBQVcsR0FBR0gsY0FBYyxHQUM5QjtJQUNFSSxHQUFHLEVBQUUsVUFEUDtJQUVFQyxNQUFNLEVBQUU7RUFGVixDQUQ4QixHQUs5QixFQUxKOztFQU9BLElBQU1DLFdBQVcsR0FBRyxTQUFkQSxXQUFjLENBQUNDLEVBQUQsRUFBNkM7SUFDL0QsSUFBSUwsVUFBSixFQUFnQjtNQUNkSyxFQUFFLENBQUNDLGNBQUg7TUFDQSxJQUFNQyxRQUFRLEdBQUdDLFFBQVEsQ0FBQ0MsY0FBVCxDQUF3QmYsSUFBSSxDQUFDZ0IsS0FBTCxDQUFXLENBQVgsQ0FBeEIsQ0FBakI7O01BQ0EsSUFBSUgsUUFBSixFQUFjO1FBQ1osSUFBQUksb0JBQUEsRUFBZ0JKLFFBQWhCO01BQ0Q7SUFDRjs7SUFDRFosT0FBTyxTQUFQLElBQUFBLE9BQU8sV0FBUCxZQUFBQSxPQUFPLENBQUdVLEVBQUgsQ0FBUDtFQUNELENBVEQ7O0VBV0Esb0JBQ0U7SUFDRSxHQUFHLEVBQUVkLEdBRFA7SUFHRSxJQUFJLEVBQUVHLElBSFI7SUFJRSxPQUFPLEVBQUVVO0VBSlgsR0FLTUgsV0FMTixFQU1NSixLQU5OO0lBQUEscUtBRWEsSUFBQWUsc0JBQUEsRUFBV25CLFNBQVgsRUFBc0I7TUFBRUcsU0FBUyxFQUFUQTtJQUFGLENBQXRCLENBRmI7RUFBQSxJQVFHSixRQVJIO0lBQUE7RUFBQSxrWUFERjtBQStCRCxDQXREbUIsQ0FBZiJ9

/***/ }),

/***/ 757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Anchor", ({
  enumerable: true,
  get: function get() {
    return _Anchor.Anchor;
  }
}));

var _Anchor = __webpack_require__(3368);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQW5jaG9yL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEFuY2hvciB9IGZyb20gJy4vQW5jaG9yJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 5909:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Badge = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _Anchor = __webpack_require__(757);

var _Text = __webpack_require__(5645);

var _excluded = ["children", "className", "href", "HrefComponent", "variant", "textProps"];

var Badge = function Badge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      HrefComponent = _ref.HrefComponent,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? {} : _ref$textProps,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      isDarkMode = _useTheme.isDarkMode;

  var classNames = (0, _classnames["default"])(className, variant);
  var textColor = isDarkMode && variant !== 'default' ? 'inverse' : 'default';
  var HrefC = HrefComponent !== null && HrefComponent !== void 0 ? HrefComponent : _Anchor.Anchor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, href ? /*#__PURE__*/_react["default"].createElement(HrefC, {
    href: href,
    className: "jsx-918747490"
  }, /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, props, {
    className: "jsx-918747490" + " " + (props && props.className != null && props.className || classNames || "")
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    color: textColor,
    variant: "xsmall"
  }, textProps), children))) : /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, props, {
    className: "jsx-918747490" + " " + (props && props.className != null && props.className || classNames || "")
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    color: textColor,
    variant: "xsmall"
  }, textProps), children)), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "918747490"
  }, ["span.jsx-918747490{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:0 4px;width:auto;}", "span.jsx-918747490 svg{margin-right:2px;}", ".default.jsx-918747490{background-color:var(--badge-default-bg);border:1px solid var(--badge-default-border);}", ".success.jsx-918747490{background-color:var(--badge-success-bg);border:1px solid var(--badge-success-border);}", ".warning.jsx-918747490{background-color:var(--badge-warning-bg);border:1px solid var(--badge-warning-border);}", ".error.jsx-918747490{background-color:var(--badge-error-bg);border:1px solid var(--badge-error-border);}", ".info.jsx-918747490{background-color:var(--badge-info-bg);border:1px solid var(--badge-info-border);}"]));
};

exports.Badge = Badge;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "C", ({
  enumerable: true,
  get: function get() {
    return _Badge.Badge;
  }
}));

var _Badge = __webpack_require__(5909);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFkZ2UvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgQmFkZ2UgfSBmcm9tICcuL0JhZGdlJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 1107:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CheckboxToggle = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _excluded = ["id", "checkedLabel", "checked", "defaultChecked", "disabled", "disabledLabel", "reverseOrder", "onChange", "uncheckedLabel"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CheckboxToggle = function CheckboxToggle(_ref) {
  var id = _ref.id,
      checkedLabel = _ref.checkedLabel,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disabledLabel = _ref.disabledLabel,
      disabledLabel = _ref$disabledLabel === void 0 ? null : _ref$disabledLabel,
      _ref$reverseOrder = _ref.reverseOrder,
      reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder,
      onChange = _ref.onChange,
      uncheckedLabel = _ref.uncheckedLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(checked || defaultChecked),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleChange = function handleChange(ev) {
    setIsChecked(ev.currentTarget.checked);
    onChange === null || onChange === void 0 ? void 0 : onChange(ev);
  };

  var label;

  if (disabled && disabledLabel) {
    label = disabledLabel;
  } else if (isChecked) {
    label = checkedLabel;
  } else {
    label = uncheckedLabel;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "jsx-2569485172"
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    type: "checkbox",
    checked: isChecked,
    disabled: disabled,
    id: id,
    onChange: handleChange
  }, props, {
    className: "jsx-2569485172" + " " + (props && props.className != null && props.className || (0, _classnames["default"])({
      reverseInput: reverseOrder
    }) || "")
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: "jsx-2569485172" + " " + ((0, _classnames["default"])({
      reverseLabel: reverseOrder
    }) || "")
  }, label), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2569485172"
  }, ["div.jsx-2569485172{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:24px;position:relative;}", "input.jsx-2569485172{opacity:0;position:absolute;}", ".reverseInput.jsx-2569485172{right:0;}", "label.jsx-2569485172{cursor:pointer;padding-left:48px;-webkit-tap-highlight-color:rgba(0,0,0,0);}", ".reverseLabel.jsx-2569485172{padding-left:0;padding-right:48px;}", "label.jsx-2569485172::before{background-color:var(--checkboxtoggle-bg);border:1px solid var(--checkboxtoggle-border);border-radius:50px;box-shadow:0 0 0 0 var(--focus-shadow);content:'';height:24px;left:0;position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:background 200ms ease,border 200ms ease, box-shadow 200ms ease;transition:background 200ms ease,border 200ms ease, box-shadow 200ms ease;width:40px;}", "label.jsx-2569485172::after{background-color:var(--checkboxtoggle-fill-bg);border-radius:100%;box-shadow:0px 2px 2px var(--checkboxtoggle-fill-shadow), 0px 0px 4px var(--checkboxtoggle-fill-shadow);content:'';height:16px;left:4px;position:absolute;top:50%;-webkit-transition:-webkit-transform 200ms ease;-webkit-transition:transform 200ms ease;transition:transform 200ms ease;-webkit-transform:translate(0,-50%);-ms-transform:translate(0,-50%);transform:translate(0,-50%);width:16px;}", ".reverseLabel.jsx-2569485172::before{left:auto;right:0;}", ".reverseLabel.jsx-2569485172::after{left:auto;right:20px;}", "input.jsx-2569485172:not([disabled])+label.jsx-2569485172:hover.jsx-2569485172::before{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);}", "input.jsx-2569485172:checked.jsx-2569485172:not([disabled])+label.jsx-2569485172:hover.jsx-2569485172::before{border-color:var(--checkboxtoggle-checked-border);}", "input.jsx-2569485172:checked+label.jsx-2569485172::before{background-color:var(--checkboxtoggle-checked-bg);border-color:var(--checkboxtoggle-checked-border);}", "input.jsx-2569485172:checked+label.jsx-2569485172::after{-webkit-transform:translate(16px,-50%);-ms-transform:translate(16px,-50%);transform:translate(16px,-50%);}", "div.jsx-2569485172:focus-within label.jsx-2569485172::before{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);}", "div.jsx-2569485172:focus-within input.jsx-2569485172:checked+label.jsx-2569485172::before{border-color:var(--checkboxtoggle-checked-border);}", "input[disabled].jsx-2569485172+label.jsx-2569485172{color:var(--text-muted);cursor:default;}", "input[disabled].jsx-2569485172+label.jsx-2569485172::before,input[disabled].jsx-2569485172+label.jsx-2569485172::after{opacity:0.6;}"]));
};

exports.CheckboxToggle = CheckboxToggle;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8175:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "p", ({
  enumerable: true,
  get: function get() {
    return _CheckboxToggle.CheckboxToggle;
  }
}));

var _CheckboxToggle = __webpack_require__(1107);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2hlY2tib3hUb2dnbGUvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgQ2hlY2tib3hUb2dnbGUgfSBmcm9tICcuL0NoZWNrYm94VG9nZ2xlJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 9127:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DD = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Text = __webpack_require__(5645);

var _excluded = ["children", "className", "variant"];

var DD = function DD(_ref) {
  var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    El: "dd",
    variant: variant || 'mono'
  }, props, {
    className: (0, _classnames["default"])(className, {
      largestrong: variant === 'largestrong'
    })
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1180450048"
  }, ["dd.largestrong{grid-column-start:1;grid-column-end:-1;padding-bottom:12px;}"]));
};

exports.DD = DD;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERCIsImNoaWxkcmVuIiwiY2xhc3NOYW1lIiwidmFyaWFudCIsInByb3BzIiwiY2xhc3NuYW1lcyIsImxhcmdlc3Ryb25nIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGF0YUxpc3QvREQudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgVGV4dCB9IGZyb20gJy4uL1RleHQnO1xuXG5leHBvcnQgY29uc3QgREQgPSAoe1xuICBjaGlsZHJlbixcbiAgY2xhc3NOYW1lLFxuICB2YXJpYW50LFxuICAuLi5wcm9wc1xufTogUmVhY3QuQ29tcG9uZW50UHJvcHM8dHlwZW9mIFRleHQ+KSA9PiAoXG4gIDxUZXh0XG4gICAgRWw9XCJkZFwiXG4gICAgdmFyaWFudD17dmFyaWFudCB8fCAnbW9ubyd9XG4gICAgey4uLnByb3BzfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NuYW1lcyhjbGFzc05hbWUsIHtcbiAgICAgIGxhcmdlc3Ryb25nOiB2YXJpYW50ID09PSAnbGFyZ2VzdHJvbmcnLFxuICAgIH0pfVxuICA+XG4gICAge2NoaWxkcmVufVxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIDpnbG9iYWwoZGQubGFyZ2VzdHJvbmcpIHtcbiAgICAgICAgZ3JpZC1jb2x1bW4tc3RhcnQ6IDE7XG4gICAgICAgIGdyaWQtY29sdW1uLWVuZDogLTE7XG4gICAgICAgIHBhZGRpbmctYm90dG9tOiAxMnB4O1xuICAgICAgfVxuICAgIGB9PC9zdHlsZT5cbiAgPC9UZXh0PlxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7Ozs7QUFFTyxJQUFNQSxFQUFFLEdBQUcsU0FBTEEsRUFBSztFQUFBLElBQ2hCQyxRQURnQixRQUNoQkEsUUFEZ0I7RUFBQSxJQUVoQkMsU0FGZ0IsUUFFaEJBLFNBRmdCO0VBQUEsSUFHaEJDLE9BSGdCLFFBR2hCQSxPQUhnQjtFQUFBLElBSWJDLEtBSmE7RUFBQSxvQkFNaEIsZ0NBQUMsVUFBRDtJQUNFLEVBQUUsRUFBQyxJQURMO0lBRUUsT0FBTyxFQUFFRCxPQUFPLElBQUk7RUFGdEIsR0FHTUMsS0FITjtJQUlFLFNBQVMsRUFBRSxJQUFBQyxzQkFBQSxFQUFXSCxTQUFYLEVBQXNCO01BQy9CSSxXQUFXLEVBQUVILE9BQU8sS0FBSztJQURNLENBQXRCO0VBSmIsSUFRR0YsUUFSSDtJQUFBO0VBQUEsb0ZBTmdCO0FBQUEsQ0FBWCJ9

/***/ }),

/***/ 4079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DT = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Text = __webpack_require__(5645);

var DT = function DT(props) {
  return /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    El: "dt",
    color: "muted",
    truncate: true
  }, props));
};

exports.DT = DT;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEVCIsInByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGF0YUxpc3QvRFQudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi9UZXh0JztcblxuZXhwb3J0IGNvbnN0IERUID0gKHByb3BzOiBSZWFjdC5Db21wb25lbnRQcm9wczx0eXBlb2YgVGV4dD4pID0+IChcbiAgPFRleHQgRWw9XCJkdFwiIGNvbG9yPVwibXV0ZWRcIiB0cnVuY2F0ZSB7Li4ucHJvcHN9IC8+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLEVBQUUsR0FBRyxTQUFMQSxFQUFLLENBQUNDLEtBQUQ7RUFBQSxvQkFDaEIsZ0NBQUMsVUFBRDtJQUFNLEVBQUUsRUFBQyxJQUFUO0lBQWMsS0FBSyxFQUFDLE9BQXBCO0lBQTRCLFFBQVE7RUFBcEMsR0FBeUNBLEtBQXpDLEVBRGdCO0FBQUEsQ0FBWCJ9

/***/ }),

/***/ 7051:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DataList = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var DataList = function DataList(_ref) {
  var children = _ref.children;

  var _useTheme = (0, _Theme.useTheme)(),
      mediaQueries = _useTheme.mediaQueries;

  return /*#__PURE__*/_react["default"].createElement("dl", {
    className: _style["default"].dynamic([["471814538", [mediaQueries.medium, mediaQueries.large, mediaQueries.xlarge]]])
  }, children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "471814538",
    dynamic: [mediaQueries.medium, mediaQueries.large, mediaQueries.xlarge]
  }, ["dl.__jsx-style-dynamic-selector{display:grid;gap:4px 8px;grid-template-columns:1fr;grid-template-rows:1fr;grid-template-areas:'.';margin:0;}", "dl.__jsx-style-dynamic-selector dd{margin:0;overflow:hidden;}", "@media ".concat(mediaQueries.medium, "{dl.__jsx-style-dynamic-selector{grid-template-columns:180px 1fr;grid-template-areas:'. .';}}"), "@media ".concat(mediaQueries.large, "{dl.__jsx-style-dynamic-selector{grid-template-columns:1fr;grid-template-areas:'.';}}"), "@media ".concat(mediaQueries.xlarge, "{dl.__jsx-style-dynamic-selector{grid-template-columns:180px 1fr;grid-template-areas:'. .';}}")]));
};

exports.DataList = DataList;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "DD", ({
  enumerable: true,
  get: function get() {
    return _DD.DD;
  }
}));
Object.defineProperty(exports, "DT", ({
  enumerable: true,
  get: function get() {
    return _DT.DT;
  }
}));
Object.defineProperty(exports, "F", ({
  enumerable: true,
  get: function get() {
    return _DataList.DataList;
  }
}));

var _DataList = __webpack_require__(7051);

var _DD = __webpack_require__(9127);

var _DT = __webpack_require__(4079);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGF0YUxpc3QvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgRGF0YUxpc3QgfSBmcm9tICcuL0RhdGFMaXN0JztcbmV4cG9ydCB7IEREIH0gZnJvbSAnLi9ERCc7XG5leHBvcnQgeyBEVCB9IGZyb20gJy4vRFQnO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQSJ9

/***/ }),

/***/ 3810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.FocusTrap = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _dom = __webpack_require__(6912);

var _excluded = ["active", "arrowKeys", "children", "restoreFocus", "searchByCharacter"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FocusTrap = function FocusTrap(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? true : _ref$active,
      _ref$arrowKeys = _ref.arrowKeys,
      arrowKeys = _ref$arrowKeys === void 0 ? 'none' : _ref$arrowKeys,
      children = _ref.children,
      _ref$restoreFocus = _ref.restoreFocus,
      restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus,
      _ref$searchByCharacte = _ref.searchByCharacter,
      searchByCharacter = _ref$searchByCharacte === void 0 ? false : _ref$searchByCharacte,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var previousFocusRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _els$;

    if (!active || !ref.current) return;

    var handleKeyDown = function handleKeyDown(ev) {
      var _els;

      var els = (0, _dom.getFocusableElements)(ref.current);
      var currentIndex = els.findIndex(function (el) {
        return el === document.activeElement;
      });
      var nextIndex = (currentIndex + 1) % els.length;
      var prevIndex = currentIndex === 0 ? els.length - 1 : currentIndex - 1;

      switch (ev.key) {
        case 'ArrowDown':
          if (!['updown', 'all'].includes(arrowKeys)) return;
          ev.preventDefault();
          els[nextIndex].focus();
          break;

        case 'ArrowLeft':
          if (!['leftright', 'all'].includes(arrowKeys)) return;
          els[prevIndex].focus();
          break;

        case 'ArrowRight':
          if (!['leftright', 'all'].includes(arrowKeys)) return;
          els[nextIndex].focus();
          break;

        case 'ArrowUp':
          if (!['updown', 'all'].includes(arrowKeys)) return;
          ev.preventDefault();
          els[prevIndex].focus();
          break;

        case 'End':
        case 'PageDown':
          if (arrowKeys === 'none') return;
          ev.preventDefault();
          els[els.length - 1].focus();
          break;

        case 'Home':
        case 'PageUp':
          if (arrowKeys === 'none') return;
          ev.preventDefault();
          els[0].focus();
          break;

        case 'Tab':
          // Keeps focus inside container.
          ev.preventDefault();
          els === null || els === void 0 ? void 0 : (_els = els[ev.shiftKey ? prevIndex : nextIndex]) === null || _els === void 0 ? void 0 : _els.focus();
          break;
      }

      var elStartsWithKey = function elStartsWithKey(el) {
        return el.textContent.toLowerCase().startsWith(ev.key);
      };

      if (searchByCharacter && ev.which >= 65 && ev.which <= 90 && els.some(elStartsWithKey)) {
        // a-z, with shift A-Z
        var first = els.findIndex(elStartsWithKey);
        var next = els.findIndex(function (el, i) {
          return el.textContent.toLowerCase().startsWith(ev.key) && i > currentIndex;
        });
        els[next >= 0 ? next : first].focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    previousFocusRef.current = document.activeElement;
    var focusTrapContainer = ref.current;
    var els = (0, _dom.getFocusableElements)(focusTrapContainer);
    els === null || els === void 0 ? void 0 : (_els$ = els[0]) === null || _els$ === void 0 ? void 0 : _els$.focus();
    /* Clean-up and focus restoration */

    return function () {
      if (!active) return;
      document.removeEventListener('keydown', handleKeyDown);
      /* Only restore focus when the HTMLElement that is FocusTrapped is inside the activeElement;
       * or when the activeElement is the document body.
       */

      var focusIsInContainer = document.activeElement.contains(focusTrapContainer);
      var focusIsInBody = document.activeElement === document.body;
      if (restoreFocus && (focusIsInContainer || focusIsInBody)) previousFocusRef.current.focus();
    };
  }, [active, arrowKeys, restoreFocus, searchByCharacter]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, props), children);
};

exports.FocusTrap = FocusTrap;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "FocusTrap", ({
  enumerable: true,
  get: function get() {
    return _FocusTrap.FocusTrap;
  }
}));

var _FocusTrap = __webpack_require__(3810);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9jdXNUcmFwL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEZvY3VzVHJhcCB9IGZyb20gJy4vRm9jdXNUcmFwJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 2013:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.E = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var AddEmojiIcon = function AddEmojiIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 2.35889C4.88422 2.35889 2.35865 4.88447 2.35865 7.99992C2.35865 11.1154 4.88422 13.6409 7.99967 13.6409C11.1151 13.6409 13.6407 11.1154 13.6407 7.99992C13.6407 7.7167 13.8703 7.4871 14.1535 7.4871C14.4367 7.4871 14.6663 7.7167 14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C8.2829 1.33325 8.5125 1.56285 8.5125 1.84607C8.5125 2.1293 8.2829 2.35889 7.99967 2.35889Z",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "6",
    cy: "6.33325",
    r: "1",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "6.33325",
    r: "1",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79703 9.14683L5.79674 9.14611L5.79633 9.1451L5.79877 9.15073C5.80175 9.1575 5.80726 9.16969 5.81545 9.18655C5.83186 9.22033 5.85878 9.27235 5.8973 9.33655C5.97477 9.46566 6.09647 9.6396 6.27003 9.81316C6.61094 10.1541 7.15589 10.5001 7.99981 10.5001C8.84372 10.5001 9.38867 10.1541 9.72959 9.81316C9.90315 9.6396 10.0248 9.46566 10.1023 9.33655C10.1408 9.27235 10.1678 9.22033 10.1842 9.18655C10.1924 9.16969 10.1979 9.1575 10.2008 9.15073L10.2034 9.14492C10.3069 8.8904 10.5967 8.76696 10.8522 8.86915C11.1086 8.9717 11.2333 9.26269 11.1307 9.51908L10.6665 9.33338C11.1307 9.51908 11.1308 9.51883 11.1307 9.51908L11.1298 9.52127L11.1287 9.52408L11.1256 9.53153C11.1232 9.53729 11.12 9.54464 11.1162 9.55347C11.1084 9.57112 11.0976 9.59473 11.0837 9.62345C11.0558 9.68081 11.015 9.759 10.9598 9.85105C10.8498 10.0344 10.6798 10.2772 10.4367 10.5203C9.94428 11.0127 9.15589 11.5001 7.99981 11.5001C6.84372 11.5001 6.05534 11.0127 5.56292 10.5203C5.31982 10.2772 5.14985 10.0344 5.03981 9.85105C4.98458 9.759 4.9438 9.68081 4.91594 9.62345C4.90199 9.59473 4.89122 9.57112 4.88346 9.55347C4.87957 9.54464 4.87643 9.53729 4.87402 9.53153L4.87093 9.52408L4.86978 9.52127L4.86931 9.5201C4.86921 9.51985 4.8689 9.51908 5.33314 9.33338L4.8689 9.51908C4.76635 9.26269 4.89105 8.9717 5.14745 8.86915C5.40291 8.76696 5.69279 8.89059 5.79633 9.1451",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.867 0.533333C13.867 0.238781 13.6282 0 13.3337 0C13.0391 0 12.8003 0.238781 12.8003 0.533333V2.13333H11.2003C10.9058 2.13333 10.667 2.37211 10.667 2.66667C10.667 2.96122 10.9058 3.2 11.2003 3.2H12.8003V4.8C12.8003 5.09455 13.0391 5.33333 13.3337 5.33333C13.6282 5.33333 13.867 5.09455 13.867 4.8V3.2H15.467C15.7615 3.2 16.0003 2.96122 16.0003 2.66667C16.0003 2.37211 15.7615 2.13333 15.467 2.13333H13.867V0.533333Z",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.E = AddEmojiIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 4182:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.j = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var AppsIcon = function AppsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 4H14.5V10H20.5V4ZM8 20C9.933 20 11.5 18.433 11.5 16.5C11.5 14.567 9.933 13 8 13C6.067 13 4.5 14.567 4.5 16.5C4.5 18.433 6.067 20 8 20ZM8 4L11.5 10H4.5L8 4ZM20.5311 14.75L17.5 13L14.4689 14.75V18.25L17.5 20L20.5311 18.25V14.75Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.j = AppsIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBcHBzSWNvbiIsImNvbG9yIiwic2l6ZSIsInByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSWNvbnMvQXBwc0ljb24udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LlNWR0F0dHJpYnV0ZXM8U1ZHRWxlbWVudD4ge1xuICBjb2xvcj86IHN0cmluZztcbiAgc2l6ZT86IG51bWJlcjtcbn1cblxuZXhwb3J0IGNvbnN0IEFwcHNJY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY29sb3IgPSAnY3VycmVudENvbG9yJyxcbiAgc2l6ZSA9IDI0LFxuICAuLi5wcm9wc1xufSkgPT4gKFxuICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiB2aWV3Qm94PVwiMCAwIDI1IDI0XCIgey4uLnByb3BzfT5cbiAgICA8cGF0aFxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGNsaXBSdWxlPVwiZXZlbm9kZFwiXG4gICAgICBkPVwiTTIwLjUgNEgxNC41VjEwSDIwLjVWNFpNOCAyMEM5LjkzMyAyMCAxMS41IDE4LjQzMyAxMS41IDE2LjVDMTEuNSAxNC41NjcgOS45MzMgMTMgOCAxM0M2LjA2NyAxMyA0LjUgMTQuNTY3IDQuNSAxNi41QzQuNSAxOC40MzMgNi4wNjcgMjAgOCAyMFpNOCA0TDExLjUgMTBINC41TDggNFpNMjAuNTMxMSAxNC43NUwxNy41IDEzTDE0LjQ2ODkgMTQuNzVWMTguMjVMMTcuNSAyMEwyMC41MzExIDE4LjI1VjE0Ljc1WlwiXG4gICAgLz5cbiAgICA8c3R5bGUganN4PntgXG4gICAgICBzdmcge1xuICAgICAgICBmaWxsOiAke2NvbG9yfTtcbiAgICAgICAgaGVpZ2h0OiAke3NpemV9cHg7XG4gICAgICAgIHdpZHRoOiAke3NpemV9cHg7XG4gICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgfVxuICAgIGB9PC9zdHlsZT5cbiAgPC9zdmc+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7OztBQU9PLElBQU1BLFFBQWtELEdBQUcsU0FBckRBLFFBQXFEO0VBQUEsc0JBQ2hFQyxLQURnRTtFQUFBLElBQ2hFQSxLQURnRSwyQkFDeEQsY0FEd0Q7RUFBQSxxQkFFaEVDLElBRmdFO0VBQUEsSUFFaEVBLElBRmdFLDBCQUV6RCxFQUZ5RDtFQUFBLElBRzdEQyxLQUg2RDtFQUFBLG9CQUtoRTtJQUFLLEtBQUssRUFBQyw0QkFBWDtJQUF3QyxPQUFPLEVBQUM7RUFBaEQsR0FBZ0VBLEtBQWhFO0lBQUEsc0RBUWNGLEtBUmQsRUFTZ0JDLElBVGhCLEVBVWVBLElBVmY7RUFBQSxpQkFDRTtJQUNFLFFBQVEsRUFBQyxTQURYO0lBRUUsUUFBUSxFQUFDLFNBRlg7SUFHRSxDQUFDLEVBQUMsME9BSEo7SUFBQSxzREFPWUQsS0FQWixFQVFjQyxJQVJkLEVBU2FBLElBVGI7RUFBQSxFQURGO0lBQUE7SUFBQSxVQVFjRCxLQVJkLEVBU2dCQyxJQVRoQixFQVVlQSxJQVZmO0VBQUEsb0RBUWNELEtBUmQscUJBU2dCQyxJQVRoQixzQkFVZUEsSUFWZiwwQkFMZ0U7QUFBQSxDQUEzRCJ9

/***/ }),

/***/ 218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.r = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var ArchiveIcon = function ArchiveIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7C5 5.89543 5.89543 5 7 5H17C18.1046 5 19 5.89543 19 7V9C19 9.74708 18.5904 10.3985 17.9835 10.7419C17.9944 10.8264 18 10.9125 18 11V17C18 18.1046 17.1046 19 16 19H8C6.89543 19 6 18.1046 6 17V11C6 10.9125 6.00561 10.8264 6.0165 10.7419C5.40961 10.3985 5 9.74707 5 9V7ZM8 11H16V17H8V11ZM7 9V7H17V9H7Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.r = ArchiveIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3870:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.L = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size", "variant"];

var ArrowRightIcon = function ArrowRightIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'thin' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 8H12M12 8L9 5M12 8L9 11",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.L = ArrowRightIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBcnJvd1JpZ2h0SWNvbiIsImNvbG9yIiwic2l6ZSIsInZhcmlhbnQiLCJwcm9wcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25zL0Fycm93UmlnaHRJY29uLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbnRlcmZhY2UgUHJvcHMgZXh0ZW5kcyBSZWFjdC5TVkdBdHRyaWJ1dGVzPFNWR0VsZW1lbnQ+IHtcbiAgY29sb3I/OiBzdHJpbmc7XG4gIHNpemU/OiBudW1iZXI7XG4gIHZhcmlhbnQ/OiAndGhpbicgfCAndGhpY2snO1xufVxuXG5leHBvcnQgY29uc3QgQXJyb3dSaWdodEljb246IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBjb2xvciA9ICdjdXJyZW50Q29sb3InLFxuICBzaXplID0gMjQsXG4gIHZhcmlhbnQgPSAndGhpbicsXG4gIC4uLnByb3BzXG59KSA9PiAoXG4gIDxzdmcgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiIHZpZXdCb3g9XCIwIDAgMTYgMTZcIiB7Li4ucHJvcHN9PlxuICAgIDxwYXRoXG4gICAgICBkPVwiTTQgOEgxMk0xMiA4TDkgNU0xMiA4TDkgMTFcIlxuICAgICAgc3Ryb2tlPXtjb2xvcn1cbiAgICAgIHN0cm9rZUxpbmVjYXA9XCJyb3VuZFwiXG4gICAgICBzdHJva2VMaW5lam9pbj1cInJvdW5kXCJcbiAgICAgIHN0cm9rZVdpZHRoPXt2YXJpYW50ID09PSAndGhpY2snID8gMiA6IDF9XG4gICAgLz5cbiAgICA8c3R5bGUganN4PntgXG4gICAgICBzdmcge1xuICAgICAgICBoZWlnaHQ6ICR7c2l6ZX1weDtcbiAgICAgICAgd2lkdGg6ICR7c2l6ZX1weDtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L3N2Zz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBUU8sSUFBTUEsY0FBd0QsR0FBRyxTQUEzREEsY0FBMkQ7RUFBQSxzQkFDdEVDLEtBRHNFO0VBQUEsSUFDdEVBLEtBRHNFLDJCQUM5RCxjQUQ4RDtFQUFBLHFCQUV0RUMsSUFGc0U7RUFBQSxJQUV0RUEsSUFGc0UsMEJBRS9ELEVBRitEO0VBQUEsd0JBR3RFQyxPQUhzRTtFQUFBLElBR3RFQSxPQUhzRSw2QkFHNUQsTUFINEQ7RUFBQSxJQUluRUMsS0FKbUU7RUFBQSxvQkFNdEU7SUFBSyxLQUFLLEVBQUMsNEJBQVg7SUFBd0MsT0FBTyxFQUFDO0VBQWhELEdBQWdFQSxLQUFoRTtJQUFBLHNEQVVnQkYsSUFWaEIsRUFXZUEsSUFYZjtFQUFBLGlCQUNFO0lBQ0UsQ0FBQyxFQUFDLDRCQURKO0lBRUUsTUFBTSxFQUFFRCxLQUZWO0lBR0UsYUFBYSxFQUFDLE9BSGhCO0lBSUUsY0FBYyxFQUFDLE9BSmpCO0lBS0UsV0FBVyxFQUFFRSxPQUFPLEtBQUssT0FBWixHQUFzQixDQUF0QixHQUEwQixDQUx6QztJQUFBLHNEQVNjRCxJQVRkLEVBVWFBLElBVmI7RUFBQSxFQURGO0lBQUE7SUFBQSxVQVVnQkEsSUFWaEIsRUFXZUEsSUFYZjtFQUFBLHNEQVVnQkEsSUFWaEIsc0JBV2VBLElBWGYsMEJBTnNFO0FBQUEsQ0FBakUifQ==

/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.f = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var AudioIcon = function AudioIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.5C3 9.67157 3.67157 9 4.5 9H5.96456L11.0501 4.83907C11.4987 4.47205 12.1186 4.3963 12.6423 4.6445C13.1661 4.89269 13.5 5.42042 13.5 6V18C13.5 18.5796 13.1661 19.1073 12.6423 19.3555C12.1186 19.6037 11.4987 19.528 11.0501 19.1609L5.96455 15H4.5C3.67157 15 3 14.3284 3 13.5V10.5ZM15.55 7.4C15.8814 7.15147 16.3515 7.21863 16.6 7.55L16 8C16.6 7.55 16.6003 7.5503 16.6005 7.55061L16.601 7.55131L16.6023 7.553L16.6056 7.55749L16.6154 7.5709C16.6233 7.58179 16.6339 7.59658 16.647 7.61514C16.673 7.65224 16.7087 7.70451 16.7519 7.77094C16.8382 7.90369 16.9547 8.09379 17.083 8.33333C17.3388 8.81074 17.6466 9.49402 17.8527 10.3181C18.2682 11.9802 18.2672 14.2271 16.6 16.45C16.3515 16.7814 15.8814 16.8485 15.55 16.6C15.2187 16.3515 15.1515 15.8814 15.4 15.55C16.7328 13.7729 16.7319 12.0198 16.3974 10.6819C16.2285 10.006 15.9738 9.43925 15.7608 9.04166C15.6548 8.84371 15.5603 8.69006 15.4943 8.58843C15.4613 8.53768 15.4355 8.5001 15.419 8.47666C15.4108 8.46494 15.405 8.45678 15.4017 8.45229L15.3997 8.44948L15.3993 8.44905L15.3989 8.44846L15.3988 8.44838C15.1517 8.1171 15.2192 7.64812 15.55 7.4ZM19.1049 5.55648C18.8599 5.22246 18.3906 5.15025 18.0565 5.3952C17.7228 5.6399 17.6504 6.10855 17.8945 6.44251L17.8946 6.44265L17.8946 6.44267L17.8947 6.44282L17.8949 6.44303L17.8951 6.44332L17.8952 6.44353L17.901 6.45161C17.9069 6.45995 17.9167 6.47384 17.9299 6.49313C17.9564 6.53171 17.9967 6.59176 18.0475 6.67183C18.1494 6.83209 18.2934 7.07177 18.4544 7.37926C18.7774 7.99584 19.1643 8.87586 19.4215 9.92809C19.9329 12.0203 19.9328 14.778 17.8952 17.5565C17.6503 17.8905 17.7225 18.3599 18.0565 18.6048C18.3906 18.8498 18.8599 18.7776 19.1049 18.4435C21.4673 15.222 21.4672 11.9797 20.8786 9.57191C20.5858 8.37415 20.1477 7.37917 19.7832 6.68325C19.6005 6.33449 19.4351 6.05854 19.3135 5.86724C19.2527 5.77153 19.2027 5.69682 19.1668 5.64458C19.1489 5.61845 19.1345 5.59793 19.1241 5.58319L19.1114 5.56543L19.1073 5.55985L19.1059 5.55789L19.1053 5.55712C19.1051 5.55679 19.1049 5.55648 18.5001 6L19.1049 5.55648Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.f = AudioIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.y = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var BreakoutIcon = function BreakoutIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9.5V6.5H9.5V9.5H4.5ZM3 6C3 5.44772 3.44772 5 4 5H10C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V6ZM4 13C3.44772 13 3 13.4477 3 14V18C3 18.5523 3.44772 19 4 19H10C10.5523 19 11 18.5523 11 18V14C11 13.4477 10.5523 13 10 13H4ZM14.5 6.5V9.5H19.5V6.5H14.5ZM14 5C13.4477 5 13 5.44772 13 6V10C13 10.5523 13.4477 11 14 11H20C20.5523 11 21 10.5523 21 10V6C21 5.44772 20.5523 5 20 5H14ZM14.5 17.5V14.5H19.5V17.5H14.5ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V18C21 18.5523 20.5523 19 20 19H14C13.4477 19 13 18.5523 13 18V14Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.y = BreakoutIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.H = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "id", "muted", "transition", "size"];

var CamIcon = function CamIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      id = _ref.id,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? true : _ref$transition,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "camIconMask".concat(id),
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    fill: "white",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.87715 19L18.8772 3",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted,
      transition: transition
    }) || "")
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: muted ? "url(#camIconMask".concat(id, ")") : undefined,
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5Z",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 20L20 4",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted,
      transition: transition
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1108613548",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}"), ".strike.__jsx-style-dynamic-selector{-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);}", ".strike.transition.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform 240ms ease;-webkit-transition:transform 240ms ease;transition:transform 240ms ease;}", ".strike.muted.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}"]));
};

exports.H = CamIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3513:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CaretLeftIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size", "variant"];

var CaretLeftIcon = function CaretLeftIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'thick' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "9",
    y1: "5",
    x2: "6",
    y2: "8",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "6",
    y1: "8",
    x2: "9",
    y2: "11",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.CaretLeftIcon = CaretLeftIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CaretRightIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size", "variant"];

var CaretRightIcon = function CaretRightIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'thick' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "7",
    y1: "5",
    x2: "10",
    y2: "8",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "10",
    y1: "8",
    x2: "7",
    y2: "11",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.CaretRightIcon = CaretRightIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.y = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size", "variant"];

var CaretUpIcon = function CaretUpIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'thick' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "5",
    y1: "9",
    x2: "8",
    y2: "6",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "8",
    y1: "6",
    x2: "11",
    y2: "9",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.y = CaretUpIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1814:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.k = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var ChatIcon = function ChatIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.k = ChatIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDaGF0SWNvbiIsImNvbG9yIiwic2l6ZSIsInByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSWNvbnMvQ2hhdEljb24udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LlNWR0F0dHJpYnV0ZXM8U1ZHRWxlbWVudD4ge1xuICBjb2xvcj86IHN0cmluZztcbiAgc2l6ZT86IG51bWJlcjtcbn1cblxuZXhwb3J0IGNvbnN0IENoYXRJY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY29sb3IgPSAnY3VycmVudENvbG9yJyxcbiAgc2l6ZSA9IDI0LFxuICAuLi5wcm9wc1xufSkgPT4gKFxuICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfT5cbiAgICA8cGF0aFxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGNsaXBSdWxlPVwiZXZlbm9kZFwiXG4gICAgICBkPVwiTTEyIDE4QzE2LjQxODMgMTggMjAgMTQuODY2IDIwIDExQzIwIDcuMTM0MDEgMTYuNDE4MyA0IDEyIDRDNy41ODE3MiA0IDQgNy4xMzQwMSA0IDExQzQgMTIuNDM1OCA0LjQ5NDA0IDEzLjc3MDcgNS4zNDE1IDE0Ljg4MTVDNS40NzYxMyAxNS4xNTQ2IDUuNzUzNTcgMTYuMDI4NyA1IDE3LjczNjRDNC42MzAyNCAxOC40OTQxIDQuNDY3MTEgMTkgNSAxOUM2LjEyMDY4IDE5IDYuNjQ4OTMgMTguNjM1MyA3LjE5Nzg4IDE4LjI1NjNDNy42NTYwMiAxNy45Mzk5IDguMTI4NTggMTcuNjEzNyA4Ljk3MTk3IDE3LjQ4MTJDOS45MDU5OSAxNy44MTU2IDEwLjkyODQgMTggMTIgMThaXCJcbiAgICAvPlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIHN2ZyB7XG4gICAgICAgIGZpbGw6ICR7Y29sb3J9O1xuICAgICAgICBoZWlnaHQ6ICR7c2l6ZX1weDtcbiAgICAgICAgd2lkdGg6ICR7c2l6ZX1weDtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L3N2Zz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBT08sSUFBTUEsUUFBa0QsR0FBRyxTQUFyREEsUUFBcUQ7RUFBQSxzQkFDaEVDLEtBRGdFO0VBQUEsSUFDaEVBLEtBRGdFLDJCQUN4RCxjQUR3RDtFQUFBLHFCQUVoRUMsSUFGZ0U7RUFBQSxJQUVoRUEsSUFGZ0UsMEJBRXpELEVBRnlEO0VBQUEsSUFHN0RDLEtBSDZEO0VBQUEsb0JBS2hFO0lBQUssS0FBSyxFQUFDLDRCQUFYO0lBQXdDLE9BQU8sRUFBQztFQUFoRCxHQUFnRUEsS0FBaEU7SUFBQSxzREFRY0YsS0FSZCxFQVNnQkMsSUFUaEIsRUFVZUEsSUFWZjtFQUFBLGlCQUNFO0lBQ0UsUUFBUSxFQUFDLFNBRFg7SUFFRSxRQUFRLEVBQUMsU0FGWDtJQUdFLENBQUMsRUFBQyxzVUFISjtJQUFBLHNEQU9ZRCxLQVBaLEVBUWNDLElBUmQsRUFTYUEsSUFUYjtFQUFBLEVBREY7SUFBQTtJQUFBLFVBUWNELEtBUmQsRUFTZ0JDLElBVGhCLEVBVWVBLElBVmY7RUFBQSxvREFRY0QsS0FSZCxxQkFTZ0JDLElBVGhCLHNCQVVlQSxJQVZmLDBCQUxnRTtBQUFBLENBQTNEIn0=

/***/ }),

/***/ 7880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CloseIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "rotate", "size", "variant"];

var CloseIcon = function CloseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? 0 : _ref$rotate,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("g", {
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "6.41",
    y1: "6.41",
    x2: "17.59",
    y2: "17.59",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1.5,
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "17.59",
    y1: "6.41",
    x2: "6.41",
    y2: "17.59",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1.5,
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1296944475",
    dynamic: [color, size, size, rotate]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}"), "g.__jsx-style-dynamic-selector{-webkit-transform:rotate(".concat(rotate, "deg);-ms-transform:rotate(").concat(rotate, "deg);transform:rotate(").concat(rotate, "deg);-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;}")]));
};

exports.CloseIcon = CloseIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.d = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var EffectsIcon = function EffectsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4",
    fill: color,
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 3L12 6",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 18L12 21",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 12L6 12",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 12L21 12",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.34314 6.34314L7.75735 7.75735",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.2427 16.2426L17.6569 17.6569",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.6569 6.34314L16.2426 7.75735",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.75732 16.2426L6.34311 17.6569",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.d = EffectsIcon;

/*#__PURE__*/
_react["default"].createElement("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.w = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var EllipsisIcon = function EllipsisIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 7.99984C5.33334 7.26346 4.73638 6.6665 4.00001 6.6665C3.26363 6.6665 2.66667 7.26346 2.66667 7.99984C2.66667 8.73622 3.26363 9.33317 4.00001 9.33317C4.73638 9.33317 5.33334 8.73622 5.33334 7.99984ZM9.33333 7.99992C9.33333 7.26354 8.73638 6.66659 8 6.66659C7.26362 6.66659 6.66667 7.26354 6.66667 7.99992C6.66667 8.7363 7.26362 9.33325 8 9.33325C8.73638 9.33325 9.33333 8.7363 9.33333 7.99992ZM12 6.66659C12.7364 6.66659 13.3333 7.26354 13.3333 7.99992C13.3333 8.7363 12.7364 9.33325 12 9.33325C11.2636 9.33325 10.6667 8.7363 10.6667 7.99992C10.6667 7.26354 11.2636 6.66659 12 6.66659Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.w = EllipsisIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.S = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var EmojiIcon = function EmojiIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25Z",
    fill: "none",
    stroke: color,
    strokeWidth: "1.5",
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "9",
    cy: "9.5",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "15",
    cy: "9.5",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 14C8 14 9 16.5 12 16.5C15 16.5 16 14 16 14",
    fill: "none",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.S = EmojiIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2681:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.H = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var EmojiReactionsIcon = function EmojiReactionsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43215 4.65422C2.69213 6.23617 2.1683 9.97193 4.36758 12.2465L8.43344 16.4515L8.42497 16.4811L11.6609 20.0001L13.8235 17.7635C13.3201 17.3416 13 16.7082 13 16C13 14.7297 14.0297 13.7 15.3 13.7H16.2V12.8C16.2 11.5297 17.2297 10.5 18.5 10.5C19.0754 10.5 19.6015 10.7113 20.0049 11.0606C21.1335 8.83446 20.396 5.98382 18.0933 4.65435C15.8841 3.37884 13.1826 4.05114 11.7628 5.95392C10.343 4.05104 7.64144 3.37868 5.43215 4.65422ZM18.5 12C18.9418 12 19.3 12.3582 19.3 12.8V15.2H21.7C22.1418 15.2 22.5 15.5582 22.5 16C22.5 16.4418 22.1418 16.8 21.7 16.8H19.3V19.2C19.3 19.6418 18.9418 20 18.5 20C18.0582 20 17.7 19.6418 17.7 19.2V16.8H15.3C14.8582 16.8 14.5 16.4418 14.5 16C14.5 15.5582 14.8582 15.2 15.3 15.2H17.7V12.8C17.7 12.3582 18.0582 12 18.5 12Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.H = EmojiReactionsIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.i = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var ExitIcon = function ExitIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 4.5H14C15.3807 4.5 16.5 5.61929 16.5 7V10H15V7C15 6.44772 14.5523 6 14 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H14C14.5523 18 15 17.5523 15 17V14H16.5V17C16.5 18.3807 15.3807 19.5 14 19.5H7C5.61929 19.5 4.5 18.3807 4.5 17V7C4.5 5.61929 5.61929 4.5 7 4.5Z",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.0303 8.46967C18.7374 8.17678 18.2626 8.17678 17.9697 8.46967C17.6768 8.76256 17.6768 9.23744 17.9697 9.53033L19.6893 11.25H12.75C12.3358 11.25 12 11.5858 12 12C12 12.4142 12.3358 12.75 12.75 12.75H19.6893L17.9697 14.4697C17.6768 14.7626 17.6768 15.2374 17.9697 15.5303C18.2626 15.8232 18.7374 15.8232 19.0303 15.5303L22.0303 12.5303C22.3232 12.2374 22.3232 11.7626 22.0303 11.4697L19.0303 8.46967Z",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.i = ExitIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.h = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var GaugeIcon = function GaugeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.864 16.1422C13.6924 17.3137 11.793 17.3137 10.6214 16.1422C9.44981 14.9706 9.44981 13.0711 10.6214 11.8995C11.793 10.7279 22.6422 4.12134 22.6422 4.12134C22.6422 4.12134 21.2642 6.38431 19.6552 8.95481C20.6598 10.3761 21.25 12.1103 21.25 13.9824C21.25 16.0617 20.5209 17.9729 19.3047 19.4724C19.0438 19.7941 18.5715 19.8434 18.2498 19.5825C17.9281 19.3216 17.8788 18.8493 18.1397 18.5276C19.1472 17.2853 19.75 15.705 19.75 13.9824C19.75 12.661 19.3947 11.4222 18.7741 10.356C17.1022 13.0008 15.4046 15.6016 14.864 16.1422ZM12.5 5.25002C13.7098 5.25002 14.8624 5.49511 15.9106 5.93831C15.3676 6.28008 14.8189 6.62746 14.2821 6.97009C13.712 6.82637 13.115 6.75002 12.5 6.75002C8.49437 6.75002 5.25 9.98961 5.25 13.9824C5.25 15.705 5.85277 17.2853 6.86029 18.5276C7.1212 18.8493 7.07191 19.3216 6.75019 19.5825C6.42848 19.8434 5.95617 19.7941 5.69526 19.4724C4.47914 17.9729 3.75 16.0617 3.75 13.9824C3.75 9.15806 7.66907 5.25002 12.5 5.25002Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.h = GaugeIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJHYXVnZUljb24iLCJjb2xvciIsInNpemUiLCJwcm9wcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25zL0dhdWdlSWNvbi50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW50ZXJmYWNlIFByb3BzIGV4dGVuZHMgUmVhY3QuU1ZHQXR0cmlidXRlczxTVkdFbGVtZW50PiB7XG4gIGNvbG9yPzogc3RyaW5nO1xuICBzaXplPzogbnVtYmVyO1xufVxuXG5leHBvcnQgY29uc3QgR2F1Z2VJY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY29sb3IgPSAnY3VycmVudENvbG9yJyxcbiAgc2l6ZSA9IDI0LFxuICAuLi5wcm9wc1xufSkgPT4gKFxuICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfT5cbiAgICA8cGF0aFxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGNsaXBSdWxlPVwiZXZlbm9kZFwiXG4gICAgICBkPVwiTTE0Ljg2NCAxNi4xNDIyQzEzLjY5MjQgMTcuMzEzNyAxMS43OTMgMTcuMzEzNyAxMC42MjE0IDE2LjE0MjJDOS40NDk4MSAxNC45NzA2IDkuNDQ5ODEgMTMuMDcxMSAxMC42MjE0IDExLjg5OTVDMTEuNzkzIDEwLjcyNzkgMjIuNjQyMiA0LjEyMTM0IDIyLjY0MjIgNC4xMjEzNEMyMi42NDIyIDQuMTIxMzQgMjEuMjY0MiA2LjM4NDMxIDE5LjY1NTIgOC45NTQ4MUMyMC42NTk4IDEwLjM3NjEgMjEuMjUgMTIuMTEwMyAyMS4yNSAxMy45ODI0QzIxLjI1IDE2LjA2MTcgMjAuNTIwOSAxNy45NzI5IDE5LjMwNDcgMTkuNDcyNEMxOS4wNDM4IDE5Ljc5NDEgMTguNTcxNSAxOS44NDM0IDE4LjI0OTggMTkuNTgyNUMxNy45MjgxIDE5LjMyMTYgMTcuODc4OCAxOC44NDkzIDE4LjEzOTcgMTguNTI3NkMxOS4xNDcyIDE3LjI4NTMgMTkuNzUgMTUuNzA1IDE5Ljc1IDEzLjk4MjRDMTkuNzUgMTIuNjYxIDE5LjM5NDcgMTEuNDIyMiAxOC43NzQxIDEwLjM1NkMxNy4xMDIyIDEzLjAwMDggMTUuNDA0NiAxNS42MDE2IDE0Ljg2NCAxNi4xNDIyWk0xMi41IDUuMjUwMDJDMTMuNzA5OCA1LjI1MDAyIDE0Ljg2MjQgNS40OTUxMSAxNS45MTA2IDUuOTM4MzFDMTUuMzY3NiA2LjI4MDA4IDE0LjgxODkgNi42Mjc0NiAxNC4yODIxIDYuOTcwMDlDMTMuNzEyIDYuODI2MzcgMTMuMTE1IDYuNzUwMDIgMTIuNSA2Ljc1MDAyQzguNDk0MzcgNi43NTAwMiA1LjI1IDkuOTg5NjEgNS4yNSAxMy45ODI0QzUuMjUgMTUuNzA1IDUuODUyNzcgMTcuMjg1MyA2Ljg2MDI5IDE4LjUyNzZDNy4xMjEyIDE4Ljg0OTMgNy4wNzE5MSAxOS4zMjE2IDYuNzUwMTkgMTkuNTgyNUM2LjQyODQ4IDE5Ljg0MzQgNS45NTYxNyAxOS43OTQxIDUuNjk1MjYgMTkuNDcyNEM0LjQ3OTE0IDE3Ljk3MjkgMy43NSAxNi4wNjE3IDMuNzUgMTMuOTgyNEMzLjc1IDkuMTU4MDYgNy42NjkwNyA1LjI1MDAyIDEyLjUgNS4yNTAwMlpcIlxuICAgIC8+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgc3ZnIHtcbiAgICAgICAgZmlsbDogJHtjb2xvcn07XG4gICAgICAgIGhlaWdodDogJHtzaXplfXB4O1xuICAgICAgICB3aWR0aDogJHtzaXplfXB4O1xuICAgICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvc3ZnPlxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFPTyxJQUFNQSxTQUFtRCxHQUFHLFNBQXREQSxTQUFzRDtFQUFBLHNCQUNqRUMsS0FEaUU7RUFBQSxJQUNqRUEsS0FEaUUsMkJBQ3pELGNBRHlEO0VBQUEscUJBRWpFQyxJQUZpRTtFQUFBLElBRWpFQSxJQUZpRSwwQkFFMUQsRUFGMEQ7RUFBQSxJQUc5REMsS0FIOEQ7RUFBQSxvQkFLakU7SUFBSyxLQUFLLEVBQUMsNEJBQVg7SUFBd0MsT0FBTyxFQUFDO0VBQWhELEdBQWdFQSxLQUFoRTtJQUFBLHNEQVFjRixLQVJkLEVBU2dCQyxJQVRoQixFQVVlQSxJQVZmO0VBQUEsaUJBQ0U7SUFDRSxRQUFRLEVBQUMsU0FEWDtJQUVFLFFBQVEsRUFBQyxTQUZYO0lBR0UsQ0FBQyxFQUFDLGs3QkFISjtJQUFBLHNEQU9ZRCxLQVBaLEVBUWNDLElBUmQsRUFTYUEsSUFUYjtFQUFBLEVBREY7SUFBQTtJQUFBLFVBUWNELEtBUmQsRUFTZ0JDLElBVGhCLEVBVWVBLElBVmY7RUFBQSxvREFRY0QsS0FSZCxxQkFTZ0JDLElBVGhCLHNCQVVlQSxJQVZmLDBCQUxpRTtBQUFBLENBQTVEIn0=

/***/ }),

/***/ 7877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.U = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _excluded = ["fill", "stroke", "size"];

var GearIcon = function GearIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'var(--nav-icon-fill)' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'var(--nav-icon-stroke)' : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors;

  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2022363242", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.5C7 1.22386 7.22386 1 7.5 1H8.5C8.77614 1 9 1.22386 9 1.5V3.10002C9.63839 3.2296 10.2326 3.48082 10.7574 3.82842L11.8891 2.69671C12.0844 2.50145 12.401 2.50145 12.5962 2.69671L13.3034 3.40382C13.4986 3.59908 13.4986 3.91566 13.3034 4.11093L12.1716 5.24265C12.5192 5.76744 12.7704 6.36164 12.9 7H14.5C14.7761 7 15 7.22386 15 7.5V8.5C15 8.77614 14.7761 9 14.5 9H12.9C12.7704 9.63838 12.5192 10.2326 12.1716 10.7574L13.3033 11.8891C13.4986 12.0844 13.4986 12.401 13.3033 12.5962L12.5962 13.3033C12.4009 13.4986 12.0844 13.4986 11.8891 13.3033L10.7574 12.1716C10.2326 12.5192 9.63837 12.7704 9 12.9V14.5C9 14.7761 8.77614 15 8.5 15H7.5C7.22386 15 7 14.7761 7 14.5V12.9C6.36163 12.7704 5.76743 12.5192 5.24263 12.1716L4.11094 13.3033C3.91568 13.4986 3.59909 13.4986 3.40383 13.3033L2.69673 12.5962C2.50146 12.4009 2.50146 12.0844 2.69673 11.8891L3.82841 10.7574C3.48081 10.2326 3.2296 9.63838 3.10002 9H1.5C1.22386 9 1 8.77614 1 8.5V7.5C1 7.22386 1.22386 7 1.5 7H3.10002C3.2296 6.36164 3.4808 5.76744 3.82837 5.24265L2.69668 4.11095C2.50142 3.91569 2.50142 3.59911 2.69668 3.40385L3.40379 2.69674C3.59905 2.50148 3.91563 2.50148 4.1109 2.69674L5.24257 3.82842C5.76739 3.48082 6.36161 3.2296 7 3.10002V1.5ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z",
    fill: fill !== null && fill !== void 0 ? fill : colors.system.grey,
    className: _style["default"].dynamic([["2022363242", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 3.10002H8.5V3.50872L8.90053 3.59002L9 3.10002ZM10.7574 3.82842L10.4813 4.24528L10.822 4.47093L11.111 4.18198L10.7574 3.82842ZM11.8891 2.69671L12.2427 3.05027L12.2427 3.05027L11.8891 2.69671ZM12.5962 2.69671L12.2427 3.05027V3.05027L12.5962 2.69671ZM13.3034 3.40382L13.6569 3.05027V3.05027L13.3034 3.40382ZM13.3034 4.11093L13.6569 4.46448V4.46448L13.3034 4.11093ZM12.1716 5.24265L11.8181 4.88909L11.5291 5.17805L11.7548 5.51874L12.1716 5.24265ZM12.9 7L12.41 7.09947L12.4913 7.5H12.9V7ZM12.9 9V8.5H12.4913L12.41 8.90053L12.9 9ZM12.1716 10.7574L11.7547 10.4813L11.5291 10.822L11.818 11.111L12.1716 10.7574ZM11.8891 13.3033L11.5355 13.6569V13.6569L11.8891 13.3033ZM10.7574 12.1716L11.1109 11.8181L10.822 11.5291L10.4813 11.7548L10.7574 12.1716ZM9 12.9L8.90053 12.41L8.5 12.4913V12.9H9ZM7 12.9H7.5V12.4913L7.09947 12.41L7 12.9ZM5.24263 12.1716L5.51872 11.7548L5.17803 11.5291L4.88908 11.8181L5.24263 12.1716ZM4.11094 13.3033L3.75739 12.9498L3.75738 12.9498L4.11094 13.3033ZM3.40383 13.3033L3.75739 12.9498L3.75739 12.9498L3.40383 13.3033ZM2.69673 12.5962L3.05028 12.2426H3.05028L2.69673 12.5962ZM2.69673 11.8891L3.05028 12.2426H3.05028L2.69673 11.8891ZM3.82841 10.7574L4.18196 11.111L4.47092 10.822L4.24527 10.4813L3.82841 10.7574ZM3.10002 9L3.59002 8.90053L3.50872 8.5H3.10002V9ZM3.10002 7V7.5H3.50872L3.59002 7.09947L3.10002 7ZM3.82837 5.24265L4.24523 5.51874L4.47088 5.17804L4.18193 4.88909L3.82837 5.24265ZM2.69668 3.40385L2.34313 3.05029H2.34313L2.69668 3.40385ZM3.40379 2.69674L3.05024 2.34319L3.05023 2.34319L3.40379 2.69674ZM4.1109 2.69674L4.46445 2.34319V2.34319L4.1109 2.69674ZM5.24257 3.82842L4.88902 4.18197L5.17798 4.47093L5.51867 4.24528L5.24257 3.82842ZM7 3.10002L7.09947 3.59002L7.5 3.50872V3.10002H7ZM7.5 0.5C6.94771 0.5 6.5 0.947716 6.5 1.5H7.5V1.5V0.5ZM8.5 0.5H7.5V1.5H8.5V0.5ZM9.5 1.5C9.5 0.947715 9.05229 0.5 8.5 0.5V1.5H9.5ZM9.5 3.10002V1.5H8.5V3.10002H9.5ZM11.0335 3.41156C10.4563 3.02923 9.80226 2.75267 9.09947 2.61001L8.90053 3.59002C9.47452 3.70654 10.009 3.93241 10.4813 4.24528L11.0335 3.41156ZM11.5356 2.34316L10.4039 3.47487L11.111 4.18198L12.2427 3.05027L11.5356 2.34316ZM12.9498 2.34316C12.5593 1.95263 11.9261 1.95263 11.5356 2.34316L12.2427 3.05027H12.2427L12.9498 2.34316ZM13.6569 3.05027L12.9498 2.34316L12.2427 3.05027L12.9498 3.75737L13.6569 3.05027ZM13.6569 4.46448C14.0474 4.07395 14.0474 3.44079 13.6569 3.05027L12.9498 3.75737V3.75737L13.6569 4.46448ZM12.5252 5.5962L13.6569 4.46448L12.9498 3.75737L11.8181 4.88909L12.5252 5.5962ZM13.39 6.90053C13.2473 6.19777 12.9708 5.5438 12.5885 4.96656L11.7548 5.51874C12.0676 5.99109 12.2935 6.52551 12.41 7.09947L13.39 6.90053ZM14.5 6.5H12.9V7.5H14.5V6.5ZM15.5 7.5C15.5 6.94771 15.0523 6.5 14.5 6.5V7.5H15.5ZM15.5 8.5V7.5H14.5V8.5H15.5ZM14.5 9.5C15.0523 9.5 15.5 9.05228 15.5 8.5H14.5V9.5ZM12.9 9.5H14.5V8.5H12.9V9.5ZM12.5885 11.0335C12.9708 10.4563 13.2473 9.80225 13.39 9.09947L12.41 8.90053C12.2935 9.47451 12.0676 10.0089 11.7547 10.4813L12.5885 11.0335ZM11.818 11.111L12.9498 12.2427L13.6569 11.5356L12.5251 10.4039L11.818 11.111ZM12.9498 12.2427L13.6569 12.9498C14.0474 12.5593 14.0474 11.9261 13.6569 11.5356L12.9498 12.2427ZM12.9498 12.2427L12.2426 12.9498L12.9498 13.6569L13.6569 12.9498L12.9498 12.2427ZM12.2426 12.9498H12.2426L11.5355 13.6569C11.9261 14.0474 12.5592 14.0474 12.9498 13.6569L12.2426 12.9498ZM12.2426 12.9498L11.1109 11.8181L10.4038 12.5252L11.5355 13.6569L12.2426 12.9498ZM9.09947 13.39C9.80224 13.2473 10.4562 12.9708 11.0335 12.5885L10.4813 11.7548C10.0089 12.0676 9.4745 12.2935 8.90053 12.41L9.09947 13.39ZM9.5 14.5V12.9H8.5V14.5H9.5ZM8.5 15.5C9.05229 15.5 9.5 15.0523 9.5 14.5H8.5V15.5ZM7.5 15.5H8.5V14.5H7.5V15.5ZM6.5 14.5C6.5 15.0523 6.94771 15.5 7.5 15.5V14.5H6.5ZM6.5 12.9V14.5H7.5V12.9H6.5ZM4.96654 12.5885C5.54378 12.9708 6.19776 13.2473 6.90053 13.39L7.09947 12.41C6.5255 12.2935 5.99108 12.0676 5.51872 11.7548L4.96654 12.5885ZM4.88908 11.8181L3.75739 12.9498L4.46449 13.6569L5.59618 12.5252L4.88908 11.8181ZM3.75738 12.9498H3.75739L3.05028 13.6569C3.4408 14.0474 4.07397 14.0474 4.46449 13.6569L3.75738 12.9498ZM3.75739 12.9498L3.05028 12.2426L2.34317 12.9498L3.05028 13.6569L3.75739 12.9498ZM3.05028 12.2426V12.2426L2.34317 11.5355C1.95265 11.9261 1.95265 12.5592 2.34317 12.9498L3.05028 12.2426ZM3.05028 12.2426L4.18196 11.111L3.47486 10.4039L2.34317 11.5355L3.05028 12.2426ZM2.61001 9.09947C2.75267 9.80226 3.02922 10.4563 3.41155 11.0335L4.24527 10.4813C3.93241 10.0089 3.70654 9.47451 3.59002 8.90053L2.61001 9.09947ZM3.10002 8.5H1.5V9.5H3.10002V8.5ZM1.5 8.5H1.5H0.5C0.5 9.05229 0.947716 9.5 1.5 9.5V8.5ZM1.5 8.5V7.5H0.5V8.5H1.5ZM1.5 7.5V6.5C0.947715 6.5 0.5 6.94771 0.5 7.5H1.5ZM1.5 7.5H3.10002V6.5H1.5V7.5ZM3.41151 4.96655C3.0292 5.54379 2.75266 6.19777 2.61001 6.90053L3.59002 7.09947C3.70653 6.52551 3.93239 5.99109 4.24523 5.51874L3.41151 4.96655ZM2.34313 4.46451L3.47482 5.5962L4.18193 4.88909L3.05024 3.7574L2.34313 4.46451ZM2.34313 3.05029C1.9526 3.44082 1.9526 4.07398 2.34313 4.46451L3.05024 3.7574V3.7574L2.34313 3.05029ZM3.05023 2.34319L2.34313 3.05029L3.05024 3.7574L3.75734 3.05029L3.05023 2.34319ZM4.46445 2.34319C4.07392 1.95266 3.44076 1.95266 3.05024 2.34319L3.75734 3.05029H3.75734L4.46445 2.34319ZM5.59613 3.47487L4.46445 2.34319L3.75734 3.05029L4.88902 4.18197L5.59613 3.47487ZM6.90053 2.61001C6.19774 2.75267 5.54373 3.02923 4.96648 3.41156L5.51867 4.24528C5.99104 3.93241 6.52548 3.70654 7.09947 3.59002L6.90053 2.61001ZM6.5 1.5V3.10002H7.5V1.5H6.5ZM8 10.5C9.38071 10.5 10.5 9.38071 10.5 8H9.5C9.5 8.82843 8.82843 9.5 8 9.5V10.5ZM5.5 8C5.5 9.38071 6.61929 10.5 8 10.5V9.5C7.17157 9.5 6.5 8.82843 6.5 8H5.5ZM8 5.5C6.61929 5.5 5.5 6.61929 5.5 8H6.5C6.5 7.17157 7.17157 6.5 8 6.5V5.5ZM10.5 8C10.5 6.61929 9.38071 5.5 8 5.5V6.5C8.82843 6.5 9.5 7.17157 9.5 8H10.5Z",
    fill: stroke !== null && stroke !== void 0 ? stroke : colors.system.greyDark,
    className: _style["default"].dynamic([["2022363242", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2022363242",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.U = GearIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.q = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var GridViewIcon = function GridViewIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["3569927790", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 8.5C6 7.94772 6.44772 7.5 7 7.5H17C17.5523 7.5 18 7.94772 18 8.5V15.5C18 16.0523 17.5523 16.5 17 16.5H7C6.44772 16.5 6 16.0523 6 15.5V8.5Z",
    stroke: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 16V14H6.5V13H9.5V11H6.5V10H9.5V8H10.5V10H13.5V8H14.5V10H17.5V11H14.5V13H17.5V14H14.5V16H13.5V14H10.5V16H9.5ZM13.5 13V11H10.5V13H13.5Z",
    fill: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3569927790",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:transparent;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.q = GridViewIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.b = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var HelpIcon = function HelpIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38337 9.01386H8.45479V8.81397C8.50277 8.39019 8.91055 8.06237 9.29434 7.69456C9.63816 7.35874 9.94999 6.99094 9.94999 6.43923C9.94999 5.59168 9.35031 5 8.17494 5C7.03955 5 6.24797 5.65565 6.2 6.76706H7.3114C7.36737 6.26333 7.66322 5.9435 8.10298 5.9435C8.52675 5.9435 8.71865 6.16738 8.71865 6.53518C8.71865 6.85501 8.46279 7.11087 8.17494 7.39072C7.79914 7.75853 7.38337 8.15032 7.38337 8.77399V9.01386ZM7.95409 11C8.36393 11 8.7 10.6705 8.7 10.2543C8.7 9.82948 8.36393 9.5 7.95409 9.5C7.53606 9.5 7.2 9.82948 7.2 10.2543C7.2 10.6705 7.53606 11 7.95409 11Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.b = HelpIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports._ = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var HiddenIcon = function HiddenIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6869 3.02006C13.8821 2.8248 13.8821 2.50821 13.6869 2.31295C13.4916 2.11769 13.175 2.11769 12.9798 2.31295L2.31311 12.9796C2.11785 13.1749 2.11785 13.4915 2.31311 13.6867C2.50838 13.882 2.82496 13.882 3.02022 13.6867L5.334 11.3729C6.13555 11.7511 7.04014 11.9998 8 11.9998C11.3333 11.9998 14 8.99984 14 7.99984C14 7.40271 13.0492 6.09244 11.5733 5.13363L13.6869 3.02006ZM9.72309 6.98385L6.98402 9.72293C7.28177 9.89887 7.6291 9.99984 8 9.99984C9.10457 9.99984 10 9.10441 10 7.99984C10 7.62893 9.89904 7.28161 9.72309 6.98385Z",
    fill: color,
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 3.99984C8.55851 3.99984 9.09831 4.08406 9.60998 4.22898L7.83218 6.00678C6.86147 6.08742 6.08758 6.86131 6.00694 7.83202L3.59367 10.2453C2.60289 9.40297 2 8.47532 2 7.99984C2 6.99984 4.66667 3.99984 8 3.99984Z",
    fill: color,
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports._ = HiddenIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.t = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var HomeIcon = function HomeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.9999 6.35675L13.05 7.07868C13.2775 7.23512 13.5888 7.17747 13.7452 6.94992C13.9017 6.72237 13.844 6.41108 13.6165 6.25464L8.47199 2.7178C8.18761 2.52229 7.81215 2.52229 7.52778 2.7178L2.38329 6.25464C2.15573 6.41108 2.09809 6.72237 2.25453 6.94992C2.41097 7.17747 2.72226 7.23512 2.94981 7.07868L3.99988 6.35676V12.3333C3.99988 12.7015 4.29835 13 4.66654 13H11.3332C11.7014 13 11.9999 12.7015 11.9999 12.3333V6.35675Z",
    fill: color,
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.t = HomeIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3232:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.s = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var InfoIcon = function InfoIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2234010024", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5Z",
    stroke: color,
    className: _style["default"].dynamic([["2234010024", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00368 5.99984C8.36798 5.99984 8.66671 5.70697 8.66671 5.33702C8.66671 4.95937 8.36798 4.6665 8.00368 4.6665C7.6321 4.6665 7.33337 4.95937 7.33337 5.33702C7.33337 5.70697 7.6321 5.99984 8.00368 5.99984Z",
    fill: color,
    className: _style["default"].dynamic([["2234010024", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 7.3335V10.6668",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2234010024", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2234010024",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:none;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.s = InfoIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6498:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.B = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var LandscapeIcon = function LandscapeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.976 9.15507L8.93629 17.7832C8.35636 18.6116 8.94905 19.75 9.96033 19.75H22.0397C23.051 19.75 23.6436 18.6116 23.0637 17.7832L17.024 9.15507C16.5264 8.44417 15.4736 8.44417 14.976 9.15507Z",
    fill: "white",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.03972 12.9808L3.10724 17.6998C2.42878 18.5139 3.00772 19.75 4.06752 19.75H11.9325C12.9923 19.75 13.5712 18.5139 12.8928 17.6998L8.96028 12.9808C8.46053 12.3811 7.53947 12.3811 7.03972 12.9808L7.61589 13.4609L7.03972 12.9808Z",
    fill: "white",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "6",
    r: "2.25",
    fill: "white",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.B = LandscapeIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2805:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LockIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var LockIcon = function LockIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4",
    y: "7",
    width: "8",
    height: "6",
    rx: "1.33333",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C6.34315 3 5 4.34315 5 6V10H11V6C11 4.34315 9.65685 3 8 3ZM8 4C6.89543 4 6 4.89543 6 6V8H10V6C10 4.89543 9.10457 4 8 4Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.LockIcon = LockIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.P = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var LowerHandIcon = function LowerHandIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2447 18.7473C16.3739 19.6165 15.2114 20.1166 14.0232 20.1339C11.9527 20.1638 8.69576 20.2109 7.17774 20.2319C7.10243 20.2319 7.02803 20.231 6.95458 20.2275C6.29246 20.2022 5.79605 19.6699 5.8132 19.0054C5.83034 18.341 6.35676 17.766 7.02077 17.6875C7.09638 17.6788 7.17025 17.6701 7.24484 17.6658C8.04373 17.6163 9.24478 17.5509 10.0695 17.5057C10.2247 17.4977 10.3658 17.3967 10.429 17.2499C10.4921 17.1032 10.4649 16.9397 10.3578 16.8326C8.63744 15.114 4.34197 10.8203 3.05736 9.53574C3.02224 9.50061 2.98723 9.46202 2.95229 9.42169C2.54841 8.99091 2.58667 8.29195 3.03581 7.84782C3.48579 7.40454 4.18438 7.37668 4.61062 7.78677C4.65429 7.82506 4.6945 7.86348 4.73381 7.90278C5.75413 8.92311 8.20059 11.3642 9.17582 12.3376C9.25527 12.4171 9.36629 12.4599 9.48242 12.4559C9.59854 12.4518 9.71283 12.4011 9.79803 12.3159C9.97471 12.1392 9.9835 11.8628 9.81874 11.698C8.69799 10.5791 5.37601 7.2589 4.28782 6.1743C4.27946 6.16593 4.2711 6.15757 4.26279 6.14747C3.84158 5.71729 3.86556 5.00585 4.31358 4.54445C4.76249 4.08216 5.47466 4.03739 5.91925 4.44251C5.9426 4.46766 5.96614 4.48761 5.98789 4.50936C7.14329 5.6522 10.3855 8.9016 11.4969 10.0148C11.5772 10.0951 11.6874 10.1371 11.8044 10.1339C11.9214 10.129 12.0348 10.0791 12.1201 9.9922L12.1218 9.99041C12.2977 9.81289 12.3056 9.53737 12.1408 9.37262C11.1674 8.39739 8.70696 5.93516 7.70862 4.92965C7.69272 4.91376 7.67767 4.8987 7.66268 4.88191C7.24577 4.45245 7.2713 3.74615 7.72003 3.28905C8.16786 2.83286 8.87465 2.79346 9.31225 3.20056C9.36333 3.24985 9.41536 3.2965 9.46303 3.34417C10.5319 4.413 12.8618 6.74477 13.8094 7.69233C13.9733 7.85625 14.248 7.84753 14.4255 7.67342C14.5107 7.58821 14.5613 7.47566 14.5662 7.36037C14.5703 7.24425 14.5282 7.13406 14.4497 7.05371C13.7414 6.34187 12.5909 5.18414 11.9385 4.53353C10.7507 3.35114 12.4051 1.70511 13.5902 2.89019C14.5888 3.88877 17.8764 7.1764 20.5626 9.86444C21.312 10.6138 21.7067 11.6542 21.6589 12.7508C21.6093 13.8474 21.1222 14.9083 20.3045 15.6942C20.3045 15.6942 18.5441 17.4513 17.2447 18.7473Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.P = LowerHandIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.d = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var MetricsIcon = function MetricsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    "data-testid": "MetricsIcon",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 11L6 6L10 10L14 5",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "6",
    cy: "6",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "10",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "14",
    cy: "5",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2",
    cy: "11",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.d = MetricsIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.S = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "id", "muted", "size"],
    _excluded2 = ["color", "id", "muted", "size"],
    _excluded3 = ["transition"];

var MicrophoneIconWithTransition = function MicrophoneIconWithTransition(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      id = _ref.id,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("defs", {
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "micIconMask".concat(id),
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    fill: "white",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.88 19L18.88 3",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted
    }) || "")
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    mask: muted ? "url(#micIconMask".concat(id, ")") : undefined,
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3Z",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 20L20 4",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3470324109",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}"), ".strike.__jsx-style-dynamic-selector{-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform 240ms ease;-webkit-transition:transform 240ms ease;transition:transform 240ms ease;}", ".strike.muted.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}"]));
};

var MicrophoneIconStatic = function MicrophoneIconStatic(_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'currentColor' : _ref2$color,
      id = _ref2.id,
      _ref2$muted = _ref2.muted,
      muted = _ref2$muted === void 0 ? false : _ref2$muted,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 24 : _ref2$size,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);

  if (muted) {
    return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, props, {
      className: _style["default"].dynamic([["2085849465", [size, size]]]) + " " + (props && props.className != null && props.className || "")
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.99996 2C9.06523 2 9.93598 2.83285 9.99659 3.88293L5.99996 7.87956V4C5.99996 2.89543 6.89539 2 7.99996 2Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99996 6.70711L13.6868 3.02022C13.8821 2.82496 13.8821 2.50838 13.6868 2.31311C13.4916 2.11785 13.175 2.11785 12.9797 2.31311L2.31307 12.9798C2.11781 13.175 2.11781 13.4916 2.31307 13.6869C2.50833 13.8821 2.82492 13.8821 3.02018 13.6869L5.46367 11.2434C6.03955 11.667 6.74051 11.9055 7.49996 11.9769V13.5C7.49996 13.7761 7.72382 14 7.99996 14C8.2761 14 8.49996 13.7761 8.49996 13.5V11.9769C9.3992 11.8924 10.2164 11.5736 10.8411 10.9905C11.5856 10.2957 12 9.27833 12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2238 7.5 11 7.72386 11 8C11 9.05501 10.6643 9.78763 10.1588 10.2595C9.64751 10.7367 8.90551 11 7.99996 11C7.27926 11 6.66216 10.8332 6.18251 10.5246L6.98398 9.72309C7.28173 9.89904 7.62905 10 7.99996 10C9.10453 10 9.99996 9.10457 9.99996 8V6.70711Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.07402 8.8055C5.02583 8.56097 4.99996 8.29291 4.99996 8C4.99996 7.72386 4.7761 7.5 4.49996 7.5C4.22382 7.5 3.99996 7.72386 3.99996 8C3.99996 8.59793 4.09062 9.13877 4.26331 9.61621L5.07402 8.8055Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
      id: "2085849465",
      dynamic: [size, size]
    }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2022363242", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C6.89543 2 6 2.89543 6 4V8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8V4C10 2.89543 9.10457 2 8 2ZM5 8C5 7.72386 4.77614 7.5 4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 9.27833 4.41438 10.2957 5.15884 10.9905C5.78352 11.5736 6.60076 11.8924 7.5 11.9769V13.5C7.5 13.7761 7.72386 14 8 14C8.27614 14 8.5 13.7761 8.5 13.5V11.9769C9.39924 11.8924 10.2165 11.5736 10.8412 10.9905C11.5856 10.2957 12 9.27833 12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2239 7.5 11 7.72386 11 8C11 9.05501 10.6644 9.78763 10.1588 10.2595C9.64755 10.7367 8.90556 11 8 11C7.09444 11 6.35245 10.7367 5.84116 10.2595C5.33562 9.78763 5 9.05501 5 8Z",
    fill: color,
    className: _style["default"].dynamic([["2022363242", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2022363242",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

var MicrophoneIcon = function MicrophoneIcon(props) {
  if ('transition' in props) {
    var transition = props.transition,
        rest = (0, _objectWithoutProperties2["default"])(props, _excluded3);
    return /*#__PURE__*/_react["default"].createElement(MicrophoneIconWithTransition, rest);
  }

  return /*#__PURE__*/_react["default"].createElement(MicrophoneIconStatic, props);
};

exports.S = MicrophoneIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.n = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var NoiseCancellationIcon = function NoiseCancellationIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["509484923", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.33339 6.66667C5.33339 5.86333 5.47979 5.11252 5.87057 4.56977C6.24677 4.04727 6.88662 3.66667 8.00006 3.66667C9.1135 3.66667 9.75335 4.04727 10.1295 4.56977C10.5203 5.11252 10.6667 5.86333 10.6667 6.66667H10.6439C10.2883 6.66667 10.0001 6.95494 10.0001 7.31054V10.6895C10.0001 11.0451 10.2883 11.3333 10.6439 11.3333H10.9488C11.7197 11.3333 12.377 10.7746 12.5012 10.0138C12.6108 9.34239 12.6108 8.65761 12.5012 7.98618C12.3983 7.35588 11.9295 6.8643 11.3334 6.71419V6.66667C11.3334 5.80333 11.1798 4.88748 10.6706 4.18023C10.1468 3.45273 9.28662 3 8.00006 3C6.7135 3 5.85335 3.45273 5.32955 4.18023C4.82033 4.88748 4.66673 5.80333 4.66673 6.66667V6.71419C4.0706 6.8643 3.60182 7.35588 3.49892 7.98618C3.38929 8.65761 3.38929 9.34239 3.49892 10.0138C3.62313 10.7746 4.28043 11.3333 5.05133 11.3333H5.35618C5.71179 11.3333 6.00006 11.0451 6.00006 10.6895V7.31054C6.00006 6.95494 5.71179 6.66667 5.35618 6.66667H5.33339ZM3.66673 5.83333C3.66673 6.10948 3.44287 6.33333 3.16673 6.33333C2.89059 6.33333 2.66673 6.10948 2.66673 5.83333C2.66673 5.55719 2.89059 5.33333 3.16673 5.33333C3.44287 5.33333 3.66673 5.55719 3.66673 5.83333ZM3.16673 12.3333C3.44287 12.3333 3.66673 12.1095 3.66673 11.8333C3.66673 11.5572 3.44287 11.3333 3.16673 11.3333C2.89059 11.3333 2.66673 11.5572 2.66673 11.8333C2.66673 12.1095 2.89059 12.3333 3.16673 12.3333ZM2.66673 7.16667C2.66673 7.44281 2.44287 7.66667 2.16673 7.66667C1.89059 7.66667 1.66673 7.44281 1.66673 7.16667C1.66673 6.89052 1.89059 6.66667 2.16673 6.66667C2.44287 6.66667 2.66673 6.89052 2.66673 7.16667ZM2.16673 11C2.44287 11 2.66673 10.7761 2.66673 10.5C2.66673 10.2239 2.44287 10 2.16673 10C1.89059 10 1.66673 10.2239 1.66673 10.5C1.66673 10.7761 1.89059 11 2.16673 11ZM2.33339 8.83333C2.33339 9.10948 2.10954 9.33333 1.83339 9.33333C1.55725 9.33333 1.33339 9.10948 1.33339 8.83333C1.33339 8.55719 1.55725 8.33333 1.83339 8.33333C2.10954 8.33333 2.33339 8.55719 2.33339 8.83333ZM12.8334 6.33333C12.5573 6.33333 12.3334 6.10948 12.3334 5.83333C12.3334 5.55719 12.5573 5.33333 12.8334 5.33333C13.1095 5.33333 13.3334 5.55719 13.3334 5.83333C13.3334 6.10948 13.1095 6.33333 12.8334 6.33333ZM12.3334 11.8333C12.3334 12.1095 12.5573 12.3333 12.8334 12.3333C13.1095 12.3333 13.3334 12.1095 13.3334 11.8333C13.3334 11.5572 13.1095 11.3333 12.8334 11.3333C12.5573 11.3333 12.3334 11.5572 12.3334 11.8333ZM13.8334 7.66667C13.5573 7.66667 13.3334 7.44281 13.3334 7.16667C13.3334 6.89052 13.5573 6.66667 13.8334 6.66667C14.1095 6.66667 14.3334 6.89052 14.3334 7.16667C14.3334 7.44281 14.1095 7.66667 13.8334 7.66667ZM13.3334 10.5C13.3334 10.7761 13.5573 11 13.8334 11C14.1095 11 14.3334 10.7761 14.3334 10.5C14.3334 10.2239 14.1095 10 13.8334 10C13.5573 10 13.3334 10.2239 13.3334 10.5ZM14.1667 9.33333C13.8906 9.33333 13.6667 9.10948 13.6667 8.83333C13.6667 8.55719 13.8906 8.33333 14.1667 8.33333C14.4429 8.33333 14.6667 8.55719 14.6667 8.83333C14.6667 9.10948 14.4429 9.33333 14.1667 9.33333Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "509484923",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:transparent;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.n = NoiseCancellationIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJOb2lzZUNhbmNlbGxhdGlvbkljb24iLCJjb2xvciIsInNpemUiLCJwcm9wcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25zL05vaXNlQ2FuY2VsbGF0aW9uSWNvbi50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW50ZXJmYWNlIFByb3BzIGV4dGVuZHMgUmVhY3QuU1ZHQXR0cmlidXRlczxTVkdFbGVtZW50PiB7XG4gIGNvbG9yPzogc3RyaW5nO1xuICBzaXplPzogbnVtYmVyO1xufVxuXG5leHBvcnQgY29uc3QgTm9pc2VDYW5jZWxsYXRpb25JY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID1cbiAgKHsgY29sb3IgPSAnY3VycmVudENvbG9yJywgc2l6ZSA9IDI0LCAuLi5wcm9wcyB9KSA9PiAoXG4gICAgPHN2ZyB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCIgdmlld0JveD1cIjAgMCAxNiAxNlwiIHsuLi5wcm9wc30+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTUuMzMzMzkgNi42NjY2N0M1LjMzMzM5IDUuODYzMzMgNS40Nzk3OSA1LjExMjUyIDUuODcwNTcgNC41Njk3N0M2LjI0Njc3IDQuMDQ3MjcgNi44ODY2MiAzLjY2NjY3IDguMDAwMDYgMy42NjY2N0M5LjExMzUgMy42NjY2NyA5Ljc1MzM1IDQuMDQ3MjcgMTAuMTI5NSA0LjU2OTc3QzEwLjUyMDMgNS4xMTI1MiAxMC42NjY3IDUuODYzMzMgMTAuNjY2NyA2LjY2NjY3SDEwLjY0MzlDMTAuMjg4MyA2LjY2NjY3IDEwLjAwMDEgNi45NTQ5NCAxMC4wMDAxIDcuMzEwNTRWMTAuNjg5NUMxMC4wMDAxIDExLjA0NTEgMTAuMjg4MyAxMS4zMzMzIDEwLjY0MzkgMTEuMzMzM0gxMC45NDg4QzExLjcxOTcgMTEuMzMzMyAxMi4zNzcgMTAuNzc0NiAxMi41MDEyIDEwLjAxMzhDMTIuNjEwOCA5LjM0MjM5IDEyLjYxMDggOC42NTc2MSAxMi41MDEyIDcuOTg2MThDMTIuMzk4MyA3LjM1NTg4IDExLjkyOTUgNi44NjQzIDExLjMzMzQgNi43MTQxOVY2LjY2NjY3QzExLjMzMzQgNS44MDMzMyAxMS4xNzk4IDQuODg3NDggMTAuNjcwNiA0LjE4MDIzQzEwLjE0NjggMy40NTI3MyA5LjI4NjYyIDMgOC4wMDAwNiAzQzYuNzEzNSAzIDUuODUzMzUgMy40NTI3MyA1LjMyOTU1IDQuMTgwMjNDNC44MjAzMyA0Ljg4NzQ4IDQuNjY2NzMgNS44MDMzMyA0LjY2NjczIDYuNjY2NjdWNi43MTQxOUM0LjA3MDYgNi44NjQzIDMuNjAxODIgNy4zNTU4OCAzLjQ5ODkyIDcuOTg2MThDMy4zODkyOSA4LjY1NzYxIDMuMzg5MjkgOS4zNDIzOSAzLjQ5ODkyIDEwLjAxMzhDMy42MjMxMyAxMC43NzQ2IDQuMjgwNDMgMTEuMzMzMyA1LjA1MTMzIDExLjMzMzNINS4zNTYxOEM1LjcxMTc5IDExLjMzMzMgNi4wMDAwNiAxMS4wNDUxIDYuMDAwMDYgMTAuNjg5NVY3LjMxMDU0QzYuMDAwMDYgNi45NTQ5NCA1LjcxMTc5IDYuNjY2NjcgNS4zNTYxOCA2LjY2NjY3SDUuMzMzMzlaTTMuNjY2NzMgNS44MzMzM0MzLjY2NjczIDYuMTA5NDggMy40NDI4NyA2LjMzMzMzIDMuMTY2NzMgNi4zMzMzM0MyLjg5MDU5IDYuMzMzMzMgMi42NjY3MyA2LjEwOTQ4IDIuNjY2NzMgNS44MzMzM0MyLjY2NjczIDUuNTU3MTkgMi44OTA1OSA1LjMzMzMzIDMuMTY2NzMgNS4zMzMzM0MzLjQ0Mjg3IDUuMzMzMzMgMy42NjY3MyA1LjU1NzE5IDMuNjY2NzMgNS44MzMzM1pNMy4xNjY3MyAxMi4zMzMzQzMuNDQyODcgMTIuMzMzMyAzLjY2NjczIDEyLjEwOTUgMy42NjY3MyAxMS44MzMzQzMuNjY2NzMgMTEuNTU3MiAzLjQ0Mjg3IDExLjMzMzMgMy4xNjY3MyAxMS4zMzMzQzIuODkwNTkgMTEuMzMzMyAyLjY2NjczIDExLjU1NzIgMi42NjY3MyAxMS44MzMzQzIuNjY2NzMgMTIuMTA5NSAyLjg5MDU5IDEyLjMzMzMgMy4xNjY3MyAxMi4zMzMzWk0yLjY2NjczIDcuMTY2NjdDMi42NjY3MyA3LjQ0MjgxIDIuNDQyODcgNy42NjY2NyAyLjE2NjczIDcuNjY2NjdDMS44OTA1OSA3LjY2NjY3IDEuNjY2NzMgNy40NDI4MSAxLjY2NjczIDcuMTY2NjdDMS42NjY3MyA2Ljg5MDUyIDEuODkwNTkgNi42NjY2NyAyLjE2NjczIDYuNjY2NjdDMi40NDI4NyA2LjY2NjY3IDIuNjY2NzMgNi44OTA1MiAyLjY2NjczIDcuMTY2NjdaTTIuMTY2NzMgMTFDMi40NDI4NyAxMSAyLjY2NjczIDEwLjc3NjEgMi42NjY3MyAxMC41QzIuNjY2NzMgMTAuMjIzOSAyLjQ0Mjg3IDEwIDIuMTY2NzMgMTBDMS44OTA1OSAxMCAxLjY2NjczIDEwLjIyMzkgMS42NjY3MyAxMC41QzEuNjY2NzMgMTAuNzc2MSAxLjg5MDU5IDExIDIuMTY2NzMgMTFaTTIuMzMzMzkgOC44MzMzM0MyLjMzMzM5IDkuMTA5NDggMi4xMDk1NCA5LjMzMzMzIDEuODMzMzkgOS4zMzMzM0MxLjU1NzI1IDkuMzMzMzMgMS4zMzMzOSA5LjEwOTQ4IDEuMzMzMzkgOC44MzMzM0MxLjMzMzM5IDguNTU3MTkgMS41NTcyNSA4LjMzMzMzIDEuODMzMzkgOC4zMzMzM0MyLjEwOTU0IDguMzMzMzMgMi4zMzMzOSA4LjU1NzE5IDIuMzMzMzkgOC44MzMzM1pNMTIuODMzNCA2LjMzMzMzQzEyLjU1NzMgNi4zMzMzMyAxMi4zMzM0IDYuMTA5NDggMTIuMzMzNCA1LjgzMzMzQzEyLjMzMzQgNS41NTcxOSAxMi41NTczIDUuMzMzMzMgMTIuODMzNCA1LjMzMzMzQzEzLjEwOTUgNS4zMzMzMyAxMy4zMzM0IDUuNTU3MTkgMTMuMzMzNCA1LjgzMzMzQzEzLjMzMzQgNi4xMDk0OCAxMy4xMDk1IDYuMzMzMzMgMTIuODMzNCA2LjMzMzMzWk0xMi4zMzM0IDExLjgzMzNDMTIuMzMzNCAxMi4xMDk1IDEyLjU1NzMgMTIuMzMzMyAxMi44MzM0IDEyLjMzMzNDMTMuMTA5NSAxMi4zMzMzIDEzLjMzMzQgMTIuMTA5NSAxMy4zMzM0IDExLjgzMzNDMTMuMzMzNCAxMS41NTcyIDEzLjEwOTUgMTEuMzMzMyAxMi44MzM0IDExLjMzMzNDMTIuNTU3MyAxMS4zMzMzIDEyLjMzMzQgMTEuNTU3MiAxMi4zMzM0IDExLjgzMzNaTTEzLjgzMzQgNy42NjY2N0MxMy41NTczIDcuNjY2NjcgMTMuMzMzNCA3LjQ0MjgxIDEzLjMzMzQgNy4xNjY2N0MxMy4zMzM0IDYuODkwNTIgMTMuNTU3MyA2LjY2NjY3IDEzLjgzMzQgNi42NjY2N0MxNC4xMDk1IDYuNjY2NjcgMTQuMzMzNCA2Ljg5MDUyIDE0LjMzMzQgNy4xNjY2N0MxNC4zMzM0IDcuNDQyODEgMTQuMTA5NSA3LjY2NjY3IDEzLjgzMzQgNy42NjY2N1pNMTMuMzMzNCAxMC41QzEzLjMzMzQgMTAuNzc2MSAxMy41NTczIDExIDEzLjgzMzQgMTFDMTQuMTA5NSAxMSAxNC4zMzM0IDEwLjc3NjEgMTQuMzMzNCAxMC41QzE0LjMzMzQgMTAuMjIzOSAxNC4xMDk1IDEwIDEzLjgzMzQgMTBDMTMuNTU3MyAxMCAxMy4zMzM0IDEwLjIyMzkgMTMuMzMzNCAxMC41Wk0xNC4xNjY3IDkuMzMzMzNDMTMuODkwNiA5LjMzMzMzIDEzLjY2NjcgOS4xMDk0OCAxMy42NjY3IDguODMzMzNDMTMuNjY2NyA4LjU1NzE5IDEzLjg5MDYgOC4zMzMzMyAxNC4xNjY3IDguMzMzMzNDMTQuNDQyOSA4LjMzMzMzIDE0LjY2NjcgOC41NTcxOSAxNC42NjY3IDguODMzMzNDMTQuNjY2NyA5LjEwOTQ4IDE0LjQ0MjkgOS4zMzMzMyAxNC4xNjY3IDkuMzMzMzNaXCJcbiAgICAgICAgZmlsbD17Y29sb3J9XG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAgIGNsaXBSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAvPlxuICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICBzdmcge1xuICAgICAgICAgIGZpbGw6IHRyYW5zcGFyZW50O1xuICAgICAgICAgIGhlaWdodDogJHtzaXplfXB4O1xuICAgICAgICAgIHdpZHRoOiAke3NpemV9cHg7XG4gICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgIH1cbiAgICAgIGB9PC9zdHlsZT5cbiAgICA8L3N2Zz5cbiAgKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFPTyxJQUFNQSxxQkFBK0QsR0FDMUUsU0FEV0EscUJBQ1g7RUFBQSxzQkFBR0MsS0FBSDtFQUFBLElBQUdBLEtBQUgsMkJBQVcsY0FBWDtFQUFBLHFCQUEyQkMsSUFBM0I7RUFBQSxJQUEyQkEsSUFBM0IsMEJBQWtDLEVBQWxDO0VBQUEsSUFBeUNDLEtBQXpDO0VBQUEsb0JBQ0U7SUFBSyxLQUFLLEVBQUMsNEJBQVg7SUFBd0MsT0FBTyxFQUFDO0VBQWhELEdBQWdFQSxLQUFoRTtJQUFBLHFEQVVnQkQsSUFWaEIsRUFXZUEsSUFYZjtFQUFBLGlCQUNFO0lBQ0UsQ0FBQyxFQUFDLHEzRkFESjtJQUVFLElBQUksRUFBRUQsS0FGUjtJQUdFLFFBQVEsRUFBQyxTQUhYO0lBSUUsUUFBUSxFQUFDLFNBSlg7SUFBQSxxREFTY0MsSUFUZCxFQVVhQSxJQVZiO0VBQUEsRUFERjtJQUFBO0lBQUEsVUFVZ0JBLElBVmhCLEVBV2VBLElBWGY7RUFBQSx1RUFVZ0JBLElBVmhCLHNCQVdlQSxJQVhmLDBCQURGO0FBQUEsQ0FESyJ9

/***/ }),

/***/ 6115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.W = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["size", "backgroundColor", "color"];

var NoiseCancellationIconOn = function NoiseCancellationIconOn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'inherit' : _ref$backgroundColor,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["509484923", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: backgroundColor,
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 10C8.00004 8.795 8.21964 7.66878 8.80581 6.85465C9.37011 6.07091 10.3299 5.5 12 5.5C13.6702 5.5 14.63 6.07091 15.1943 6.85465C15.7804 7.66878 16 8.795 16 10H15.9659C15.4325 10 15 10.4324 15 10.9658V16.0342C15 16.5676 15.4325 17 15.9659 17H16.4231C17.5795 17 18.5654 16.162 18.7518 15.0207C18.9162 14.0136 18.9162 12.9864 18.7518 11.9793C18.5974 11.0338 17.8942 10.2965 17 10.0713V10C17 8.705 16.7696 7.33122 16.0058 6.27035C15.2201 5.17909 13.9299 4.5 12 4.5C10.0702 4.5 8.77998 5.17909 7.99428 6.27035C7.23045 7.33122 7.00004 8.705 7.00004 10V10.0713C6.10585 10.2965 5.40268 11.0338 5.24832 11.9793C5.08389 12.9864 5.08389 14.0136 5.24832 15.0207C5.43465 16.162 6.4206 17 7.57694 17H8.03423C8.56763 17 9.00004 16.5676 9.00004 16.0342V10.9658C9.00004 10.4324 8.56763 10 8.03423 10H8.00004Z",
    fill: color,
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "509484923",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:transparent;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.W = NoiseCancellationIconOn;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.b = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size", "variant"];

var PictureInPictureIcon = function PictureInPictureIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1809851938", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 5.5H6C5.17157 5.5 4.5 6.17157 4.5 7V13C4.5 13.8284 5.17157 14.5 6 14.5H14C14.8284 14.5 15.5 13.8284 15.5 13V7C15.5 6.17157 14.8284 5.5 14 5.5Z",
    fill: "transparent",
    stroke: color,
    className: _style["default"].dynamic([["1809851938", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.85355 7.14645C6.65829 6.95118 6.34171 6.95118 6.14645 7.14645C5.95118 7.34171 5.95118 7.65829 6.14645 7.85355L6.85355 7.14645ZM9.5 10.5V11C9.77614 11 10 10.7761 10 10.5H9.5ZM10 8C10 7.72386 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.72386 9 8H10ZM7 10C6.72386 10 6.5 10.2239 6.5 10.5C6.5 10.7761 6.72386 11 7 11V10ZM6.14645 7.85355L9.14645 10.8536L9.85355 10.1464L6.85355 7.14645L6.14645 7.85355ZM10 10.5V8H9V10.5H10ZM9.5 10H7V11H9.5V10Z",
    fill: color,
    className: _style["default"].dynamic([["1809851938", [size, size]]]) + " " + ((0, _classnames["default"])('arrow', {
      leave: variant === 'leave'
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 13C10 11.8954 10.8954 11 12 11H18C19.1046 11 20 11.8954 20 13V17C20 18.1046 19.1046 19 18 19H12C10.8954 19 10 18.1046 10 17V13Z",
    fill: color,
    className: _style["default"].dynamic([["1809851938", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1809851938",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}"), ".arrow.__jsx-style-dynamic-selector{-webkit-transform-origin:8px 9px;-ms-transform-origin:8px 9px;transform-origin:8px 9px;-webkit-transition:-webkit-transform 250ms ease;-webkit-transition:transform 250ms ease;transition:transform 250ms ease;}", ".arrow.leave.__jsx-style-dynamic-selector{-webkit-transform:scale(-1,-1);-ms-transform:scale(-1,-1);transform:scale(-1,-1);}"]));
};

exports.b = PictureInPictureIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.q = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var PinIcon = function PinIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.82577 4.55164C5.59118 3.80267 6.13655 3 6.95175 3H9.71482C10.53 3 11.0754 3.80267 10.8408 4.55164C10.7544 4.82751 10.667 5.12695 10.6017 5.39691C10.5335 5.67915 10.4999 5.88769 10.4999 6C10.4999 6.0452 10.5233 6.19737 10.5914 6.47462C10.6545 6.73169 10.744 7.04987 10.8473 7.39579C11.0537 8.0867 11.3095 8.86856 11.5056 9.45407C11.7588 10.2102 11.1987 11 10.3956 11H8.83328V13.3333C8.83328 13.6095 8.60942 13.8333 8.33328 13.8333C8.05714 13.8333 7.83328 13.6095 7.83328 13.3333V11H6.27101C5.46786 11 4.90777 10.2102 5.16095 9.45407C5.35701 8.86856 5.61288 8.0867 5.81926 7.39579C5.92259 7.04987 6.01203 6.73169 6.07519 6.47462C6.1433 6.19737 6.16661 6.0452 6.16661 6C6.16661 5.88769 6.13308 5.67915 6.06483 5.39691C5.99955 5.12695 5.91218 4.82751 5.82577 4.55164Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.q = PinIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3096:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.s = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var RaiseHandIcon = function RaiseHandIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5079 20.9944C9.29707 20.9933 8.1399 20.5296 7.30105 19.71C5.83931 18.2815 3.53997 16.0345 2.46894 14.9866C2.41651 14.9339 2.36533 14.8812 2.31665 14.8273C1.8735 14.3461 1.89847 13.626 2.37282 13.1728C2.84717 12.7197 3.61362 12.6857 4.13041 13.0956C4.18908 13.1424 4.2465 13.1881 4.30142 13.2372C4.89186 13.7618 5.77315 14.5568 6.37857 15.1025C6.49217 15.2055 6.66068 15.2336 6.80673 15.1751C6.95278 15.1165 7.04765 14.9831 7.04765 14.8332C7.0464 12.4258 7.04516 6.41325 7.04516 4.61475C7.04516 4.56558 7.04765 4.51406 7.0514 4.46136C7.07012 3.87709 7.58317 3.41458 8.20481 3.4181C8.82646 3.42278 9.33202 3.89231 9.34325 4.47776C9.347 4.53513 9.34825 4.59016 9.34825 4.6452C9.34825 6.07369 9.35199 9.49505 9.35324 10.8592C9.35324 10.9704 9.40067 11.0781 9.48431 11.1566C9.56794 11.235 9.68279 11.2795 9.80137 11.2795C10.0473 11.2795 10.2458 11.0922 10.2458 10.8615C10.2445 9.29366 10.2433 4.64403 10.2408 3.12303C10.2408 3.11132 10.2408 3.09961 10.242 3.08673C10.2483 2.49074 10.7601 2.00951 11.3929 2.00014C12.0271 1.99077 12.5538 2.45796 12.5813 3.05278C12.5801 3.08673 12.5826 3.11717 12.5826 3.14762C12.5913 4.75643 12.5863 9.30069 12.5851 10.858C12.5851 10.9704 12.6325 11.0769 12.7161 11.1566C12.801 11.235 12.9146 11.2795 13.0344 11.2783C13.0344 11.2783 13.0357 11.2783 13.0369 11.2783C13.2828 11.2772 13.4801 11.0898 13.4801 10.8592C13.4813 9.49505 13.4826 6.0491 13.4876 4.64637C13.4876 4.62412 13.4876 4.60304 13.4888 4.5808C13.4976 3.98832 14.0069 3.51177 14.6372 3.50591C15.2664 3.50006 15.7857 3.96725 15.8069 4.55855C15.8081 4.6288 15.8119 4.69789 15.8119 4.76463C15.8119 6.26103 15.8106 9.52433 15.8106 10.851C15.8106 11.0804 16.0079 11.2666 16.2525 11.269C16.3711 11.269 16.4847 11.2256 16.5683 11.1484C16.652 11.0699 16.6994 10.9634 16.7007 10.8521C16.7032 9.85803 16.7081 8.24219 16.7069 7.33006C16.7032 5.6709 19 5.67676 19 7.33592C19 8.73397 19 13.3368 18.9988 17.0989C18.9988 18.148 18.5494 19.1526 17.753 19.8868C16.9553 20.6198 15.878 21.0214 14.7621 20.9991C14.7621 20.9991 12.3142 20.9968 10.5079 20.9944Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.s = RaiseHandIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.A = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var RecordIcon = function RecordIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.05673 11.7832H6.6259V10.6179H7.06326C7.4941 10.6179 7.7291 10.7737 7.7291 11.1667V11.1938C7.7291 11.5867 7.50715 11.7832 7.05673 11.7832Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10C3 7.79086 4.79086 6 7 6H17C19.2091 6 21 7.79086 21 10V14C21 16.2091 19.2091 18 17 18H7C4.79086 18 3 16.2091 3 14V10ZM5.29422 14.4187V9.57453H7.12201C8.34271 9.57453 9.02161 10.0894 9.02161 11.1125V11.1396C9.02161 11.8306 8.6691 12.2168 8.17952 12.4133L9.29577 14.4187H7.88576L6.93923 12.6843H6.6259V14.4187H5.29422ZM10.3881 14.4187V9.57453H13.6128V10.645H11.7198V11.4783H13.2277V12.4675H11.7198V13.3482H13.7173V14.4187H10.3881ZM16.9974 14.5C18.205 14.5 19.0798 13.8496 19.1711 12.5962H17.8395C17.7742 13.1314 17.4413 13.3889 16.9713 13.3889C16.3315 13.3889 15.9725 12.8943 15.9725 12.0203V11.9661C15.9725 11.0854 16.3511 10.5976 16.9517 10.5976C17.4217 10.5976 17.6828 10.8686 17.735 11.3631H19.1124C19.0014 10.0827 18.1593 9.5 16.9452 9.5C15.5808 9.5 14.5625 10.4824 14.5625 11.9729C14.5625 13.4681 15.464 14.5 16.9974 14.5Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.A = RecordIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZWNvcmRJY29uIiwiY29sb3IiLCJzaXplIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JY29ucy9SZWNvcmRJY29uLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbnRlcmZhY2UgUHJvcHMgZXh0ZW5kcyBSZWFjdC5TVkdBdHRyaWJ1dGVzPFNWR0VsZW1lbnQ+IHtcbiAgY29sb3I/OiBzdHJpbmc7XG4gIHNpemU/OiBudW1iZXI7XG59XG5cbmV4cG9ydCBjb25zdCBSZWNvcmRJY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY29sb3IgPSAnY3VycmVudENvbG9yJyxcbiAgc2l6ZSA9IDI0LFxuICAuLi5wcm9wc1xufSkgPT4gKFxuICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfT5cbiAgICA8cGF0aCBkPVwiTTcuMDU2NzMgMTEuNzgzMkg2LjYyNTlWMTAuNjE3OUg3LjA2MzI2QzcuNDk0MSAxMC42MTc5IDcuNzI5MSAxMC43NzM3IDcuNzI5MSAxMS4xNjY3VjExLjE5MzhDNy43MjkxIDExLjU4NjcgNy41MDcxNSAxMS43ODMyIDcuMDU2NzMgMTEuNzgzMlpcIiAvPlxuICAgIDxwYXRoXG4gICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgY2xpcFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGQ9XCJNMyAxMEMzIDcuNzkwODYgNC43OTA4NiA2IDcgNkgxN0MxOS4yMDkxIDYgMjEgNy43OTA4NiAyMSAxMFYxNEMyMSAxNi4yMDkxIDE5LjIwOTEgMTggMTcgMThIN0M0Ljc5MDg2IDE4IDMgMTYuMjA5MSAzIDE0VjEwWk01LjI5NDIyIDE0LjQxODdWOS41NzQ1M0g3LjEyMjAxQzguMzQyNzEgOS41NzQ1MyA5LjAyMTYxIDEwLjA4OTQgOS4wMjE2MSAxMS4xMTI1VjExLjEzOTZDOS4wMjE2MSAxMS44MzA2IDguNjY5MSAxMi4yMTY4IDguMTc5NTIgMTIuNDEzM0w5LjI5NTc3IDE0LjQxODdINy44ODU3Nkw2LjkzOTIzIDEyLjY4NDNINi42MjU5VjE0LjQxODdINS4yOTQyMlpNMTAuMzg4MSAxNC40MTg3VjkuNTc0NTNIMTMuNjEyOFYxMC42NDVIMTEuNzE5OFYxMS40NzgzSDEzLjIyNzdWMTIuNDY3NUgxMS43MTk4VjEzLjM0ODJIMTMuNzE3M1YxNC40MTg3SDEwLjM4ODFaTTE2Ljk5NzQgMTQuNUMxOC4yMDUgMTQuNSAxOS4wNzk4IDEzLjg0OTYgMTkuMTcxMSAxMi41OTYySDE3LjgzOTVDMTcuNzc0MiAxMy4xMzE0IDE3LjQ0MTMgMTMuMzg4OSAxNi45NzEzIDEzLjM4ODlDMTYuMzMxNSAxMy4zODg5IDE1Ljk3MjUgMTIuODk0MyAxNS45NzI1IDEyLjAyMDNWMTEuOTY2MUMxNS45NzI1IDExLjA4NTQgMTYuMzUxMSAxMC41OTc2IDE2Ljk1MTcgMTAuNTk3NkMxNy40MjE3IDEwLjU5NzYgMTcuNjgyOCAxMC44Njg2IDE3LjczNSAxMS4zNjMxSDE5LjExMjRDMTkuMDAxNCAxMC4wODI3IDE4LjE1OTMgOS41IDE2Ljk0NTIgOS41QzE1LjU4MDggOS41IDE0LjU2MjUgMTAuNDgyNCAxNC41NjI1IDExLjk3MjlDMTQuNTYyNSAxMy40NjgxIDE1LjQ2NCAxNC41IDE2Ljk5NzQgMTQuNVpcIlxuICAgIC8+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgc3ZnIHtcbiAgICAgICAgZmlsbDogJHtjb2xvcn07XG4gICAgICAgIGhlaWdodDogJHtzaXplfXB4O1xuICAgICAgICB3aWR0aDogJHtzaXplfXB4O1xuICAgICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvc3ZnPlxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFPTyxJQUFNQSxVQUFvRCxHQUFHLFNBQXZEQSxVQUF1RDtFQUFBLHNCQUNsRUMsS0FEa0U7RUFBQSxJQUNsRUEsS0FEa0UsMkJBQzFELGNBRDBEO0VBQUEscUJBRWxFQyxJQUZrRTtFQUFBLElBRWxFQSxJQUZrRSwwQkFFM0QsRUFGMkQ7RUFBQSxJQUcvREMsS0FIK0Q7RUFBQSxvQkFLbEU7SUFBSyxLQUFLLEVBQUMsNEJBQVg7SUFBd0MsT0FBTyxFQUFDO0VBQWhELEdBQWdFQSxLQUFoRTtJQUFBLHNEQVNjRixLQVRkLEVBVWdCQyxJQVZoQixFQVdlQSxJQVhmO0VBQUEsaUJBQ0U7SUFBTSxDQUFDLEVBQUMsOElBQVI7SUFBQSxzREFRWUQsS0FSWixFQVNjQyxJQVRkLEVBVWFBLElBVmI7RUFBQSxFQURGLGVBRUU7SUFDRSxRQUFRLEVBQUMsU0FEWDtJQUVFLFFBQVEsRUFBQyxTQUZYO0lBR0UsQ0FBQyxFQUFDLGkwQkFISjtJQUFBLHNEQU9ZRCxLQVBaLEVBUWNDLElBUmQsRUFTYUEsSUFUYjtFQUFBLEVBRkY7SUFBQTtJQUFBLFVBU2NELEtBVGQsRUFVZ0JDLElBVmhCLEVBV2VBLElBWGY7RUFBQSxvREFTY0QsS0FUZCxxQkFVZ0JDLElBVmhCLHNCQVdlQSxJQVhmLDBCQUxrRTtBQUFBLENBQTdEIn0=

/***/ }),

/***/ 5434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.D = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var RefreshIcon = function RefreshIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15259 8.00001C2.15259 5.13671 4.47375 2.81555 7.33704 2.81555C10.0407 2.81555 12.2611 4.88517 12.5002 7.52659L12.9721 7.03316C13.1629 6.8336 13.4794 6.82653 13.679 7.01739C13.8786 7.20825 13.8856 7.52475 13.6948 7.72432L12.322 9.1597C12.2277 9.25833 12.0972 9.31412 11.9607 9.31412C11.8242 9.31412 11.6937 9.25833 11.5993 9.1597L10.2266 7.72433C10.0357 7.52476 10.0428 7.20826 10.2424 7.0174C10.4419 6.82654 10.7584 6.8336 10.9493 7.03317L11.5038 7.613C11.3085 5.48341 9.51757 3.81555 7.33704 3.81555C5.02792 3.81555 3.15565 5.68593 3.15259 7.99434L3.15262 8C3.15262 10.309 5.02276 12.1811 7.33096 12.1844L7.33708 12.1844C8.51404 12.1844 9.57678 11.6992 10.3377 10.9165C10.5302 10.7185 10.8467 10.714 11.0447 10.9065C11.2427 11.099 11.2472 11.4155 11.0547 11.6135C10.1148 12.5804 8.79925 13.1825 7.34396 13.1844L7.33708 13.1845C4.47588 13.1845 2.15602 10.8667 2.15263 8.00629L2.15259 8.00001Z",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.D = RefreshIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6958:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.B = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var ReturnIcon = function ReturnIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55485 12.5474C9.84581 12.8392 10.3176 12.8392 10.6085 12.5474C10.8995 12.2556 10.8995 11.7825 10.6085 11.4906L9.00295 9.88037H12.9592C15.1963 9.88037 17.0099 11.6992 17.0099 13.9429C17.0099 16.1866 15.1963 18.0055 12.9592 18.0055H6.24506C5.83357 18.0055 5.5 18.3401 5.5 18.7528C5.5 19.1654 5.83357 19.5 6.24506 19.5H12.9592C16.0193 19.5 18.5 17.012 18.5 13.9429C18.5 10.8739 16.0193 8.38589 12.9592 8.38589H9.00295L10.6085 6.77562C10.8995 6.4838 10.8995 6.01068 10.6085 5.71886C10.3176 5.42705 9.84581 5.42705 9.55485 5.71886L6.67738 8.60475C6.38642 8.89657 6.38642 9.36969 6.67738 9.66151L9.55485 12.5474Z",
    fill: color,
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.B = ReturnIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZXR1cm5JY29uIiwiY29sb3IiLCJzaXplIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JY29ucy9SZXR1cm5JY29uLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbnRlcmZhY2UgUHJvcHMgZXh0ZW5kcyBSZWFjdC5TVkdBdHRyaWJ1dGVzPFNWR0VsZW1lbnQ+IHtcbiAgY29sb3I/OiBzdHJpbmc7XG4gIHNpemU/OiBudW1iZXI7XG59XG5cbmV4cG9ydCBjb25zdCBSZXR1cm5JY29uOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY29sb3IgPSAnY3VycmVudENvbG9yJyxcbiAgc2l6ZSA9IDI0LFxuICAuLi5wcm9wc1xufSkgPT4gKFxuICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfT5cbiAgICA8cGF0aFxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGNsaXBSdWxlPVwiZXZlbm9kZFwiXG4gICAgICBkPVwiTTkuNTU0ODUgMTIuNTQ3NEM5Ljg0NTgxIDEyLjgzOTIgMTAuMzE3NiAxMi44MzkyIDEwLjYwODUgMTIuNTQ3NEMxMC44OTk1IDEyLjI1NTYgMTAuODk5NSAxMS43ODI1IDEwLjYwODUgMTEuNDkwNkw5LjAwMjk1IDkuODgwMzdIMTIuOTU5MkMxNS4xOTYzIDkuODgwMzcgMTcuMDA5OSAxMS42OTkyIDE3LjAwOTkgMTMuOTQyOUMxNy4wMDk5IDE2LjE4NjYgMTUuMTk2MyAxOC4wMDU1IDEyLjk1OTIgMTguMDA1NUg2LjI0NTA2QzUuODMzNTcgMTguMDA1NSA1LjUgMTguMzQwMSA1LjUgMTguNzUyOEM1LjUgMTkuMTY1NCA1LjgzMzU3IDE5LjUgNi4yNDUwNiAxOS41SDEyLjk1OTJDMTYuMDE5MyAxOS41IDE4LjUgMTcuMDEyIDE4LjUgMTMuOTQyOUMxOC41IDEwLjg3MzkgMTYuMDE5MyA4LjM4NTg5IDEyLjk1OTIgOC4zODU4OUg5LjAwMjk1TDEwLjYwODUgNi43NzU2MkMxMC44OTk1IDYuNDgzOCAxMC44OTk1IDYuMDEwNjggMTAuNjA4NSA1LjcxODg2QzEwLjMxNzYgNS40MjcwNSA5Ljg0NTgxIDUuNDI3MDUgOS41NTQ4NSA1LjcxODg2TDYuNjc3MzggOC42MDQ3NUM2LjM4NjQyIDguODk2NTcgNi4zODY0MiA5LjM2OTY5IDYuNjc3MzggOS42NjE1MUw5LjU1NDg1IDEyLjU0NzRaXCJcbiAgICAgIGZpbGw9e2NvbG9yfVxuICAgIC8+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgc3ZnIHtcbiAgICAgICAgZmlsbDogJHtjb2xvcn07XG4gICAgICAgIGhlaWdodDogJHtzaXplfXB4O1xuICAgICAgICB3aWR0aDogJHtzaXplfXB4O1xuICAgICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvc3ZnPlxuKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFPTyxJQUFNQSxVQUFvRCxHQUFHLFNBQXZEQSxVQUF1RDtFQUFBLHNCQUNsRUMsS0FEa0U7RUFBQSxJQUNsRUEsS0FEa0UsMkJBQzFELGNBRDBEO0VBQUEscUJBRWxFQyxJQUZrRTtFQUFBLElBRWxFQSxJQUZrRSwwQkFFM0QsRUFGMkQ7RUFBQSxJQUcvREMsS0FIK0Q7RUFBQSxvQkFLbEU7SUFBSyxLQUFLLEVBQUMsNEJBQVg7SUFBd0MsT0FBTyxFQUFDO0VBQWhELEdBQWdFQSxLQUFoRTtJQUFBLHNEQVNjRixLQVRkLEVBVWdCQyxJQVZoQixFQVdlQSxJQVhmO0VBQUEsaUJBQ0U7SUFDRSxRQUFRLEVBQUMsU0FEWDtJQUVFLFFBQVEsRUFBQyxTQUZYO0lBR0UsQ0FBQyxFQUFDLG1tQkFISjtJQUlFLElBQUksRUFBRUQsS0FKUjtJQUFBLHNEQVFZQSxLQVJaLEVBU2NDLElBVGQsRUFVYUEsSUFWYjtFQUFBLEVBREY7SUFBQTtJQUFBLFVBU2NELEtBVGQsRUFVZ0JDLElBVmhCLEVBV2VBLElBWGY7RUFBQSxvREFTY0QsS0FUZCxxQkFVZ0JDLElBVmhCLHNCQVdlQSxJQVhmLDBCQUxrRTtBQUFBLENBQTdEIn0=

/***/ }),

/***/ 8244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.E = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _excluded = ["size"];

var ReverseIcon = function ReverseIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors;

  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["509484923", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 5.79086 1.79086 4 4 4H20C22.2091 4 24 5.79086 24 8V18C24 20.2091 22.2091 22 20 22H4C1.79086 22 0 20.2091 0 18V8Z",
    fill: colors.system.white,
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.72361 2.55279L7 4H17L16.2764 2.55279C16.107 2.214 15.7607 2 15.382 2H8.61803C8.23926 2 7.893 2.214 7.72361 2.55279Z",
    fill: "white",
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.3107 12.613C17.3107 9.51304 14.7977 7 11.6977 7C10.2742 7 8.97442 7.52992 7.98494 8.40326",
    stroke: colors.system.blueDark,
    strokeWidth: "1.13806",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.68926 12.613C6.68926 15.713 9.2023 18.2261 12.3023 18.2261C13.7258 18.2261 15.0256 17.6962 16.0151 16.8228",
    stroke: colors.system.blueDark,
    strokeWidth: "1.13806",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.56147 10.5493C6.75567 10.2256 7.22476 10.2256 7.41896 10.5493L9.11312 13.3729C9.31308 13.7061 9.07302 14.1301 8.68438 14.1301H5.29606C4.90741 14.1301 4.66736 13.7061 4.86731 13.3729L6.56147 10.5493Z",
    fill: colors.system.blueDark,
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.4344 14.683C17.2402 15.0067 16.7711 15.0067 16.5769 14.683L14.8786 11.8526C14.6787 11.5193 14.9187 11.0953 15.3074 11.0953L18.7039 11.0953C19.0926 11.0953 19.3326 11.5193 19.1327 11.8526L17.4344 14.683Z",
    fill: colors.system.blueDark,
    className: _style["default"].dynamic([["509484923", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "509484923",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:transparent;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.E = ReverseIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZXZlcnNlSWNvbiIsInNpemUiLCJwcm9wcyIsInVzZVRoZW1lIiwiY29sb3JzIiwic3lzdGVtIiwid2hpdGUiLCJibHVlRGFyayJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25zL1JldmVyc2VJY29uLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyB1c2VUaGVtZSB9IGZyb20gJy4uLy4uL2NvbnRleHRzL1RoZW1lJztcblxuaW50ZXJmYWNlIFByb3BzIGV4dGVuZHMgUmVhY3QuU1ZHQXR0cmlidXRlczxTVkdFbGVtZW50PiB7XG4gIGNvbG9yPzogc3RyaW5nO1xuICBzaXplPzogbnVtYmVyO1xufVxuXG5leHBvcnQgY29uc3QgUmV2ZXJzZUljb246IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBzaXplID0gMjQsXG4gIC4uLnByb3BzXG59KSA9PiB7XG4gIGNvbnN0IHsgY29sb3JzIH0gPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gKFxuICAgIDxzdmcgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiIHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9PlxuICAgICAgPHBhdGhcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgICAgY2xpcFJ1bGU9XCJldmVub2RkXCJcbiAgICAgICAgZD1cIk0wIDhDMCA1Ljc5MDg2IDEuNzkwODYgNCA0IDRIMjBDMjIuMjA5MSA0IDI0IDUuNzkwODYgMjQgOFYxOEMyNCAyMC4yMDkxIDIyLjIwOTEgMjIgMjAgMjJINEMxLjc5MDg2IDIyIDAgMjAuMjA5MSAwIDE4VjhaXCJcbiAgICAgICAgZmlsbD17Y29sb3JzLnN5c3RlbS53aGl0ZX1cbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTcuNzIzNjEgMi41NTI3OUw3IDRIMTdMMTYuMjc2NCAyLjU1Mjc5QzE2LjEwNyAyLjIxNCAxNS43NjA3IDIgMTUuMzgyIDJIOC42MTgwM0M4LjIzOTI2IDIgNy44OTMgMi4yMTQgNy43MjM2MSAyLjU1Mjc5WlwiXG4gICAgICAgIGZpbGw9XCJ3aGl0ZVwiXG4gICAgICAvPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNy4zMTA3IDEyLjYxM0MxNy4zMTA3IDkuNTEzMDQgMTQuNzk3NyA3IDExLjY5NzcgN0MxMC4yNzQyIDcgOC45NzQ0MiA3LjUyOTkyIDcuOTg0OTQgOC40MDMyNlwiXG4gICAgICAgIHN0cm9rZT17Y29sb3JzLnN5c3RlbS5ibHVlRGFya31cbiAgICAgICAgc3Ryb2tlV2lkdGg9XCIxLjEzODA2XCJcbiAgICAgICAgc3Ryb2tlTGluZWNhcD1cInJvdW5kXCJcbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTYuNjg5MjYgMTIuNjEzQzYuNjg5MjYgMTUuNzEzIDkuMjAyMyAxOC4yMjYxIDEyLjMwMjMgMTguMjI2MUMxMy43MjU4IDE4LjIyNjEgMTUuMDI1NiAxNy42OTYyIDE2LjAxNTEgMTYuODIyOFwiXG4gICAgICAgIHN0cm9rZT17Y29sb3JzLnN5c3RlbS5ibHVlRGFya31cbiAgICAgICAgc3Ryb2tlV2lkdGg9XCIxLjEzODA2XCJcbiAgICAgICAgc3Ryb2tlTGluZWNhcD1cInJvdW5kXCJcbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTYuNTYxNDcgMTAuNTQ5M0M2Ljc1NTY3IDEwLjIyNTYgNy4yMjQ3NiAxMC4yMjU2IDcuNDE4OTYgMTAuNTQ5M0w5LjExMzEyIDEzLjM3MjlDOS4zMTMwOCAxMy43MDYxIDkuMDczMDIgMTQuMTMwMSA4LjY4NDM4IDE0LjEzMDFINS4yOTYwNkM0LjkwNzQxIDE0LjEzMDEgNC42NjczNiAxMy43MDYxIDQuODY3MzEgMTMuMzcyOUw2LjU2MTQ3IDEwLjU0OTNaXCJcbiAgICAgICAgZmlsbD17Y29sb3JzLnN5c3RlbS5ibHVlRGFya31cbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE3LjQzNDQgMTQuNjgzQzE3LjI0MDIgMTUuMDA2NyAxNi43NzExIDE1LjAwNjcgMTYuNTc2OSAxNC42ODNMMTQuODc4NiAxMS44NTI2QzE0LjY3ODcgMTEuNTE5MyAxNC45MTg3IDExLjA5NTMgMTUuMzA3NCAxMS4wOTUzTDE4LjcwMzkgMTEuMDk1M0MxOS4wOTI2IDExLjA5NTMgMTkuMzMyNiAxMS41MTkzIDE5LjEzMjcgMTEuODUyNkwxNy40MzQ0IDE0LjY4M1pcIlxuICAgICAgICBmaWxsPXtjb2xvcnMuc3lzdGVtLmJsdWVEYXJrfVxuICAgICAgLz5cbiAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgc3ZnIHtcbiAgICAgICAgICBmaWxsOiB0cmFuc3BhcmVudDtcbiAgICAgICAgICBoZWlnaHQ6ICR7c2l6ZX1weDtcbiAgICAgICAgICB3aWR0aDogJHtzaXplfXB4O1xuICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICB9XG4gICAgICBgfTwvc3R5bGU+XG4gICAgPC9zdmc+XG4gICk7XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQU9PLElBQU1BLFdBQXFELEdBQUcsU0FBeERBLFdBQXdELE9BRy9EO0VBQUEscUJBRkpDLElBRUk7RUFBQSxJQUZKQSxJQUVJLDBCQUZHLEVBRUg7RUFBQSxJQUREQyxLQUNDOztFQUNKLGdCQUFtQixJQUFBQyxlQUFBLEdBQW5CO0VBQUEsSUFBUUMsTUFBUixhQUFRQSxNQUFSOztFQUNBLG9CQUNFO0lBQUssS0FBSyxFQUFDLDRCQUFYO0lBQXdDLE9BQU8sRUFBQztFQUFoRCxHQUFnRUYsS0FBaEU7SUFBQSxxREFrQ2dCRCxJQWxDaEIsRUFtQ2VBLElBbkNmO0VBQUEsaUJBQ0U7SUFDRSxRQUFRLEVBQUMsU0FEWDtJQUVFLFFBQVEsRUFBQyxTQUZYO0lBR0UsQ0FBQyxFQUFDLHlIQUhKO0lBSUUsSUFBSSxFQUFFRyxNQUFNLENBQUNDLE1BQVAsQ0FBY0MsS0FKdEI7SUFBQSxxREFpQ2NMLElBakNkLEVBa0NhQSxJQWxDYjtFQUFBLEVBREYsZUFPRTtJQUNFLENBQUMsRUFBQyx3SEFESjtJQUVFLElBQUksRUFBQyxPQUZQO0lBQUEscURBMkJjQSxJQTNCZCxFQTRCYUEsSUE1QmI7RUFBQSxFQVBGLGVBV0U7SUFDRSxDQUFDLEVBQUMsK0ZBREo7SUFFRSxNQUFNLEVBQUVHLE1BQU0sQ0FBQ0MsTUFBUCxDQUFjRSxRQUZ4QjtJQUdFLFdBQVcsRUFBQyxTQUhkO0lBSUUsYUFBYSxFQUFDLE9BSmhCO0lBQUEscURBdUJjTixJQXZCZCxFQXdCYUEsSUF4QmI7RUFBQSxFQVhGLGVBaUJFO0lBQ0UsQ0FBQyxFQUFDLCtHQURKO0lBRUUsTUFBTSxFQUFFRyxNQUFNLENBQUNDLE1BQVAsQ0FBY0UsUUFGeEI7SUFHRSxXQUFXLEVBQUMsU0FIZDtJQUlFLGFBQWEsRUFBQyxPQUpoQjtJQUFBLHFEQWlCY04sSUFqQmQsRUFrQmFBLElBbEJiO0VBQUEsRUFqQkYsZUF1QkU7SUFDRSxDQUFDLEVBQUMsMk1BREo7SUFFRSxJQUFJLEVBQUVHLE1BQU0sQ0FBQ0MsTUFBUCxDQUFjRSxRQUZ0QjtJQUFBLHFEQVdjTixJQVhkLEVBWWFBLElBWmI7RUFBQSxFQXZCRixlQTJCRTtJQUNFLENBQUMsRUFBQyxnTkFESjtJQUVFLElBQUksRUFBRUcsTUFBTSxDQUFDQyxNQUFQLENBQWNFLFFBRnRCO0lBQUEscURBT2NOLElBUGQsRUFRYUEsSUFSYjtFQUFBLEVBM0JGO0lBQUE7SUFBQSxVQWtDZ0JBLElBbENoQixFQW1DZUEsSUFuQ2Y7RUFBQSx1RUFrQ2dCQSxJQWxDaEIsc0JBbUNlQSxJQW5DZiwwQkFERjtBQTBDRCxDQS9DTSJ9

/***/ }),

/***/ 4800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.Q = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var ScreenshareIcon = function ScreenshareIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9997 4.5H7.00031C5.61937 4.5 4.5 5.61937 4.5 7.00031V13.9997C4.5 15.3806 5.61937 16.5 7.00031 16.5H16.9997C18.3806 16.5 19.5 15.3806 19.5 13.9997V7.00031C19.5 5.61937 18.3806 4.5 16.9997 4.5ZM7.99969 18C7.58625 18 7.24969 18.3356 7.24969 18.75C7.24969 19.1644 7.58625 19.5 7.99969 19.5H16.0003C16.4147 19.5 16.7503 19.1644 16.7503 18.75C16.7503 18.3356 16.4147 18 16.0003 18H7.99969ZM8.66156 10.2816C8.44594 10.5094 8.44594 10.8788 8.66156 11.1066C8.87813 11.3344 9.22781 11.3344 9.44344 11.1066L11.4478 8.99156V13.4166C11.4478 13.7391 11.6944 13.9997 12 13.9997C12.3056 13.9997 12.5522 13.7391 12.5522 13.4166V8.99156L14.5566 11.1066C14.7722 11.3344 15.1228 11.3344 15.3384 11.1066C15.5541 10.8788 15.5541 10.5094 15.3384 10.2816L12.3909 7.17094C12.1753 6.94312 11.8247 6.94312 11.6091 7.17094L8.66156 10.2816Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.Q = ScreenshareIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.d = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var SpeakerViewIcon = function SpeakerViewIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["3569927790", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.5 8.5C5.5 7.94772 5.94772 7.5 6.5 7.5H17.5C18.0523 7.5 18.5 7.94772 18.5 8.5V15.5C18.5 16.0523 18.0523 16.5 17.5 16.5H6.5C5.94772 16.5 5.5 16.0523 5.5 15.5V8.5Z",
    stroke: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "14.5",
    y1: "8",
    x2: "14.5",
    y2: "16",
    stroke: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "15",
    y1: "10.5",
    x2: "18",
    y2: "10.5",
    stroke: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "15",
    y1: "13.5",
    x2: "18",
    y2: "13.5",
    stroke: color,
    className: _style["default"].dynamic([["3569927790", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3569927790",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:transparent;height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.d = SpeakerViewIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.C = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var StopScreenshareIcon = function StopScreenshareIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53051 16.5356H17.0493C18.4269 16.5356 19.5432 15.4192 19.5432 14.0416V7.05822C19.5432 6.6161 19.4277 6.20011 19.2257 5.83938L20.5792 4.48691C20.8736 4.1925 20.8736 3.71521 20.5792 3.4208C20.2848 3.12639 19.8075 3.12639 19.5131 3.4208L3.42005 19.5138C3.12665 19.8082 3.12665 20.2855 3.42005 20.5799C3.71446 20.8733 4.19174 20.8733 4.48615 20.5799L8.53051 16.5356ZM7.98289 19.554H16.0435C16.4585 19.554 16.7971 19.2154 16.7971 18.8004C16.7971 18.3844 16.4585 18.0468 16.0435 18.0468H7.98289C7.5669 18.0468 7.22928 18.3844 7.22928 18.8004C7.22928 19.2154 7.5669 19.554 7.98289 19.554ZM16.2515 4.56428H7.07354C5.69595 4.56428 4.5796 5.68062 4.5796 7.05822V14.0416C4.5796 14.6546 4.80066 15.2153 5.16641 15.6493L16.2515 4.56428Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.C = StopScreenshareIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.t = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var UserIcon = function UserIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7C8 5 9 3 12 3C15 3 16 5 16 7C16 10 14.2091 12 12 12C9.79086 12 8 10 8 7ZM4.5 20C4.5 16.3771 5.73052 14.3949 8.93456 12.5673C9.85701 13.1654 10.9186 13.5 12 13.5C13.0818 13.5 14.1439 13.1651 15.0666 12.5666C18.2695 14.3853 19.4984 16.3218 19.4984 19.9443C19.4995 19.9628 19.5 19.9814 19.5 20C19.5 20.5215 19.0772 20.9443 18.5557 20.9443L18.4984 20.9443L5.5 21C4.94772 21 4.5 20.5523 4.5 20Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.t = UserIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WarningIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "size"];

var WarningIcon = function WarningIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["2785131988", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7687 5.09326C11.321 4.15426 12.679 4.15426 13.2314 5.09326L20.7336 17.8471C21.2938 18.7994 20.6072 20 19.5023 20H4.49776C3.39288 20 2.70623 18.7994 3.26642 17.8471L10.7687 5.09326ZM11 10C11 9.44771 11.4477 9 12 9C12.5523 9 13 9.44771 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
    className: _style["default"].dynamic([["2785131988", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2785131988",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.WarningIcon = WarningIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Menu = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Card = __webpack_require__(8257);

var _Popover = __webpack_require__(2060);

var _MenuDivider = __webpack_require__(174);

var _MenuItem = __webpack_require__(2474);

var _excluded = ["cardListProps", "cardProps", "children", "className", "items"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Menu = function Menu(_ref) {
  var _cardListProps$style;

  var _ref$cardListProps = _ref.cardListProps,
      cardListProps = _ref$cardListProps === void 0 ? {} : _ref$cardListProps,
      _ref$cardProps = _ref.cardProps,
      cardProps = _ref$cardProps === void 0 ? {} : _ref$cardProps,
      children = _ref.children,
      className = _ref.className,
      items = _ref.items,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var triggerRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(function () {
    triggerRef.current = document.getElementById(props['aria-labelledby']);
  }, [props]);
  return /*#__PURE__*/_react["default"].createElement(_Popover.Popover, (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('menu', className),
    cardProps: _objectSpread(_objectSpread({}, cardProps), {}, {
      noBorder: true,
      shadow: 'strong'
    })
  }), items && /*#__PURE__*/_react["default"].createElement("div", {
    role: "menu",
    className: "jsx-110985627" + " " + "menu-list"
  }, /*#__PURE__*/_react["default"].createElement(_Card.CardList, (0, _extends2["default"])({}, cardListProps, {
    style: _objectSpread({}, (_cardListProps$style = cardListProps === null || cardListProps === void 0 ? void 0 : cardListProps.style) !== null && _cardListProps$style !== void 0 ? _cardListProps$style : {})
  }), items.map(function (item, i) {
    return 'divider' in item ? /*#__PURE__*/_react["default"].createElement(_MenuDivider.MenuDivider, {
      key: "menuitem-".concat(i)
    }) : /*#__PURE__*/_react["default"].createElement(_MenuItem.MenuItem, (0, _extends2["default"])({
      key: "menuitem-".concat(i)
    }, item));
  }))), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "110985627"
  }, [".menu-list.jsx-110985627{background:var(--menu-bg);min-width:176px;}", ".menu-list.jsx-110985627 .menu-item{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;position:relative;width:100%;}", ".menu-list.jsx-110985627 .menu-item.button > span{max-width:100%;min-width:1px;}", ".menu-list.jsx-110985627 .menu-item:focus-visible{box-shadow:0 0 0 2px var(--focus-shadow);outline:none;}", ".menu-list.jsx-110985627 .menu-item:not(.static):focus-visible,.menu-list.jsx-110985627 .menu-item:not(.static):hover{background-color:var(--menu-item-hover-bg);}", ".menu-list.jsx-110985627 .menu-item[disabled]:hover{background:var(--menu-bg);cursor:not-allowed;}", ".menu-list.jsx-110985627 label.menu-item{cursor:pointer;}"]));
};

exports.Menu = Menu;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MenuButton = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Button = __webpack_require__(9757);

var _excluded = ["children", "className", "id", "onClick", "open"];

var MenuButton = function MenuButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      onClick = _ref.onClick,
      open = _ref.open,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var handleClick = function handleClick(ev) {
    /**
     * Timeout prevents this click to be handled by useClosable,
     * which would close the Menu straight away.
     */
    setTimeout(function () {
      onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    }, 10);
  };

  return /*#__PURE__*/_react["default"].createElement(_Button.Button, (0, _extends2["default"])({
    className: (0, _classnames["default"])('menuButton', className),
    onClick: handleClick,
    focusable: false
  }, props, {
    "aria-haspopup": "true",
    "aria-expanded": open,
    id: id
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2079435950"
  }, [".menuButton{-webkit-transition:box-shadow 200ms ease;transition:box-shadow 200ms ease;}", ".menuButton:focus-visible{box-shadow:0 0 0 2px var(--focus-shadow);border-radius:4px;}"]));
};

exports.MenuButton = MenuButton;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MenuDivider = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _react = _interopRequireDefault(__webpack_require__(7294));

var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "jsx-585623312"
  }, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "585623312"
  }, ["div.jsx-585623312{border-top:1px solid var(--card-border);margin:8px 0;}"]));
};

exports.MenuDivider = MenuDivider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJNZW51RGl2aWRlciJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lbnUvTWVudURpdmlkZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBjb25zdCBNZW51RGl2aWRlcjogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48dW5rbm93bj4+ID0gKCkgPT4gKFxuICA8ZGl2PlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIGRpdiB7XG4gICAgICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCB2YXIoLS1jYXJkLWJvcmRlcik7XG4gICAgICAgIG1hcmdpbjogOHB4IDA7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L2Rpdj5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRU8sSUFBTUEsV0FBdUQsR0FBRyxTQUExREEsV0FBMEQ7RUFBQSxvQkFDckU7SUFBQTtFQUFBO0lBQUE7RUFBQSxpRkFEcUU7QUFBQSxDQUFoRSJ9

/***/ }),

/***/ 2474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MenuItem = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Anchor = __webpack_require__(757);

var _Button = __webpack_require__(9757);

var _CheckIcon = __webpack_require__(7886);

var _Text = __webpack_require__(5645);

var _excluded = ["active", "className", "disabled", "download", "href", "static", "HrefComponent", "icon", "label", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MenuItem = function MenuItem(_ref) {
  var active = _ref.active,
      className = _ref.className,
      disabled = _ref.disabled,
      download = _ref.download,
      href = _ref.href,
      _static = _ref["static"],
      _ref$HrefComponent = _ref.HrefComponent,
      HrefComponent = _ref$HrefComponent === void 0 ? href ? _Anchor.Anchor : _static ? 'div' : _Button.Button : _ref$HrefComponent,
      icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var itemProps = _objectSpread(_objectSpread({}, props), {}, {
    disabled: _static ? null : disabled,
    download: _static ? null : download,
    href: _static ? null : href,
    focusable: false,
    onClick: onClick,
    variant: href || _static ? null : 'ghost'
  });

  return /*#__PURE__*/_react["default"].createElement(HrefComponent, (0, _extends2["default"])({
    role: "menuitem"
  }, itemProps, {
    className: "jsx-1792543468" + " " + ((0, _classnames["default"])('menu-item', className, {
      active: active,
      "static": _static
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    El: "span",
    color: disabled ? 'muted' : 'default',
    variant: active ? 'strong' : 'base'
  }, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "jsx-1792543468" + " " + ((0, _classnames["default"])('icon', {
      active: active
    }) || "")
  }, active ? /*#__PURE__*/_react["default"].createElement(_CheckIcon.CheckIcon, {
    size: 16
  }) : icon), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1792543468"
  }, [".icon.jsx-1792543468{-webkit-flex:none;-ms-flex:none;flex:none;margin-left:16px;}"]));
};

exports.MenuItem = MenuItem;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2104:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Menu", ({
  enumerable: true,
  get: function get() {
    return _Menu.Menu;
  }
}));
Object.defineProperty(exports, "MenuButton", ({
  enumerable: true,
  get: function get() {
    return _MenuButton.MenuButton;
  }
}));

var _Menu = __webpack_require__(1851);

var _MenuButton = __webpack_require__(447);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTWVudS9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBNZW51IH0gZnJvbSAnLi9NZW51JztcbmV4cG9ydCB7IE1lbnVCdXR0b24gfSBmcm9tICcuL01lbnVCdXR0b24nO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQSJ9

/***/ }),

/***/ 3852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Modal = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _reactDom = __webpack_require__(8316);

var _Theme = __webpack_require__(1609);

var _useScrollLock = __webpack_require__(3398);

var _Button = __webpack_require__(9757);

var _Card = __webpack_require__(8257);

var _FocusTrap = __webpack_require__(3615);

var _CloseIcon = __webpack_require__(7880);

var _LockIcon = __webpack_require__(2805);

var _Stack = __webpack_require__(4776);

var _Text = __webpack_require__(5645);

var _VisuallyHidden = __webpack_require__(812);

var _excluded = ["actions", "children", "closeText", "hideOnBackdropClick", "hideOnEsc", "locked", "onClose", "position", "title", "variant"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var transitionMs = 200;

var Modal = function Modal(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      children = _ref.children,
      _ref$closeText = _ref.closeText,
      closeText = _ref$closeText === void 0 ? 'Close' : _ref$closeText,
      _ref$hideOnBackdropCl = _ref.hideOnBackdropClick,
      hideOnBackdropClick = _ref$hideOnBackdropCl === void 0 ? true : _ref$hideOnBackdropCl,
      _ref$hideOnEsc = _ref.hideOnEsc,
      hideOnEsc = _ref$hideOnEsc === void 0 ? true : _ref$hideOnEsc,
      _ref$locked = _ref.locked,
      locked = _ref$locked === void 0 ? false : _ref$locked,
      onClose = _ref.onClose,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'center' : _ref$position,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      mediaQueries = _useTheme.mediaQueries,
      zIndex = _useTheme.zIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var modalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setIsVisible(true);
  }, []);

  var close = function close() {
    setIsVisible(false);
    setTimeout(function () {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }, transitionMs);
  };

  var handleBackdropClick = function handleBackdropClick(ev) {
    var isBackDropTarget = ev.target === ev.currentTarget;
    var isFocusOutside = !ev.currentTarget.contains(document.activeElement); // close only if backdrop is actually clicked

    if (isBackDropTarget && isFocusOutside && hideOnBackdropClick && !locked) {
      close();
    }
  };

  (0, _useScrollLock.useScrollLock)(true, function () {
    if (hideOnEsc && !locked) close();
  });
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    onClick: handleBackdropClick,
    role: "presentation"
  }, props, {
    className: _style["default"].dynamic([["3755911558", [transitionMs, zIndex.modal, transitionMs, transitionMs, mediaQueries.large]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])('backdrop', {
      isVisible: isVisible
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: modalRef,
    role: "dialog",
    "aria-labelledby": "modal-title",
    "aria-modal": "true",
    className: _style["default"].dynamic([["3755911558", [transitionMs, zIndex.modal, transitionMs, transitionMs, mediaQueries.large]]]) + " " + ((0, _classnames["default"])('modal', position) || "")
  }, /*#__PURE__*/_react["default"].createElement(_FocusTrap.FocusTrap, null, /*#__PURE__*/_react["default"].createElement(_Card.Card, {
    noBorder: true,
    shadow: "strong"
  }, title && /*#__PURE__*/_react["default"].createElement(_Card.CardHeader, null, /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    align: "center",
    justify: "space-between",
    horizontal: true
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    id: "modal-title",
    variant: "largestrong"
  }, title), variant === 'secure' && /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    gap: 4,
    horizontal: true
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "muted"
  }, "Secure"), /*#__PURE__*/_react["default"].createElement(_LockIcon.LockIcon, {
    color: "var(--text-muted)",
    size: 16
  })), variant === 'closable' && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: close,
    variant: "ghost"
  }, /*#__PURE__*/_react["default"].createElement(_CloseIcon.CloseIcon, null), /*#__PURE__*/_react["default"].createElement(_VisuallyHidden.VisuallyHidden, null, closeText)))), /*#__PURE__*/_react["default"].createElement(_Card.CardContent, null, children), actions.length > 0 && /*#__PURE__*/_react["default"].createElement(_Card.CardContent, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["3755911558", [transitionMs, zIndex.modal, transitionMs, transitionMs, mediaQueries.large]]]) + " " + "modal-actions"
  }, _react.Children.map(actions, function (child) {
    var _child$props;

    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      disabled: ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.disabled) || locked,
      onClick: function onClick() {
        var _child$props2;

        if ((_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.onClick) {
          var _child$props3, _child$props3$onClick;

          (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : (_child$props3$onClick = _child$props3.onClick) === null || _child$props3$onClick === void 0 ? void 0 : _child$props3$onClick.call(_child$props3, close);
        } else {
          close();
        }
      }
    });
  })))))), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3755911558",
    dynamic: [transitionMs, zIndex.modal, transitionMs, transitionMs, mediaQueries.large]
  }, [".backdrop.__jsx-style-dynamic-selector{background-color:var(--backdrop-hidden);bottom:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;left:0;overflow-y:auto;padding:40px 0;position:fixed;right:0;top:0;-webkit-transition:background ".concat(transitionMs, "ms ease;transition:background ").concat(transitionMs, "ms ease;z-index:").concat(zIndex.modal, ";}"), ".backdrop.__jsx-style-dynamic-selector .modal.__jsx-style-dynamic-selector{max-width:568px;opacity:0;-webkit-transform:scale(0.95);-ms-transform:scale(0.95);transform:scale(0.95);-webkit-transition:opacity ".concat(transitionMs, "ms ease, -webkit-transform ").concat(transitionMs, "ms ease;-webkit-transition:opacity ").concat(transitionMs, "ms ease, transform ").concat(transitionMs, "ms ease;transition:opacity ").concat(transitionMs, "ms ease, transform ").concat(transitionMs, "ms ease;width:90vw;}"), ".backdrop.__jsx-style-dynamic-selector .modal.center.__jsx-style-dynamic-selector{margin:auto;}", ".backdrop.__jsx-style-dynamic-selector .modal.top.__jsx-style-dynamic-selector{margin:0px auto auto;}", ".isVisible.__jsx-style-dynamic-selector{background-color:var(--backdrop);}", ".isVisible.__jsx-style-dynamic-selector .modal.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}", ".modal-actions.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;}", "@media ".concat(mediaQueries.large, "{.backdrop.__jsx-style-dynamic-selector{padding:80px 0;}}")])), document.body);
};

exports.Modal = Modal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5964:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "u", ({
  enumerable: true,
  get: function get() {
    return _Modal.Modal;
  }
}));

var _Modal = __webpack_require__(3852);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTW9kYWwvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgTW9kYWwgfSBmcm9tICcuL01vZGFsJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 608:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Popover = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _useAbsolutePosition2 = __webpack_require__(1200);

var _useClosable = __webpack_require__(8273);

var _useResize = __webpack_require__(4605);

var _Card = __webpack_require__(8257);

var _FocusTrap = __webpack_require__(3615);

var _Portal = __webpack_require__(5970);

var _excluded = ["aria-labelledby", "align", "cardProps", "children", "className", "edgeSpacing", "focusTrapProps", "offsetLeft", "offsetTop", "onClose", "placement", "position", "style", "transitionMs"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MIN_HEIGHT = 80;

var Popover = function Popover(_ref) {
  var _containerRef$current2, _focusTrapProps$arrow, _cardProps$style;

  var ariaLabelledBy = _ref['aria-labelledby'],
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$cardProps = _ref.cardProps,
      cardProps = _ref$cardProps === void 0 ? {} : _ref$cardProps,
      children = _ref.children,
      className = _ref.className,
      _ref$edgeSpacing = _ref.edgeSpacing,
      edgeSpacing = _ref$edgeSpacing === void 0 ? 0 : _ref$edgeSpacing,
      _ref$focusTrapProps = _ref.focusTrapProps,
      focusTrapProps = _ref$focusTrapProps === void 0 ? {} : _ref$focusTrapProps,
      _ref$offsetLeft = _ref.offsetLeft,
      offsetLeft = _ref$offsetLeft === void 0 ? 0 : _ref$offsetLeft,
      _ref$offsetTop = _ref.offsetTop,
      offsetTop = _ref$offsetTop === void 0 ? 8 : _ref$offsetTop,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? null : _ref$onClose,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$position = _ref.position,
      stylePosition = _ref$position === void 0 ? 'absolute' : _ref$position,
      style = _ref.style,
      _ref$transitionMs = _ref.transitionMs,
      transitionMs = _ref$transitionMs === void 0 ? 200 : _ref$transitionMs,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      zIndex = _useTheme.zIndex;

  var containerRef = (0, _react.useRef)(null);
  var triggerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeFocusTrap = _useState2[0],
      setActiveFocusTrap = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];
  /**
   * maxHeight to avoid Popover overlapping window edges
   */


  var _useState5 = (0, _react.useState)('100vh'),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      maxHeight = _useState6[0],
      setMaxHeight = _useState6[1];
  /**
   * Re-calculating maxHeight on resize prevents the Popover from overflowing.
   */


  (0, _useResize.useResize)((0, _react.useCallback)(function () {
    if (!triggerRef.current) return;

    var _triggerRef$current$g = triggerRef.current.getBoundingClientRect(),
        bottom = _triggerRef$current$g.bottom,
        top = _triggerRef$current$g.top;

    switch (placement) {
      case 'bottom':
        setMaxHeight(Math.max(MIN_HEIGHT, window.innerHeight - bottom - offsetTop - edgeSpacing));
        break;

      case 'top':
        setMaxHeight(Math.max(MIN_HEIGHT, top - offsetTop - edgeSpacing));
        break;
    }
  }, [edgeSpacing, offsetTop, placement]));

  var _useAbsolutePosition = (0, _useAbsolutePosition2.useAbsolutePosition)({
    align: align,
    containerRef: containerRef,
    placement: placement,
    offsetLeft: offsetLeft,
    offsetTop: offsetTop,
    ref: triggerRef,
    position: stylePosition
  }),
      reposition = _useAbsolutePosition.reposition,
      position = _useAbsolutePosition.style;

  var close = (0, _react.useCallback)(function () {
    setVisible(false);
    setTimeout(function () {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }, transitionMs);
  }, [onClose, transitionMs]);
  (0, _useClosable.useClosable)({
    ref: containerRef,
    onClose: close
  }, [visible]);
  (0, _react.useEffect)(function () {
    reposition();
  }, [ariaLabelledBy, reposition, maxHeight]);
  (0, _react.useLayoutEffect)(function () {
    // Avoid displaying Menu while trigger is clicked, to prevent closing it immediately
    var visibleTimeout = setTimeout(function () {
      setVisible(true);
    }, 50);
    return function () {
      clearTimeout(visibleTimeout);
    };
  }, []); // Set useAbsolutePosition triggerRef

  (0, _react.useLayoutEffect)(function () {
    triggerRef.current = document.getElementById(ariaLabelledBy);
  }, [ariaLabelledBy]); // Activate FocusTrap when popover is open

  (0, _react.useEffect)(function () {
    var _containerRef$current;

    var styleTop = parseFloat((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.style.top);
    var top = position === null || position === void 0 ? void 0 : position.top;
    var isActive = Math.abs(top - styleTop) < 0.1;
    setActiveFocusTrap(isActive);
  }, [(_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.style, position]);
  return /*#__PURE__*/_react["default"].createElement(_Portal.Portal, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: containerRef,
    style: _objectSpread(_objectSpread(_objectSpread({}, position), style), {}, {
      maxHeight: maxHeight
    })
  }, props, {
    className: _style["default"].dynamic([["2044965394", [transitionMs, zIndex.menu]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])('popover', className, {
      visible: visible
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_FocusTrap.FocusTrap, (0, _extends2["default"])({}, focusTrapProps, {
    active: activeFocusTrap,
    arrowKeys: (_focusTrapProps$arrow = focusTrapProps === null || focusTrapProps === void 0 ? void 0 : focusTrapProps.arrowKeys) !== null && _focusTrapProps$arrow !== void 0 ? _focusTrapProps$arrow : 'all'
  }), /*#__PURE__*/_react["default"].createElement(_Card.Card, (0, _extends2["default"])({}, cardProps, {
    noBorder: true,
    shadow: "strong",
    style: _objectSpread(_objectSpread({}, (_cardProps$style = cardProps.style) !== null && _cardProps$style !== void 0 ? _cardProps$style : {}), {}, {
      maxHeight: maxHeight,
      overflow: 'auto'
    })
  }), children)), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2044965394",
    dynamic: [transitionMs, zIndex.menu]
  }, [".popover.__jsx-style-dynamic-selector{left:-99em;opacity:0;position:absolute;top:-99em;-webkit-transition:opacity ".concat(transitionMs, "ms ease;transition:opacity ").concat(transitionMs, "ms ease;z-index:").concat(zIndex.menu, ";}"), ".popover.visible.__jsx-style-dynamic-selector{opacity:1;}"])));
};

exports.Popover = Popover;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 2060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Popover", ({
  enumerable: true,
  get: function get() {
    return _Popover.Popover;
  }
}));

var _Popover = __webpack_require__(608);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUG9wb3Zlci9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBQb3BvdmVyIH0gZnJvbSAnLi9Qb3BvdmVyJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Portal = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = __webpack_require__(7294);

var _reactDom = _interopRequireDefault(__webpack_require__(8316));

var _excluded = ["children", "el"];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$el = _ref.el,
      el = _ref$el === void 0 ? 'div' : _ref$el,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var portal = (0, _react.useRef)(canUseDOM ? document.createElement(el) : null);
  (0, _react.useEffect)(function () {
    if (!portal.current) return; // assigning all the HTMLElement properties to the element

    var portalEl = Object.assign(portal.current, rest);
    document.body.appendChild(portalEl);
    return function () {
      document.body.removeChild(portalEl);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return canUseDOM ? /*#__PURE__*/_reactDom["default"].createPortal(children, portal.current) : null;
};

exports.Portal = Portal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Portal", ({
  enumerable: true,
  get: function get() {
    return _Portal.Portal;
  }
}));

var _Portal = __webpack_require__(898);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUG9ydGFsL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFBvcnRhbCB9IGZyb20gJy4vUG9ydGFsJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 8894:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Radio = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _excluded = ["checked", "id", "label"];

var Radio = function Radio(_ref) {
  var checked = _ref.checked,
      id = _ref.id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      fontFamilies = _useTheme.fontFamilies;

  var isControlled = typeof checked === 'boolean';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["1120102028", [label ? '24px' : '16px', fontFamilies.medium]]])
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    checked: checked,
    id: id,
    type: "radio"
  }, props, {
    className: _style["default"].dynamic([["1120102028", [label ? '24px' : '16px', fontFamilies.medium]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])({
      isControlled: isControlled,
      checked: checked
    }) || "")
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: _style["default"].dynamic([["1120102028", [label ? '24px' : '16px', fontFamilies.medium]]])
  }, label), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1120102028",
    dynamic: [label ? '24px' : '16px', fontFamilies.medium]
  }, ["div.__jsx-style-dynamic-selector{position:relative;}", "input.__jsx-style-dynamic-selector{margin:0;opacity:0;position:absolute;}", "label.__jsx-style-dynamic-selector{cursor:pointer;display:inline-block;padding-left:".concat(label ? '24px' : '16px', ";-webkit-tap-highlight-color:rgba(0,0,0,0);}"), "label.__jsx-style-dynamic-selector::before{border:1px solid var(--radio-border);border-radius:100%;box-shadow:0 0 0 0 var(--focus-shadow);content:'';height:16px;left:0;position:absolute;top:1px;-webkit-transition:border 200ms ease,box-shadow 200ms ease;transition:border 200ms ease,box-shadow 200ms ease;width:16px;}", "label.__jsx-style-dynamic-selector::after{background-color:var(--radio-checked);border-radius:100%;content:'';height:8px;left:4px;opacity:0;position:absolute;top:5px;-webkit-transition:opacity 200ms ease;transition:opacity 200ms ease;width:8px;}", ".isControlled.checked.__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector,input.__jsx-style-dynamic-selector:not(.isControlled):checked+label.__jsx-style-dynamic-selector{font-family:".concat(fontFamilies.medium, ";font-weight:normal;}"), ".isControlled.checked.__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector::after,input.__jsx-style-dynamic-selector:not(.isControlled):checked+label.__jsx-style-dynamic-selector::after{opacity:1;}", "input.__jsx-style-dynamic-selector:not([disabled])+label.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector::before,div.__jsx-style-dynamic-selector:focus-within label.__jsx-style-dynamic-selector::before{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);}", "input[disabled].__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector{color:var(--text-muted);cursor:default;}", "input[disabled].__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector::before{opacity:0.6;}", ".isControlled.checked[disabled].__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector::after,input.__jsx-style-dynamic-selector:not(.isControlled):checked[disabled]+label.__jsx-style-dynamic-selector::after{opacity:0.6;}"]));
};

exports.Radio = Radio;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Radio", ({
  enumerable: true,
  get: function get() {
    return _Radio.Radio;
  }
}));

var _Radio = __webpack_require__(8894);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUmFkaW8vaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgUmFkaW8gfSBmcm9tICcuL1JhZGlvJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 7430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Caret = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _CaretDownIcon = __webpack_require__(97);

var Caret = function Caret(_ref) {
  var disabled = _ref.disabled;

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors;

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "jsx-2075650144"
  }, /*#__PURE__*/_react["default"].createElement(_CaretDownIcon.CaretDownIcon, {
    color: disabled ? colors.supportiveText : 'currentColor',
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2075650144"
  }, ["span.jsx-2075650144{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;pointer-events:none;position:absolute;right:8px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}"]));
};

exports.Caret = Caret;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJldCIsImRpc2FibGVkIiwidXNlVGhlbWUiLCJjb2xvcnMiLCJzdXBwb3J0aXZlVGV4dCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9DYXJldC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgdXNlVGhlbWUgfSBmcm9tICcuLi8uLi9jb250ZXh0cy9UaGVtZSc7XG5pbXBvcnQgeyBDYXJldERvd25JY29uIH0gZnJvbSAnLi4vSWNvbnMvQ2FyZXREb3duSWNvbic7XG5cbmludGVyZmFjZSBQcm9wcyB7XG4gIGRpc2FibGVkPzogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IENhcmV0OiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgZGlzYWJsZWQsXG59KSA9PiB7XG4gIGNvbnN0IHsgY29sb3JzIH0gPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPHNwYW4+XG4gICAgICA8Q2FyZXREb3duSWNvblxuICAgICAgICBjb2xvcj17ZGlzYWJsZWQgPyBjb2xvcnMuc3VwcG9ydGl2ZVRleHQgOiAnY3VycmVudENvbG9yJ31cbiAgICAgICAgc2l6ZT17MTZ9XG4gICAgICAvPlxuICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICBzcGFuIHtcbiAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgcmlnaHQ6IDhweDtcbiAgICAgICAgICB0b3A6IDUwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgIH1cbiAgICAgIGB9PC9zdHlsZT5cbiAgICA8L3NwYW4+XG4gICk7XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUNBOztBQU1PLElBQU1BLEtBQStDLEdBQUcsU0FBbERBLEtBQWtELE9BRXpEO0VBQUEsSUFESkMsUUFDSSxRQURKQSxRQUNJOztFQUNKLGdCQUFtQixJQUFBQyxlQUFBLEdBQW5CO0VBQUEsSUFBUUMsTUFBUixhQUFRQSxNQUFSOztFQUVBLG9CQUNFO0lBQUE7RUFBQSxnQkFDRSxnQ0FBQyw0QkFBRDtJQUNFLEtBQUssRUFBRUYsUUFBUSxHQUFHRSxNQUFNLENBQUNDLGNBQVYsR0FBMkIsY0FENUM7SUFFRSxJQUFJLEVBQUU7RUFGUixFQURGO0lBQUE7RUFBQSx5UkFERjtBQWtCRCxDQXZCTSJ9

/***/ }),

/***/ 6328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CustomSelect = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _useAbsolutePosition2 = __webpack_require__(1200);

var _useClosable = __webpack_require__(8273);

var _Button = __webpack_require__(9757);

var _Card = __webpack_require__(8257);

var _Checkbox = __webpack_require__(8889);

var _FocusTrap = __webpack_require__(3615);

var _Portal = __webpack_require__(5970);

var _Radio = __webpack_require__(9153);

var _Stack = __webpack_require__(4776);

var _Text = __webpack_require__(5645);

var _Caret = __webpack_require__(7430);

var _excluded = ["alignMenu", "disabled", "id", "label", "multiple", "name", "onChange", "options"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CustomSelect = function CustomSelect(_ref) {
  var _optionsRef$current;

  var _ref$alignMenu = _ref.alignMenu,
      alignMenu = _ref$alignMenu === void 0 ? 'left' : _ref$alignMenu,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      multiple = _ref.multiple,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      zIndex = _useTheme.zIndex;

  var ref = (0, _react.useRef)(null);
  var optionsRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(options),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      changedOptions = _useState4[0],
      setChangedOptions = _useState4[1];

  var _useAbsolutePosition = (0, _useAbsolutePosition2.useAbsolutePosition)({
    align: alignMenu,
    containerRef: optionsRef,
    offsetTop: 4,
    ref: ref
  }),
      reposition = _useAbsolutePosition.reposition,
      position = _useAbsolutePosition.style;

  var availableOptions = options.filter(function (o) {
    return !o.disabled;
  });
  var selectedOptions = options.filter(function (o) {
    return o.selected;
  });
  var allSelected = multiple && selectedOptions.length === options.length && availableOptions.length > 0;
  var noneSelected = selectedOptions.length === 0;

  var close = function close() {
    setIsOpen(false);
  };

  (0, _react.useEffect)(function () {
    if (!isOpen) {
      setChangedOptions(options);
    }

    if (isOpen) {
      reposition();
    }
  }, [isOpen, options, reposition]);

  var handleSelectionClick = function handleSelectionClick() {
    if (disabled) return;
    setIsOpen(true);
  };

  var hasChanged = (0, _react.useMemo)(function () {
    return changedOptions.some(function (co, i) {
      var _options$i;

      return (co === null || co === void 0 ? void 0 : co.selected) !== ((_options$i = options[i]) === null || _options$i === void 0 ? void 0 : _options$i.selected);
    });
  }, [changedOptions, options]);

  var handleOptionChange = function handleOptionChange(ev) {
    var _ev$target = ev.target,
        checked = _ev$target.checked,
        value = _ev$target.value;
    setChangedOptions(function (co) {
      return co.map(function (o) {
        return o.value === value ? _objectSpread(_objectSpread({}, o), {}, {
          selected: checked
        }) : multiple ? o : _objectSpread(_objectSpread({}, o), {}, {
          selected: false
        });
      });
    });
  };

  var handleClearClick = function handleClearClick() {
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
    close();
  };

  var handleApplyClick = function handleApplyClick() {
    onChange === null || onChange === void 0 ? void 0 : onChange(multiple ? changedOptions.filter(function (co) {
      return co.selected && !co.disabled;
    }).map(function (co) {
      return co.value;
    }) : changedOptions.find(function (co) {
      return co.selected;
    }).value);
    close();
  };

  (0, _useClosable.useClosable)({
    onClose: close,
    ref: optionsRef
  }, [isOpen]);

  if (!multiple && options.filter(function (o) {
    return o.selected;
  }).length > 1) {
    console.warn("Setting more than 1 selected value on a non-multipe Select is not supported. Check <Select name=\"".concat(name, "\" />"));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: _style["default"].dynamic([["392716582", [zIndex.menu]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])({
      disabled: disabled,
      isOpen: isOpen
    }) || "")
  }), selectedOptions.map(function (s) {
    return /*#__PURE__*/_react["default"].createElement("input", {
      key: "".concat(name, "-val-").concat(s.value),
      type: "hidden",
      name: name,
      value: s.value,
      className: _style["default"].dynamic([["392716582", [zIndex.menu]]])
    });
  }), /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    gap: 4
  }, label && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    El: "label",
    id: "label-".concat(id),
    variant: "strong"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["392716582", [zIndex.menu]]]) + " " + "select"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    ref: ref,
    "aria-controls": "list-".concat(id),
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    id: id,
    onClick: handleSelectionClick,
    tabIndex: disabled ? -1 : props === null || props === void 0 ? void 0 : props.tabIndex,
    type: "button",
    className: _style["default"].dynamic([["392716582", [zIndex.menu]]]) + " " + "selection"
  }, /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    align: "center",
    justify: "start",
    horizontal: true,
    wrap: true
  }, allSelected || noneSelected ? /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: disabled ? 'muted' : 'default'
  }, allSelected && 'All', noneSelected && 'Select…') : selectedOptions.map(function (s) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: s.value,
      className: _style["default"].dynamic([["392716582", [zIndex.menu]]]) + " " + "option"
    }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      color: disabled ? 'muted' : 'default'
    }, (s === null || s === void 0 ? void 0 : s.selectedLabel) || s.label));
  }))), /*#__PURE__*/_react["default"].createElement(_Caret.Caret, {
    disabled: disabled
  }))), isOpen && /*#__PURE__*/_react["default"].createElement(_Portal.Portal, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: optionsRef,
    "aria-labelledby": "label-".concat(id),
    "aria-multiselectable": multiple,
    id: "list-".concat(id),
    role: "listbox",
    style: position,
    className: _style["default"].dynamic([["392716582", [zIndex.menu]]]) + " " + ((0, _classnames["default"])('options', {
      isOpen: isOpen
    }) || "")
  }, /*#__PURE__*/_react["default"].createElement(_FocusTrap.FocusTrap, {
    arrowKeys: "updown",
    searchByCharacter: true // only focus first element, when options element is positioned
    // to avoid undesired scrolling
    ,
    active: ((_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 ? void 0 : _optionsRef$current.style.top) === "".concat(position === null || position === void 0 ? void 0 : position.top, "px")
  }, /*#__PURE__*/_react["default"].createElement(_Card.Card, {
    style: {
      background: 'var(--menu-bg)'
    },
    noBorder: true,
    shadow: "strong"
  }, /*#__PURE__*/_react["default"].createElement(_Card.CardList, null, options.map(function (o, i) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      "aria-disabled": o.disabled,
      key: name + o.value,
      htmlFor: name + o.value,
      className: _style["default"].dynamic([["392716582", [zIndex.menu]]])
    }, /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
      align: "center",
      justify: "space-between",
      horizontal: true
    }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      color: o.disabled ? 'muted' : 'default',
      El: "span"
    }, o.label), multiple ? /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
      "aria-disabled": o.disabled,
      "aria-selected": changedOptions[i].selected,
      checked: changedOptions[i].selected,
      disabled: o.disabled,
      id: name + o.value,
      label: "",
      name: name,
      onChange: handleOptionChange,
      role: "option",
      value: o.value
    }) : /*#__PURE__*/_react["default"].createElement(_Radio.Radio, {
      "aria-disabled": o.disabled,
      "aria-selected": changedOptions[i].selected,
      checked: changedOptions[i].selected,
      disabled: o.disabled,
      id: name + o.value,
      label: "",
      name: name,
      onChange: handleOptionChange,
      role: "option",
      value: o.value
    })));
  })), /*#__PURE__*/_react["default"].createElement(_Card.CardContent, {
    style: {
      padding: '8px 16px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    align: "center",
    justify: multiple ? 'space-between' : 'end',
    horizontal: true
  }, multiple && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: changedOptions.every(function (co) {
      return !co.selected;
    }),
    onClick: handleClearClick,
    variant: "ghost"
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    El: "span",
    style: {
      opacity: changedOptions.every(function (co) {
        return !co.selected;
      }) ? 0 : 1
    },
    underline: true
  }, "Clear")), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: !hasChanged,
    onClick: handleApplyClick,
    size: "small"
  }, "Apply"))))))), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "392716582",
    dynamic: [zIndex.menu]
  }, [".selection.__jsx-style-dynamic-selector{background:var(--input-bg);border:1px solid var(--input-border);border-radius:8px;box-shadow:0 0 0 0 var(--focus-shadow);cursor:pointer;display:block;padding:6px 7px 7px;position:relative;-webkit-transition:border 200ms ease,box-shadow 200ms ease;transition:border 200ms ease,box-shadow 200ms ease;width:100%;}", ".select.__jsx-style-dynamic-selector{position:relative;}", ".disabled.__jsx-style-dynamic-selector .selection.__jsx-style-dynamic-selector{background:var(--input-disabled-bg);box-shadow:none !important;color:var(--input-disabled-color);cursor:default;}", ".selection.__jsx-style-dynamic-selector:focus{outline:none;}", ".isOpen.__jsx-style-dynamic-selector .selection.__jsx-style-dynamic-selector,.selection.__jsx-style-dynamic-selector:focus,.selection.__jsx-style-dynamic-selector:hover{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);}", ".selection.__jsx-style-dynamic-selector .option.__jsx-style-dynamic-selector{display:inline-block;white-space:nowrap;}", ".options.__jsx-style-dynamic-selector{min-width:176px;opacity:0;-webkit-transition:opacity 200ms ease;transition:opacity 200ms ease;}", ".options.__jsx-style-dynamic-selector{left:-99em;top:-99em;}", ".options.isOpen.__jsx-style-dynamic-selector{opacity:1;z-index:".concat(zIndex.menu, ";}"), ".options.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector{display:block;}", ".options.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector:not([aria-disabled='true']){cursor:pointer;}", ".options.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector:focus{outline:none;}", ".options.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector:focus-within,.options.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector:not([aria-disabled='true']):hover{background-color:var(--menu-item-hover-bg);}", ".options.__jsx-style-dynamic-selector label[aria-disabled='true'].__jsx-style-dynamic-selector{opacity:0.4;}"]));
};

exports.CustomSelect = CustomSelect;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NativeSelect = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _pxToRem = __webpack_require__(7227);

var _Stack = __webpack_require__(4776);

var _Text = __webpack_require__(5645);

var _Caret = __webpack_require__(7430);

var _excluded = ["disabled", "id", "label", "multiple", "onChange", "options"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NativeSelect = function NativeSelect(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      onChange = _ref.onChange,
      options = _ref.options,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      fontFamilies = _useTheme.fontFamilies,
      fontSizes = _useTheme.fontSizes,
      lineHeights = _useTheme.lineHeights;

  var selectRef = (0, _react.useRef)(null);

  var handleChange = function handleChange(ev) {
    var values = Array.from(ev.currentTarget.selectedOptions).map(function (o) {
      return o.value;
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(multiple ? values : values[0]);
  };

  var selectedValue = (0, _react.useMemo)(function () {
    var _options$find;

    return ((_options$find = options.find(function (o) {
      return o.selected;
    })) === null || _options$find === void 0 ? void 0 : _options$find.value) || null;
  }, [options]); // Update DOM when selected option changes.

  (0, _react.useEffect)(function () {
    var selectEl = selectRef.current;
    if (!selectEl || !selectedValue) return;
    selectEl.value = selectedValue;
  }, [selectedValue]);
  return /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    gap: 4
  }, label && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    El: "label",
    htmlFor: id,
    id: "label-".concat(id),
    variant: "strong"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["1562907547", [fontFamilies.regular, fontSizes.base, lineHeights.base, fontSizes.base, (0, _pxToRem.pxToRem)(16)]]]) + " " + "select"
  }, /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    ref: selectRef,
    defaultValue: 'value' in props ? undefined : selectedValue,
    disabled: disabled,
    id: id,
    multiple: multiple,
    onChange: handleChange
  }, props, {
    className: _style["default"].dynamic([["1562907547", [fontFamilies.regular, fontSizes.base, lineHeights.base, fontSizes.base, (0, _pxToRem.pxToRem)(16)]]]) + " " + (props && props.className != null && props.className || "")
  }), options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: o.value,
      value: o.value,
      className: _style["default"].dynamic([["1562907547", [fontFamilies.regular, fontSizes.base, lineHeights.base, fontSizes.base, (0, _pxToRem.pxToRem)(16)]]])
    }, o.label);
  })), !multiple && /*#__PURE__*/_react["default"].createElement(_Caret.Caret, {
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1562907547",
    dynamic: [fontFamilies.regular, fontSizes.base, lineHeights.base, fontSizes.base, (0, _pxToRem.pxToRem)(16)]
  }, ["select.__jsx-style-dynamic-selector{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:var(--input-bg);border:1px solid var(--input-border);border-radius:8px;box-shadow:0 0 0 0 var(--focus-shadow);color:var(--input-color);display:block;font-family:".concat(fontFamilies.regular, ";font-size:").concat(fontSizes.base, ";line-height:").concat(lineHeights.base, ";padding:6px 28px 7px 7px;position:relative;-webkit-transition:border 200ms ease,box-shadow 200ms ease;transition:border 200ms ease,box-shadow 200ms ease;width:100%;}"), "select.__jsx-style-dynamic-selector:focus,select.__jsx-style-dynamic-selector:hover{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);outline:none;}", "select[disabled].__jsx-style-dynamic-selector{background:var(--input-disabled-bg);box-shadow:none !important;color:var(--input-disabled-color);cursor:default;}", "option.__jsx-style-dynamic-selector{font-size:".concat(fontSizes.base, ";}"), ".select.__jsx-style-dynamic-selector{position:relative;}", "@supports (-webkit-touch-callout:none){select.__jsx-style-dynamic-selector{font-size:".concat((0, _pxToRem.pxToRem)(16), ";}}")]));
};

exports.NativeSelect = NativeSelect;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Select = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _CustomSelect = __webpack_require__(6328);

var _NativeSelect = __webpack_require__(6214);

var _excluded = ["native"];

var Select = function Select(_ref) {
  var _ref$native = _ref["native"],
      _native = _ref$native === void 0 ? false : _ref$native,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  return _native ? /*#__PURE__*/_react["default"].createElement(_NativeSelect.NativeSelect, props) : /*#__PURE__*/_react["default"].createElement(_CustomSelect.CustomSelect, props);
};

exports.Select = Select;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTZWxlY3QiLCJuYXRpdmUiLCJwcm9wcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9TZWxlY3QudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IEN1c3RvbVNlbGVjdCB9IGZyb20gJy4vQ3VzdG9tU2VsZWN0JztcbmltcG9ydCB7IE5hdGl2ZVNlbGVjdCB9IGZyb20gJy4vTmF0aXZlU2VsZWN0JztcblxudHlwZSBOYXRpdmVQcm9wcyA9IFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBOYXRpdmVTZWxlY3Q+O1xudHlwZSBDdXN0b21Qcm9wcyA9IFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBDdXN0b21TZWxlY3Q+O1xudHlwZSBQcm9wcyA9IE5hdGl2ZVByb3BzIHwgQ3VzdG9tUHJvcHM7XG5cbmV4cG9ydCBjb25zdCBTZWxlY3Q6IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBuYXRpdmUgPSBmYWxzZSxcbiAgLi4ucHJvcHNcbn0pID0+XG4gIG5hdGl2ZSA/IChcbiAgICA8TmF0aXZlU2VsZWN0IHsuLi4ocHJvcHMgYXMgTmF0aXZlUHJvcHMpfSAvPlxuICApIDogKFxuICAgIDxDdXN0b21TZWxlY3Qgey4uLihwcm9wcyBhcyBDdXN0b21Qcm9wcyl9IC8+XG4gICk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7Ozs7QUFNTyxJQUFNQSxNQUFnRCxHQUFHLFNBQW5EQSxNQUFtRDtFQUFBO0VBQUEsSUFDOURDLE9BRDhELDRCQUNyRCxLQURxRDtFQUFBLElBRTNEQyxLQUYyRDs7RUFBQSxPQUk5REQsT0FBTSxnQkFDSixnQ0FBQywwQkFBRCxFQUFtQkMsS0FBbkIsQ0FESSxnQkFHSixnQ0FBQywwQkFBRCxFQUFtQkEsS0FBbkIsQ0FQNEQ7QUFBQSxDQUF6RCJ9

/***/ }),

/***/ 6296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "P", ({
  enumerable: true,
  get: function get() {
    return _Select.Select;
  }
}));

var _Select = __webpack_require__(9877);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VsZWN0L2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFNlbGVjdCB9IGZyb20gJy4vU2VsZWN0JztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 5191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Snackbar = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _Stack = __webpack_require__(4776);

var _Text = __webpack_require__(5645);

var _SnackbarIcon = __webpack_require__(3345);

var _excluded = ["children", "className", "icon", "id", "onHide", "timeout", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HIDE_TIME = 250;

var Snackbar = function Snackbar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      id = _ref.id,
      onHide = _ref.onHide,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 4000 : _ref$timeout,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'success' : _ref$type,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      zIndex = _useTheme.zIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  (0, _react.useLayoutEffect)(function () {
    setVisible(true);
    var hideTimeout = setTimeout(function () {
      setHidden(true);
    }, timeout);
    return function () {
      clearTimeout(hideTimeout);
    };
  }, [timeout]);

  var handleClick = function handleClick() {
    setHidden(true);
  };

  (0, _react.useLayoutEffect)(function () {
    if (!hidden) return;
    var hideTimeout = setTimeout(function () {
      onHide();
    }, HIDE_TIME);
    return function () {
      clearTimeout(hideTimeout);
    };
  }, [hidden, onHide]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    onClick: handleClick
  }, props, {
    className: _style["default"].dynamic([["3245147525", [HIDE_TIME, HIDE_TIME, zIndex.snackbar]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])('snackbar', className, type, {
      visible: visible && !hidden
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_Stack.Stack, {
    align: "center",
    gap: 4,
    horizontal: true
  }, /*#__PURE__*/_react["default"].createElement(_SnackbarIcon.SnackbarIcon, {
    type: type,
    icon: icon
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    className: "text",
    color: "inherit"
  }, children)), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3245147525",
    dynamic: [HIDE_TIME, HIDE_TIME, zIndex.snackbar]
  }, [".snackbar{border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.2);cursor:pointer;opacity:0;padding:8px 16px;-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;-webkit-transform:scale(0.95);-ms-transform:scale(0.95);transform:scale(0.95);-webkit-transition:opacity ".concat(HIDE_TIME, "ms ease,-webkit-transform ").concat(HIDE_TIME, "ms ease;-webkit-transition:opacity ").concat(HIDE_TIME, "ms ease,transform ").concat(HIDE_TIME, "ms ease;transition:opacity ").concat(HIDE_TIME, "ms ease,transform ").concat(HIDE_TIME, "ms ease;z-index:").concat(zIndex.snackbar, ";}"), ".snackbar.visible{opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}", ".snackbar.success{background-color:var(--snackbar-success-bg);color:var(--snackbar-success-color);}", ".snackbar.error{background-color:var(--snackbar-error-bg);color:var(--snackbar-error-color);}", ".snackbar.info{background-color:var(--snackbar-info-bg);color:var(--snackbar-info-color);}", ".snackbar .text{padding-bottom:2px;}"]));
};

exports.Snackbar = Snackbar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SnackbarIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _CheckIcon = __webpack_require__(7886);

var _WarningIcon = __webpack_require__(8262);

var SnackbarIcon = function SnackbarIcon(_ref) {
  var icon = _ref.icon,
      type = _ref.type;
  if (icon) return /*#__PURE__*/_react["default"].cloneElement(icon, {
    color: "var(--snackbar-".concat(type, "-color)")
  });

  if (type === 'error') {
    return /*#__PURE__*/_react["default"].createElement(_WarningIcon.WarningIcon, {
      color: "var(--snackbar-error-color)",
      size: 16
    });
  }

  if (type === 'success') {
    return /*#__PURE__*/_react["default"].createElement(_CheckIcon.CheckIcon, {
      color: "var(--snackbar-success-color)",
      size: 16
    });
  }
};

exports.SnackbarIcon = SnackbarIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTbmFja2Jhckljb24iLCJpY29uIiwidHlwZSIsIlJlYWN0IiwiY2xvbmVFbGVtZW50IiwiY29sb3IiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbmFja2Jhci9TbmFja2Jhckljb24udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENoZWNrSWNvbiB9IGZyb20gJy4uL0ljb25zL0NoZWNrSWNvbic7XG5pbXBvcnQgeyBXYXJuaW5nSWNvbiB9IGZyb20gJy4uL0ljb25zL1dhcm5pbmdJY29uJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgaWNvbj86IEpTWC5FbGVtZW50O1xuICB0eXBlOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjb25zdCBTbmFja2Jhckljb246IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBpY29uLFxuICB0eXBlLFxufSkgPT4ge1xuICBpZiAoaWNvbilcbiAgICByZXR1cm4gUmVhY3QuY2xvbmVFbGVtZW50KGljb24sIHtcbiAgICAgIGNvbG9yOiBgdmFyKC0tc25hY2tiYXItJHt0eXBlfS1jb2xvcilgLFxuICAgIH0pO1xuXG4gIGlmICh0eXBlID09PSAnZXJyb3InKSB7XG4gICAgcmV0dXJuIDxXYXJuaW5nSWNvbiBjb2xvcj1cInZhcigtLXNuYWNrYmFyLWVycm9yLWNvbG9yKVwiIHNpemU9ezE2fSAvPjtcbiAgfVxuICBpZiAodHlwZSA9PT0gJ3N1Y2Nlc3MnKSB7XG4gICAgcmV0dXJuIDxDaGVja0ljb24gY29sb3I9XCJ2YXIoLS1zbmFja2Jhci1zdWNjZXNzLWNvbG9yKVwiIHNpemU9ezE2fSAvPjtcbiAgfVxufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7O0FBT08sSUFBTUEsWUFBc0QsR0FBRyxTQUF6REEsWUFBeUQsT0FHaEU7RUFBQSxJQUZKQyxJQUVJLFFBRkpBLElBRUk7RUFBQSxJQURKQyxJQUNJLFFBREpBLElBQ0k7RUFDSixJQUFJRCxJQUFKLEVBQ0Usb0JBQU9FLGlCQUFBLENBQU1DLFlBQU4sQ0FBbUJILElBQW5CLEVBQXlCO0lBQzlCSSxLQUFLLDJCQUFvQkgsSUFBcEI7RUFEeUIsQ0FBekIsQ0FBUDs7RUFJRixJQUFJQSxJQUFJLEtBQUssT0FBYixFQUFzQjtJQUNwQixvQkFBTyxnQ0FBQyx3QkFBRDtNQUFhLEtBQUssRUFBQyw2QkFBbkI7TUFBaUQsSUFBSSxFQUFFO0lBQXZELEVBQVA7RUFDRDs7RUFDRCxJQUFJQSxJQUFJLEtBQUssU0FBYixFQUF3QjtJQUN0QixvQkFBTyxnQ0FBQyxvQkFBRDtNQUFXLEtBQUssRUFBQywrQkFBakI7TUFBaUQsSUFBSSxFQUFFO0lBQXZELEVBQVA7RUFDRDtBQUNGLENBZk0ifQ==

/***/ }),

/***/ 3751:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SnackbarPresenter = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Snackbar = __webpack_require__(4017);

var _Snackbar2 = __webpack_require__(5191);

var _excluded = ["horizontalAlign", "reverseMessageOrder"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SnackbarPresenter = function SnackbarPresenter(_ref) {
  var _ref$horizontalAlign = _ref.horizontalAlign,
      horizontalAlign = _ref$horizontalAlign === void 0 ? 'right' : _ref$horizontalAlign,
      _ref$reverseMessageOr = _ref.reverseMessageOrder,
      reverseMessageOrder = _ref$reverseMessageOr === void 0 ? false : _ref$reverseMessageOr,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useSnackbar = (0, _Snackbar.useSnackbar)(),
      messages = _useSnackbar.messages,
      handleHide = _useSnackbar.handleHide;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isClient = _useState2[0],
      setIsClient = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsClient(true);
  }, []);
  if (!messages) return;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "jsx-2876917454" + " " + (props && props.className != null && props.className || (0, _classnames["default"])('snackbar-presenter', {
      'left-aligned': horizontalAlign === 'left',
      'message-order-reversed': reverseMessageOrder
    }) || "")
  }), isClient && messages.map(function (_ref2) {
    var id = _ref2.id,
        message = _ref2.message;
    return /*#__PURE__*/_react["default"].createElement(_Snackbar2.Snackbar, {
      key: id,
      id: id,
      onHide: function onHide() {
        return handleHide(id);
      },
      timeout: message === null || message === void 0 ? void 0 : message.timeout,
      type: message.type,
      icon: message === null || message === void 0 ? void 0 : message.icon
    }, message.content);
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2876917454"
  }, [".snackbar-presenter{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;top:calc(var(--header-height) + 8px);right:8px;left:auto;position:fixed;z-index:999;}", ".left-aligned{left:8px;right:auto;}", ".message-order-reversed{-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;}", ".snackbar-presenter:not(.message-order-reversed) .snackbar + .snackbar{margin-top:8px;}", ".snackbar-presenter.message-order-reversed .snackbar + .snackbar{margin-bottom:8px;}"]));
};

exports.SnackbarPresenter = SnackbarPresenter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 4063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Snackbar.Snackbar;
  }
});
Object.defineProperty(exports, "O9", ({
  enumerable: true,
  get: function get() {
    return _SnackbarPresenter.SnackbarPresenter;
  }
}));

var _Snackbar = __webpack_require__(5191);

var _SnackbarPresenter = __webpack_require__(3751);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU25hY2tiYXIvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgU25hY2tiYXIgfSBmcm9tICcuL1NuYWNrYmFyJztcbmV4cG9ydCB7IFNuYWNrYmFyUHJlc2VudGVyIH0gZnJvbSAnLi9TbmFja2JhclByZXNlbnRlcic7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBIn0=

/***/ }),

/***/ 9896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Tab = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _Button = __webpack_require__(9757);

var _Menu = __webpack_require__(2104);

var _Text = __webpack_require__(5645);

var _Tabs = __webpack_require__(4108);

var _excluded = ["children", "className", "icon", "index", "menuButton", "onClick", "textProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tab = function Tab(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      index = _ref.index,
      _ref$menuButton = _ref.menuButton,
      menuButton = _ref$menuButton === void 0 ? null : _ref$menuButton,
      onClick = _ref.onClick,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? {} : _ref$textProps,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_Tabs.TabsContext),
      activeTab = _useContext.activeTab,
      id = _useContext.id,
      setTab = _useContext.setTab,
      vertical = _useContext.vertical;

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors,
      isDarkMode = _useTheme.isDarkMode;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleClick = function handleClick(ev) {
    onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    setTab(index);
  };

  var isActive = index === activeTab;

  var handlePointerEnter = function handlePointerEnter() {
    return setIsHovered(true);
  };

  var handlePointerLeave = function handlePointerLeave() {
    return setIsHovered(false);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["745967564", [isDarkMode ? colors.system.blue : colors.system.greyLight, colors.accent, colors.accentText]]]) + " " + "tab-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, (0, _extends2["default"])({
    variant: "ghost",
    role: "tab",
    "aria-selected": isActive,
    "aria-controls": "tabpanel-".concat(id, "-").concat(index),
    className: (0, _classnames["default"])('tab', className, {
      'tab-active': isActive,
      'tab-vertical': vertical
    }),
    "data-tab-index": index,
    id: "tab-".concat(id, "-").concat(index),
    onClick: handleClick,
    onPointerEnter: handlePointerEnter,
    onPointerLeave: handlePointerLeave,
    tabIndex: isActive ? 0 : -1
  }, props), icon, /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    color: isActive && vertical ? 'inherit' : isActive || isHovered || vertical ? 'default' : 'muted',
    variant: "strong"
  }, textProps), children)), menuButton && /*#__PURE__*/_react["default"].createElement(_Menu.MenuButton, (0, _extends2["default"])({}, menuButton, {
    focusable: true,
    variant: "ghost"
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "745967564",
    dynamic: [isDarkMode ? colors.system.blue : colors.system.greyLight, colors.accent, colors.accentText]
  }, [".tab-wrapper.__jsx-style-dynamic-selector{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:4px;}", ".tab-wrapper.__jsx-style-dynamic-selector .tab{gap:4px;}", ".tab-wrapper.__jsx-style-dynamic-selector .tab-vertical{padding:8px 16px;width:100%;}", ".tab-wrapper.__jsx-style-dynamic-selector .tab-vertical:focus,.tab-wrapper.__jsx-style-dynamic-selector .tab-vertical:hover{background:".concat(isDarkMode ? colors.system.blue : colors.system.greyLight, ";}"), ".tab-wrapper.__jsx-style-dynamic-selector .tab-vertical:hover{box-shadow:none;}", ".tab-wrapper.__jsx-style-dynamic-selector .tab-vertical.tab-active{background-color:".concat(colors.accent, ";color:").concat(colors.accentText, ";}"), ".tab-wrapper.__jsx-style-dynamic-selector .menuButton{height:16px;}"]));
};

exports.Tab = Tab;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TabList = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(5182));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _tinykeys = _interopRequireDefault(__webpack_require__(7255));

var _useResize = __webpack_require__(4605);

var _useResizeObserver = __webpack_require__(9782);

var _Button = __webpack_require__(9757);

var _CaretLeftIcon = __webpack_require__(3513);

var _CaretRightIcon = __webpack_require__(8029);

var _Tabs = __webpack_require__(4108);

var _excluded = ["children", "className", "gap", "spaceAround", "style"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TabList = function TabList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 16 : _ref$gap,
      _ref$spaceAround = _ref.spaceAround,
      spaceAround = _ref$spaceAround === void 0 ? 0 : _ref$spaceAround,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_Tabs.TabsContext),
      activeTab = _useContext.activeTab,
      id = _useContext.id,
      setTab = _useContext.setTab,
      vertical = _useContext.vertical;

  var tablistRef = (0, _react.useRef)(null);
  var scrollableRef = (0, _react.useRef)(null);
  var indicatorRef = (0, _react.useRef)(null);
  var getTabs = (0, _react.useCallback)(function () {
    return Array.from(document.querySelectorAll("[id^=\"tab-".concat(id, "-\"]")));
  }, [id]);
  /**
   * Setup keyboard controls:
   * - ArrowLeft moves focus to previous tab
   * - ArrowRight moves focus to next tab
   * - Home moves focus to first tab
   * - End moves focus to last tab
   * https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html
   */

  (0, _react.useEffect)(function () {
    if (!tablistRef.current) return;

    var focusPrev = function focusPrev() {
      var tabs = getTabs();
      var currentTabIdx = tabs.findIndex(function (tab) {
        return tab.isEqualNode(document.activeElement);
      });
      var prevTab = currentTabIdx - 1 < 0 ? tabs.length - 1 : currentTabIdx - 1;
      tabs[prevTab].focus();
    };

    var focusNext = function focusNext() {
      var tabs = getTabs();
      var currentTabIdx = tabs.findIndex(function (tab) {
        return tab.isEqualNode(document.activeElement);
      });
      var nextTab = currentTabIdx + 1 >= tabs.length ? 0 : currentTabIdx + 1;
      tabs[nextTab].focus();
    };

    var unsubscribe = (0, _tinykeys["default"])(tablistRef.current, {
      ArrowLeft: function ArrowLeft() {
        if (!tablistRef.current.contains(document.activeElement) || vertical) return;
        focusPrev();
      },
      ArrowRight: function ArrowRight() {
        if (!tablistRef.current.contains(document.activeElement) || vertical) return;
        focusNext();
      },
      ArrowUp: function ArrowUp(ev) {
        if (!tablistRef.current.contains(document.activeElement) || !vertical) return;
        ev.preventDefault();
        focusPrev();
      },
      ArrowDown: function ArrowDown(ev) {
        if (!tablistRef.current.contains(document.activeElement) || !vertical) return;
        ev.preventDefault();
        focusNext();
      },
      End: function End(ev) {
        if (!tablistRef.current.contains(document.activeElement)) return;
        ev.preventDefault();
        var tabs = getTabs();
        tabs[tabs.length - 1].focus();
      },
      Home: function Home(ev) {
        if (!tablistRef.current.contains(document.activeElement)) return;
        ev.preventDefault();
        var tabs = getTabs();
        tabs[0].focus();
      }
    });
    return function () {
      unsubscribe();
    };
  }, [getTabs, vertical]);
  var repositionIndicator = (0, _react.useCallback)(function () {
    if (vertical) return;
    var tabEl = document.getElementById("tab-".concat(id, "-").concat(activeTab));
    if (!tabEl || !indicatorRef.current) return;
    var tabWrapper = tabEl.closest('.tab-wrapper');
    var left = tabWrapper.offsetLeft - spaceAround;
    indicatorRef.current.style.transform = "translateX(".concat(left, "px)");
    indicatorRef.current.style.width = "".concat(tabWrapper.clientWidth, "px");
  }, [activeTab, id, spaceAround, vertical]);
  (0, _react.useEffect)(function () {
    if (vertical) return;
    var timeout;
    var tabEl = document.getElementById("tab-".concat(id, "-").concat(activeTab));
    if (!tabEl) return;
    window.addEventListener('resize', repositionIndicator);

    if ('fonts' in document) {
      // wait for fonts to be loaded, otherwise position is wrong
      document.fonts.ready.then(function () {
        repositionIndicator();
      });
    } else {
      // fallback to simply timeout if fonts API is not supported
      timeout = setTimeout(repositionIndicator, 300);
    }

    return function () {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener('resize', repositionIndicator);
    };
  }, [activeTab, children, id, repositionIndicator, vertical]);
  (0, _react.useEffect)(function () {
    var tablist = scrollableRef.current;
    if (!tablist) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var firstTab = tablist.querySelector('.tab');
        var idx = Number(firstTab.dataset['tabIndex']);

        if ((0, _toConsumableArray2["default"])(mutation.removedNodes).some(function (node) {
          return node.querySelector('.tab.tab-active');
        })) {
          setTab(idx);
        } else if (tablist.querySelectorAll('.tab').length <= activeTab) {
          setTab(idx);
        } else {
          repositionIndicator();
        }
      });
    });
    observer.observe(tablist, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [activeTab, repositionIndicator, setTab]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isScrollable = _useState2[0],
      setIsScrollable = _useState2[1];

  var _useState3 = (0, _react.useState)('start'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      scrollState = _useState4[0],
      setScrollState = _useState4[1];

  var updateScrollableState = (0, _react.useCallback)(function () {
    var scrollable = scrollableRef.current;
    if (!scrollable) return;
    var clientWidth = scrollable.clientWidth,
        scrollWidth = scrollable.scrollWidth;
    setIsScrollable(scrollWidth > clientWidth);
  }, []);
  (0, _useResizeObserver.useResizeObserver)(scrollableRef, updateScrollableState);
  (0, _useResize.useResize)(updateScrollableState);
  (0, _react.useEffect)(function () {
    var scrollable = scrollableRef.current;
    if (vertical || !scrollable) return;

    if (typeof MutationObserver === 'undefined') {
      var prevTextContent = scrollable.textContent;
      var interval = setInterval(function () {
        var content = scrollable === null || scrollable === void 0 ? void 0 : scrollable.textContent;
        if (content === prevTextContent) return;
        updateScrollableState();
        repositionIndicator();
        prevTextContent = content;
      }, 1000);
      return function () {
        clearInterval(interval);
      };
    }

    var observer = new MutationObserver(function () {
      updateScrollableState();
      repositionIndicator();
    });
    observer.observe(scrollable, {
      characterData: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [repositionIndicator, updateScrollableState, vertical]);
  (0, _react.useEffect)(function () {
    var scrollable = scrollableRef.current;
    if (vertical || !scrollable) return;
    updateScrollableState();

    var handleScroll = function handleScroll() {
      if (scrollable.scrollLeft === 0) {
        setScrollState('start');
      } else if (Math.round(scrollable.scrollLeft) === scrollable.scrollWidth - scrollable.clientWidth) {
        setScrollState('end');
      } else {
        setScrollState('middle');
      }
    };

    scrollable.addEventListener('scroll', handleScroll, true);
    return function () {
      scrollable.removeEventListener('scroll', handleScroll);
    };
  }, [updateScrollableState, vertical]);
  (0, _react.useEffect)(function () {
    var tabEl = document.getElementById("tab-".concat(id, "-").concat(activeTab));
    var scrollable = scrollableRef.current;
    if (!scrollable || !tabEl) return;
    scrollable.scrollTo({
      left: tabEl.offsetLeft + tabEl.clientWidth / 2 - scrollable.clientWidth / 2,
      behavior: 'smooth'
    });
  }, [activeTab, id]);

  var handleClickPrev = function handleClickPrev() {
    scrollableRef.current.scrollBy({
      left: -tablistRef.current.clientWidth / 2,
      behavior: 'smooth'
    });
  };

  var handleClickNext = function handleClickNext() {
    scrollableRef.current.scrollBy({
      left: tablistRef.current.clientWidth / 2,
      behavior: 'smooth'
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: tablistRef,
    role: "tablist",
    "aria-orientation": vertical ? 'vertical' : 'horizontal',
    style: _objectSpread(_objectSpread({}, style), {}, {
      '--gap': "".concat(gap, "px"),
      '--pad': "".concat(spaceAround, "px")
    })
  }, props, {
    className: "jsx-1540521899" + " " + (props && props.className != null && props.className || (0, _classnames["default"])('tablist', className, {
      'tablist-vertical': vertical,
      scrollable: isScrollable,
      scrollStart: isScrollable && scrollState === 'start',
      scrollMiddle: isScrollable && scrollState === 'middle',
      scrollEnd: isScrollable && scrollState === 'end'
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: scrollableRef,
    className: "jsx-1540521899" + " " + "tablist-inner"
  }, _react["default"].Children.map(children, function (tab, i) {
    var _tab$props$index;

    return tab ? /*#__PURE__*/_react["default"].cloneElement(tab, {
      index: (_tab$props$index = tab.props.index) !== null && _tab$props$index !== void 0 ? _tab$props$index : i
    }) : null;
  }), !vertical && /*#__PURE__*/_react["default"].createElement("span", {
    ref: indicatorRef,
    role: "presentation",
    className: "jsx-1540521899" + " " + "indicator"
  })), !vertical && isScrollable && scrollState !== 'start' && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "scroll prev",
    variant: "ghost",
    onClick: handleClickPrev
  }, /*#__PURE__*/_react["default"].createElement(_CaretLeftIcon.CaretLeftIcon, {
    size: 16
  })), !vertical && isScrollable && scrollState !== 'end' && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "scroll next",
    variant: "ghost",
    onClick: handleClickNext
  }, /*#__PURE__*/_react["default"].createElement(_CaretRightIcon.CaretRightIcon, {
    size: 16
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1540521899"
  }, [".tablist.jsx-1540521899{position:relative;}", ".tablist-inner.jsx-1540521899{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;gap:var(--gap);padding:var(--pad);padding-bottom:max(8px,var(--pad));position:relative;-webkit-scrollbar-width:none;-moz-scrollbar-width:none;-ms-scrollbar-width:none;scrollbar-width:none;}", ".tablist.scrollable.jsx-1540521899 .tablist-inner.jsx-1540521899{overflow-x:auto;overflow-y:visible;}", ".tablist-inner.jsx-1540521899::-webkit-scrollbar{display:none;}", ".tablist-vertical.jsx-1540521899 .tablist-inner.jsx-1540521899{-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:0;padding:0;}", ".indicator.jsx-1540521899{background:var(--tabs-indicator);border-radius:4px;bottom:0;height:2px;opacity:0;position:absolute;}", ".indicator[style].jsx-1540521899{opacity:1;-webkit-transition:opacity 200ms ease 200ms,width 200ms ease, -webkit-transform 200ms ease;-webkit-transition:opacity 200ms ease 200ms,width 200ms ease, transform 200ms ease;transition:opacity 200ms ease 200ms,width 200ms ease, transform 200ms ease;}", ".tablist.jsx-1540521899:not(.tablist-vertical) .tab{padding:var(--pad);}", ".tablist.scrollable.jsx-1540521899 .scroll{margin:-4px;padding:4px;position:absolute;top:calc(2 * var(--pad));z-index:2;}", ".tablist.scrollable.jsx-1540521899 .scroll.prev{left:0;}", ".tablist.scrollable.jsx-1540521899 .scroll.next{right:0;}", ".tablist.scrollable.jsx-1540521899:not(.tablist-vertical)::before,.tablist.scrollable.jsx-1540521899:not(.tablist-vertical)::after{content:'';height:calc(100% + 2px);opacity:0;pointer-events:none;position:absolute;top:-1px;-webkit-transition:opacity 150ms ease;transition:opacity 150ms ease;width:48px;z-index:1;}", ".tablist.scrollable.jsx-1540521899:not(.tablist-vertical)::before{background:linear-gradient( to right, var(--tabs-bg) 0%, var(--tabs-bg) 25%, var(--tabs-scroll-bg-op0) 100% );left:-1px;}", ".tablist.scrollable.jsx-1540521899:not(.tablist-vertical)::after{background:linear-gradient( to left, var(--tabs-bg) 0%, var(--tabs-bg) 25%, var(--tabs-scroll-bg-op0) 100% );right:-1px;}", ".tablist.scrollable.jsx-1540521899:not(.scrollStart)::before,.tablist.scrollable.jsx-1540521899:not(.scrollEnd)::after{opacity:1;}"]));
};

exports.TabList = TabList;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TabPanel = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Tabs = __webpack_require__(4108);

var _excluded = ["children", "className", "hideStrategy", "index"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$hideStrategy = _ref.hideStrategy,
      hideStrategy = _ref$hideStrategy === void 0 ? 'empty' : _ref$hideStrategy,
      index = _ref.index,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_Tabs.TabsContext),
      activeTab = _useContext.activeTab,
      id = _useContext.id,
      vertical = _useContext.vertical;

  var isVisible = activeTab === index;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "tabpanel",
    "aria-hidden": !isVisible,
    "aria-labelledby": "tabpanel-".concat(id, "-").concat(index),
    id: "tabpanel-".concat(id, "-").concat(index)
  }, props, {
    className: "jsx-208734022" + " " + (props && props.className != null && props.className || (0, _classnames["default"])('tabpanel', className, {
      'tabpanel-vertical': vertical,
      visible: isVisible
    }) || "")
  }), isVisible || hideStrategy === 'css' ? children : null, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "208734022"
  }, [".tabpanel.jsx-208734022{display:none;}", ".tabpanel.visible.jsx-208734022{display:block;padding-top:16px;}", ".tabpanel-vertical.visible.jsx-208734022{padding-top:0;}"]));
};

exports.TabPanel = TabPanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TabPanels = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var TabPanels = function TabPanels(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _react["default"].Children.map(children, function (tab, i) {
    return tab ? /*#__PURE__*/_react["default"].cloneElement(tab, {
      index: i
    }) : null;
  }));
};

exports.TabPanels = TabPanels;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUYWJQYW5lbHMiLCJjaGlsZHJlbiIsIlJlYWN0IiwiQ2hpbGRyZW4iLCJtYXAiLCJ0YWIiLCJpIiwiY2xvbmVFbGVtZW50IiwiaW5kZXgiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UYWJzL1RhYlBhbmVscy50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGNvbnN0IFRhYlBhbmVsczogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48dW5rbm93bj4+ID0gKHtcbiAgY2hpbGRyZW4sXG59KSA9PiAoXG4gIDw+XG4gICAge1JlYWN0LkNoaWxkcmVuLm1hcChjaGlsZHJlbiwgKHRhYjogSlNYLkVsZW1lbnQsIGkpID0+XG4gICAgICB0YWJcbiAgICAgICAgPyBSZWFjdC5jbG9uZUVsZW1lbnQodGFiLCB7XG4gICAgICAgICAgICBpbmRleDogaSxcbiAgICAgICAgICB9KVxuICAgICAgICA6IG51bGxcbiAgICApfVxuICA8Lz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVPLElBQU1BLFNBQXFELEdBQUcsU0FBeERBLFNBQXdEO0VBQUEsSUFDbkVDLFFBRG1FLFFBQ25FQSxRQURtRTtFQUFBLG9CQUduRSxrRUFDR0MsaUJBQUEsQ0FBTUMsUUFBTixDQUFlQyxHQUFmLENBQW1CSCxRQUFuQixFQUE2QixVQUFDSSxHQUFELEVBQW1CQyxDQUFuQjtJQUFBLE9BQzVCRCxHQUFHLGdCQUNDSCxpQkFBQSxDQUFNSyxZQUFOLENBQW1CRixHQUFuQixFQUF3QjtNQUN0QkcsS0FBSyxFQUFFRjtJQURlLENBQXhCLENBREQsR0FJQyxJQUx3QjtFQUFBLENBQTdCLENBREgsQ0FIbUU7QUFBQSxDQUE5RCJ9

/***/ }),

/***/ 4108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TabsContext = exports.Tabs = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _react = _interopRequireWildcard(__webpack_require__(7294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabsContext = /*#__PURE__*/(0, _react.createContext)({
  activeTab: 0,
  id: null,
  setTab: null,
  vertical: false
});
exports.TabsContext = TabsContext;

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      onChangeTab = _ref.onChangeTab,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical;

  var _useState = (0, _react.useState)(initialIndex !== null && initialIndex !== void 0 ? initialIndex : 0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  (0, _react.useEffect)(function () {
    setActiveTab(initialIndex !== null && initialIndex !== void 0 ? initialIndex : 0);
  }, [initialIndex]);
  (0, _react.useEffect)(function () {
    onChangeTab === null || onChangeTab === void 0 ? void 0 : onChangeTab(activeTab);
  }, [activeTab, onChangeTab]);
  return /*#__PURE__*/_react["default"].createElement(TabsContext.Provider, {
    value: {
      activeTab: activeTab,
      id: id,
      setTab: setActiveTab,
      vertical: vertical
    }
  }, children);
};

exports.Tabs = Tabs;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 5431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "OK", ({
  enumerable: true,
  get: function get() {
    return _Tab.Tab;
  }
}));
Object.defineProperty(exports, "td", ({
  enumerable: true,
  get: function get() {
    return _TabList.TabList;
  }
}));
Object.defineProperty(exports, "x4", ({
  enumerable: true,
  get: function get() {
    return _TabPanel.TabPanel;
  }
}));
Object.defineProperty(exports, "nP", ({
  enumerable: true,
  get: function get() {
    return _TabPanels.TabPanels;
  }
}));
Object.defineProperty(exports, "mQ", ({
  enumerable: true,
  get: function get() {
    return _Tabs.Tabs;
  }
}));

var _Tab = __webpack_require__(9896);

var _TabList = __webpack_require__(9512);

var _TabPanel = __webpack_require__(7982);

var _TabPanels = __webpack_require__(8037);

var _Tabs = __webpack_require__(4108);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFicy9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBUYWIgfSBmcm9tICcuL1RhYic7XG5leHBvcnQgeyBUYWJMaXN0IH0gZnJvbSAnLi9UYWJMaXN0JztcbmV4cG9ydCB7IFRhYlBhbmVsIH0gZnJvbSAnLi9UYWJQYW5lbCc7XG5leHBvcnQgeyBUYWJQYW5lbHMgfSBmcm9tICcuL1RhYlBhbmVscyc7XG5leHBvcnQgeyBUYWJzIH0gZnJvbSAnLi9UYWJzJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0EifQ==

/***/ }),

/***/ 3395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Tooltip = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _useResize = __webpack_require__(4605);

var _Portal = __webpack_require__(5970);

var _Text = __webpack_require__(5645);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Offset for the arrow to not live on the corner.
 */
var ALIGN_OFFSET = 8;
/**
 * The spacing between the toggle and the tooltip.
 */

var SPACING = 8;
/**
 * const outside component to avoid {} being recreated on every render,
 * which would lead to an inifite render loop for the realign useEffect.
 */

var defaultStyle = {};

var Tooltip = function Tooltip(_ref) {
  var _toggleRef$current;

  var _ref$border = _ref.border,
      border = _ref$border === void 0 ? false : _ref$border,
      children = _ref.children,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disableListeners = _ref.disableListeners,
      disableListeners = _ref$disableListeners === void 0 ? false : _ref$disableListeners,
      id = _ref.id,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? defaultStyle : _ref$style,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      title = _ref.title,
      _ref$toggleStyle = _ref.toggleStyle,
      toggleStyle = _ref$toggleStyle === void 0 ? null : _ref$toggleStyle;

  var _useTheme = (0, _Theme.useTheme)(),
      zIndex = _useTheme.zIndex;

  var _useState = (0, _react.useState)(open),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var toggleRef = (0, _react.useRef)(null);
  var tooltipRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)('center'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      align = _useState4[0],
      setAlign = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      position = _useState6[0],
      setPosition = _useState6[1];

  var handleClick = function handleClick() {
    return setIsOpen(true);
  };

  var handleFocus = function handleFocus(ev) {
    /*
     * When navigating with a keyboard, focus usually shifts from one element to another.
     * The previously focused element is referenced in relatedTarget.
     * For programmatic focus shift or when focus happens due to a mouse click,
     * there isn't necessarily a relatedTarget set.
     * While this doesn't cover 100% of cases, it gets us close enough to only
     * open the tooltip, when focused via keyboard navigation.
     */
    if (!ev.relatedTarget) return;
    setIsOpen(true);
  };

  var handleKeyDown = function handleKeyDown(ev) {
    if (ev.key !== 'Enter') return;
    setIsOpen(true);
  };

  var handlePointerEnter = function handlePointerEnter() {
    return setIsOpen(true);
  };

  var handlePointerLeave = function handlePointerLeave() {
    return setIsOpen(false);
  };

  var placeBelow = placement === 'bottom';
  /**
   * Reset isOpen state to open, unless tooltip is disabled.
   */

  (0, _react.useEffect)(function () {
    setIsOpen(open && !disabled);
  }, [disabled, open]);
  var realign = (0, _react.useCallback)(function () {
    if (!isOpen || disabled) {
      setPosition(null);
      return;
    }

    if (!toggleRef.current || !tooltipRef.current) return;
    var toggleRect = toggleRef.current.getBoundingClientRect();
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    var main = document.querySelector('main');
    var mainRect = main === null || main === void 0 ? void 0 : main.getBoundingClientRect();
    var center = toggleRect.left + toggleRect.width / 2;
    var leftEdge = center - tooltipRect.width / 2;
    var rightEdge = center + tooltipRect.width / 2;
    var top = window.scrollY + toggleRect.top - tooltipRect.height - SPACING;

    if (placeBelow) {
      top = window.scrollY + toggleRect.bottom + SPACING;
    }

    if (rightEdge > ((mainRect === null || mainRect === void 0 ? void 0 : mainRect.left) || 0) + ((mainRect === null || mainRect === void 0 ? void 0 : mainRect.width) || window.innerWidth)) {
      setAlign('right');
      setPosition({
        left: toggleRect.right + ALIGN_OFFSET - tooltipRect.width,
        top: top
      });
    } else if (leftEdge < ((mainRect === null || mainRect === void 0 ? void 0 : mainRect.left) || 0)) {
      setAlign('left');
      setPosition({
        left: toggleRect.left - ALIGN_OFFSET,
        top: top
      });
    } else {
      setAlign('center');
      setPosition({
        left: toggleRect.left + (toggleRect.right - toggleRect.left) / 2 - tooltipRect.width / 2,
        top: top
      });
    }
  }, [disabled, isOpen, placeBelow]);
  (0, _useResize.useResize)(realign);
  (0, _react.useEffect)(function () {
    realign();
  }, [isOpen, open, realign, style, title, toggleStyle]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: toggleRef,
    "aria-describedby": disabled ? undefined : id,
    onBlur: disableListeners || disabled ? null : handlePointerLeave,
    onClick: disableListeners || disabled ? null : handleClick,
    onFocus: disableListeners || disabled ? null : handleFocus,
    onKeyDown: disableListeners || disabled ? null : handleKeyDown,
    onPointerEnter: disableListeners || disabled ? null : handlePointerEnter,
    onPointerLeave: disableListeners || disabled ? null : handlePointerLeave,
    tabIndex: disabled ? undefined : tabIndex,
    style: toggleStyle,
    className: _style["default"].dynamic([["2068754017", [delay]], ["1020643217", [zIndex.tooltip, ALIGN_OFFSET, ALIGN_OFFSET]]])
  }, !disabled && /*#__PURE__*/_react["default"].createElement(_Portal.Portal, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: tooltipRef,
    id: id,
    role: "tooltip",
    "aria-hidden": !isOpen,
    style: _objectSpread(_objectSpread(_objectSpread({}, style), position), {}, {
      '--toggle-width': "".concat((_toggleRef$current = toggleRef.current) === null || _toggleRef$current === void 0 ? void 0 : _toggleRef$current.clientWidth, "px")
    }),
    className: _style["default"].dynamic([["2068754017", [delay]], ["1020643217", [zIndex.tooltip, ALIGN_OFFSET, ALIGN_OFFSET]]]) + " " + ((0, _classnames["default"])('tooltip', align, {
      border: border,
      open: isOpen,
      placeBelow: placeBelow
    }) || "")
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "inherit"
  }, title))), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2068754017",
    dynamic: [delay]
  }, [".tooltip.open.__jsx-style-dynamic-selector{-webkit-transition-delay:".concat(delay, "ms;transition-delay:").concat(delay, "ms;}")]), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1020643217",
    dynamic: [zIndex.tooltip, ALIGN_OFFSET, ALIGN_OFFSET]
  }, ["span.__jsx-style-dynamic-selector{border-radius:2px;box-shadow:0 0 0 0 var(--focus-shadow);display:block;outline:none;position:relative;-webkit-transition:box-shadow 200ms ease;transition:box-shadow 200ms ease;}", "span.__jsx-style-dynamic-selector:not([tabindex='-1']):focus-within{box-shadow:0 0 0 2px var(--focus-shadow);}", ".tooltip.__jsx-style-dynamic-selector{background-color:var(--tooltip-bg);border-radius:8px;box-shadow:var(--tooltip-shadow);color:var(--tooltip-color);max-width:min(320px,80vw);opacity:0;padding:7px 8px 9px;pointer-events:none;position:absolute;text-align:center;top:-99em;-webkit-transition:opacity 200ms ease;transition:opacity 200ms ease;z-index:".concat(zIndex.tooltip, ";}"), ".tooltip.border.__jsx-style-dynamic-selector{border:1px solid var(--tooltip-border);}", ".tooltip.open.__jsx-style-dynamic-selector{opacity:1;}", ".tooltip.__jsx-style-dynamic-selector::after{--tt-arrow-size:5px;--tt-arrow-color:var(--tooltip-bg);}", ".tooltip.border.__jsx-style-dynamic-selector::before{--tt-arrow-size:6px;--tt-arrow-color:var(--tooltip-border);}", ".tooltip.__jsx-style-dynamic-selector::after,.tooltip.border.__jsx-style-dynamic-selector::before{border:var(--tt-arrow-size) solid transparent;border-top-color:var(--tt-arrow-color);content:'';height:0;position:absolute;top:100%;-webkit-transform:scaleY(0.8);-ms-transform:scaleY(0.8);transform:scaleY(0.8);-webkit-transform-origin:top center;-ms-transform-origin:top center;transform-origin:top center;width:0;}", ".tooltip.placeBelow.__jsx-style-dynamic-selector::after,.tooltip.placeBelow.border.__jsx-style-dynamic-selector::before{top:0;-webkit-transform:scaleY(-0.8);-ms-transform:scaleY(-0.8);transform:scaleY(-0.8);}", ".tooltip.center.__jsx-style-dynamic-selector::after,.tooltip.center.border.__jsx-style-dynamic-selector::before{left:calc(50% - var(--tt-arrow-size));}", ".tooltip.left.__jsx-style-dynamic-selector::after,.tooltip.left.border.__jsx-style-dynamic-selector::before{left:calc( ".concat(ALIGN_OFFSET, "px + calc(var(--toggle-width) / 2) - var(--tt-arrow-size) );}"), ".tooltip.right.__jsx-style-dynamic-selector::after,.tooltip.right.border.__jsx-style-dynamic-selector::before{right:calc( ".concat(ALIGN_OFFSET, "px + calc(var(--toggle-width) / 2) - var(--tt-arrow-size) );}")]));
};

exports.Tooltip = Tooltip;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "u", ({
  enumerable: true,
  get: function get() {
    return _Tooltip.Tooltip;
  }
}));

var _Tooltip = __webpack_require__(3395);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVG9vbHRpcC9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBUb29sdGlwIH0gZnJvbSAnLi9Ub29sdGlwJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 3922:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SnackbarProvider = exports.SnackbarContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(5182));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _react = _interopRequireWildcard(__webpack_require__(7294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SnackbarContext = /*#__PURE__*/(0, _react.createContext)({
  addMessage: function addMessage() {},
  messages: [],
  handleHide: function handleHide() {}
});
exports.SnackbarContext = SnackbarContext;
var counter = 0;

var SnackbarProvider = function SnackbarProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      messages = _useState2[0],
      setMessages = _useState2[1];

  var addMessage = (0, _react.useCallback)(function (m) {
    if (!m.type) m.type = 'success';
    setMessages(function (msgs) {
      return [{
        id: ++counter,
        message: m
      }].concat((0, _toConsumableArray2["default"])(msgs));
    });
  }, []);

  var handleHide = function handleHide(hideId) {
    setMessages(function (msgs) {
      return msgs.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== hideId;
      });
    });
  };

  return /*#__PURE__*/_react["default"].createElement(SnackbarContext.Provider, {
    value: {
      addMessage: addMessage,
      messages: messages,
      handleHide: handleHide
    }
  }, children);
};

exports.SnackbarProvider = SnackbarProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 4017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "SnackbarProvider", ({
  enumerable: true,
  get: function get() {
    return _SnackbarProvider.SnackbarProvider;
  }
}));
Object.defineProperty(exports, "useSnackbar", ({
  enumerable: true,
  get: function get() {
    return _useSnackbar.useSnackbar;
  }
}));

var _SnackbarProvider = __webpack_require__(3922);

var _useSnackbar = __webpack_require__(3241);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnRleHRzL1NuYWNrYmFyL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFNuYWNrYmFyUHJvdmlkZXIgfSBmcm9tICcuL1NuYWNrYmFyUHJvdmlkZXInO1xuZXhwb3J0IHsgdXNlU25hY2tiYXIgfSBmcm9tICcuL3VzZVNuYWNrYmFyJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0EifQ==

/***/ }),

/***/ 3241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useSnackbar = void 0;

var _react = __webpack_require__(7294);

var _SnackbarProvider = __webpack_require__(3922);

var useSnackbar = function useSnackbar() {
  return (0, _react.useContext)(_SnackbarProvider.SnackbarContext);
};

exports.useSnackbar = useSnackbar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTbmFja2JhciIsInVzZUNvbnRleHQiLCJTbmFja2JhckNvbnRleHQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dHMvU25hY2tiYXIvdXNlU25hY2tiYXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgU25hY2tiYXJDb250ZXh0LCBTbmFja2JhclByb3ZpZGVyVmFsdWUgfSBmcm9tICcuL1NuYWNrYmFyUHJvdmlkZXInO1xuXG5leHBvcnQgY29uc3QgdXNlU25hY2tiYXIgPSAoKSA9PlxuICB1c2VDb250ZXh0PFNuYWNrYmFyUHJvdmlkZXJWYWx1ZT4oU25hY2tiYXJDb250ZXh0KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjO0VBQUEsT0FDekIsSUFBQUMsaUJBQUEsRUFBa0NDLGlDQUFsQyxDQUR5QjtBQUFBLENBQXBCIn0=

/***/ }),

/***/ 1200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useAbsolutePosition = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _react = __webpack_require__(7294);

var _useResize = __webpack_require__(4605);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useAbsolutePosition = function useAbsolutePosition(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      containerRef = _ref.containerRef,
      _ref$offsetLeft = _ref.offsetLeft,
      offsetLeft = _ref$offsetLeft === void 0 ? 0 : _ref$offsetLeft,
      _ref$offsetTop = _ref.offsetTop,
      offsetTop = _ref$offsetTop === void 0 ? 8 : _ref$offsetTop,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$position = _ref.position,
      stylePosition = _ref$position === void 0 ? 'absolute' : _ref$position,
      ref = _ref.ref;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var calcPosition = (0, _react.useCallback)(function () {
    var _containerRef$current, _containerRef$current2, _containerRef$current3;

    if (!ref.current || !containerRef.current) return;
    var trigger = ref.current;
    var triggerRect = trigger.getBoundingClientRect();
    var left = null;
    var top = null;

    switch (align) {
      case 'left':
        left = Math.min(triggerRect.left, window.innerWidth - containerRef.current.clientWidth);
        break;

      case 'right':
        left = Math.max(0, triggerRect.right - ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth));
        break;

      case 'center':
        left = triggerRect.left + triggerRect.width / 2 - ((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth) / 2;
        break;
    }

    switch (placement) {
      case 'bottom':
        top = (stylePosition === 'absolute' ? window.scrollY : 0) + triggerRect.top + triggerRect.height + offsetTop;
        break;

      case 'top':
        top = (stylePosition === 'absolute' ? window.scrollY : 0) + triggerRect.top - ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.clientHeight) - offsetTop;
        break;
    }

    setPosition({
      left: left + offsetLeft,
      top: top
    });
  }, [align, containerRef, offsetLeft, offsetTop, placement, ref, stylePosition]);
  (0, _useResize.useResize)(calcPosition);
  (0, _react.useEffect)(function () {
    if (!containerRef.current || !ref.current) return;
    calcPosition();
  }, [calcPosition, containerRef, ref]);
  return {
    reposition: calcPosition,
    style: _objectSpread({
      position: stylePosition
    }, position)
  };
};

exports.useAbsolutePosition = useAbsolutePosition;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useClosable = void 0;

var _react = __webpack_require__(7294);

/**
 * Sets up document click and escape key event listeners.
 * Calls onClose, when clicked outside of passed ref and all deps are truthy.
 */
var useClosable = function useClosable(_ref, deps) {
  var onClose = _ref.onClose,
      ref = _ref.ref;
  var active = (0, _react.useMemo)(function () {
    return deps.every(Boolean);
  }, [deps]);
  (0, _react.useEffect)(function () {
    if (!active) return;

    var handleClick = function handleClick(ev) {
      var _ref$current;

      // close menu when user clicked outside
      var target = ev.target;

      if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(target))) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };

    var handleKeydown = function handleKeydown(ev) {
      switch (ev.key) {
        case 'Escape':
          ev.stopImmediatePropagation();
          onClose === null || onClose === void 0 ? void 0 : onClose();
          break;
      }
    };

    var handleBlurWindow = function handleBlurWindow() {
      /**
       * Detects when the user's focus moves to an embedded iframe.
       */
      if (document.activeElement.tagName === 'IFRAME') {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    }; // This timeout is needed to assure that browsers have time to process clicks
    // before React updates the hook.
    // Otherwise components using useClosable could run into a race condition
    // that would prevent users from triggering the ref correctly.


    var timeout = setTimeout(function () {
      document.addEventListener('keydown', handleKeydown);
      document.addEventListener('click', handleClick);
      window.addEventListener('blur', handleBlurWindow);
    }, 300);
    return function () {
      clearTimeout(timeout);
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('click', handleClick);
      window.removeEventListener('blur', handleBlurWindow);
    };
  }, [active, onClose, ref]);
};

exports.useClosable = useClosable;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useResizeObserver = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _react = __webpack_require__(7294);

/**
 * Sets up a ResizeObserver for the given ref element.
 * Whenever the element's dimension change, callback is called
 * with the element's current width and height.
 */
var useResizeObserver = function useResizeObserver(ref, callback) {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isPageVisible = _useState2[0],
      setIsPageVisible = _useState2[1];
  /**
   * Setup page visibility change listener.
   * When a page is backgrounded, ResizeObservers don't seem to catch any events.
   * We'll fall back to an interval in that case, since intervals are only throttled,
   * when the page is backgrounded.
   */


  (0, _react.useEffect)(function () {
    var handleVisibilityChange = function handleVisibilityChange() {
      setIsPageVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!ref.current) return;

    if (typeof ResizeObserver !== 'undefined' && isPageVisible) {
      var frame;
      var resizeObserver = new ResizeObserver(function () {
        if (!ref.current) return;

        var _ref$current$getBound = ref.current.getBoundingClientRect(),
            height = _ref$current$getBound.height,
            width = _ref$current$getBound.width;

        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          callback(width, height);
        });
      });
      resizeObserver.observe(ref.current);
      return function () {
        resizeObserver.disconnect();
      };
    }

    var lastWidth;
    var lastHeight;
    var interval = setInterval(function () {
      if (!ref.current) return;

      var _ref$current$getBound2 = ref.current.getBoundingClientRect(),
          height = _ref$current$getBound2.height,
          width = _ref$current$getBound2.width;

      if (width !== lastWidth || height !== lastHeight) {
        callback(width, height);
        lastWidth = width;
        lastHeight = height;
      }
    }, 100);
    return function () {
      clearInterval(interval);
    };
  }, [callback, isPageVisible, ref]);
};

exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useScrollLock = void 0;

var _react = __webpack_require__(7294);

var useScrollLock = function useScrollLock(locked) {
  var onUnlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var handleKeyDown = (0, _react.useCallback)(function (ev) {
    if (ev.key === 'Escape') {
      onUnlock === null || onUnlock === void 0 ? void 0 : onUnlock();
    }
  }, [onUnlock]);
  (0, _react.useEffect)(function () {
    var lock = function lock() {
      document.documentElement.classList.add('scroll-lock');
    };

    var unlock = function unlock() {
      document.documentElement.classList.remove('scroll-lock');
    };

    if (locked) {
      lock();
    } else {
      unlock();
      onUnlock === null || onUnlock === void 0 ? void 0 : onUnlock();
    }

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      unlock();
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown, locked, onUnlock]);
};

exports.useScrollLock = useScrollLock;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.scrollToElement = exports.isElementVisibleInViewport = exports.isElementVisibleInContainer = exports.getFocusableElements = void 0;

var getFocusableElements = function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll('input,select,textarea,a[href],button,[tabindex],audio[controls],video[controls],[contenteditable]:not([contenteditable="false"])')).filter(function (el) {
    return el.getAttribute('disabled') === null;
  }).filter(function (el) {
    return el.getAttribute('aria-disabled') !== 'true';
  }).filter(function (el) {
    var tabindex = el.getAttribute('tabindex');
    return tabindex === null || parseInt(tabindex, 10) >= 0;
  });
};

exports.getFocusableElements = getFocusableElements;

var scrollToElement = function scrollToElement(targetEl) {
  var rect = targetEl.getBoundingClientRect();
  var headerHeight = document.documentElement.style.getPropertyValue('--header-height');
  window.scrollTo({
    behavior: 'smooth',
    top: Math.max(0, window.pageYOffset + rect.y - parseInt(headerHeight, 10) - 16)
  });
  var id = targetEl.getAttribute('id');

  if (id) {
    history.pushState({}, '', "#".concat(id));
    window.dispatchEvent(new Event('hashchange'));
  }
};

exports.scrollToElement = scrollToElement;

var isElementVisibleInViewport = function isElementVisibleInViewport(e) {
  var _e$getBoundingClientR = e.getBoundingClientRect(),
      bottom = _e$getBoundingClientR.bottom,
      left = _e$getBoundingClientR.left,
      right = _e$getBoundingClientR.right,
      top = _e$getBoundingClientR.top;

  return top >= 0 && left >= 0 && bottom <= (window.innerHeight || document.documentElement.clientHeight) && right <= (window.innerWidth || document.documentElement.clientWidth);
}; // See: https://htmldom.dev/check-if-an-element-is-visible-in-a-scrollable-container/


exports.isElementVisibleInViewport = isElementVisibleInViewport;

var isElementVisibleInContainer = function isElementVisibleInContainer(e, container) {
  var visibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var _e$getBoundingClientR2 = e.getBoundingClientRect(),
      bottom = _e$getBoundingClientR2.bottom,
      height = _e$getBoundingClientR2.height,
      top = _e$getBoundingClientR2.top;

  var containerRect = container.getBoundingClientRect();
  var vis = Math.min(Math.max(visibility, 0), 1);
  var minVisibleHeight = height * vis;
  var visibleBottomEdge = Math.min(bottom, containerRect.bottom);
  var visibleTopEdge = Math.max(top, containerRect.top);
  var visibleHeight = visibleBottomEdge - visibleTopEdge;
  return visibleHeight >= minVisibleHeight;
};

exports.isElementVisibleInContainer = isElementVisibleInContainer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9930:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.w = void 0;
var inMemoryStorage = {};

function isSupported(getStorage) {
  try {
    var key = '__some_random_key_you_are_not_going_to_use__';
    getStorage().setItem(key, key);
    getStorage().removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

var safeStorage = function safeStorage(getStorage) {
  return {
    clear: function clear() {
      if (isSupported(getStorage)) {
        getStorage().clear();
      } else {
        inMemoryStorage = {};
      }
    },
    getItem: function getItem(key) {
      var _inMemoryStorage;

      if (isSupported(getStorage)) {
        return getStorage().getItem(key);
      }

      return (_inMemoryStorage = inMemoryStorage) === null || _inMemoryStorage === void 0 ? void 0 : _inMemoryStorage[key];
    },
    removeItem: function removeItem(key) {
      if (isSupported(getStorage)) {
        getStorage().removeItem(key);
      } else {
        var _inMemoryStorage2;

        (_inMemoryStorage2 = inMemoryStorage) === null || _inMemoryStorage2 === void 0 ? true : delete _inMemoryStorage2[key];
      }
    },
    setItem: function setItem(key, value) {
      if (isSupported(getStorage)) {
        getStorage().setItem(key, value);
      } else {
        inMemoryStorage[key] = value;
      }
    }
  };
};

exports.w = safeStorage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Y = void 0;

var sortByKey = function sortByKey(key) {
  var caseSensitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (a, b) {
    var _String, _String2;

    var aKey = !caseSensitive && typeof a[key] === 'string' ? (_String = String(a[key])) === null || _String === void 0 ? void 0 : _String.toLowerCase() : a[key];
    var bKey = !caseSensitive && typeof b[key] === 'string' ? (_String2 = String(b[key])) === null || _String2 === void 0 ? void 0 : _String2.toLowerCase() : b[key];
    if (aKey > bKey) return 1;
    if (aKey < bKey) return -1;
    return 0;
  };
};

exports.Y = sortByKey;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzb3J0QnlLZXkiLCJrZXkiLCJjYXNlU2Vuc2l0aXZlIiwiYSIsImIiLCJhS2V5IiwiU3RyaW5nIiwidG9Mb3dlckNhc2UiLCJiS2V5Il0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9zb3J0QnlLZXkudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHNvcnRCeUtleSA9XG4gIDxUID0gUmVjb3JkPHN0cmluZywgdW5rbm93bj4+KGtleToga2V5b2YgVCwgY2FzZVNlbnNpdGl2ZSA9IHRydWUpID0+XG4gIChhOiBULCBiOiBUKSA9PiB7XG4gICAgY29uc3QgYUtleSA9XG4gICAgICAhY2FzZVNlbnNpdGl2ZSAmJiB0eXBlb2YgYVtrZXldID09PSAnc3RyaW5nJ1xuICAgICAgICA/IFN0cmluZyhhW2tleV0pPy50b0xvd2VyQ2FzZSgpXG4gICAgICAgIDogYVtrZXldO1xuICAgIGNvbnN0IGJLZXkgPVxuICAgICAgIWNhc2VTZW5zaXRpdmUgJiYgdHlwZW9mIGJba2V5XSA9PT0gJ3N0cmluZydcbiAgICAgICAgPyBTdHJpbmcoYltrZXldKT8udG9Mb3dlckNhc2UoKVxuICAgICAgICA6IGJba2V5XTtcbiAgICBpZiAoYUtleSA+IGJLZXkpIHJldHVybiAxO1xuICAgIGlmIChhS2V5IDwgYktleSkgcmV0dXJuIC0xO1xuICAgIHJldHVybiAwO1xuICB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQU8sSUFBTUEsU0FBUyxHQUNwQixTQURXQSxTQUNYLENBQThCQyxHQUE5QjtFQUFBLElBQTRDQyxhQUE1Qyx1RUFBNEQsSUFBNUQ7RUFBQSxPQUNBLFVBQUNDLENBQUQsRUFBT0MsQ0FBUCxFQUFnQjtJQUFBOztJQUNkLElBQU1DLElBQUksR0FDUixDQUFDSCxhQUFELElBQWtCLE9BQU9DLENBQUMsQ0FBQ0YsR0FBRCxDQUFSLEtBQWtCLFFBQXBDLGNBQ0lLLE1BQU0sQ0FBQ0gsQ0FBQyxDQUFDRixHQUFELENBQUYsQ0FEViw0Q0FDSSxRQUFnQk0sV0FBaEIsRUFESixHQUVJSixDQUFDLENBQUNGLEdBQUQsQ0FIUDtJQUlBLElBQU1PLElBQUksR0FDUixDQUFDTixhQUFELElBQWtCLE9BQU9FLENBQUMsQ0FBQ0gsR0FBRCxDQUFSLEtBQWtCLFFBQXBDLGVBQ0lLLE1BQU0sQ0FBQ0YsQ0FBQyxDQUFDSCxHQUFELENBQUYsQ0FEViw2Q0FDSSxTQUFnQk0sV0FBaEIsRUFESixHQUVJSCxDQUFDLENBQUNILEdBQUQsQ0FIUDtJQUlBLElBQUlJLElBQUksR0FBR0csSUFBWCxFQUFpQixPQUFPLENBQVA7SUFDakIsSUFBSUgsSUFBSSxHQUFHRyxJQUFYLEVBQWlCLE9BQU8sQ0FBQyxDQUFSO0lBQ2pCLE9BQU8sQ0FBUDtFQUNELENBYkQ7QUFBQSxDQURLIn0=

/***/ }),

/***/ 9399:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.P = void 0;

var throttle = function throttle(callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(void 0, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
};

exports.P = throttle;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ0aHJvdHRsZSIsImNhbGxiYWNrIiwibGltaXQiLCJ3YWl0Iiwic2V0VGltZW91dCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdGhyb3R0bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHRocm90dGxlID0gKGNhbGxiYWNrOiBGdW5jdGlvbiwgbGltaXQ6IG51bWJlcikgPT4ge1xuICBsZXQgd2FpdCA9IGZhbHNlO1xuICByZXR1cm4gKC4uLmFyZ3MpID0+IHtcbiAgICBpZiAoIXdhaXQpIHtcbiAgICAgIGNhbGxiYWNrKC4uLmFyZ3MpO1xuICAgICAgd2FpdCA9IHRydWU7XG4gICAgICBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgd2FpdCA9IGZhbHNlO1xuICAgICAgfSwgbGltaXQpO1xuICAgIH1cbiAgfTtcbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBTyxJQUFNQSxRQUFRLEdBQUcsU0FBWEEsUUFBVyxDQUFDQyxRQUFELEVBQXFCQyxLQUFyQixFQUF1QztFQUM3RCxJQUFJQyxJQUFJLEdBQUcsS0FBWDtFQUNBLE9BQU8sWUFBYTtJQUNsQixJQUFJLENBQUNBLElBQUwsRUFBVztNQUNURixRQUFRLE1BQVI7TUFDQUUsSUFBSSxHQUFHLElBQVA7TUFDQUMsVUFBVSxDQUFDLFlBQU07UUFDZkQsSUFBSSxHQUFHLEtBQVA7TUFDRCxDQUZTLEVBRVBELEtBRk8sQ0FBVjtJQUdEO0VBQ0YsQ0FSRDtBQVNELENBWE0ifQ==

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [107,401,229,106,531,812,473,774,888,179], function() { return __webpack_exec__(4458), __webpack_exec__(5705); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);